
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("h6ySE", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "ServiceDeskExternalLinksPage", () => $460e5c0a84f958a9$export$318e27f15404d46c);
$parcel$export(module.exports, "default", () => $460e5c0a84f958a9$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $kwce8 = parcelRequire("kwce8");

var $4Bees = parcelRequire("4Bees");

var $knPb9 = parcelRequire("knPb9");

var $fee69 = parcelRequire("fee69");

var $bNe1g = parcelRequire("bNe1g");

var $iVSJI = parcelRequire("iVSJI");

var $2Ba2b = parcelRequire("2Ba2b");

var $2wMrb = parcelRequire("2wMrb");

var $kCywN = parcelRequire("kCywN");

var $lB25E = parcelRequire("lB25E");

var $7mGdK = parcelRequire("7mGdK");
const $460e5c0a84f958a9$var$METRICS_PAGE_ID = 'project-settings-apps.external-links-settings';
const $460e5c0a84f958a9$export$318e27f15404d46c = (props)=>{
    const { usePathParam: usePathParam } = props;
    const { data: projectContext, loading: isProjectContextLoading } = (0, $bNe1g.useProjectContext)();
    const [projectKey] = usePathParam('projectKey');
    const isProjectAdmin = Boolean(projectContext?.isProjectAdmin);
    const getExternalLinksContent = ()=>{
        if (isProjectContextLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
            size: "large",
            label: "loading"
        });
        if (!isProjectAdmin) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2Ba2b.ProjectNotFound), null);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7mGdK.default), {
            projectContext: projectContext
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kCywN.ProjectSettingsController), {
        projectKey: projectKey
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fee69.ErrorBoundaryFlag), {
        id: $460e5c0a84f958a9$var$METRICS_PAGE_ID
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2wMrb.ProjectSubProductUpdater), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iVSJI.ServiceDeskAnalyticsContext), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kwce8.ThemeProvider), {
        theme: {}
    }, getExternalLinksContent()))));
};
var $460e5c0a84f958a9$export$2e2bcd8739ae039 = (0, $knPb9.default)($460e5c0a84f958a9$export$318e27f15404d46c, {
    usePathParam: (0, $lB25E.usePathParam)
});

});
parcelRegister("2Ba2b", function(module, exports) {

$parcel$export(module.exports, "ProjectNotFound", () => $abcdf98f8a718d25$export$849d319c342682a2);
$parcel$export(module.exports, "GenericError", () => $abcdf98f8a718d25$export$7d465be8efa67280);

var $eUqFw = parcelRequire("eUqFw");

var $220ac = parcelRequire("220ac");

var $heNSb = parcelRequire("heNSb");

var $lQXqy = parcelRequire("lQXqy");

var $7QuzF = parcelRequire("7QuzF");

var $4Es8k = parcelRequire("4Es8k");

var $5JgJ2 = parcelRequire("5JgJ2");

var $lB25E = parcelRequire("lB25E");

var $6Yj0X = parcelRequire("6Yj0X");
const $abcdf98f8a718d25$export$849d319c342682a2 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const projectsPath = '/jira/projects';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $heNSb.DocumentTitle), {
        title: formatMessage((0, $6Yj0X.default).notFoundDocumentTitleJsm)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $220ac.default), {
        renderImage: (0, $4Es8k.getAkEmptyStateRenderImageFn)((0, $7QuzF.default)),
        maxImageWidth: 120,
        header: formatMessage((0, $6Yj0X.default).notFoundTitle),
        description: formatMessage((0, $6Yj0X.default).notFoundDescription),
        primaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Link), {
            to: projectsPath
        }, formatMessage((0, $6Yj0X.default).notFoundAction))
    }));
};
const $abcdf98f8a718d25$export$7d465be8efa67280 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $heNSb.DocumentTitle), {
        title: formatMessage((0, $6Yj0X.default).genericDocumentTitleJsm)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $220ac.default), {
        renderImage: (0, $4Es8k.getAkEmptyStateRenderImageFn)((0, $lQXqy.default)),
        maxImageWidth: 120,
        header: formatMessage((0, $6Yj0X.default).genericErrorTitle),
        description: formatMessage((0, $6Yj0X.default).genericErrorDescription)
    }));
};

});
parcelRegister("heNSb", function(module, exports) {

$parcel$export(module.exports, "DocumentTitle", () => $44af95caa6ad02db$export$dd5ad0b65cf665da);

var $eUqFw = parcelRequire("eUqFw");

var $1TtYL = parcelRequire("1TtYL");

class $44af95caa6ad02db$export$dd5ad0b65cf665da extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            TitleSubscriber: (0, $1TtYL.DocumentTitleSubscriber)
        };
    }
    shouldComponentUpdate(nextProps) {
        return nextProps.title !== this.props.title;
    }
    render() {
        const { title: title, TitleSubscriber: TitleSubscriber } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(TitleSubscriber, null, ({ contextArray: contextArray }, { setTitle: setTitle, addDocumentTitle: addDocumentTitle, removeDocumentTitle: removeDocumentTitle })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1TtYL.DocumentTitleHelper), {
                title: title,
                setTitle: setTitle,
                addDocumentTitle: addDocumentTitle,
                contextArray: contextArray,
                removeDocumentTitle: removeDocumentTitle,
                TitleSubscriber: TitleSubscriber
            }));
    }
}

});

parcelRegister("lQXqy", function(module, exports) {

$parcel$export(module.exports, "default", () => $30559913302f86cb$export$2e2bcd8739ae039);
$parcel$export(module.exports, "viewBox", () => $30559913302f86cb$export$a179c88182cb9d56);
$parcel$export(module.exports, "srcLight", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("1cuWo")))));
$parcel$export(module.exports, "srcDark", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("48S62")))));
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = m5v37k2r2scm86wgmrk6
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/m5v37k2r2scm86wgmrk6

var $9TZf5 = parcelRequire("9TZf5");

var $48S62 = parcelRequire("48S62");

var $1cuWo = parcelRequire("1cuWo");
const $30559913302f86cb$var$Illustration = (0, $9TZf5.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($1cuWo)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($48S62))
});
var $30559913302f86cb$export$2e2bcd8739ae039 = $30559913302f86cb$var$Illustration;
// for advanced use only
const $30559913302f86cb$export$a179c88182cb9d56 = [
    0,
    0,
    164,
    218
];

});
parcelRegister("48S62", function(module, exports) {
module.exports = new URL("error-darkmode.9dba78cd.svg", import.meta.url).toString();

});

parcelRegister("1cuWo", function(module, exports) {
module.exports = new URL("error.b7de7f77.svg", import.meta.url).toString();

});


parcelRegister("7QuzF", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ab5059cf2dfabb6$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = 53grvvhrxck68z6q4s7ztq4p
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/53grvvhrxck68z6q4s7ztq4p

var $9TZf5 = parcelRequire("9TZf5");

var $fCVbE = parcelRequire("fCVbE");
const $3ab5059cf2dfabb6$var$Illustration = (0, $9TZf5.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($fCVbE)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($fCVbE))
});
var $3ab5059cf2dfabb6$export$2e2bcd8739ae039 = $3ab5059cf2dfabb6$var$Illustration;
// for advanced use only
const $3ab5059cf2dfabb6$export$a179c88182cb9d56 = [
    0,
    0,
    167,
    226
];

});
parcelRegister("fCVbE", function(module, exports) {
module.exports = new URL("search-error.a6df7c97.svg", import.meta.url).toString();

});


parcelRegister("6Yj0X", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c13e1fbd282caae$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $6c13e1fbd282caae$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    notFoundDocumentTitleJsm: {
        "id": "servicedesk-spa-commons.common.utils.errors.not-found-document-title-jsm",
        "defaultMessage": "Project not found - Service project"
    },
    notFoundTitle: {
        "id": "servicedesk-spa-commons.common.utils.errors.not-found-title",
        "defaultMessage": "This project isn't available"
    },
    notFoundDescription: {
        "id": "servicedesk-spa-commons.common.utils.errors.not-found-description",
        "defaultMessage": "It may have been deleted or your permissions may have changed"
    },
    notFoundAction: {
        "id": "servicedesk-spa-commons.common.utils.errors.not-found-action",
        "defaultMessage": "View a list of all projects"
    },
    genericDocumentTitleJsm: {
        "id": "servicedesk-spa-commons.common.utils.errors.generic-document-title-jsm",
        "defaultMessage": "Error - Service project"
    },
    genericErrorTitle: {
        "id": "servicedesk-spa-commons.common.utils.errors.generic-error-title",
        "defaultMessage": "An error occurred"
    },
    genericErrorDescription: {
        "id": "servicedesk-spa-commons.common.utils.errors.generic-error-description",
        "defaultMessage": "An error occurred while loading this page"
    }
});

});


parcelRegister("2wMrb", function(module, exports) {

$parcel$export(module.exports, "ProjectSubProductUpdater", () => $967eaa8dc0617775$export$bfbf80c212b0dcb9);

var $eUqFw = parcelRequire("eUqFw");

var $SEaoU = parcelRequire("SEaoU");

var $i889l = parcelRequire("i889l");

var $fO5rB = parcelRequire("fO5rB");

var $6QL9v = parcelRequire("6QL9v");
const $967eaa8dc0617775$export$bfbf80c212b0dcb9 = ({ allowMonolithDeferral: allowMonolithDeferral = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $SEaoU.ContainerContextSubscriber), null, ({ data: data })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, data && (0, $i889l.isProjectContext)(data) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fO5rB.SubProductUpdater), {
            subProduct: (0, $6QL9v.getSubProductFromProjectType)(data.project.type),
            allowMonolithDeferral: allowMonolithDeferral
        })));

});
parcelRegister("i889l", function(module, exports) {

$parcel$export(module.exports, "isProjectContext", () => $bedad64595855821$export$d46e75e464bf2407);
$parcel$export(module.exports, "isUserContext", () => $bedad64595855821$export$8d1083037a4a6250);
const $bedad64595855821$export$d46e75e464bf2407 = (containerContext)=>containerContext.project !== undefined;
const $bedad64595855821$export$8d1083037a4a6250 = (containerContext)=>containerContext.user !== undefined;

});

parcelRegister("fO5rB", function(module, exports) {

$parcel$export(module.exports, "SubProductUpdater", () => $0dcc4693f2e4993e$export$eb40d3df56aa5c53);

var $eUqFw = parcelRequire("eUqFw");

var $3viaK = parcelRequire("3viaK");

var $cOnuN = parcelRequire("cOnuN");

var $6QL9v = parcelRequire("6QL9v");

var $kxBN8 = parcelRequire("kxBN8");

var $2SV7r = parcelRequire("2SV7r");
const $0dcc4693f2e4993e$export$eb40d3df56aa5c53 = ({ allowMonolithDeferral: allowMonolithDeferral = false, ...props })=>{
    const subProduct = (0, $2SV7r.isSubProductProps)(props) ? props.subProduct : (0, $6QL9v.getSubProductFromProjectType)(props.projectType);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3viaK.default), {
        op: (0, $kxBN8.default),
        args: [
            subProduct,
            allowMonolithDeferral
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cOnuN.default), {
        subProduct: subProduct
    }));
};

});
parcelRegister("cOnuN", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3e22c81c3ebeab6$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lgxha = parcelRequire("lgxha");

var $j5W2t = parcelRequire("j5W2t");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b3e22c81c3ebeab6$export$2e2bcd8739ae039 = ({ subProduct: subProduct })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lgxha.default), {
        op: (0, $j5W2t.default),
        args: [
            subProduct
        ]
    });

});
parcelRegister("j5W2t", function(module, exports) {

$parcel$export(module.exports, "default", () => $8613fa53f568085a$export$2e2bcd8739ae039);

var $gUUjF = parcelRequire("gUUjF");

var $lRmyA = parcelRequire("lRmyA");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8613fa53f568085a$export$2e2bcd8739ae039 = (subProduct)=>{
    (0, $lRmyA.performGetRequest)(`/rest/internal/2/mauTag/${subProduct}`).catch((err)=>{
        (0, $gUUjF.default).safeErrorWithoutCustomerData('common.tag-mau.tag-mau-event', 'Error connecting to monolith mau tag endpoint', err);
    });
};

});


parcelRegister("6QL9v", function(module, exports) {

$parcel$export(module.exports, "getSubProductFromProjectType", () => $c2784746c0813b99$export$b1fe420ed15dff7b);

var $dWlsy = parcelRequire("dWlsy");
const $c2784746c0813b99$export$b1fe420ed15dff7b = (projectType)=>{
    // for Analytics only 'product_discovery' is mapped to 'polaris'. In other cases it is mapped to 'software'
    if (projectType === 'product_discovery') return 'polaris';
    return (0, $dWlsy.subProductFromProjectType)(projectType);
};

});

parcelRegister("kxBN8", function(module, exports) {

$parcel$export(module.exports, "default", () => $95a7ec92a66826ce$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $2BvS3 = parcelRequire("2BvS3");
var $ds5Im = parcelRequire("ds5Im");
var $4DtuZ = parcelRequire("4DtuZ");


var $gUUjF = parcelRequire("gUUjF");

var $3FyZ4 = parcelRequire("3FyZ4");
const $95a7ec92a66826ce$var$maybeDelayAndRace = (// @ts-expect-error - TS2304 - Cannot find name 'Deferred'.
maybeWaitPromise, getDefaultPromise, getRacePromise)=>maybeWaitPromise ? Promise.race([
        maybeWaitPromise.then(getDefaultPromise),
        getRacePromise()
    ]) : getDefaultPromise();
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$95a7ec92a66826ce$export$2e2bcd8739ae039 = async (subProduct, allowMonolithDeferral)=>{
    (0, $3FyZ4.getAnalyticsWebClientPromise)().then((client)=>{
        client.setSubProduct(subProduct);
        if (subProduct === 'serviceDesk') client.setUIViewedAttributes({
            solutions: [
                (0, $96da08ab2c7a3243$export$c8b406ad8ee0dab9)
            ]
        });
        else client.removeUIViewedAttribute('solutions');
    });
    // IMPORTANT -
    // Until such time as all pre-TTI WRM loads are removed we find that waitForHeritage() then
    // loadBridgeStrict() is too slow, resulting in `subproduct:unknown` for analytics events.
    // In that same case however, profiling shows us that polling in loadBridgeWeak() somehow
    // resolves the same AMD code faster.
    // This is not well understood, but it does allow us to work around the issue by racing these
    // two techniques.
    // Once there is no pre-TTI WRM loads we the waitForHeritage() then loadBridgeStrict() does seem
    // to be faster such that we can remove the `Promise.race()`.
    /* eslint-disable jira/wrm/no-load-bridge */ $95a7ec92a66826ce$var$maybeDelayAndRace(allowMonolithDeferral ? (0, $4DtuZ.waitForHeritage)() : null, ()=>(0, $2BvS3.loadBridgeStrict)({
            name: 'jira/analytics/sub-product-resolver',
            wrmKeys: [
                'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client'
            ]
        }), ()=>(0, $ds5Im.loadBridgeWeak)({
            name: 'jira/analytics/sub-product-resolver'
        })).then((subProductResolver)=>{
        subProductResolver.setSubProduct(subProduct);
    }).catch((e)=>(0, $gUUjF.default).safeErrorWithoutCustomerData('common.analytics-sub-product.sub-product-updater', 'Error connecting to monolith sub product resolver', e));
/* eslint-enable jira/wrm/no-load-bridge */ };

});
const $96da08ab2c7a3243$export$c8b406ad8ee0dab9 = 'jiraServiceManagement';


parcelRegister("2SV7r", function(module, exports) {

$parcel$export(module.exports, "isSubProductProps", () => $5e5ef73a1d4e492a$export$c3063d6d7a8c075f);
const $5e5ef73a1d4e492a$export$c3063d6d7a8c075f = (props)=>'subProduct' in props && typeof props.subProduct === 'string';
const $5e5ef73a1d4e492a$export$81da4a7e1ba1dcee = (props)=>'projectType' in props && typeof props.projectType === 'string';

});



parcelRegister("kCywN", function(module, exports) {

$parcel$export(module.exports, "ProjectSettingsController", () => $d103d2cdc5840880$export$9e38610dc1164d7d);

var $eUqFw = parcelRequire("eUqFw");

var $0cdA8 = parcelRequire("0cdA8");

var $bAQOb = parcelRequire("bAQOb");

var $dnJL9 = parcelRequire("dnJL9");

var $eI64M = parcelRequire("eI64M");

var $bhwgQ = parcelRequire("bhwgQ");

var $gd0Sp = parcelRequire("gd0Sp");

var $lB25E = parcelRequire("lB25E");

var $3hSJ4 = parcelRequire("3hSJ4");
const $d103d2cdc5840880$var$ERROR_REPORTING_PACKAGE_ID = 'projectSettingsController';
const $d103d2cdc5840880$var$ERROR_REPORTING_PACKAGE_NAME = 'jiraSpaAppsSoftwareProjectSettingsController';
const $d103d2cdc5840880$export$2164d5fb3f070c32 = ({ projectKey: projectKey, isRouteAllowedForNonAdmins: isRouteAllowedForNonAdmins, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: $d103d2cdc5840880$var$ERROR_REPORTING_PACKAGE_ID,
        teamName: "morphinecake",
        packageName: $d103d2cdc5840880$var$ERROR_REPORTING_PACKAGE_NAME,
        sendToPrivacyUnsafeSplunk: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bhwgQ.AuthenticationCheck), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d103d2cdc5840880$var$RedirectNonAdminsAndArchivedProjects, {
        projectKey: projectKey,
        isRouteAllowedForNonAdmins: isRouteAllowedForNonAdmins
    }, children)));
const $d103d2cdc5840880$export$6d6f90026f9508a7 = ({ projectKey: projectKey, isRouteAllowedForNonAdmins: isRouteAllowedForNonAdmins, children: children, packageId: packageId = $d103d2cdc5840880$var$ERROR_REPORTING_PACKAGE_ID, packageName: packageName = $d103d2cdc5840880$var$ERROR_REPORTING_PACKAGE_NAME, teamName: teamName = 'morphinecake' })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: $d103d2cdc5840880$var$ERROR_REPORTING_PACKAGE_ID,
        teamName: "morphinecake",
        packageName: $d103d2cdc5840880$var$ERROR_REPORTING_PACKAGE_NAME,
        sendToPrivacyUnsafeSplunk: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bhwgQ.AuthenticationCheck), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d103d2cdc5840880$var$RedirectNonAdminsAndArchivedProjects, {
        projectKey: projectKey,
        isRouteAllowedForNonAdmins: isRouteAllowedForNonAdmins
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: packageId,
        teamName: teamName,
        packageName: packageName,
        sendToPrivacyUnsafeSplunk: true
    }, children))));
const $d103d2cdc5840880$export$9e38610dc1164d7d = (0, $dnJL9.componentWithFG)('projectsettingscontroller_error_boundary', $d103d2cdc5840880$export$6d6f90026f9508a7, $d103d2cdc5840880$export$2164d5fb3f070c32);
const $d103d2cdc5840880$var$RedirectNonAdminsAndArchivedProjectsNew = ({ projectKey: projectKey, isRouteAllowedForNonAdmins: isRouteAllowedForNonAdmins, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gd0Sp.TenantContextSubscriber), null, ({ tenantContext: tenantContext })=>{
        if (!projectKey) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Redirect), {
            to: "/jira/projects"
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3hSJ4.ProjectContextSubscriber), null, (projectContext)=>{
            if (projectContext.isProjectArchived) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eI64M.RedirectToArchivedPage), null);
            if (tenantContext.isAdmin || projectContext.isProjectAdmin || isRouteAllowedForNonAdmins && isRouteAllowedForNonAdmins()) return children;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Redirect), {
                to: `/projects/${projectContext.projectKey}`
            });
        });
    });
const $d103d2cdc5840880$var$RedirectNonAdminsAndArchivedProjectsOld = ({ projectKey: projectKey, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gd0Sp.TenantContextSubscriber), null, ({ tenantContext: tenantContext })=>{
        if (!projectKey) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Redirect), {
            to: "/jira/projects"
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3hSJ4.ProjectContextSubscriber), null, (projectContext)=>{
            if (projectContext.isProjectArchived) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eI64M.RedirectToArchivedPage), null);
            if (tenantContext.isAdmin || projectContext.isProjectAdmin) return children;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Redirect), {
                to: `/projects/${projectContext.projectKey}`
            });
        });
    });
const $d103d2cdc5840880$var$RedirectNonAdminsAndArchivedProjects = (0, $bAQOb.componentWithFF)('olympus-da-157-enable-project-settings-navigation_zxaq5', $d103d2cdc5840880$var$RedirectNonAdminsAndArchivedProjectsNew, $d103d2cdc5840880$var$RedirectNonAdminsAndArchivedProjectsOld);

});
parcelRegister("eI64M", function(module, exports) {

$parcel$export(module.exports, "isProjectArchivedCondition", () => $949f89d276fadb14$export$34040938aec58f90);
$parcel$export(module.exports, "RedirectToArchivedPage", () => $949f89d276fadb14$export$36db2ddf32573bd8);
$parcel$export(module.exports, "default", () => $949f89d276fadb14$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $bNe1g = parcelRequire("bNe1g");

var $lB25E = parcelRequire("lB25E");

const $949f89d276fadb14$export$34040938aec58f90 = (projectContextData)=>projectContextData && projectContextData.isProjectArchived || false;
const $949f89d276fadb14$var$RedirectIfProjectArchived = ({ projectKey: projectKey })=>{
    if (projectKey === null) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bNe1g.ProjectContextProvider), null, (projectContext)=>$949f89d276fadb14$export$34040938aec58f90(projectContext.data) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Redirect), {
            to: (0, $8b47e2956ab1dffe$export$9a6ccb84170b615b)
        }) : null);
};
const $949f89d276fadb14$export$36db2ddf32573bd8 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Redirect), {
        to: (0, $8b47e2956ab1dffe$export$9a6ccb84170b615b)
    });
var $949f89d276fadb14$export$2e2bcd8739ae039 = $949f89d276fadb14$var$RedirectIfProjectArchived;

});
const $8b47e2956ab1dffe$export$9a6ccb84170b615b = '/jira/errors/project-archived';


parcelRegister("3hSJ4", function(module, exports) {

$parcel$export(module.exports, "ProjectContextSubscriber", () => $21ed2776f26316f6$export$b6f3f3997ca8a783);

var $ixwgj = parcelRequire("ixwgj");

var $lB25E = parcelRequire("lB25E");
const $21ed2776f26316f6$export$b6f3f3997ca8a783 = ({ children: children })=>{
    const { data: data } = (0, $lB25E.useResource)((0, $ixwgj.projectContextResourceWithCache));
    if (!data) return null;
    return children(data);
};

});


parcelRegister("7mGdK", function(module, exports) {

$parcel$export(module.exports, "default", () => $dbe834851aa5aec5$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $foc4i = parcelRequire("foc4i");

var $k6OXS = parcelRequire("k6OXS");

var $2d7Sj = parcelRequire("2d7Sj");

var $ifUq1 = parcelRequire("ifUq1");
const $dbe834851aa5aec5$export$8a2fa7fa4aee7394 = (props)=>{
    const { projectContext: projectContext } = props;
    if (!projectContext) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $foc4i.default), null);
    const { projectId: projectId, projectKey: projectKey, projectName: projectName } = projectContext;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2d7Sj.ServiceDeskDocumentTitle), {
        projectName: projectName,
        section: "externalLinks"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ifUq1.default), {
        baseUrl: "",
        projectKey: projectKey
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $k6OXS.ExternalLinks), {
        projectId: projectId.toString()
    })));
};
var $dbe834851aa5aec5$export$2e2bcd8739ae039 = $dbe834851aa5aec5$export$8a2fa7fa4aee7394;

});
parcelRegister("k6OXS", function(module, exports) {

$parcel$export(module.exports, "ExternalLinks", () => $5b4bc163cc894e4c$export$7c6fdaf98295312b);

var $eUqFw = parcelRequire("eUqFw");

var $bFzGY = parcelRequire("bFzGY");

var $3NCZx = parcelRequire("3NCZx");

var $0cdA8 = parcelRequire("0cdA8");

var $5JgJ2 = parcelRequire("5JgJ2");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");

var $dWLk9 = parcelRequire("dWLk9");

var $4nnPJ = parcelRequire("4nnPJ");
var $9IbuV = parcelRequire("9IbuV");

var $bFQmf = parcelRequire("bFQmf");

var $aLG4f = parcelRequire("aLG4f");

var $7c9iU = parcelRequire("7c9iU");

var $9pxTN = parcelRequire("9pxTN");

var $kNDA2 = parcelRequire("kNDA2");
function $5b4bc163cc894e4c$export$8657bf1c52c27b8f() {
    (0, $9IbuV.useUFOComponentExperience)((0, $aLG4f.externalResourcesReorderExperience));
    const [{ data: data, isLoading: isLoading, error: error }, { fetchExternalLinks: fetchExternalLinks, deleteExternalLink: deleteExternalLink, reorderExternalLink: reorderExternalLink }] = (0, $bFQmf.useExternalLinks)();
    const [isDeleting] = (0, $bFQmf.useIsDeleting)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    (0, $eUqFw.useEffect)(()=>{
        fetchExternalLinks();
    }, [
        fetchExternalLinks
    ]);
    if (error) {
        if (!(0, $kNDA2.isNetworkError)(error)) (0, $4nnPJ.GlobalPageLoadExperience).failure({
            force: true,
            metadata: {
                error: error.reason
            }
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3NCZx.default), {
            header: formatMessage((0, $7c9iU.default).errorHeader),
            description: formatMessage((0, $7c9iU.default).errorDescription)
        });
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const markExperienceFailed = (location, err)=>{
        (0, $4nnPJ.GlobalPageLoadExperience).failure({
            force: true,
            metadata: {
                error: err.message
            }
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "externalResourcesView",
        packageName: "jiraServicedeskExternalResourcesSettings",
        teamName: "jsm-nebula",
        fallback: "page",
        onError: markExperienceFailed
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9pxTN.Links), {
        links: data,
        isLoading: isLoading,
        isDeleting: isDeleting,
        onDelete: deleteExternalLink,
        onReorder: reorderExternalLink
    }));
}
const $5b4bc163cc894e4c$export$7c6fdaf98295312b = ({ projectId: projectId })=>{
    const cloudId = (0, $dWLk9.useCloudId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bFQmf.ExternalLinksContainer), {
        cloudId: cloudId,
        projectId: projectId,
        createAnalyticsEvent: createAnalyticsEvent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: "jsmExternalResourcesSettings",
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5b4bc163cc894e4c$export$8657bf1c52c27b8f, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), null)));
};
var $5b4bc163cc894e4c$export$2e2bcd8739ae039 = $5b4bc163cc894e4c$export$7c6fdaf98295312b;

});
parcelRegister("3NCZx", function(module, exports) {

$parcel$export(module.exports, "default", () => $0cbb1e7780288e8f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $220ac = parcelRequire("220ac");

var $1ybV0 = parcelRequire("1ybV0");

var $giAhk = parcelRequire("giAhk");

var $4zP5Y = parcelRequire("4zP5Y");

var $80J5A = parcelRequire("80J5A");

var $eQdlC = parcelRequire("eQdlC");
function $0cbb1e7780288e8f$export$edf27be85e5f6da0(props) {
    const { header: header, description: description, size: size, onRetry: onRetry, isLoading: isLoading, intl: { formatMessage: formatMessage }, errorImage: errorImage, isSubtle: isSubtle, imageWidth: imageWidth, maxImageHeight: maxImageHeight, retryMessage: retryMessage, renderErrorImage: renderErrorImage } = props;
    const buttonAppearance = isSubtle ? 'default' : 'primary';
    const defaultImageUrl = isSubtle ? (0, (/*@__PURE__*/$parcel$interopDefault($4zP5Y))) : (0, (/*@__PURE__*/$parcel$interopDefault($80J5A)));
    const isAssetConsolidation = (0, $1ybV0.ff)('jfe-asset-consolidation-itsm-agni_po996');
    const fallbackImage = errorImage || defaultImageUrl;
    let imageUrl;
    if (isAssetConsolidation) {
        if (renderErrorImage) imageUrl = undefined;
        else imageUrl = fallbackImage;
    } else imageUrl = fallbackImage;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $220ac.default), {
        testId: "common-components-error-state.empty-state",
        size: size,
        imageWidth: imageWidth,
        imageUrl: imageUrl,
        header: header,
        description: description,
        isLoading: isLoading,
        maxImageHeight: maxImageHeight,
        primaryAction: !onRetry ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            appearance: buttonAppearance,
            isDisabled: isLoading,
            onClick: onRetry
        }, formatMessage(retryMessage)),
        renderImage: renderErrorImage
    });
}
$0cbb1e7780288e8f$export$edf27be85e5f6da0.defaultProps = {
    header: '',
    size: 'wide',
    isLoading: false,
    isSubtle: false,
    retryMessage: (0, $eQdlC.default).retry
};
var $0cbb1e7780288e8f$export$2e2bcd8739ae039 = (0, $giAhk.injectIntlV2)($0cbb1e7780288e8f$export$edf27be85e5f6da0);

});
parcelRegister("4zP5Y", function(module, exports) {
module.exports = new URL("error-subtle.580d9941.svg", import.meta.url).toString();

});

parcelRegister("80J5A", function(module, exports) {
module.exports = new URL("error.4fa1b24b.svg", import.meta.url).toString();

});

parcelRegister("eQdlC", function(module, exports) {

$parcel$export(module.exports, "default", () => $8bc26b353252dab4$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $8bc26b353252dab4$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    retry: {
        "id": "common.components.error-state.retry-action",
        "defaultMessage": "Try again"
    }
});

});


// SCREENS
const $41ea3621645e2acc$export$f636b5b56f1d624a = 'Screen';
const $41ea3621645e2acc$export$9d2de6eebf7462b5 = 'Drawer';
const $41ea3621645e2acc$export$1171103ea9083ffa = 'Modal';
const $41ea3621645e2acc$export$cae2783c9279926 = 'InlineDialog';
const $41ea3621645e2acc$export$d1123261ca8831d2 = 'Dropdown';
const $41ea3621645e2acc$export$238d30785c4bca84 = 'Banner';
const $41ea3621645e2acc$export$a1562d08625f5d7e = 'UI';
const $41ea3621645e2acc$export$947dac6c72b26f81 = 'TRACK';
const $41ea3621645e2acc$export$f1d537d508d2945a = 'SCREEN';
const $41ea3621645e2acc$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("9IbuV", function(module, exports) {

$parcel$export(module.exports, "useUFOComponentExperience", () => $dfcd8ff9c232688c$export$30ab340faaed55d4);

var $eUqFw = parcelRequire("eUqFw");
const $dfcd8ff9c232688c$var$useConstructor = (callback)=>{
    const hasBeenFired = (0, $eUqFw.useRef)(false);
    if (!hasBeenFired.current) {
        callback();
        hasBeenFired.current = true;
    }
    return null;
};
const $dfcd8ff9c232688c$export$30ab340faaed55d4 = (experience)=>{
    (0, $eUqFw.useEffect)(()=>{
        return ()=>{
            experience.abort();
        };
    // we want this cleanup to only happen on unmount so this is a legit use of empty array
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    $dfcd8ff9c232688c$var$useConstructor(()=>experience.start());
    return null;
};

});

parcelRegister("bFQmf", function(module, exports) {

$parcel$export(module.exports, "ExternalLinksContainer", () => $5ca1dafd45710058$export$6dff686b9ebd7db3);
$parcel$export(module.exports, "useExternalLinks", () => $5ca1dafd45710058$export$ee398c0948d70e92);
$parcel$export(module.exports, "useIsDeleting", () => $5ca1dafd45710058$export$b1f118028875837);
$parcel$export(module.exports, "useIsAdding", () => $5ca1dafd45710058$export$2ab0f4d5ca254690);
$parcel$export(module.exports, "useIsUpdating", () => $5ca1dafd45710058$export$9d3f25b5ebbe8bd1);
$parcel$export(module.exports, "useLinkIcon", () => $5ca1dafd45710058$export$2031541de29c75c7);

var $WBLbN = parcelRequire("WBLbN");

var $bjkZM = parcelRequire("bjkZM");

var $lPWVM = parcelRequire("lPWVM");
const $5ca1dafd45710058$var$initialState = {
    isDeleting: false,
    isAdding: false,
    isUpdating: false,
    isReordering: false,
    links: {
        isLoading: true,
        data: [],
        error: null,
        totalSize: 0
    },
    icons: {}
};
const $5ca1dafd45710058$export$6f57813fe9f31bf9 = (0, $WBLbN.createStore)({
    initialState: $5ca1dafd45710058$var$initialState,
    actions: $bjkZM.actions,
    name: 'ExternalLinksStore'
});
const $5ca1dafd45710058$export$6dff686b9ebd7db3 = (0, $WBLbN.createContainer)($5ca1dafd45710058$export$6f57813fe9f31bf9, {
    displayName: 'ExternalLinksContainer'
});
const $5ca1dafd45710058$export$ee398c0948d70e92 = (0, $WBLbN.createHook)($5ca1dafd45710058$export$6f57813fe9f31bf9, {
    selector: (0, $lPWVM.getExternalLinks)
});
const $5ca1dafd45710058$export$b1f118028875837 = (0, $WBLbN.createHook)($5ca1dafd45710058$export$6f57813fe9f31bf9, {
    selector: (0, $lPWVM.getIsDeleting)
});
const $5ca1dafd45710058$export$2ab0f4d5ca254690 = (0, $WBLbN.createHook)($5ca1dafd45710058$export$6f57813fe9f31bf9, {
    selector: (0, $lPWVM.getIsAdding)
});
const $5ca1dafd45710058$export$9d3f25b5ebbe8bd1 = (0, $WBLbN.createHook)($5ca1dafd45710058$export$6f57813fe9f31bf9, {
    selector: (0, $lPWVM.getIsUpdating)
});
const $5ca1dafd45710058$export$2e0e23eaa99297d = (0, $WBLbN.createHook)($5ca1dafd45710058$export$6f57813fe9f31bf9, {
    selector: (0, $lPWVM.getIsReordering)
});
const $5ca1dafd45710058$export$2031541de29c75c7 = (0, $WBLbN.createHook)($5ca1dafd45710058$export$6f57813fe9f31bf9, {
    selector: (0, $lPWVM.getLinkIcon)
});

});
parcelRegister("bjkZM", function(module, exports) {

$parcel$export(module.exports, "actions", () => $71250acb5672e372$export$e324594224ef24da);

var $hEqcD = parcelRequire("hEqcD");

var $ie54Y = parcelRequire("ie54Y");

var $6exGp = parcelRequire("6exGp");

var $hrLRb = parcelRequire("hrLRb");

var $1YFpn = parcelRequire("1YFpn");

var $cGi9W = parcelRequire("cGi9W");
const $71250acb5672e372$export$e324594224ef24da = {
    addExternalLink: $hEqcD.addExternalLink,
    fetchExternalLinks: $hrLRb.fetchExternalLinks,
    deleteExternalLink: $ie54Y.deleteExternalLink,
    updateExternalLink: $cGi9W.updateExternalLink,
    reorderExternalLink: $1YFpn.reorderExternalLink,
    fetchExternalLinkIcon: $6exGp.fetchExternalLinkIcon
};

});
parcelRegister("hEqcD", function(module, exports) {

$parcel$export(module.exports, "addExternalLink", () => $107c05cb1a1cfe71$export$214e81dd55410a);

var $jMP2a = parcelRequire("jMP2a");

var $exuoN = parcelRequire("exuoN");

var $aLG4f = parcelRequire("aLG4f");

var $4kAdO = parcelRequire("4kAdO");
const $107c05cb1a1cfe71$export$b4b5eff8a8712c89 = 'externalResourceAdd';
const $107c05cb1a1cfe71$export$214e81dd55410a = (formData)=>async ({ getState: getState, setState: setState }, props)=>{
        const { cloudId: cloudId, projectId: projectId, createAnalyticsEvent: createAnalyticsEvent } = props;
        try {
            setState({
                ...getState(),
                isAdding: true
            });
            const { finalData: finalData, wasLinkPrefixedWithExpectedProtocol: wasLinkPrefixedWithExpectedProtocol, protocolPrefix: protocolPrefix } = (0, $exuoN.formatFormData)(formData);
            const { resourceType: resourceType, link: link, title: title, description: description } = finalData;
            const payload = {
                projectId: projectId,
                resourceType: resourceType.value,
                link: link,
                title: title,
                description: description
            };
            const addedLink = await (0, $4kAdO.addExternalLink)(cloudId, payload);
            const currentState = {
                ...getState()
            };
            const newLinks = [
                ...currentState.links.data,
                addedLink
            ];
            setState({
                ...currentState,
                isAdding: false,
                links: {
                    ...currentState.links,
                    data: newLinks,
                    totalSize: currentState.links.totalSize + 1
                }
            });
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), `${$107c05cb1a1cfe71$export$b4b5eff8a8712c89} succeeded`, addedLink.id, {
                resourceType: resourceType.value,
                wasLinkPrefixedWithExpectedProtocol: wasLinkPrefixedWithExpectedProtocol,
                protocolPrefix: protocolPrefix,
                linksCount: newLinks.length
            });
            (0, $aLG4f.externalResourcesAddUpdateExperience).success();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                ...getState(),
                isAdding: false
            });
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), `${$107c05cb1a1cfe71$export$b4b5eff8a8712c89} failed`);
            (0, $aLG4f.markAddUpdateExperienceFailed)(null, error);
            // @ts-expect-error - TS2345 - Argument of type 'false' is not assignable to parameter of type 'string | undefined'.
            throw new Error(false);
        }
    };

});
parcelRegister("exuoN", function(module, exports) {

$parcel$export(module.exports, "getTruncatedTitleForFlag", () => $29a7e23a108fb8ab$export$fc578a036765841);
$parcel$export(module.exports, "formatFormData", () => $29a7e23a108fb8ab$export$8598f685c2ea7d93);
$parcel$export(module.exports, "batch", () => $29a7e23a108fb8ab$export$712ea50be43a7858);

var $dxIU5 = parcelRequire("dxIU5");

var $jG2Eu = parcelRequire("jG2Eu");

var $aNx7t = parcelRequire("aNx7t");
const $29a7e23a108fb8ab$export$fc578a036765841 = (title)=>{
    if (title.trim().length <= (0, $aNx7t.MAX_FLAG_TITLE_LENGTH)) return title;
    return `${title.trim().slice(0, (0, $aNx7t.MAX_FLAG_TITLE_LENGTH))}...`;
};
const $29a7e23a108fb8ab$export$8598f685c2ea7d93 = (formData)=>{
    const { link: link } = formData;
    const finalData = formData;
    const expectedProtocolPrefixes = [
        'https://',
        'http://',
        'ftp://',
        'tel:',
        'mailto:'
    ];
    let wasLinkPrefixedWithExpectedProtocol = false;
    // regex to match URL protocol e.g. https://
    const protoRegex = new RegExp('^(.*:(//)?)(.*)$', 'gm');
    const match = protoRegex.exec(link);
    const protocolPrefix = match ? match[1] : undefined;
    // If the link is prefixed with an expected protocol, do not add any prefix
    // else prefix it with https://
    for(let i = 0; i < expectedProtocolPrefixes.length; i += 1)if (link.indexOf(expectedProtocolPrefixes[i]) === 0) {
        wasLinkPrefixedWithExpectedProtocol = true;
        return {
            finalData: finalData,
            wasLinkPrefixedWithExpectedProtocol: wasLinkPrefixedWithExpectedProtocol,
            protocolPrefix: protocolPrefix
        };
    }
    // prefix with https:// protocol
    finalData.link = `https://${link}`;
    return {
        finalData: finalData,
        wasLinkPrefixedWithExpectedProtocol: wasLinkPrefixedWithExpectedProtocol,
        protocolPrefix: protocolPrefix
    };
};
const $29a7e23a108fb8ab$var$defer = ()=>{
    let resolve = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let reject = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)));
    const promise = new Promise((rslv, rjct)=>{
        resolve = rslv;
        reject = rjct;
    });
    return {
        promise: promise,
        resolve: resolve,
        reject: reject
    };
};
const $29a7e23a108fb8ab$export$712ea50be43a7858 = (func, wait, options = {})=>{
    let arrArg = [];
    let deferred = $29a7e23a108fb8ab$var$defer();
    const callThenResetArgs = (args)=>{
        try {
            const result = func(args);
            deferred.resolve(result);
        } catch (err) {
            deferred.reject(err);
        }
        arrArg = [];
        deferred = $29a7e23a108fb8ab$var$defer();
    };
    const debouncedFunc = (0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))(callThenResetArgs, wait, options);
    return (arg)=>{
        arrArg = arrArg.concat(arg);
        debouncedFunc(arrArg);
        return deferred.promise;
    };
};

});
parcelRegister("aNx7t", function(module, exports) {

$parcel$export(module.exports, "ERROR_TYPES", () => $77656102e0e3b790$export$63d334e60537ba01);
$parcel$export(module.exports, "MAX_URL_LENGTH", () => $77656102e0e3b790$export$ad8ccaa587ef5e2e);
$parcel$export(module.exports, "MAX_TITLE_LENGTH", () => $77656102e0e3b790$export$59c091bb1efefe81);
$parcel$export(module.exports, "MAX_DESCRIPTION_LENGTH", () => $77656102e0e3b790$export$614cf5493945cd86);
$parcel$export(module.exports, "MIN_ROWS_DESCRIPTION", () => $77656102e0e3b790$export$cf66c33b182096db);
$parcel$export(module.exports, "MAX_FLAG_TITLE_LENGTH", () => $77656102e0e3b790$export$da49fbf6bf426381);
$parcel$export(module.exports, "MAX_NO_OF_LINKS_ALLOWED", () => $77656102e0e3b790$export$7c5bdb9e61b5b371);
$parcel$export(module.exports, "MODES", () => $77656102e0e3b790$export$240b20df485e8ed6);
$parcel$export(module.exports, "EXTERNAL_RESOURCES_DELETE_EXPERIENCE_ID", () => $77656102e0e3b790$export$f979fc1cb9cd7020);
$parcel$export(module.exports, "EXTERNAL_RESOURCES_ADD_UPDATE_EXPERIENCE_ID", () => $77656102e0e3b790$export$80bae55ad37f20ba);
$parcel$export(module.exports, "EXTERNAL_RESOURCES_REORDER_EXPERIENCE_ID", () => $77656102e0e3b790$export$a73ead93d783b009);
const $77656102e0e3b790$export$63d334e60537ba01 = {
    EMPTY: 'EMPTY',
    CHAR_LIMIT_EXCEEDED: 'CHAR_LIMIT_EXCEEDED'
};
const $77656102e0e3b790$export$ad8ccaa587ef5e2e = 2048;
const $77656102e0e3b790$export$59c091bb1efefe81 = 100;
const $77656102e0e3b790$export$614cf5493945cd86 = 255;
const $77656102e0e3b790$export$cf66c33b182096db = 5;
const $77656102e0e3b790$export$da49fbf6bf426381 = 25;
const $77656102e0e3b790$export$7c5bdb9e61b5b371 = 10;
const $77656102e0e3b790$export$240b20df485e8ed6 = {
    ADD: 'ADD',
    EDIT: 'EDIT'
};
const $77656102e0e3b790$export$f979fc1cb9cd7020 = 'service-management.delete.external-resources';
const $77656102e0e3b790$export$80bae55ad37f20ba = 'service-management.add-update.external-resources';
const $77656102e0e3b790$export$a73ead93d783b009 = 'service-management.reorder.external-resources';

});


parcelRegister("aLG4f", function(module, exports) {

$parcel$export(module.exports, "ProductExperienceStart", () => $ef58f43db7d22460$export$8c235a9c4b486599);
$parcel$export(module.exports, "externalResourcesDeleteExperience", () => $ef58f43db7d22460$export$c5d738ec805c9b9e);
$parcel$export(module.exports, "externalResourcesAddUpdateExperience", () => $ef58f43db7d22460$export$d066ecff38e96f29);
$parcel$export(module.exports, "externalResourcesReorderExperience", () => $ef58f43db7d22460$export$5c32d878dc2418b5);
$parcel$export(module.exports, "markDeleteExperienceFailed", () => $ef58f43db7d22460$export$b57d27bd052c8a12);
$parcel$export(module.exports, "markAddUpdateExperienceFailed", () => $ef58f43db7d22460$export$52bf0b4c3ecfa8ae);
$parcel$export(module.exports, "markReorderExperienceFailed", () => $ef58f43db7d22460$export$2560a75a127e2e1d);

var $12kyE = parcelRequire("12kyE");
var $kDfSL = parcelRequire("kDfSL");
var $9IbuV = parcelRequire("9IbuV");

var $aNx7t = parcelRequire("aNx7t");
const $ef58f43db7d22460$export$8c235a9c4b486599 = (props)=>{
    const { ufoExperience: ufoExperience } = props;
    (0, $9IbuV.useUFOComponentExperience)(ufoExperience);
    return null;
};
const $ef58f43db7d22460$export$c5d738ec805c9b9e = new (0, $kDfSL.UFOExperience)((0, $aNx7t.EXTERNAL_RESOURCES_DELETE_EXPERIENCE_ID), {
    type: (0, $12kyE.ExperienceTypes).Experience,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).Custom
});
const $ef58f43db7d22460$export$d066ecff38e96f29 = new (0, $kDfSL.UFOExperience)((0, $aNx7t.EXTERNAL_RESOURCES_ADD_UPDATE_EXPERIENCE_ID), {
    type: (0, $12kyE.ExperienceTypes).Experience,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).Custom
});
const $ef58f43db7d22460$export$5c32d878dc2418b5 = new (0, $kDfSL.UFOExperience)((0, $aNx7t.EXTERNAL_RESOURCES_REORDER_EXPERIENCE_ID), {
    type: (0, $12kyE.ExperienceTypes).Experience,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).Custom
});
const $ef58f43db7d22460$var$markExperienceFailed = (experience, error)=>{
    $ef58f43db7d22460$export$d066ecff38e96f29.failure({
        force: true,
        metadata: {
            error: error.message
        }
    });
};
const $ef58f43db7d22460$export$b57d27bd052c8a12 = (location, error)=>{
    $ef58f43db7d22460$var$markExperienceFailed($ef58f43db7d22460$export$c5d738ec805c9b9e, error);
};
const $ef58f43db7d22460$export$52bf0b4c3ecfa8ae = (location, error)=>{
    $ef58f43db7d22460$var$markExperienceFailed($ef58f43db7d22460$export$d066ecff38e96f29, error);
};
const $ef58f43db7d22460$export$2560a75a127e2e1d = (location, error)=>{
    $ef58f43db7d22460$var$markExperienceFailed($ef58f43db7d22460$export$5c32d878dc2418b5, error);
};

});

parcelRegister("4kAdO", function(module, exports) {

$parcel$export(module.exports, "addExternalLink", () => $bfdb559bca189294$export$214e81dd55410a);

var $lRmyA = parcelRequire("lRmyA");
const $bfdb559bca189294$export$214e81dd55410a = (cloudId, payload)=>{
    const uri = `/gateway/api/jira/help-sandook/cloudid/${cloudId}/api/v1/external-links/`;
    return (0, $lRmyA.performPostRequest)(uri, {
        body: JSON.stringify(payload)
    });
};

});


parcelRegister("ie54Y", function(module, exports) {

$parcel$export(module.exports, "deleteExternalLink", () => $4f13ae36fdfc7189$export$d4ac43d2cc195e02);

var $2kD8a = parcelRequire("2kD8a");

var $jMP2a = parcelRequire("jMP2a");

var $aLG4f = parcelRequire("aLG4f");

var $fWU8P = parcelRequire("fWU8P");
const $4f13ae36fdfc7189$export$b4b5eff8a8712c89 = 'externalResourceDelete';
const $4f13ae36fdfc7189$export$d4ac43d2cc195e02 = (linkId)=>async ({ getState: getState, setState: setState }, props)=>{
        const { cloudId: cloudId, projectId: projectId, createAnalyticsEvent: createAnalyticsEvent } = props;
        try {
            setState({
                ...getState(),
                isDeleting: true
            });
            await (0, $fWU8P.deleteExternalLink)(cloudId, projectId, linkId);
            const currentState = {
                ...getState()
            };
            const currentLinks = [
                ...currentState.links.data
            ];
            (0, (/*@__PURE__*/$parcel$interopDefault($2kD8a)))(currentLinks, [
                currentLinks.findIndex(({ id: id })=>id === linkId)
            ]);
            setState({
                ...currentState,
                links: {
                    ...currentState.links,
                    data: currentLinks,
                    totalSize: currentState.links.totalSize - 1
                },
                isDeleting: false
            });
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), `${$4f13ae36fdfc7189$export$b4b5eff8a8712c89} succeeded`);
            (0, $aLG4f.externalResourcesDeleteExperience).success();
            return true;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                ...getState(),
                isDeleting: false
            });
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), `${$4f13ae36fdfc7189$export$b4b5eff8a8712c89} failed`);
            (0, $aLG4f.markDeleteExperienceFailed)(null, error);
            // @ts-expect-error - TS2345 - Argument of type 'false' is not assignable to parameter of type 'string | undefined'.
            throw new Error(false);
        }
    };

});
parcelRegister("2kD8a", function(module, exports) {

var $kJvGp = parcelRequire("kJvGp");

var $leUVW = parcelRequire("leUVW");

var $kufEI = parcelRequire("kufEI");

var $3Sx56 = parcelRequire("3Sx56");

var $224h2 = parcelRequire("224h2");

var $3hFfZ = parcelRequire("3hFfZ");
/**
 * Removes elements from `array` corresponding to `indexes` and returns an
 * array of removed elements.
 *
 * **Note:** Unlike `_.at`, this method mutates `array`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {...(number|number[])} [indexes] The indexes of elements to remove.
 * @returns {Array} Returns the new array of removed elements.
 * @example
 *
 * var array = ['a', 'b', 'c', 'd'];
 * var pulled = _.pullAt(array, [1, 3]);
 *
 * console.log(array);
 * // => ['a', 'c']
 *
 * console.log(pulled);
 * // => ['b', 'd']
 */ var $1b2bcd8e9758dc1b$var$pullAt = $224h2(function(array, indexes) {
    var length = array == null ? 0 : array.length, result = $leUVW(array, indexes);
    $kufEI(array, $kJvGp(indexes, function(index) {
        return $3hFfZ(index, length) ? +index : index;
    }).sort($3Sx56));
    return result;
});
module.exports = $1b2bcd8e9758dc1b$var$pullAt;

});
parcelRegister("leUVW", function(module, exports) {

var $illlw = parcelRequire("illlw");
/**
 * The base implementation of `_.at` without support for individual paths.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {string[]} paths The property paths to pick.
 * @returns {Array} Returns the picked elements.
 */ function $f767119e93640561$var$baseAt(object, paths) {
    var index = -1, length = paths.length, result = Array(length), skip = object == null;
    while(++index < length)result[index] = skip ? undefined : $illlw(object, paths[index]);
    return result;
}
module.exports = $f767119e93640561$var$baseAt;

});

parcelRegister("kufEI", function(module, exports) {

var $3zPPS = parcelRequire("3zPPS");

var $3hFfZ = parcelRequire("3hFfZ");
/** Used for built-in method references. */ var $eea2c0df8dc0632a$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $eea2c0df8dc0632a$var$splice = $eea2c0df8dc0632a$var$arrayProto.splice;
/**
 * The base implementation of `_.pullAt` without support for individual
 * indexes or capturing the removed elements.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {number[]} indexes The indexes of elements to remove.
 * @returns {Array} Returns `array`.
 */ function $eea2c0df8dc0632a$var$basePullAt(array, indexes) {
    var length = array ? indexes.length : 0, lastIndex = length - 1;
    while(length--){
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
            var previous = index;
            if ($3hFfZ(index)) $eea2c0df8dc0632a$var$splice.call(array, index, 1);
            else $3zPPS(array, index);
        }
    }
    return array;
}
module.exports = $eea2c0df8dc0632a$var$basePullAt;

});


parcelRegister("fWU8P", function(module, exports) {

$parcel$export(module.exports, "deleteExternalLink", () => $c96664f133c556af$export$d4ac43d2cc195e02);

var $lRmyA = parcelRequire("lRmyA");
const $c96664f133c556af$export$d4ac43d2cc195e02 = (cloudId, projectId, linkId)=>{
    const uri = `/gateway/api/jira/help-sandook/cloudid/${cloudId}/api/v1/external-links/project/${projectId}/link/${linkId}`;
    return (0, $lRmyA.performDeleteRequest)(uri);
};

});


parcelRegister("6exGp", function(module, exports) {

$parcel$export(module.exports, "fetchExternalLinkIcon", () => $13575b182982f517$export$745020f5681cf571);

var $jMP2a = parcelRequire("jMP2a");

var $exuoN = parcelRequire("exuoN");

var $474rH = parcelRequire("474rH");
const $13575b182982f517$export$b4b5eff8a8712c89 = 'externalResourceIconFetch';
const $13575b182982f517$var$batchedFetchExternalLinkIconService = (0, $exuoN.batch)((0, $474rH.fetchExternalLinkIcon), 0);
const $13575b182982f517$export$745020f5681cf571 = (linkOrigin)=>async ({ getState: getState, setState: setState }, props)=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = props;
        try {
            let state = getState();
            if (Object.keys(state.icons).includes(linkOrigin)) return state.icons[linkOrigin];
            setState({
                ...state,
                icons: {
                    ...state.icons,
                    [linkOrigin]: {
                        iconUrl: null,
                        isLoading: true
                    }
                }
            });
            const resolvedObject = await $13575b182982f517$var$batchedFetchExternalLinkIconService(linkOrigin);
            const iconUrl = resolvedObject[linkOrigin].body?.data?.generator?.icon?.url;
            const linkIconObject = {
                iconUrl: iconUrl,
                isLoading: false
            };
            state = getState();
            setState({
                ...state,
                icons: {
                    ...state.icons,
                    [linkOrigin]: linkIconObject
                }
            });
            (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), `${$13575b182982f517$export$b4b5eff8a8712c89} succeeded`, {
                isIconPresent: Boolean(iconUrl)
            });
            return linkIconObject;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), `${$13575b182982f517$export$b4b5eff8a8712c89} failed`);
            const linkIconObject = {
                iconUrl: null,
                isLoading: false
            };
            const state = getState();
            setState({
                ...state,
                icons: {
                    ...state.icons,
                    [linkOrigin]: linkIconObject
                }
            });
            return linkIconObject;
        }
    };

});
parcelRegister("474rH", function(module, exports) {

$parcel$export(module.exports, "fetchExternalLinkIcon", () => $52a85a12009fed32$export$745020f5681cf571);

var $lRmyA = parcelRequire("lRmyA");
const $52a85a12009fed32$export$745020f5681cf571 = (urls)=>(0, $lRmyA.performPostRequest)('/gateway/api/object-resolver/resolve/batch', {
        body: JSON.stringify(urls.map((url)=>({
                resourceUrl: url
            })))
    }).then((response)=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const results = {};
        urls.forEach((url, index)=>{
            results[url] = response[index];
        });
        return results;
    });

});


parcelRegister("hrLRb", function(module, exports) {

$parcel$export(module.exports, "fetchExternalLinks", () => $35d1a72f099acf6d$export$633b48ab7e391339);

var $jMP2a = parcelRequire("jMP2a");

var $eTwyz = parcelRequire("eTwyz");
const $35d1a72f099acf6d$export$b4b5eff8a8712c89 = 'externalResourcesFetch';
const $35d1a72f099acf6d$export$633b48ab7e391339 = ()=>async ({ getState: getState, setState: setState }, props)=>{
        const { cloudId: cloudId, projectId: projectId, createAnalyticsEvent: createAnalyticsEvent } = props;
        try {
            setState({
                ...getState(),
                links: {
                    data: [],
                    isLoading: true,
                    error: null,
                    totalSize: 0
                }
            });
            const { links: links, total: total } = await (0, $eTwyz.fetchExternalLinks)(cloudId, projectId);
            setState({
                ...getState(),
                links: {
                    data: links,
                    isLoading: false,
                    error: null,
                    totalSize: total
                }
            });
            (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), `${$35d1a72f099acf6d$export$b4b5eff8a8712c89} succeeded`);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            let errorState = error;
            /**
			 * Send experience failure events only when fetch external links API call responds
			 * with a status of 5xx or 404.
			 */ if (`${error.statusCode}`.startsWith('5') || error.statusCode === 404) (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), `${$35d1a72f099acf6d$export$b4b5eff8a8712c89} failed`);
            else errorState = null;
            setState({
                ...getState(),
                links: {
                    data: [],
                    error: errorState,
                    isLoading: false,
                    totalSize: 0
                }
            });
        }
    };

});
parcelRegister("eTwyz", function(module, exports) {

$parcel$export(module.exports, "fetchExternalLinks", () => $1d148d0f8f8522b4$export$633b48ab7e391339);

var $2OdyW = parcelRequire("2OdyW");
const $1d148d0f8f8522b4$export$633b48ab7e391339 = (cloudId, projectId)=>{
    const uri = `/gateway/api/jira/help-sandook/cloudid/${cloudId}/api/v1/external-links/project/${projectId}`;
    return (0, $2OdyW.default)(uri, {
        method: 'GET'
    });
};

});


parcelRegister("1YFpn", function(module, exports) {

$parcel$export(module.exports, "reorderExternalLink", () => $6baa5befc95dc244$export$5307324defbc7dcc);

var $jMP2a = parcelRequire("jMP2a");

var $aLG4f = parcelRequire("aLG4f");

var $ftsV6 = parcelRequire("ftsV6");
const $6baa5befc95dc244$export$b4b5eff8a8712c89 = 'externalResourceReorder';
// @ts-expect-error - TS2304 - Cannot find name 'ExternalLinkObject'.
const $6baa5befc95dc244$var$reorderLinks = (list, startIndex, endIndex)=>{
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
};
const $6baa5befc95dc244$export$5307324defbc7dcc = (sourceIndex, destinationIndex)=>async ({ getState: getState, setState: setState }, props)=>{
        const { cloudId: cloudId, projectId: projectId, createAnalyticsEvent: createAnalyticsEvent } = props;
        const currentState = {
            ...getState()
        };
        try {
            setState({
                ...getState(),
                isReordering: true
            });
            const newLinks = $6baa5befc95dc244$var$reorderLinks(currentState.links.data, sourceIndex, destinationIndex);
            setState({
                ...currentState,
                isReordering: false,
                links: {
                    ...currentState.links,
                    data: newLinks,
                    totalSize: currentState.links.totalSize
                }
            });
            const payload = {
                ids: newLinks.map((link)=>link.id)
            };
            await (0, $ftsV6.reorderExternalLink)(cloudId, projectId, payload);
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), `${$6baa5befc95dc244$export$b4b5eff8a8712c89} succeeded`, {
                sourceIndex: sourceIndex,
                destinationIndex: destinationIndex,
                linksCount: newLinks.length
            });
            (0, $aLG4f.externalResourcesReorderExperience).success();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                ...getState(),
                links: {
                    ...currentState.links
                },
                isReordering: false
            });
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), `${$6baa5befc95dc244$export$b4b5eff8a8712c89} failed`);
            (0, $aLG4f.markReorderExperienceFailed)(null, error);
            // @ts-expect-error - TS2345 - Argument of type 'false' is not assignable to parameter of type 'string | undefined'.
            throw new Error(false);
        }
    };

});
parcelRegister("ftsV6", function(module, exports) {

$parcel$export(module.exports, "reorderExternalLink", () => $d80ab0835171ad33$export$5307324defbc7dcc);

var $lRmyA = parcelRequire("lRmyA");
const $d80ab0835171ad33$export$5307324defbc7dcc = (cloudId, projectId, payload)=>{
    const uri = `/gateway/api/jira/help-sandook/cloudid/${cloudId}/api/v1/external-links/project/${projectId}/reorder`;
    return (0, $lRmyA.performPutRequest)(uri, {
        body: JSON.stringify(payload)
    });
};

});


parcelRegister("cGi9W", function(module, exports) {

$parcel$export(module.exports, "updateExternalLink", () => $00498131a9c12503$export$bfc9d62c36f02bc1);

var $jMP2a = parcelRequire("jMP2a");

var $exuoN = parcelRequire("exuoN");

var $aLG4f = parcelRequire("aLG4f");

var $dPcA2 = parcelRequire("dPcA2");
const $00498131a9c12503$export$b4b5eff8a8712c89 = 'externalResourceUpdate';
const $00498131a9c12503$export$bfc9d62c36f02bc1 = (formData, linkId)=>async ({ getState: getState, setState: setState }, props)=>{
        const { cloudId: cloudId, projectId: projectId, createAnalyticsEvent: createAnalyticsEvent } = props;
        try {
            setState({
                ...getState(),
                isUpdating: true
            });
            const { finalData: finalData, wasLinkPrefixedWithExpectedProtocol: wasLinkPrefixedWithExpectedProtocol, protocolPrefix: protocolPrefix } = (0, $exuoN.formatFormData)(formData);
            const { resourceType: resourceType, link: link, title: title, description: description } = finalData;
            const payload = {
                projectId: projectId,
                id: linkId,
                resourceType: resourceType.value,
                link: link,
                title: title,
                description: description
            };
            const updatedLink = await (0, $dPcA2.updateExternalLink)(cloudId, payload);
            const currentState = {
                ...getState()
            };
            const newLinks = currentState.links.data.map((linkObj)=>linkObj.id === linkId ? updatedLink : linkObj);
            setState({
                ...currentState,
                isUpdating: false,
                links: {
                    ...currentState.links,
                    data: newLinks,
                    totalSize: currentState.links.totalSize
                }
            });
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), `${$00498131a9c12503$export$b4b5eff8a8712c89} succeeded`, updatedLink.id, {
                resourceType: resourceType.value,
                wasLinkPrefixedWithExpectedProtocol: wasLinkPrefixedWithExpectedProtocol,
                protocolPrefix: protocolPrefix,
                linksCount: newLinks.length
            });
            (0, $aLG4f.externalResourcesAddUpdateExperience).success();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                ...getState(),
                isUpdating: false
            });
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), `${$00498131a9c12503$export$b4b5eff8a8712c89} failed`);
            (0, $aLG4f.markAddUpdateExperienceFailed)(null, error);
            // @ts-expect-error - TS2345 - Argument of type 'false' is not assignable to parameter of type 'string | undefined'.
            throw new Error(false);
        }
    };

});
parcelRegister("dPcA2", function(module, exports) {

$parcel$export(module.exports, "updateExternalLink", () => $e98e4315b8cd1964$export$bfc9d62c36f02bc1);

var $lRmyA = parcelRequire("lRmyA");
const $e98e4315b8cd1964$export$bfc9d62c36f02bc1 = (cloudId, payload)=>{
    const uri = `/gateway/api/jira/help-sandook/cloudid/${cloudId}/api/v1/external-links/`;
    return (0, $lRmyA.performPutRequest)(uri, {
        body: JSON.stringify(payload)
    });
};

});



parcelRegister("lPWVM", function(module, exports) {

$parcel$export(module.exports, "getExternalLinks", () => $7dca68ce9599ef30$export$ec401995dee39995);
$parcel$export(module.exports, "getIsDeleting", () => $7dca68ce9599ef30$export$e83cb845d245cbb1);
$parcel$export(module.exports, "getIsAdding", () => $7dca68ce9599ef30$export$8a8d5da7a080041d);
$parcel$export(module.exports, "getIsUpdating", () => $7dca68ce9599ef30$export$e22b6655632ef921);
$parcel$export(module.exports, "getIsReordering", () => $7dca68ce9599ef30$export$a5edcb8e903e1e21);
$parcel$export(module.exports, "getLinkIcon", () => $7dca68ce9599ef30$export$a7d2f0694e28c714);
const $7dca68ce9599ef30$export$ec401995dee39995 = (state)=>state.links;
const $7dca68ce9599ef30$export$e83cb845d245cbb1 = (state)=>state.isDeleting;
const $7dca68ce9599ef30$export$8a8d5da7a080041d = (state)=>state.isAdding;
const $7dca68ce9599ef30$export$e22b6655632ef921 = (state)=>state.isUpdating;
const $7dca68ce9599ef30$export$a5edcb8e903e1e21 = (state)=>state.isReordering;
const $7dca68ce9599ef30$export$a7d2f0694e28c714 = (state, linkUrl)=>state.icons[linkUrl];

});


parcelRegister("7c9iU", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d227fb86bca2c78$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $4d227fb86bca2c78$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    errorHeader: {
        "id": "servicedesk-external-links.error-header",
        "defaultMessage": "We couldn\u2019t load your links"
    },
    errorDescription: {
        "id": "servicedesk-external-links.error-description",
        "defaultMessage": "Refresh the page to try again."
    }
});

});

parcelRegister("9pxTN", function(module, exports) {

$parcel$export(module.exports, "Links", () => $967febb674adf9aa$export$b2e089eb3692b073);

var $eUqFw = parcelRequire("eUqFw");

var $966Wa = parcelRequire("966Wa");

var $51sCz = parcelRequire("51sCz");

var $dULIU = parcelRequire("dULIU");

var $4Bees = parcelRequire("4Bees");

var $3a8wJ = parcelRequire("3a8wJ");

var $0cdA8 = parcelRequire("0cdA8");

var $k8Qyf = parcelRequire("k8Qyf");

var $5JgJ2 = parcelRequire("5JgJ2");

var $8WuJm = parcelRequire("8WuJm");
var $jMP2a = parcelRequire("jMP2a");

var $be3PE = parcelRequire("be3PE");

var $51Ia6 = parcelRequire("51Ia6");

var $aNx7t = parcelRequire("aNx7t");

var $exuoN = parcelRequire("exuoN");

var $aLG4f = parcelRequire("aLG4f");

var $8e1a3 = parcelRequire("8e1a3");

var $2XNf4 = parcelRequire("2XNf4");

var $aQ7jM = parcelRequire("aQ7jM");

var $6SJDT = parcelRequire("6SJDT");

var $hI9bd = parcelRequire("hI9bd");

var $ajZNq = parcelRequire("ajZNq");

var $frmnI = parcelRequire("frmnI");
const $967febb674adf9aa$export$b2e089eb3692b073 = ({ links: links, isLoading: isLoading, isDeleting: isDeleting, onDelete: onDelete, onReorder: onReorder })=>{
    const [linkToBeDeleted, setIsLinkToBeDeleted] = (0, $eUqFw.useState)(null);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagService)();
    const hasLinks = links.length > 0;
    const isMaxLimitReached = links.length >= (0, $aNx7t.MAX_NO_OF_LINKS_ALLOWED);
    const [isAddLinkModalOpen, setIsAddLinkModalOpen] = (0, $eUqFw.useState)(false);
    const [mode, setMode] = (0, $eUqFw.useState)((0, $aNx7t.MODES).ADD);
    const [linkToBeUpdated, setLinkToBeUpdated] = (0, $eUqFw.useState)(null);
    const [{ data: pageContextData }] = (0, $51Ia6.usePageContext)();
    const portalUrl = pageContextData?.serviceDeskContext.portalUrl;
    const openAddLinkModal = (0, $eUqFw.useCallback)(()=>{
        setMode((0, $aNx7t.MODES).ADD);
        setIsAddLinkModalOpen(true);
    }, [
        setIsAddLinkModalOpen,
        setMode
    ]);
    const closeAddLinkModal = (0, $eUqFw.useCallback)(()=>setIsAddLinkModalOpen(false), [
        setIsAddLinkModalOpen
    ]);
    const openUpdateLinkModal = (0, $eUqFw.useCallback)((linkId)=>{
        setMode((0, $aNx7t.MODES).EDIT);
        setIsAddLinkModalOpen(true);
        setLinkToBeUpdated(links[links.findIndex(({ id: id })=>id === linkId)]);
    }, [
        setIsAddLinkModalOpen,
        setMode,
        setLinkToBeUpdated,
        links
    ]);
    const onDragEnd = (0, $eUqFw.useCallback)((result)=>{
        const sourceIndex = result.source.index;
        const destinationIndex = result.destination ? result.destination.index : null;
        // may not have any destination (drag to nowhere)
        if (destinationIndex !== null) onReorder(sourceIndex, destinationIndex).catch(()=>{
            showFlag({
                type: 'error',
                isAutoDismiss: true,
                title: (0, $ajZNq.default).externalLinksReorderFailureTitle,
                description: (0, $ajZNq.default).externalLinksReorderFailureDescription
            });
        });
    }, [
        onReorder,
        showFlag
    ]);
    const DraggableLinks = (0, $eUqFw.useMemo)(()=>links.map((link, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $966Wa.Draggable), {
                draggableId: link.id,
                key: link.id,
                index: index
            }, ({ draggableProps: draggableProps, dragHandleProps: dragHandleProps, innerRef: innerRef }, { isDragging: isDragging })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $frmnI.DragWrapper), {
                    ...draggableProps,
                    ref: innerRef,
                    isDragging: isDragging
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $frmnI.LinkWrapper), {
                    "data-testid": "servicedesk-external-links.ui.links.link-wrapper"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $51sCz.default), {
                    isInset: true
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $frmnI.DragButton), {
                    ...dragHandleProps,
                    "aria-label": formatMessage((0, $ajZNq.default).externalLinksReorderDragIndicatorNonfinal),
                    "data-testid": "servicedesk-external-links.ui.links.drag-button"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dULIU))), {
                    label: formatMessage((0, $ajZNq.default).externalLinksReorderDragIndicatorNonfinal)
                }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $frmnI.LinkContentWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI9bd.Link), {
                    key: link.id,
                    ...link,
                    index: index,
                    onDelete: (linkId)=>setIsLinkToBeDeleted(linkId),
                    onUpdate: (linkId)=>openUpdateLinkModal(linkId)
                })))))), [
        links,
        formatMessage,
        openUpdateLinkModal,
        setIsLinkToBeDeleted
    ]);
    const DraggableLinksView = (0, $eUqFw.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
            id: "externalResourcesReorder",
            packageName: "jiraServicedeskExternalResourcesSettings",
            teamName: "jsm-nebula",
            fallback: "flag",
            onError: (0, $aLG4f.markReorderExperienceFailed)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $966Wa.DragDropContext), {
            onDragEnd: onDragEnd
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $966Wa.Droppable), {
            droppableId: "droppable-link"
        }, ({ droppableProps: droppableProps, innerRef: innerRef, placeholder: placeholder }, { isDraggingOver: isDraggingOver })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $frmnI.LinksListWrapper), {
                ...droppableProps,
                ref: innerRef,
                isDraggingOver: isDraggingOver
            }, DraggableLinks, placeholder)))), [
        onDragEnd,
        DraggableLinks
    ]);
    const getContent = ()=>{
        if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $frmnI.LinksContentContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $frmnI.SpinnerContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
            size: "large"
        })));
        if (!hasLinks) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aQ7jM.EmptyLinkSection), {
            onAddLinkClick: openAddLinkModal
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $frmnI.LinksContentContainer), null, DraggableLinksView);
    };
    const getTruncatedLinkTitle = ()=>(0, $exuoN.getTruncatedTitleForFlag)(links.find((link)=>link.id === linkToBeDeleted)?.title || '');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $frmnI.LinksWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3a8wJ.default), {
        actions: hasLinks ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $frmnI.PageActionsWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $frmnI.StyledButton), {
            appearance: "primary",
            onClick: (_, analyticsEvent)=>{
                (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'externalResourceAdd', {
                    isEmpty: false
                });
                openAddLinkModal();
            },
            isDisabled: isMaxLimitReached,
            name: "external-resource-add",
            "data-testId": "servicedesk-external-links.ui.links.add-link-button"
        }, formatMessage((0, $ajZNq.default).externalLinksAddLinkButton)), isMaxLimitReached && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6SJDT.LimitReachedPopup), null)) : null
    }, formatMessage((0, $ajZNq.default).externalLinksPageHeaderHeading)), hasLinks ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", {
        "data-test-id": "servicedesk-external-links.ui.links.p"
    }, formatMessage((0, $ajZNq.default).externalLinksReorderingPageHeaderDescription, {
        limit: (0, $aNx7t.MAX_NO_OF_LINKS_ALLOWED),
        a: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
                href: portalUrl,
                target: "_blank"
            }, chunks)
    })) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        attributes: {
            links_count: links.length
        }
    }, getContent()), !isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $be3PE.JsmPageInteractiveEvent), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2XNf4.DeleteDiscardPrompt), {
        isOpen: Boolean(linkToBeDeleted),
        isDeleting: isDeleting,
        onCancel: ()=>setIsLinkToBeDeleted(null),
        onProceed: ()=>{
            if (linkToBeDeleted !== null) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            onDelete(linkToBeDeleted).then((isSuccessfull)=>{
                if (isSuccessfull) {
                    setIsLinkToBeDeleted(null);
                    showFlag({
                        type: 'success',
                        isAutoDismiss: true,
                        title: (0, $ajZNq.default).externalLinksDeleteSuccessFlagTitle,
                        description: [
                            (0, $ajZNq.default).externalLinksDeleteSuccessFlagDescription,
                            {
                                linkTitle: getTruncatedLinkTitle()
                            }
                        ]
                    });
                }
            }).catch(()=>{
                showFlag({
                    type: 'error',
                    isAutoDismiss: true,
                    title: (0, $ajZNq.default).externalLinksDeleteFailureTitle,
                    description: (0, $ajZNq.default).externalLinksDeleteFailureDescription
                });
            });
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8e1a3.AddLinkModal), {
        isOpen: isAddLinkModalOpen,
        onClose: closeAddLinkModal,
        mode: mode,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        link: linkToBeUpdated
    }));
};
var $967febb674adf9aa$export$2e2bcd8739ae039 = $967febb674adf9aa$export$b2e089eb3692b073;

});
parcelRegister("966Wa", function(module, exports) {

$parcel$export(module.exports, "DragDropContext", () => $69fa0e3037063634$export$237bd83162c14364);
$parcel$export(module.exports, "Draggable", () => $69fa0e3037063634$export$f2a139e5d18b9882);
$parcel$export(module.exports, "Droppable", () => $69fa0e3037063634$export$423ec2075359570a);

var $eUqFw = parcelRequire("eUqFw");

var $fzXll = parcelRequire("fzXll");

var $bqCNv = parcelRequire("bqCNv");

var $34lu7 = parcelRequire("34lu7");

var $4QJdp = parcelRequire("4QJdp");
parcelRequire("jJs3W");
var $94zHK = parcelRequire("94zHK");
var $b02ud = parcelRequire("b02ud");

var $bn5nT = parcelRequire("bn5nT");

var $dCUwp = parcelRequire("dCUwp");

var $3YjjI = parcelRequire("3YjjI");

var $l1Zd2 = parcelRequire("l1Zd2");

var $gxvYj = parcelRequire("gxvYj");

var $5JNlj = parcelRequire("5JNlj");

var $85I24 = parcelRequire("85I24");

var $lEfVV = parcelRequire("lEfVV");

var $8kUbC = parcelRequire("8kUbC");
var $69fa0e3037063634$var$isProduction = true;
var $69fa0e3037063634$var$spacesAndTabs = /[ \t]{2,}/g;
var $69fa0e3037063634$var$lineStartWithSpaces = /^[ \t]*/gm;
var $69fa0e3037063634$var$clean = function clean(value) {
    return value.replace($69fa0e3037063634$var$spacesAndTabs, ' ').replace($69fa0e3037063634$var$lineStartWithSpaces, '').trim();
};
var $69fa0e3037063634$var$getDevMessage = function getDevMessage(message) {
    return $69fa0e3037063634$var$clean("\n  %creact-beautiful-dnd\n\n  %c" + $69fa0e3037063634$var$clean(message) + "\n\n  %c\uD83D\uDC77\u200D This is a development only message. It will be removed in production builds.\n");
};
var $69fa0e3037063634$var$getFormattedMessage = function getFormattedMessage(message) {
    return [
        $69fa0e3037063634$var$getDevMessage(message),
        'color: #00C584; font-size: 1.2em; font-weight: bold;',
        'line-height: 1.5',
        'color: #723874;'
    ];
};
var $69fa0e3037063634$var$isDisabledFlag = '__react-beautiful-dnd-disable-dev-warnings';
function $69fa0e3037063634$var$log(type, message) {
    var _console;
    if ($69fa0e3037063634$var$isProduction) return;
    if (typeof window !== 'undefined' && window[$69fa0e3037063634$var$isDisabledFlag]) return;
    (_console = console)[type].apply(_console, $69fa0e3037063634$var$getFormattedMessage(message));
}
var $69fa0e3037063634$var$warning = $69fa0e3037063634$var$log.bind(null, 'warn');
var $69fa0e3037063634$var$error = $69fa0e3037063634$var$log.bind(null, 'error');
function $69fa0e3037063634$var$noop() {}
function $69fa0e3037063634$var$getOptions(shared, fromBinding) {
    return (0, $34lu7.default)({}, shared, fromBinding);
}
function $69fa0e3037063634$var$bindEvents(el, bindings, sharedOptions) {
    var unbindings = bindings.map(function(binding) {
        var options = $69fa0e3037063634$var$getOptions(sharedOptions, binding.options);
        el.addEventListener(binding.eventName, binding.fn, options);
        return function unbind() {
            el.removeEventListener(binding.eventName, binding.fn, options);
        };
    });
    return function unbindAll() {
        unbindings.forEach(function(unbind) {
            unbind();
        });
    };
}
var $69fa0e3037063634$var$isProduction$1 = true;
var $69fa0e3037063634$var$prefix = 'Invariant failed';
function $69fa0e3037063634$var$RbdInvariant(message) {
    this.message = message;
}
$69fa0e3037063634$var$RbdInvariant.prototype.toString = function toString() {
    return this.message;
};
function $69fa0e3037063634$var$invariant(condition, message) {
    if (condition) return;
    if ($69fa0e3037063634$var$isProduction$1) throw new $69fa0e3037063634$var$RbdInvariant($69fa0e3037063634$var$prefix);
    else throw new $69fa0e3037063634$var$RbdInvariant($69fa0e3037063634$var$prefix + ": " + (message || ''));
}
var $69fa0e3037063634$var$ErrorBoundary = function(_React$Component) {
    (0, $bqCNv.default)(ErrorBoundary, _React$Component);
    function ErrorBoundary() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.callbacks = null;
        _this.unbind = $69fa0e3037063634$var$noop;
        _this.onWindowError = function(event) {
            var callbacks = _this.getCallbacks();
            if (callbacks.isDragging()) callbacks.tryAbort();
            var err = event.error;
            if (err instanceof $69fa0e3037063634$var$RbdInvariant) event.preventDefault();
        };
        _this.getCallbacks = function() {
            if (!_this.callbacks) throw new Error('Unable to find AppCallbacks in <ErrorBoundary/>');
            return _this.callbacks;
        };
        _this.setCallbacks = function(callbacks) {
            _this.callbacks = callbacks;
        };
        return _this;
    }
    var _proto = ErrorBoundary.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.unbind = $69fa0e3037063634$var$bindEvents(window, [
            {
                eventName: 'error',
                fn: this.onWindowError
            }
        ]);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.unbind();
    };
    _proto.componentDidCatch = function componentDidCatch(err) {
        if (err instanceof $69fa0e3037063634$var$RbdInvariant) {
            this.setState({});
            return;
        }
        throw err;
    };
    _proto.render = function render() {
        return this.props.children(this.setCallbacks);
    };
    return ErrorBoundary;
}((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component);
var $69fa0e3037063634$var$liftInstruction = "Draggable item. Ensure your screen reader is not in browse mode and then press space bar to lift.";
var $69fa0e3037063634$var$position = function position(index) {
    return index + 1;
};
var $69fa0e3037063634$var$onDragStart = function onDragStart(start) {
    return "\n  You have lifted an item in position " + $69fa0e3037063634$var$position(start.source.index) + ".\n  Use the arrow keys to move, space bar to drop, and escape to cancel.\n";
};
var $69fa0e3037063634$var$withLocation = function withLocation(source, destination) {
    var isInHomeList = source.droppableId === destination.droppableId;
    var startPosition = $69fa0e3037063634$var$position(source.index);
    var endPosition = $69fa0e3037063634$var$position(destination.index);
    if (isInHomeList) return "\n      You have moved the item from position " + startPosition + "\n      to position " + endPosition + "\n    ";
    return "\n    You have moved the item from position " + startPosition + "\n    in list " + source.droppableId + "\n    to list " + destination.droppableId + "\n    in position " + endPosition + "\n  ";
};
var $69fa0e3037063634$var$withCombine = function withCombine(id, source, combine) {
    var inHomeList = source.droppableId === combine.droppableId;
    if (inHomeList) return "\n      The item " + id + "\n      has been combined with " + combine.draggableId;
    return "\n      The item " + id + "\n      in list " + source.droppableId + "\n      has been combined with " + combine.draggableId + "\n      in list " + combine.droppableId + "\n    ";
};
var $69fa0e3037063634$var$onDragUpdate = function onDragUpdate(update) {
    var location = update.destination;
    if (location) return $69fa0e3037063634$var$withLocation(update.source, location);
    var combine = update.combine;
    if (combine) return $69fa0e3037063634$var$withCombine(update.draggableId, update.source, combine);
    return 'You are over an area that cannot be dropped on';
};
var $69fa0e3037063634$var$returnedToStart = function returnedToStart(source) {
    return "\n  The item has returned to its starting position\n  of " + $69fa0e3037063634$var$position(source.index) + "\n";
};
var $69fa0e3037063634$var$onDragEnd = function onDragEnd(result) {
    if (result.reason === 'CANCEL') return "\n      Movement cancelled.\n      " + $69fa0e3037063634$var$returnedToStart(result.source) + "\n    ";
    var location = result.destination;
    var combine = result.combine;
    if (location) return "\n      You have dropped the item.\n      " + $69fa0e3037063634$var$withLocation(result.source, location) + "\n    ";
    if (combine) return "\n      You have dropped the item.\n      " + $69fa0e3037063634$var$withCombine(result.draggableId, result.source, combine) + "\n    ";
    return "\n    The item has been dropped while not over a drop area.\n    " + $69fa0e3037063634$var$returnedToStart(result.source) + "\n  ";
};
var $69fa0e3037063634$var$preset = {
    liftInstruction: $69fa0e3037063634$var$liftInstruction,
    onDragStart: $69fa0e3037063634$var$onDragStart,
    onDragUpdate: $69fa0e3037063634$var$onDragUpdate,
    onDragEnd: $69fa0e3037063634$var$onDragEnd
};
var $69fa0e3037063634$var$origin = {
    x: 0,
    y: 0
};
var $69fa0e3037063634$var$add = function add(point1, point2) {
    return {
        x: point1.x + point2.x,
        y: point1.y + point2.y
    };
};
var $69fa0e3037063634$var$subtract = function subtract(point1, point2) {
    return {
        x: point1.x - point2.x,
        y: point1.y - point2.y
    };
};
var $69fa0e3037063634$var$isEqual = function isEqual(point1, point2) {
    return point1.x === point2.x && point1.y === point2.y;
};
var $69fa0e3037063634$var$negate = function negate(point) {
    return {
        x: point.x !== 0 ? -point.x : 0,
        y: point.y !== 0 ? -point.y : 0
    };
};
var $69fa0e3037063634$var$patch = function patch(line, value, otherValue) {
    var _ref;
    if (otherValue === void 0) otherValue = 0;
    return _ref = {}, _ref[line] = value, _ref[line === 'x' ? 'y' : 'x'] = otherValue, _ref;
};
var $69fa0e3037063634$var$distance = function distance(point1, point2) {
    return Math.sqrt(Math.pow(point2.x - point1.x, 2) + Math.pow(point2.y - point1.y, 2));
};
var $69fa0e3037063634$var$closest = function closest(target, points) {
    return Math.min.apply(Math, points.map(function(point) {
        return $69fa0e3037063634$var$distance(target, point);
    }));
};
var $69fa0e3037063634$var$apply = function apply(fn) {
    return function(point) {
        return {
            x: fn(point.x),
            y: fn(point.y)
        };
    };
};
var $69fa0e3037063634$var$executeClip = function(frame, subject) {
    var result = (0, $bn5nT.getRect)({
        top: Math.max(subject.top, frame.top),
        right: Math.min(subject.right, frame.right),
        bottom: Math.min(subject.bottom, frame.bottom),
        left: Math.max(subject.left, frame.left)
    });
    if (result.width <= 0 || result.height <= 0) return null;
    return result;
};
var $69fa0e3037063634$var$offsetByPosition = function offsetByPosition(spacing, point) {
    return {
        top: spacing.top + point.y,
        left: spacing.left + point.x,
        bottom: spacing.bottom + point.y,
        right: spacing.right + point.x
    };
};
var $69fa0e3037063634$var$getCorners = function getCorners(spacing) {
    return [
        {
            x: spacing.left,
            y: spacing.top
        },
        {
            x: spacing.right,
            y: spacing.top
        },
        {
            x: spacing.left,
            y: spacing.bottom
        },
        {
            x: spacing.right,
            y: spacing.bottom
        }
    ];
};
var $69fa0e3037063634$var$noSpacing = {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
};
var $69fa0e3037063634$var$scroll = function scroll(target, frame) {
    if (!frame) return target;
    return $69fa0e3037063634$var$offsetByPosition(target, frame.scroll.diff.displacement);
};
var $69fa0e3037063634$var$increase = function increase(target, axis, withPlaceholder) {
    if (withPlaceholder && withPlaceholder.increasedBy) {
        var _extends2;
        return (0, $34lu7.default)({}, target, (_extends2 = {}, _extends2[axis.end] = target[axis.end] + withPlaceholder.increasedBy[axis.line], _extends2));
    }
    return target;
};
var $69fa0e3037063634$var$clip = function clip(target, frame) {
    if (frame && frame.shouldClipSubject) return $69fa0e3037063634$var$executeClip(frame.pageMarginBox, target);
    return (0, $bn5nT.getRect)(target);
};
var $69fa0e3037063634$var$getSubject = function(_ref) {
    var page = _ref.page, withPlaceholder = _ref.withPlaceholder, axis = _ref.axis, frame = _ref.frame;
    var scrolled = $69fa0e3037063634$var$scroll(page.marginBox, frame);
    var increased = $69fa0e3037063634$var$increase(scrolled, axis, withPlaceholder);
    var clipped = $69fa0e3037063634$var$clip(increased, frame);
    return {
        page: page,
        withPlaceholder: withPlaceholder,
        active: clipped
    };
};
var $69fa0e3037063634$var$scrollDroppable = function(droppable, newScroll) {
    !droppable.frame && $69fa0e3037063634$var$invariant(false);
    var scrollable = droppable.frame;
    var scrollDiff = $69fa0e3037063634$var$subtract(newScroll, scrollable.scroll.initial);
    var scrollDisplacement = $69fa0e3037063634$var$negate(scrollDiff);
    var frame = (0, $34lu7.default)({}, scrollable, {
        scroll: {
            initial: scrollable.scroll.initial,
            current: newScroll,
            diff: {
                value: scrollDiff,
                displacement: scrollDisplacement
            },
            max: scrollable.scroll.max
        }
    });
    var subject = $69fa0e3037063634$var$getSubject({
        page: droppable.subject.page,
        withPlaceholder: droppable.subject.withPlaceholder,
        axis: droppable.axis,
        frame: frame
    });
    var result = (0, $34lu7.default)({}, droppable, {
        frame: frame,
        subject: subject
    });
    return result;
};
function $69fa0e3037063634$var$values(map) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($3YjjI)))(map);
}
function $69fa0e3037063634$var$findIndex(list, predicate) {
    if (list.findIndex) return list.findIndex(predicate);
    for(var i = 0; i < list.length; i++){
        if (predicate(list[i])) return i;
    }
    return -1;
}
function $69fa0e3037063634$var$find(list, predicate) {
    if (list.find) return list.find(predicate);
    var index = $69fa0e3037063634$var$findIndex(list, predicate);
    if (index !== -1) return list[index];
    return undefined;
}
function $69fa0e3037063634$var$toArray(list) {
    return Array.prototype.slice.call(list);
}
var $69fa0e3037063634$var$toDroppableMap = (0, $dCUwp.default)(function(droppables) {
    return droppables.reduce(function(previous, current) {
        previous[current.descriptor.id] = current;
        return previous;
    }, {});
});
var $69fa0e3037063634$var$toDraggableMap = (0, $dCUwp.default)(function(draggables) {
    return draggables.reduce(function(previous, current) {
        previous[current.descriptor.id] = current;
        return previous;
    }, {});
});
var $69fa0e3037063634$var$toDroppableList = (0, $dCUwp.default)(function(droppables) {
    return $69fa0e3037063634$var$values(droppables);
});
var $69fa0e3037063634$var$toDraggableList = (0, $dCUwp.default)(function(draggables) {
    return $69fa0e3037063634$var$values(draggables);
});
var $69fa0e3037063634$var$getDraggablesInsideDroppable = (0, $dCUwp.default)(function(droppableId, draggables) {
    var result = $69fa0e3037063634$var$toDraggableList(draggables).filter(function(draggable) {
        return droppableId === draggable.descriptor.droppableId;
    }).sort(function(a, b) {
        return a.descriptor.index - b.descriptor.index;
    });
    return result;
});
function $69fa0e3037063634$var$tryGetDestination(impact) {
    if (impact.at && impact.at.type === 'REORDER') return impact.at.destination;
    return null;
}
function $69fa0e3037063634$var$tryGetCombine(impact) {
    if (impact.at && impact.at.type === 'COMBINE') return impact.at.combine;
    return null;
}
var $69fa0e3037063634$var$removeDraggableFromList = (0, $dCUwp.default)(function(remove, list) {
    return list.filter(function(item) {
        return item.descriptor.id !== remove.descriptor.id;
    });
});
var $69fa0e3037063634$var$moveToNextCombine = function(_ref) {
    var isMovingForward = _ref.isMovingForward, draggable = _ref.draggable, destination = _ref.destination, insideDestination = _ref.insideDestination, previousImpact = _ref.previousImpact;
    if (!destination.isCombineEnabled) return null;
    var location = $69fa0e3037063634$var$tryGetDestination(previousImpact);
    if (!location) return null;
    function getImpact(target) {
        var at = {
            type: 'COMBINE',
            combine: {
                draggableId: target,
                droppableId: destination.descriptor.id
            }
        };
        return (0, $34lu7.default)({}, previousImpact, {
            at: at
        });
    }
    var all = previousImpact.displaced.all;
    var closestId = all.length ? all[0] : null;
    if (isMovingForward) return closestId ? getImpact(closestId) : null;
    var withoutDraggable = $69fa0e3037063634$var$removeDraggableFromList(draggable, insideDestination);
    if (!closestId) {
        if (!withoutDraggable.length) return null;
        var last = withoutDraggable[withoutDraggable.length - 1];
        return getImpact(last.descriptor.id);
    }
    var indexOfClosest = $69fa0e3037063634$var$findIndex(withoutDraggable, function(d) {
        return d.descriptor.id === closestId;
    });
    !(indexOfClosest !== -1) && $69fa0e3037063634$var$invariant(false);
    var proposedIndex = indexOfClosest - 1;
    if (proposedIndex < 0) return null;
    var before = withoutDraggable[proposedIndex];
    return getImpact(before.descriptor.id);
};
var $69fa0e3037063634$var$isHomeOf = function(draggable, destination) {
    return draggable.descriptor.droppableId === destination.descriptor.id;
};
var $69fa0e3037063634$var$noDisplacedBy = {
    point: $69fa0e3037063634$var$origin,
    value: 0
};
var $69fa0e3037063634$var$emptyGroups = {
    invisible: {},
    visible: {},
    all: []
};
var $69fa0e3037063634$var$noImpact = {
    displaced: $69fa0e3037063634$var$emptyGroups,
    displacedBy: $69fa0e3037063634$var$noDisplacedBy,
    at: null
};
var $69fa0e3037063634$var$isWithin = function(lowerBound, upperBound) {
    return function(value) {
        return lowerBound <= value && value <= upperBound;
    };
};
var $69fa0e3037063634$var$isPartiallyVisibleThroughFrame = function(frame) {
    var isWithinVertical = $69fa0e3037063634$var$isWithin(frame.top, frame.bottom);
    var isWithinHorizontal = $69fa0e3037063634$var$isWithin(frame.left, frame.right);
    return function(subject) {
        var isContained = isWithinVertical(subject.top) && isWithinVertical(subject.bottom) && isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);
        if (isContained) return true;
        var isPartiallyVisibleVertically = isWithinVertical(subject.top) || isWithinVertical(subject.bottom);
        var isPartiallyVisibleHorizontally = isWithinHorizontal(subject.left) || isWithinHorizontal(subject.right);
        var isPartiallyContained = isPartiallyVisibleVertically && isPartiallyVisibleHorizontally;
        if (isPartiallyContained) return true;
        var isBiggerVertically = subject.top < frame.top && subject.bottom > frame.bottom;
        var isBiggerHorizontally = subject.left < frame.left && subject.right > frame.right;
        var isTargetBiggerThanFrame = isBiggerVertically && isBiggerHorizontally;
        if (isTargetBiggerThanFrame) return true;
        var isTargetBiggerOnOneAxis = isBiggerVertically && isPartiallyVisibleHorizontally || isBiggerHorizontally && isPartiallyVisibleVertically;
        return isTargetBiggerOnOneAxis;
    };
};
var $69fa0e3037063634$var$isTotallyVisibleThroughFrame = function(frame) {
    var isWithinVertical = $69fa0e3037063634$var$isWithin(frame.top, frame.bottom);
    var isWithinHorizontal = $69fa0e3037063634$var$isWithin(frame.left, frame.right);
    return function(subject) {
        var isContained = isWithinVertical(subject.top) && isWithinVertical(subject.bottom) && isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);
        return isContained;
    };
};
var $69fa0e3037063634$var$vertical = {
    direction: 'vertical',
    line: 'y',
    crossAxisLine: 'x',
    start: 'top',
    end: 'bottom',
    size: 'height',
    crossAxisStart: 'left',
    crossAxisEnd: 'right',
    crossAxisSize: 'width'
};
var $69fa0e3037063634$var$horizontal = {
    direction: 'horizontal',
    line: 'x',
    crossAxisLine: 'y',
    start: 'left',
    end: 'right',
    size: 'width',
    crossAxisStart: 'top',
    crossAxisEnd: 'bottom',
    crossAxisSize: 'height'
};
var $69fa0e3037063634$var$isTotallyVisibleThroughFrameOnAxis = function(axis) {
    return function(frame) {
        var isWithinVertical = $69fa0e3037063634$var$isWithin(frame.top, frame.bottom);
        var isWithinHorizontal = $69fa0e3037063634$var$isWithin(frame.left, frame.right);
        return function(subject) {
            if (axis === $69fa0e3037063634$var$vertical) return isWithinVertical(subject.top) && isWithinVertical(subject.bottom);
            return isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);
        };
    };
};
var $69fa0e3037063634$var$getDroppableDisplaced = function getDroppableDisplaced(target, destination) {
    var displacement = destination.frame ? destination.frame.scroll.diff.displacement : $69fa0e3037063634$var$origin;
    return $69fa0e3037063634$var$offsetByPosition(target, displacement);
};
var $69fa0e3037063634$var$isVisibleInDroppable = function isVisibleInDroppable(target, destination, isVisibleThroughFrameFn) {
    if (!destination.subject.active) return false;
    return isVisibleThroughFrameFn(destination.subject.active)(target);
};
var $69fa0e3037063634$var$isVisibleInViewport = function isVisibleInViewport(target, viewport, isVisibleThroughFrameFn) {
    return isVisibleThroughFrameFn(viewport)(target);
};
var $69fa0e3037063634$var$isVisible = function isVisible(_ref) {
    var toBeDisplaced = _ref.target, destination = _ref.destination, viewport = _ref.viewport, withDroppableDisplacement = _ref.withDroppableDisplacement, isVisibleThroughFrameFn = _ref.isVisibleThroughFrameFn;
    var displacedTarget = withDroppableDisplacement ? $69fa0e3037063634$var$getDroppableDisplaced(toBeDisplaced, destination) : toBeDisplaced;
    return $69fa0e3037063634$var$isVisibleInDroppable(displacedTarget, destination, isVisibleThroughFrameFn) && $69fa0e3037063634$var$isVisibleInViewport(displacedTarget, viewport, isVisibleThroughFrameFn);
};
var $69fa0e3037063634$var$isPartiallyVisible = function isPartiallyVisible(args) {
    return $69fa0e3037063634$var$isVisible((0, $34lu7.default)({}, args, {
        isVisibleThroughFrameFn: $69fa0e3037063634$var$isPartiallyVisibleThroughFrame
    }));
};
var $69fa0e3037063634$var$isTotallyVisible = function isTotallyVisible(args) {
    return $69fa0e3037063634$var$isVisible((0, $34lu7.default)({}, args, {
        isVisibleThroughFrameFn: $69fa0e3037063634$var$isTotallyVisibleThroughFrame
    }));
};
var $69fa0e3037063634$var$isTotallyVisibleOnAxis = function isTotallyVisibleOnAxis(args) {
    return $69fa0e3037063634$var$isVisible((0, $34lu7.default)({}, args, {
        isVisibleThroughFrameFn: $69fa0e3037063634$var$isTotallyVisibleThroughFrameOnAxis(args.destination.axis)
    }));
};
var $69fa0e3037063634$var$getShouldAnimate = function getShouldAnimate(id, last, forceShouldAnimate) {
    if (typeof forceShouldAnimate === 'boolean') return forceShouldAnimate;
    if (!last) return true;
    var invisible = last.invisible, visible = last.visible;
    if (invisible[id]) return false;
    var previous = visible[id];
    return previous ? previous.shouldAnimate : true;
};
function $69fa0e3037063634$var$getTarget(draggable, displacedBy) {
    var marginBox = draggable.page.marginBox;
    var expandBy = {
        top: displacedBy.point.y,
        right: 0,
        bottom: 0,
        left: displacedBy.point.x
    };
    return (0, $bn5nT.getRect)((0, $bn5nT.expand)(marginBox, expandBy));
}
function $69fa0e3037063634$var$getDisplacementGroups(_ref) {
    var afterDragging = _ref.afterDragging, destination = _ref.destination, displacedBy = _ref.displacedBy, viewport = _ref.viewport, forceShouldAnimate = _ref.forceShouldAnimate, last = _ref.last;
    return afterDragging.reduce(function process(groups, draggable) {
        var target = $69fa0e3037063634$var$getTarget(draggable, displacedBy);
        var id = draggable.descriptor.id;
        groups.all.push(id);
        var isVisible = $69fa0e3037063634$var$isPartiallyVisible({
            target: target,
            destination: destination,
            viewport: viewport,
            withDroppableDisplacement: true
        });
        if (!isVisible) {
            groups.invisible[draggable.descriptor.id] = true;
            return groups;
        }
        var shouldAnimate = $69fa0e3037063634$var$getShouldAnimate(id, last, forceShouldAnimate);
        var displacement = {
            draggableId: id,
            shouldAnimate: shouldAnimate
        };
        groups.visible[id] = displacement;
        return groups;
    }, {
        all: [],
        visible: {},
        invisible: {}
    });
}
function $69fa0e3037063634$var$getIndexOfLastItem(draggables, options) {
    if (!draggables.length) return 0;
    var indexOfLastItem = draggables[draggables.length - 1].descriptor.index;
    return options.inHomeList ? indexOfLastItem : indexOfLastItem + 1;
}
function $69fa0e3037063634$var$goAtEnd(_ref) {
    var insideDestination = _ref.insideDestination, inHomeList = _ref.inHomeList, displacedBy = _ref.displacedBy, destination = _ref.destination;
    var newIndex = $69fa0e3037063634$var$getIndexOfLastItem(insideDestination, {
        inHomeList: inHomeList
    });
    return {
        displaced: $69fa0e3037063634$var$emptyGroups,
        displacedBy: displacedBy,
        at: {
            type: 'REORDER',
            destination: {
                droppableId: destination.descriptor.id,
                index: newIndex
            }
        }
    };
}
function $69fa0e3037063634$var$calculateReorderImpact(_ref2) {
    var draggable = _ref2.draggable, insideDestination = _ref2.insideDestination, destination = _ref2.destination, viewport = _ref2.viewport, displacedBy = _ref2.displacedBy, last = _ref2.last, index = _ref2.index, forceShouldAnimate = _ref2.forceShouldAnimate;
    var inHomeList = $69fa0e3037063634$var$isHomeOf(draggable, destination);
    if (index == null) return $69fa0e3037063634$var$goAtEnd({
        insideDestination: insideDestination,
        inHomeList: inHomeList,
        displacedBy: displacedBy,
        destination: destination
    });
    var match = $69fa0e3037063634$var$find(insideDestination, function(item) {
        return item.descriptor.index === index;
    });
    if (!match) return $69fa0e3037063634$var$goAtEnd({
        insideDestination: insideDestination,
        inHomeList: inHomeList,
        displacedBy: displacedBy,
        destination: destination
    });
    var withoutDragging = $69fa0e3037063634$var$removeDraggableFromList(draggable, insideDestination);
    var sliceFrom = insideDestination.indexOf(match);
    var impacted = withoutDragging.slice(sliceFrom);
    var displaced = $69fa0e3037063634$var$getDisplacementGroups({
        afterDragging: impacted,
        destination: destination,
        displacedBy: displacedBy,
        last: last,
        viewport: viewport.frame,
        forceShouldAnimate: forceShouldAnimate
    });
    return {
        displaced: displaced,
        displacedBy: displacedBy,
        at: {
            type: 'REORDER',
            destination: {
                droppableId: destination.descriptor.id,
                index: index
            }
        }
    };
}
function $69fa0e3037063634$var$didStartAfterCritical(draggableId, afterCritical) {
    return Boolean(afterCritical.effected[draggableId]);
}
var $69fa0e3037063634$var$fromCombine = function(_ref) {
    var isMovingForward = _ref.isMovingForward, destination = _ref.destination, draggables = _ref.draggables, combine = _ref.combine, afterCritical = _ref.afterCritical;
    if (!destination.isCombineEnabled) return null;
    var combineId = combine.draggableId;
    var combineWith = draggables[combineId];
    var combineWithIndex = combineWith.descriptor.index;
    var didCombineWithStartAfterCritical = $69fa0e3037063634$var$didStartAfterCritical(combineId, afterCritical);
    if (didCombineWithStartAfterCritical) {
        if (isMovingForward) return combineWithIndex;
        return combineWithIndex - 1;
    }
    if (isMovingForward) return combineWithIndex + 1;
    return combineWithIndex;
};
var $69fa0e3037063634$var$fromReorder = function(_ref) {
    var isMovingForward = _ref.isMovingForward, isInHomeList = _ref.isInHomeList, insideDestination = _ref.insideDestination, location = _ref.location;
    if (!insideDestination.length) return null;
    var currentIndex = location.index;
    var proposedIndex = isMovingForward ? currentIndex + 1 : currentIndex - 1;
    var firstIndex = insideDestination[0].descriptor.index;
    var lastIndex = insideDestination[insideDestination.length - 1].descriptor.index;
    var upperBound = isInHomeList ? lastIndex : lastIndex + 1;
    if (proposedIndex < firstIndex) return null;
    if (proposedIndex > upperBound) return null;
    return proposedIndex;
};
var $69fa0e3037063634$var$moveToNextIndex = function(_ref) {
    var isMovingForward = _ref.isMovingForward, isInHomeList = _ref.isInHomeList, draggable = _ref.draggable, draggables = _ref.draggables, destination = _ref.destination, insideDestination = _ref.insideDestination, previousImpact = _ref.previousImpact, viewport = _ref.viewport, afterCritical = _ref.afterCritical;
    var wasAt = previousImpact.at;
    !wasAt && $69fa0e3037063634$var$invariant(false);
    if (wasAt.type === 'REORDER') {
        var _newIndex = $69fa0e3037063634$var$fromReorder({
            isMovingForward: isMovingForward,
            isInHomeList: isInHomeList,
            location: wasAt.destination,
            insideDestination: insideDestination
        });
        if (_newIndex == null) return null;
        return $69fa0e3037063634$var$calculateReorderImpact({
            draggable: draggable,
            insideDestination: insideDestination,
            destination: destination,
            viewport: viewport,
            last: previousImpact.displaced,
            displacedBy: previousImpact.displacedBy,
            index: _newIndex
        });
    }
    var newIndex = $69fa0e3037063634$var$fromCombine({
        isMovingForward: isMovingForward,
        destination: destination,
        displaced: previousImpact.displaced,
        draggables: draggables,
        combine: wasAt.combine,
        afterCritical: afterCritical
    });
    if (newIndex == null) return null;
    return $69fa0e3037063634$var$calculateReorderImpact({
        draggable: draggable,
        insideDestination: insideDestination,
        destination: destination,
        viewport: viewport,
        last: previousImpact.displaced,
        displacedBy: previousImpact.displacedBy,
        index: newIndex
    });
};
var $69fa0e3037063634$var$getCombinedItemDisplacement = function(_ref) {
    var displaced = _ref.displaced, afterCritical = _ref.afterCritical, combineWith = _ref.combineWith, displacedBy = _ref.displacedBy;
    var isDisplaced = Boolean(displaced.visible[combineWith] || displaced.invisible[combineWith]);
    if ($69fa0e3037063634$var$didStartAfterCritical(combineWith, afterCritical)) return isDisplaced ? $69fa0e3037063634$var$origin : $69fa0e3037063634$var$negate(displacedBy.point);
    return isDisplaced ? displacedBy.point : $69fa0e3037063634$var$origin;
};
var $69fa0e3037063634$var$whenCombining = function(_ref) {
    var afterCritical = _ref.afterCritical, impact = _ref.impact, draggables = _ref.draggables;
    var combine = $69fa0e3037063634$var$tryGetCombine(impact);
    !combine && $69fa0e3037063634$var$invariant(false);
    var combineWith = combine.draggableId;
    var center = draggables[combineWith].page.borderBox.center;
    var displaceBy = $69fa0e3037063634$var$getCombinedItemDisplacement({
        displaced: impact.displaced,
        afterCritical: afterCritical,
        combineWith: combineWith,
        displacedBy: impact.displacedBy
    });
    return $69fa0e3037063634$var$add(center, displaceBy);
};
var $69fa0e3037063634$var$distanceFromStartToBorderBoxCenter = function distanceFromStartToBorderBoxCenter(axis, box) {
    return box.margin[axis.start] + box.borderBox[axis.size] / 2;
};
var $69fa0e3037063634$var$distanceFromEndToBorderBoxCenter = function distanceFromEndToBorderBoxCenter(axis, box) {
    return box.margin[axis.end] + box.borderBox[axis.size] / 2;
};
var $69fa0e3037063634$var$getCrossAxisBorderBoxCenter = function getCrossAxisBorderBoxCenter(axis, target, isMoving) {
    return target[axis.crossAxisStart] + isMoving.margin[axis.crossAxisStart] + isMoving.borderBox[axis.crossAxisSize] / 2;
};
var $69fa0e3037063634$var$goAfter = function goAfter(_ref) {
    var axis = _ref.axis, moveRelativeTo = _ref.moveRelativeTo, isMoving = _ref.isMoving;
    return $69fa0e3037063634$var$patch(axis.line, moveRelativeTo.marginBox[axis.end] + $69fa0e3037063634$var$distanceFromStartToBorderBoxCenter(axis, isMoving), $69fa0e3037063634$var$getCrossAxisBorderBoxCenter(axis, moveRelativeTo.marginBox, isMoving));
};
var $69fa0e3037063634$var$goBefore = function goBefore(_ref2) {
    var axis = _ref2.axis, moveRelativeTo = _ref2.moveRelativeTo, isMoving = _ref2.isMoving;
    return $69fa0e3037063634$var$patch(axis.line, moveRelativeTo.marginBox[axis.start] - $69fa0e3037063634$var$distanceFromEndToBorderBoxCenter(axis, isMoving), $69fa0e3037063634$var$getCrossAxisBorderBoxCenter(axis, moveRelativeTo.marginBox, isMoving));
};
var $69fa0e3037063634$var$goIntoStart = function goIntoStart(_ref3) {
    var axis = _ref3.axis, moveInto = _ref3.moveInto, isMoving = _ref3.isMoving;
    return $69fa0e3037063634$var$patch(axis.line, moveInto.contentBox[axis.start] + $69fa0e3037063634$var$distanceFromStartToBorderBoxCenter(axis, isMoving), $69fa0e3037063634$var$getCrossAxisBorderBoxCenter(axis, moveInto.contentBox, isMoving));
};
var $69fa0e3037063634$var$whenReordering = function(_ref) {
    var impact = _ref.impact, draggable = _ref.draggable, draggables = _ref.draggables, droppable = _ref.droppable, afterCritical = _ref.afterCritical;
    var insideDestination = $69fa0e3037063634$var$getDraggablesInsideDroppable(droppable.descriptor.id, draggables);
    var draggablePage = draggable.page;
    var axis = droppable.axis;
    if (!insideDestination.length) return $69fa0e3037063634$var$goIntoStart({
        axis: axis,
        moveInto: droppable.page,
        isMoving: draggablePage
    });
    var displaced = impact.displaced, displacedBy = impact.displacedBy;
    var closestAfter = displaced.all[0];
    if (closestAfter) {
        var closest = draggables[closestAfter];
        if ($69fa0e3037063634$var$didStartAfterCritical(closestAfter, afterCritical)) return $69fa0e3037063634$var$goBefore({
            axis: axis,
            moveRelativeTo: closest.page,
            isMoving: draggablePage
        });
        var withDisplacement = (0, $bn5nT.offset)(closest.page, displacedBy.point);
        return $69fa0e3037063634$var$goBefore({
            axis: axis,
            moveRelativeTo: withDisplacement,
            isMoving: draggablePage
        });
    }
    var last = insideDestination[insideDestination.length - 1];
    if (last.descriptor.id === draggable.descriptor.id) return draggablePage.borderBox.center;
    if ($69fa0e3037063634$var$didStartAfterCritical(last.descriptor.id, afterCritical)) {
        var page = (0, $bn5nT.offset)(last.page, $69fa0e3037063634$var$negate(afterCritical.displacedBy.point));
        return $69fa0e3037063634$var$goAfter({
            axis: axis,
            moveRelativeTo: page,
            isMoving: draggablePage
        });
    }
    return $69fa0e3037063634$var$goAfter({
        axis: axis,
        moveRelativeTo: last.page,
        isMoving: draggablePage
    });
};
var $69fa0e3037063634$var$withDroppableDisplacement = function(droppable, point) {
    var frame = droppable.frame;
    if (!frame) return point;
    return $69fa0e3037063634$var$add(point, frame.scroll.diff.displacement);
};
var $69fa0e3037063634$var$getResultWithoutDroppableDisplacement = function getResultWithoutDroppableDisplacement(_ref) {
    var impact = _ref.impact, draggable = _ref.draggable, droppable = _ref.droppable, draggables = _ref.draggables, afterCritical = _ref.afterCritical;
    var original = draggable.page.borderBox.center;
    var at = impact.at;
    if (!droppable) return original;
    if (!at) return original;
    if (at.type === 'REORDER') return $69fa0e3037063634$var$whenReordering({
        impact: impact,
        draggable: draggable,
        draggables: draggables,
        droppable: droppable,
        afterCritical: afterCritical
    });
    return $69fa0e3037063634$var$whenCombining({
        impact: impact,
        draggables: draggables,
        afterCritical: afterCritical
    });
};
var $69fa0e3037063634$var$getPageBorderBoxCenterFromImpact = function(args) {
    var withoutDisplacement = $69fa0e3037063634$var$getResultWithoutDroppableDisplacement(args);
    var droppable = args.droppable;
    var withDisplacement = droppable ? $69fa0e3037063634$var$withDroppableDisplacement(droppable, withoutDisplacement) : withoutDisplacement;
    return withDisplacement;
};
var $69fa0e3037063634$var$scrollViewport = function(viewport, newScroll) {
    var diff = $69fa0e3037063634$var$subtract(newScroll, viewport.scroll.initial);
    var displacement = $69fa0e3037063634$var$negate(diff);
    var frame = (0, $bn5nT.getRect)({
        top: newScroll.y,
        bottom: newScroll.y + viewport.frame.height,
        left: newScroll.x,
        right: newScroll.x + viewport.frame.width
    });
    var updated = {
        frame: frame,
        scroll: {
            initial: viewport.scroll.initial,
            max: viewport.scroll.max,
            current: newScroll,
            diff: {
                value: diff,
                displacement: displacement
            }
        }
    };
    return updated;
};
function $69fa0e3037063634$var$getDraggables(ids, draggables) {
    return ids.map(function(id) {
        return draggables[id];
    });
}
function $69fa0e3037063634$var$tryGetVisible(id, groups) {
    for(var i = 0; i < groups.length; i++){
        var displacement = groups[i].visible[id];
        if (displacement) return displacement;
    }
    return null;
}
var $69fa0e3037063634$var$speculativelyIncrease = function(_ref) {
    var impact = _ref.impact, viewport = _ref.viewport, destination = _ref.destination, draggables = _ref.draggables, maxScrollChange = _ref.maxScrollChange;
    var scrolledViewport = $69fa0e3037063634$var$scrollViewport(viewport, $69fa0e3037063634$var$add(viewport.scroll.current, maxScrollChange));
    var scrolledDroppable = destination.frame ? $69fa0e3037063634$var$scrollDroppable(destination, $69fa0e3037063634$var$add(destination.frame.scroll.current, maxScrollChange)) : destination;
    var last = impact.displaced;
    var withViewportScroll = $69fa0e3037063634$var$getDisplacementGroups({
        afterDragging: $69fa0e3037063634$var$getDraggables(last.all, draggables),
        destination: destination,
        displacedBy: impact.displacedBy,
        viewport: scrolledViewport.frame,
        last: last,
        forceShouldAnimate: false
    });
    var withDroppableScroll = $69fa0e3037063634$var$getDisplacementGroups({
        afterDragging: $69fa0e3037063634$var$getDraggables(last.all, draggables),
        destination: scrolledDroppable,
        displacedBy: impact.displacedBy,
        viewport: viewport.frame,
        last: last,
        forceShouldAnimate: false
    });
    var invisible = {};
    var visible = {};
    var groups = [
        last,
        withViewportScroll,
        withDroppableScroll
    ];
    last.all.forEach(function(id) {
        var displacement = $69fa0e3037063634$var$tryGetVisible(id, groups);
        if (displacement) {
            visible[id] = displacement;
            return;
        }
        invisible[id] = true;
    });
    var newImpact = (0, $34lu7.default)({}, impact, {
        displaced: {
            all: last.all,
            invisible: invisible,
            visible: visible
        }
    });
    return newImpact;
};
var $69fa0e3037063634$var$withViewportDisplacement = function(viewport, point) {
    return $69fa0e3037063634$var$add(viewport.scroll.diff.displacement, point);
};
var $69fa0e3037063634$var$getClientFromPageBorderBoxCenter = function(_ref) {
    var pageBorderBoxCenter = _ref.pageBorderBoxCenter, draggable = _ref.draggable, viewport = _ref.viewport;
    var withoutPageScrollChange = $69fa0e3037063634$var$withViewportDisplacement(viewport, pageBorderBoxCenter);
    var offset = $69fa0e3037063634$var$subtract(withoutPageScrollChange, draggable.page.borderBox.center);
    return $69fa0e3037063634$var$add(draggable.client.borderBox.center, offset);
};
var $69fa0e3037063634$var$isTotallyVisibleInNewLocation = function(_ref) {
    var draggable = _ref.draggable, destination = _ref.destination, newPageBorderBoxCenter = _ref.newPageBorderBoxCenter, viewport = _ref.viewport, withDroppableDisplacement = _ref.withDroppableDisplacement, _ref$onlyOnMainAxis = _ref.onlyOnMainAxis, onlyOnMainAxis = _ref$onlyOnMainAxis === void 0 ? false : _ref$onlyOnMainAxis;
    var changeNeeded = $69fa0e3037063634$var$subtract(newPageBorderBoxCenter, draggable.page.borderBox.center);
    var shifted = $69fa0e3037063634$var$offsetByPosition(draggable.page.borderBox, changeNeeded);
    var args = {
        target: shifted,
        destination: destination,
        withDroppableDisplacement: withDroppableDisplacement,
        viewport: viewport
    };
    return onlyOnMainAxis ? $69fa0e3037063634$var$isTotallyVisibleOnAxis(args) : $69fa0e3037063634$var$isTotallyVisible(args);
};
var $69fa0e3037063634$var$moveToNextPlace = function(_ref) {
    var isMovingForward = _ref.isMovingForward, draggable = _ref.draggable, destination = _ref.destination, draggables = _ref.draggables, previousImpact = _ref.previousImpact, viewport = _ref.viewport, previousPageBorderBoxCenter = _ref.previousPageBorderBoxCenter, previousClientSelection = _ref.previousClientSelection, afterCritical = _ref.afterCritical;
    if (!destination.isEnabled) return null;
    var insideDestination = $69fa0e3037063634$var$getDraggablesInsideDroppable(destination.descriptor.id, draggables);
    var isInHomeList = $69fa0e3037063634$var$isHomeOf(draggable, destination);
    var impact = $69fa0e3037063634$var$moveToNextCombine({
        isMovingForward: isMovingForward,
        draggable: draggable,
        destination: destination,
        insideDestination: insideDestination,
        previousImpact: previousImpact
    }) || $69fa0e3037063634$var$moveToNextIndex({
        isMovingForward: isMovingForward,
        isInHomeList: isInHomeList,
        draggable: draggable,
        draggables: draggables,
        destination: destination,
        insideDestination: insideDestination,
        previousImpact: previousImpact,
        viewport: viewport,
        afterCritical: afterCritical
    });
    if (!impact) return null;
    var pageBorderBoxCenter = $69fa0e3037063634$var$getPageBorderBoxCenterFromImpact({
        impact: impact,
        draggable: draggable,
        droppable: destination,
        draggables: draggables,
        afterCritical: afterCritical
    });
    var isVisibleInNewLocation = $69fa0e3037063634$var$isTotallyVisibleInNewLocation({
        draggable: draggable,
        destination: destination,
        newPageBorderBoxCenter: pageBorderBoxCenter,
        viewport: viewport.frame,
        withDroppableDisplacement: false,
        onlyOnMainAxis: true
    });
    if (isVisibleInNewLocation) {
        var clientSelection = $69fa0e3037063634$var$getClientFromPageBorderBoxCenter({
            pageBorderBoxCenter: pageBorderBoxCenter,
            draggable: draggable,
            viewport: viewport
        });
        return {
            clientSelection: clientSelection,
            impact: impact,
            scrollJumpRequest: null
        };
    }
    var distance = $69fa0e3037063634$var$subtract(pageBorderBoxCenter, previousPageBorderBoxCenter);
    var cautious = $69fa0e3037063634$var$speculativelyIncrease({
        impact: impact,
        viewport: viewport,
        destination: destination,
        draggables: draggables,
        maxScrollChange: distance
    });
    return {
        clientSelection: previousClientSelection,
        impact: cautious,
        scrollJumpRequest: distance
    };
};
var $69fa0e3037063634$var$getKnownActive = function getKnownActive(droppable) {
    var rect = droppable.subject.active;
    !rect && $69fa0e3037063634$var$invariant(false);
    return rect;
};
var $69fa0e3037063634$var$getBestCrossAxisDroppable = function(_ref) {
    var isMovingForward = _ref.isMovingForward, pageBorderBoxCenter = _ref.pageBorderBoxCenter, source = _ref.source, droppables = _ref.droppables, viewport = _ref.viewport;
    var active = source.subject.active;
    if (!active) return null;
    var axis = source.axis;
    var isBetweenSourceClipped = $69fa0e3037063634$var$isWithin(active[axis.start], active[axis.end]);
    var candidates = $69fa0e3037063634$var$toDroppableList(droppables).filter(function(droppable) {
        return droppable !== source;
    }).filter(function(droppable) {
        return droppable.isEnabled;
    }).filter(function(droppable) {
        return Boolean(droppable.subject.active);
    }).filter(function(droppable) {
        return $69fa0e3037063634$var$isPartiallyVisibleThroughFrame(viewport.frame)($69fa0e3037063634$var$getKnownActive(droppable));
    }).filter(function(droppable) {
        var activeOfTarget = $69fa0e3037063634$var$getKnownActive(droppable);
        if (isMovingForward) return active[axis.crossAxisEnd] < activeOfTarget[axis.crossAxisEnd];
        return activeOfTarget[axis.crossAxisStart] < active[axis.crossAxisStart];
    }).filter(function(droppable) {
        var activeOfTarget = $69fa0e3037063634$var$getKnownActive(droppable);
        var isBetweenDestinationClipped = $69fa0e3037063634$var$isWithin(activeOfTarget[axis.start], activeOfTarget[axis.end]);
        return isBetweenSourceClipped(activeOfTarget[axis.start]) || isBetweenSourceClipped(activeOfTarget[axis.end]) || isBetweenDestinationClipped(active[axis.start]) || isBetweenDestinationClipped(active[axis.end]);
    }).sort(function(a, b) {
        var first = $69fa0e3037063634$var$getKnownActive(a)[axis.crossAxisStart];
        var second = $69fa0e3037063634$var$getKnownActive(b)[axis.crossAxisStart];
        if (isMovingForward) return first - second;
        return second - first;
    }).filter(function(droppable, index, array) {
        return $69fa0e3037063634$var$getKnownActive(droppable)[axis.crossAxisStart] === $69fa0e3037063634$var$getKnownActive(array[0])[axis.crossAxisStart];
    });
    if (!candidates.length) return null;
    if (candidates.length === 1) return candidates[0];
    var contains = candidates.filter(function(droppable) {
        var isWithinDroppable = $69fa0e3037063634$var$isWithin($69fa0e3037063634$var$getKnownActive(droppable)[axis.start], $69fa0e3037063634$var$getKnownActive(droppable)[axis.end]);
        return isWithinDroppable(pageBorderBoxCenter[axis.line]);
    });
    if (contains.length === 1) return contains[0];
    if (contains.length > 1) return contains.sort(function(a, b) {
        return $69fa0e3037063634$var$getKnownActive(a)[axis.start] - $69fa0e3037063634$var$getKnownActive(b)[axis.start];
    })[0];
    return candidates.sort(function(a, b) {
        var first = $69fa0e3037063634$var$closest(pageBorderBoxCenter, $69fa0e3037063634$var$getCorners($69fa0e3037063634$var$getKnownActive(a)));
        var second = $69fa0e3037063634$var$closest(pageBorderBoxCenter, $69fa0e3037063634$var$getCorners($69fa0e3037063634$var$getKnownActive(b)));
        if (first !== second) return first - second;
        return $69fa0e3037063634$var$getKnownActive(a)[axis.start] - $69fa0e3037063634$var$getKnownActive(b)[axis.start];
    })[0];
};
var $69fa0e3037063634$var$getCurrentPageBorderBoxCenter = function getCurrentPageBorderBoxCenter(draggable, afterCritical) {
    var original = draggable.page.borderBox.center;
    return $69fa0e3037063634$var$didStartAfterCritical(draggable.descriptor.id, afterCritical) ? $69fa0e3037063634$var$subtract(original, afterCritical.displacedBy.point) : original;
};
var $69fa0e3037063634$var$getCurrentPageBorderBox = function getCurrentPageBorderBox(draggable, afterCritical) {
    var original = draggable.page.borderBox;
    return $69fa0e3037063634$var$didStartAfterCritical(draggable.descriptor.id, afterCritical) ? $69fa0e3037063634$var$offsetByPosition(original, $69fa0e3037063634$var$negate(afterCritical.displacedBy.point)) : original;
};
var $69fa0e3037063634$var$getClosestDraggable = function(_ref) {
    var pageBorderBoxCenter = _ref.pageBorderBoxCenter, viewport = _ref.viewport, destination = _ref.destination, insideDestination = _ref.insideDestination, afterCritical = _ref.afterCritical;
    var sorted = insideDestination.filter(function(draggable) {
        return $69fa0e3037063634$var$isTotallyVisible({
            target: $69fa0e3037063634$var$getCurrentPageBorderBox(draggable, afterCritical),
            destination: destination,
            viewport: viewport.frame,
            withDroppableDisplacement: true
        });
    }).sort(function(a, b) {
        var distanceToA = $69fa0e3037063634$var$distance(pageBorderBoxCenter, $69fa0e3037063634$var$withDroppableDisplacement(destination, $69fa0e3037063634$var$getCurrentPageBorderBoxCenter(a, afterCritical)));
        var distanceToB = $69fa0e3037063634$var$distance(pageBorderBoxCenter, $69fa0e3037063634$var$withDroppableDisplacement(destination, $69fa0e3037063634$var$getCurrentPageBorderBoxCenter(b, afterCritical)));
        if (distanceToA < distanceToB) return -1;
        if (distanceToB < distanceToA) return 1;
        return a.descriptor.index - b.descriptor.index;
    });
    return sorted[0] || null;
};
var $69fa0e3037063634$var$getDisplacedBy = (0, $dCUwp.default)(function getDisplacedBy(axis, displaceBy) {
    var displacement = displaceBy[axis.line];
    return {
        value: displacement,
        point: $69fa0e3037063634$var$patch(axis.line, displacement)
    };
});
var $69fa0e3037063634$var$getRequiredGrowthForPlaceholder = function getRequiredGrowthForPlaceholder(droppable, placeholderSize, draggables) {
    var axis = droppable.axis;
    if (droppable.descriptor.mode === 'virtual') return $69fa0e3037063634$var$patch(axis.line, placeholderSize[axis.line]);
    var availableSpace = droppable.subject.page.contentBox[axis.size];
    var insideDroppable = $69fa0e3037063634$var$getDraggablesInsideDroppable(droppable.descriptor.id, draggables);
    var spaceUsed = insideDroppable.reduce(function(sum, dimension) {
        return sum + dimension.client.marginBox[axis.size];
    }, 0);
    var requiredSpace = spaceUsed + placeholderSize[axis.line];
    var needsToGrowBy = requiredSpace - availableSpace;
    if (needsToGrowBy <= 0) return null;
    return $69fa0e3037063634$var$patch(axis.line, needsToGrowBy);
};
var $69fa0e3037063634$var$withMaxScroll = function withMaxScroll(frame, max) {
    return (0, $34lu7.default)({}, frame, {
        scroll: (0, $34lu7.default)({}, frame.scroll, {
            max: max
        })
    });
};
var $69fa0e3037063634$var$addPlaceholder = function addPlaceholder(droppable, draggable, draggables) {
    var frame = droppable.frame;
    !!$69fa0e3037063634$var$isHomeOf(draggable, droppable) && $69fa0e3037063634$var$invariant(false);
    !!droppable.subject.withPlaceholder && $69fa0e3037063634$var$invariant(false);
    var placeholderSize = $69fa0e3037063634$var$getDisplacedBy(droppable.axis, draggable.displaceBy).point;
    var requiredGrowth = $69fa0e3037063634$var$getRequiredGrowthForPlaceholder(droppable, placeholderSize, draggables);
    var added = {
        placeholderSize: placeholderSize,
        increasedBy: requiredGrowth,
        oldFrameMaxScroll: droppable.frame ? droppable.frame.scroll.max : null
    };
    if (!frame) {
        var _subject = $69fa0e3037063634$var$getSubject({
            page: droppable.subject.page,
            withPlaceholder: added,
            axis: droppable.axis,
            frame: droppable.frame
        });
        return (0, $34lu7.default)({}, droppable, {
            subject: _subject
        });
    }
    var maxScroll = requiredGrowth ? $69fa0e3037063634$var$add(frame.scroll.max, requiredGrowth) : frame.scroll.max;
    var newFrame = $69fa0e3037063634$var$withMaxScroll(frame, maxScroll);
    var subject = $69fa0e3037063634$var$getSubject({
        page: droppable.subject.page,
        withPlaceholder: added,
        axis: droppable.axis,
        frame: newFrame
    });
    return (0, $34lu7.default)({}, droppable, {
        subject: subject,
        frame: newFrame
    });
};
var $69fa0e3037063634$var$removePlaceholder = function removePlaceholder(droppable) {
    var added = droppable.subject.withPlaceholder;
    !added && $69fa0e3037063634$var$invariant(false);
    var frame = droppable.frame;
    if (!frame) {
        var _subject2 = $69fa0e3037063634$var$getSubject({
            page: droppable.subject.page,
            axis: droppable.axis,
            frame: null,
            withPlaceholder: null
        });
        return (0, $34lu7.default)({}, droppable, {
            subject: _subject2
        });
    }
    var oldMaxScroll = added.oldFrameMaxScroll;
    !oldMaxScroll && $69fa0e3037063634$var$invariant(false);
    var newFrame = $69fa0e3037063634$var$withMaxScroll(frame, oldMaxScroll);
    var subject = $69fa0e3037063634$var$getSubject({
        page: droppable.subject.page,
        axis: droppable.axis,
        frame: newFrame,
        withPlaceholder: null
    });
    return (0, $34lu7.default)({}, droppable, {
        subject: subject,
        frame: newFrame
    });
};
var $69fa0e3037063634$var$moveToNewDroppable = function(_ref) {
    var previousPageBorderBoxCenter = _ref.previousPageBorderBoxCenter, moveRelativeTo = _ref.moveRelativeTo, insideDestination = _ref.insideDestination, draggable = _ref.draggable, draggables = _ref.draggables, destination = _ref.destination, viewport = _ref.viewport, afterCritical = _ref.afterCritical;
    if (!moveRelativeTo) {
        if (insideDestination.length) return null;
        var proposed = {
            displaced: $69fa0e3037063634$var$emptyGroups,
            displacedBy: $69fa0e3037063634$var$noDisplacedBy,
            at: {
                type: 'REORDER',
                destination: {
                    droppableId: destination.descriptor.id,
                    index: 0
                }
            }
        };
        var proposedPageBorderBoxCenter = $69fa0e3037063634$var$getPageBorderBoxCenterFromImpact({
            impact: proposed,
            draggable: draggable,
            droppable: destination,
            draggables: draggables,
            afterCritical: afterCritical
        });
        var withPlaceholder = $69fa0e3037063634$var$isHomeOf(draggable, destination) ? destination : $69fa0e3037063634$var$addPlaceholder(destination, draggable, draggables);
        var isVisibleInNewLocation = $69fa0e3037063634$var$isTotallyVisibleInNewLocation({
            draggable: draggable,
            destination: withPlaceholder,
            newPageBorderBoxCenter: proposedPageBorderBoxCenter,
            viewport: viewport.frame,
            withDroppableDisplacement: false,
            onlyOnMainAxis: true
        });
        return isVisibleInNewLocation ? proposed : null;
    }
    var isGoingBeforeTarget = Boolean(previousPageBorderBoxCenter[destination.axis.line] <= moveRelativeTo.page.borderBox.center[destination.axis.line]);
    var proposedIndex = function() {
        var relativeTo = moveRelativeTo.descriptor.index;
        if (moveRelativeTo.descriptor.id === draggable.descriptor.id) return relativeTo;
        if (isGoingBeforeTarget) return relativeTo;
        return relativeTo + 1;
    }();
    var displacedBy = $69fa0e3037063634$var$getDisplacedBy(destination.axis, draggable.displaceBy);
    return $69fa0e3037063634$var$calculateReorderImpact({
        draggable: draggable,
        insideDestination: insideDestination,
        destination: destination,
        viewport: viewport,
        displacedBy: displacedBy,
        last: $69fa0e3037063634$var$emptyGroups,
        index: proposedIndex
    });
};
var $69fa0e3037063634$var$moveCrossAxis = function(_ref) {
    var isMovingForward = _ref.isMovingForward, previousPageBorderBoxCenter = _ref.previousPageBorderBoxCenter, draggable = _ref.draggable, isOver = _ref.isOver, draggables = _ref.draggables, droppables = _ref.droppables, viewport = _ref.viewport, afterCritical = _ref.afterCritical;
    var destination = $69fa0e3037063634$var$getBestCrossAxisDroppable({
        isMovingForward: isMovingForward,
        pageBorderBoxCenter: previousPageBorderBoxCenter,
        source: isOver,
        droppables: droppables,
        viewport: viewport
    });
    if (!destination) return null;
    var insideDestination = $69fa0e3037063634$var$getDraggablesInsideDroppable(destination.descriptor.id, draggables);
    var moveRelativeTo = $69fa0e3037063634$var$getClosestDraggable({
        pageBorderBoxCenter: previousPageBorderBoxCenter,
        viewport: viewport,
        destination: destination,
        insideDestination: insideDestination,
        afterCritical: afterCritical
    });
    var impact = $69fa0e3037063634$var$moveToNewDroppable({
        previousPageBorderBoxCenter: previousPageBorderBoxCenter,
        destination: destination,
        draggable: draggable,
        draggables: draggables,
        moveRelativeTo: moveRelativeTo,
        insideDestination: insideDestination,
        viewport: viewport,
        afterCritical: afterCritical
    });
    if (!impact) return null;
    var pageBorderBoxCenter = $69fa0e3037063634$var$getPageBorderBoxCenterFromImpact({
        impact: impact,
        draggable: draggable,
        droppable: destination,
        draggables: draggables,
        afterCritical: afterCritical
    });
    var clientSelection = $69fa0e3037063634$var$getClientFromPageBorderBoxCenter({
        pageBorderBoxCenter: pageBorderBoxCenter,
        draggable: draggable,
        viewport: viewport
    });
    return {
        clientSelection: clientSelection,
        impact: impact,
        scrollJumpRequest: null
    };
};
var $69fa0e3037063634$var$whatIsDraggedOver = function(impact) {
    var at = impact.at;
    if (!at) return null;
    if (at.type === 'REORDER') return at.destination.droppableId;
    return at.combine.droppableId;
};
var $69fa0e3037063634$var$getDroppableOver = function getDroppableOver(impact, droppables) {
    var id = $69fa0e3037063634$var$whatIsDraggedOver(impact);
    return id ? droppables[id] : null;
};
var $69fa0e3037063634$var$moveInDirection = function(_ref) {
    var state = _ref.state, type = _ref.type;
    var isActuallyOver = $69fa0e3037063634$var$getDroppableOver(state.impact, state.dimensions.droppables);
    var isMainAxisMovementAllowed = Boolean(isActuallyOver);
    var home = state.dimensions.droppables[state.critical.droppable.id];
    var isOver = isActuallyOver || home;
    var direction = isOver.axis.direction;
    var isMovingOnMainAxis = direction === 'vertical' && (type === 'MOVE_UP' || type === 'MOVE_DOWN') || direction === 'horizontal' && (type === 'MOVE_LEFT' || type === 'MOVE_RIGHT');
    if (isMovingOnMainAxis && !isMainAxisMovementAllowed) return null;
    var isMovingForward = type === 'MOVE_DOWN' || type === 'MOVE_RIGHT';
    var draggable = state.dimensions.draggables[state.critical.draggable.id];
    var previousPageBorderBoxCenter = state.current.page.borderBoxCenter;
    var _state$dimensions = state.dimensions, draggables = _state$dimensions.draggables, droppables = _state$dimensions.droppables;
    return isMovingOnMainAxis ? $69fa0e3037063634$var$moveToNextPlace({
        isMovingForward: isMovingForward,
        previousPageBorderBoxCenter: previousPageBorderBoxCenter,
        draggable: draggable,
        destination: isOver,
        draggables: draggables,
        viewport: state.viewport,
        previousClientSelection: state.current.client.selection,
        previousImpact: state.impact,
        afterCritical: state.afterCritical
    }) : $69fa0e3037063634$var$moveCrossAxis({
        isMovingForward: isMovingForward,
        previousPageBorderBoxCenter: previousPageBorderBoxCenter,
        draggable: draggable,
        isOver: isOver,
        draggables: draggables,
        droppables: droppables,
        viewport: state.viewport,
        afterCritical: state.afterCritical
    });
};
function $69fa0e3037063634$var$isMovementAllowed(state) {
    return state.phase === 'DRAGGING' || state.phase === 'COLLECTING';
}
function $69fa0e3037063634$var$isPositionInFrame(frame) {
    var isWithinVertical = $69fa0e3037063634$var$isWithin(frame.top, frame.bottom);
    var isWithinHorizontal = $69fa0e3037063634$var$isWithin(frame.left, frame.right);
    return function run(point) {
        return isWithinVertical(point.y) && isWithinHorizontal(point.x);
    };
}
function $69fa0e3037063634$var$getHasOverlap(first, second) {
    return first.left < second.right && first.right > second.left && first.top < second.bottom && first.bottom > second.top;
}
function $69fa0e3037063634$var$getFurthestAway(_ref) {
    var pageBorderBox = _ref.pageBorderBox, draggable = _ref.draggable, candidates = _ref.candidates;
    var startCenter = draggable.page.borderBox.center;
    var sorted = candidates.map(function(candidate) {
        var axis = candidate.axis;
        var target = $69fa0e3037063634$var$patch(candidate.axis.line, pageBorderBox.center[axis.line], candidate.page.borderBox.center[axis.crossAxisLine]);
        return {
            id: candidate.descriptor.id,
            distance: $69fa0e3037063634$var$distance(startCenter, target)
        };
    }).sort(function(a, b) {
        return b.distance - a.distance;
    });
    return sorted[0] ? sorted[0].id : null;
}
function $69fa0e3037063634$var$getDroppableOver$1(_ref2) {
    var pageBorderBox = _ref2.pageBorderBox, draggable = _ref2.draggable, droppables = _ref2.droppables;
    var candidates = $69fa0e3037063634$var$toDroppableList(droppables).filter(function(item) {
        if (!item.isEnabled) return false;
        var active = item.subject.active;
        if (!active) return false;
        if (!$69fa0e3037063634$var$getHasOverlap(pageBorderBox, active)) return false;
        if ($69fa0e3037063634$var$isPositionInFrame(active)(pageBorderBox.center)) return true;
        var axis = item.axis;
        var childCenter = active.center[axis.crossAxisLine];
        var crossAxisStart = pageBorderBox[axis.crossAxisStart];
        var crossAxisEnd = pageBorderBox[axis.crossAxisEnd];
        var isContained = $69fa0e3037063634$var$isWithin(active[axis.crossAxisStart], active[axis.crossAxisEnd]);
        var isStartContained = isContained(crossAxisStart);
        var isEndContained = isContained(crossAxisEnd);
        if (!isStartContained && !isEndContained) return true;
        if (isStartContained) return crossAxisStart < childCenter;
        return crossAxisEnd > childCenter;
    });
    if (!candidates.length) return null;
    if (candidates.length === 1) return candidates[0].descriptor.id;
    return $69fa0e3037063634$var$getFurthestAway({
        pageBorderBox: pageBorderBox,
        draggable: draggable,
        candidates: candidates
    });
}
var $69fa0e3037063634$var$offsetRectByPosition = function offsetRectByPosition(rect, point) {
    return (0, $bn5nT.getRect)($69fa0e3037063634$var$offsetByPosition(rect, point));
};
var $69fa0e3037063634$var$withDroppableScroll = function(droppable, area) {
    var frame = droppable.frame;
    if (!frame) return area;
    return $69fa0e3037063634$var$offsetRectByPosition(area, frame.scroll.diff.value);
};
function $69fa0e3037063634$var$getIsDisplaced(_ref) {
    var displaced = _ref.displaced, id = _ref.id;
    return Boolean(displaced.visible[id] || displaced.invisible[id]);
}
function $69fa0e3037063634$var$atIndex(_ref) {
    var draggable = _ref.draggable, closest = _ref.closest, inHomeList = _ref.inHomeList;
    if (!closest) return null;
    if (!inHomeList) return closest.descriptor.index;
    if (closest.descriptor.index > draggable.descriptor.index) return closest.descriptor.index - 1;
    return closest.descriptor.index;
}
var $69fa0e3037063634$var$getReorderImpact = function(_ref2) {
    var targetRect = _ref2.pageBorderBoxWithDroppableScroll, draggable = _ref2.draggable, destination = _ref2.destination, insideDestination = _ref2.insideDestination, last = _ref2.last, viewport = _ref2.viewport, afterCritical = _ref2.afterCritical;
    var axis = destination.axis;
    var displacedBy = $69fa0e3037063634$var$getDisplacedBy(destination.axis, draggable.displaceBy);
    var displacement = displacedBy.value;
    var targetStart = targetRect[axis.start];
    var targetEnd = targetRect[axis.end];
    var withoutDragging = $69fa0e3037063634$var$removeDraggableFromList(draggable, insideDestination);
    var closest = $69fa0e3037063634$var$find(withoutDragging, function(child) {
        var id = child.descriptor.id;
        var childCenter = child.page.borderBox.center[axis.line];
        var didStartAfterCritical$1 = $69fa0e3037063634$var$didStartAfterCritical(id, afterCritical);
        var isDisplaced = $69fa0e3037063634$var$getIsDisplaced({
            displaced: last,
            id: id
        });
        if (didStartAfterCritical$1) {
            if (isDisplaced) return targetEnd <= childCenter;
            return targetStart < childCenter - displacement;
        }
        if (isDisplaced) return targetEnd <= childCenter + displacement;
        return targetStart < childCenter;
    });
    var newIndex = $69fa0e3037063634$var$atIndex({
        draggable: draggable,
        closest: closest,
        inHomeList: $69fa0e3037063634$var$isHomeOf(draggable, destination)
    });
    return $69fa0e3037063634$var$calculateReorderImpact({
        draggable: draggable,
        insideDestination: insideDestination,
        destination: destination,
        viewport: viewport,
        last: last,
        displacedBy: displacedBy,
        index: newIndex
    });
};
var $69fa0e3037063634$var$combineThresholdDivisor = 4;
var $69fa0e3037063634$var$getCombineImpact = function(_ref) {
    var draggable = _ref.draggable, targetRect = _ref.pageBorderBoxWithDroppableScroll, previousImpact = _ref.previousImpact, destination = _ref.destination, insideDestination = _ref.insideDestination, afterCritical = _ref.afterCritical;
    if (!destination.isCombineEnabled) return null;
    var axis = destination.axis;
    var displacedBy = $69fa0e3037063634$var$getDisplacedBy(destination.axis, draggable.displaceBy);
    var displacement = displacedBy.value;
    var targetStart = targetRect[axis.start];
    var targetEnd = targetRect[axis.end];
    var withoutDragging = $69fa0e3037063634$var$removeDraggableFromList(draggable, insideDestination);
    var combineWith = $69fa0e3037063634$var$find(withoutDragging, function(child) {
        var id = child.descriptor.id;
        var childRect = child.page.borderBox;
        var childSize = childRect[axis.size];
        var threshold = childSize / $69fa0e3037063634$var$combineThresholdDivisor;
        var didStartAfterCritical$1 = $69fa0e3037063634$var$didStartAfterCritical(id, afterCritical);
        var isDisplaced = $69fa0e3037063634$var$getIsDisplaced({
            displaced: previousImpact.displaced,
            id: id
        });
        if (didStartAfterCritical$1) {
            if (isDisplaced) return targetEnd > childRect[axis.start] + threshold && targetEnd < childRect[axis.end] - threshold;
            return targetStart > childRect[axis.start] - displacement + threshold && targetStart < childRect[axis.end] - displacement - threshold;
        }
        if (isDisplaced) return targetEnd > childRect[axis.start] + displacement + threshold && targetEnd < childRect[axis.end] + displacement - threshold;
        return targetStart > childRect[axis.start] + threshold && targetStart < childRect[axis.end] - threshold;
    });
    if (!combineWith) return null;
    var impact = {
        displacedBy: displacedBy,
        displaced: previousImpact.displaced,
        at: {
            type: 'COMBINE',
            combine: {
                draggableId: combineWith.descriptor.id,
                droppableId: destination.descriptor.id
            }
        }
    };
    return impact;
};
var $69fa0e3037063634$var$getDragImpact = function(_ref) {
    var pageOffset = _ref.pageOffset, draggable = _ref.draggable, draggables = _ref.draggables, droppables = _ref.droppables, previousImpact = _ref.previousImpact, viewport = _ref.viewport, afterCritical = _ref.afterCritical;
    var pageBorderBox = $69fa0e3037063634$var$offsetRectByPosition(draggable.page.borderBox, pageOffset);
    var destinationId = $69fa0e3037063634$var$getDroppableOver$1({
        pageBorderBox: pageBorderBox,
        draggable: draggable,
        droppables: droppables
    });
    if (!destinationId) return $69fa0e3037063634$var$noImpact;
    var destination = droppables[destinationId];
    var insideDestination = $69fa0e3037063634$var$getDraggablesInsideDroppable(destination.descriptor.id, draggables);
    var pageBorderBoxWithDroppableScroll = $69fa0e3037063634$var$withDroppableScroll(destination, pageBorderBox);
    return $69fa0e3037063634$var$getCombineImpact({
        pageBorderBoxWithDroppableScroll: pageBorderBoxWithDroppableScroll,
        draggable: draggable,
        previousImpact: previousImpact,
        destination: destination,
        insideDestination: insideDestination,
        afterCritical: afterCritical
    }) || $69fa0e3037063634$var$getReorderImpact({
        pageBorderBoxWithDroppableScroll: pageBorderBoxWithDroppableScroll,
        draggable: draggable,
        destination: destination,
        insideDestination: insideDestination,
        last: previousImpact.displaced,
        viewport: viewport,
        afterCritical: afterCritical
    });
};
var $69fa0e3037063634$var$patchDroppableMap = function(droppables, updated) {
    var _extends2;
    return (0, $34lu7.default)({}, droppables, (_extends2 = {}, _extends2[updated.descriptor.id] = updated, _extends2));
};
var $69fa0e3037063634$var$clearUnusedPlaceholder = function clearUnusedPlaceholder(_ref) {
    var previousImpact = _ref.previousImpact, impact = _ref.impact, droppables = _ref.droppables;
    var last = $69fa0e3037063634$var$whatIsDraggedOver(previousImpact);
    var now = $69fa0e3037063634$var$whatIsDraggedOver(impact);
    if (!last) return droppables;
    if (last === now) return droppables;
    var lastDroppable = droppables[last];
    if (!lastDroppable.subject.withPlaceholder) return droppables;
    var updated = $69fa0e3037063634$var$removePlaceholder(lastDroppable);
    return $69fa0e3037063634$var$patchDroppableMap(droppables, updated);
};
var $69fa0e3037063634$var$recomputePlaceholders = function(_ref2) {
    var draggable = _ref2.draggable, draggables = _ref2.draggables, droppables = _ref2.droppables, previousImpact = _ref2.previousImpact, impact = _ref2.impact;
    var cleaned = $69fa0e3037063634$var$clearUnusedPlaceholder({
        previousImpact: previousImpact,
        impact: impact,
        droppables: droppables
    });
    var isOver = $69fa0e3037063634$var$whatIsDraggedOver(impact);
    if (!isOver) return cleaned;
    var droppable = droppables[isOver];
    if ($69fa0e3037063634$var$isHomeOf(draggable, droppable)) return cleaned;
    if (droppable.subject.withPlaceholder) return cleaned;
    var patched = $69fa0e3037063634$var$addPlaceholder(droppable, draggable, draggables);
    return $69fa0e3037063634$var$patchDroppableMap(cleaned, patched);
};
var $69fa0e3037063634$var$update = function(_ref) {
    var state = _ref.state, forcedClientSelection = _ref.clientSelection, forcedDimensions = _ref.dimensions, forcedViewport = _ref.viewport, forcedImpact = _ref.impact, scrollJumpRequest = _ref.scrollJumpRequest;
    var viewport = forcedViewport || state.viewport;
    var dimensions = forcedDimensions || state.dimensions;
    var clientSelection = forcedClientSelection || state.current.client.selection;
    var offset = $69fa0e3037063634$var$subtract(clientSelection, state.initial.client.selection);
    var client = {
        offset: offset,
        selection: clientSelection,
        borderBoxCenter: $69fa0e3037063634$var$add(state.initial.client.borderBoxCenter, offset)
    };
    var page = {
        selection: $69fa0e3037063634$var$add(client.selection, viewport.scroll.current),
        borderBoxCenter: $69fa0e3037063634$var$add(client.borderBoxCenter, viewport.scroll.current),
        offset: $69fa0e3037063634$var$add(client.offset, viewport.scroll.diff.value)
    };
    var current = {
        client: client,
        page: page
    };
    if (state.phase === 'COLLECTING') return (0, $34lu7.default)({
        phase: 'COLLECTING'
    }, state, {
        dimensions: dimensions,
        viewport: viewport,
        current: current
    });
    var draggable = dimensions.draggables[state.critical.draggable.id];
    var newImpact = forcedImpact || $69fa0e3037063634$var$getDragImpact({
        pageOffset: page.offset,
        draggable: draggable,
        draggables: dimensions.draggables,
        droppables: dimensions.droppables,
        previousImpact: state.impact,
        viewport: viewport,
        afterCritical: state.afterCritical
    });
    var withUpdatedPlaceholders = $69fa0e3037063634$var$recomputePlaceholders({
        draggable: draggable,
        impact: newImpact,
        previousImpact: state.impact,
        draggables: dimensions.draggables,
        droppables: dimensions.droppables
    });
    var result = (0, $34lu7.default)({}, state, {
        current: current,
        dimensions: {
            draggables: dimensions.draggables,
            droppables: withUpdatedPlaceholders
        },
        impact: newImpact,
        viewport: viewport,
        scrollJumpRequest: scrollJumpRequest || null,
        forceShouldAnimate: scrollJumpRequest ? false : null
    });
    return result;
};
function $69fa0e3037063634$var$getDraggables$1(ids, draggables) {
    return ids.map(function(id) {
        return draggables[id];
    });
}
var $69fa0e3037063634$var$recompute = function(_ref) {
    var impact = _ref.impact, viewport = _ref.viewport, draggables = _ref.draggables, destination = _ref.destination, forceShouldAnimate = _ref.forceShouldAnimate;
    var last = impact.displaced;
    var afterDragging = $69fa0e3037063634$var$getDraggables$1(last.all, draggables);
    var displaced = $69fa0e3037063634$var$getDisplacementGroups({
        afterDragging: afterDragging,
        destination: destination,
        displacedBy: impact.displacedBy,
        viewport: viewport.frame,
        forceShouldAnimate: forceShouldAnimate,
        last: last
    });
    return (0, $34lu7.default)({}, impact, {
        displaced: displaced
    });
};
var $69fa0e3037063634$var$getClientBorderBoxCenter = function(_ref) {
    var impact = _ref.impact, draggable = _ref.draggable, droppable = _ref.droppable, draggables = _ref.draggables, viewport = _ref.viewport, afterCritical = _ref.afterCritical;
    var pageBorderBoxCenter = $69fa0e3037063634$var$getPageBorderBoxCenterFromImpact({
        impact: impact,
        draggable: draggable,
        draggables: draggables,
        droppable: droppable,
        afterCritical: afterCritical
    });
    return $69fa0e3037063634$var$getClientFromPageBorderBoxCenter({
        pageBorderBoxCenter: pageBorderBoxCenter,
        draggable: draggable,
        viewport: viewport
    });
};
var $69fa0e3037063634$var$refreshSnap = function(_ref) {
    var state = _ref.state, forcedDimensions = _ref.dimensions, forcedViewport = _ref.viewport;
    !(state.movementMode === 'SNAP') && $69fa0e3037063634$var$invariant(false);
    var needsVisibilityCheck = state.impact;
    var viewport = forcedViewport || state.viewport;
    var dimensions = forcedDimensions || state.dimensions;
    var draggables = dimensions.draggables, droppables = dimensions.droppables;
    var draggable = draggables[state.critical.draggable.id];
    var isOver = $69fa0e3037063634$var$whatIsDraggedOver(needsVisibilityCheck);
    !isOver && $69fa0e3037063634$var$invariant(false);
    var destination = droppables[isOver];
    var impact = $69fa0e3037063634$var$recompute({
        impact: needsVisibilityCheck,
        viewport: viewport,
        destination: destination,
        draggables: draggables
    });
    var clientSelection = $69fa0e3037063634$var$getClientBorderBoxCenter({
        impact: impact,
        draggable: draggable,
        droppable: destination,
        draggables: draggables,
        viewport: viewport,
        afterCritical: state.afterCritical
    });
    return $69fa0e3037063634$var$update({
        impact: impact,
        clientSelection: clientSelection,
        state: state,
        dimensions: dimensions,
        viewport: viewport
    });
};
var $69fa0e3037063634$var$getHomeLocation = function(descriptor) {
    return {
        index: descriptor.index,
        droppableId: descriptor.droppableId
    };
};
var $69fa0e3037063634$var$getLiftEffect = function(_ref) {
    var draggable = _ref.draggable, home = _ref.home, draggables = _ref.draggables, viewport = _ref.viewport;
    var displacedBy = $69fa0e3037063634$var$getDisplacedBy(home.axis, draggable.displaceBy);
    var insideHome = $69fa0e3037063634$var$getDraggablesInsideDroppable(home.descriptor.id, draggables);
    var rawIndex = insideHome.indexOf(draggable);
    !(rawIndex !== -1) && $69fa0e3037063634$var$invariant(false);
    var afterDragging = insideHome.slice(rawIndex + 1);
    var effected = afterDragging.reduce(function(previous, item) {
        previous[item.descriptor.id] = true;
        return previous;
    }, {});
    var afterCritical = {
        inVirtualList: home.descriptor.mode === 'virtual',
        displacedBy: displacedBy,
        effected: effected
    };
    var displaced = $69fa0e3037063634$var$getDisplacementGroups({
        afterDragging: afterDragging,
        destination: home,
        displacedBy: displacedBy,
        last: null,
        viewport: viewport.frame,
        forceShouldAnimate: false
    });
    var impact = {
        displaced: displaced,
        displacedBy: displacedBy,
        at: {
            type: 'REORDER',
            destination: $69fa0e3037063634$var$getHomeLocation(draggable.descriptor)
        }
    };
    return {
        impact: impact,
        afterCritical: afterCritical
    };
};
var $69fa0e3037063634$var$patchDimensionMap = function(dimensions, updated) {
    return {
        draggables: dimensions.draggables,
        droppables: $69fa0e3037063634$var$patchDroppableMap(dimensions.droppables, updated)
    };
};
var $69fa0e3037063634$var$records = {};
var $69fa0e3037063634$var$isEnabled = false;
var $69fa0e3037063634$var$isTimingsEnabled = function isTimingsEnabled() {
    return $69fa0e3037063634$var$isEnabled;
};
var $69fa0e3037063634$var$start = function start(key) {
    var now;
};
var $69fa0e3037063634$var$finish = function finish(key) {
    var now, previous, result, rounded, style;
};
var $69fa0e3037063634$var$offsetDraggable = function(_ref) {
    var draggable = _ref.draggable, offset$1 = _ref.offset, initialWindowScroll = _ref.initialWindowScroll;
    var client = (0, $bn5nT.offset)(draggable.client, offset$1);
    var page = (0, $bn5nT.withScroll)(client, initialWindowScroll);
    var moved = (0, $34lu7.default)({}, draggable, {
        placeholder: (0, $34lu7.default)({}, draggable.placeholder, {
            client: client
        }),
        client: client,
        page: page
    });
    return moved;
};
var $69fa0e3037063634$var$getFrame = function(droppable) {
    var frame = droppable.frame;
    !frame && $69fa0e3037063634$var$invariant(false);
    return frame;
};
var $69fa0e3037063634$var$adjustAdditionsForScrollChanges = function(_ref) {
    var additions = _ref.additions, updatedDroppables = _ref.updatedDroppables, viewport = _ref.viewport;
    var windowScrollChange = viewport.scroll.diff.value;
    return additions.map(function(draggable) {
        var droppableId = draggable.descriptor.droppableId;
        var modified = updatedDroppables[droppableId];
        var frame = $69fa0e3037063634$var$getFrame(modified);
        var droppableScrollChange = frame.scroll.diff.value;
        var totalChange = $69fa0e3037063634$var$add(windowScrollChange, droppableScrollChange);
        var moved = $69fa0e3037063634$var$offsetDraggable({
            draggable: draggable,
            offset: totalChange,
            initialWindowScroll: viewport.scroll.initial
        });
        return moved;
    });
};
var $69fa0e3037063634$var$timingsKey = 'Processing dynamic changes';
var $69fa0e3037063634$var$publishWhileDraggingInVirtual = function(_ref) {
    var _extends2, _extends3;
    var state = _ref.state, published = _ref.published;
    $69fa0e3037063634$var$start($69fa0e3037063634$var$timingsKey);
    var withScrollChange = published.modified.map(function(update) {
        var existing = state.dimensions.droppables[update.droppableId];
        var scrolled = $69fa0e3037063634$var$scrollDroppable(existing, update.scroll);
        return scrolled;
    });
    var droppables = (0, $34lu7.default)({}, state.dimensions.droppables, $69fa0e3037063634$var$toDroppableMap(withScrollChange));
    var updatedAdditions = $69fa0e3037063634$var$toDraggableMap($69fa0e3037063634$var$adjustAdditionsForScrollChanges({
        additions: published.additions,
        updatedDroppables: droppables,
        viewport: state.viewport
    }));
    var draggables = (0, $34lu7.default)({}, state.dimensions.draggables, updatedAdditions);
    published.removals.forEach(function(id) {
        delete draggables[id];
    });
    var dimensions = {
        droppables: droppables,
        draggables: draggables
    };
    var wasOverId = $69fa0e3037063634$var$whatIsDraggedOver(state.impact);
    var wasOver = wasOverId ? dimensions.droppables[wasOverId] : null;
    var draggable = dimensions.draggables[state.critical.draggable.id];
    var home = dimensions.droppables[state.critical.droppable.id];
    var _getLiftEffect = $69fa0e3037063634$var$getLiftEffect({
        draggable: draggable,
        home: home,
        draggables: draggables,
        viewport: state.viewport
    }), onLiftImpact = _getLiftEffect.impact, afterCritical = _getLiftEffect.afterCritical;
    var previousImpact = wasOver && wasOver.isCombineEnabled ? state.impact : onLiftImpact;
    var impact = $69fa0e3037063634$var$getDragImpact({
        pageOffset: state.current.page.offset,
        draggable: dimensions.draggables[state.critical.draggable.id],
        draggables: dimensions.draggables,
        droppables: dimensions.droppables,
        previousImpact: previousImpact,
        viewport: state.viewport,
        afterCritical: afterCritical
    });
    $69fa0e3037063634$var$finish($69fa0e3037063634$var$timingsKey);
    var draggingState = (0, $34lu7.default)({
        phase: 'DRAGGING'
    }, state, (_extends2 = {}, _extends2["phase"] = 'DRAGGING', _extends2.impact = impact, _extends2.onLiftImpact = onLiftImpact, _extends2.dimensions = dimensions, _extends2.afterCritical = afterCritical, _extends2.forceShouldAnimate = false, _extends2));
    if (state.phase === 'COLLECTING') return draggingState;
    var dropPending = (0, $34lu7.default)({
        phase: 'DROP_PENDING'
    }, draggingState, (_extends3 = {}, _extends3["phase"] = 'DROP_PENDING', _extends3.reason = state.reason, _extends3.isWaiting = false, _extends3));
    return dropPending;
};
var $69fa0e3037063634$var$isSnapping = function isSnapping(state) {
    return state.movementMode === 'SNAP';
};
var $69fa0e3037063634$var$postDroppableChange = function postDroppableChange(state, updated, isEnabledChanging) {
    var dimensions = $69fa0e3037063634$var$patchDimensionMap(state.dimensions, updated);
    if (!$69fa0e3037063634$var$isSnapping(state) || isEnabledChanging) return $69fa0e3037063634$var$update({
        state: state,
        dimensions: dimensions
    });
    return $69fa0e3037063634$var$refreshSnap({
        state: state,
        dimensions: dimensions
    });
};
function $69fa0e3037063634$var$removeScrollJumpRequest(state) {
    if (state.isDragging && state.movementMode === 'SNAP') return (0, $34lu7.default)({
        phase: 'DRAGGING'
    }, state, {
        scrollJumpRequest: null
    });
    return state;
}
var $69fa0e3037063634$var$idle = {
    phase: 'IDLE',
    completed: null,
    shouldFlush: false
};
var $69fa0e3037063634$var$reducer = function(state, action) {
    if (state === void 0) state = $69fa0e3037063634$var$idle;
    if (action.type === 'FLUSH') return (0, $34lu7.default)({}, $69fa0e3037063634$var$idle, {
        shouldFlush: true
    });
    if (action.type === 'INITIAL_PUBLISH') {
        !(state.phase === 'IDLE') && $69fa0e3037063634$var$invariant(false);
        var _action$payload = action.payload, critical = _action$payload.critical, clientSelection = _action$payload.clientSelection, viewport = _action$payload.viewport, dimensions = _action$payload.dimensions, movementMode = _action$payload.movementMode;
        var draggable = dimensions.draggables[critical.draggable.id];
        var home = dimensions.droppables[critical.droppable.id];
        var client = {
            selection: clientSelection,
            borderBoxCenter: draggable.client.borderBox.center,
            offset: $69fa0e3037063634$var$origin
        };
        var initial = {
            client: client,
            page: {
                selection: $69fa0e3037063634$var$add(client.selection, viewport.scroll.initial),
                borderBoxCenter: $69fa0e3037063634$var$add(client.selection, viewport.scroll.initial),
                offset: $69fa0e3037063634$var$add(client.selection, viewport.scroll.diff.value)
            }
        };
        var isWindowScrollAllowed = $69fa0e3037063634$var$toDroppableList(dimensions.droppables).every(function(item) {
            return !item.isFixedOnPage;
        });
        var _getLiftEffect = $69fa0e3037063634$var$getLiftEffect({
            draggable: draggable,
            home: home,
            draggables: dimensions.draggables,
            viewport: viewport
        }), impact = _getLiftEffect.impact, afterCritical = _getLiftEffect.afterCritical;
        var result = {
            phase: 'DRAGGING',
            isDragging: true,
            critical: critical,
            movementMode: movementMode,
            dimensions: dimensions,
            initial: initial,
            current: initial,
            isWindowScrollAllowed: isWindowScrollAllowed,
            impact: impact,
            afterCritical: afterCritical,
            onLiftImpact: impact,
            viewport: viewport,
            scrollJumpRequest: null,
            forceShouldAnimate: null
        };
        return result;
    }
    if (action.type === 'COLLECTION_STARTING') {
        var _extends2;
        if (state.phase === 'COLLECTING' || state.phase === 'DROP_PENDING') return state;
        !(state.phase === 'DRAGGING') && $69fa0e3037063634$var$invariant(false);
        var _result = (0, $34lu7.default)({
            phase: 'COLLECTING'
        }, state, (_extends2 = {}, _extends2["phase"] = 'COLLECTING', _extends2));
        return _result;
    }
    if (action.type === 'PUBLISH_WHILE_DRAGGING') {
        !(state.phase === 'COLLECTING' || state.phase === 'DROP_PENDING') && $69fa0e3037063634$var$invariant(false);
        return $69fa0e3037063634$var$publishWhileDraggingInVirtual({
            state: state,
            published: action.payload
        });
    }
    if (action.type === 'MOVE') {
        if (state.phase === 'DROP_PENDING') return state;
        !$69fa0e3037063634$var$isMovementAllowed(state) && $69fa0e3037063634$var$invariant(false);
        var _clientSelection = action.payload.client;
        if ($69fa0e3037063634$var$isEqual(_clientSelection, state.current.client.selection)) return state;
        return $69fa0e3037063634$var$update({
            state: state,
            clientSelection: _clientSelection,
            impact: $69fa0e3037063634$var$isSnapping(state) ? state.impact : null
        });
    }
    if (action.type === 'UPDATE_DROPPABLE_SCROLL') {
        if (state.phase === 'DROP_PENDING') return $69fa0e3037063634$var$removeScrollJumpRequest(state);
        if (state.phase === 'COLLECTING') return $69fa0e3037063634$var$removeScrollJumpRequest(state);
        !$69fa0e3037063634$var$isMovementAllowed(state) && $69fa0e3037063634$var$invariant(false);
        var _action$payload2 = action.payload, id = _action$payload2.id, newScroll = _action$payload2.newScroll;
        var target = state.dimensions.droppables[id];
        if (!target) return state;
        var scrolled = $69fa0e3037063634$var$scrollDroppable(target, newScroll);
        return $69fa0e3037063634$var$postDroppableChange(state, scrolled, false);
    }
    if (action.type === 'UPDATE_DROPPABLE_IS_ENABLED') {
        if (state.phase === 'DROP_PENDING') return state;
        !$69fa0e3037063634$var$isMovementAllowed(state) && $69fa0e3037063634$var$invariant(false);
        var _action$payload3 = action.payload, _id = _action$payload3.id, isEnabled = _action$payload3.isEnabled;
        var _target = state.dimensions.droppables[_id];
        !_target && $69fa0e3037063634$var$invariant(false);
        !(_target.isEnabled !== isEnabled) && $69fa0e3037063634$var$invariant(false);
        var updated = (0, $34lu7.default)({}, _target, {
            isEnabled: isEnabled
        });
        return $69fa0e3037063634$var$postDroppableChange(state, updated, true);
    }
    if (action.type === 'UPDATE_DROPPABLE_IS_COMBINE_ENABLED') {
        if (state.phase === 'DROP_PENDING') return state;
        !$69fa0e3037063634$var$isMovementAllowed(state) && $69fa0e3037063634$var$invariant(false);
        var _action$payload4 = action.payload, _id2 = _action$payload4.id, isCombineEnabled = _action$payload4.isCombineEnabled;
        var _target2 = state.dimensions.droppables[_id2];
        !_target2 && $69fa0e3037063634$var$invariant(false);
        !(_target2.isCombineEnabled !== isCombineEnabled) && $69fa0e3037063634$var$invariant(false);
        var _updated = (0, $34lu7.default)({}, _target2, {
            isCombineEnabled: isCombineEnabled
        });
        return $69fa0e3037063634$var$postDroppableChange(state, _updated, true);
    }
    if (action.type === 'MOVE_BY_WINDOW_SCROLL') {
        if (state.phase === 'DROP_PENDING' || state.phase === 'DROP_ANIMATING') return state;
        !$69fa0e3037063634$var$isMovementAllowed(state) && $69fa0e3037063634$var$invariant(false);
        !state.isWindowScrollAllowed && $69fa0e3037063634$var$invariant(false);
        var _newScroll = action.payload.newScroll;
        if ($69fa0e3037063634$var$isEqual(state.viewport.scroll.current, _newScroll)) return $69fa0e3037063634$var$removeScrollJumpRequest(state);
        var _viewport = $69fa0e3037063634$var$scrollViewport(state.viewport, _newScroll);
        if ($69fa0e3037063634$var$isSnapping(state)) return $69fa0e3037063634$var$refreshSnap({
            state: state,
            viewport: _viewport
        });
        return $69fa0e3037063634$var$update({
            state: state,
            viewport: _viewport
        });
    }
    if (action.type === 'UPDATE_VIEWPORT_MAX_SCROLL') {
        if (!$69fa0e3037063634$var$isMovementAllowed(state)) return state;
        var maxScroll = action.payload.maxScroll;
        if ($69fa0e3037063634$var$isEqual(maxScroll, state.viewport.scroll.max)) return state;
        var withMaxScroll = (0, $34lu7.default)({}, state.viewport, {
            scroll: (0, $34lu7.default)({}, state.viewport.scroll, {
                max: maxScroll
            })
        });
        return (0, $34lu7.default)({
            phase: 'DRAGGING'
        }, state, {
            viewport: withMaxScroll
        });
    }
    if (action.type === 'MOVE_UP' || action.type === 'MOVE_DOWN' || action.type === 'MOVE_LEFT' || action.type === 'MOVE_RIGHT') {
        if (state.phase === 'COLLECTING' || state.phase === 'DROP_PENDING') return state;
        !(state.phase === 'DRAGGING') && $69fa0e3037063634$var$invariant(false);
        var _result2 = $69fa0e3037063634$var$moveInDirection({
            state: state,
            type: action.type
        });
        if (!_result2) return state;
        return $69fa0e3037063634$var$update({
            state: state,
            impact: _result2.impact,
            clientSelection: _result2.clientSelection,
            scrollJumpRequest: _result2.scrollJumpRequest
        });
    }
    if (action.type === 'DROP_PENDING') {
        var _extends3;
        var reason = action.payload.reason;
        !(state.phase === 'COLLECTING') && $69fa0e3037063634$var$invariant(false);
        var newState = (0, $34lu7.default)({
            phase: 'DROP_PENDING'
        }, state, (_extends3 = {}, _extends3["phase"] = 'DROP_PENDING', _extends3.isWaiting = true, _extends3.reason = reason, _extends3));
        return newState;
    }
    if (action.type === 'DROP_ANIMATE') {
        var _action$payload5 = action.payload, completed = _action$payload5.completed, dropDuration = _action$payload5.dropDuration, newHomeClientOffset = _action$payload5.newHomeClientOffset;
        !(state.phase === 'DRAGGING' || state.phase === 'DROP_PENDING') && $69fa0e3037063634$var$invariant(false);
        var _result3 = {
            phase: 'DROP_ANIMATING',
            completed: completed,
            dropDuration: dropDuration,
            newHomeClientOffset: newHomeClientOffset,
            dimensions: state.dimensions
        };
        return _result3;
    }
    if (action.type === 'DROP_COMPLETE') {
        var _completed = action.payload.completed;
        return {
            phase: 'IDLE',
            completed: _completed,
            shouldFlush: false
        };
    }
    return state;
};
var $69fa0e3037063634$var$beforeInitialCapture = function beforeInitialCapture(args) {
    return {
        type: 'BEFORE_INITIAL_CAPTURE',
        payload: args
    };
};
var $69fa0e3037063634$var$lift = function lift(args) {
    return {
        type: 'LIFT',
        payload: args
    };
};
var $69fa0e3037063634$var$initialPublish = function initialPublish(args) {
    return {
        type: 'INITIAL_PUBLISH',
        payload: args
    };
};
var $69fa0e3037063634$var$publishWhileDragging = function publishWhileDragging(args) {
    return {
        type: 'PUBLISH_WHILE_DRAGGING',
        payload: args
    };
};
var $69fa0e3037063634$var$collectionStarting = function collectionStarting() {
    return {
        type: 'COLLECTION_STARTING',
        payload: null
    };
};
var $69fa0e3037063634$var$updateDroppableScroll = function updateDroppableScroll(args) {
    return {
        type: 'UPDATE_DROPPABLE_SCROLL',
        payload: args
    };
};
var $69fa0e3037063634$var$updateDroppableIsEnabled = function updateDroppableIsEnabled(args) {
    return {
        type: 'UPDATE_DROPPABLE_IS_ENABLED',
        payload: args
    };
};
var $69fa0e3037063634$var$updateDroppableIsCombineEnabled = function updateDroppableIsCombineEnabled(args) {
    return {
        type: 'UPDATE_DROPPABLE_IS_COMBINE_ENABLED',
        payload: args
    };
};
var $69fa0e3037063634$var$move = function move(args) {
    return {
        type: 'MOVE',
        payload: args
    };
};
var $69fa0e3037063634$var$moveByWindowScroll = function moveByWindowScroll(args) {
    return {
        type: 'MOVE_BY_WINDOW_SCROLL',
        payload: args
    };
};
var $69fa0e3037063634$var$updateViewportMaxScroll = function updateViewportMaxScroll(args) {
    return {
        type: 'UPDATE_VIEWPORT_MAX_SCROLL',
        payload: args
    };
};
var $69fa0e3037063634$var$moveUp = function moveUp() {
    return {
        type: 'MOVE_UP',
        payload: null
    };
};
var $69fa0e3037063634$var$moveDown = function moveDown() {
    return {
        type: 'MOVE_DOWN',
        payload: null
    };
};
var $69fa0e3037063634$var$moveRight = function moveRight() {
    return {
        type: 'MOVE_RIGHT',
        payload: null
    };
};
var $69fa0e3037063634$var$moveLeft = function moveLeft() {
    return {
        type: 'MOVE_LEFT',
        payload: null
    };
};
var $69fa0e3037063634$var$flush = function flush() {
    return {
        type: 'FLUSH',
        payload: null
    };
};
var $69fa0e3037063634$var$animateDrop = function animateDrop(args) {
    return {
        type: 'DROP_ANIMATE',
        payload: args
    };
};
var $69fa0e3037063634$var$completeDrop = function completeDrop(args) {
    return {
        type: 'DROP_COMPLETE',
        payload: args
    };
};
var $69fa0e3037063634$var$drop = function drop(args) {
    return {
        type: 'DROP',
        payload: args
    };
};
var $69fa0e3037063634$var$dropPending = function dropPending(args) {
    return {
        type: 'DROP_PENDING',
        payload: args
    };
};
var $69fa0e3037063634$var$dropAnimationFinished = function dropAnimationFinished() {
    return {
        type: 'DROP_ANIMATION_FINISHED',
        payload: null
    };
};
function $69fa0e3037063634$var$checkIndexes(insideDestination) {
    if (insideDestination.length <= 1) return;
    var indexes = insideDestination.map(function(d) {
        return d.descriptor.index;
    });
    var errors = {};
    for(var i = 1; i < indexes.length; i++){
        var current = indexes[i];
        var previous = indexes[i - 1];
        if (current !== previous + 1) errors[current] = true;
    }
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($l1Zd2)))(errors).length) return;
    var formatted = indexes.map(function(index) {
        var hasError = Boolean(errors[index]);
        return hasError ? "[\uD83D\uDD25" + index + "]" : "" + index;
    }).join(', ');
}
function $69fa0e3037063634$var$validateDimensions(critical, dimensions) {
    var insideDestination;
}
var $69fa0e3037063634$var$lift$1 = function(marshal) {
    return function(_ref) {
        var getState = _ref.getState, dispatch = _ref.dispatch;
        return function(next) {
            return function(action) {
                if (action.type !== 'LIFT') {
                    next(action);
                    return;
                }
                var _action$payload = action.payload, id = _action$payload.id, clientSelection = _action$payload.clientSelection, movementMode = _action$payload.movementMode;
                var initial = getState();
                if (initial.phase === 'DROP_ANIMATING') dispatch($69fa0e3037063634$var$completeDrop({
                    completed: initial.completed
                }));
                !(getState().phase === 'IDLE') && $69fa0e3037063634$var$invariant(false);
                dispatch($69fa0e3037063634$var$flush());
                dispatch($69fa0e3037063634$var$beforeInitialCapture({
                    draggableId: id,
                    movementMode: movementMode
                }));
                var scrollOptions = {
                    shouldPublishImmediately: movementMode === 'SNAP'
                };
                var request = {
                    draggableId: id,
                    scrollOptions: scrollOptions
                };
                var _marshal$startPublish = marshal.startPublishing(request), critical = _marshal$startPublish.critical, dimensions = _marshal$startPublish.dimensions, viewport = _marshal$startPublish.viewport;
                $69fa0e3037063634$var$validateDimensions(critical, dimensions);
                dispatch($69fa0e3037063634$var$initialPublish({
                    critical: critical,
                    dimensions: dimensions,
                    clientSelection: clientSelection,
                    movementMode: movementMode,
                    viewport: viewport
                }));
            };
        };
    };
};
var $69fa0e3037063634$var$style = function(marshal) {
    return function() {
        return function(next) {
            return function(action) {
                if (action.type === 'INITIAL_PUBLISH') marshal.dragging();
                if (action.type === 'DROP_ANIMATE') marshal.dropping(action.payload.completed.result.reason);
                if (action.type === 'FLUSH' || action.type === 'DROP_COMPLETE') marshal.resting();
                next(action);
            };
        };
    };
};
var $69fa0e3037063634$var$curves = {
    outOfTheWay: 'cubic-bezier(0.2, 0, 0, 1)',
    drop: 'cubic-bezier(.2,1,.1,1)'
};
var $69fa0e3037063634$var$combine = {
    opacity: {
        drop: 0,
        combining: 0.7
    },
    scale: {
        drop: 0.75
    }
};
var $69fa0e3037063634$var$timings = {
    outOfTheWay: 0.2,
    minDropTime: 0.33,
    maxDropTime: 0.55
};
var $69fa0e3037063634$var$outOfTheWayTiming = $69fa0e3037063634$var$timings.outOfTheWay + "s " + $69fa0e3037063634$var$curves.outOfTheWay;
var $69fa0e3037063634$var$transitions = {
    fluid: "opacity " + $69fa0e3037063634$var$outOfTheWayTiming,
    snap: "transform " + $69fa0e3037063634$var$outOfTheWayTiming + ", opacity " + $69fa0e3037063634$var$outOfTheWayTiming,
    drop: function drop(duration) {
        var timing = duration + "s " + $69fa0e3037063634$var$curves.drop;
        return "transform " + timing + ", opacity " + timing;
    },
    outOfTheWay: "transform " + $69fa0e3037063634$var$outOfTheWayTiming,
    placeholder: "height " + $69fa0e3037063634$var$outOfTheWayTiming + ", width " + $69fa0e3037063634$var$outOfTheWayTiming + ", margin " + $69fa0e3037063634$var$outOfTheWayTiming
};
var $69fa0e3037063634$var$moveTo = function moveTo(offset) {
    return $69fa0e3037063634$var$isEqual(offset, $69fa0e3037063634$var$origin) ? null : "translate(" + offset.x + "px, " + offset.y + "px)";
};
var $69fa0e3037063634$var$transforms = {
    moveTo: $69fa0e3037063634$var$moveTo,
    drop: function drop(offset, isCombining) {
        var translate = $69fa0e3037063634$var$moveTo(offset);
        if (!translate) return null;
        if (!isCombining) return translate;
        return translate + " scale(" + $69fa0e3037063634$var$combine.scale.drop + ")";
    }
};
var $69fa0e3037063634$var$minDropTime = $69fa0e3037063634$var$timings.minDropTime, $69fa0e3037063634$var$maxDropTime = $69fa0e3037063634$var$timings.maxDropTime;
var $69fa0e3037063634$var$dropTimeRange = $69fa0e3037063634$var$maxDropTime - $69fa0e3037063634$var$minDropTime;
var $69fa0e3037063634$var$maxDropTimeAtDistance = 1500;
var $69fa0e3037063634$var$cancelDropModifier = 0.6;
var $69fa0e3037063634$var$getDropDuration = function(_ref) {
    var current = _ref.current, destination = _ref.destination, reason = _ref.reason;
    var distance$1 = $69fa0e3037063634$var$distance(current, destination);
    if (distance$1 <= 0) return $69fa0e3037063634$var$minDropTime;
    if (distance$1 >= $69fa0e3037063634$var$maxDropTimeAtDistance) return $69fa0e3037063634$var$maxDropTime;
    var percentage = distance$1 / $69fa0e3037063634$var$maxDropTimeAtDistance;
    var duration = $69fa0e3037063634$var$minDropTime + $69fa0e3037063634$var$dropTimeRange * percentage;
    var withDuration = reason === 'CANCEL' ? duration * $69fa0e3037063634$var$cancelDropModifier : duration;
    return Number(withDuration.toFixed(2));
};
var $69fa0e3037063634$var$getNewHomeClientOffset = function(_ref) {
    var impact = _ref.impact, draggable = _ref.draggable, dimensions = _ref.dimensions, viewport = _ref.viewport, afterCritical = _ref.afterCritical;
    var draggables = dimensions.draggables, droppables = dimensions.droppables;
    var droppableId = $69fa0e3037063634$var$whatIsDraggedOver(impact);
    var destination = droppableId ? droppables[droppableId] : null;
    var home = droppables[draggable.descriptor.droppableId];
    var newClientCenter = $69fa0e3037063634$var$getClientBorderBoxCenter({
        impact: impact,
        draggable: draggable,
        draggables: draggables,
        afterCritical: afterCritical,
        droppable: destination || home,
        viewport: viewport
    });
    var offset = $69fa0e3037063634$var$subtract(newClientCenter, draggable.client.borderBox.center);
    return offset;
};
var $69fa0e3037063634$var$getDropImpact = function(_ref) {
    var draggables = _ref.draggables, reason = _ref.reason, lastImpact = _ref.lastImpact, home = _ref.home, viewport = _ref.viewport, onLiftImpact = _ref.onLiftImpact;
    if (!lastImpact.at || reason !== 'DROP') {
        var recomputedHomeImpact = $69fa0e3037063634$var$recompute({
            draggables: draggables,
            impact: onLiftImpact,
            destination: home,
            viewport: viewport,
            forceShouldAnimate: true
        });
        return {
            impact: recomputedHomeImpact,
            didDropInsideDroppable: false
        };
    }
    if (lastImpact.at.type === 'REORDER') return {
        impact: lastImpact,
        didDropInsideDroppable: true
    };
    var withoutMovement = (0, $34lu7.default)({}, lastImpact, {
        displaced: $69fa0e3037063634$var$emptyGroups
    });
    return {
        impact: withoutMovement,
        didDropInsideDroppable: true
    };
};
var $69fa0e3037063634$var$drop$1 = function(_ref) {
    var getState = _ref.getState, dispatch = _ref.dispatch;
    return function(next) {
        return function(action) {
            if (action.type !== 'DROP') {
                next(action);
                return;
            }
            var state = getState();
            var reason = action.payload.reason;
            if (state.phase === 'COLLECTING') {
                dispatch($69fa0e3037063634$var$dropPending({
                    reason: reason
                }));
                return;
            }
            if (state.phase === 'IDLE') return;
            var isWaitingForDrop = state.phase === 'DROP_PENDING' && state.isWaiting;
            !!isWaitingForDrop && $69fa0e3037063634$var$invariant(false);
            !(state.phase === 'DRAGGING' || state.phase === 'DROP_PENDING') && $69fa0e3037063634$var$invariant(false);
            var critical = state.critical;
            var dimensions = state.dimensions;
            var draggable = dimensions.draggables[state.critical.draggable.id];
            var _getDropImpact = $69fa0e3037063634$var$getDropImpact({
                reason: reason,
                lastImpact: state.impact,
                afterCritical: state.afterCritical,
                onLiftImpact: state.onLiftImpact,
                home: state.dimensions.droppables[state.critical.droppable.id],
                viewport: state.viewport,
                draggables: state.dimensions.draggables
            }), impact = _getDropImpact.impact, didDropInsideDroppable = _getDropImpact.didDropInsideDroppable;
            var destination = didDropInsideDroppable ? $69fa0e3037063634$var$tryGetDestination(impact) : null;
            var combine = didDropInsideDroppable ? $69fa0e3037063634$var$tryGetCombine(impact) : null;
            var source = {
                index: critical.draggable.index,
                droppableId: critical.droppable.id
            };
            var result = {
                draggableId: draggable.descriptor.id,
                type: draggable.descriptor.type,
                source: source,
                reason: reason,
                mode: state.movementMode,
                destination: destination,
                combine: combine
            };
            var newHomeClientOffset = $69fa0e3037063634$var$getNewHomeClientOffset({
                impact: impact,
                draggable: draggable,
                dimensions: dimensions,
                viewport: state.viewport,
                afterCritical: state.afterCritical
            });
            var completed = {
                critical: state.critical,
                afterCritical: state.afterCritical,
                result: result,
                impact: impact
            };
            var isAnimationRequired = !$69fa0e3037063634$var$isEqual(state.current.client.offset, newHomeClientOffset) || Boolean(result.combine);
            if (!isAnimationRequired) {
                dispatch($69fa0e3037063634$var$completeDrop({
                    completed: completed
                }));
                return;
            }
            var dropDuration = $69fa0e3037063634$var$getDropDuration({
                current: state.current.client.offset,
                destination: newHomeClientOffset,
                reason: reason
            });
            var args = {
                newHomeClientOffset: newHomeClientOffset,
                dropDuration: dropDuration,
                completed: completed
            };
            dispatch($69fa0e3037063634$var$animateDrop(args));
        };
    };
};
var $69fa0e3037063634$var$getWindowScroll = function() {
    return {
        x: window.pageXOffset,
        y: window.pageYOffset
    };
};
function $69fa0e3037063634$var$getWindowScrollBinding(update) {
    return {
        eventName: 'scroll',
        options: {
            passive: true,
            capture: false
        },
        fn: function fn(event) {
            if (event.target !== window && event.target !== window.document) return;
            update();
        }
    };
}
function $69fa0e3037063634$var$getScrollListener(_ref) {
    var onWindowScroll = _ref.onWindowScroll;
    function updateScroll() {
        onWindowScroll($69fa0e3037063634$var$getWindowScroll());
    }
    var scheduled = (0, $gxvYj.default)(updateScroll);
    var binding = $69fa0e3037063634$var$getWindowScrollBinding(scheduled);
    var unbind = $69fa0e3037063634$var$noop;
    function isActive() {
        return unbind !== $69fa0e3037063634$var$noop;
    }
    function start() {
        !!isActive() && $69fa0e3037063634$var$invariant(false);
        unbind = $69fa0e3037063634$var$bindEvents(window, [
            binding
        ]);
    }
    function stop() {
        !isActive() && $69fa0e3037063634$var$invariant(false);
        scheduled.cancel();
        unbind();
        unbind = $69fa0e3037063634$var$noop;
    }
    return {
        start: start,
        stop: stop,
        isActive: isActive
    };
}
var $69fa0e3037063634$var$shouldEnd = function shouldEnd(action) {
    return action.type === 'DROP_COMPLETE' || action.type === 'DROP_ANIMATE' || action.type === 'FLUSH';
};
var $69fa0e3037063634$var$scrollListener = function(store) {
    var listener = $69fa0e3037063634$var$getScrollListener({
        onWindowScroll: function onWindowScroll(newScroll) {
            store.dispatch($69fa0e3037063634$var$moveByWindowScroll({
                newScroll: newScroll
            }));
        }
    });
    return function(next) {
        return function(action) {
            if (!listener.isActive() && action.type === 'INITIAL_PUBLISH') listener.start();
            if (listener.isActive() && $69fa0e3037063634$var$shouldEnd(action)) listener.stop();
            next(action);
        };
    };
};
var $69fa0e3037063634$var$getExpiringAnnounce = function(announce) {
    var wasCalled = false;
    var isExpired = false;
    var timeoutId = setTimeout(function() {
        isExpired = true;
    });
    var result = function result(message) {
        if (wasCalled) return;
        if (isExpired) return;
        wasCalled = true;
        announce(message);
        clearTimeout(timeoutId);
    };
    result.wasCalled = function() {
        return wasCalled;
    };
    return result;
};
var $69fa0e3037063634$var$getAsyncMarshal = function() {
    var entries = [];
    var execute = function execute(timerId) {
        var index = $69fa0e3037063634$var$findIndex(entries, function(item) {
            return item.timerId === timerId;
        });
        !(index !== -1) && $69fa0e3037063634$var$invariant(false);
        var _entries$splice = entries.splice(index, 1), entry = _entries$splice[0];
        entry.callback();
    };
    var add = function add(fn) {
        var timerId = setTimeout(function() {
            return execute(timerId);
        });
        var entry = {
            timerId: timerId,
            callback: fn
        };
        entries.push(entry);
    };
    var flush = function flush() {
        if (!entries.length) return;
        var shallow = [].concat(entries);
        entries.length = 0;
        shallow.forEach(function(entry) {
            clearTimeout(entry.timerId);
            entry.callback();
        });
    };
    return {
        add: add,
        flush: flush
    };
};
var $69fa0e3037063634$var$areLocationsEqual = function areLocationsEqual(first, second) {
    if (first == null && second == null) return true;
    if (first == null || second == null) return false;
    return first.droppableId === second.droppableId && first.index === second.index;
};
var $69fa0e3037063634$var$isCombineEqual = function isCombineEqual(first, second) {
    if (first == null && second == null) return true;
    if (first == null || second == null) return false;
    return first.draggableId === second.draggableId && first.droppableId === second.droppableId;
};
var $69fa0e3037063634$var$isCriticalEqual = function isCriticalEqual(first, second) {
    if (first === second) return true;
    var isDraggableEqual = first.draggable.id === second.draggable.id && first.draggable.droppableId === second.draggable.droppableId && first.draggable.type === second.draggable.type && first.draggable.index === second.draggable.index;
    var isDroppableEqual = first.droppable.id === second.droppable.id && first.droppable.type === second.droppable.type;
    return isDraggableEqual && isDroppableEqual;
};
var $69fa0e3037063634$var$withTimings = function withTimings(key, fn) {
    $69fa0e3037063634$var$start(key);
    fn();
    $69fa0e3037063634$var$finish(key);
};
var $69fa0e3037063634$var$getDragStart = function getDragStart(critical, mode) {
    return {
        draggableId: critical.draggable.id,
        type: critical.droppable.type,
        source: {
            droppableId: critical.droppable.id,
            index: critical.draggable.index
        },
        mode: mode
    };
};
var $69fa0e3037063634$var$execute = function execute(responder, data, announce, getDefaultMessage) {
    if (!responder) {
        announce(getDefaultMessage(data));
        return;
    }
    var willExpire = $69fa0e3037063634$var$getExpiringAnnounce(announce);
    var provided = {
        announce: willExpire
    };
    responder(data, provided);
    if (!willExpire.wasCalled()) announce(getDefaultMessage(data));
};
var $69fa0e3037063634$var$getPublisher = function(getResponders, announce) {
    var asyncMarshal = $69fa0e3037063634$var$getAsyncMarshal();
    var dragging = null;
    var beforeCapture = function beforeCapture(draggableId, mode) {
        !!dragging && $69fa0e3037063634$var$invariant(false);
        $69fa0e3037063634$var$withTimings('onBeforeCapture', function() {
            var fn = getResponders().onBeforeCapture;
            if (fn) {
                var before = {
                    draggableId: draggableId,
                    mode: mode
                };
                fn(before);
            }
        });
    };
    var beforeStart = function beforeStart(critical, mode) {
        !!dragging && $69fa0e3037063634$var$invariant(false);
        $69fa0e3037063634$var$withTimings('onBeforeDragStart', function() {
            var fn = getResponders().onBeforeDragStart;
            if (fn) fn($69fa0e3037063634$var$getDragStart(critical, mode));
        });
    };
    var start = function start(critical, mode) {
        !!dragging && $69fa0e3037063634$var$invariant(false);
        var data = $69fa0e3037063634$var$getDragStart(critical, mode);
        dragging = {
            mode: mode,
            lastCritical: critical,
            lastLocation: data.source,
            lastCombine: null
        };
        asyncMarshal.add(function() {
            $69fa0e3037063634$var$withTimings('onDragStart', function() {
                return $69fa0e3037063634$var$execute(getResponders().onDragStart, data, announce, $69fa0e3037063634$var$preset.onDragStart);
            });
        });
    };
    var update = function update(critical, impact) {
        var location = $69fa0e3037063634$var$tryGetDestination(impact);
        var combine = $69fa0e3037063634$var$tryGetCombine(impact);
        !dragging && $69fa0e3037063634$var$invariant(false);
        var hasCriticalChanged = !$69fa0e3037063634$var$isCriticalEqual(critical, dragging.lastCritical);
        if (hasCriticalChanged) dragging.lastCritical = critical;
        var hasLocationChanged = !$69fa0e3037063634$var$areLocationsEqual(dragging.lastLocation, location);
        if (hasLocationChanged) dragging.lastLocation = location;
        var hasGroupingChanged = !$69fa0e3037063634$var$isCombineEqual(dragging.lastCombine, combine);
        if (hasGroupingChanged) dragging.lastCombine = combine;
        if (!hasCriticalChanged && !hasLocationChanged && !hasGroupingChanged) return;
        var data = (0, $34lu7.default)({}, $69fa0e3037063634$var$getDragStart(critical, dragging.mode), {
            combine: combine,
            destination: location
        });
        asyncMarshal.add(function() {
            $69fa0e3037063634$var$withTimings('onDragUpdate', function() {
                return $69fa0e3037063634$var$execute(getResponders().onDragUpdate, data, announce, $69fa0e3037063634$var$preset.onDragUpdate);
            });
        });
    };
    var flush = function flush() {
        !dragging && $69fa0e3037063634$var$invariant(false);
        asyncMarshal.flush();
    };
    var drop = function drop(result) {
        !dragging && $69fa0e3037063634$var$invariant(false);
        dragging = null;
        $69fa0e3037063634$var$withTimings('onDragEnd', function() {
            return $69fa0e3037063634$var$execute(getResponders().onDragEnd, result, announce, $69fa0e3037063634$var$preset.onDragEnd);
        });
    };
    var abort = function abort() {
        if (!dragging) return;
        var result = (0, $34lu7.default)({}, $69fa0e3037063634$var$getDragStart(dragging.lastCritical, dragging.mode), {
            combine: null,
            destination: null,
            reason: 'CANCEL'
        });
        drop(result);
    };
    return {
        beforeCapture: beforeCapture,
        beforeStart: beforeStart,
        start: start,
        update: update,
        flush: flush,
        drop: drop,
        abort: abort
    };
};
var $69fa0e3037063634$var$responders = function(getResponders, announce) {
    var publisher = $69fa0e3037063634$var$getPublisher(getResponders, announce);
    return function(store) {
        return function(next) {
            return function(action) {
                if (action.type === 'BEFORE_INITIAL_CAPTURE') {
                    publisher.beforeCapture(action.payload.draggableId, action.payload.movementMode);
                    return;
                }
                if (action.type === 'INITIAL_PUBLISH') {
                    var critical = action.payload.critical;
                    publisher.beforeStart(critical, action.payload.movementMode);
                    next(action);
                    publisher.start(critical, action.payload.movementMode);
                    return;
                }
                if (action.type === 'DROP_COMPLETE') {
                    var result = action.payload.completed.result;
                    publisher.flush();
                    next(action);
                    publisher.drop(result);
                    return;
                }
                next(action);
                if (action.type === 'FLUSH') {
                    publisher.abort();
                    return;
                }
                var state = store.getState();
                if (state.phase === 'DRAGGING') publisher.update(state.critical, state.impact);
            };
        };
    };
};
var $69fa0e3037063634$var$dropAnimationFinish = function(store) {
    return function(next) {
        return function(action) {
            if (action.type !== 'DROP_ANIMATION_FINISHED') {
                next(action);
                return;
            }
            var state = store.getState();
            !(state.phase === 'DROP_ANIMATING') && $69fa0e3037063634$var$invariant(false);
            store.dispatch($69fa0e3037063634$var$completeDrop({
                completed: state.completed
            }));
        };
    };
};
var $69fa0e3037063634$var$dropAnimationFlushOnScroll = function(store) {
    var unbind = null;
    var frameId = null;
    function clear() {
        if (frameId) {
            cancelAnimationFrame(frameId);
            frameId = null;
        }
        if (unbind) {
            unbind();
            unbind = null;
        }
    }
    return function(next) {
        return function(action) {
            if (action.type === 'FLUSH' || action.type === 'DROP_COMPLETE' || action.type === 'DROP_ANIMATION_FINISHED') clear();
            next(action);
            if (action.type !== 'DROP_ANIMATE') return;
            var binding = {
                eventName: 'scroll',
                options: {
                    capture: true,
                    passive: false,
                    once: true
                },
                fn: function flushDropAnimation() {
                    var state = store.getState();
                    if (state.phase === 'DROP_ANIMATING') store.dispatch($69fa0e3037063634$var$dropAnimationFinished());
                }
            };
            frameId = requestAnimationFrame(function() {
                frameId = null;
                unbind = $69fa0e3037063634$var$bindEvents(window, [
                    binding
                ]);
            });
        };
    };
};
var $69fa0e3037063634$var$dimensionMarshalStopper = function(marshal) {
    return function() {
        return function(next) {
            return function(action) {
                if (action.type === 'DROP_COMPLETE' || action.type === 'FLUSH' || action.type === 'DROP_ANIMATE') marshal.stopPublishing();
                next(action);
            };
        };
    };
};
var $69fa0e3037063634$var$focus = function(marshal) {
    var isWatching = false;
    return function() {
        return function(next) {
            return function(action) {
                if (action.type === 'INITIAL_PUBLISH') {
                    isWatching = true;
                    marshal.tryRecordFocus(action.payload.critical.draggable.id);
                    next(action);
                    marshal.tryRestoreFocusRecorded();
                    return;
                }
                next(action);
                if (!isWatching) return;
                if (action.type === 'FLUSH') {
                    isWatching = false;
                    marshal.tryRestoreFocusRecorded();
                    return;
                }
                if (action.type === 'DROP_COMPLETE') {
                    isWatching = false;
                    var result = action.payload.completed.result;
                    if (result.combine) marshal.tryShiftRecord(result.draggableId, result.combine.draggableId);
                    marshal.tryRestoreFocusRecorded();
                }
            };
        };
    };
};
var $69fa0e3037063634$var$shouldStop = function shouldStop(action) {
    return action.type === 'DROP_COMPLETE' || action.type === 'DROP_ANIMATE' || action.type === 'FLUSH';
};
var $69fa0e3037063634$var$autoScroll = function(autoScroller) {
    return function(store) {
        return function(next) {
            return function(action) {
                if ($69fa0e3037063634$var$shouldStop(action)) {
                    autoScroller.stop();
                    next(action);
                    return;
                }
                if (action.type === 'INITIAL_PUBLISH') {
                    next(action);
                    var state = store.getState();
                    !(state.phase === 'DRAGGING') && $69fa0e3037063634$var$invariant(false);
                    autoScroller.start(state);
                    return;
                }
                next(action);
                autoScroller.scroll(store.getState());
            };
        };
    };
};
var $69fa0e3037063634$var$pendingDrop = function(store) {
    return function(next) {
        return function(action) {
            next(action);
            if (action.type !== 'PUBLISH_WHILE_DRAGGING') return;
            var postActionState = store.getState();
            if (postActionState.phase !== 'DROP_PENDING') return;
            if (postActionState.isWaiting) return;
            store.dispatch($69fa0e3037063634$var$drop({
                reason: postActionState.reason
            }));
        };
    };
};
var $69fa0e3037063634$var$composeEnhancers = (0, $4QJdp.compose);
var $69fa0e3037063634$var$createStore = function(_ref) {
    var dimensionMarshal = _ref.dimensionMarshal, focusMarshal = _ref.focusMarshal, styleMarshal = _ref.styleMarshal, getResponders = _ref.getResponders, announce = _ref.announce, autoScroller = _ref.autoScroller;
    return (0, $4QJdp.createStore)($69fa0e3037063634$var$reducer, $69fa0e3037063634$var$composeEnhancers((0, $4QJdp.applyMiddleware)($69fa0e3037063634$var$style(styleMarshal), $69fa0e3037063634$var$dimensionMarshalStopper(dimensionMarshal), $69fa0e3037063634$var$lift$1(dimensionMarshal), $69fa0e3037063634$var$drop$1, $69fa0e3037063634$var$dropAnimationFinish, $69fa0e3037063634$var$dropAnimationFlushOnScroll, $69fa0e3037063634$var$pendingDrop, $69fa0e3037063634$var$autoScroll(autoScroller), $69fa0e3037063634$var$scrollListener, $69fa0e3037063634$var$focus(focusMarshal), $69fa0e3037063634$var$responders(getResponders, announce))));
};
var $69fa0e3037063634$var$clean$1 = function clean() {
    return {
        additions: {},
        removals: {},
        modified: {}
    };
};
var $69fa0e3037063634$var$timingKey = 'Publish collection from DOM';
function $69fa0e3037063634$var$createPublisher(_ref) {
    var registry = _ref.registry, callbacks = _ref.callbacks;
    var staging = $69fa0e3037063634$var$clean$1();
    var frameId = null;
    var collect = function collect() {
        if (frameId) return;
        callbacks.collectionStarting();
        frameId = requestAnimationFrame(function() {
            frameId = null;
            $69fa0e3037063634$var$start($69fa0e3037063634$var$timingKey);
            var _staging = staging, additions = _staging.additions, removals = _staging.removals, modified = _staging.modified;
            var added = (0, (/*@__PURE__*/$parcel$interopDefault($l1Zd2)))(additions).map(function(id) {
                return registry.draggable.getById(id).getDimension($69fa0e3037063634$var$origin);
            }).sort(function(a, b) {
                return a.descriptor.index - b.descriptor.index;
            });
            var updated = (0, (/*@__PURE__*/$parcel$interopDefault($l1Zd2)))(modified).map(function(id) {
                var entry = registry.droppable.getById(id);
                var scroll = entry.callbacks.getScrollWhileDragging();
                return {
                    droppableId: id,
                    scroll: scroll
                };
            });
            var result = {
                additions: added,
                removals: (0, (/*@__PURE__*/$parcel$interopDefault($l1Zd2)))(removals),
                modified: updated
            };
            staging = $69fa0e3037063634$var$clean$1();
            $69fa0e3037063634$var$finish($69fa0e3037063634$var$timingKey);
            callbacks.publish(result);
        });
    };
    var add = function add(entry) {
        var id = entry.descriptor.id;
        staging.additions[id] = entry;
        staging.modified[entry.descriptor.droppableId] = true;
        if (staging.removals[id]) delete staging.removals[id];
        collect();
    };
    var remove = function remove(entry) {
        var descriptor = entry.descriptor;
        staging.removals[descriptor.id] = true;
        staging.modified[descriptor.droppableId] = true;
        if (staging.additions[descriptor.id]) delete staging.additions[descriptor.id];
        collect();
    };
    var stop = function stop() {
        if (!frameId) return;
        cancelAnimationFrame(frameId);
        frameId = null;
        staging = $69fa0e3037063634$var$clean$1();
    };
    return {
        add: add,
        remove: remove,
        stop: stop
    };
}
var $69fa0e3037063634$var$getMaxScroll = function(_ref) {
    var scrollHeight = _ref.scrollHeight, scrollWidth = _ref.scrollWidth, height = _ref.height, width = _ref.width;
    var maxScroll = $69fa0e3037063634$var$subtract({
        x: scrollWidth,
        y: scrollHeight
    }, {
        x: width,
        y: height
    });
    var adjustedMaxScroll = {
        x: Math.max(0, maxScroll.x),
        y: Math.max(0, maxScroll.y)
    };
    return adjustedMaxScroll;
};
var $69fa0e3037063634$var$getDocumentElement = function() {
    var doc = document.documentElement;
    !doc && $69fa0e3037063634$var$invariant(false);
    return doc;
};
var $69fa0e3037063634$var$getMaxWindowScroll = function() {
    var doc = $69fa0e3037063634$var$getDocumentElement();
    var maxScroll = $69fa0e3037063634$var$getMaxScroll({
        scrollHeight: doc.scrollHeight,
        scrollWidth: doc.scrollWidth,
        width: doc.clientWidth,
        height: doc.clientHeight
    });
    return maxScroll;
};
var $69fa0e3037063634$var$getViewport = function() {
    var scroll = $69fa0e3037063634$var$getWindowScroll();
    var maxScroll = $69fa0e3037063634$var$getMaxWindowScroll();
    var top = scroll.y;
    var left = scroll.x;
    var doc = $69fa0e3037063634$var$getDocumentElement();
    var width = doc.clientWidth;
    var height = doc.clientHeight;
    var right = left + width;
    var bottom = top + height;
    var frame = (0, $bn5nT.getRect)({
        top: top,
        left: left,
        right: right,
        bottom: bottom
    });
    var viewport = {
        frame: frame,
        scroll: {
            initial: scroll,
            current: scroll,
            max: maxScroll,
            diff: {
                value: $69fa0e3037063634$var$origin,
                displacement: $69fa0e3037063634$var$origin
            }
        }
    };
    return viewport;
};
var $69fa0e3037063634$var$getInitialPublish = function(_ref) {
    var critical = _ref.critical, scrollOptions = _ref.scrollOptions, registry = _ref.registry;
    var timingKey = 'Initial collection from DOM';
    $69fa0e3037063634$var$start(timingKey);
    var viewport = $69fa0e3037063634$var$getViewport();
    var windowScroll = viewport.scroll.current;
    var home = critical.droppable;
    var droppables = registry.droppable.getAllByType(home.type).map(function(entry) {
        return entry.callbacks.getDimensionAndWatchScroll(windowScroll, scrollOptions);
    });
    var draggables = registry.draggable.getAllByType(critical.draggable.type).map(function(entry) {
        return entry.getDimension(windowScroll);
    });
    var dimensions = {
        draggables: $69fa0e3037063634$var$toDraggableMap(draggables),
        droppables: $69fa0e3037063634$var$toDroppableMap(droppables)
    };
    $69fa0e3037063634$var$finish(timingKey);
    var result = {
        dimensions: dimensions,
        critical: critical,
        viewport: viewport
    };
    return result;
};
function $69fa0e3037063634$var$shouldPublishUpdate(registry, dragging, entry) {
    if (entry.descriptor.id === dragging.id) return false;
    if (entry.descriptor.type !== dragging.type) return false;
    var home = registry.droppable.getById(entry.descriptor.droppableId);
    if (home.descriptor.mode !== 'virtual') return false;
    return true;
}
var $69fa0e3037063634$var$createDimensionMarshal = function(registry, callbacks) {
    var collection = null;
    var publisher = $69fa0e3037063634$var$createPublisher({
        callbacks: {
            publish: callbacks.publishWhileDragging,
            collectionStarting: callbacks.collectionStarting
        },
        registry: registry
    });
    var updateDroppableIsEnabled = function updateDroppableIsEnabled(id, isEnabled) {
        !registry.droppable.exists(id) && $69fa0e3037063634$var$invariant(false);
        if (!collection) return;
        callbacks.updateDroppableIsEnabled({
            id: id,
            isEnabled: isEnabled
        });
    };
    var updateDroppableIsCombineEnabled = function updateDroppableIsCombineEnabled(id, isCombineEnabled) {
        if (!collection) return;
        !registry.droppable.exists(id) && $69fa0e3037063634$var$invariant(false);
        callbacks.updateDroppableIsCombineEnabled({
            id: id,
            isCombineEnabled: isCombineEnabled
        });
    };
    var updateDroppableScroll = function updateDroppableScroll(id, newScroll) {
        if (!collection) return;
        !registry.droppable.exists(id) && $69fa0e3037063634$var$invariant(false);
        callbacks.updateDroppableScroll({
            id: id,
            newScroll: newScroll
        });
    };
    var scrollDroppable = function scrollDroppable(id, change) {
        if (!collection) return;
        registry.droppable.getById(id).callbacks.scroll(change);
    };
    var stopPublishing = function stopPublishing() {
        if (!collection) return;
        publisher.stop();
        var home = collection.critical.droppable;
        registry.droppable.getAllByType(home.type).forEach(function(entry) {
            return entry.callbacks.dragStopped();
        });
        collection.unsubscribe();
        collection = null;
    };
    var subscriber = function subscriber(event) {
        !collection && $69fa0e3037063634$var$invariant(false);
        var dragging = collection.critical.draggable;
        if (event.type === 'ADDITION') {
            if ($69fa0e3037063634$var$shouldPublishUpdate(registry, dragging, event.value)) publisher.add(event.value);
        }
        if (event.type === 'REMOVAL') {
            if ($69fa0e3037063634$var$shouldPublishUpdate(registry, dragging, event.value)) publisher.remove(event.value);
        }
    };
    var startPublishing = function startPublishing(request) {
        !!collection && $69fa0e3037063634$var$invariant(false);
        var entry = registry.draggable.getById(request.draggableId);
        var home = registry.droppable.getById(entry.descriptor.droppableId);
        var critical = {
            draggable: entry.descriptor,
            droppable: home.descriptor
        };
        var unsubscribe = registry.subscribe(subscriber);
        collection = {
            critical: critical,
            unsubscribe: unsubscribe
        };
        return $69fa0e3037063634$var$getInitialPublish({
            critical: critical,
            registry: registry,
            scrollOptions: request.scrollOptions
        });
    };
    var marshal = {
        updateDroppableIsEnabled: updateDroppableIsEnabled,
        updateDroppableIsCombineEnabled: updateDroppableIsCombineEnabled,
        scrollDroppable: scrollDroppable,
        updateDroppableScroll: updateDroppableScroll,
        startPublishing: startPublishing,
        stopPublishing: stopPublishing
    };
    return marshal;
};
var $69fa0e3037063634$var$canStartDrag = function(state, id) {
    if (state.phase === 'IDLE') return true;
    if (state.phase !== 'DROP_ANIMATING') return false;
    if (state.completed.result.draggableId === id) return false;
    return state.completed.result.reason === 'DROP';
};
var $69fa0e3037063634$var$scrollWindow = function(change) {
    window.scrollBy(change.x, change.y);
};
var $69fa0e3037063634$var$getScrollableDroppables = (0, $dCUwp.default)(function(droppables) {
    return $69fa0e3037063634$var$toDroppableList(droppables).filter(function(droppable) {
        if (!droppable.isEnabled) return false;
        if (!droppable.frame) return false;
        return true;
    });
});
var $69fa0e3037063634$var$getScrollableDroppableOver = function getScrollableDroppableOver(target, droppables) {
    var maybe = $69fa0e3037063634$var$find($69fa0e3037063634$var$getScrollableDroppables(droppables), function(droppable) {
        !droppable.frame && $69fa0e3037063634$var$invariant(false);
        return $69fa0e3037063634$var$isPositionInFrame(droppable.frame.pageMarginBox)(target);
    });
    return maybe;
};
var $69fa0e3037063634$var$getBestScrollableDroppable = function(_ref) {
    var center = _ref.center, destination = _ref.destination, droppables = _ref.droppables;
    if (destination) {
        var _dimension = droppables[destination];
        if (!_dimension.frame) return null;
        return _dimension;
    }
    var dimension = $69fa0e3037063634$var$getScrollableDroppableOver(center, droppables);
    return dimension;
};
var $69fa0e3037063634$var$config = {
    startFromPercentage: 0.25,
    maxScrollAtPercentage: 0.05,
    maxPixelScroll: 28,
    ease: function ease(percentage) {
        return Math.pow(percentage, 2);
    },
    durationDampening: {
        stopDampeningAt: 1200,
        accelerateAt: 360
    }
};
var $69fa0e3037063634$var$getDistanceThresholds = function(container, axis) {
    var startScrollingFrom = container[axis.size] * $69fa0e3037063634$var$config.startFromPercentage;
    var maxScrollValueAt = container[axis.size] * $69fa0e3037063634$var$config.maxScrollAtPercentage;
    var thresholds = {
        startScrollingFrom: startScrollingFrom,
        maxScrollValueAt: maxScrollValueAt
    };
    return thresholds;
};
var $69fa0e3037063634$var$getPercentage = function(_ref) {
    var startOfRange = _ref.startOfRange, endOfRange = _ref.endOfRange, current = _ref.current;
    var range = endOfRange - startOfRange;
    if (range === 0) return 0;
    var currentInRange = current - startOfRange;
    var percentage = currentInRange / range;
    return percentage;
};
var $69fa0e3037063634$var$minScroll = 1;
var $69fa0e3037063634$var$getValueFromDistance = function(distanceToEdge, thresholds) {
    if (distanceToEdge > thresholds.startScrollingFrom) return 0;
    if (distanceToEdge <= thresholds.maxScrollValueAt) return $69fa0e3037063634$var$config.maxPixelScroll;
    if (distanceToEdge === thresholds.startScrollingFrom) return $69fa0e3037063634$var$minScroll;
    var percentageFromMaxScrollValueAt = $69fa0e3037063634$var$getPercentage({
        startOfRange: thresholds.maxScrollValueAt,
        endOfRange: thresholds.startScrollingFrom,
        current: distanceToEdge
    });
    var percentageFromStartScrollingFrom = 1 - percentageFromMaxScrollValueAt;
    var scroll = $69fa0e3037063634$var$config.maxPixelScroll * $69fa0e3037063634$var$config.ease(percentageFromStartScrollingFrom);
    return Math.ceil(scroll);
};
var $69fa0e3037063634$var$accelerateAt = $69fa0e3037063634$var$config.durationDampening.accelerateAt;
var $69fa0e3037063634$var$stopAt = $69fa0e3037063634$var$config.durationDampening.stopDampeningAt;
var $69fa0e3037063634$var$dampenValueByTime = function(proposedScroll, dragStartTime) {
    var startOfRange = dragStartTime;
    var endOfRange = $69fa0e3037063634$var$stopAt;
    var now = (0, (/*@__PURE__*/$parcel$interopDefault($5JNlj)))();
    var runTime = now - startOfRange;
    if (runTime >= $69fa0e3037063634$var$stopAt) return proposedScroll;
    if (runTime < $69fa0e3037063634$var$accelerateAt) return $69fa0e3037063634$var$minScroll;
    var betweenAccelerateAtAndStopAtPercentage = $69fa0e3037063634$var$getPercentage({
        startOfRange: $69fa0e3037063634$var$accelerateAt,
        endOfRange: endOfRange,
        current: runTime
    });
    var scroll = proposedScroll * $69fa0e3037063634$var$config.ease(betweenAccelerateAtAndStopAtPercentage);
    return Math.ceil(scroll);
};
var $69fa0e3037063634$var$getValue = function(_ref) {
    var distanceToEdge = _ref.distanceToEdge, thresholds = _ref.thresholds, dragStartTime = _ref.dragStartTime, shouldUseTimeDampening = _ref.shouldUseTimeDampening;
    var scroll = $69fa0e3037063634$var$getValueFromDistance(distanceToEdge, thresholds);
    if (scroll === 0) return 0;
    if (!shouldUseTimeDampening) return scroll;
    return Math.max($69fa0e3037063634$var$dampenValueByTime(scroll, dragStartTime), $69fa0e3037063634$var$minScroll);
};
var $69fa0e3037063634$var$getScrollOnAxis = function(_ref) {
    var container = _ref.container, distanceToEdges = _ref.distanceToEdges, dragStartTime = _ref.dragStartTime, axis = _ref.axis, shouldUseTimeDampening = _ref.shouldUseTimeDampening;
    var thresholds = $69fa0e3037063634$var$getDistanceThresholds(container, axis);
    var isCloserToEnd = distanceToEdges[axis.end] < distanceToEdges[axis.start];
    if (isCloserToEnd) return $69fa0e3037063634$var$getValue({
        distanceToEdge: distanceToEdges[axis.end],
        thresholds: thresholds,
        dragStartTime: dragStartTime,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    return -1 * $69fa0e3037063634$var$getValue({
        distanceToEdge: distanceToEdges[axis.start],
        thresholds: thresholds,
        dragStartTime: dragStartTime,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
};
var $69fa0e3037063634$var$adjustForSizeLimits = function(_ref) {
    var container = _ref.container, subject = _ref.subject, proposedScroll = _ref.proposedScroll;
    var isTooBigVertically = subject.height > container.height;
    var isTooBigHorizontally = subject.width > container.width;
    if (!isTooBigHorizontally && !isTooBigVertically) return proposedScroll;
    if (isTooBigHorizontally && isTooBigVertically) return null;
    return {
        x: isTooBigHorizontally ? 0 : proposedScroll.x,
        y: isTooBigVertically ? 0 : proposedScroll.y
    };
};
var $69fa0e3037063634$var$clean$2 = $69fa0e3037063634$var$apply(function(value) {
    return value === 0 ? 0 : value;
});
var $69fa0e3037063634$var$getScroll = function(_ref) {
    var dragStartTime = _ref.dragStartTime, container = _ref.container, subject = _ref.subject, center = _ref.center, shouldUseTimeDampening = _ref.shouldUseTimeDampening;
    var distanceToEdges = {
        top: center.y - container.top,
        right: container.right - center.x,
        bottom: container.bottom - center.y,
        left: center.x - container.left
    };
    var y = $69fa0e3037063634$var$getScrollOnAxis({
        container: container,
        distanceToEdges: distanceToEdges,
        dragStartTime: dragStartTime,
        axis: $69fa0e3037063634$var$vertical,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    var x = $69fa0e3037063634$var$getScrollOnAxis({
        container: container,
        distanceToEdges: distanceToEdges,
        dragStartTime: dragStartTime,
        axis: $69fa0e3037063634$var$horizontal,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    var required = $69fa0e3037063634$var$clean$2({
        x: x,
        y: y
    });
    if ($69fa0e3037063634$var$isEqual(required, $69fa0e3037063634$var$origin)) return null;
    var limited = $69fa0e3037063634$var$adjustForSizeLimits({
        container: container,
        subject: subject,
        proposedScroll: required
    });
    if (!limited) return null;
    return $69fa0e3037063634$var$isEqual(limited, $69fa0e3037063634$var$origin) ? null : limited;
};
var $69fa0e3037063634$var$smallestSigned = $69fa0e3037063634$var$apply(function(value) {
    if (value === 0) return 0;
    return value > 0 ? 1 : -1;
});
var $69fa0e3037063634$var$getOverlap = function() {
    var getRemainder = function getRemainder(target, max) {
        if (target < 0) return target;
        if (target > max) return target - max;
        return 0;
    };
    return function(_ref) {
        var current = _ref.current, max = _ref.max, change = _ref.change;
        var targetScroll = $69fa0e3037063634$var$add(current, change);
        var overlap = {
            x: getRemainder(targetScroll.x, max.x),
            y: getRemainder(targetScroll.y, max.y)
        };
        if ($69fa0e3037063634$var$isEqual(overlap, $69fa0e3037063634$var$origin)) return null;
        return overlap;
    };
}();
var $69fa0e3037063634$var$canPartiallyScroll = function canPartiallyScroll(_ref2) {
    var rawMax = _ref2.max, current = _ref2.current, change = _ref2.change;
    var max = {
        x: Math.max(current.x, rawMax.x),
        y: Math.max(current.y, rawMax.y)
    };
    var smallestChange = $69fa0e3037063634$var$smallestSigned(change);
    var overlap = $69fa0e3037063634$var$getOverlap({
        max: max,
        current: current,
        change: smallestChange
    });
    if (!overlap) return true;
    if (smallestChange.x !== 0 && overlap.x === 0) return true;
    if (smallestChange.y !== 0 && overlap.y === 0) return true;
    return false;
};
var $69fa0e3037063634$var$canScrollWindow = function canScrollWindow(viewport, change) {
    return $69fa0e3037063634$var$canPartiallyScroll({
        current: viewport.scroll.current,
        max: viewport.scroll.max,
        change: change
    });
};
var $69fa0e3037063634$var$getWindowOverlap = function getWindowOverlap(viewport, change) {
    if (!$69fa0e3037063634$var$canScrollWindow(viewport, change)) return null;
    var max = viewport.scroll.max;
    var current = viewport.scroll.current;
    return $69fa0e3037063634$var$getOverlap({
        current: current,
        max: max,
        change: change
    });
};
var $69fa0e3037063634$var$canScrollDroppable = function canScrollDroppable(droppable, change) {
    var frame = droppable.frame;
    if (!frame) return false;
    return $69fa0e3037063634$var$canPartiallyScroll({
        current: frame.scroll.current,
        max: frame.scroll.max,
        change: change
    });
};
var $69fa0e3037063634$var$getDroppableOverlap = function getDroppableOverlap(droppable, change) {
    var frame = droppable.frame;
    if (!frame) return null;
    if (!$69fa0e3037063634$var$canScrollDroppable(droppable, change)) return null;
    return $69fa0e3037063634$var$getOverlap({
        current: frame.scroll.current,
        max: frame.scroll.max,
        change: change
    });
};
var $69fa0e3037063634$var$getWindowScrollChange = function(_ref) {
    var viewport = _ref.viewport, subject = _ref.subject, center = _ref.center, dragStartTime = _ref.dragStartTime, shouldUseTimeDampening = _ref.shouldUseTimeDampening;
    var scroll = $69fa0e3037063634$var$getScroll({
        dragStartTime: dragStartTime,
        container: viewport.frame,
        subject: subject,
        center: center,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    return scroll && $69fa0e3037063634$var$canScrollWindow(viewport, scroll) ? scroll : null;
};
var $69fa0e3037063634$var$getDroppableScrollChange = function(_ref) {
    var droppable = _ref.droppable, subject = _ref.subject, center = _ref.center, dragStartTime = _ref.dragStartTime, shouldUseTimeDampening = _ref.shouldUseTimeDampening;
    var frame = droppable.frame;
    if (!frame) return null;
    var scroll = $69fa0e3037063634$var$getScroll({
        dragStartTime: dragStartTime,
        container: frame.pageMarginBox,
        subject: subject,
        center: center,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    return scroll && $69fa0e3037063634$var$canScrollDroppable(droppable, scroll) ? scroll : null;
};
var $69fa0e3037063634$var$scroll$1 = function(_ref) {
    var state = _ref.state, dragStartTime = _ref.dragStartTime, shouldUseTimeDampening = _ref.shouldUseTimeDampening, scrollWindow = _ref.scrollWindow, scrollDroppable = _ref.scrollDroppable;
    var center = state.current.page.borderBoxCenter;
    var draggable = state.dimensions.draggables[state.critical.draggable.id];
    var subject = draggable.page.marginBox;
    if (state.isWindowScrollAllowed) {
        var viewport = state.viewport;
        var _change = $69fa0e3037063634$var$getWindowScrollChange({
            dragStartTime: dragStartTime,
            viewport: viewport,
            subject: subject,
            center: center,
            shouldUseTimeDampening: shouldUseTimeDampening
        });
        if (_change) {
            scrollWindow(_change);
            return;
        }
    }
    var droppable = $69fa0e3037063634$var$getBestScrollableDroppable({
        center: center,
        destination: $69fa0e3037063634$var$whatIsDraggedOver(state.impact),
        droppables: state.dimensions.droppables
    });
    if (!droppable) return;
    var change = $69fa0e3037063634$var$getDroppableScrollChange({
        dragStartTime: dragStartTime,
        droppable: droppable,
        subject: subject,
        center: center,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    if (change) scrollDroppable(droppable.descriptor.id, change);
};
var $69fa0e3037063634$var$createFluidScroller = function(_ref) {
    var scrollWindow = _ref.scrollWindow, scrollDroppable = _ref.scrollDroppable;
    var scheduleWindowScroll = (0, $gxvYj.default)(scrollWindow);
    var scheduleDroppableScroll = (0, $gxvYj.default)(scrollDroppable);
    var dragging = null;
    var tryScroll = function tryScroll(state) {
        !dragging && $69fa0e3037063634$var$invariant(false);
        var _dragging = dragging, shouldUseTimeDampening = _dragging.shouldUseTimeDampening, dragStartTime = _dragging.dragStartTime;
        $69fa0e3037063634$var$scroll$1({
            state: state,
            scrollWindow: scheduleWindowScroll,
            scrollDroppable: scheduleDroppableScroll,
            dragStartTime: dragStartTime,
            shouldUseTimeDampening: shouldUseTimeDampening
        });
    };
    var start$1 = function start$1(state) {
        $69fa0e3037063634$var$start('starting fluid scroller');
        !!dragging && $69fa0e3037063634$var$invariant(false);
        var dragStartTime = (0, (/*@__PURE__*/$parcel$interopDefault($5JNlj)))();
        var wasScrollNeeded = false;
        var fakeScrollCallback = function fakeScrollCallback() {
            wasScrollNeeded = true;
        };
        $69fa0e3037063634$var$scroll$1({
            state: state,
            dragStartTime: 0,
            shouldUseTimeDampening: false,
            scrollWindow: fakeScrollCallback,
            scrollDroppable: fakeScrollCallback
        });
        dragging = {
            dragStartTime: dragStartTime,
            shouldUseTimeDampening: wasScrollNeeded
        };
        $69fa0e3037063634$var$finish('starting fluid scroller');
        if (wasScrollNeeded) tryScroll(state);
    };
    var stop = function stop() {
        if (!dragging) return;
        scheduleWindowScroll.cancel();
        scheduleDroppableScroll.cancel();
        dragging = null;
    };
    return {
        start: start$1,
        stop: stop,
        scroll: tryScroll
    };
};
var $69fa0e3037063634$var$createJumpScroller = function(_ref) {
    var move = _ref.move, scrollDroppable = _ref.scrollDroppable, scrollWindow = _ref.scrollWindow;
    var moveByOffset = function moveByOffset(state, offset) {
        var client = $69fa0e3037063634$var$add(state.current.client.selection, offset);
        move({
            client: client
        });
    };
    var scrollDroppableAsMuchAsItCan = function scrollDroppableAsMuchAsItCan(droppable, change) {
        if (!$69fa0e3037063634$var$canScrollDroppable(droppable, change)) return change;
        var overlap = $69fa0e3037063634$var$getDroppableOverlap(droppable, change);
        if (!overlap) {
            scrollDroppable(droppable.descriptor.id, change);
            return null;
        }
        var whatTheDroppableCanScroll = $69fa0e3037063634$var$subtract(change, overlap);
        scrollDroppable(droppable.descriptor.id, whatTheDroppableCanScroll);
        var remainder = $69fa0e3037063634$var$subtract(change, whatTheDroppableCanScroll);
        return remainder;
    };
    var scrollWindowAsMuchAsItCan = function scrollWindowAsMuchAsItCan(isWindowScrollAllowed, viewport, change) {
        if (!isWindowScrollAllowed) return change;
        if (!$69fa0e3037063634$var$canScrollWindow(viewport, change)) return change;
        var overlap = $69fa0e3037063634$var$getWindowOverlap(viewport, change);
        if (!overlap) {
            scrollWindow(change);
            return null;
        }
        var whatTheWindowCanScroll = $69fa0e3037063634$var$subtract(change, overlap);
        scrollWindow(whatTheWindowCanScroll);
        var remainder = $69fa0e3037063634$var$subtract(change, whatTheWindowCanScroll);
        return remainder;
    };
    var jumpScroller = function jumpScroller(state) {
        var request = state.scrollJumpRequest;
        if (!request) return;
        var destination = $69fa0e3037063634$var$whatIsDraggedOver(state.impact);
        !destination && $69fa0e3037063634$var$invariant(false);
        var droppableRemainder = scrollDroppableAsMuchAsItCan(state.dimensions.droppables[destination], request);
        if (!droppableRemainder) return;
        var viewport = state.viewport;
        var windowRemainder = scrollWindowAsMuchAsItCan(state.isWindowScrollAllowed, viewport, droppableRemainder);
        if (!windowRemainder) return;
        moveByOffset(state, windowRemainder);
    };
    return jumpScroller;
};
var $69fa0e3037063634$var$createAutoScroller = function(_ref) {
    var scrollDroppable = _ref.scrollDroppable, scrollWindow = _ref.scrollWindow, move = _ref.move;
    var fluidScroller = $69fa0e3037063634$var$createFluidScroller({
        scrollWindow: scrollWindow,
        scrollDroppable: scrollDroppable
    });
    var jumpScroll = $69fa0e3037063634$var$createJumpScroller({
        move: move,
        scrollWindow: scrollWindow,
        scrollDroppable: scrollDroppable
    });
    var scroll = function scroll(state) {
        if (state.phase !== 'DRAGGING') return;
        if (state.movementMode === 'FLUID') {
            fluidScroller.scroll(state);
            return;
        }
        if (!state.scrollJumpRequest) return;
        jumpScroll(state);
    };
    var scroller = {
        scroll: scroll,
        start: fluidScroller.start,
        stop: fluidScroller.stop
    };
    return scroller;
};
var $69fa0e3037063634$var$prefix$1 = 'data-rbd';
var $69fa0e3037063634$var$dragHandle = function() {
    var base = $69fa0e3037063634$var$prefix$1 + "-drag-handle";
    return {
        base: base,
        draggableId: base + "-draggable-id",
        contextId: base + "-context-id"
    };
}();
var $69fa0e3037063634$var$draggable = function() {
    var base = $69fa0e3037063634$var$prefix$1 + "-draggable";
    return {
        base: base,
        contextId: base + "-context-id",
        id: base + "-id"
    };
}();
var $69fa0e3037063634$var$droppable = function() {
    var base = $69fa0e3037063634$var$prefix$1 + "-droppable";
    return {
        base: base,
        contextId: base + "-context-id",
        id: base + "-id"
    };
}();
var $69fa0e3037063634$var$scrollContainer = {
    contextId: $69fa0e3037063634$var$prefix$1 + "-scroll-container-context-id"
};
var $69fa0e3037063634$var$makeGetSelector = function makeGetSelector(context) {
    return function(attribute) {
        return "[" + attribute + "=\"" + context + "\"]";
    };
};
var $69fa0e3037063634$var$getStyles = function getStyles(rules, property) {
    return rules.map(function(rule) {
        var value = rule.styles[property];
        if (!value) return '';
        return rule.selector + " { " + value + " }";
    }).join(' ');
};
var $69fa0e3037063634$var$noPointerEvents = 'pointer-events: none;';
var $69fa0e3037063634$var$getStyles$1 = function(contextId) {
    var getSelector = $69fa0e3037063634$var$makeGetSelector(contextId);
    var dragHandle$1 = function() {
        var grabCursor = "\n      cursor: -webkit-grab;\n      cursor: grab;\n    ";
        return {
            selector: getSelector($69fa0e3037063634$var$dragHandle.contextId),
            styles: {
                always: "\n          -webkit-touch-callout: none;\n          -webkit-tap-highlight-color: rgba(0,0,0,0);\n          touch-action: manipulation;\n        ",
                resting: grabCursor,
                dragging: $69fa0e3037063634$var$noPointerEvents,
                dropAnimating: grabCursor
            }
        };
    }();
    var draggable$1 = function() {
        var transition = "\n      transition: " + $69fa0e3037063634$var$transitions.outOfTheWay + ";\n    ";
        return {
            selector: getSelector($69fa0e3037063634$var$draggable.contextId),
            styles: {
                dragging: transition,
                dropAnimating: transition,
                userCancel: transition
            }
        };
    }();
    var droppable$1 = {
        selector: getSelector($69fa0e3037063634$var$droppable.contextId),
        styles: {
            always: "overflow-anchor: none;"
        }
    };
    var body = {
        selector: 'body',
        styles: {
            dragging: "\n        cursor: grabbing;\n        cursor: -webkit-grabbing;\n        user-select: none;\n        -webkit-user-select: none;\n        -moz-user-select: none;\n        -ms-user-select: none;\n        overflow-anchor: none;\n      "
        }
    };
    var rules = [
        draggable$1,
        dragHandle$1,
        droppable$1,
        body
    ];
    return {
        always: $69fa0e3037063634$var$getStyles(rules, 'always'),
        resting: $69fa0e3037063634$var$getStyles(rules, 'resting'),
        dragging: $69fa0e3037063634$var$getStyles(rules, 'dragging'),
        dropAnimating: $69fa0e3037063634$var$getStyles(rules, 'dropAnimating'),
        userCancel: $69fa0e3037063634$var$getStyles(rules, 'userCancel')
    };
};
var $69fa0e3037063634$var$useIsomorphicLayoutEffect = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? (0, $eUqFw.useLayoutEffect) : (0, $eUqFw.useEffect);
var $69fa0e3037063634$var$getHead = function getHead() {
    var head = document.querySelector('head');
    !head && $69fa0e3037063634$var$invariant(false);
    return head;
};
var $69fa0e3037063634$var$createStyleEl = function createStyleEl(nonce) {
    var el = document.createElement('style');
    if (nonce) el.setAttribute('nonce', nonce);
    el.type = 'text/css';
    return el;
};
function $69fa0e3037063634$var$useStyleMarshal(contextId, nonce) {
    var styles = (0, $fzXll.useMemo)(function() {
        return $69fa0e3037063634$var$getStyles$1(contextId);
    }, [
        contextId
    ]);
    var alwaysRef = (0, $eUqFw.useRef)(null);
    var dynamicRef = (0, $eUqFw.useRef)(null);
    var setDynamicStyle = (0, $fzXll.useCallback)((0, $dCUwp.default)(function(proposed) {
        var el = dynamicRef.current;
        !el && $69fa0e3037063634$var$invariant(false);
        el.textContent = proposed;
    }), []);
    var setAlwaysStyle = (0, $fzXll.useCallback)(function(proposed) {
        var el = alwaysRef.current;
        !el && $69fa0e3037063634$var$invariant(false);
        el.textContent = proposed;
    }, []);
    $69fa0e3037063634$var$useIsomorphicLayoutEffect(function() {
        !(!alwaysRef.current && !dynamicRef.current) && $69fa0e3037063634$var$invariant(false);
        var always = $69fa0e3037063634$var$createStyleEl(nonce);
        var dynamic = $69fa0e3037063634$var$createStyleEl(nonce);
        alwaysRef.current = always;
        dynamicRef.current = dynamic;
        always.setAttribute($69fa0e3037063634$var$prefix$1 + "-always", contextId);
        dynamic.setAttribute($69fa0e3037063634$var$prefix$1 + "-dynamic", contextId);
        $69fa0e3037063634$var$getHead().appendChild(always);
        $69fa0e3037063634$var$getHead().appendChild(dynamic);
        setAlwaysStyle(styles.always);
        setDynamicStyle(styles.resting);
        return function() {
            var remove = function remove(ref) {
                var current = ref.current;
                !current && $69fa0e3037063634$var$invariant(false);
                $69fa0e3037063634$var$getHead().removeChild(current);
                ref.current = null;
            };
            remove(alwaysRef);
            remove(dynamicRef);
        };
    }, [
        nonce,
        setAlwaysStyle,
        setDynamicStyle,
        styles.always,
        styles.resting,
        contextId
    ]);
    var dragging = (0, $fzXll.useCallback)(function() {
        return setDynamicStyle(styles.dragging);
    }, [
        setDynamicStyle,
        styles.dragging
    ]);
    var dropping = (0, $fzXll.useCallback)(function(reason) {
        if (reason === 'DROP') {
            setDynamicStyle(styles.dropAnimating);
            return;
        }
        setDynamicStyle(styles.userCancel);
    }, [
        setDynamicStyle,
        styles.dropAnimating,
        styles.userCancel
    ]);
    var resting = (0, $fzXll.useCallback)(function() {
        if (!dynamicRef.current) return;
        setDynamicStyle(styles.resting);
    }, [
        setDynamicStyle,
        styles.resting
    ]);
    var marshal = (0, $fzXll.useMemo)(function() {
        return {
            dragging: dragging,
            dropping: dropping,
            resting: resting
        };
    }, [
        dragging,
        dropping,
        resting
    ]);
    return marshal;
}
var $69fa0e3037063634$var$getWindowFromEl = function(el) {
    return el && el.ownerDocument ? el.ownerDocument.defaultView : window;
};
function $69fa0e3037063634$var$isHtmlElement(el) {
    return el instanceof $69fa0e3037063634$var$getWindowFromEl(el).HTMLElement;
}
function $69fa0e3037063634$var$findDragHandle(contextId, draggableId) {
    var selector = "[" + $69fa0e3037063634$var$dragHandle.contextId + "=\"" + contextId + "\"]";
    var possible = $69fa0e3037063634$var$toArray(document.querySelectorAll(selector));
    if (!possible.length) return null;
    var handle = $69fa0e3037063634$var$find(possible, function(el) {
        return el.getAttribute($69fa0e3037063634$var$dragHandle.draggableId) === draggableId;
    });
    if (!handle) return null;
    if (!$69fa0e3037063634$var$isHtmlElement(handle)) return null;
    return handle;
}
function $69fa0e3037063634$var$useFocusMarshal(contextId) {
    var entriesRef = (0, $eUqFw.useRef)({});
    var recordRef = (0, $eUqFw.useRef)(null);
    var restoreFocusFrameRef = (0, $eUqFw.useRef)(null);
    var isMountedRef = (0, $eUqFw.useRef)(false);
    var register = (0, $fzXll.useCallback)(function register(id, focus) {
        var entry = {
            id: id,
            focus: focus
        };
        entriesRef.current[id] = entry;
        return function unregister() {
            var entries = entriesRef.current;
            var current = entries[id];
            if (current !== entry) delete entries[id];
        };
    }, []);
    var tryGiveFocus = (0, $fzXll.useCallback)(function tryGiveFocus(tryGiveFocusTo) {
        var handle = $69fa0e3037063634$var$findDragHandle(contextId, tryGiveFocusTo);
        if (handle && handle !== document.activeElement) handle.focus();
    }, [
        contextId
    ]);
    var tryShiftRecord = (0, $fzXll.useCallback)(function tryShiftRecord(previous, redirectTo) {
        if (recordRef.current === previous) recordRef.current = redirectTo;
    }, []);
    var tryRestoreFocusRecorded = (0, $fzXll.useCallback)(function tryRestoreFocusRecorded() {
        if (restoreFocusFrameRef.current) return;
        if (!isMountedRef.current) return;
        restoreFocusFrameRef.current = requestAnimationFrame(function() {
            restoreFocusFrameRef.current = null;
            var record = recordRef.current;
            if (record) tryGiveFocus(record);
        });
    }, [
        tryGiveFocus
    ]);
    var tryRecordFocus = (0, $fzXll.useCallback)(function tryRecordFocus(id) {
        recordRef.current = null;
        var focused = document.activeElement;
        if (!focused) return;
        if (focused.getAttribute($69fa0e3037063634$var$dragHandle.draggableId) !== id) return;
        recordRef.current = id;
    }, []);
    $69fa0e3037063634$var$useIsomorphicLayoutEffect(function() {
        isMountedRef.current = true;
        return function clearFrameOnUnmount() {
            isMountedRef.current = false;
            var frameId = restoreFocusFrameRef.current;
            if (frameId) cancelAnimationFrame(frameId);
        };
    }, []);
    var marshal = (0, $fzXll.useMemo)(function() {
        return {
            register: register,
            tryRecordFocus: tryRecordFocus,
            tryRestoreFocusRecorded: tryRestoreFocusRecorded,
            tryShiftRecord: tryShiftRecord
        };
    }, [
        register,
        tryRecordFocus,
        tryRestoreFocusRecorded,
        tryShiftRecord
    ]);
    return marshal;
}
function $69fa0e3037063634$var$createRegistry() {
    var entries = {
        draggables: {},
        droppables: {}
    };
    var subscribers = [];
    function subscribe(cb) {
        subscribers.push(cb);
        return function unsubscribe() {
            var index = subscribers.indexOf(cb);
            if (index === -1) return;
            subscribers.splice(index, 1);
        };
    }
    function notify(event) {
        if (subscribers.length) subscribers.forEach(function(cb) {
            return cb(event);
        });
    }
    function findDraggableById(id) {
        return entries.draggables[id] || null;
    }
    function getDraggableById(id) {
        var entry = findDraggableById(id);
        !entry && $69fa0e3037063634$var$invariant(false);
        return entry;
    }
    var draggableAPI = {
        register: function register(entry) {
            entries.draggables[entry.descriptor.id] = entry;
            notify({
                type: 'ADDITION',
                value: entry
            });
        },
        update: function update(entry, last) {
            var current = entries.draggables[last.descriptor.id];
            if (!current) return;
            if (current.uniqueId !== entry.uniqueId) return;
            delete entries.draggables[last.descriptor.id];
            entries.draggables[entry.descriptor.id] = entry;
        },
        unregister: function unregister(entry) {
            var draggableId = entry.descriptor.id;
            var current = findDraggableById(draggableId);
            if (!current) return;
            if (entry.uniqueId !== current.uniqueId) return;
            delete entries.draggables[draggableId];
            notify({
                type: 'REMOVAL',
                value: entry
            });
        },
        getById: getDraggableById,
        findById: findDraggableById,
        exists: function exists(id) {
            return Boolean(findDraggableById(id));
        },
        getAllByType: function getAllByType(type) {
            return $69fa0e3037063634$var$values(entries.draggables).filter(function(entry) {
                return entry.descriptor.type === type;
            });
        }
    };
    function findDroppableById(id) {
        return entries.droppables[id] || null;
    }
    function getDroppableById(id) {
        var entry = findDroppableById(id);
        !entry && $69fa0e3037063634$var$invariant(false);
        return entry;
    }
    var droppableAPI = {
        register: function register(entry) {
            entries.droppables[entry.descriptor.id] = entry;
        },
        unregister: function unregister(entry) {
            var current = findDroppableById(entry.descriptor.id);
            if (!current) return;
            if (entry.uniqueId !== current.uniqueId) return;
            delete entries.droppables[entry.descriptor.id];
        },
        getById: getDroppableById,
        findById: findDroppableById,
        exists: function exists(id) {
            return Boolean(findDroppableById(id));
        },
        getAllByType: function getAllByType(type) {
            return $69fa0e3037063634$var$values(entries.droppables).filter(function(entry) {
                return entry.descriptor.type === type;
            });
        }
    };
    function clean() {
        entries.draggables = {};
        entries.droppables = {};
        subscribers.length = 0;
    }
    return {
        draggable: draggableAPI,
        droppable: droppableAPI,
        subscribe: subscribe,
        clean: clean
    };
}
function $69fa0e3037063634$var$useRegistry() {
    var registry = (0, $fzXll.useMemo)($69fa0e3037063634$var$createRegistry, []);
    (0, $eUqFw.useEffect)(function() {
        return function unmount() {
            requestAnimationFrame(registry.clean);
        };
    }, [
        registry
    ]);
    return registry;
}
var $69fa0e3037063634$var$StoreContext = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext(null);
var $69fa0e3037063634$var$getBodyElement = function() {
    var body = document.body;
    !body && $69fa0e3037063634$var$invariant(false);
    return body;
};
var $69fa0e3037063634$var$visuallyHidden = {
    position: 'absolute',
    width: '1px',
    height: '1px',
    margin: '-1px',
    border: '0',
    padding: '0',
    overflow: 'hidden',
    clip: 'rect(0 0 0 0)',
    'clip-path': 'inset(100%)'
};
var $69fa0e3037063634$var$getId = function getId(contextId) {
    return "rbd-announcement-" + contextId;
};
function $69fa0e3037063634$var$useAnnouncer(contextId) {
    var id = (0, $fzXll.useMemo)(function() {
        return $69fa0e3037063634$var$getId(contextId);
    }, [
        contextId
    ]);
    var ref = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useEffect)(function setup() {
        var el = document.createElement('div');
        ref.current = el;
        el.id = id;
        el.setAttribute('aria-live', 'assertive');
        el.setAttribute('role', 'log');
        el.setAttribute('aria-atomic', 'true');
        (0, (/*@__PURE__*/$parcel$interopDefault($85I24)))(el.style, $69fa0e3037063634$var$visuallyHidden);
        $69fa0e3037063634$var$getBodyElement().appendChild(el);
        return function cleanup() {
            setTimeout(function remove() {
                $69fa0e3037063634$var$getBodyElement().removeChild(el);
                if (el === ref.current) ref.current = null;
            });
        };
    }, [
        id
    ]);
    var announce = (0, $fzXll.useCallback)(function(message) {
        var el = ref.current;
        if (el) {
            el.textContent = message;
            return;
        }
    }, []);
    return announce;
}
var $69fa0e3037063634$var$getId$1 = function getId(contextId) {
    return "rbd-lift-instruction-" + contextId;
};
function $69fa0e3037063634$var$useLiftInstruction(contextId, liftInstruction) {
    var id = (0, $fzXll.useMemo)(function() {
        return $69fa0e3037063634$var$getId$1(contextId);
    }, [
        contextId
    ]);
    (0, $eUqFw.useEffect)(function mount() {
        var el = document.createElement('div');
        el.id = id;
        el.textContent = liftInstruction;
        (0, (/*@__PURE__*/$parcel$interopDefault($85I24)))(el.style, {
            display: 'none'
        });
        $69fa0e3037063634$var$getBodyElement().appendChild(el);
        return function unmount() {
            $69fa0e3037063634$var$getBodyElement().removeChild(el);
        };
    }, [
        id,
        liftInstruction
    ]);
    return id;
}
var $69fa0e3037063634$var$AppContext = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext(null);
var $69fa0e3037063634$var$peerDependencies = {
    react: "^16.8.5",
    "react-dom": "^16.8.5"
};
var $69fa0e3037063634$var$semver = /(\d+)\.(\d+)\.(\d+)/;
var $69fa0e3037063634$var$getVersion = function getVersion(value) {
    var result = $69fa0e3037063634$var$semver.exec(value);
    !(result != null) && $69fa0e3037063634$var$invariant(false);
    var major = Number(result[1]);
    var minor = Number(result[2]);
    var patch = Number(result[3]);
    return {
        major: major,
        minor: minor,
        patch: patch,
        raw: value
    };
};
var $69fa0e3037063634$var$isSatisfied = function isSatisfied(expected, actual) {
    if (actual.major > expected.major) return true;
    if (actual.major < expected.major) return false;
    if (actual.minor > expected.minor) return true;
    if (actual.minor < expected.minor) return false;
    return actual.patch >= expected.patch;
};
var $69fa0e3037063634$var$checkReactVersion = function(peerDepValue, actualValue) {
    var peerDep = $69fa0e3037063634$var$getVersion(peerDepValue);
    var actual = $69fa0e3037063634$var$getVersion(actualValue);
    if ($69fa0e3037063634$var$isSatisfied(peerDep, actual)) return;
};
var $69fa0e3037063634$var$suffix = "\n  We expect a html5 doctype: <!doctype html>\n  This is to ensure consistent browser layout and measurement\n\n  More information: https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/guides/doctype.md\n";
var $69fa0e3037063634$var$checkDoctype = function(doc) {
    var doctype = doc.doctype;
    if (!doctype) return;
    doctype.name.toLowerCase();
    doctype.publicId;
};
function $69fa0e3037063634$var$useDev(useHook) {}
function $69fa0e3037063634$var$useDevSetupWarning(fn, inputs) {
    $69fa0e3037063634$var$useDev(function() {
        (0, $eUqFw.useEffect)(function() {
            try {
                fn();
            } catch (e) {
                $69fa0e3037063634$var$error("\n          A setup problem was encountered.\n\n          > " + e.message + "\n        ");
            }
        }, inputs);
    });
}
function $69fa0e3037063634$var$useStartupValidation() {
    $69fa0e3037063634$var$useDevSetupWarning(function() {
        $69fa0e3037063634$var$checkReactVersion($69fa0e3037063634$var$peerDependencies.react, (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).version);
        $69fa0e3037063634$var$checkDoctype(document);
    }, []);
}
function $69fa0e3037063634$var$usePrevious(current) {
    var ref = (0, $eUqFw.useRef)(current);
    (0, $eUqFw.useEffect)(function() {
        ref.current = current;
    });
    return ref;
}
function $69fa0e3037063634$var$create() {
    var lock = null;
    function isClaimed() {
        return Boolean(lock);
    }
    function isActive(value) {
        return value === lock;
    }
    function claim(abandon) {
        !!lock && $69fa0e3037063634$var$invariant(false);
        var newLock = {
            abandon: abandon
        };
        lock = newLock;
        return newLock;
    }
    function release() {
        !lock && $69fa0e3037063634$var$invariant(false);
        lock = null;
    }
    function tryAbandon() {
        if (lock) {
            lock.abandon();
            release();
        }
    }
    return {
        isClaimed: isClaimed,
        isActive: isActive,
        claim: claim,
        release: release,
        tryAbandon: tryAbandon
    };
}
var $69fa0e3037063634$var$tab = 9;
var $69fa0e3037063634$var$enter = 13;
var $69fa0e3037063634$var$escape = 27;
var $69fa0e3037063634$var$space = 32;
var $69fa0e3037063634$var$pageUp = 33;
var $69fa0e3037063634$var$pageDown = 34;
var $69fa0e3037063634$var$end = 35;
var $69fa0e3037063634$var$home = 36;
var $69fa0e3037063634$var$arrowLeft = 37;
var $69fa0e3037063634$var$arrowUp = 38;
var $69fa0e3037063634$var$arrowRight = 39;
var $69fa0e3037063634$var$arrowDown = 40;
var $69fa0e3037063634$var$_preventedKeys;
var $69fa0e3037063634$var$preventedKeys = ($69fa0e3037063634$var$_preventedKeys = {}, $69fa0e3037063634$var$_preventedKeys[$69fa0e3037063634$var$enter] = true, $69fa0e3037063634$var$_preventedKeys[$69fa0e3037063634$var$tab] = true, $69fa0e3037063634$var$_preventedKeys);
var $69fa0e3037063634$var$preventStandardKeyEvents = function(event) {
    if ($69fa0e3037063634$var$preventedKeys[event.keyCode]) event.preventDefault();
};
var $69fa0e3037063634$var$supportedEventName = function() {
    var base = 'visibilitychange';
    if (typeof document === 'undefined') return base;
    var candidates = [
        base,
        "ms" + base,
        "webkit" + base,
        "moz" + base,
        "o" + base
    ];
    var supported = $69fa0e3037063634$var$find(candidates, function(eventName) {
        return "on" + eventName in document;
    });
    return supported || base;
}();
var $69fa0e3037063634$var$primaryButton = 0;
var $69fa0e3037063634$var$sloppyClickThreshold = 5;
function $69fa0e3037063634$var$isSloppyClickThresholdExceeded(original, current) {
    return Math.abs(current.x - original.x) >= $69fa0e3037063634$var$sloppyClickThreshold || Math.abs(current.y - original.y) >= $69fa0e3037063634$var$sloppyClickThreshold;
}
var $69fa0e3037063634$var$idle$1 = {
    type: 'IDLE'
};
function $69fa0e3037063634$var$getCaptureBindings(_ref) {
    var cancel = _ref.cancel, completed = _ref.completed, getPhase = _ref.getPhase, setPhase = _ref.setPhase;
    return [
        {
            eventName: 'mousemove',
            fn: function fn(event) {
                var button = event.button, clientX = event.clientX, clientY = event.clientY;
                if (button !== $69fa0e3037063634$var$primaryButton) return;
                var point = {
                    x: clientX,
                    y: clientY
                };
                var phase = getPhase();
                if (phase.type === 'DRAGGING') {
                    event.preventDefault();
                    phase.actions.move(point);
                    return;
                }
                !(phase.type === 'PENDING') && $69fa0e3037063634$var$invariant(false);
                var pending = phase.point;
                if (!$69fa0e3037063634$var$isSloppyClickThresholdExceeded(pending, point)) return;
                event.preventDefault();
                var actions = phase.actions.fluidLift(point);
                setPhase({
                    type: 'DRAGGING',
                    actions: actions
                });
            }
        },
        {
            eventName: 'mouseup',
            fn: function fn(event) {
                var phase = getPhase();
                if (phase.type !== 'DRAGGING') {
                    cancel();
                    return;
                }
                event.preventDefault();
                phase.actions.drop({
                    shouldBlockNextClick: true
                });
                completed();
            }
        },
        {
            eventName: 'mousedown',
            fn: function fn(event) {
                if (getPhase().type === 'DRAGGING') event.preventDefault();
                cancel();
            }
        },
        {
            eventName: 'keydown',
            fn: function fn(event) {
                var phase = getPhase();
                if (phase.type === 'PENDING') {
                    cancel();
                    return;
                }
                if (event.keyCode === $69fa0e3037063634$var$escape) {
                    event.preventDefault();
                    cancel();
                    return;
                }
                $69fa0e3037063634$var$preventStandardKeyEvents(event);
            }
        },
        {
            eventName: 'resize',
            fn: cancel
        },
        {
            eventName: 'scroll',
            options: {
                passive: true,
                capture: false
            },
            fn: function fn() {
                if (getPhase().type === 'PENDING') cancel();
            }
        },
        {
            eventName: 'webkitmouseforcedown',
            fn: function fn(event) {
                var phase = getPhase();
                !(phase.type !== 'IDLE') && $69fa0e3037063634$var$invariant(false);
                if (phase.actions.shouldRespectForcePress()) {
                    cancel();
                    return;
                }
                event.preventDefault();
            }
        },
        {
            eventName: $69fa0e3037063634$var$supportedEventName,
            fn: cancel
        }
    ];
}
function $69fa0e3037063634$var$useMouseSensor(api) {
    var phaseRef = (0, $eUqFw.useRef)($69fa0e3037063634$var$idle$1);
    var unbindEventsRef = (0, $eUqFw.useRef)($69fa0e3037063634$var$noop);
    var startCaptureBinding = (0, $fzXll.useMemo)(function() {
        return {
            eventName: 'mousedown',
            fn: function onMouseDown(event) {
                if (event.defaultPrevented) return;
                if (event.button !== $69fa0e3037063634$var$primaryButton) return;
                if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
                var draggableId = api.findClosestDraggableId(event);
                if (!draggableId) return;
                var actions = api.tryGetLock(draggableId, stop, {
                    sourceEvent: event
                });
                if (!actions) return;
                event.preventDefault();
                var point = {
                    x: event.clientX,
                    y: event.clientY
                };
                unbindEventsRef.current();
                startPendingDrag(actions, point);
            }
        };
    }, [
        api
    ]);
    var preventForcePressBinding = (0, $fzXll.useMemo)(function() {
        return {
            eventName: 'webkitmouseforcewillbegin',
            fn: function fn(event) {
                if (event.defaultPrevented) return;
                var id = api.findClosestDraggableId(event);
                if (!id) return;
                var options = api.findOptionsForDraggable(id);
                if (!options) return;
                if (options.shouldRespectForcePress) return;
                if (!api.canGetLock(id)) return;
                event.preventDefault();
            }
        };
    }, [
        api
    ]);
    var listenForCapture = (0, $fzXll.useCallback)(function listenForCapture() {
        var options = {
            passive: false,
            capture: true
        };
        unbindEventsRef.current = $69fa0e3037063634$var$bindEvents(window, [
            preventForcePressBinding,
            startCaptureBinding
        ], options);
    }, [
        preventForcePressBinding,
        startCaptureBinding
    ]);
    var stop = (0, $fzXll.useCallback)(function() {
        var current = phaseRef.current;
        if (current.type === 'IDLE') return;
        phaseRef.current = $69fa0e3037063634$var$idle$1;
        unbindEventsRef.current();
        listenForCapture();
    }, [
        listenForCapture
    ]);
    var cancel = (0, $fzXll.useCallback)(function() {
        var phase = phaseRef.current;
        stop();
        if (phase.type === 'DRAGGING') phase.actions.cancel({
            shouldBlockNextClick: true
        });
        if (phase.type === 'PENDING') phase.actions.abort();
    }, [
        stop
    ]);
    var bindCapturingEvents = (0, $fzXll.useCallback)(function bindCapturingEvents() {
        var options = {
            capture: true,
            passive: false
        };
        var bindings = $69fa0e3037063634$var$getCaptureBindings({
            cancel: cancel,
            completed: stop,
            getPhase: function getPhase() {
                return phaseRef.current;
            },
            setPhase: function setPhase(phase) {
                phaseRef.current = phase;
            }
        });
        unbindEventsRef.current = $69fa0e3037063634$var$bindEvents(window, bindings, options);
    }, [
        cancel,
        stop
    ]);
    var startPendingDrag = (0, $fzXll.useCallback)(function startPendingDrag(actions, point) {
        !(phaseRef.current.type === 'IDLE') && $69fa0e3037063634$var$invariant(false);
        phaseRef.current = {
            type: 'PENDING',
            point: point,
            actions: actions
        };
        bindCapturingEvents();
    }, [
        bindCapturingEvents
    ]);
    $69fa0e3037063634$var$useIsomorphicLayoutEffect(function mount() {
        listenForCapture();
        return function unmount() {
            unbindEventsRef.current();
        };
    }, [
        listenForCapture
    ]);
}
var $69fa0e3037063634$var$_scrollJumpKeys;
function $69fa0e3037063634$var$noop$1() {}
var $69fa0e3037063634$var$scrollJumpKeys = ($69fa0e3037063634$var$_scrollJumpKeys = {}, $69fa0e3037063634$var$_scrollJumpKeys[$69fa0e3037063634$var$pageDown] = true, $69fa0e3037063634$var$_scrollJumpKeys[$69fa0e3037063634$var$pageUp] = true, $69fa0e3037063634$var$_scrollJumpKeys[$69fa0e3037063634$var$home] = true, $69fa0e3037063634$var$_scrollJumpKeys[$69fa0e3037063634$var$end] = true, $69fa0e3037063634$var$_scrollJumpKeys);
function $69fa0e3037063634$var$getDraggingBindings(actions, stop) {
    function cancel() {
        stop();
        actions.cancel();
    }
    function drop() {
        stop();
        actions.drop();
    }
    return [
        {
            eventName: 'keydown',
            fn: function fn(event) {
                if (event.keyCode === $69fa0e3037063634$var$escape) {
                    event.preventDefault();
                    cancel();
                    return;
                }
                if (event.keyCode === $69fa0e3037063634$var$space) {
                    event.preventDefault();
                    drop();
                    return;
                }
                if (event.keyCode === $69fa0e3037063634$var$arrowDown) {
                    event.preventDefault();
                    actions.moveDown();
                    return;
                }
                if (event.keyCode === $69fa0e3037063634$var$arrowUp) {
                    event.preventDefault();
                    actions.moveUp();
                    return;
                }
                if (event.keyCode === $69fa0e3037063634$var$arrowRight) {
                    event.preventDefault();
                    actions.moveRight();
                    return;
                }
                if (event.keyCode === $69fa0e3037063634$var$arrowLeft) {
                    event.preventDefault();
                    actions.moveLeft();
                    return;
                }
                if ($69fa0e3037063634$var$scrollJumpKeys[event.keyCode]) {
                    event.preventDefault();
                    return;
                }
                $69fa0e3037063634$var$preventStandardKeyEvents(event);
            }
        },
        {
            eventName: 'mousedown',
            fn: cancel
        },
        {
            eventName: 'mouseup',
            fn: cancel
        },
        {
            eventName: 'click',
            fn: cancel
        },
        {
            eventName: 'touchstart',
            fn: cancel
        },
        {
            eventName: 'resize',
            fn: cancel
        },
        {
            eventName: 'wheel',
            fn: cancel,
            options: {
                passive: true
            }
        },
        {
            eventName: $69fa0e3037063634$var$supportedEventName,
            fn: cancel
        }
    ];
}
function $69fa0e3037063634$var$useKeyboardSensor(api) {
    var unbindEventsRef = (0, $eUqFw.useRef)($69fa0e3037063634$var$noop$1);
    var startCaptureBinding = (0, $fzXll.useMemo)(function() {
        return {
            eventName: 'keydown',
            fn: function onKeyDown(event) {
                if (event.defaultPrevented) return;
                if (event.keyCode !== $69fa0e3037063634$var$space) return;
                var draggableId = api.findClosestDraggableId(event);
                if (!draggableId) return;
                var preDrag = api.tryGetLock(draggableId, stop, {
                    sourceEvent: event
                });
                if (!preDrag) return;
                event.preventDefault();
                var isCapturing = true;
                var actions = preDrag.snapLift();
                unbindEventsRef.current();
                function stop() {
                    !isCapturing && $69fa0e3037063634$var$invariant(false);
                    isCapturing = false;
                    unbindEventsRef.current();
                    listenForCapture();
                }
                unbindEventsRef.current = $69fa0e3037063634$var$bindEvents(window, $69fa0e3037063634$var$getDraggingBindings(actions, stop), {
                    capture: true,
                    passive: false
                });
            }
        };
    }, [
        api
    ]);
    var listenForCapture = (0, $fzXll.useCallback)(function tryStartCapture() {
        var options = {
            passive: false,
            capture: true
        };
        unbindEventsRef.current = $69fa0e3037063634$var$bindEvents(window, [
            startCaptureBinding
        ], options);
    }, [
        startCaptureBinding
    ]);
    $69fa0e3037063634$var$useIsomorphicLayoutEffect(function mount() {
        listenForCapture();
        return function unmount() {
            unbindEventsRef.current();
        };
    }, [
        listenForCapture
    ]);
}
var $69fa0e3037063634$var$idle$2 = {
    type: 'IDLE'
};
var $69fa0e3037063634$var$timeForLongPress = 120;
var $69fa0e3037063634$var$forcePressThreshold = 0.15;
function $69fa0e3037063634$var$getWindowBindings(_ref) {
    var cancel = _ref.cancel, getPhase = _ref.getPhase;
    return [
        {
            eventName: 'orientationchange',
            fn: cancel
        },
        {
            eventName: 'resize',
            fn: cancel
        },
        {
            eventName: 'contextmenu',
            fn: function fn(event) {
                event.preventDefault();
            }
        },
        {
            eventName: 'keydown',
            fn: function fn(event) {
                if (getPhase().type !== 'DRAGGING') {
                    cancel();
                    return;
                }
                if (event.keyCode === $69fa0e3037063634$var$escape) event.preventDefault();
                cancel();
            }
        },
        {
            eventName: $69fa0e3037063634$var$supportedEventName,
            fn: cancel
        }
    ];
}
function $69fa0e3037063634$var$getHandleBindings(_ref2) {
    var cancel = _ref2.cancel, completed = _ref2.completed, getPhase = _ref2.getPhase;
    return [
        {
            eventName: 'touchmove',
            options: {
                capture: false
            },
            fn: function fn(event) {
                var phase = getPhase();
                if (phase.type !== 'DRAGGING') {
                    cancel();
                    return;
                }
                phase.hasMoved = true;
                var _event$touches$ = event.touches[0], clientX = _event$touches$.clientX, clientY = _event$touches$.clientY;
                var point = {
                    x: clientX,
                    y: clientY
                };
                event.preventDefault();
                phase.actions.move(point);
            }
        },
        {
            eventName: 'touchend',
            fn: function fn(event) {
                var phase = getPhase();
                if (phase.type !== 'DRAGGING') {
                    cancel();
                    return;
                }
                event.preventDefault();
                phase.actions.drop({
                    shouldBlockNextClick: true
                });
                completed();
            }
        },
        {
            eventName: 'touchcancel',
            fn: function fn(event) {
                if (getPhase().type !== 'DRAGGING') {
                    cancel();
                    return;
                }
                event.preventDefault();
                cancel();
            }
        },
        {
            eventName: 'touchforcechange',
            fn: function fn(event) {
                var phase = getPhase();
                !(phase.type !== 'IDLE') && $69fa0e3037063634$var$invariant(false);
                var touch = event.touches[0];
                if (!touch) return;
                var isForcePress = touch.force >= $69fa0e3037063634$var$forcePressThreshold;
                if (!isForcePress) return;
                var shouldRespect = phase.actions.shouldRespectForcePress();
                if (phase.type === 'PENDING') {
                    if (shouldRespect) cancel();
                    return;
                }
                if (shouldRespect) {
                    if (phase.hasMoved) {
                        event.preventDefault();
                        return;
                    }
                    cancel();
                    return;
                }
                event.preventDefault();
            }
        },
        {
            eventName: $69fa0e3037063634$var$supportedEventName,
            fn: cancel
        }
    ];
}
function $69fa0e3037063634$var$useMouseSensor$1(api) {
    var phaseRef = (0, $eUqFw.useRef)($69fa0e3037063634$var$idle$2);
    var unbindEventsRef = (0, $eUqFw.useRef)($69fa0e3037063634$var$noop);
    var getPhase = (0, $fzXll.useCallback)(function getPhase() {
        return phaseRef.current;
    }, []);
    var setPhase = (0, $fzXll.useCallback)(function setPhase(phase) {
        phaseRef.current = phase;
    }, []);
    var startCaptureBinding = (0, $fzXll.useMemo)(function() {
        return {
            eventName: 'touchstart',
            fn: function onTouchStart(event) {
                if (event.defaultPrevented) return;
                var draggableId = api.findClosestDraggableId(event);
                if (!draggableId) return;
                var actions = api.tryGetLock(draggableId, stop, {
                    sourceEvent: event
                });
                if (!actions) return;
                var touch = event.touches[0];
                var clientX = touch.clientX, clientY = touch.clientY;
                var point = {
                    x: clientX,
                    y: clientY
                };
                unbindEventsRef.current();
                startPendingDrag(actions, point);
            }
        };
    }, [
        api
    ]);
    var listenForCapture = (0, $fzXll.useCallback)(function listenForCapture() {
        var options = {
            capture: true,
            passive: false
        };
        unbindEventsRef.current = $69fa0e3037063634$var$bindEvents(window, [
            startCaptureBinding
        ], options);
    }, [
        startCaptureBinding
    ]);
    var stop = (0, $fzXll.useCallback)(function() {
        var current = phaseRef.current;
        if (current.type === 'IDLE') return;
        if (current.type === 'PENDING') clearTimeout(current.longPressTimerId);
        setPhase($69fa0e3037063634$var$idle$2);
        unbindEventsRef.current();
        listenForCapture();
    }, [
        listenForCapture,
        setPhase
    ]);
    var cancel = (0, $fzXll.useCallback)(function() {
        var phase = phaseRef.current;
        stop();
        if (phase.type === 'DRAGGING') phase.actions.cancel({
            shouldBlockNextClick: true
        });
        if (phase.type === 'PENDING') phase.actions.abort();
    }, [
        stop
    ]);
    var bindCapturingEvents = (0, $fzXll.useCallback)(function bindCapturingEvents() {
        var options = {
            capture: true,
            passive: false
        };
        var args = {
            cancel: cancel,
            completed: stop,
            getPhase: getPhase
        };
        var unbindTarget = $69fa0e3037063634$var$bindEvents(window, $69fa0e3037063634$var$getHandleBindings(args), options);
        var unbindWindow = $69fa0e3037063634$var$bindEvents(window, $69fa0e3037063634$var$getWindowBindings(args), options);
        unbindEventsRef.current = function unbindAll() {
            unbindTarget();
            unbindWindow();
        };
    }, [
        cancel,
        getPhase,
        stop
    ]);
    var startDragging = (0, $fzXll.useCallback)(function startDragging() {
        var phase = getPhase();
        !(phase.type === 'PENDING') && $69fa0e3037063634$var$invariant(false);
        var actions = phase.actions.fluidLift(phase.point);
        setPhase({
            type: 'DRAGGING',
            actions: actions,
            hasMoved: false
        });
    }, [
        getPhase,
        setPhase
    ]);
    var startPendingDrag = (0, $fzXll.useCallback)(function startPendingDrag(actions, point) {
        !(getPhase().type === 'IDLE') && $69fa0e3037063634$var$invariant(false);
        var longPressTimerId = setTimeout(startDragging, $69fa0e3037063634$var$timeForLongPress);
        setPhase({
            type: 'PENDING',
            point: point,
            actions: actions,
            longPressTimerId: longPressTimerId
        });
        bindCapturingEvents();
    }, [
        bindCapturingEvents,
        getPhase,
        setPhase,
        startDragging
    ]);
    $69fa0e3037063634$var$useIsomorphicLayoutEffect(function mount() {
        listenForCapture();
        return function unmount() {
            unbindEventsRef.current();
            var phase = getPhase();
            if (phase.type === 'PENDING') {
                clearTimeout(phase.longPressTimerId);
                setPhase($69fa0e3037063634$var$idle$2);
            }
        };
    }, [
        getPhase,
        listenForCapture,
        setPhase
    ]);
    $69fa0e3037063634$var$useIsomorphicLayoutEffect(function webkitHack() {
        var unbind = $69fa0e3037063634$var$bindEvents(window, [
            {
                eventName: 'touchmove',
                fn: function fn() {},
                options: {
                    capture: false,
                    passive: false
                }
            }
        ]);
        return unbind;
    }, []);
}
function $69fa0e3037063634$var$useValidateSensorHooks(sensorHooks) {
    $69fa0e3037063634$var$useDev(function() {
        var previousRef = $69fa0e3037063634$var$usePrevious(sensorHooks);
        $69fa0e3037063634$var$useDevSetupWarning(function() {
            !(previousRef.current.length === sensorHooks.length) && $69fa0e3037063634$var$invariant(false);
        });
    });
}
var $69fa0e3037063634$var$interactiveTagNames = {
    input: true,
    button: true,
    textarea: true,
    select: true,
    option: true,
    optgroup: true,
    video: true,
    audio: true
};
function $69fa0e3037063634$var$isAnInteractiveElement(parent, current) {
    if (current == null) return false;
    var hasAnInteractiveTag = Boolean($69fa0e3037063634$var$interactiveTagNames[current.tagName.toLowerCase()]);
    if (hasAnInteractiveTag) return true;
    var attribute = current.getAttribute('contenteditable');
    if (attribute === 'true' || attribute === '') return true;
    if (current === parent) return false;
    return $69fa0e3037063634$var$isAnInteractiveElement(parent, current.parentElement);
}
function $69fa0e3037063634$var$isEventInInteractiveElement(draggable, event) {
    var target = event.target;
    if (!$69fa0e3037063634$var$isHtmlElement(target)) return false;
    return $69fa0e3037063634$var$isAnInteractiveElement(draggable, target);
}
var $69fa0e3037063634$var$getBorderBoxCenterPosition = function(el) {
    return (0, $bn5nT.getRect)(el.getBoundingClientRect()).center;
};
function $69fa0e3037063634$var$isElement(el) {
    return el instanceof $69fa0e3037063634$var$getWindowFromEl(el).Element;
}
var $69fa0e3037063634$var$supportedMatchesName = function() {
    var base = 'matches';
    if (typeof document === 'undefined') return base;
    var candidates = [
        base,
        'msMatchesSelector',
        'webkitMatchesSelector'
    ];
    var value = $69fa0e3037063634$var$find(candidates, function(name) {
        return name in Element.prototype;
    });
    return value || base;
}();
function $69fa0e3037063634$var$closestPonyfill(el, selector) {
    if (el == null) return null;
    if (el[$69fa0e3037063634$var$supportedMatchesName](selector)) return el;
    return $69fa0e3037063634$var$closestPonyfill(el.parentElement, selector);
}
function $69fa0e3037063634$var$closest$1(el, selector) {
    if (el.closest) return el.closest(selector);
    return $69fa0e3037063634$var$closestPonyfill(el, selector);
}
function $69fa0e3037063634$var$getSelector(contextId) {
    return "[" + $69fa0e3037063634$var$dragHandle.contextId + "=\"" + contextId + "\"]";
}
function $69fa0e3037063634$var$findClosestDragHandleFromEvent(contextId, event) {
    var target = event.target;
    if (!$69fa0e3037063634$var$isElement(target)) return null;
    var selector = $69fa0e3037063634$var$getSelector(contextId);
    var handle = $69fa0e3037063634$var$closest$1(target, selector);
    if (!handle) return null;
    if (!$69fa0e3037063634$var$isHtmlElement(handle)) return null;
    return handle;
}
function $69fa0e3037063634$var$tryGetClosestDraggableIdFromEvent(contextId, event) {
    var handle = $69fa0e3037063634$var$findClosestDragHandleFromEvent(contextId, event);
    if (!handle) return null;
    return handle.getAttribute($69fa0e3037063634$var$dragHandle.draggableId);
}
function $69fa0e3037063634$var$findDraggable(contextId, draggableId) {
    var selector = "[" + $69fa0e3037063634$var$draggable.contextId + "=\"" + contextId + "\"]";
    var possible = $69fa0e3037063634$var$toArray(document.querySelectorAll(selector));
    var draggable$1 = $69fa0e3037063634$var$find(possible, function(el) {
        return el.getAttribute($69fa0e3037063634$var$draggable.id) === draggableId;
    });
    if (!draggable$1) return null;
    if (!$69fa0e3037063634$var$isHtmlElement(draggable$1)) return null;
    return draggable$1;
}
function $69fa0e3037063634$var$preventDefault(event) {
    event.preventDefault();
}
function $69fa0e3037063634$var$_isActive(_ref) {
    var expected = _ref.expected, phase = _ref.phase, isLockActive = _ref.isLockActive, shouldWarn = _ref.shouldWarn;
    if (!isLockActive()) {
        shouldWarn;
        return false;
    }
    if (expected !== phase) {
        shouldWarn;
        return false;
    }
    return true;
}
function $69fa0e3037063634$var$canStart(_ref2) {
    var lockAPI = _ref2.lockAPI, store = _ref2.store, registry = _ref2.registry, draggableId = _ref2.draggableId;
    if (lockAPI.isClaimed()) return false;
    var entry = registry.draggable.findById(draggableId);
    if (!entry) return false;
    if (!entry.options.isEnabled) return false;
    if (!$69fa0e3037063634$var$canStartDrag(store.getState(), draggableId)) return false;
    return true;
}
function $69fa0e3037063634$var$tryStart(_ref3) {
    var lockAPI = _ref3.lockAPI, contextId = _ref3.contextId, store = _ref3.store, registry = _ref3.registry, draggableId = _ref3.draggableId, forceSensorStop = _ref3.forceSensorStop, sourceEvent = _ref3.sourceEvent;
    var shouldStart = $69fa0e3037063634$var$canStart({
        lockAPI: lockAPI,
        store: store,
        registry: registry,
        draggableId: draggableId
    });
    if (!shouldStart) return null;
    var entry = registry.draggable.getById(draggableId);
    var el = $69fa0e3037063634$var$findDraggable(contextId, entry.descriptor.id);
    if (!el) return null;
    if (sourceEvent && !entry.options.canDragInteractiveElements && $69fa0e3037063634$var$isEventInInteractiveElement(el, sourceEvent)) return null;
    var lock = lockAPI.claim(forceSensorStop || $69fa0e3037063634$var$noop);
    var phase = 'PRE_DRAG';
    function getShouldRespectForcePress() {
        return entry.options.shouldRespectForcePress;
    }
    function isLockActive() {
        return lockAPI.isActive(lock);
    }
    function tryDispatch(expected, getAction) {
        if ($69fa0e3037063634$var$_isActive({
            expected: expected,
            phase: phase,
            isLockActive: isLockActive,
            shouldWarn: true
        })) store.dispatch(getAction());
    }
    var tryDispatchWhenDragging = tryDispatch.bind(this, 'DRAGGING');
    function lift$1(args) {
        function completed() {
            lockAPI.release();
            phase = 'COMPLETED';
        }
        if (phase !== 'PRE_DRAG') {
            completed();
            !(phase === 'PRE_DRAG') && $69fa0e3037063634$var$invariant(false);
        }
        store.dispatch($69fa0e3037063634$var$lift(args.liftActionArgs));
        phase = 'DRAGGING';
        function finish(reason, options) {
            if (options === void 0) options = {
                shouldBlockNextClick: false
            };
            args.cleanup();
            if (options.shouldBlockNextClick) {
                var unbind = $69fa0e3037063634$var$bindEvents(window, [
                    {
                        eventName: 'click',
                        fn: $69fa0e3037063634$var$preventDefault,
                        options: {
                            once: true,
                            passive: false,
                            capture: true
                        }
                    }
                ]);
                setTimeout(unbind);
            }
            completed();
            store.dispatch($69fa0e3037063634$var$drop({
                reason: reason
            }));
        }
        return (0, $34lu7.default)({
            isActive: function isActive() {
                return $69fa0e3037063634$var$_isActive({
                    expected: 'DRAGGING',
                    phase: phase,
                    isLockActive: isLockActive,
                    shouldWarn: false
                });
            },
            shouldRespectForcePress: getShouldRespectForcePress,
            drop: function drop(options) {
                return finish('DROP', options);
            },
            cancel: function cancel(options) {
                return finish('CANCEL', options);
            }
        }, args.actions);
    }
    function fluidLift(clientSelection) {
        var move$1 = (0, $gxvYj.default)(function(client) {
            tryDispatchWhenDragging(function() {
                return $69fa0e3037063634$var$move({
                    client: client
                });
            });
        });
        var api = lift$1({
            liftActionArgs: {
                id: draggableId,
                clientSelection: clientSelection,
                movementMode: 'FLUID'
            },
            cleanup: function cleanup() {
                return move$1.cancel();
            },
            actions: {
                move: move$1
            }
        });
        return (0, $34lu7.default)({}, api, {
            move: move$1
        });
    }
    function snapLift() {
        var actions = {
            moveUp: function moveUp$1() {
                return tryDispatchWhenDragging($69fa0e3037063634$var$moveUp);
            },
            moveRight: function moveRight$1() {
                return tryDispatchWhenDragging($69fa0e3037063634$var$moveRight);
            },
            moveDown: function moveDown$1() {
                return tryDispatchWhenDragging($69fa0e3037063634$var$moveDown);
            },
            moveLeft: function moveLeft$1() {
                return tryDispatchWhenDragging($69fa0e3037063634$var$moveLeft);
            }
        };
        return lift$1({
            liftActionArgs: {
                id: draggableId,
                clientSelection: $69fa0e3037063634$var$getBorderBoxCenterPosition(el),
                movementMode: 'SNAP'
            },
            cleanup: $69fa0e3037063634$var$noop,
            actions: actions
        });
    }
    function abortPreDrag() {
        var shouldRelease = $69fa0e3037063634$var$_isActive({
            expected: 'PRE_DRAG',
            phase: phase,
            isLockActive: isLockActive,
            shouldWarn: true
        });
        if (shouldRelease) lockAPI.release();
    }
    var preDrag = {
        isActive: function isActive() {
            return $69fa0e3037063634$var$_isActive({
                expected: 'PRE_DRAG',
                phase: phase,
                isLockActive: isLockActive,
                shouldWarn: false
            });
        },
        shouldRespectForcePress: getShouldRespectForcePress,
        fluidLift: fluidLift,
        snapLift: snapLift,
        abort: abortPreDrag
    };
    return preDrag;
}
var $69fa0e3037063634$var$defaultSensors = [
    $69fa0e3037063634$var$useMouseSensor,
    $69fa0e3037063634$var$useKeyboardSensor,
    $69fa0e3037063634$var$useMouseSensor$1
];
function $69fa0e3037063634$var$useSensorMarshal(_ref4) {
    var contextId = _ref4.contextId, store = _ref4.store, registry = _ref4.registry, customSensors = _ref4.customSensors, enableDefaultSensors = _ref4.enableDefaultSensors;
    var useSensors = [].concat(enableDefaultSensors ? $69fa0e3037063634$var$defaultSensors : [], customSensors || []);
    var lockAPI = (0, $eUqFw.useState)(function() {
        return $69fa0e3037063634$var$create();
    })[0];
    var tryAbandonLock = (0, $fzXll.useCallback)(function tryAbandonLock(previous, current) {
        if (previous.isDragging && !current.isDragging) lockAPI.tryAbandon();
    }, [
        lockAPI
    ]);
    $69fa0e3037063634$var$useIsomorphicLayoutEffect(function listenToStore() {
        var previous = store.getState();
        var unsubscribe = store.subscribe(function() {
            var current = store.getState();
            tryAbandonLock(previous, current);
            previous = current;
        });
        return unsubscribe;
    }, [
        lockAPI,
        store,
        tryAbandonLock
    ]);
    $69fa0e3037063634$var$useIsomorphicLayoutEffect(function() {
        return lockAPI.tryAbandon;
    }, [
        lockAPI.tryAbandon
    ]);
    var canGetLock = (0, $fzXll.useCallback)(function(draggableId) {
        return $69fa0e3037063634$var$canStart({
            lockAPI: lockAPI,
            registry: registry,
            store: store,
            draggableId: draggableId
        });
    }, [
        lockAPI,
        registry,
        store
    ]);
    var tryGetLock = (0, $fzXll.useCallback)(function(draggableId, forceStop, options) {
        return $69fa0e3037063634$var$tryStart({
            lockAPI: lockAPI,
            registry: registry,
            contextId: contextId,
            store: store,
            draggableId: draggableId,
            forceSensorStop: forceStop,
            sourceEvent: options && options.sourceEvent ? options.sourceEvent : null
        });
    }, [
        contextId,
        lockAPI,
        registry,
        store
    ]);
    var findClosestDraggableId = (0, $fzXll.useCallback)(function(event) {
        return $69fa0e3037063634$var$tryGetClosestDraggableIdFromEvent(contextId, event);
    }, [
        contextId
    ]);
    var findOptionsForDraggable = (0, $fzXll.useCallback)(function(id) {
        var entry = registry.draggable.findById(id);
        return entry ? entry.options : null;
    }, [
        registry.draggable
    ]);
    var tryReleaseLock = (0, $fzXll.useCallback)(lockAPI.tryAbandon, [
        lockAPI
    ]);
    var isLockClaimed = (0, $fzXll.useCallback)(lockAPI.isClaimed, [
        lockAPI
    ]);
    var api = (0, $fzXll.useMemo)(function() {
        return {
            canGetLock: canGetLock,
            tryGetLock: tryGetLock,
            findClosestDraggableId: findClosestDraggableId,
            findOptionsForDraggable: findOptionsForDraggable,
            tryReleaseLock: tryReleaseLock,
            isLockClaimed: isLockClaimed
        };
    }, [
        canGetLock,
        tryGetLock,
        findClosestDraggableId,
        findOptionsForDraggable,
        tryReleaseLock,
        isLockClaimed
    ]);
    $69fa0e3037063634$var$useValidateSensorHooks(useSensors);
    for(var i = 0; i < useSensors.length; i++)useSensors[i](api);
}
var $69fa0e3037063634$var$createResponders = function createResponders(props) {
    return {
        onBeforeCapture: props.onBeforeCapture,
        onBeforeDragStart: props.onBeforeDragStart,
        onDragStart: props.onDragStart,
        onDragEnd: props.onDragEnd,
        onDragUpdate: props.onDragUpdate
    };
};
function $69fa0e3037063634$var$getStore(lazyRef) {
    !lazyRef.current && $69fa0e3037063634$var$invariant(false);
    return lazyRef.current;
}
function $69fa0e3037063634$var$App(props) {
    var contextId = props.contextId, setCallbacks = props.setCallbacks, sensors = props.sensors, nonce = props.nonce, liftInstruction = props.liftInstruction;
    var lazyStoreRef = (0, $eUqFw.useRef)(null);
    $69fa0e3037063634$var$useStartupValidation();
    var lastPropsRef = $69fa0e3037063634$var$usePrevious(props);
    var getResponders = (0, $fzXll.useCallback)(function() {
        return $69fa0e3037063634$var$createResponders(lastPropsRef.current);
    }, [
        lastPropsRef
    ]);
    var announce = $69fa0e3037063634$var$useAnnouncer(contextId);
    var liftInstructionId = $69fa0e3037063634$var$useLiftInstruction(contextId, liftInstruction);
    var styleMarshal = $69fa0e3037063634$var$useStyleMarshal(contextId, nonce);
    var lazyDispatch = (0, $fzXll.useCallback)(function(action) {
        $69fa0e3037063634$var$getStore(lazyStoreRef).dispatch(action);
    }, []);
    var marshalCallbacks = (0, $fzXll.useMemo)(function() {
        return (0, $4QJdp.bindActionCreators)({
            publishWhileDragging: $69fa0e3037063634$var$publishWhileDragging,
            updateDroppableScroll: $69fa0e3037063634$var$updateDroppableScroll,
            updateDroppableIsEnabled: $69fa0e3037063634$var$updateDroppableIsEnabled,
            updateDroppableIsCombineEnabled: $69fa0e3037063634$var$updateDroppableIsCombineEnabled,
            collectionStarting: $69fa0e3037063634$var$collectionStarting
        }, lazyDispatch);
    }, [
        lazyDispatch
    ]);
    var registry = $69fa0e3037063634$var$useRegistry();
    var dimensionMarshal = (0, $fzXll.useMemo)(function() {
        return $69fa0e3037063634$var$createDimensionMarshal(registry, marshalCallbacks);
    }, [
        registry,
        marshalCallbacks
    ]);
    var autoScroller = (0, $fzXll.useMemo)(function() {
        return $69fa0e3037063634$var$createAutoScroller((0, $34lu7.default)({
            scrollWindow: $69fa0e3037063634$var$scrollWindow,
            scrollDroppable: dimensionMarshal.scrollDroppable
        }, (0, $4QJdp.bindActionCreators)({
            move: $69fa0e3037063634$var$move
        }, lazyDispatch)));
    }, [
        dimensionMarshal.scrollDroppable,
        lazyDispatch
    ]);
    var focusMarshal = $69fa0e3037063634$var$useFocusMarshal(contextId);
    var store = (0, $fzXll.useMemo)(function() {
        return $69fa0e3037063634$var$createStore({
            announce: announce,
            autoScroller: autoScroller,
            dimensionMarshal: dimensionMarshal,
            focusMarshal: focusMarshal,
            getResponders: getResponders,
            styleMarshal: styleMarshal
        });
    }, [
        announce,
        autoScroller,
        dimensionMarshal,
        focusMarshal,
        getResponders,
        styleMarshal
    ]);
    lazyStoreRef.current = store;
    var tryResetStore = (0, $fzXll.useCallback)(function() {
        var current = $69fa0e3037063634$var$getStore(lazyStoreRef);
        var state = current.getState();
        if (state.phase !== 'IDLE') current.dispatch($69fa0e3037063634$var$flush());
    }, []);
    var isDragging = (0, $fzXll.useCallback)(function() {
        var state = $69fa0e3037063634$var$getStore(lazyStoreRef).getState();
        return state.isDragging || state.phase === 'DROP_ANIMATING';
    }, []);
    var appCallbacks = (0, $fzXll.useMemo)(function() {
        return {
            isDragging: isDragging,
            tryAbort: tryResetStore
        };
    }, [
        isDragging,
        tryResetStore
    ]);
    setCallbacks(appCallbacks);
    var getCanLift = (0, $fzXll.useCallback)(function(id) {
        return $69fa0e3037063634$var$canStartDrag($69fa0e3037063634$var$getStore(lazyStoreRef).getState(), id);
    }, []);
    var getIsMovementAllowed = (0, $fzXll.useCallback)(function() {
        return $69fa0e3037063634$var$isMovementAllowed($69fa0e3037063634$var$getStore(lazyStoreRef).getState());
    }, []);
    var appContext = (0, $fzXll.useMemo)(function() {
        return {
            marshal: dimensionMarshal,
            focus: focusMarshal,
            contextId: contextId,
            canLift: getCanLift,
            isMovementAllowed: getIsMovementAllowed,
            liftInstructionId: liftInstructionId,
            registry: registry
        };
    }, [
        contextId,
        dimensionMarshal,
        focusMarshal,
        getCanLift,
        getIsMovementAllowed,
        liftInstructionId,
        registry
    ]);
    $69fa0e3037063634$var$useSensorMarshal({
        contextId: contextId,
        store: store,
        registry: registry,
        customSensors: sensors,
        enableDefaultSensors: props.enableDefaultSensors !== false
    });
    (0, $eUqFw.useEffect)(function() {
        return tryResetStore;
    }, [
        tryResetStore
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($69fa0e3037063634$var$AppContext.Provider, {
        value: appContext
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b02ud.default), {
        context: $69fa0e3037063634$var$StoreContext,
        store: store
    }, props.children));
}
var $69fa0e3037063634$var$instanceCount = 0;
function $69fa0e3037063634$export$2bfe52350fc0150d() {
    $69fa0e3037063634$var$instanceCount = 0;
}
function $69fa0e3037063634$export$237bd83162c14364(props) {
    var contextId = (0, $fzXll.useMemo)(function() {
        return "" + $69fa0e3037063634$var$instanceCount++;
    }, []);
    var liftInstruction = props.liftInstruction || $69fa0e3037063634$var$preset.liftInstruction;
    return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($69fa0e3037063634$var$ErrorBoundary, null, function(setCallbacks) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($69fa0e3037063634$var$App, {
            nonce: props.nonce,
            contextId: contextId,
            setCallbacks: setCallbacks,
            liftInstruction: liftInstruction,
            enableDefaultSensors: props.enableDefaultSensors,
            sensors: props.sensors,
            onBeforeCapture: props.onBeforeCapture,
            onBeforeDragStart: props.onBeforeDragStart,
            onDragStart: props.onDragStart,
            onDragUpdate: props.onDragUpdate,
            onDragEnd: props.onDragEnd
        }, props.children);
    });
}
var $69fa0e3037063634$var$isEqual$1 = function isEqual(base) {
    return function(value) {
        return base === value;
    };
};
var $69fa0e3037063634$var$isScroll = $69fa0e3037063634$var$isEqual$1('scroll');
var $69fa0e3037063634$var$isAuto = $69fa0e3037063634$var$isEqual$1('auto');
var $69fa0e3037063634$var$isVisible$1 = $69fa0e3037063634$var$isEqual$1('visible');
var $69fa0e3037063634$var$isEither = function isEither(overflow, fn) {
    return fn(overflow.overflowX) || fn(overflow.overflowY);
};
var $69fa0e3037063634$var$isBoth = function isBoth(overflow, fn) {
    return fn(overflow.overflowX) && fn(overflow.overflowY);
};
var $69fa0e3037063634$var$isElementScrollable = function isElementScrollable(el) {
    var style = window.getComputedStyle(el);
    var overflow = {
        overflowX: style.overflowX,
        overflowY: style.overflowY
    };
    return $69fa0e3037063634$var$isEither(overflow, $69fa0e3037063634$var$isScroll) || $69fa0e3037063634$var$isEither(overflow, $69fa0e3037063634$var$isAuto);
};
var $69fa0e3037063634$var$isBodyScrollable = function isBodyScrollable() {
    var body, html, htmlStyle, htmlOverflow;
    return false;
};
var $69fa0e3037063634$var$getClosestScrollable = function getClosestScrollable(el) {
    if (el == null) return null;
    if (el === document.body) return $69fa0e3037063634$var$isBodyScrollable() ? el : null;
    if (el === document.documentElement) return null;
    if (!$69fa0e3037063634$var$isElementScrollable(el)) return getClosestScrollable(el.parentElement);
    return el;
};
var $69fa0e3037063634$var$checkForNestedScrollContainers = function(scrollable) {
    if (!scrollable) return;
    var anotherScrollParent = $69fa0e3037063634$var$getClosestScrollable(scrollable.parentElement);
    if (!anotherScrollParent) return;
};
var $69fa0e3037063634$var$getScroll$1 = function(el) {
    return {
        x: el.scrollLeft,
        y: el.scrollTop
    };
};
var $69fa0e3037063634$var$getIsFixed = function getIsFixed(el) {
    if (!el) return false;
    var style = window.getComputedStyle(el);
    if (style.position === 'fixed') return true;
    return getIsFixed(el.parentElement);
};
var $69fa0e3037063634$var$getEnv = function(start) {
    var closestScrollable = $69fa0e3037063634$var$getClosestScrollable(start);
    var isFixedOnPage = $69fa0e3037063634$var$getIsFixed(start);
    return {
        closestScrollable: closestScrollable,
        isFixedOnPage: isFixedOnPage
    };
};
var $69fa0e3037063634$var$getDroppableDimension = function(_ref) {
    var descriptor = _ref.descriptor, isEnabled = _ref.isEnabled, isCombineEnabled = _ref.isCombineEnabled, isFixedOnPage = _ref.isFixedOnPage, direction = _ref.direction, client = _ref.client, page = _ref.page, closest = _ref.closest;
    var frame = function() {
        if (!closest) return null;
        var scrollSize = closest.scrollSize, frameClient = closest.client;
        var maxScroll = $69fa0e3037063634$var$getMaxScroll({
            scrollHeight: scrollSize.scrollHeight,
            scrollWidth: scrollSize.scrollWidth,
            height: frameClient.paddingBox.height,
            width: frameClient.paddingBox.width
        });
        return {
            pageMarginBox: closest.page.marginBox,
            frameClient: frameClient,
            scrollSize: scrollSize,
            shouldClipSubject: closest.shouldClipSubject,
            scroll: {
                initial: closest.scroll,
                current: closest.scroll,
                max: maxScroll,
                diff: {
                    value: $69fa0e3037063634$var$origin,
                    displacement: $69fa0e3037063634$var$origin
                }
            }
        };
    }();
    var axis = direction === 'vertical' ? $69fa0e3037063634$var$vertical : $69fa0e3037063634$var$horizontal;
    var subject = $69fa0e3037063634$var$getSubject({
        page: page,
        withPlaceholder: null,
        axis: axis,
        frame: frame
    });
    var dimension = {
        descriptor: descriptor,
        isCombineEnabled: isCombineEnabled,
        isFixedOnPage: isFixedOnPage,
        axis: axis,
        isEnabled: isEnabled,
        client: client,
        page: page,
        frame: frame,
        subject: subject
    };
    return dimension;
};
var $69fa0e3037063634$var$getClient = function getClient(targetRef, closestScrollable) {
    var base = (0, $bn5nT.getBox)(targetRef);
    if (!closestScrollable) return base;
    if (targetRef !== closestScrollable) return base;
    var top = base.paddingBox.top - closestScrollable.scrollTop;
    var left = base.paddingBox.left - closestScrollable.scrollLeft;
    var bottom = top + closestScrollable.scrollHeight;
    var right = left + closestScrollable.scrollWidth;
    var paddingBox = {
        top: top,
        right: right,
        bottom: bottom,
        left: left
    };
    var borderBox = (0, $bn5nT.expand)(paddingBox, base.border);
    var client = (0, $bn5nT.createBox)({
        borderBox: borderBox,
        margin: base.margin,
        border: base.border,
        padding: base.padding
    });
    return client;
};
var $69fa0e3037063634$var$getDimension = function(_ref) {
    var ref = _ref.ref, descriptor = _ref.descriptor, env = _ref.env, windowScroll = _ref.windowScroll, direction = _ref.direction, isDropDisabled = _ref.isDropDisabled, isCombineEnabled = _ref.isCombineEnabled, shouldClipSubject = _ref.shouldClipSubject;
    var closestScrollable = env.closestScrollable;
    var client = $69fa0e3037063634$var$getClient(ref, closestScrollable);
    var page = (0, $bn5nT.withScroll)(client, windowScroll);
    var closest = function() {
        if (!closestScrollable) return null;
        var frameClient = (0, $bn5nT.getBox)(closestScrollable);
        var scrollSize = {
            scrollHeight: closestScrollable.scrollHeight,
            scrollWidth: closestScrollable.scrollWidth
        };
        return {
            client: frameClient,
            page: (0, $bn5nT.withScroll)(frameClient, windowScroll),
            scroll: $69fa0e3037063634$var$getScroll$1(closestScrollable),
            scrollSize: scrollSize,
            shouldClipSubject: shouldClipSubject
        };
    }();
    var dimension = $69fa0e3037063634$var$getDroppableDimension({
        descriptor: descriptor,
        isEnabled: !isDropDisabled,
        isCombineEnabled: isCombineEnabled,
        isFixedOnPage: env.isFixedOnPage,
        direction: direction,
        client: client,
        page: page,
        closest: closest
    });
    return dimension;
};
var $69fa0e3037063634$var$immediate = {
    passive: false
};
var $69fa0e3037063634$var$delayed = {
    passive: true
};
var $69fa0e3037063634$var$getListenerOptions = function(options) {
    return options.shouldPublishImmediately ? $69fa0e3037063634$var$immediate : $69fa0e3037063634$var$delayed;
};
function $69fa0e3037063634$var$useRequiredContext(Context) {
    var result = (0, $eUqFw.useContext)(Context);
    !result && $69fa0e3037063634$var$invariant(false);
    return result;
}
var $69fa0e3037063634$var$count = 0;
function $69fa0e3037063634$var$useUniqueId(prefix) {
    var countRef = (0, $eUqFw.useRef)($69fa0e3037063634$var$count++);
    return prefix + "::" + countRef.current;
}
var $69fa0e3037063634$var$getClosestScrollableFromDrag = function getClosestScrollableFromDrag(dragging) {
    return dragging && dragging.env.closestScrollable || null;
};
function $69fa0e3037063634$var$useDroppablePublisher(args) {
    var whileDraggingRef = (0, $eUqFw.useRef)(null);
    var appContext = $69fa0e3037063634$var$useRequiredContext($69fa0e3037063634$var$AppContext);
    var uniqueId = $69fa0e3037063634$var$useUniqueId('droppable');
    var registry = appContext.registry, marshal = appContext.marshal;
    var previousRef = $69fa0e3037063634$var$usePrevious(args);
    var descriptor = (0, $fzXll.useMemo)(function() {
        return {
            id: args.droppableId,
            type: args.type,
            mode: args.mode
        };
    }, [
        args.droppableId,
        args.mode,
        args.type
    ]);
    var publishedDescriptorRef = (0, $eUqFw.useRef)(descriptor);
    var memoizedUpdateScroll = (0, $fzXll.useMemo)(function() {
        return (0, $dCUwp.default)(function(x, y) {
            !whileDraggingRef.current && $69fa0e3037063634$var$invariant(false);
            var scroll = {
                x: x,
                y: y
            };
            marshal.updateDroppableScroll(descriptor.id, scroll);
        });
    }, [
        descriptor.id,
        marshal
    ]);
    var getClosestScroll = (0, $fzXll.useCallback)(function() {
        var dragging = whileDraggingRef.current;
        if (!dragging || !dragging.env.closestScrollable) return $69fa0e3037063634$var$origin;
        return $69fa0e3037063634$var$getScroll$1(dragging.env.closestScrollable);
    }, []);
    var updateScroll = (0, $fzXll.useCallback)(function() {
        var scroll = getClosestScroll();
        memoizedUpdateScroll(scroll.x, scroll.y);
    }, [
        getClosestScroll,
        memoizedUpdateScroll
    ]);
    var scheduleScrollUpdate = (0, $fzXll.useMemo)(function() {
        return (0, $gxvYj.default)(updateScroll);
    }, [
        updateScroll
    ]);
    var onClosestScroll = (0, $fzXll.useCallback)(function() {
        var dragging = whileDraggingRef.current;
        var closest = $69fa0e3037063634$var$getClosestScrollableFromDrag(dragging);
        !(dragging && closest) && $69fa0e3037063634$var$invariant(false);
        var options = dragging.scrollOptions;
        if (options.shouldPublishImmediately) {
            updateScroll();
            return;
        }
        scheduleScrollUpdate();
    }, [
        scheduleScrollUpdate,
        updateScroll
    ]);
    var getDimensionAndWatchScroll = (0, $fzXll.useCallback)(function(windowScroll, options) {
        !!whileDraggingRef.current && $69fa0e3037063634$var$invariant(false);
        var previous = previousRef.current;
        var ref = previous.getDroppableRef();
        !ref && $69fa0e3037063634$var$invariant(false);
        var env = $69fa0e3037063634$var$getEnv(ref);
        var dragging = {
            ref: ref,
            descriptor: descriptor,
            env: env,
            scrollOptions: options
        };
        whileDraggingRef.current = dragging;
        var dimension = $69fa0e3037063634$var$getDimension({
            ref: ref,
            descriptor: descriptor,
            env: env,
            windowScroll: windowScroll,
            direction: previous.direction,
            isDropDisabled: previous.isDropDisabled,
            isCombineEnabled: previous.isCombineEnabled,
            shouldClipSubject: !previous.ignoreContainerClipping
        });
        var scrollable = env.closestScrollable;
        if (scrollable) {
            scrollable.setAttribute($69fa0e3037063634$var$scrollContainer.contextId, appContext.contextId);
            scrollable.addEventListener('scroll', onClosestScroll, $69fa0e3037063634$var$getListenerOptions(dragging.scrollOptions));
        }
        return dimension;
    }, [
        appContext.contextId,
        descriptor,
        onClosestScroll,
        previousRef
    ]);
    var getScrollWhileDragging = (0, $fzXll.useCallback)(function() {
        var dragging = whileDraggingRef.current;
        var closest = $69fa0e3037063634$var$getClosestScrollableFromDrag(dragging);
        !(dragging && closest) && $69fa0e3037063634$var$invariant(false);
        return $69fa0e3037063634$var$getScroll$1(closest);
    }, []);
    var dragStopped = (0, $fzXll.useCallback)(function() {
        var dragging = whileDraggingRef.current;
        !dragging && $69fa0e3037063634$var$invariant(false);
        var closest = $69fa0e3037063634$var$getClosestScrollableFromDrag(dragging);
        whileDraggingRef.current = null;
        if (!closest) return;
        scheduleScrollUpdate.cancel();
        closest.removeAttribute($69fa0e3037063634$var$scrollContainer.contextId);
        closest.removeEventListener('scroll', onClosestScroll, $69fa0e3037063634$var$getListenerOptions(dragging.scrollOptions));
    }, [
        onClosestScroll,
        scheduleScrollUpdate
    ]);
    var scroll = (0, $fzXll.useCallback)(function(change) {
        var dragging = whileDraggingRef.current;
        !dragging && $69fa0e3037063634$var$invariant(false);
        var closest = $69fa0e3037063634$var$getClosestScrollableFromDrag(dragging);
        !closest && $69fa0e3037063634$var$invariant(false);
        closest.scrollTop += change.y;
        closest.scrollLeft += change.x;
    }, []);
    var callbacks = (0, $fzXll.useMemo)(function() {
        return {
            getDimensionAndWatchScroll: getDimensionAndWatchScroll,
            getScrollWhileDragging: getScrollWhileDragging,
            dragStopped: dragStopped,
            scroll: scroll
        };
    }, [
        dragStopped,
        getDimensionAndWatchScroll,
        getScrollWhileDragging,
        scroll
    ]);
    var entry = (0, $fzXll.useMemo)(function() {
        return {
            uniqueId: uniqueId,
            descriptor: descriptor,
            callbacks: callbacks
        };
    }, [
        callbacks,
        descriptor,
        uniqueId
    ]);
    $69fa0e3037063634$var$useIsomorphicLayoutEffect(function() {
        publishedDescriptorRef.current = entry.descriptor;
        registry.droppable.register(entry);
        return function() {
            if (whileDraggingRef.current) dragStopped();
            registry.droppable.unregister(entry);
        };
    }, [
        callbacks,
        descriptor,
        dragStopped,
        entry,
        marshal,
        registry.droppable
    ]);
    $69fa0e3037063634$var$useIsomorphicLayoutEffect(function() {
        if (!whileDraggingRef.current) return;
        marshal.updateDroppableIsEnabled(publishedDescriptorRef.current.id, !args.isDropDisabled);
    }, [
        args.isDropDisabled,
        marshal
    ]);
    $69fa0e3037063634$var$useIsomorphicLayoutEffect(function() {
        if (!whileDraggingRef.current) return;
        marshal.updateDroppableIsCombineEnabled(publishedDescriptorRef.current.id, args.isCombineEnabled);
    }, [
        args.isCombineEnabled,
        marshal
    ]);
}
function $69fa0e3037063634$var$noop$2() {}
var $69fa0e3037063634$var$empty = {
    width: 0,
    height: 0,
    margin: $69fa0e3037063634$var$noSpacing
};
var $69fa0e3037063634$var$getSize = function getSize(_ref) {
    var isAnimatingOpenOnMount = _ref.isAnimatingOpenOnMount, placeholder = _ref.placeholder, animate = _ref.animate;
    if (isAnimatingOpenOnMount) return $69fa0e3037063634$var$empty;
    if (animate === 'close') return $69fa0e3037063634$var$empty;
    return {
        height: placeholder.client.borderBox.height,
        width: placeholder.client.borderBox.width,
        margin: placeholder.client.margin
    };
};
var $69fa0e3037063634$var$getStyle = function getStyle(_ref2) {
    var isAnimatingOpenOnMount = _ref2.isAnimatingOpenOnMount, placeholder = _ref2.placeholder, animate = _ref2.animate;
    var size = $69fa0e3037063634$var$getSize({
        isAnimatingOpenOnMount: isAnimatingOpenOnMount,
        placeholder: placeholder,
        animate: animate
    });
    return {
        display: placeholder.display,
        boxSizing: 'border-box',
        width: size.width,
        height: size.height,
        marginTop: size.margin.top,
        marginRight: size.margin.right,
        marginBottom: size.margin.bottom,
        marginLeft: size.margin.left,
        flexShrink: '0',
        flexGrow: '0',
        pointerEvents: 'none',
        transition: animate !== 'none' ? $69fa0e3037063634$var$transitions.placeholder : null
    };
};
function $69fa0e3037063634$var$Placeholder(props) {
    var animateOpenTimerRef = (0, $eUqFw.useRef)(null);
    var tryClearAnimateOpenTimer = (0, $fzXll.useCallback)(function() {
        if (!animateOpenTimerRef.current) return;
        clearTimeout(animateOpenTimerRef.current);
        animateOpenTimerRef.current = null;
    }, []);
    var animate = props.animate, onTransitionEnd = props.onTransitionEnd, onClose = props.onClose, contextId = props.contextId;
    var _useState = (0, $eUqFw.useState)(props.animate === 'open'), isAnimatingOpenOnMount = _useState[0], setIsAnimatingOpenOnMount = _useState[1];
    (0, $eUqFw.useEffect)(function() {
        if (!isAnimatingOpenOnMount) return $69fa0e3037063634$var$noop$2;
        if (animate !== 'open') {
            tryClearAnimateOpenTimer();
            setIsAnimatingOpenOnMount(false);
            return $69fa0e3037063634$var$noop$2;
        }
        if (animateOpenTimerRef.current) return $69fa0e3037063634$var$noop$2;
        animateOpenTimerRef.current = setTimeout(function() {
            animateOpenTimerRef.current = null;
            setIsAnimatingOpenOnMount(false);
        });
        return tryClearAnimateOpenTimer;
    }, [
        animate,
        isAnimatingOpenOnMount,
        tryClearAnimateOpenTimer
    ]);
    var onSizeChangeEnd = (0, $fzXll.useCallback)(function(event) {
        if (event.propertyName !== 'height') return;
        onTransitionEnd();
        if (animate === 'close') onClose();
    }, [
        animate,
        onClose,
        onTransitionEnd
    ]);
    var style = $69fa0e3037063634$var$getStyle({
        isAnimatingOpenOnMount: isAnimatingOpenOnMount,
        animate: props.animate,
        placeholder: props.placeholder
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(props.placeholder.tagName, {
        style: style,
        'data-rbd-placeholder-context-id': contextId,
        onTransitionEnd: onSizeChangeEnd,
        ref: props.innerRef
    });
}
var $69fa0e3037063634$var$Placeholder$1 = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).memo($69fa0e3037063634$var$Placeholder);
var $69fa0e3037063634$var$DroppableContext = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext(null);
function $69fa0e3037063634$var$checkIsValidInnerRef(el) {
    !(el && $69fa0e3037063634$var$isHtmlElement(el)) && $69fa0e3037063634$var$invariant(false);
}
function $69fa0e3037063634$var$isBoolean(value) {
    return typeof value === 'boolean';
}
function $69fa0e3037063634$var$runChecks(args, checks) {
    checks.forEach(function(check) {
        return check(args);
    });
}
var $69fa0e3037063634$var$shared = [
    function required(_ref) {
        var props = _ref.props;
        !props.droppableId && $69fa0e3037063634$var$invariant(false);
        !(typeof props.droppableId === 'string') && $69fa0e3037063634$var$invariant(false);
    },
    function _boolean(_ref2) {
        var props = _ref2.props;
        !$69fa0e3037063634$var$isBoolean(props.isDropDisabled) && $69fa0e3037063634$var$invariant(false);
        !$69fa0e3037063634$var$isBoolean(props.isCombineEnabled) && $69fa0e3037063634$var$invariant(false);
        !$69fa0e3037063634$var$isBoolean(props.ignoreContainerClipping) && $69fa0e3037063634$var$invariant(false);
    },
    function ref(_ref3) {
        var getDroppableRef = _ref3.getDroppableRef;
        $69fa0e3037063634$var$checkIsValidInnerRef(getDroppableRef());
    }
];
var $69fa0e3037063634$var$standard = [
    function placeholder(_ref4) {
        var props = _ref4.props, getPlaceholderRef = _ref4.getPlaceholderRef;
        if (!props.placeholder) return;
        var ref = getPlaceholderRef();
        if (ref) return;
    }
];
var $69fa0e3037063634$var$virtual = [
    function hasClone(_ref5) {
        var props = _ref5.props;
        !props.renderClone && $69fa0e3037063634$var$invariant(false);
    },
    function hasNoPlaceholder(_ref6) {
        var getPlaceholderRef = _ref6.getPlaceholderRef;
        !!getPlaceholderRef() && $69fa0e3037063634$var$invariant(false);
    }
];
function $69fa0e3037063634$var$useValidation(args) {
    $69fa0e3037063634$var$useDevSetupWarning(function() {
        $69fa0e3037063634$var$runChecks(args, $69fa0e3037063634$var$shared);
        if (args.props.mode === 'standard') $69fa0e3037063634$var$runChecks(args, $69fa0e3037063634$var$standard);
        if (args.props.mode === 'virtual') $69fa0e3037063634$var$runChecks(args, $69fa0e3037063634$var$virtual);
    });
}
var $69fa0e3037063634$var$AnimateInOut = function(_React$PureComponent) {
    (0, $bqCNv.default)(AnimateInOut, _React$PureComponent);
    function AnimateInOut() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$PureComponent.call.apply(_React$PureComponent, [
            this
        ].concat(args)) || this;
        _this.state = {
            isVisible: Boolean(_this.props.on),
            data: _this.props.on,
            animate: _this.props.shouldAnimate && _this.props.on ? 'open' : 'none'
        };
        _this.onClose = function() {
            if (_this.state.animate !== 'close') return;
            _this.setState({
                isVisible: false
            });
        };
        return _this;
    }
    AnimateInOut.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
        if (!props.shouldAnimate) return {
            isVisible: Boolean(props.on),
            data: props.on,
            animate: 'none'
        };
        if (props.on) return {
            isVisible: true,
            data: props.on,
            animate: 'open'
        };
        if (state.isVisible) return {
            isVisible: true,
            data: state.data,
            animate: 'close'
        };
        return {
            isVisible: false,
            animate: 'close',
            data: null
        };
    };
    var _proto = AnimateInOut.prototype;
    _proto.render = function render() {
        if (!this.state.isVisible) return null;
        var provided = {
            onClose: this.onClose,
            data: this.state.data,
            animate: this.state.animate
        };
        return this.props.children(provided);
    };
    return AnimateInOut;
}((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).PureComponent);
var $69fa0e3037063634$var$zIndexOptions = {
    dragging: 5000,
    dropAnimating: 4500
};
var $69fa0e3037063634$var$getDraggingTransition = function getDraggingTransition(shouldAnimateDragMovement, dropping) {
    if (dropping) return $69fa0e3037063634$var$transitions.drop(dropping.duration);
    if (shouldAnimateDragMovement) return $69fa0e3037063634$var$transitions.snap;
    return $69fa0e3037063634$var$transitions.fluid;
};
var $69fa0e3037063634$var$getDraggingOpacity = function getDraggingOpacity(isCombining, isDropAnimating) {
    if (!isCombining) return null;
    return isDropAnimating ? $69fa0e3037063634$var$combine.opacity.drop : $69fa0e3037063634$var$combine.opacity.combining;
};
var $69fa0e3037063634$var$getShouldDraggingAnimate = function getShouldDraggingAnimate(dragging) {
    if (dragging.forceShouldAnimate != null) return dragging.forceShouldAnimate;
    return dragging.mode === 'SNAP';
};
function $69fa0e3037063634$var$getDraggingStyle(dragging) {
    var dimension = dragging.dimension;
    var box = dimension.client;
    var offset = dragging.offset, combineWith = dragging.combineWith, dropping = dragging.dropping;
    var isCombining = Boolean(combineWith);
    var shouldAnimate = $69fa0e3037063634$var$getShouldDraggingAnimate(dragging);
    var isDropAnimating = Boolean(dropping);
    var transform = isDropAnimating ? $69fa0e3037063634$var$transforms.drop(offset, isCombining) : $69fa0e3037063634$var$transforms.moveTo(offset);
    var style = {
        position: 'fixed',
        top: box.marginBox.top,
        left: box.marginBox.left,
        boxSizing: 'border-box',
        width: box.borderBox.width,
        height: box.borderBox.height,
        transition: $69fa0e3037063634$var$getDraggingTransition(shouldAnimate, dropping),
        transform: transform,
        opacity: $69fa0e3037063634$var$getDraggingOpacity(isCombining, isDropAnimating),
        zIndex: isDropAnimating ? $69fa0e3037063634$var$zIndexOptions.dropAnimating : $69fa0e3037063634$var$zIndexOptions.dragging,
        pointerEvents: 'none'
    };
    return style;
}
function $69fa0e3037063634$var$getSecondaryStyle(secondary) {
    return {
        transform: $69fa0e3037063634$var$transforms.moveTo(secondary.offset),
        transition: secondary.shouldAnimateDisplacement ? null : 'none'
    };
}
function $69fa0e3037063634$var$getStyle$1(mapped) {
    return mapped.type === 'DRAGGING' ? $69fa0e3037063634$var$getDraggingStyle(mapped) : $69fa0e3037063634$var$getSecondaryStyle(mapped);
}
function $69fa0e3037063634$var$getDimension$1(descriptor, el, windowScroll) {
    if (windowScroll === void 0) windowScroll = $69fa0e3037063634$var$origin;
    var computedStyles = window.getComputedStyle(el);
    var borderBox = el.getBoundingClientRect();
    var client = (0, $bn5nT.calculateBox)(borderBox, computedStyles);
    var page = (0, $bn5nT.withScroll)(client, windowScroll);
    var placeholder = {
        client: client,
        tagName: el.tagName.toLowerCase(),
        display: computedStyles.display
    };
    var displaceBy = {
        x: client.marginBox.width,
        y: client.marginBox.height
    };
    var dimension = {
        descriptor: descriptor,
        placeholder: placeholder,
        displaceBy: displaceBy,
        client: client,
        page: page
    };
    return dimension;
}
function $69fa0e3037063634$var$useDraggablePublisher(args) {
    var uniqueId = $69fa0e3037063634$var$useUniqueId('draggable');
    var descriptor = args.descriptor, registry = args.registry, getDraggableRef = args.getDraggableRef, canDragInteractiveElements = args.canDragInteractiveElements, shouldRespectForcePress = args.shouldRespectForcePress, isEnabled = args.isEnabled;
    var options = (0, $fzXll.useMemo)(function() {
        return {
            canDragInteractiveElements: canDragInteractiveElements,
            shouldRespectForcePress: shouldRespectForcePress,
            isEnabled: isEnabled
        };
    }, [
        canDragInteractiveElements,
        isEnabled,
        shouldRespectForcePress
    ]);
    var getDimension = (0, $fzXll.useCallback)(function(windowScroll) {
        var el = getDraggableRef();
        !el && $69fa0e3037063634$var$invariant(false);
        return $69fa0e3037063634$var$getDimension$1(descriptor, el, windowScroll);
    }, [
        descriptor,
        getDraggableRef
    ]);
    var entry = (0, $fzXll.useMemo)(function() {
        return {
            uniqueId: uniqueId,
            descriptor: descriptor,
            options: options,
            getDimension: getDimension
        };
    }, [
        descriptor,
        getDimension,
        options,
        uniqueId
    ]);
    var publishedRef = (0, $eUqFw.useRef)(entry);
    var isFirstPublishRef = (0, $eUqFw.useRef)(true);
    $69fa0e3037063634$var$useIsomorphicLayoutEffect(function() {
        registry.draggable.register(publishedRef.current);
        return function() {
            return registry.draggable.unregister(publishedRef.current);
        };
    }, [
        registry.draggable
    ]);
    $69fa0e3037063634$var$useIsomorphicLayoutEffect(function() {
        if (isFirstPublishRef.current) {
            isFirstPublishRef.current = false;
            return;
        }
        var last = publishedRef.current;
        publishedRef.current = entry;
        registry.draggable.update(entry, last);
    }, [
        entry,
        registry.draggable
    ]);
}
function $69fa0e3037063634$var$useValidation$1(props, contextId, getRef) {
    $69fa0e3037063634$var$useDevSetupWarning(function() {
        function prefix(id) {
            return "Draggable[id: " + id + "]: ";
        }
        var id = props.draggableId;
        !id && $69fa0e3037063634$var$invariant(false);
        !(typeof id === 'string') && $69fa0e3037063634$var$invariant(false);
        !(0, (/*@__PURE__*/$parcel$interopDefault($8kUbC)))(props.index) && $69fa0e3037063634$var$invariant(false);
        if (props.mapped.type === 'DRAGGING') return;
        $69fa0e3037063634$var$checkIsValidInnerRef(getRef());
        if (props.isEnabled) !$69fa0e3037063634$var$findDragHandle(contextId, id) && $69fa0e3037063634$var$invariant(false);
    });
}
function $69fa0e3037063634$var$useClonePropValidation(isClone) {
    $69fa0e3037063634$var$useDev(function() {
        var initialRef = (0, $eUqFw.useRef)(isClone);
        $69fa0e3037063634$var$useDevSetupWarning(function() {
            !(isClone === initialRef.current) && $69fa0e3037063634$var$invariant(false);
        }, [
            isClone
        ]);
    });
}
function $69fa0e3037063634$var$preventHtml5Dnd(event) {
    event.preventDefault();
}
function $69fa0e3037063634$var$Draggable(props) {
    var ref = (0, $eUqFw.useRef)(null);
    var setRef = (0, $fzXll.useCallback)(function(el) {
        ref.current = el;
    }, []);
    var getRef = (0, $fzXll.useCallback)(function() {
        return ref.current;
    }, []);
    var _useRequiredContext = $69fa0e3037063634$var$useRequiredContext($69fa0e3037063634$var$AppContext), contextId = _useRequiredContext.contextId, liftInstructionId = _useRequiredContext.liftInstructionId, registry = _useRequiredContext.registry;
    var _useRequiredContext2 = $69fa0e3037063634$var$useRequiredContext($69fa0e3037063634$var$DroppableContext), type = _useRequiredContext2.type, droppableId = _useRequiredContext2.droppableId;
    var descriptor = (0, $fzXll.useMemo)(function() {
        return {
            id: props.draggableId,
            index: props.index,
            type: type,
            droppableId: droppableId
        };
    }, [
        props.draggableId,
        props.index,
        type,
        droppableId
    ]);
    var children = props.children, draggableId = props.draggableId, isEnabled = props.isEnabled, shouldRespectForcePress = props.shouldRespectForcePress, canDragInteractiveElements = props.canDragInteractiveElements, isClone = props.isClone, mapped = props.mapped, dropAnimationFinishedAction = props.dropAnimationFinished;
    $69fa0e3037063634$var$useValidation$1(props, contextId, getRef);
    $69fa0e3037063634$var$useClonePropValidation(isClone);
    if (!isClone) {
        var forPublisher = (0, $fzXll.useMemo)(function() {
            return {
                descriptor: descriptor,
                registry: registry,
                getDraggableRef: getRef,
                canDragInteractiveElements: canDragInteractiveElements,
                shouldRespectForcePress: shouldRespectForcePress,
                isEnabled: isEnabled
            };
        }, [
            descriptor,
            registry,
            getRef,
            canDragInteractiveElements,
            shouldRespectForcePress,
            isEnabled
        ]);
        $69fa0e3037063634$var$useDraggablePublisher(forPublisher);
    }
    var dragHandleProps = (0, $fzXll.useMemo)(function() {
        return isEnabled ? {
            tabIndex: 0,
            'data-rbd-drag-handle-draggable-id': draggableId,
            'data-rbd-drag-handle-context-id': contextId,
            'aria-labelledby': liftInstructionId,
            draggable: false,
            onDragStart: $69fa0e3037063634$var$preventHtml5Dnd
        } : null;
    }, [
        contextId,
        draggableId,
        isEnabled,
        liftInstructionId
    ]);
    var onMoveEnd = (0, $fzXll.useCallback)(function(event) {
        if (mapped.type !== 'DRAGGING') return;
        if (!mapped.dropping) return;
        if (event.propertyName !== 'transform') return;
        dropAnimationFinishedAction();
    }, [
        dropAnimationFinishedAction,
        mapped
    ]);
    var provided = (0, $fzXll.useMemo)(function() {
        var style = $69fa0e3037063634$var$getStyle$1(mapped);
        var onTransitionEnd = mapped.type === 'DRAGGING' && mapped.dropping ? onMoveEnd : null;
        var result = {
            innerRef: setRef,
            draggableProps: {
                'data-rbd-draggable-context-id': contextId,
                'data-rbd-draggable-id': draggableId,
                style: style,
                onTransitionEnd: onTransitionEnd
            },
            dragHandleProps: dragHandleProps
        };
        return result;
    }, [
        contextId,
        dragHandleProps,
        draggableId,
        mapped,
        onMoveEnd,
        setRef
    ]);
    var rubric = (0, $fzXll.useMemo)(function() {
        return {
            draggableId: descriptor.id,
            type: descriptor.type,
            source: {
                index: descriptor.index,
                droppableId: descriptor.droppableId
            }
        };
    }, [
        descriptor.droppableId,
        descriptor.id,
        descriptor.index,
        descriptor.type
    ]);
    return children(provided, mapped.snapshot, rubric);
}
var $69fa0e3037063634$var$isStrictEqual = function(a, b) {
    return a === b;
};
var $69fa0e3037063634$var$whatIsDraggedOverFromResult = function(result) {
    var combine = result.combine, destination = result.destination;
    if (destination) return destination.droppableId;
    if (combine) return combine.droppableId;
    return null;
};
var $69fa0e3037063634$var$getCombineWithFromResult = function getCombineWithFromResult(result) {
    return result.combine ? result.combine.draggableId : null;
};
var $69fa0e3037063634$var$getCombineWithFromImpact = function getCombineWithFromImpact(impact) {
    return impact.at && impact.at.type === 'COMBINE' ? impact.at.combine.draggableId : null;
};
function $69fa0e3037063634$var$getDraggableSelector() {
    var memoizedOffset = (0, $dCUwp.default)(function(x, y) {
        return {
            x: x,
            y: y
        };
    });
    var getMemoizedSnapshot = (0, $dCUwp.default)(function(mode, isClone, draggingOver, combineWith, dropping) {
        return {
            isDragging: true,
            isClone: isClone,
            isDropAnimating: Boolean(dropping),
            dropAnimation: dropping,
            mode: mode,
            draggingOver: draggingOver,
            combineWith: combineWith,
            combineTargetFor: null
        };
    });
    var getMemoizedProps = (0, $dCUwp.default)(function(offset, mode, dimension, isClone, draggingOver, combineWith, forceShouldAnimate) {
        return {
            mapped: {
                type: 'DRAGGING',
                dropping: null,
                draggingOver: draggingOver,
                combineWith: combineWith,
                mode: mode,
                offset: offset,
                dimension: dimension,
                forceShouldAnimate: forceShouldAnimate,
                snapshot: getMemoizedSnapshot(mode, isClone, draggingOver, combineWith, null)
            }
        };
    });
    var selector = function selector(state, ownProps) {
        if (state.isDragging) {
            if (state.critical.draggable.id !== ownProps.draggableId) return null;
            var offset = state.current.client.offset;
            var dimension = state.dimensions.draggables[ownProps.draggableId];
            var draggingOver = $69fa0e3037063634$var$whatIsDraggedOver(state.impact);
            var combineWith = $69fa0e3037063634$var$getCombineWithFromImpact(state.impact);
            var forceShouldAnimate = state.forceShouldAnimate;
            return getMemoizedProps(memoizedOffset(offset.x, offset.y), state.movementMode, dimension, ownProps.isClone, draggingOver, combineWith, forceShouldAnimate);
        }
        if (state.phase === 'DROP_ANIMATING') {
            var completed = state.completed;
            if (completed.result.draggableId !== ownProps.draggableId) return null;
            var isClone = ownProps.isClone;
            var _dimension = state.dimensions.draggables[ownProps.draggableId];
            var result = completed.result;
            var mode = result.mode;
            var _draggingOver = $69fa0e3037063634$var$whatIsDraggedOverFromResult(result);
            var _combineWith = $69fa0e3037063634$var$getCombineWithFromResult(result);
            var duration = state.dropDuration;
            var dropping = {
                duration: duration,
                curve: $69fa0e3037063634$var$curves.drop,
                moveTo: state.newHomeClientOffset,
                opacity: _combineWith ? $69fa0e3037063634$var$combine.opacity.drop : null,
                scale: _combineWith ? $69fa0e3037063634$var$combine.scale.drop : null
            };
            return {
                mapped: {
                    type: 'DRAGGING',
                    offset: state.newHomeClientOffset,
                    dimension: _dimension,
                    dropping: dropping,
                    draggingOver: _draggingOver,
                    combineWith: _combineWith,
                    mode: mode,
                    forceShouldAnimate: null,
                    snapshot: getMemoizedSnapshot(mode, isClone, _draggingOver, _combineWith, dropping)
                }
            };
        }
        return null;
    };
    return selector;
}
function $69fa0e3037063634$var$getSecondarySnapshot(combineTargetFor) {
    return {
        isDragging: false,
        isDropAnimating: false,
        isClone: false,
        dropAnimation: null,
        mode: null,
        draggingOver: null,
        combineTargetFor: combineTargetFor,
        combineWith: null
    };
}
var $69fa0e3037063634$var$atRest = {
    mapped: {
        type: 'SECONDARY',
        offset: $69fa0e3037063634$var$origin,
        combineTargetFor: null,
        shouldAnimateDisplacement: true,
        snapshot: $69fa0e3037063634$var$getSecondarySnapshot(null)
    }
};
function $69fa0e3037063634$var$getSecondarySelector() {
    var memoizedOffset = (0, $dCUwp.default)(function(x, y) {
        return {
            x: x,
            y: y
        };
    });
    var getMemoizedSnapshot = (0, $dCUwp.default)($69fa0e3037063634$var$getSecondarySnapshot);
    var getMemoizedProps = (0, $dCUwp.default)(function(offset, combineTargetFor, shouldAnimateDisplacement) {
        if (combineTargetFor === void 0) combineTargetFor = null;
        return {
            mapped: {
                type: 'SECONDARY',
                offset: offset,
                combineTargetFor: combineTargetFor,
                shouldAnimateDisplacement: shouldAnimateDisplacement,
                snapshot: getMemoizedSnapshot(combineTargetFor)
            }
        };
    });
    var getFallback = function getFallback(combineTargetFor) {
        return combineTargetFor ? getMemoizedProps($69fa0e3037063634$var$origin, combineTargetFor, true) : null;
    };
    var getProps = function getProps(ownId, draggingId, impact, afterCritical) {
        var visualDisplacement = impact.displaced.visible[ownId];
        var isAfterCriticalInVirtualList = Boolean(afterCritical.inVirtualList && afterCritical.effected[ownId]);
        var combine = $69fa0e3037063634$var$tryGetCombine(impact);
        var combineTargetFor = combine && combine.draggableId === ownId ? draggingId : null;
        if (!visualDisplacement) {
            if (!isAfterCriticalInVirtualList) return getFallback(combineTargetFor);
            if (impact.displaced.invisible[ownId]) return null;
            var change = $69fa0e3037063634$var$negate(afterCritical.displacedBy.point);
            var _offset = memoizedOffset(change.x, change.y);
            return getMemoizedProps(_offset, combineTargetFor, true);
        }
        if (isAfterCriticalInVirtualList) return getFallback(combineTargetFor);
        var displaceBy = impact.displacedBy.point;
        var offset = memoizedOffset(displaceBy.x, displaceBy.y);
        return getMemoizedProps(offset, combineTargetFor, visualDisplacement.shouldAnimate);
    };
    var selector = function selector(state, ownProps) {
        if (state.isDragging) {
            if (state.critical.draggable.id === ownProps.draggableId) return null;
            return getProps(ownProps.draggableId, state.critical.draggable.id, state.impact, state.afterCritical);
        }
        if (state.phase === 'DROP_ANIMATING') {
            var completed = state.completed;
            if (completed.result.draggableId === ownProps.draggableId) return null;
            return getProps(ownProps.draggableId, completed.result.draggableId, completed.impact, completed.afterCritical);
        }
        return null;
    };
    return selector;
}
var $69fa0e3037063634$var$makeMapStateToProps = function makeMapStateToProps() {
    var draggingSelector = $69fa0e3037063634$var$getDraggableSelector();
    var secondarySelector = $69fa0e3037063634$var$getSecondarySelector();
    var selector = function selector(state, ownProps) {
        return draggingSelector(state, ownProps) || secondarySelector(state, ownProps) || $69fa0e3037063634$var$atRest;
    };
    return selector;
};
var $69fa0e3037063634$var$mapDispatchToProps = {
    dropAnimationFinished: $69fa0e3037063634$var$dropAnimationFinished
};
var $69fa0e3037063634$var$ConnectedDraggable = (0, $94zHK.default)($69fa0e3037063634$var$makeMapStateToProps, $69fa0e3037063634$var$mapDispatchToProps, null, {
    context: $69fa0e3037063634$var$StoreContext,
    pure: true,
    areStatePropsEqual: $69fa0e3037063634$var$isStrictEqual
})($69fa0e3037063634$var$Draggable);
function $69fa0e3037063634$var$PrivateDraggable(props) {
    var droppableContext = $69fa0e3037063634$var$useRequiredContext($69fa0e3037063634$var$DroppableContext);
    var isUsingCloneFor = droppableContext.isUsingCloneFor;
    if (isUsingCloneFor === props.draggableId && !props.isClone) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($69fa0e3037063634$var$ConnectedDraggable, props);
}
function $69fa0e3037063634$export$f2a139e5d18b9882(props) {
    var isEnabled = typeof props.isDragDisabled === 'boolean' ? !props.isDragDisabled : true;
    var canDragInteractiveElements = Boolean(props.disableInteractiveElementBlocking);
    var shouldRespectForcePress = Boolean(props.shouldRespectForcePress);
    return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($69fa0e3037063634$var$PrivateDraggable, (0, $34lu7.default)({}, props, {
        isClone: false,
        isEnabled: isEnabled,
        canDragInteractiveElements: canDragInteractiveElements,
        shouldRespectForcePress: shouldRespectForcePress
    }));
}
function $69fa0e3037063634$var$Droppable(props) {
    var appContext = (0, $eUqFw.useContext)($69fa0e3037063634$var$AppContext);
    !appContext && $69fa0e3037063634$var$invariant(false);
    var contextId = appContext.contextId, isMovementAllowed = appContext.isMovementAllowed;
    var droppableRef = (0, $eUqFw.useRef)(null);
    var placeholderRef = (0, $eUqFw.useRef)(null);
    var children = props.children, droppableId = props.droppableId, type = props.type, mode = props.mode, direction = props.direction, ignoreContainerClipping = props.ignoreContainerClipping, isDropDisabled = props.isDropDisabled, isCombineEnabled = props.isCombineEnabled, snapshot = props.snapshot, useClone = props.useClone, updateViewportMaxScroll = props.updateViewportMaxScroll, getContainerForClone = props.getContainerForClone;
    var getDroppableRef = (0, $fzXll.useCallback)(function() {
        return droppableRef.current;
    }, []);
    var setDroppableRef = (0, $fzXll.useCallback)(function(value) {
        droppableRef.current = value;
    }, []);
    var getPlaceholderRef = (0, $fzXll.useCallback)(function() {
        return placeholderRef.current;
    }, []);
    var setPlaceholderRef = (0, $fzXll.useCallback)(function(value) {
        placeholderRef.current = value;
    }, []);
    $69fa0e3037063634$var$useValidation({
        props: props,
        getDroppableRef: getDroppableRef,
        getPlaceholderRef: getPlaceholderRef
    });
    var onPlaceholderTransitionEnd = (0, $fzXll.useCallback)(function() {
        if (isMovementAllowed()) updateViewportMaxScroll({
            maxScroll: $69fa0e3037063634$var$getMaxWindowScroll()
        });
    }, [
        isMovementAllowed,
        updateViewportMaxScroll
    ]);
    $69fa0e3037063634$var$useDroppablePublisher({
        droppableId: droppableId,
        type: type,
        mode: mode,
        direction: direction,
        isDropDisabled: isDropDisabled,
        isCombineEnabled: isCombineEnabled,
        ignoreContainerClipping: ignoreContainerClipping,
        getDroppableRef: getDroppableRef
    });
    var placeholder = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($69fa0e3037063634$var$AnimateInOut, {
        on: props.placeholder,
        shouldAnimate: props.shouldAnimatePlaceholder
    }, function(_ref) {
        var onClose = _ref.onClose, data = _ref.data, animate = _ref.animate;
        return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($69fa0e3037063634$var$Placeholder$1, {
            placeholder: data,
            onClose: onClose,
            innerRef: setPlaceholderRef,
            animate: animate,
            contextId: contextId,
            onTransitionEnd: onPlaceholderTransitionEnd
        });
    });
    var provided = (0, $fzXll.useMemo)(function() {
        return {
            innerRef: setDroppableRef,
            placeholder: placeholder,
            droppableProps: {
                'data-rbd-droppable-id': droppableId,
                'data-rbd-droppable-context-id': contextId
            }
        };
    }, [
        contextId,
        droppableId,
        placeholder,
        setDroppableRef
    ]);
    var isUsingCloneFor = useClone ? useClone.dragging.draggableId : null;
    var droppableContext = (0, $fzXll.useMemo)(function() {
        return {
            droppableId: droppableId,
            type: type,
            isUsingCloneFor: isUsingCloneFor
        };
    }, [
        droppableId,
        isUsingCloneFor,
        type
    ]);
    function getClone() {
        if (!useClone) return null;
        var dragging = useClone.dragging, render = useClone.render;
        var node = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($69fa0e3037063634$var$PrivateDraggable, {
            draggableId: dragging.draggableId,
            index: dragging.source.index,
            isClone: true,
            isEnabled: true,
            shouldRespectForcePress: false,
            canDragInteractiveElements: true
        }, function(draggableProvided, draggableSnapshot) {
            return render(draggableProvided, draggableSnapshot, dragging);
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($lEfVV))).createPortal(node, getContainerForClone());
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($69fa0e3037063634$var$DroppableContext.Provider, {
        value: droppableContext
    }, children(provided, snapshot), getClone());
}
var $69fa0e3037063634$var$isMatchingType = function isMatchingType(type, critical) {
    return type === critical.droppable.type;
};
var $69fa0e3037063634$var$getDraggable = function getDraggable(critical, dimensions) {
    return dimensions.draggables[critical.draggable.id];
};
var $69fa0e3037063634$var$makeMapStateToProps$1 = function makeMapStateToProps() {
    var idleWithAnimation = {
        placeholder: null,
        shouldAnimatePlaceholder: true,
        snapshot: {
            isDraggingOver: false,
            draggingOverWith: null,
            draggingFromThisWith: null,
            isUsingPlaceholder: false
        },
        useClone: null
    };
    var idleWithoutAnimation = (0, $34lu7.default)({}, idleWithAnimation, {
        shouldAnimatePlaceholder: false
    });
    var getDraggableRubric = (0, $dCUwp.default)(function(descriptor) {
        return {
            draggableId: descriptor.id,
            type: descriptor.type,
            source: {
                index: descriptor.index,
                droppableId: descriptor.droppableId
            }
        };
    });
    var getMapProps = (0, $dCUwp.default)(function(id, isEnabled, isDraggingOverForConsumer, isDraggingOverForImpact, dragging, renderClone) {
        var draggableId = dragging.descriptor.id;
        var isHome = dragging.descriptor.droppableId === id;
        if (isHome) {
            var useClone = renderClone ? {
                render: renderClone,
                dragging: getDraggableRubric(dragging.descriptor)
            } : null;
            var _snapshot = {
                isDraggingOver: isDraggingOverForConsumer,
                draggingOverWith: isDraggingOverForConsumer ? draggableId : null,
                draggingFromThisWith: draggableId,
                isUsingPlaceholder: true
            };
            return {
                placeholder: dragging.placeholder,
                shouldAnimatePlaceholder: false,
                snapshot: _snapshot,
                useClone: useClone
            };
        }
        if (!isEnabled) return idleWithoutAnimation;
        if (!isDraggingOverForImpact) return idleWithAnimation;
        var snapshot = {
            isDraggingOver: isDraggingOverForConsumer,
            draggingOverWith: draggableId,
            draggingFromThisWith: null,
            isUsingPlaceholder: true
        };
        return {
            placeholder: dragging.placeholder,
            shouldAnimatePlaceholder: true,
            snapshot: snapshot,
            useClone: null
        };
    });
    var selector = function selector(state, ownProps) {
        var id = ownProps.droppableId;
        var type = ownProps.type;
        var isEnabled = !ownProps.isDropDisabled;
        var renderClone = ownProps.renderClone;
        if (state.isDragging) {
            var critical = state.critical;
            if (!$69fa0e3037063634$var$isMatchingType(type, critical)) return idleWithoutAnimation;
            var dragging = $69fa0e3037063634$var$getDraggable(critical, state.dimensions);
            var isDraggingOver = $69fa0e3037063634$var$whatIsDraggedOver(state.impact) === id;
            return getMapProps(id, isEnabled, isDraggingOver, isDraggingOver, dragging, renderClone);
        }
        if (state.phase === 'DROP_ANIMATING') {
            var completed = state.completed;
            if (!$69fa0e3037063634$var$isMatchingType(type, completed.critical)) return idleWithoutAnimation;
            var _dragging = $69fa0e3037063634$var$getDraggable(completed.critical, state.dimensions);
            return getMapProps(id, isEnabled, $69fa0e3037063634$var$whatIsDraggedOverFromResult(completed.result) === id, $69fa0e3037063634$var$whatIsDraggedOver(completed.impact) === id, _dragging, renderClone);
        }
        if (state.phase === 'IDLE' && state.completed && !state.shouldFlush) {
            var _completed = state.completed;
            if (!$69fa0e3037063634$var$isMatchingType(type, _completed.critical)) return idleWithoutAnimation;
            var wasOver = $69fa0e3037063634$var$whatIsDraggedOver(_completed.impact) === id;
            var wasCombining = Boolean(_completed.impact.at && _completed.impact.at.type === 'COMBINE');
            var isHome = _completed.critical.droppable.id === id;
            if (wasOver) return wasCombining ? idleWithAnimation : idleWithoutAnimation;
            if (isHome) return idleWithAnimation;
            return idleWithoutAnimation;
        }
        return idleWithoutAnimation;
    };
    return selector;
};
var $69fa0e3037063634$var$mapDispatchToProps$1 = {
    updateViewportMaxScroll: $69fa0e3037063634$var$updateViewportMaxScroll
};
function $69fa0e3037063634$var$getBody() {
    !document.body && $69fa0e3037063634$var$invariant(false);
    return document.body;
}
var $69fa0e3037063634$var$defaultProps = {
    mode: 'standard',
    type: 'DEFAULT',
    direction: 'vertical',
    isDropDisabled: false,
    isCombineEnabled: false,
    ignoreContainerClipping: false,
    renderClone: null,
    getContainerForClone: $69fa0e3037063634$var$getBody
};
var $69fa0e3037063634$export$423ec2075359570a = (0, $94zHK.default)($69fa0e3037063634$var$makeMapStateToProps$1, $69fa0e3037063634$var$mapDispatchToProps$1, null, {
    context: $69fa0e3037063634$var$StoreContext,
    pure: true,
    areStatePropsEqual: $69fa0e3037063634$var$isStrictEqual
})($69fa0e3037063634$var$Droppable);
$69fa0e3037063634$export$423ec2075359570a.defaultProps = $69fa0e3037063634$var$defaultProps;

});
parcelRegister("bqCNv", function(module, exports) {

$parcel$export(module.exports, "default", () => $852037c688a362ca$export$2e2bcd8739ae039);

var $aqlSy = parcelRequire("aqlSy");

var $hhPJ7 = parcelRequire("hhPJ7");
function $852037c688a362ca$export$2e2bcd8739ae039(subClass, superClass) {
    subClass.prototype = (0, (/*@__PURE__*/$parcel$interopDefault($aqlSy)))(superClass.prototype);
    subClass.prototype.constructor = subClass;
    (0, $hhPJ7.default)(subClass, superClass);
}

});
parcelRegister("aqlSy", function(module, exports) {

module.exports = (parcelRequire("fKlYj"));

});
parcelRegister("fKlYj", function(module, exports) {
parcelRequire("3w0kn");

var $dhx8H = parcelRequire("dhx8H");
var $b76c3205a8a74d63$require$$Object = $dhx8H.Object;
module.exports = function create(P, D) {
    return $b76c3205a8a74d63$require$$Object.create(P, D);
};

});
parcelRegister("3w0kn", function(module, exports) {

var $5wEa2 = parcelRequire("5wEa2");

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$5wEa2($5wEa2.S, 'Object', {
    create: (parcelRequire("cZpQU"))
});

});
parcelRegister("5wEa2", function(module, exports) {

var $63L5I = parcelRequire("63L5I");

var $dhx8H = parcelRequire("dhx8H");

var $8fJLB = parcelRequire("8fJLB");

var $8akT7 = parcelRequire("8akT7");

var $8uIdh = parcelRequire("8uIdh");
var $405f18044f314da9$var$PROTOTYPE = 'prototype';
var $405f18044f314da9$var$$export = function(type, name, source) {
    var IS_FORCED = type & $405f18044f314da9$var$$export.F;
    var IS_GLOBAL = type & $405f18044f314da9$var$$export.G;
    var IS_STATIC = type & $405f18044f314da9$var$$export.S;
    var IS_PROTO = type & $405f18044f314da9$var$$export.P;
    var IS_BIND = type & $405f18044f314da9$var$$export.B;
    var IS_WRAP = type & $405f18044f314da9$var$$export.W;
    var exports = IS_GLOBAL ? $dhx8H : $dhx8H[name] || ($dhx8H[name] = {});
    var expProto = exports[$405f18044f314da9$var$PROTOTYPE];
    var target = IS_GLOBAL ? $63L5I : IS_STATIC ? $63L5I[name] : ($63L5I[name] || {})[$405f18044f314da9$var$PROTOTYPE];
    var key, own, out;
    if (IS_GLOBAL) source = name;
    for(key in source){
        // contains in native
        own = !IS_FORCED && target && target[key] !== undefined;
        if (own && $8uIdh(exports, key)) continue;
        // export native or passed
        out = own ? target[key] : source[key];
        // prevent global pollution for namespaces
        exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key] : IS_BIND && own ? $8fJLB(out, $63L5I) : IS_WRAP && target[key] == out ? function(C) {
            var F = function(a, b, c) {
                if (this instanceof C) {
                    switch(arguments.length){
                        case 0:
                            return new C();
                        case 1:
                            return new C(a);
                        case 2:
                            return new C(a, b);
                    }
                    return new C(a, b, c);
                }
                return C.apply(this, arguments);
            };
            F[$405f18044f314da9$var$PROTOTYPE] = C[$405f18044f314da9$var$PROTOTYPE];
            return F;
        // make static versions for prototype methods
        }(out) : IS_PROTO && typeof out == 'function' ? $8fJLB(Function.call, out) : out;
        // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
        if (IS_PROTO) {
            (exports.virtual || (exports.virtual = {}))[key] = out;
            // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
            if (type & $405f18044f314da9$var$$export.R && expProto && !expProto[key]) $8akT7(expProto, key, out);
        }
    }
};
// type bitmap
$405f18044f314da9$var$$export.F = 1; // forced
$405f18044f314da9$var$$export.G = 2; // global
$405f18044f314da9$var$$export.S = 4; // static
$405f18044f314da9$var$$export.P = 8; // proto
$405f18044f314da9$var$$export.B = 16; // bind
$405f18044f314da9$var$$export.W = 32; // wrap
$405f18044f314da9$var$$export.U = 64; // safe
$405f18044f314da9$var$$export.R = 128; // real proto method for `library`
module.exports = $405f18044f314da9$var$$export;

});
parcelRegister("63L5I", function(module, exports) {
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var $46978d3810f5c50a$var$global = module.exports = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
if (typeof __g == 'number') __g = $46978d3810f5c50a$var$global; // eslint-disable-line no-undef

});

parcelRegister("dhx8H", function(module, exports) {
var $9ab691a5895850dc$var$core = module.exports = {
    version: '2.6.12'
};
if (typeof __e == 'number') __e = $9ab691a5895850dc$var$core; // eslint-disable-line no-undef

});

parcelRegister("8fJLB", function(module, exports) {
// optional / simple context binding

var $2vhgy = parcelRequire("2vhgy");
module.exports = function(fn, that, length) {
    $2vhgy(fn);
    if (that === undefined) return fn;
    switch(length){
        case 1:
            return function(a) {
                return fn.call(that, a);
            };
        case 2:
            return function(a, b) {
                return fn.call(that, a, b);
            };
        case 3:
            return function(a, b, c) {
                return fn.call(that, a, b, c);
            };
    }
    return function() {
        return fn.apply(that, arguments);
    };
};

});
parcelRegister("2vhgy", function(module, exports) {
module.exports = function(it) {
    if (typeof it != 'function') throw TypeError(it + ' is not a function!');
    return it;
};

});


parcelRegister("8akT7", function(module, exports) {

var $9jrHv = parcelRequire("9jrHv");

var $dhKmr = parcelRequire("dhKmr");

module.exports = (parcelRequire("kD5IQ")) ? function(object, key, value) {
    return $9jrHv.f(object, key, $dhKmr(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};

});
parcelRegister("9jrHv", function(module, exports) {

$parcel$export(module.exports, "f", () => $6c7b6032f547fb4c$export$2d1720544b23b823, (v) => $6c7b6032f547fb4c$export$2d1720544b23b823 = v);
var $6c7b6032f547fb4c$export$2d1720544b23b823;

var $aIdHH = parcelRequire("aIdHH");

var $3Ksbk = parcelRequire("3Ksbk");

var $1zpu5 = parcelRequire("1zpu5");
var $6c7b6032f547fb4c$var$dP = Object.defineProperty;

$6c7b6032f547fb4c$export$2d1720544b23b823 = (parcelRequire("kD5IQ")) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
    $aIdHH(O);
    P = $1zpu5(P, true);
    $aIdHH(Attributes);
    if ($3Ksbk) try {
        return $6c7b6032f547fb4c$var$dP(O, P, Attributes);
    } catch (e) {}
    if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
    if ('value' in Attributes) O[P] = Attributes.value;
    return O;
};

});
parcelRegister("aIdHH", function(module, exports) {

var $8T9YM = parcelRequire("8T9YM");
module.exports = function(it) {
    if (!$8T9YM(it)) throw TypeError(it + ' is not an object!');
    return it;
};

});
parcelRegister("8T9YM", function(module, exports) {
module.exports = function(it) {
    return typeof it === 'object' ? it !== null : typeof it === 'function';
};

});


parcelRegister("3Ksbk", function(module, exports) {



module.exports = !(parcelRequire("kD5IQ")) && !(parcelRequire("cbAAd"))(function() {
    return Object.defineProperty((parcelRequire("2fnkQ"))('div'), 'a', {
        get: function() {
            return 7;
        }
    }).a != 7;
});

});
parcelRegister("kD5IQ", function(module, exports) {
// Thank's IE8 for his funny defineProperty

module.exports = !(parcelRequire("cbAAd"))(function() {
    return Object.defineProperty({}, 'a', {
        get: function() {
            return 7;
        }
    }).a != 7;
});

});
parcelRegister("cbAAd", function(module, exports) {
module.exports = function(exec) {
    try {
        return !!exec();
    } catch (e) {
        return true;
    }
};

});


parcelRegister("2fnkQ", function(module, exports) {

var $8T9YM = parcelRequire("8T9YM");

var $63L5I = parcelRequire("63L5I");
var $1a2f155b99584f9f$require$document = $63L5I.document;
// typeof document.createElement is 'object' in old IE
var $1a2f155b99584f9f$var$is = $8T9YM($1a2f155b99584f9f$require$document) && $8T9YM($1a2f155b99584f9f$require$document.createElement);
module.exports = function(it) {
    return $1a2f155b99584f9f$var$is ? $1a2f155b99584f9f$require$document.createElement(it) : {};
};

});


parcelRegister("1zpu5", function(module, exports) {
// 7.1.1 ToPrimitive(input [, PreferredType])

var $8T9YM = parcelRequire("8T9YM");
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function(it, S) {
    if (!$8T9YM(it)) return it;
    var fn, val;
    if (S && typeof (fn = it.toString) == 'function' && !$8T9YM(val = fn.call(it))) return val;
    if (typeof (fn = it.valueOf) == 'function' && !$8T9YM(val = fn.call(it))) return val;
    if (!S && typeof (fn = it.toString) == 'function' && !$8T9YM(val = fn.call(it))) return val;
    throw TypeError("Can't convert object to primitive value");
};

});


parcelRegister("dhKmr", function(module, exports) {
module.exports = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};

});


parcelRegister("8uIdh", function(module, exports) {
var $62f36be98ddb54f8$var$hasOwnProperty = {}.hasOwnProperty;
module.exports = function(it, key) {
    return $62f36be98ddb54f8$var$hasOwnProperty.call(it, key);
};

});


parcelRegister("cZpQU", function(module, exports) {
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])

var $aIdHH = parcelRequire("aIdHH");

var $1o8G4 = parcelRequire("1o8G4");

var $c3pDW = parcelRequire("c3pDW");

var $974f3c4319e9c96a$var$IE_PROTO = (parcelRequire("5PKej"))('IE_PROTO');
var $974f3c4319e9c96a$var$Empty = function() {};
var $974f3c4319e9c96a$var$PROTOTYPE = 'prototype';


// Create object with fake `null` prototype: use iframe Object with cleared prototype
var $974f3c4319e9c96a$var$createDict = function() {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = (parcelRequire("2fnkQ"))('iframe');
    var i = $c3pDW.length;
    var lt = '<';
    var gt = '>';
    var iframeDocument;
    iframe.style.display = 'none';
    (parcelRequire("5JYrt")).appendChild(iframe);
    iframe.src = 'javascript:'; // eslint-disable-line no-script-url
    // createDict = iframe.contentWindow.Object;
    // html.removeChild(iframe);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
    iframeDocument.close();
    $974f3c4319e9c96a$var$createDict = iframeDocument.F;
    while(i--)delete $974f3c4319e9c96a$var$createDict[$974f3c4319e9c96a$var$PROTOTYPE][$c3pDW[i]];
    return $974f3c4319e9c96a$var$createDict();
};
module.exports = Object.create || function create(O, Properties) {
    var result;
    if (O !== null) {
        $974f3c4319e9c96a$var$Empty[$974f3c4319e9c96a$var$PROTOTYPE] = $aIdHH(O);
        result = new $974f3c4319e9c96a$var$Empty();
        $974f3c4319e9c96a$var$Empty[$974f3c4319e9c96a$var$PROTOTYPE] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[$974f3c4319e9c96a$var$IE_PROTO] = O;
    } else result = $974f3c4319e9c96a$var$createDict();
    return Properties === undefined ? result : $1o8G4(result, Properties);
};

});
parcelRegister("1o8G4", function(module, exports) {

var $9jrHv = parcelRequire("9jrHv");

var $aIdHH = parcelRequire("aIdHH");

var $kJc9M = parcelRequire("kJc9M");

module.exports = (parcelRequire("kD5IQ")) ? Object.defineProperties : function defineProperties(O, Properties) {
    $aIdHH(O);
    var keys = $kJc9M(Properties);
    var length = keys.length;
    var i = 0;
    var P;
    while(length > i)$9jrHv.f(O, P = keys[i++], Properties[P]);
    return O;
};

});
parcelRegister("kJc9M", function(module, exports) {
// 19.1.2.14 / 15.2.3.14 Object.keys(O)

var $58JMR = parcelRequire("58JMR");

var $c3pDW = parcelRequire("c3pDW");
module.exports = Object.keys || function keys(O) {
    return $58JMR(O, $c3pDW);
};

});
parcelRegister("58JMR", function(module, exports) {

var $8uIdh = parcelRequire("8uIdh");

var $6WitF = parcelRequire("6WitF");

var $3be1377c0765345e$var$arrayIndexOf = (parcelRequire("hZ5wn"))(false);

var $3be1377c0765345e$var$IE_PROTO = (parcelRequire("5PKej"))('IE_PROTO');
module.exports = function(object, names) {
    var O = $6WitF(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)if (key != $3be1377c0765345e$var$IE_PROTO) $8uIdh(O, key) && result.push(key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($8uIdh(O, key = names[i++])) ~$3be1377c0765345e$var$arrayIndexOf(result, key) || result.push(key);
    return result;
};

});
parcelRegister("6WitF", function(module, exports) {
// to indexed object, toObject with fallback for non-array-like ES3 strings

var $jRK2B = parcelRequire("jRK2B");

var $5XrWm = parcelRequire("5XrWm");
module.exports = function(it) {
    return $jRK2B($5XrWm(it));
};

});
parcelRegister("jRK2B", function(module, exports) {
// fallback for non-array-like ES3 and non-enumerable old V8 strings

var $9A6tO = parcelRequire("9A6tO");
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it) {
    return $9A6tO(it) == 'String' ? it.split('') : Object(it);
};

});
parcelRegister("9A6tO", function(module, exports) {
var $6f9c80961703262c$var$toString = {}.toString;
module.exports = function(it) {
    return $6f9c80961703262c$var$toString.call(it).slice(8, -1);
};

});


parcelRegister("5XrWm", function(module, exports) {
// 7.2.1 RequireObjectCoercible(argument)
module.exports = function(it) {
    if (it == undefined) throw TypeError("Can't call method on  " + it);
    return it;
};

});


parcelRegister("hZ5wn", function(module, exports) {
// false -> Array#indexOf
// true  -> Array#includes

var $6WitF = parcelRequire("6WitF");

var $9sYrG = parcelRequire("9sYrG");

var $dmeMq = parcelRequire("dmeMq");
module.exports = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $6WitF($this);
        var length = $9sYrG(O.length);
        var index = $dmeMq(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare
        if (IS_INCLUDES && el != el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare
            if (value != value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++)if (IS_INCLUDES || index in O) {
            if (O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};

});
parcelRegister("9sYrG", function(module, exports) {
// 7.1.15 ToLength

var $cIXGZ = parcelRequire("cIXGZ");
var $6e459dd0a2f7e0ab$var$min = Math.min;
module.exports = function(it) {
    return it > 0 ? $6e459dd0a2f7e0ab$var$min($cIXGZ(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

});
parcelRegister("cIXGZ", function(module, exports) {
// 7.1.4 ToInteger
var $9437e5c320839147$var$ceil = Math.ceil;
var $9437e5c320839147$var$floor = Math.floor;
module.exports = function(it) {
    return isNaN(it = +it) ? 0 : (it > 0 ? $9437e5c320839147$var$floor : $9437e5c320839147$var$ceil)(it);
};

});


parcelRegister("dmeMq", function(module, exports) {

var $cIXGZ = parcelRequire("cIXGZ");
var $9b98cb76c764326c$var$max = Math.max;
var $9b98cb76c764326c$var$min = Math.min;
module.exports = function(index, length) {
    index = $cIXGZ(index);
    return index < 0 ? $9b98cb76c764326c$var$max(index + length, 0) : $9b98cb76c764326c$var$min(index, length);
};

});


parcelRegister("5PKej", function(module, exports) {

var $43f59377ae23d08e$var$shared = (parcelRequire("jmDxJ"))('keys');

var $c3eWa = parcelRequire("c3eWa");
module.exports = function(key) {
    return $43f59377ae23d08e$var$shared[key] || ($43f59377ae23d08e$var$shared[key] = $c3eWa(key));
};

});
parcelRegister("jmDxJ", function(module, exports) {

var $dhx8H = parcelRequire("dhx8H");

var $63L5I = parcelRequire("63L5I");
var $e18ebed786cb5a63$var$SHARED = '__core-js_shared__';
var $e18ebed786cb5a63$var$store = $63L5I[$e18ebed786cb5a63$var$SHARED] || ($63L5I[$e18ebed786cb5a63$var$SHARED] = {});

(module.exports = function(key, value) {
    return $e18ebed786cb5a63$var$store[key] || ($e18ebed786cb5a63$var$store[key] = value !== undefined ? value : {});
})('versions', []).push({
    version: $dhx8H.version,
    mode: (parcelRequire("ijzx7")) ? 'pure' : 'global',
    copyright: "\xa9 2020 Denis Pushkarev (zloirock.ru)"
});

});
parcelRegister("ijzx7", function(module, exports) {
module.exports = true;

});


parcelRegister("c3eWa", function(module, exports) {
var $8c615a0c227a0f34$var$id = 0;
var $8c615a0c227a0f34$var$px = Math.random();
module.exports = function(key) {
    return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++$8c615a0c227a0f34$var$id + $8c615a0c227a0f34$var$px).toString(36));
};

});



parcelRegister("c3pDW", function(module, exports) {
// IE 8- don't enum bug keys
module.exports = 'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'.split(',');

});



parcelRegister("5JYrt", function(module, exports) {

var $63L5I = parcelRequire("63L5I");
var $42e00a46ad7a4675$require$document = $63L5I.document;
module.exports = $42e00a46ad7a4675$require$document && $42e00a46ad7a4675$require$document.documentElement;

});





parcelRegister("hhPJ7", function(module, exports) {

$parcel$export(module.exports, "default", () => $c95c260637bde23a$export$2e2bcd8739ae039);

var $5wQ82 = parcelRequire("5wQ82");
function $c95c260637bde23a$export$2e2bcd8739ae039(o, p) {
    $c95c260637bde23a$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($5wQ82))) ? (0, (/*@__PURE__*/$parcel$interopDefault($5wQ82))).bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $c95c260637bde23a$export$2e2bcd8739ae039(o, p);
}

});
parcelRegister("5wQ82", function(module, exports) {

module.exports = (parcelRequire("1Ra8X"));

});
parcelRegister("1Ra8X", function(module, exports) {
parcelRequire("l16ba");

module.exports = (parcelRequire("dhx8H")).Object.setPrototypeOf;

});
parcelRegister("l16ba", function(module, exports) {
// 19.1.3.19 Object.setPrototypeOf(O, proto)

var $5wEa2 = parcelRequire("5wEa2");

$5wEa2($5wEa2.S, 'Object', {
    setPrototypeOf: (parcelRequire("35fJw")).set
});

});
parcelRegister("35fJw", function(module, exports) {
// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */ 
var $8T9YM = parcelRequire("8T9YM");

var $aIdHH = parcelRequire("aIdHH");
var $23ee0b0348ea4da9$var$check = function(O, proto) {
    $aIdHH(O);
    if (!$8T9YM(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};


module.exports = {
    set: Object.setPrototypeOf || ('__proto__' in {} ? function(test, buggy, set) {
        try {
            set = (parcelRequire("8fJLB"))(Function.call, (parcelRequire("2PKjW")).f(Object.prototype, '__proto__').set, 2);
            set(test, []);
            buggy = !(test instanceof Array);
        } catch (e) {
            buggy = true;
        }
        return function setPrototypeOf(O, proto) {
            $23ee0b0348ea4da9$var$check(O, proto);
            if (buggy) O.__proto__ = proto;
            else set(O, proto);
            return O;
        };
    }({}, false) : undefined),
    check: $23ee0b0348ea4da9$var$check
};

});
parcelRegister("2PKjW", function(module, exports) {

$parcel$export(module.exports, "f", () => $2104467c0339117f$export$2d1720544b23b823, (v) => $2104467c0339117f$export$2d1720544b23b823 = v);
var $2104467c0339117f$export$2d1720544b23b823;

var $4hWyV = parcelRequire("4hWyV");

var $dhKmr = parcelRequire("dhKmr");

var $6WitF = parcelRequire("6WitF");

var $1zpu5 = parcelRequire("1zpu5");

var $8uIdh = parcelRequire("8uIdh");

var $3Ksbk = parcelRequire("3Ksbk");
var $2104467c0339117f$var$gOPD = Object.getOwnPropertyDescriptor;

$2104467c0339117f$export$2d1720544b23b823 = (parcelRequire("kD5IQ")) ? $2104467c0339117f$var$gOPD : function getOwnPropertyDescriptor(O, P) {
    O = $6WitF(O);
    P = $1zpu5(P, true);
    if ($3Ksbk) try {
        return $2104467c0339117f$var$gOPD(O, P);
    } catch (e) {}
    if ($8uIdh(O, P)) return $dhKmr(!$4hWyV.f.call(O, P), O[P]);
};

});
parcelRegister("4hWyV", function(module, exports) {

$parcel$export(module.exports, "f", () => $31f62d36f059d1f7$export$2d1720544b23b823, (v) => $31f62d36f059d1f7$export$2d1720544b23b823 = v);
var $31f62d36f059d1f7$export$2d1720544b23b823;
$31f62d36f059d1f7$export$2d1720544b23b823 = ({}).propertyIsEnumerable;

});








parcelRegister("34lu7", function(module, exports) {

$parcel$export(module.exports, "default", () => $23c2693f2e66cfe6$export$2e2bcd8739ae039);

var $85I24 = parcelRequire("85I24");
function $23c2693f2e66cfe6$export$2e2bcd8739ae039() {
    $23c2693f2e66cfe6$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($85I24))) ? (0, (/*@__PURE__*/$parcel$interopDefault($85I24))).bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $23c2693f2e66cfe6$export$2e2bcd8739ae039.apply(this, arguments);
}

});
parcelRegister("85I24", function(module, exports) {

module.exports = (parcelRequire("aOK7Q"));

});
parcelRegister("aOK7Q", function(module, exports) {
parcelRequire("8ASim");

module.exports = (parcelRequire("dhx8H")).Object.assign;

});
parcelRegister("8ASim", function(module, exports) {
// 19.1.3.1 Object.assign(target, source)

var $5wEa2 = parcelRequire("5wEa2");

$5wEa2($5wEa2.S + $5wEa2.F, 'Object', {
    assign: (parcelRequire("jxu2z"))
});

});
parcelRegister("jxu2z", function(module, exports) {
'use strict';

var $kD5IQ = parcelRequire("kD5IQ");

var $kJc9M = parcelRequire("kJc9M");

var $cAldW = parcelRequire("cAldW");

var $4hWyV = parcelRequire("4hWyV");

var $1kVaN = parcelRequire("1kVaN");

var $jRK2B = parcelRequire("jRK2B");
var $e39866c849d56a4e$var$$assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$e39866c849d56a4e$var$$assign || (parcelRequire("cbAAd"))(function() {
    var A = {};
    var B = {};
    // eslint-disable-next-line no-undef
    var S = Symbol();
    var K = 'abcdefghijklmnopqrst';
    A[S] = 7;
    K.split('').forEach(function(k) {
        B[k] = k;
    });
    return $e39866c849d56a4e$var$$assign({}, A)[S] != 7 || Object.keys($e39866c849d56a4e$var$$assign({}, B)).join('') != K;
}) ? function assign(target, source) {
    var T = $1kVaN(target);
    var aLen = arguments.length;
    var index = 1;
    var getSymbols = $cAldW.f;
    var isEnum = $4hWyV.f;
    while(aLen > index){
        var S = $jRK2B(arguments[index++]);
        var keys = getSymbols ? $kJc9M(S).concat(getSymbols(S)) : $kJc9M(S);
        var length = keys.length;
        var j = 0;
        var key;
        while(length > j){
            key = keys[j++];
            if (!$kD5IQ || isEnum.call(S, key)) T[key] = S[key];
        }
    }
    return T;
} : $e39866c849d56a4e$var$$assign;

});
parcelRegister("cAldW", function(module, exports) {

$parcel$export(module.exports, "f", () => $92994f6ff34f2a23$export$2d1720544b23b823, (v) => $92994f6ff34f2a23$export$2d1720544b23b823 = v);
var $92994f6ff34f2a23$export$2d1720544b23b823;
$92994f6ff34f2a23$export$2d1720544b23b823 = Object.getOwnPropertySymbols;

});

parcelRegister("1kVaN", function(module, exports) {
// 7.1.13 ToObject(argument)

var $5XrWm = parcelRequire("5XrWm");
module.exports = function(it) {
    return Object($5XrWm(it));
};

});






parcelRegister("4QJdp", function(module, exports) {

$parcel$export(module.exports, "createStore", () => $387f179275880db7$export$f51a9068ac82ea43);
$parcel$export(module.exports, "combineReducers", () => $387f179275880db7$export$66e4520cdb265d18);
$parcel$export(module.exports, "bindActionCreators", () => $387f179275880db7$export$aea084d96e84da92);
$parcel$export(module.exports, "compose", () => $387f179275880db7$export$f672e0b6f7222cd7);
$parcel$export(module.exports, "applyMiddleware", () => $387f179275880db7$export$9ff26e0402cc7b7);

var $1Xn5q = parcelRequire("1Xn5q");
/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */ function $387f179275880db7$var$formatProdErrorMessage(code) {
    return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + 'use the non-minified dev environment for full errors. ';
}
// Inlined version of the `symbol-observable` polyfill
var $387f179275880db7$var$$$observable = function() {
    return typeof Symbol === 'function' && Symbol.observable || '@@observable';
}();
/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */ var $387f179275880db7$var$randomString = function randomString() {
    return Math.random().toString(36).substring(7).split('').join('.');
};
var $387f179275880db7$export$4219e499db7ca678 = {
    INIT: "@@redux/INIT" + $387f179275880db7$var$randomString(),
    REPLACE: "@@redux/REPLACE" + $387f179275880db7$var$randomString(),
    PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
        return "@@redux/PROBE_UNKNOWN_ACTION" + $387f179275880db7$var$randomString();
    }
};
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $387f179275880db7$var$isPlainObject(obj) {
    if (typeof obj !== 'object' || obj === null) return false;
    var proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto;
}
// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function $387f179275880db7$var$miniKindOf(val) {
    if (val === void 0) return 'undefined';
    if (val === null) return 'null';
    var type = typeof val;
    switch(type){
        case 'boolean':
        case 'string':
        case 'number':
        case 'symbol':
        case 'function':
            return type;
    }
    if (Array.isArray(val)) return 'array';
    if ($387f179275880db7$var$isDate(val)) return 'date';
    if ($387f179275880db7$var$isError(val)) return 'error';
    var constructorName = $387f179275880db7$var$ctorName(val);
    switch(constructorName){
        case 'Symbol':
        case 'Promise':
        case 'WeakMap':
        case 'WeakSet':
        case 'Map':
        case 'Set':
            return constructorName;
    } // other
    return type.slice(8, -1).toLowerCase().replace(/\s/g, '');
}
function $387f179275880db7$var$ctorName(val) {
    return typeof val.constructor === 'function' ? val.constructor.name : null;
}
function $387f179275880db7$var$isError(val) {
    return val instanceof Error || typeof val.message === 'string' && val.constructor && typeof val.constructor.stackTraceLimit === 'number';
}
function $387f179275880db7$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === 'function' && typeof val.getDate === 'function' && typeof val.setDate === 'function';
}
function $387f179275880db7$var$kindOf(val) {
    var typeOfVal = typeof val;
    return typeOfVal;
}
/**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */ function $387f179275880db7$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    var _ref2;
    if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') throw new Error($387f179275880db7$var$formatProdErrorMessage(0));
    if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
        enhancer = preloadedState;
        preloadedState = undefined;
    }
    if (typeof enhancer !== 'undefined') {
        if (typeof enhancer !== 'function') throw new Error($387f179275880db7$var$formatProdErrorMessage(1));
        return enhancer($387f179275880db7$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    if (typeof reducer !== 'function') throw new Error($387f179275880db7$var$formatProdErrorMessage(2));
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = [];
    var nextListeners = currentListeners;
    var isDispatching = false;
    /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */ function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
    }
    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
        if (isDispatching) throw new Error($387f179275880db7$var$formatProdErrorMessage(3));
        return currentState;
    }
    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
        if (typeof listener !== 'function') throw new Error($387f179275880db7$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($387f179275880db7$var$formatProdErrorMessage(5));
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        nextListeners.push(listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($387f179275880db7$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
            currentListeners = null;
        };
    }
    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
        if (!$387f179275880db7$var$isPlainObject(action)) throw new Error($387f179275880db7$var$formatProdErrorMessage(7));
        if (typeof action.type === 'undefined') throw new Error($387f179275880db7$var$formatProdErrorMessage(8));
        if (isDispatching) throw new Error($387f179275880db7$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            listener();
        }
        return action;
    }
    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
        if (typeof nextReducer !== 'function') throw new Error($387f179275880db7$var$formatProdErrorMessage(10));
        currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
        // Any reducers that existed in both the new and old rootReducer
        // will receive the previous state. This effectively populates
        // the new state tree with any relevant data from the old one.
        dispatch({
            type: $387f179275880db7$export$4219e499db7ca678.REPLACE
        });
    }
    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
        var _ref;
        var outerSubscribe = subscribe;
        return _ref = {
            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                if (typeof observer !== 'object' || observer === null) throw new Error($387f179275880db7$var$formatProdErrorMessage(11));
                function observeState() {
                    if (observer.next) observer.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, _ref[$387f179275880db7$var$$$observable] = function() {
            return this;
        }, _ref;
    } // When a store is created, an "INIT" action is dispatched so that every
    // reducer returns their initial state. This effectively populates
    // the initial state tree.
    dispatch({
        type: $387f179275880db7$export$4219e499db7ca678.INIT
    });
    return _ref2 = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, _ref2[$387f179275880db7$var$$$observable] = observable, _ref2;
}
/**
 * Creates a Redux store that holds the state tree.
 *
 * **We recommend using `configureStore` from the
 * `@reduxjs/toolkit` package**, which replaces `createStore`:
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */ var $387f179275880db7$export$8928921ea2d3b126 = $387f179275880db7$export$f51a9068ac82ea43;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $387f179275880db7$var$warning(message) {
    /* eslint-disable no-console */ if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    } catch (e) {} // eslint-disable-line no-empty
}
function $387f179275880db7$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === $387f179275880db7$export$4219e499db7ca678.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$387f179275880db7$var$isPlainObject(inputState)) return "The " + argumentName + " has unexpected type of \"" + $387f179275880db7$var$kindOf(inputState) + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $387f179275880db7$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
}
function $387f179275880db7$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(undefined, {
            type: $387f179275880db7$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === 'undefined') throw new Error($387f179275880db7$var$formatProdErrorMessage(12));
        if (typeof reducer(undefined, {
            type: $387f179275880db7$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === 'undefined') throw new Error($387f179275880db7$var$formatProdErrorMessage(13));
    });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */ function $387f179275880db7$export$66e4520cdb265d18(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === 'function') finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
    // keys multiple times.
    var unexpectedKeyCache;
    var shapeAssertionError;
    try {
        $387f179275880db7$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state, action) {
        if (state === void 0) state = {};
        if (shapeAssertionError) throw shapeAssertionError;
        var warningMessage;
        var hasChanged = false;
        var nextState = {};
        for(var _i = 0; _i < finalReducerKeys.length; _i++){
            var _key = finalReducerKeys[_i];
            var reducer = finalReducers[_key];
            var previousStateForKey = state[_key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === 'undefined') {
                var actionType = action && action.type;
                throw new Error($387f179275880db7$var$formatProdErrorMessage(14));
            }
            nextState[_key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
function $387f179275880db7$var$bindActionCreator(actionCreator, dispatch) {
    return function() {
        return dispatch(actionCreator.apply(this, arguments));
    };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */ function $387f179275880db7$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === 'function') return $387f179275880db7$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== 'object' || actionCreators === null) throw new Error($387f179275880db7$var$formatProdErrorMessage(16));
    var boundActionCreators = {};
    for(var key in actionCreators){
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === 'function') boundActionCreators[key] = $387f179275880db7$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */ function $387f179275880db7$export$f672e0b6f7222cd7() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            return a(b.apply(void 0, arguments));
        };
    });
}
/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */ function $387f179275880db7$export$9ff26e0402cc7b7() {
    for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
    return function(createStore) {
        return function() {
            var store = createStore.apply(void 0, arguments);
            var _dispatch = function dispatch() {
                throw new Error($387f179275880db7$var$formatProdErrorMessage(15));
            };
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function dispatch() {
                    return _dispatch.apply(void 0, arguments);
                }
            };
            var chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            _dispatch = $387f179275880db7$export$f672e0b6f7222cd7.apply(void 0, chain)(store.dispatch);
            return (0, $1Xn5q.default)((0, $1Xn5q.default)({}, store), {}, {
                dispatch: _dispatch
            });
        };
    };
}

});
parcelRegister("1Xn5q", function(module, exports) {

$parcel$export(module.exports, "default", () => $16cd35a30248fb20$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");
function $16cd35a30248fb20$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $16cd35a30248fb20$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $16cd35a30248fb20$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $16cd35a30248fb20$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}

});


parcelRegister("jJs3W", function(module, exports) {
$parcel$export(module.exports, "connect", () => (parcelRequire("94zHK")).default);
$parcel$export(module.exports, "Provider", () => (parcelRequire("b02ud")).default);
$parcel$export(module.exports, "useDispatch", () => (parcelRequire("6N2vY")).useDispatch);
$parcel$export(module.exports, "useSelector", () => (parcelRequire("cU4FA")).useSelector);
parcelRequire("lPIk7");
parcelRequire("035eW");
var $lEfVV = parcelRequire("lEfVV");

var $4Ut1d = parcelRequire("4Ut1d");
// with standard React renderers (ReactDOM, React Native)
(0, $4Ut1d.setBatch)((0, $lEfVV.unstable_batchedUpdates));

});
parcelRegister("lPIk7", function(module, exports) {

$parcel$export(module.exports, "Provider", () => (parcelRequire("b02ud")).default);
$parcel$export(module.exports, "connect", () => (parcelRequire("94zHK")).default);
$parcel$export(module.exports, "useDispatch", () => (parcelRequire("6N2vY")).useDispatch);
$parcel$export(module.exports, "useSelector", () => (parcelRequire("cU4FA")).useSelector);

var $b02ud = parcelRequire("b02ud");

var $lwCWn = parcelRequire("lwCWn");

var $iqB4h = parcelRequire("iqB4h");

var $94zHK = parcelRequire("94zHK");

var $6N2vY = parcelRequire("6N2vY");

var $cU4FA = parcelRequire("cU4FA");

var $2bGhE = parcelRequire("2bGhE");

var $9UMSs = parcelRequire("9UMSs");

});
parcelRegister("b02ud", function(module, exports) {

$parcel$export(module.exports, "default", () => $80219f881731fd50$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");


var $iqB4h = parcelRequire("iqB4h");

var $eOZYb = parcelRequire("eOZYb");

var $8RW1t = parcelRequire("8RW1t");
function $80219f881731fd50$var$Provider(_ref) {
    var store = _ref.store, context = _ref.context, children = _ref.children;
    var contextValue = (0, $eUqFw.useMemo)(function() {
        var subscription = (0, $eOZYb.createSubscription)(store);
        return {
            store: store,
            subscription: subscription
        };
    }, [
        store
    ]);
    var previousState = (0, $eUqFw.useMemo)(function() {
        return store.getState();
    }, [
        store
    ]);
    (0, $8RW1t.useIsomorphicLayoutEffect)(function() {
        var subscription = contextValue.subscription;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return function() {
            subscription.tryUnsubscribe();
            subscription.onStateChange = null;
        };
    }, [
        contextValue,
        previousState
    ]);
    var Context = context || (0, $iqB4h.ReactReduxContext);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $80219f881731fd50$export$2e2bcd8739ae039 = $80219f881731fd50$var$Provider;

});
parcelRegister("iqB4h", function(module, exports) {

$parcel$export(module.exports, "ReactReduxContext", () => $d6a768a4a73470b3$export$cc80c08dc91f1c00);

var $eUqFw = parcelRequire("eUqFw");
var $d6a768a4a73470b3$export$cc80c08dc91f1c00 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext(null);
var $d6a768a4a73470b3$export$2e2bcd8739ae039 = $d6a768a4a73470b3$export$cc80c08dc91f1c00;

});

parcelRegister("eOZYb", function(module, exports) {

$parcel$export(module.exports, "createSubscription", () => $aca5ce1240833bb9$export$d567d2b9af322f8f);

var $4Ut1d = parcelRequire("4Ut1d");
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
function $aca5ce1240833bb9$var$createListenerCollection() {
    var batch = (0, $4Ut1d.getBatch)();
    var first = null;
    var last = null;
    return {
        clear: function clear() {
            first = null;
            last = null;
        },
        notify: function notify() {
            batch(function() {
                var listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get: function get() {
            var listeners = [];
            var listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe: function subscribe(callback) {
            var isSubscribed = true;
            var listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
var $aca5ce1240833bb9$var$nullListeners = {
    notify: function notify() {},
    get: function get() {
        return [];
    }
};
function $aca5ce1240833bb9$export$d567d2b9af322f8f(store, parentSub) {
    var unsubscribe;
    var listeners = $aca5ce1240833bb9$var$nullListeners;
    function addNestedSub(listener) {
        trySubscribe();
        return listeners.subscribe(listener);
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return Boolean(unsubscribe);
    }
    function trySubscribe() {
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $aca5ce1240833bb9$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        if (unsubscribe) {
            unsubscribe();
            unsubscribe = undefined;
            listeners.clear();
            listeners = $aca5ce1240833bb9$var$nullListeners;
        }
    }
    var subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribe,
        tryUnsubscribe: tryUnsubscribe,
        getListeners: function getListeners() {
            return listeners;
        }
    };
    return subscription;
}

});
parcelRegister("4Ut1d", function(module, exports) {

$parcel$export(module.exports, "setBatch", () => $3932e6df69670101$export$4b9874722d0da7bc);
$parcel$export(module.exports, "getBatch", () => $3932e6df69670101$export$fc47d4c0ba3bd2c6);
// Default to a dummy "batch" implementation that just runs the callback
function $3932e6df69670101$var$defaultNoopBatch(callback) {
    callback();
}
var $3932e6df69670101$var$batch = $3932e6df69670101$var$defaultNoopBatch; // Allow injecting another batching function later
var $3932e6df69670101$export$4b9874722d0da7bc = function setBatch(newBatch) {
    return $3932e6df69670101$var$batch = newBatch;
}; // Supply a getter just to skip dealing with ESM bindings
var $3932e6df69670101$export$fc47d4c0ba3bd2c6 = function getBatch() {
    return $3932e6df69670101$var$batch;
};

});


parcelRegister("8RW1t", function(module, exports) {

$parcel$export(module.exports, "useIsomorphicLayoutEffect", () => $67504818408d46d4$export$700979bc83e7db82);

var $eUqFw = parcelRequire("eUqFw");
var $67504818408d46d4$export$700979bc83e7db82 = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? (0, $eUqFw.useLayoutEffect) : (0, $eUqFw.useEffect);

});


parcelRegister("lwCWn", function(module, exports) {

$parcel$export(module.exports, "default", () => $fabacaeccb986465$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $6XgOP = parcelRequire("6XgOP");

var $lxchL = parcelRequire("lxchL");

var $eUqFw = parcelRequire("eUqFw");

var $8T8or = parcelRequire("8T8or");

var $eOZYb = parcelRequire("eOZYb");

var $8RW1t = parcelRequire("8RW1t");

var $iqB4h = parcelRequire("iqB4h");
var $fabacaeccb986465$var$_excluded = [
    "getDisplayName",
    "methodName",
    "renderCountProp",
    "shouldHandleStateChanges",
    "storeKey",
    "withRef",
    "forwardRef",
    "context"
], $fabacaeccb986465$var$_excluded2 = [
    "reactReduxForwardedRef"
];
var $fabacaeccb986465$var$EMPTY_ARRAY = [];
var $fabacaeccb986465$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
];
var $fabacaeccb986465$var$stringifyComponent = function stringifyComponent(Comp) {
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
function $fabacaeccb986465$var$storeStateUpdatesReducer(state, action) {
    var updateCount = state[1];
    return [
        action.payload,
        updateCount + 1
    ];
}
function $fabacaeccb986465$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    (0, $8RW1t.useIsomorphicLayoutEffect)(function() {
        return effectFunc.apply(void 0, effectArgs);
    }, dependencies);
}
function $fabacaeccb986465$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, actualChildProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    // We want to capture the wrapper props and child props we used for later comparisons
    lastWrapperProps.current = wrapperProps;
    lastChildProps.current = actualChildProps;
    renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
}
function $fabacaeccb986465$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, childPropsFromStoreUpdate, notifyNestedSubs, forceComponentUpdateDispatch) {
    // If we're not subscribed to the store, nothing to do here
    if (!shouldHandleStateChanges) return; // Capture values for checking if and when this component unmounts
    var didUnsubscribe = false;
    var lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component
    var checkForUpdates = function checkForUpdates() {
        if (didUnsubscribe) // Don't run stale listeners.
        // Redux doesn't guarantee unsubscriptions happen until next dispatch.
        return;
        var latestStoreState = store.getState();
        var newChildProps, error;
        try {
            // Actually run the selector with the most recent store state and wrapper props
            // to determine what the child props should be
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
         // If the child props haven't changed, nothing to do here - cascade the subscription update
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            // Save references to the new child props.  Note that we track the "child props from store update"
            // as a ref instead of a useState/useReducer because we need a way to determine if that value has
            // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
            // forcing another re-render, which we don't want.
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true; // If the child props _did_ change (or we caught an error), this wrapper component needs to re-render
            forceComponentUpdateDispatch({
                type: 'STORE_UPDATED',
                payload: {
                    error: error
                }
            });
        }
    }; // Actually subscribe to the nearest connected ancestor (or store)
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe(); // Pull data from the store after first render in case the store has
    // changed since we began.
    checkForUpdates();
    var unsubscribeWrapper = function unsubscribeWrapper() {
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) // It's possible that we caught an error due to a bad mapState function, but the
        // parent re-rendered without this component and we're about to unmount.
        // This shouldn't happen as long as we do top-down subscriptions correctly, but
        // if we ever do those wrong, this throw will surface the error in our tests.
        // In that case, throw the error from here so it doesn't get lost.
        throw lastThrownError;
    };
    return unsubscribeWrapper;
}
var $fabacaeccb986465$var$initStateUpdates = function initStateUpdates() {
    return [
        null,
        0
    ];
};
function $fabacaeccb986465$export$2e2bcd8739ae039(/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
      export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
    Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
    Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/ selectorFactory, _ref) {
    if (_ref === void 0) _ref = {};
    var _ref2 = _ref, _ref2$getDisplayName = _ref2.getDisplayName, getDisplayName = _ref2$getDisplayName === void 0 ? function(name) {
        return "ConnectAdvanced(" + name + ")";
    } : _ref2$getDisplayName, _ref2$methodName = _ref2.methodName, methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName, _ref2$renderCountProp = _ref2.renderCountProp, renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp, _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges, shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta, _ref2$storeKey = _ref2.storeKey, storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey, _ref2$withRef = _ref2.withRef, withRef = _ref2$withRef === void 0 ? false : _ref2$withRef, _ref2$forwardRef = _ref2.forwardRef, forwardRef = _ref2$forwardRef === void 0 ? false : _ref2$forwardRef, _ref2$context = _ref2.context, context = _ref2$context === void 0 ? (0, $iqB4h.ReactReduxContext) : _ref2$context, connectOptions = (0, $6XgOP.default)(_ref2, $fabacaeccb986465$var$_excluded);
    var customStoreWarningMessage;
    var Context = context;
    return function wrapWithConnect(WrappedComponent) {
        var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
        var displayName = getDisplayName(wrappedComponentName);
        var selectorFactoryOptions = (0, $kU09D.default)({}, connectOptions, {
            getDisplayName: getDisplayName,
            methodName: methodName,
            renderCountProp: renderCountProp,
            shouldHandleStateChanges: shouldHandleStateChanges,
            storeKey: storeKey,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent
        });
        var pure = connectOptions.pure;
        function createChildSelector(store) {
            return selectorFactory(store.dispatch, selectorFactoryOptions);
        } // If we aren't running in "pure" mode, we don't want to memoize values.
        // To avoid conditionally calling hooks, we fall back to a tiny wrapper
        // that just executes the given callback immediately.
        var usePureOnlyMemo = pure ? (0, $eUqFw.useMemo) : function(callback) {
            return callback();
        };
        function ConnectFunction(props) {
            var _useMemo = (0, $eUqFw.useMemo)(function() {
                // Distinguish between actual "data" props that were passed to the wrapper component,
                // and values needed to control behavior (forwarded refs, alternate context instances).
                // To maintain the wrapperProps object reference, memoize this destructuring.
                var reactReduxForwardedRef = props.reactReduxForwardedRef, wrapperProps = (0, $6XgOP.default)(props, $fabacaeccb986465$var$_excluded2);
                return [
                    props.context,
                    reactReduxForwardedRef,
                    wrapperProps
                ];
            }, [
                props
            ]), propsContext = _useMemo[0], reactReduxForwardedRef = _useMemo[1], wrapperProps = _useMemo[2];
            var ContextToUse = (0, $eUqFw.useMemo)(function() {
                // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
                // Memoize the check that determines which context instance we should use.
                return propsContext && propsContext.Consumer && (0, $8T8or.isContextConsumer)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(propsContext.Consumer, null)) ? propsContext : Context;
            }, [
                propsContext,
                Context
            ]); // Retrieve the store and ancestor subscription via context, if available
            var contextValue = (0, $eUqFw.useContext)(ContextToUse); // The store _must_ exist as either a prop or in context.
            // We'll check to see if it _looks_ like a Redux store first.
            // This allows us to pass through a `store` prop that is just a plain value.
            var didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            var didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            var store = didStoreComeFromProps ? props.store : contextValue.store;
            var childPropsSelector = (0, $eUqFw.useMemo)(function() {
                // The child props selector needs the store reference as an input.
                // Re-create this selector whenever the store changes.
                return createChildSelector(store);
            }, [
                store
            ]);
            var _useMemo2 = (0, $eUqFw.useMemo)(function() {
                if (!shouldHandleStateChanges) return $fabacaeccb986465$var$NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                var subscription = (0, $eOZYb.createSubscription)(store, didStoreComeFromProps ? null : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                var notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
                return [
                    subscription,
                    notifyNestedSubs
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]), subscription = _useMemo2[0], notifyNestedSubs = _useMemo2[1]; // Determine what {store, subscription} value should be put into nested context, if necessary,
            // and memoize that value to avoid unnecessary context updates.
            var overriddenContextValue = (0, $eUqFw.useMemo)(function() {
                if (didStoreComeFromProps) // This component is directly subscribed to a store from props.
                // We don't want descendants reading from this store - pass down whatever
                // the existing context value is from the nearest connected ancestor.
                return contextValue;
                 // Otherwise, put this component's subscription instance into context, so that
                // connected descendants won't update until after this component is done
                return (0, $kU09D.default)({}, contextValue, {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]); // We need to force this wrapper component to re-render whenever a Redux store update
            // causes a change to the calculated child component props (or we caught an error in mapState)
            var _useReducer = (0, $eUqFw.useReducer)($fabacaeccb986465$var$storeStateUpdatesReducer, $fabacaeccb986465$var$EMPTY_ARRAY, $fabacaeccb986465$var$initStateUpdates), _useReducer$ = _useReducer[0], previousStateUpdateResult = _useReducer$[0], forceComponentUpdateDispatch = _useReducer[1]; // Propagate any mapState/mapDispatch errors upwards
            if (previousStateUpdateResult && previousStateUpdateResult.error) throw previousStateUpdateResult.error;
             // Set up refs to coordinate values between the subscription effect and the render logic
            var lastChildProps = (0, $eUqFw.useRef)();
            var lastWrapperProps = (0, $eUqFw.useRef)(wrapperProps);
            var childPropsFromStoreUpdate = (0, $eUqFw.useRef)();
            var renderIsScheduled = (0, $eUqFw.useRef)(false);
            var actualChildProps = usePureOnlyMemo(function() {
                // Tricky logic here:
                // - This render may have been triggered by a Redux store update that produced new child props
                // - However, we may have gotten new wrapper props after that
                // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
                // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
                // So, we'll use the child props from store update only if the wrapper props are the same as last time.
                if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                 // TODO We're reading the store directly in render() here. Bad idea?
                // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
                // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
                // to determine what the child props should be.
                return childPropsSelector(store.getState(), wrapperProps);
            }, [
                store,
                previousStateUpdateResult,
                wrapperProps
            ]); // We need this to execute synchronously every time we re-render. However, React warns
            // about useLayoutEffect in SSR, so we try to detect environment and fall back to
            // just useEffect instead to avoid the warning, since neither will run anyway.
            $fabacaeccb986465$var$useIsomorphicLayoutEffectWithArgs($fabacaeccb986465$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                actualChildProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]); // Our re-subscribe logic only runs when the store/subscription setup changes
            $fabacaeccb986465$var$useIsomorphicLayoutEffectWithArgs($fabacaeccb986465$var$subscribeUpdates, [
                shouldHandleStateChanges,
                store,
                subscription,
                childPropsSelector,
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                childPropsFromStoreUpdate,
                notifyNestedSubs,
                forceComponentUpdateDispatch
            ], [
                store,
                subscription,
                childPropsSelector
            ]); // Now that all that's done, we can finally try to actually render the child component.
            // We memoize the elements for the rendered child component as an optimization.
            var renderedWrappedComponent = (0, $eUqFw.useMemo)(function() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, (0, $kU09D.default)({}, actualChildProps, {
                    ref: reactReduxForwardedRef
                }));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]); // If React sees the exact same element reference as last time, it bails out of re-rendering
            // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.
            var renderedChild = (0, $eUqFw.useMemo)(function() {
                if (shouldHandleStateChanges) // If this component is subscribed to store updates, we need to pass its own
                // subscription instance down to our descendants. That means rendering the same
                // Context instance, and putting a different value into the context.
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        } // If we're in "pure" mode, ensure our wrapper component only re-renders when incoming props have changed.
        var Connect = pure ? (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).memo(ConnectFunction) : ConnectFunction;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            var forwarded = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef(function forwardConnectRef(props, ref) {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Connect, (0, $kU09D.default)({}, props, {
                    reactReduxForwardedRef: ref
                }));
            });
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return (0, (/*@__PURE__*/$parcel$interopDefault($lxchL)))(forwarded, WrappedComponent);
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($lxchL)))(Connect, WrappedComponent);
    };
}

});
parcelRegister("8T8or", function(module, exports) {
'use strict';

module.exports = (parcelRequire("eU3cC"));

});
parcelRegister("eU3cC", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", () => $ad98c79b0cc564ad$export$a7c73072b1a182ae, (v) => $ad98c79b0cc564ad$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $ad98c79b0cc564ad$export$9f27bc3417b4524d, (v) => $ad98c79b0cc564ad$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $ad98c79b0cc564ad$export$db77ccec0bb4ccac, (v) => $ad98c79b0cc564ad$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $ad98c79b0cc564ad$export$8392c0c9d3dcbd35, (v) => $ad98c79b0cc564ad$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $ad98c79b0cc564ad$export$ffb0004e005737fa, (v) => $ad98c79b0cc564ad$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $ad98c79b0cc564ad$export$b624eff549462981, (v) => $ad98c79b0cc564ad$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $ad98c79b0cc564ad$export$7897aa7841a5380c, (v) => $ad98c79b0cc564ad$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $ad98c79b0cc564ad$export$602eac185826482c, (v) => $ad98c79b0cc564ad$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $ad98c79b0cc564ad$export$e2c29f18771995cb, (v) => $ad98c79b0cc564ad$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $ad98c79b0cc564ad$export$5f8d39834fd61797, (v) => $ad98c79b0cc564ad$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $ad98c79b0cc564ad$export$74bf444e3cd11ea5, (v) => $ad98c79b0cc564ad$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $ad98c79b0cc564ad$export$92387174baf9b227, (v) => $ad98c79b0cc564ad$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $ad98c79b0cc564ad$export$ec112efeb987d9c6, (v) => $ad98c79b0cc564ad$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $ad98c79b0cc564ad$export$b706b080d889d2c9, (v) => $ad98c79b0cc564ad$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $ad98c79b0cc564ad$export$5be5a87408f70ddc, (v) => $ad98c79b0cc564ad$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $ad98c79b0cc564ad$export$45a5e7f76e0caa8d, (v) => $ad98c79b0cc564ad$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $ad98c79b0cc564ad$export$455c2e768291efa6, (v) => $ad98c79b0cc564ad$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $ad98c79b0cc564ad$export$9522e17588c12572, (v) => $ad98c79b0cc564ad$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $ad98c79b0cc564ad$export$2110ac352bb060b9, (v) => $ad98c79b0cc564ad$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $ad98c79b0cc564ad$export$56885ab8b9c456ab, (v) => $ad98c79b0cc564ad$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $ad98c79b0cc564ad$export$d927fcb6adf8f9de, (v) => $ad98c79b0cc564ad$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $ad98c79b0cc564ad$export$b82d16f27459e05a, (v) => $ad98c79b0cc564ad$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $ad98c79b0cc564ad$export$522c17b4f5e123e8, (v) => $ad98c79b0cc564ad$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $ad98c79b0cc564ad$export$1aabd8a0274ecfd6, (v) => $ad98c79b0cc564ad$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $ad98c79b0cc564ad$export$9b621391a187a31a, (v) => $ad98c79b0cc564ad$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $ad98c79b0cc564ad$export$f5bbd400c2f4426f, (v) => $ad98c79b0cc564ad$export$f5bbd400c2f4426f = v);
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $ad98c79b0cc564ad$export$a7c73072b1a182ae;
var $ad98c79b0cc564ad$export$9f27bc3417b4524d;
var $ad98c79b0cc564ad$export$db77ccec0bb4ccac;
var $ad98c79b0cc564ad$export$8392c0c9d3dcbd35;
var $ad98c79b0cc564ad$export$ffb0004e005737fa;
var $ad98c79b0cc564ad$export$b624eff549462981;
var $ad98c79b0cc564ad$export$7897aa7841a5380c;
var $ad98c79b0cc564ad$export$602eac185826482c;
var $ad98c79b0cc564ad$export$e2c29f18771995cb;
var $ad98c79b0cc564ad$export$5f8d39834fd61797;
var $ad98c79b0cc564ad$export$74bf444e3cd11ea5;
var $ad98c79b0cc564ad$export$92387174baf9b227;
var $ad98c79b0cc564ad$export$ec112efeb987d9c6;
var $ad98c79b0cc564ad$export$b706b080d889d2c9;
var $ad98c79b0cc564ad$export$5be5a87408f70ddc;
var $ad98c79b0cc564ad$export$45a5e7f76e0caa8d;
var $ad98c79b0cc564ad$export$455c2e768291efa6;
var $ad98c79b0cc564ad$export$9522e17588c12572;
var $ad98c79b0cc564ad$export$2110ac352bb060b9;
var $ad98c79b0cc564ad$export$56885ab8b9c456ab;
var $ad98c79b0cc564ad$export$d927fcb6adf8f9de;
var $ad98c79b0cc564ad$export$b82d16f27459e05a;
var $ad98c79b0cc564ad$export$522c17b4f5e123e8;
var $ad98c79b0cc564ad$export$1aabd8a0274ecfd6;
var $ad98c79b0cc564ad$export$9b621391a187a31a;
var $ad98c79b0cc564ad$export$f5bbd400c2f4426f;
'use strict';
var $ad98c79b0cc564ad$var$b = 60103, $ad98c79b0cc564ad$var$c = 60106, $ad98c79b0cc564ad$var$d = 60107, $ad98c79b0cc564ad$var$e = 60108, $ad98c79b0cc564ad$var$f = 60114, $ad98c79b0cc564ad$var$g = 60109, $ad98c79b0cc564ad$var$h = 60110, $ad98c79b0cc564ad$var$k = 60112, $ad98c79b0cc564ad$var$l = 60113, $ad98c79b0cc564ad$var$m = 60120, $ad98c79b0cc564ad$var$n = 60115, $ad98c79b0cc564ad$var$p = 60116, $ad98c79b0cc564ad$var$q = 60121, $ad98c79b0cc564ad$var$r = 60122, $ad98c79b0cc564ad$var$u = 60117, $ad98c79b0cc564ad$var$v = 60129, $ad98c79b0cc564ad$var$w = 60131;
if ("function" === typeof Symbol && Symbol.for) {
    var $ad98c79b0cc564ad$var$x = Symbol.for;
    $ad98c79b0cc564ad$var$b = $ad98c79b0cc564ad$var$x("react.element");
    $ad98c79b0cc564ad$var$c = $ad98c79b0cc564ad$var$x("react.portal");
    $ad98c79b0cc564ad$var$d = $ad98c79b0cc564ad$var$x("react.fragment");
    $ad98c79b0cc564ad$var$e = $ad98c79b0cc564ad$var$x("react.strict_mode");
    $ad98c79b0cc564ad$var$f = $ad98c79b0cc564ad$var$x("react.profiler");
    $ad98c79b0cc564ad$var$g = $ad98c79b0cc564ad$var$x("react.provider");
    $ad98c79b0cc564ad$var$h = $ad98c79b0cc564ad$var$x("react.context");
    $ad98c79b0cc564ad$var$k = $ad98c79b0cc564ad$var$x("react.forward_ref");
    $ad98c79b0cc564ad$var$l = $ad98c79b0cc564ad$var$x("react.suspense");
    $ad98c79b0cc564ad$var$m = $ad98c79b0cc564ad$var$x("react.suspense_list");
    $ad98c79b0cc564ad$var$n = $ad98c79b0cc564ad$var$x("react.memo");
    $ad98c79b0cc564ad$var$p = $ad98c79b0cc564ad$var$x("react.lazy");
    $ad98c79b0cc564ad$var$q = $ad98c79b0cc564ad$var$x("react.block");
    $ad98c79b0cc564ad$var$r = $ad98c79b0cc564ad$var$x("react.server.block");
    $ad98c79b0cc564ad$var$u = $ad98c79b0cc564ad$var$x("react.fundamental");
    $ad98c79b0cc564ad$var$v = $ad98c79b0cc564ad$var$x("react.debug_trace_mode");
    $ad98c79b0cc564ad$var$w = $ad98c79b0cc564ad$var$x("react.legacy_hidden");
}
function $ad98c79b0cc564ad$var$y(a) {
    if ("object" === typeof a && null !== a) {
        var t = a.$$typeof;
        switch(t){
            case $ad98c79b0cc564ad$var$b:
                switch(a = a.type, a){
                    case $ad98c79b0cc564ad$var$d:
                    case $ad98c79b0cc564ad$var$f:
                    case $ad98c79b0cc564ad$var$e:
                    case $ad98c79b0cc564ad$var$l:
                    case $ad98c79b0cc564ad$var$m:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $ad98c79b0cc564ad$var$h:
                            case $ad98c79b0cc564ad$var$k:
                            case $ad98c79b0cc564ad$var$p:
                            case $ad98c79b0cc564ad$var$n:
                            case $ad98c79b0cc564ad$var$g:
                                return a;
                            default:
                                return t;
                        }
                }
            case $ad98c79b0cc564ad$var$c:
                return t;
        }
    }
}
var $ad98c79b0cc564ad$var$z = $ad98c79b0cc564ad$var$g, $ad98c79b0cc564ad$var$A = $ad98c79b0cc564ad$var$b, $ad98c79b0cc564ad$var$B = $ad98c79b0cc564ad$var$k, $ad98c79b0cc564ad$var$C = $ad98c79b0cc564ad$var$d, $ad98c79b0cc564ad$var$D = $ad98c79b0cc564ad$var$p, $ad98c79b0cc564ad$var$E = $ad98c79b0cc564ad$var$n, $ad98c79b0cc564ad$var$F = $ad98c79b0cc564ad$var$c, $ad98c79b0cc564ad$var$G = $ad98c79b0cc564ad$var$f, $ad98c79b0cc564ad$var$H = $ad98c79b0cc564ad$var$e, $ad98c79b0cc564ad$var$I = $ad98c79b0cc564ad$var$l;
$ad98c79b0cc564ad$export$a7c73072b1a182ae = $ad98c79b0cc564ad$var$h;
$ad98c79b0cc564ad$export$9f27bc3417b4524d = $ad98c79b0cc564ad$var$z;
$ad98c79b0cc564ad$export$db77ccec0bb4ccac = $ad98c79b0cc564ad$var$A;
$ad98c79b0cc564ad$export$8392c0c9d3dcbd35 = $ad98c79b0cc564ad$var$B;
$ad98c79b0cc564ad$export$ffb0004e005737fa = $ad98c79b0cc564ad$var$C;
$ad98c79b0cc564ad$export$b624eff549462981 = $ad98c79b0cc564ad$var$D;
$ad98c79b0cc564ad$export$7897aa7841a5380c = $ad98c79b0cc564ad$var$E;
$ad98c79b0cc564ad$export$602eac185826482c = $ad98c79b0cc564ad$var$F;
$ad98c79b0cc564ad$export$e2c29f18771995cb = $ad98c79b0cc564ad$var$G;
$ad98c79b0cc564ad$export$5f8d39834fd61797 = $ad98c79b0cc564ad$var$H;
$ad98c79b0cc564ad$export$74bf444e3cd11ea5 = $ad98c79b0cc564ad$var$I;
$ad98c79b0cc564ad$export$92387174baf9b227 = function() {
    return !1;
};
$ad98c79b0cc564ad$export$ec112efeb987d9c6 = function() {
    return !1;
};
$ad98c79b0cc564ad$export$b706b080d889d2c9 = function(a) {
    return $ad98c79b0cc564ad$var$y(a) === $ad98c79b0cc564ad$var$h;
};
$ad98c79b0cc564ad$export$5be5a87408f70ddc = function(a) {
    return $ad98c79b0cc564ad$var$y(a) === $ad98c79b0cc564ad$var$g;
};
$ad98c79b0cc564ad$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $ad98c79b0cc564ad$var$b;
};
$ad98c79b0cc564ad$export$455c2e768291efa6 = function(a) {
    return $ad98c79b0cc564ad$var$y(a) === $ad98c79b0cc564ad$var$k;
};
$ad98c79b0cc564ad$export$9522e17588c12572 = function(a) {
    return $ad98c79b0cc564ad$var$y(a) === $ad98c79b0cc564ad$var$d;
};
$ad98c79b0cc564ad$export$2110ac352bb060b9 = function(a) {
    return $ad98c79b0cc564ad$var$y(a) === $ad98c79b0cc564ad$var$p;
};
$ad98c79b0cc564ad$export$56885ab8b9c456ab = function(a) {
    return $ad98c79b0cc564ad$var$y(a) === $ad98c79b0cc564ad$var$n;
};
$ad98c79b0cc564ad$export$d927fcb6adf8f9de = function(a) {
    return $ad98c79b0cc564ad$var$y(a) === $ad98c79b0cc564ad$var$c;
};
$ad98c79b0cc564ad$export$b82d16f27459e05a = function(a) {
    return $ad98c79b0cc564ad$var$y(a) === $ad98c79b0cc564ad$var$f;
};
$ad98c79b0cc564ad$export$522c17b4f5e123e8 = function(a) {
    return $ad98c79b0cc564ad$var$y(a) === $ad98c79b0cc564ad$var$e;
};
$ad98c79b0cc564ad$export$1aabd8a0274ecfd6 = function(a) {
    return $ad98c79b0cc564ad$var$y(a) === $ad98c79b0cc564ad$var$l;
};
$ad98c79b0cc564ad$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $ad98c79b0cc564ad$var$d || a === $ad98c79b0cc564ad$var$f || a === $ad98c79b0cc564ad$var$v || a === $ad98c79b0cc564ad$var$e || a === $ad98c79b0cc564ad$var$l || a === $ad98c79b0cc564ad$var$m || a === $ad98c79b0cc564ad$var$w || "object" === typeof a && null !== a && (a.$$typeof === $ad98c79b0cc564ad$var$p || a.$$typeof === $ad98c79b0cc564ad$var$n || a.$$typeof === $ad98c79b0cc564ad$var$g || a.$$typeof === $ad98c79b0cc564ad$var$h || a.$$typeof === $ad98c79b0cc564ad$var$k || a.$$typeof === $ad98c79b0cc564ad$var$u || a.$$typeof === $ad98c79b0cc564ad$var$q || a[0] === $ad98c79b0cc564ad$var$r) ? !0 : !1;
};
$ad98c79b0cc564ad$export$f5bbd400c2f4426f = $ad98c79b0cc564ad$var$y;

});



parcelRegister("94zHK", function(module, exports) {

$parcel$export(module.exports, "default", () => $69b02ef9f183b3d3$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $6XgOP = parcelRequire("6XgOP");

var $lwCWn = parcelRequire("lwCWn");

var $9UMSs = parcelRequire("9UMSs");

var $foygv = parcelRequire("foygv");

var $jjA10 = parcelRequire("jjA10");

var $2Spd8 = parcelRequire("2Spd8");

var $eEprf = parcelRequire("eEprf");
var $69b02ef9f183b3d3$var$_excluded = [
    "pure",
    "areStatesEqual",
    "areOwnPropsEqual",
    "areStatePropsEqual",
    "areMergedPropsEqual"
];
/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */ function $69b02ef9f183b3d3$var$match(arg, factories, name) {
    for(var i = factories.length - 1; i >= 0; i--){
        var result = factories[i](arg);
        if (result) return result;
    }
    return function(dispatch, options) {
        throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
    };
}
function $69b02ef9f183b3d3$var$strictEqual(a, b) {
    return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
function $69b02ef9f183b3d3$export$9f9feb656dec1fc4(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, _ref$connectHOC = _ref.connectHOC, connectHOC = _ref$connectHOC === void 0 ? (0, $lwCWn.default) : _ref$connectHOC, _ref$mapStateToPropsF = _ref.mapStateToPropsFactories, mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? (0, $jjA10.default) : _ref$mapStateToPropsF, _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories, mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? (0, $foygv.default) : _ref$mapDispatchToPro, _ref$mergePropsFactor = _ref.mergePropsFactories, mergePropsFactories = _ref$mergePropsFactor === void 0 ? (0, $2Spd8.default) : _ref$mergePropsFactor, _ref$selectorFactory = _ref.selectorFactory, selectorFactory = _ref$selectorFactory === void 0 ? (0, $eEprf.default) : _ref$selectorFactory;
    return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
        if (_ref2 === void 0) _ref2 = {};
        var _ref3 = _ref2, _ref3$pure = _ref3.pure, pure = _ref3$pure === void 0 ? true : _ref3$pure, _ref3$areStatesEqual = _ref3.areStatesEqual, areStatesEqual = _ref3$areStatesEqual === void 0 ? $69b02ef9f183b3d3$var$strictEqual : _ref3$areStatesEqual, _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual, areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? (0, $9UMSs.default) : _ref3$areOwnPropsEqua, _ref3$areStatePropsEq = _ref3.areStatePropsEqual, areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? (0, $9UMSs.default) : _ref3$areStatePropsEq, _ref3$areMergedPropsE = _ref3.areMergedPropsEqual, areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? (0, $9UMSs.default) : _ref3$areMergedPropsE, extraOptions = (0, $6XgOP.default)(_ref3, $69b02ef9f183b3d3$var$_excluded);
        var initMapStateToProps = $69b02ef9f183b3d3$var$match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
        var initMapDispatchToProps = $69b02ef9f183b3d3$var$match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
        var initMergeProps = $69b02ef9f183b3d3$var$match(mergeProps, mergePropsFactories, 'mergeProps');
        return connectHOC(selectorFactory, (0, $kU09D.default)({
            // used in error messages
            methodName: 'connect',
            // used to compute Connect's displayName from the wrapped component's displayName.
            getDisplayName: function getDisplayName(name) {
                return "Connect(" + name + ")";
            },
            // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
            shouldHandleStateChanges: Boolean(mapStateToProps),
            // passed through to selectorFactory
            initMapStateToProps: initMapStateToProps,
            initMapDispatchToProps: initMapDispatchToProps,
            initMergeProps: initMergeProps,
            pure: pure,
            areStatesEqual: areStatesEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areStatePropsEqual: areStatePropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        }, extraOptions));
    };
}
var $69b02ef9f183b3d3$export$2e2bcd8739ae039 = /*#__PURE__*/ $69b02ef9f183b3d3$export$9f9feb656dec1fc4();

});
parcelRegister("9UMSs", function(module, exports) {

$parcel$export(module.exports, "default", () => $737f420d78dbedc2$export$2e2bcd8739ae039);
function $737f420d78dbedc2$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $737f420d78dbedc2$export$2e2bcd8739ae039(objA, objB) {
    if ($737f420d78dbedc2$var$is(objA, objB)) return true;
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(var i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$737f420d78dbedc2$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}

});

parcelRegister("foygv", function(module, exports) {

$parcel$export(module.exports, "default", () => $b353ad45ed306afd$export$2e2bcd8739ae039);

var $aGUDQ = parcelRequire("aGUDQ");

var $16dJ8 = parcelRequire("16dJ8");
function $b353ad45ed306afd$export$a9f27b4b187c1166(mapDispatchToProps) {
    return typeof mapDispatchToProps === 'function' ? (0, $16dJ8.wrapMapToPropsFunc)(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}
function $b353ad45ed306afd$export$ba20d1a7aa0c4a90(mapDispatchToProps) {
    return !mapDispatchToProps ? (0, $16dJ8.wrapMapToPropsConstant)(function(dispatch) {
        return {
            dispatch: dispatch
        };
    }) : undefined;
}
function $b353ad45ed306afd$export$94a6e55709d4d961(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? (0, $16dJ8.wrapMapToPropsConstant)(function(dispatch) {
        return (0, $aGUDQ.default)(mapDispatchToProps, dispatch);
    }) : undefined;
}
var $b353ad45ed306afd$export$2e2bcd8739ae039 = [
    $b353ad45ed306afd$export$a9f27b4b187c1166,
    $b353ad45ed306afd$export$ba20d1a7aa0c4a90,
    $b353ad45ed306afd$export$94a6e55709d4d961
];

});
parcelRegister("aGUDQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c89c37b8d715cdf$export$2e2bcd8739ae039);
function $7c89c37b8d715cdf$export$2e2bcd8739ae039(actionCreators, dispatch) {
    var boundActionCreators = {};
    var _loop = function _loop(key) {
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === 'function') boundActionCreators[key] = function() {
            return dispatch(actionCreator.apply(void 0, arguments));
        };
    };
    for(var key in actionCreators)_loop(key);
    return boundActionCreators;
}

});

parcelRegister("16dJ8", function(module, exports) {

$parcel$export(module.exports, "wrapMapToPropsConstant", () => $0cd0ffddfe5f8933$export$710f7c60f68acd3e);
$parcel$export(module.exports, "wrapMapToPropsFunc", () => $0cd0ffddfe5f8933$export$8d46c7f53c8c602f);
parcelRequire("32fpu");
function $0cd0ffddfe5f8933$export$710f7c60f68acd3e(getConstant) {
    return function initConstantSelector(dispatch, options) {
        var constant = getConstant(dispatch, options);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
function $0cd0ffddfe5f8933$export$e561b938df936d57(mapToProps) {
    return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
function $0cd0ffddfe5f8933$export$8d46c7f53c8c602f(mapToProps, methodName) {
    return function initProxySelector(dispatch, _ref) {
        var displayName = _ref.displayName;
        var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
        }; // allow detectFactoryAndVerify to get ownProps
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $0cd0ffddfe5f8933$export$e561b938df936d57(mapToProps);
            var props = proxy(stateOrDispatch, ownProps);
            if (typeof props === 'function') {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $0cd0ffddfe5f8933$export$e561b938df936d57(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}

});
parcelRegister("32fpu", function(module, exports) {

var $lkFcE = parcelRequire("lkFcE");

var $2pJov = parcelRequire("2pJov");
function $235d832188fff043$export$2e2bcd8739ae039(value, displayName, methodName) {
    if (!(0, $lkFcE.default)(value)) (0, $2pJov.default)(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
}

});
parcelRegister("lkFcE", function(module, exports) {

$parcel$export(module.exports, "default", () => $f87b6d4f23da449f$export$2e2bcd8739ae039);
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $f87b6d4f23da449f$export$2e2bcd8739ae039(obj) {
    if (typeof obj !== 'object' || obj === null) return false;
    var proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    var baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}

});

parcelRegister("2pJov", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c2120ec62b602d3$export$2e2bcd8739ae039);
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $1c2120ec62b602d3$export$2e2bcd8739ae039(message) {
    /* eslint-disable no-console */ if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    /* eslint-disable no-empty */ } catch (e) {}
/* eslint-enable no-empty */ }

});




parcelRegister("jjA10", function(module, exports) {

$parcel$export(module.exports, "default", () => $e0fbba8fd20a154b$export$2e2bcd8739ae039);

var $16dJ8 = parcelRequire("16dJ8");
function $e0fbba8fd20a154b$export$23fc470827b14aa(mapStateToProps) {
    return typeof mapStateToProps === 'function' ? (0, $16dJ8.wrapMapToPropsFunc)(mapStateToProps, 'mapStateToProps') : undefined;
}
function $e0fbba8fd20a154b$export$514bc8c1a53c1d66(mapStateToProps) {
    return !mapStateToProps ? (0, $16dJ8.wrapMapToPropsConstant)(function() {
        return {};
    }) : undefined;
}
var $e0fbba8fd20a154b$export$2e2bcd8739ae039 = [
    $e0fbba8fd20a154b$export$23fc470827b14aa,
    $e0fbba8fd20a154b$export$514bc8c1a53c1d66
];

});

parcelRegister("2Spd8", function(module, exports) {

$parcel$export(module.exports, "default", () => $21842e43b7ea3faa$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");
parcelRequire("32fpu");
function $21842e43b7ea3faa$export$691c327fc30bc857(stateProps, dispatchProps, ownProps) {
    return (0, $kU09D.default)({}, ownProps, stateProps, dispatchProps);
}
function $21842e43b7ea3faa$export$5b105939c84b5234(mergeProps) {
    return function initMergePropsProxy(dispatch, _ref) {
        var displayName = _ref.displayName, pure = _ref.pure, areMergedPropsEqual = _ref.areMergedPropsEqual;
        var hasRunOnce = false;
        var mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $21842e43b7ea3faa$export$d61b680184bc3f00(mergeProps) {
    return typeof mergeProps === 'function' ? $21842e43b7ea3faa$export$5b105939c84b5234(mergeProps) : undefined;
}
function $21842e43b7ea3faa$export$a13ba70ef50dda6d(mergeProps) {
    return !mergeProps ? function() {
        return $21842e43b7ea3faa$export$691c327fc30bc857;
    } : undefined;
}
var $21842e43b7ea3faa$export$2e2bcd8739ae039 = [
    $21842e43b7ea3faa$export$d61b680184bc3f00,
    $21842e43b7ea3faa$export$a13ba70ef50dda6d
];

});

parcelRegister("eEprf", function(module, exports) {

$parcel$export(module.exports, "default", () => $aaa888a6349e99a0$export$2e2bcd8739ae039);

var $6XgOP = parcelRequire("6XgOP");
parcelRequire("dGyYX");
var $aaa888a6349e99a0$var$_excluded = [
    "initMapStateToProps",
    "initMapDispatchToProps",
    "initMergeProps"
];
function $aaa888a6349e99a0$export$68c2c73bda6aa4b0(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
    return function impureFinalPropsSelector(state, ownProps) {
        return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
    };
}
function $aaa888a6349e99a0$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
    var areStatesEqual = _ref.areStatesEqual, areOwnPropsEqual = _ref.areOwnPropsEqual, areStatePropsEqual = _ref.areStatePropsEqual;
    var hasRunAtLeastOnce = false;
    var state;
    var ownProps;
    var stateProps;
    var dispatchProps;
    var mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        var nextStateProps = mapStateToProps(state, ownProps);
        var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        var stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
} // TODO: Add more comments
function $aaa888a6349e99a0$export$2e2bcd8739ae039(dispatch, _ref2) {
    var initMapStateToProps = _ref2.initMapStateToProps, initMapDispatchToProps = _ref2.initMapDispatchToProps, initMergeProps = _ref2.initMergeProps, options = (0, $6XgOP.default)(_ref2, $aaa888a6349e99a0$var$_excluded);
    var mapStateToProps = initMapStateToProps(dispatch, options);
    var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    var mergeProps = initMergeProps(dispatch, options);
    var selectorFactory = options.pure ? $aaa888a6349e99a0$export$d20c0c2ca6eb2b6f : $aaa888a6349e99a0$export$68c2c73bda6aa4b0;
    return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

});
parcelRegister("dGyYX", function(module, exports) {

var $2pJov = parcelRequire("2pJov");
function $9f6a5555b7986929$var$verify(selector, methodName, displayName) {
    if (!selector) throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
    else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
        if (!Object.prototype.hasOwnProperty.call(selector, 'dependsOnOwnProps')) (0, $2pJov.default)("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
    }
}
function $9f6a5555b7986929$export$2e2bcd8739ae039(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
    $9f6a5555b7986929$var$verify(mapStateToProps, 'mapStateToProps', displayName);
    $9f6a5555b7986929$var$verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
    $9f6a5555b7986929$var$verify(mergeProps, 'mergeProps', displayName);
}

});



parcelRegister("6N2vY", function(module, exports) {

$parcel$export(module.exports, "useDispatch", () => $4f194509acee95c5$export$8ad76b76a4c905f8);

var $iqB4h = parcelRequire("iqB4h");

var $2bGhE = parcelRequire("2bGhE");
function $4f194509acee95c5$export$bc9b55530897c558(context) {
    if (context === void 0) context = (0, $iqB4h.ReactReduxContext);
    var useStore = context === (0, $iqB4h.ReactReduxContext) ? (0, $2bGhE.useStore) : (0, $2bGhE.createStoreHook)(context);
    return function useDispatch() {
        var store = useStore();
        return store.dispatch;
    };
}
var $4f194509acee95c5$export$8ad76b76a4c905f8 = /*#__PURE__*/ $4f194509acee95c5$export$bc9b55530897c558();

});
parcelRegister("2bGhE", function(module, exports) {

$parcel$export(module.exports, "createStoreHook", () => $197d688751cead73$export$671dba69185d0304);
$parcel$export(module.exports, "useStore", () => $197d688751cead73$export$6ccbb43953eebf8);

var $eUqFw = parcelRequire("eUqFw");

var $iqB4h = parcelRequire("iqB4h");

var $bs1OA = parcelRequire("bs1OA");
function $197d688751cead73$export$671dba69185d0304(context) {
    if (context === void 0) context = (0, $iqB4h.ReactReduxContext);
    var useReduxContext = context === (0, $iqB4h.ReactReduxContext) ? (0, $bs1OA.useReduxContext) : function() {
        return (0, $eUqFw.useContext)(context);
    };
    return function useStore() {
        var _useReduxContext = useReduxContext(), store = _useReduxContext.store;
        return store;
    };
}
var $197d688751cead73$export$6ccbb43953eebf8 = /*#__PURE__*/ $197d688751cead73$export$671dba69185d0304();

});
parcelRegister("bs1OA", function(module, exports) {

$parcel$export(module.exports, "useReduxContext", () => $8563b7a80af4c71a$export$c1275ca9a6fd3ec5);

var $eUqFw = parcelRequire("eUqFw");

var $iqB4h = parcelRequire("iqB4h");
function $8563b7a80af4c71a$export$c1275ca9a6fd3ec5() {
    var contextValue = (0, $eUqFw.useContext)((0, $iqB4h.ReactReduxContext));
    return contextValue;
}

});



parcelRegister("cU4FA", function(module, exports) {

$parcel$export(module.exports, "useSelector", () => $964e5656bc2edcae$export$2105062e25df4afe);

var $eUqFw = parcelRequire("eUqFw");

var $bs1OA = parcelRequire("bs1OA");

var $eOZYb = parcelRequire("eOZYb");

var $8RW1t = parcelRequire("8RW1t");

var $iqB4h = parcelRequire("iqB4h");
var $964e5656bc2edcae$var$refEquality = function refEquality(a, b) {
    return a === b;
};
function $964e5656bc2edcae$var$useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub) {
    var _useReducer = (0, $eUqFw.useReducer)(function(s) {
        return s + 1;
    }, 0), forceRender = _useReducer[1];
    var subscription = (0, $eUqFw.useMemo)(function() {
        return (0, $eOZYb.createSubscription)(store, contextSub);
    }, [
        store,
        contextSub
    ]);
    var latestSubscriptionCallbackError = (0, $eUqFw.useRef)();
    var latestSelector = (0, $eUqFw.useRef)();
    var latestStoreState = (0, $eUqFw.useRef)();
    var latestSelectedState = (0, $eUqFw.useRef)();
    var storeState = store.getState();
    var selectedState;
    try {
        if (selector !== latestSelector.current || storeState !== latestStoreState.current || latestSubscriptionCallbackError.current) {
            var newSelectedState = selector(storeState); // ensure latest selected state is reused so that a custom equality function can result in identical references
            if (latestSelectedState.current === undefined || !equalityFn(newSelectedState, latestSelectedState.current)) selectedState = newSelectedState;
            else selectedState = latestSelectedState.current;
        } else selectedState = latestSelectedState.current;
    } catch (err) {
        if (latestSubscriptionCallbackError.current) err.message += "\nThe error may be correlated with this previous error:\n" + latestSubscriptionCallbackError.current.stack + "\n\n";
        throw err;
    }
    (0, $8RW1t.useIsomorphicLayoutEffect)(function() {
        latestSelector.current = selector;
        latestStoreState.current = storeState;
        latestSelectedState.current = selectedState;
        latestSubscriptionCallbackError.current = undefined;
    });
    (0, $8RW1t.useIsomorphicLayoutEffect)(function() {
        function checkForUpdates() {
            try {
                var newStoreState = store.getState(); // Avoid calling selector multiple times if the store's state has not changed
                if (newStoreState === latestStoreState.current) return;
                var _newSelectedState = latestSelector.current(newStoreState);
                if (equalityFn(_newSelectedState, latestSelectedState.current)) return;
                latestSelectedState.current = _newSelectedState;
                latestStoreState.current = newStoreState;
            } catch (err) {
                // we ignore all errors here, since when the component
                // is re-rendered, the selectors are called again, and
                // will throw again, if neither props nor store state
                // changed
                latestSubscriptionCallbackError.current = err;
            }
            forceRender();
        }
        subscription.onStateChange = checkForUpdates;
        subscription.trySubscribe();
        checkForUpdates();
        return function() {
            return subscription.tryUnsubscribe();
        };
    }, [
        store,
        subscription
    ]);
    return selectedState;
}
function $964e5656bc2edcae$export$2b53f90d2bd1cbfb(context) {
    if (context === void 0) context = (0, $iqB4h.ReactReduxContext);
    var useReduxContext = context === (0, $iqB4h.ReactReduxContext) ? (0, $bs1OA.useReduxContext) : function() {
        return (0, $eUqFw.useContext)(context);
    };
    return function useSelector(selector, equalityFn) {
        if (equalityFn === void 0) equalityFn = $964e5656bc2edcae$var$refEquality;
        var _useReduxContext = useReduxContext(), store = _useReduxContext.store, contextSub = _useReduxContext.subscription;
        var selectedState = $964e5656bc2edcae$var$useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub);
        (0, $eUqFw.useDebugValue)(selectedState);
        return selectedState;
    };
}
var $964e5656bc2edcae$export$2105062e25df4afe = /*#__PURE__*/ $964e5656bc2edcae$export$2b53f90d2bd1cbfb();

});


parcelRegister("035eW", function(module, exports) {

$parcel$export(module.exports, "unstable_batchedUpdates", () => (parcelRequire("lEfVV")).unstable_batchedUpdates);
/* eslint-disable import/no-unresolved */ 
var $lEfVV = parcelRequire("lEfVV");

});


parcelRegister("bn5nT", function(module, exports) {

$parcel$export(module.exports, "getRect", () => $847604ea52819b67$export$4b834cebd9e5cebe);
$parcel$export(module.exports, "expand", () => $847604ea52819b67$export$9f77e0932fb78f72);
$parcel$export(module.exports, "createBox", () => $847604ea52819b67$export$6459fc9e86be362e);
$parcel$export(module.exports, "offset", () => $847604ea52819b67$export$cc800923e997bb8);
$parcel$export(module.exports, "withScroll", () => $847604ea52819b67$export$1d0caec378d7d0ae);
$parcel$export(module.exports, "calculateBox", () => $847604ea52819b67$export$b8dfc5d4e552b8e1);
$parcel$export(module.exports, "getBox", () => $847604ea52819b67$export$34928e660d2a8702);

var $8ynlC = parcelRequire("8ynlC");
var $847604ea52819b67$export$4b834cebd9e5cebe = function getRect(_ref) {
    var top = _ref.top, right = _ref.right, bottom = _ref.bottom, left = _ref.left;
    var width = right - left;
    var height = bottom - top;
    var rect = {
        top: top,
        right: right,
        bottom: bottom,
        left: left,
        width: width,
        height: height,
        x: left,
        y: top,
        center: {
            x: (right + left) / 2,
            y: (bottom + top) / 2
        }
    };
    return rect;
};
var $847604ea52819b67$export$9f77e0932fb78f72 = function expand(target, expandBy) {
    return {
        top: target.top - expandBy.top,
        left: target.left - expandBy.left,
        bottom: target.bottom + expandBy.bottom,
        right: target.right + expandBy.right
    };
};
var $847604ea52819b67$export$8b1f3092f5e28575 = function shrink(target, shrinkBy) {
    return {
        top: target.top + shrinkBy.top,
        left: target.left + shrinkBy.left,
        bottom: target.bottom - shrinkBy.bottom,
        right: target.right - shrinkBy.right
    };
};
var $847604ea52819b67$var$shift = function shift(target, shiftBy) {
    return {
        top: target.top + shiftBy.y,
        left: target.left + shiftBy.x,
        bottom: target.bottom + shiftBy.y,
        right: target.right + shiftBy.x
    };
};
var $847604ea52819b67$var$noSpacing = {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
};
var $847604ea52819b67$export$6459fc9e86be362e = function createBox(_ref2) {
    var borderBox = _ref2.borderBox, _ref2$margin = _ref2.margin, margin = _ref2$margin === void 0 ? $847604ea52819b67$var$noSpacing : _ref2$margin, _ref2$border = _ref2.border, border = _ref2$border === void 0 ? $847604ea52819b67$var$noSpacing : _ref2$border, _ref2$padding = _ref2.padding, padding = _ref2$padding === void 0 ? $847604ea52819b67$var$noSpacing : _ref2$padding;
    var marginBox = $847604ea52819b67$export$4b834cebd9e5cebe($847604ea52819b67$export$9f77e0932fb78f72(borderBox, margin));
    var paddingBox = $847604ea52819b67$export$4b834cebd9e5cebe($847604ea52819b67$export$8b1f3092f5e28575(borderBox, border));
    var contentBox = $847604ea52819b67$export$4b834cebd9e5cebe($847604ea52819b67$export$8b1f3092f5e28575(paddingBox, padding));
    return {
        marginBox: marginBox,
        borderBox: $847604ea52819b67$export$4b834cebd9e5cebe(borderBox),
        paddingBox: paddingBox,
        contentBox: contentBox,
        margin: margin,
        border: border,
        padding: padding
    };
};
var $847604ea52819b67$var$parse = function parse(raw) {
    var value = raw.slice(0, -2);
    var suffix = raw.slice(-2);
    if (suffix !== 'px') return 0;
    var result = Number(value);
    !!isNaN(result) && (0, $8ynlC.default)(false);
    return result;
};
var $847604ea52819b67$var$getWindowScroll = function getWindowScroll() {
    return {
        x: window.pageXOffset,
        y: window.pageYOffset
    };
};
var $847604ea52819b67$export$cc800923e997bb8 = function offset(original, change) {
    var borderBox = original.borderBox, border = original.border, margin = original.margin, padding = original.padding;
    var shifted = $847604ea52819b67$var$shift(borderBox, change);
    return $847604ea52819b67$export$6459fc9e86be362e({
        borderBox: shifted,
        border: border,
        margin: margin,
        padding: padding
    });
};
var $847604ea52819b67$export$1d0caec378d7d0ae = function withScroll(original, scroll) {
    if (scroll === void 0) scroll = $847604ea52819b67$var$getWindowScroll();
    return $847604ea52819b67$export$cc800923e997bb8(original, scroll);
};
var $847604ea52819b67$export$b8dfc5d4e552b8e1 = function calculateBox(borderBox, styles) {
    var margin = {
        top: $847604ea52819b67$var$parse(styles.marginTop),
        right: $847604ea52819b67$var$parse(styles.marginRight),
        bottom: $847604ea52819b67$var$parse(styles.marginBottom),
        left: $847604ea52819b67$var$parse(styles.marginLeft)
    };
    var padding = {
        top: $847604ea52819b67$var$parse(styles.paddingTop),
        right: $847604ea52819b67$var$parse(styles.paddingRight),
        bottom: $847604ea52819b67$var$parse(styles.paddingBottom),
        left: $847604ea52819b67$var$parse(styles.paddingLeft)
    };
    var border = {
        top: $847604ea52819b67$var$parse(styles.borderTopWidth),
        right: $847604ea52819b67$var$parse(styles.borderRightWidth),
        bottom: $847604ea52819b67$var$parse(styles.borderBottomWidth),
        left: $847604ea52819b67$var$parse(styles.borderLeftWidth)
    };
    return $847604ea52819b67$export$6459fc9e86be362e({
        borderBox: borderBox,
        margin: margin,
        padding: padding,
        border: border
    });
};
var $847604ea52819b67$export$34928e660d2a8702 = function getBox(el) {
    var borderBox = el.getBoundingClientRect();
    var styles = window.getComputedStyle(el);
    return $847604ea52819b67$export$b8dfc5d4e552b8e1(borderBox, styles);
};

});

parcelRegister("dCUwp", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $9ebaaafca6cfcfc3$export$2e2bcd8739ae039);
var $9ebaaafca6cfcfc3$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === 'number' && value !== value;
};
function $9ebaaafca6cfcfc3$var$isEqual(first, second) {
    if (first === second) return true;
    if ($9ebaaafca6cfcfc3$var$safeIsNaN(first) && $9ebaaafca6cfcfc3$var$safeIsNaN(second)) return true;
    return false;
}
function $9ebaaafca6cfcfc3$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$9ebaaafca6cfcfc3$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $9ebaaafca6cfcfc3$var$memoizeOne(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $9ebaaafca6cfcfc3$var$areInputsEqual;
    var lastThis;
    var lastArgs = [];
    var lastResult;
    var calledOnce = false;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) return lastResult;
        lastResult = resultFn.apply(this, newArgs);
        calledOnce = true;
        lastThis = this;
        lastArgs = newArgs;
        return lastResult;
    }
    return memoized;
}
var $9ebaaafca6cfcfc3$export$2e2bcd8739ae039 = $9ebaaafca6cfcfc3$var$memoizeOne;

});

parcelRegister("3YjjI", function(module, exports) {

module.exports = (parcelRequire("2NZpQ"));

});
parcelRegister("2NZpQ", function(module, exports) {
parcelRequire("jDAxN");

module.exports = (parcelRequire("dhx8H")).Object.values;

});
parcelRegister("jDAxN", function(module, exports) {
// https://github.com/tc39/proposal-object-values-entries

var $5wEa2 = parcelRequire("5wEa2");

var $e4be01bfca6fcf6b$var$$values = (parcelRequire("24HEe"))(false);
$5wEa2($5wEa2.S, 'Object', {
    values: function values(it) {
        return $e4be01bfca6fcf6b$var$$values(it);
    }
});

});
parcelRegister("24HEe", function(module, exports) {

var $kD5IQ = parcelRequire("kD5IQ");

var $kJc9M = parcelRequire("kJc9M");

var $6WitF = parcelRequire("6WitF");

var $4hWyV = parcelRequire("4hWyV");
var $182dd014df77b78c$require$isEnum = $4hWyV.f;
module.exports = function(isEntries) {
    return function(it) {
        var O = $6WitF(it);
        var keys = $kJc9M(O);
        var length = keys.length;
        var i = 0;
        var result = [];
        var key;
        while(length > i){
            key = keys[i++];
            if (!$kD5IQ || $182dd014df77b78c$require$isEnum.call(O, key)) result.push(isEntries ? [
                key,
                O[key]
            ] : O[key]);
        }
        return result;
    };
};

});




parcelRegister("l1Zd2", function(module, exports) {

module.exports = (parcelRequire("3eZZ2"));

});
parcelRegister("3eZZ2", function(module, exports) {
parcelRequire("cV6iX");

module.exports = (parcelRequire("dhx8H")).Object.keys;

});
parcelRegister("cV6iX", function(module, exports) {
// 19.1.2.14 Object.keys(O)

var $1kVaN = parcelRequire("1kVaN");

var $kJc9M = parcelRequire("kJc9M");

(parcelRequire("1u1Xc"))('keys', function() {
    return function keys(it) {
        return $kJc9M($1kVaN(it));
    };
});

});
parcelRegister("1u1Xc", function(module, exports) {
// most Object methods by ES6 should accept primitives

var $5wEa2 = parcelRequire("5wEa2");

var $dhx8H = parcelRequire("dhx8H");

var $cbAAd = parcelRequire("cbAAd");
module.exports = function(KEY, exec) {
    var fn = ($dhx8H.Object || {})[KEY] || Object[KEY];
    var exp = {};
    exp[KEY] = exec(fn);
    $5wEa2($5wEa2.S + $5wEa2.F * $cbAAd(function() {
        fn(1);
    }), 'Object', exp);
};

});




parcelRegister("gxvYj", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0a8875644982a16$export$2e2bcd8739ae039);
var $c0a8875644982a16$var$rafSchd = function rafSchd(fn) {
    var lastArgs = [];
    var frameId = null;
    var wrapperFn = function wrapperFn() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        lastArgs = args;
        if (frameId) return;
        frameId = requestAnimationFrame(function() {
            frameId = null;
            fn.apply(void 0, lastArgs);
        });
    };
    wrapperFn.cancel = function() {
        if (!frameId) return;
        cancelAnimationFrame(frameId);
        frameId = null;
    };
    return wrapperFn;
};
var $c0a8875644982a16$export$2e2bcd8739ae039 = $c0a8875644982a16$var$rafSchd;

});

parcelRegister("5JNlj", function(module, exports) {

module.exports = (parcelRequire("fpboz"));

});
parcelRegister("fpboz", function(module, exports) {
parcelRequire("1WSQk");

module.exports = (parcelRequire("dhx8H")).Date.now;

});
parcelRegister("1WSQk", function(module, exports) {
// 20.3.3.1 / 15.9.4.4 Date.now()

var $5wEa2 = parcelRequire("5wEa2");
$5wEa2($5wEa2.S, 'Date', {
    now: function() {
        return new Date().getTime();
    }
});

});



parcelRegister("8kUbC", function(module, exports) {

module.exports = (parcelRequire("jmbPZ"));

});
parcelRegister("jmbPZ", function(module, exports) {
parcelRequire("hSyJ0");

module.exports = (parcelRequire("dhx8H")).Number.isInteger;

});
parcelRegister("hSyJ0", function(module, exports) {
// 20.1.2.3 Number.isInteger(number)

var $5wEa2 = parcelRequire("5wEa2");

$5wEa2($5wEa2.S, 'Number', {
    isInteger: (parcelRequire("cYSpV"))
});

});
parcelRegister("cYSpV", function(module, exports) {
// 20.1.2.3 Number.isInteger(number)

var $8T9YM = parcelRequire("8T9YM");
var $97354cb9c31bad1d$var$floor = Math.floor;
module.exports = function isInteger(it) {
    return !$8T9YM(it) && isFinite(it) && $97354cb9c31bad1d$var$floor(it) === it;
};

});





parcelRegister("dULIU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a215862d5b66b800$var$_react = $a215862d5b66b800$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $a215862d5b66b800$var$_dragHandle = $a215862d5b66b800$var$_interopRequireDefault((parcelRequire("gDDo4")));
function $a215862d5b66b800$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $a215862d5b66b800$var$DragHandlerIcon = (props)=>/*#__PURE__*/ $a215862d5b66b800$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><circle cx="10" cy="8" r="1"/><circle cx="14" cy="8" r="1"/><circle cx="10" cy="16" r="1"/><circle cx="14" cy="16" r="1"/><circle cx="10" cy="12" r="1"/><circle cx="14" cy="12" r="1"/></g></svg>`
    }, props, {
        newIcon: $a215862d5b66b800$var$_dragHandle.default
    }));
$a215862d5b66b800$var$DragHandlerIcon.displayName = 'DragHandlerIcon';
var $a215862d5b66b800$var$_default = module.exports.default = $a215862d5b66b800$var$DragHandlerIcon;

});
parcelRegister("gDDo4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b639051269ef116e35808d9097e35bf1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c1ced756fccff737$var$_react = $c1ced756fccff737$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $c1ced756fccff737$var$_UNSAFE_baseNew = $c1ced756fccff737$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $c1ced756fccff737$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "DragHandle".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for draggable elements.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c1ced756fccff737$var$DragHandleIcon = (props)=>/*#__PURE__*/ $c1ced756fccff737$var$_react.default.createElement($c1ced756fccff737$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M7 2.75a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0m5.5 0a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0M7 8a1.75 1.75 0 1 1-3.5 0A1.75 1.75 0 0 1 7 8m5.5 0A1.75 1.75 0 1 1 9 8a1.75 1.75 0 0 1 3.5 0M7 13.25a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0m5.5 0a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0"/>`
    }, props));
$c1ced756fccff737$var$DragHandleIcon.displayName = 'DragHandleIcon';
var $c1ced756fccff737$var$_default = module.exports.default = $c1ced756fccff737$var$DragHandleIcon;

});


parcelRegister("3a8wJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $2992b0d4d3fe9569$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ /* This is a wrapper around @atlaskit/page-header to patch a bug where text alignment
 in actions is incorrect. This common component is no longer necessary when
 https://ecosystem.atlassian.net/browse/AK-6385 is resolved.
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $hFGUl = parcelRequire("hFGUl");
const $2992b0d4d3fe9569$var$PageHeader = ({ actions: actions, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hFGUl.default), {
        ...props,
        // @ts-expect-error - TS2322 - Type 'Element | null' is not assignable to type 'ReactElement<any, string | JSXElementConstructor<any>> | undefined'.
        actions: actions ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2992b0d4d3fe9569$var$ActionsWrapper, null, actions) : null
    });
var $2992b0d4d3fe9569$export$2e2bcd8739ae039 = $2992b0d4d3fe9569$var$PageHeader;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2992b0d4d3fe9569$var$ActionsWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_y3gn1e5h",
            __cmplp.className
        ])
    });
});

});
parcelRegister("hFGUl", function(module, exports) {

$parcel$export(module.exports, "default", () => $f0ce2fac4b2f156d$export$2e2bcd8739ae039);
// TODO: Remove this eslint-disable when prop names have been renamed.
// This rule is here as prop name changes are a major as they are used
// by our consumers. This can be done in the next lite-mode conversion.
/* eslint-disable @repo/internal/react/boolean-prop-naming-convention */ 
var $eUqFw = parcelRequire("eUqFw");

var $5ubTM = parcelRequire("5ubTM");
/**
 * __Page header__
 *
 * A page header defines the top of a page. It contains a title and can be optionally combined with
 * breadcrumbs buttons, search, and filters.
 *
 * - [Examples](https://atlassian.design/components/page-header/examples)
 * - [Code](https://atlassian.design/components/page-header/code)
 * - [Usage](https://atlassian.design/components/page-header/usage)
 */ const $f0ce2fac4b2f156d$var$PageHeader = ({ innerRef: innerRef, breadcrumbs: breadcrumbs, actions: actions, bottomBar: bottomBar, children: children, id: id, disableTitleStyles: disableTitleStyles = false, truncateTitle: truncateTitle = false })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ubTM.OuterWrapper), null, breadcrumbs, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ubTM.TitleWrapper), {
        truncateTitle: truncateTitle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ubTM.TitleContainer), {
        truncateTitle: truncateTitle
    }, disableTitleStyles ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ubTM.StyledTitleWrapper), {
        ref: innerRef,
        truncateTitle: truncateTitle,
        id: id
    }, children)), actions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ubTM.ActionsWrapper), null, actions)), bottomBar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ubTM.BottomBarWrapper), null, " ", bottomBar, " "));
};
var $f0ce2fac4b2f156d$export$2e2bcd8739ae039 = $f0ce2fac4b2f156d$var$PageHeader;

});
parcelRegister("5ubTM", function(module, exports) {

$parcel$export(module.exports, "OuterWrapper", () => $fce98fdc5842132f$export$edaaad985a878983);
$parcel$export(module.exports, "StyledTitleWrapper", () => $fce98fdc5842132f$export$284be1ee64a3465c);
$parcel$export(module.exports, "TitleWrapper", () => $fce98fdc5842132f$export$585a3b23e887288b);
$parcel$export(module.exports, "TitleContainer", () => $fce98fdc5842132f$export$35e09ba17cc51c69);
$parcel$export(module.exports, "ActionsWrapper", () => $fce98fdc5842132f$export$c8223871eecc8f3a);
$parcel$export(module.exports, "BottomBarWrapper", () => $fce98fdc5842132f$export$6330225854c30dc);
// TODO: Remove this eslint-disable when prop names have been renamed.
// This rule is here as prop name changes are a major as they are used
// by our consumers. The prop name concerned here is truncateTitle.
// This can be done in the next lite-mode conversion.
/* eslint-disable @repo/internal/react/boolean-prop-naming-convention */ /**
                                                                          * @jsxRuntime classic
                                                                          * @jsx jsx
                                                                          */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");
function $fce98fdc5842132f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $fce98fdc5842132f$var$truncateStyles = {
    name: "13oenf9",
    styles: "overflow-x:hidden;overflow-y:hidden;text-overflow:ellipsis;white-space:nowrap"
};
const $fce98fdc5842132f$var$outerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    margin: `${"var(--ds-space-300, 24px)"} 0 ${"var(--ds-space-200, 16px)"} 0`
});
const $fce98fdc5842132f$var$titleStyles = {
    name: "1o56te0",
    styles: "color:var(--ds-text, #172B4D);font:var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);letter-spacing:normal;margin-block-start:0;outline:none"
};
const $fce98fdc5842132f$var$titleWrapperStyles = {
    name: "1wb76vg",
    styles: "display:flex;align-items:flex-start;flex-wrap:wrap"
};
const $fce98fdc5842132f$var$titleWrapperTruncateStyles = {
    name: "14gl6v0",
    styles: "flex-wrap:nowrap"
};
const $fce98fdc5842132f$var$titleContainerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    minWidth: 0,
    maxWidth: '100%',
    flex: '1 0 auto',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    flexShrink: undefined,
    marginBlockEnd: "var(--ds-space-100, 8px)"
});
const $fce98fdc5842132f$var$actionStyles = {
    name: "1ianfu6",
    styles: "max-width:100%;flex:0 0 auto;margin-block-end:var(--ds-space-100, 8px);margin-inline-start:auto;padding-inline-start:var(--ds-space-400, 32px);white-space:nowrap;>{text-align:right;}"
};
const $fce98fdc5842132f$var$titleContainerTruncateStyles = {
    name: "s2a4s9",
    styles: "flex-shrink:1"
};
const $fce98fdc5842132f$var$bottomBarStyles = (0, $1ZAYh.xcss)({
    marginBlockStart: 'space.200'
});
const $fce98fdc5842132f$export$edaaad985a878983 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $fce98fdc5842132f$var$outerStyles
    }, children);
};
const $fce98fdc5842132f$export$284be1ee64a3465c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef(({ children: children, id: id, truncateTitle: truncateTitle }, ref)=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("h1", {
        css: [
            $fce98fdc5842132f$var$titleStyles,
            truncateTitle && $fce98fdc5842132f$var$truncateStyles
        ],
        ref: ref,
        tabIndex: -1,
        id: id
    }, children);
});
const $fce98fdc5842132f$export$585a3b23e887288b = ({ children: children, truncateTitle: truncateTitle })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $fce98fdc5842132f$var$titleWrapperStyles,
            truncateTitle && $fce98fdc5842132f$var$titleWrapperTruncateStyles
        ]
    }, children);
};
const $fce98fdc5842132f$export$35e09ba17cc51c69 = ({ children: children, truncateTitle: truncateTitle })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $fce98fdc5842132f$var$titleContainerStyles,
            truncateTitle && $fce98fdc5842132f$var$titleContainerTruncateStyles
        ]
    }, children);
};
const $fce98fdc5842132f$export$c8223871eecc8f3a = ({ children: children })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $fce98fdc5842132f$var$actionStyles
    }, children);
};
const $fce98fdc5842132f$export$6330225854c30dc = ({ children: children })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        xcss: $fce98fdc5842132f$var$bottomBarStyles
    }, children);
};

});



parcelRegister("be3PE", function(module, exports) {

$parcel$export(module.exports, "JsmPageInteractiveEvent", () => $695cc37a0df2f37c$export$c4ba40c380ee9a11);

var $eUqFw = parcelRequire("eUqFw");

var $7vf5z = parcelRequire("7vf5z");
const $695cc37a0df2f37c$export$c4ba40c380ee9a11 = (args)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7vf5z.default), args);
$695cc37a0df2f37c$export$c4ba40c380ee9a11.defaultProps = {
    isExpectedToHaveSsr: false,
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    withMarks: [],
    extra: {}
};
$695cc37a0df2f37c$export$c4ba40c380ee9a11.displayName = 'JsmPageInteractiveEvent';

});
parcelRegister("7vf5z", function(module, exports) {

$parcel$export(module.exports, "checkAndEmitApdexSignal", () => $074ba9858fda469d$export$3082c88b693a5230);
$parcel$export(module.exports, "default", () => $074ba9858fda469d$export$2e2bcd8739ae039);
$parcel$export(module.exports, "baseDefaultProps", () => $074ba9858fda469d$export$9b3029ee6188a41f);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $3iMaY = parcelRequire("3iMaY");

var $eJ3kO = parcelRequire("eJ3kO");

var $51JrV = parcelRequire("51JrV");

var $4nnPJ = parcelRequire("4nnPJ");

var $22iQy = parcelRequire("22iQy");

var $brm1D = parcelRequire("brm1D");

var $ifyPR = parcelRequire("ifyPR");

var $aS0xb = parcelRequire("aS0xb");

var $45wsB = parcelRequire("45wsB");
const $074ba9858fda469d$export$3082c88b693a5230 = (appName, metricKey)=>{
    var emitSignal;
};
class $074ba9858fda469d$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            isExpectedToHaveSsr: false,
            withMarks: [],
            extra: {},
            emitOnAnimationFrame: false
        };
    }
    render() {
        const { appName: appName, metricKey: metricKey, extra: extra, metric: metric, emitOnAnimationFrame: emitOnAnimationFrame, waitForLongTaskIdleTTI: waitForLongTaskIdleTTI } = this.props;
        $074ba9858fda469d$export$3082c88b693a5230(appName, metricKey);
        const isUFODefined = (0, $1ybV0.ff)('uip.ufo') && (0, $4nnPJ.GlobalPageLoadExperience).loadingPageLoadId !== 'UNKNOWN';
        if (isUFODefined) (0, $aS0xb.addUFOSSRDoneAsFMPToInteraction)();
        if (metric) {
            // https://product-fabric.atlassian.net/browse/UFO-323
            (0, $ifyPR.addBM3SSRDoneAsFMPToInteraction)(metric);
            (0, $45wsB.trackBM3FeatureFlagsAccessed)(metric);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3iMaY.default), {
            data: extra
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eJ3kO.UFOBM3TimingsToUFO), {
            marks: metric?.getData()?.marks,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            timings: metric?.getData()?.config?.timings
        }), isUFODefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $brm1D.StopUfo), {
            appName: appName,
            customData: extra,
            key: (0, $51JrV.getInteractionId)().current
        }) : metric && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $22iQy.StopBrowserMetrics3), {
            metric: metric,
            customData: extra,
            emitOnAnimationFrame: emitOnAnimationFrame,
            waitForLongTaskIdleTTI: waitForLongTaskIdleTTI
        }));
    }
}
const $074ba9858fda469d$export$9b3029ee6188a41f = $074ba9858fda469d$export$2e2bcd8739ae039.defaultProps;

});
parcelRegister("eJ3kO", function(module, exports) {

$parcel$export(module.exports, "getBm3Timings", () => $8841aa10a213faf4$export$f02972da195a43bb);
$parcel$export(module.exports, "UFOBM3TimingsToUFO", () => $8841aa10a213faf4$export$30f0b5e5acd268bf);
$parcel$export(module.exports, "addBM3TimingsToUFO", () => $8841aa10a213faf4$export$d93d677ef2f33c5c);

var $eUqFw = parcelRequire("eUqFw");

var $3Hphq = parcelRequire("3Hphq");

var $51JrV = parcelRequire("51JrV");

var $fYqUr = parcelRequire("fYqUr");
function $8841aa10a213faf4$export$f02972da195a43bb(marks, timingConfigs) {
    const bm3Timings = {};
    if (!marks || !timingConfigs) return bm3Timings;
    timingConfigs.forEach((item)=>{
        if (!item.startMark || !item.endMark) return;
        const startTime = marks[item.startMark];
        if (!startTime) return;
        const endTime = marks[item.endMark];
        if (!endTime) return;
        bm3Timings[item.key] = {
            startTime: startTime,
            endTime: endTime
        };
    });
    return bm3Timings;
}
function $8841aa10a213faf4$export$30f0b5e5acd268bf({ marks: marks, timings: timings }) {
    const interactionContext = (0, $eUqFw.useContext)((0, $3Hphq.default));
    const interactionId = (0, $51JrV.getInteractionId)().current;
    (0, $eUqFw.useMemo)(()=>{
        if (interactionContext != null && interactionId != null && marks != null && timings != null) {
            const interactionType = (0, $fYqUr.getCurrentInteractionType)(interactionId);
            if (interactionType === 'press') return;
            const bm3Timings = $8841aa10a213faf4$export$f02972da195a43bb(marks, timings);
            interactionContext.addCustomTimings(bm3Timings);
        }
    }, [
        interactionContext,
        interactionId,
        marks,
        timings
    ]);
    return null;
}
function $8841aa10a213faf4$export$d93d677ef2f33c5c(marks, timingsConfig) {
    const interactionId = (0, $51JrV.getInteractionId)().current;
    if (interactionId) {
        const interactionType = (0, $fYqUr.getCurrentInteractionType)(interactionId);
        if (interactionType === 'press') return;
        const bm3Timings = $8841aa10a213faf4$export$f02972da195a43bb(marks, timingsConfig);
        (0, $fYqUr.addCustomTiming)(interactionId, [], bm3Timings);
    }
}

});

parcelRegister("22iQy", function(module, exports) {

$parcel$export(module.exports, "StopBrowserMetrics3", () => $c48b51f586335ad5$export$575e93c0f9905999);

var $eUqFw = parcelRequire("eUqFw");

var $acbV3 = parcelRequire("acbV3");

var $6iz4v = parcelRequire("6iz4v");

var $6xYPC = parcelRequire("6xYPC");

var $1ybV0 = parcelRequire("1ybV0");

var $cNlZD = parcelRequire("cNlZD");

var $6M8Uw = parcelRequire("6M8Uw");

var $2B87Z = parcelRequire("2B87Z");

var $87isp = parcelRequire("87isp");

var $3Hphq = parcelRequire("3Hphq");

const $c48b51f586335ad5$var$emitMetrics = (metric, customData, stopTime)=>{
    !(0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
    (0, $2B87Z.setInitialPageLoadTimingFromPerformanceMarks)('batch-js-heritage.eval', 'jira.heritage_batch_file_eval:start', 'jira.heritage_batch_file_eval:end');
    if (stopTime !== undefined) {
        if (!(0, $1ybV0.ff)('bm3.wait-for-long-task')) {
            metric.mark((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
            (0, $6iz4v.setMark)((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
            (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $37f655a4e4d5690e$export$99c08ec92759c71c));
        }
        metric.stop({
            customData: customData,
            stopTime: stopTime
        });
    } else metric.stop({
        customData: customData
    });
    if ((0, $87isp.isAutomaticExposureCollectionEnabled)()) (0, $6xYPC.stopLowPriorityEventDelay)();
};
class $c48b51f586335ad5$export$575e93c0f9905999 extends (0, $eUqFw.Component) {
    componentDidMount() {
        const { metric: metric, customData: customData, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
        if (!metric) return;
        const start = (0, $1ybV0.ff)('bm3.wait-for-long-task') ? (0, $acbV3.browserMetrics).getPageLoadMetric().getData()?.start || 0 : 0;
        (0, $6iz4v.setMark)('BROWSER_METRICS_TTI_START', {
            startTime: start
        });
        (0, $6iz4v.setMark)('BROWSER_METRICS_TTI_END');
        (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_END');
        const bm3Data = metric.getData();
        if (this.props.waitForLongTaskIdleTTI) {
            const stopTime = performance.now();
            (0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
            (0, $cNlZD.getTTIValue)().then((tti)=>{
                (0, $cNlZD.resetTTIObserver)();
                (0, $6iz4v.setMark)('BROWSER_METRICS_LONG_TASK_TTI_END', {
                    startTime: tti
                });
                (0, $6iz4v.setMeasure)('BROWSER_METRICS_LONG_TASK_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_LONG_TASK_TTI_END');
                $c48b51f586335ad5$var$emitMetrics(metric, customData, stopTime);
            });
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: stopTime
            });
        } else if (emitOnAnimationFrame) {
            const stopTime = performance.now();
            (0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: stopTime
            });
            if (typeof queueMicrotask !== 'undefined') queueMicrotask(()=>{
                (0, $6iz4v.setMark)('BROWSER_METRICS_TTI_TASK_END');
                (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI_TASK', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_TASK_END');
            });
            requestAnimationFrame(()=>{
                if ((0, $1ybV0.ff)('bm3.wait-for-long-task')) {
                    metric.mark((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
                    (0, $6iz4v.setMark)((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
                    (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $37f655a4e4d5690e$export$99c08ec92759c71c));
                }
                if ((0, $1ybV0.ff)('bm3.wait-for-long-task')) setTimeout(()=>{
                    $c48b51f586335ad5$var$emitMetrics(metric, customData, stopTime);
                }, 500);
                else $c48b51f586335ad5$var$emitMetrics(metric, customData, stopTime);
            });
        } else {
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: performance.now()
            });
            (0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
            $c48b51f586335ad5$var$emitMetrics(metric, customData);
        }
    }
    static{
        this.contextType = (0, $3Hphq.default);
    }
    render() {
        return null;
    }
}

});
parcelRegister("cNlZD", function(module, exports) {

$parcel$export(module.exports, "resetTTIObserver", () => $2134fd1f8b4ec9b6$export$1250c0c41b64ee5c);
$parcel$export(module.exports, "startTTIObserver", () => $2134fd1f8b4ec9b6$export$d2209a9a3184ff99);
$parcel$export(module.exports, "getTTIValue", () => $2134fd1f8b4ec9b6$export$e67176cf000b0a2e);

var $ba8ih = parcelRequire("ba8ih");
// Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
let $2134fd1f8b4ec9b6$var$resolveTti = (_v)=>{};
let $2134fd1f8b4ec9b6$var$observerStarted = false;
/**
 * Initialize module state and return the promise a consumer can use to wait
 * for the TTI event.
 */ function $2134fd1f8b4ec9b6$var$initTtiPromise() {
    return new Promise((resolve)=>{
        let hasResolved = false;
        const callback = (ttiResult)=>{
            if (hasResolved) return;
            hasResolved = true;
            resolve(ttiResult);
        };
        $2134fd1f8b4ec9b6$var$resolveTti = callback;
    });
}
let $2134fd1f8b4ec9b6$var$ttiPromise = $2134fd1f8b4ec9b6$var$initTtiPromise();
function $2134fd1f8b4ec9b6$export$1250c0c41b64ee5c() {
    $2134fd1f8b4ec9b6$var$ttiPromise = $2134fd1f8b4ec9b6$var$initTtiPromise();
    $2134fd1f8b4ec9b6$var$observerStarted = false;
}
function $2134fd1f8b4ec9b6$export$d2209a9a3184ff99() {
    $2134fd1f8b4ec9b6$var$observerStarted = true;
    let cleanupObserver = null;
    let lastSeenEventTime = performance.now();
    const callback = ()=>{
        cleanupObserver?.();
        $2134fd1f8b4ec9b6$var$resolveTti(lastSeenEventTime);
    };
    let timeoutId = setTimeout(callback, 5000);
    cleanupObserver = (0, $ba8ih.startLongTaskObserver)(()=>{
        lastSeenEventTime = performance.now();
        clearTimeout(timeoutId);
        timeoutId = setTimeout(callback, 5000);
    });
}
function $2134fd1f8b4ec9b6$export$e67176cf000b0a2e() {
    const promise = $2134fd1f8b4ec9b6$var$ttiPromise ?? $2134fd1f8b4ec9b6$var$initTtiPromise();
    if (!$2134fd1f8b4ec9b6$var$observerStarted) $2134fd1f8b4ec9b6$export$d2209a9a3184ff99();
    return promise;
}

});
parcelRegister("ba8ih", function(module, exports) {

$parcel$export(module.exports, "startLongTaskObserver", () => $c3f66a1c0c2d8c9c$export$af412d3da3bf848a);
/**
 * Starts a long-task observer that will call `cb` on each observation.
 * Returns a disposal function
 */ function $c3f66a1c0c2d8c9c$export$af412d3da3bf848a(cb) {
    const observer = new PerformanceObserver(()=>{
        cb();
    });
    observer.observe({
        type: 'longtask'
    });
    return ()=>{
        observer.disconnect();
    };
}

});


parcelRegister("6M8Uw", function(module, exports) {

$parcel$export(module.exports, "PRODUCT_START_MARK", () => $e57b25b6033962a3$export$8e54fca0a680fdfd);
$parcel$export(module.exports, "MarkProductStart", () => $e57b25b6033962a3$export$2a999c5f84501025);

var $6iz4v = parcelRequire("6iz4v");
const $e57b25b6033962a3$export$8e54fca0a680fdfd = 'PRODUCT_START';
const $e57b25b6033962a3$export$2a999c5f84501025 = ()=>{
    if (!false) {
        performance.clearMarks($e57b25b6033962a3$export$8e54fca0a680fdfd);
        (0, $6iz4v.setMark)($e57b25b6033962a3$export$8e54fca0a680fdfd);
    }
    return null;
};

});

const $37f655a4e4d5690e$export$56940a9488e85199 = 'jira.fe.spa-';
const $37f655a4e4d5690e$export$45c4b6bf7935c69a = `${$37f655a4e4d5690e$export$56940a9488e85199}start`;
const $37f655a4e4d5690e$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $37f655a4e4d5690e$export$ff834eccc35b9089 = 'appBundleReady';
const $37f655a4e4d5690e$export$86b05e34d462ead8 = 'prefetchApiReady';
const $37f655a4e4d5690e$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $37f655a4e4d5690e$export$1211adfff27a31fe = 'issueViewInitialDataReady';
const $37f655a4e4d5690e$export$3ae43cc1782d058f = 'jswRenderStart';
const $37f655a4e4d5690e$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $37f655a4e4d5690e$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $37f655a4e4d5690e$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $37f655a4e4d5690e$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $37f655a4e4d5690e$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $37f655a4e4d5690e$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $37f655a4e4d5690e$export$99c08ec92759c71c = 'tti-raf-mark';
const $37f655a4e4d5690e$export$48552baa9db8ce1d = 'tti-raf';


parcelRegister("brm1D", function(module, exports) {

$parcel$export(module.exports, "StopUfo", () => $aa08c3eb931d9705$export$d91154f099475c5);

var $eUqFw = parcelRequire("eUqFw");

var $3Hphq = parcelRequire("3Hphq");

var $4nnPJ = parcelRequire("4nnPJ");
class $aa08c3eb931d9705$export$d91154f099475c5 extends (0, $eUqFw.Component) {
    componentDidMount() {
        const { customData: customData, appName: appName } = this.props;
        (0, $4nnPJ.GlobalPageLoadExperience).success({
            force: true,
            metadata: customData
        });
        const name = appName || (0, $4nnPJ.GlobalPageLoadExperience).loadingPageLoadId;
        if (name) this.context?.addApdex({
            key: name,
            stopTime: performance.now()
        });
    }
    static{
        this.contextType = (0, $3Hphq.default);
    }
    render() {
        return null;
    }
}

});

parcelRegister("ifyPR", function(module, exports) {

$parcel$export(module.exports, "addBM3SSRDoneAsFMPToInteraction", () => $d6714c8d166fb68b$export$bf239ac2bfb04967);

var $51JrV = parcelRequire("51JrV");

var $fYqUr = parcelRequire("fYqUr");
function $d6714c8d166fb68b$export$bf239ac2bfb04967(metric) {
    const interactionId = (0, $51JrV.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // Use BM3 SSR mark as FMP config for UFO if it exists, temporarily.
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && data?.isInitial) (0, $fYqUr.addMetadata)(currentInteractionId, {
        __legacy__bm3ConfigSSRDoneAsFmp: config.ssr?.doneAsFmp || false
    });
}

});

parcelRegister("aS0xb", function(module, exports) {

$parcel$export(module.exports, "addUFOSSRDoneAsFMPToInteraction", () => $714e33db0dc77e43$export$e63862cd888fe05a);

var $51JrV = parcelRequire("51JrV");

var $fYqUr = parcelRequire("fYqUr");

var $4nnPJ = parcelRequire("4nnPJ");
var $aPkDp = parcelRequire("aPkDp");
async function $714e33db0dc77e43$export$e63862cd888fe05a() {
    const interactionId = (0, $51JrV.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    // Use UFO SSR mark as FMP config for rUFO if it exists, temporarily.
    const data = await (0, $4nnPJ.GlobalPageLoadExperience).exportData();
    const fmpMark = data.metrics.marks.find((mark)=>mark.name === 'fmp') || (0, $aPkDp.payloadPublisher).ssr?.getDoneMark();
    if (data.initial && fmpMark) (0, $fYqUr.addMetadata)(currentInteractionId, {
        __legacy__ufoConfigSSRDoneAsFmp: true
    });
}

});

parcelRegister("45wsB", function(module, exports) {

$parcel$export(module.exports, "trackBM3FeatureFlagsAccessed", () => $58cb476ec3ec20ed$export$f00f1e874ce869e9);

var $aWbzA = parcelRequire("aWbzA");

var $51JrV = parcelRequire("51JrV");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $58cb476ec3ec20ed$var$startsAsObject = (value)=>{
    try {
        if (value.charAt(0) === '{') return true;
    } catch (e) {
        return false;
    }
    return false;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $58cb476ec3ec20ed$var$isObject = (value)=>value && typeof value === 'object' && value.constructor === Object;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $58cb476ec3ec20ed$var$isString = (input)=>{
    let result;
    try {
        result = typeof input === 'string' || input instanceof String;
    } catch (err) {
        // swallow any errors
        result = false;
    }
    return result;
};
const $58cb476ec3ec20ed$export$7b4abba432e57989 = (value)=>$58cb476ec3ec20ed$var$isString(value) && $58cb476ec3ec20ed$var$startsAsObject(value) || $58cb476ec3ec20ed$var$isObject(value);
const $58cb476ec3ec20ed$export$fcc03ee4c944962f = (featureFlagValue)=>$58cb476ec3ec20ed$export$7b4abba432e57989(featureFlagValue) ? 'non_boolean' : featureFlagValue;
const $58cb476ec3ec20ed$export$d2818866b4acbea4 = new Map();
const $58cb476ec3ec20ed$export$f00f1e874ce869e9 = (metric)=>{
    const interactionId = (0, $51JrV.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && config?.featureFlags?.length) {
        const allFeatureFlags = (0, $aWbzA.default)();
        config.featureFlags.forEach((featureFlagName)=>{
            const value = allFeatureFlags[featureFlagName];
            if (value === undefined) return;
            const featureFlagValue = $58cb476ec3ec20ed$export$fcc03ee4c944962f(value);
            $58cb476ec3ec20ed$export$d2818866b4acbea4.set(featureFlagName, featureFlagValue);
        });
    }
};

});



parcelRegister("51Ia6", function(module, exports) {

$parcel$export(module.exports, "usePageContext", () => $16ae5fc48efca0d6$export$9c25024bdfe755f7);

var $eUqFw = parcelRequire("eUqFw");

var $iZJHG = parcelRequire("iZJHG");

var $ixwgj = parcelRequire("ixwgj");

var $gd0Sp = parcelRequire("gd0Sp");

var $jyTef = parcelRequire("jyTef");
const $16ae5fc48efca0d6$var$getProjectContextResource = ()=>(0, $ixwgj.projectContextResourceWithCache);
const $16ae5fc48efca0d6$export$9c25024bdfe755f7 = (customContext)=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    const { data: projectContext, loading: projectContextLoading, error: projectContextError } = (0, $iZJHG.useResourceWithCustomRouterContext)($16ae5fc48efca0d6$var$getProjectContextResource(), customContext);
    const [{ data: serviceDeskContext, loading: serviceDeskLoading, error: serviceDeskError }] = (0, $jyTef.useServiceDeskContext)(projectContext?.projectKey || undefined, customContext);
    const pageContextData = (0, $eUqFw.useMemo)(()=>({
            data: projectContext && serviceDeskContext ? {
                serviceDeskContext: {
                    portalId: serviceDeskContext.portalId,
                    portalUrl: serviceDeskContext.portalUrl,
                    canSeeNewIssueView: serviceDeskContext.canSeeNewIssueView,
                    userRole: serviceDeskContext.userRole,
                    serviceDeskId: serviceDeskContext.serviceDeskId
                },
                projectContext: {
                    projectId: projectContext.projectId,
                    projectKey: projectContext.projectKey,
                    projectName: projectContext.projectName,
                    projectType: projectContext.projectType,
                    // Refactor this in https://jdog.jira-dev.com/browse/JSK-443 this is a temporary fix to
                    // resolve a regression https://jira.atlassian.com/browse/JSDCLOUD-8751
                    isAdmin: projectContext.isProjectAdmin || tenantContext.isAdmin,
                    isProjectSimplified: projectContext.simplified
                },
                tenantContext: {
                    baseUrl: tenantContext.baseUrl,
                    locale: tenantContext.locale,
                    userFullname: tenantContext.userFullname,
                    cloudId: tenantContext.cloudId,
                    fabricPfDirUrl: tenantContext.fabricPfDirUrl,
                    atlassianAccountId: tenantContext.atlassianAccountId,
                    isJiraAdmin: tenantContext.isAdmin,
                    isSiteAdmin: tenantContext.isSiteAdmin,
                    activationId: tenantContext.activationId
                }
            } : null,
            loading: projectContextLoading || serviceDeskLoading,
            error: serviceDeskError || projectContextError || null
        }), [
        tenantContext,
        projectContext,
        serviceDeskContext,
        projectContextLoading,
        serviceDeskLoading,
        serviceDeskError,
        projectContextError
    ]);
    return [
        pageContextData
    ];
};

});
parcelRegister("jyTef", function(module, exports) {

$parcel$export(module.exports, "useServiceDeskContext", () => $3f940b317a874b53$export$712ead87353ac687);

var $eUqFw = parcelRequire("eUqFw");

var $iZJHG = parcelRequire("iZJHG");

var $ct0sQ = parcelRequire("ct0sQ");
const $3f940b317a874b53$var$getServiceDeskContextResource = ()=>(0, $ct0sQ.serviceDeskContextResource);
const $3f940b317a874b53$export$712ead87353ac687 = (projectKey, customContext)=>{
    const { data: data, loading: loading, error: error, refresh: refreshCache } = (0, $iZJHG.useResourceWithCustomRouterContext)($3f940b317a874b53$var$getServiceDeskContextResource(), customContext);
    (0, $eUqFw.useEffect)(()=>{
        if (!false) refreshCache();
    }, [
        projectKey,
        refreshCache
    ]);
    return [
        {
            data: data,
            loading: loading,
            error: error
        }
    ];
};

});


parcelRegister("8e1a3", function(module, exports) {

$parcel$export(module.exports, "AddLinkModal", () => $eccf15d1f4b3e41f$export$c211869ab42147b4);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");
var $7opLA = parcelRequire("7opLA");

var $lzLxZ = parcelRequire("lzLxZ");

var $aOw1G = parcelRequire("aOw1G");
var $lfiOu = parcelRequire("lfiOu");
var $2OJfS = parcelRequire("2OJfS");
var $kigFe = parcelRequire("kigFe");
var $boSVF = parcelRequire("boSVF");
var $dxopF = parcelRequire("dxopF");

var $kGQen = parcelRequire("kGQen");

var $0cdA8 = parcelRequire("0cdA8");

var $k8Qyf = parcelRequire("k8Qyf");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");

var $51Ia6 = parcelRequire("51Ia6");

var $aNx7t = parcelRequire("aNx7t");

var $exuoN = parcelRequire("exuoN");

var $bFQmf = parcelRequire("bFQmf");

var $aLG4f = parcelRequire("aLG4f");

var $40AVL = parcelRequire("40AVL");

var $1RnLW = parcelRequire("1RnLW");
const $eccf15d1f4b3e41f$export$c211869ab42147b4 = ({ isOpen: isOpen, // Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
onClose: onCloseProp = ()=>{}, mode: mode = (0, $aNx7t.MODES).ADD, link: link = null })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [isAdding, { addExternalLink: addExternalLink }] = (0, $bFQmf.useIsAdding)();
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagService)();
    const [isUpdating, { updateExternalLink: updateExternalLink }] = (0, $bFQmf.useIsUpdating)();
    const [{ data: pageContextData }] = (0, $51Ia6.usePageContext)();
    const [isModified, setIsModified] = (0, $eUqFw.useState)(false);
    const portalUrl = pageContextData?.serviceDeskContext.portalUrl;
    const onClose = (0, $eUqFw.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (_, analyticsEvent)=>{
        if (analyticsEvent) (0, $jMP2a.fireUIAnalytics)(analyticsEvent, mode === (0, $aNx7t.MODES).EDIT ? 'externalResourceUpdateModalClosed' : 'externalResourceAddModalClosed');
        onCloseProp();
        (0, $aLG4f.externalResourcesAddUpdateExperience).abort();
        setIsModified(false);
    }, [
        mode,
        onCloseProp,
        setIsModified
    ]);
    const onSubmit = (0, $eUqFw.useCallback)(async (formData)=>{
        if (mode === (0, $aNx7t.MODES).ADD) try {
            await addExternalLink(formData);
            showFlag({
                type: 'success',
                isAutoDismiss: true,
                title: (0, $1RnLW.messages).externalLinkAddSuccessFlagTitle,
                description: [
                    (0, $1RnLW.messages).externalLinkAddSuccessFlagDescription,
                    {
                        linkTitle: (0, $exuoN.getTruncatedTitleForFlag)(formData.title)
                    }
                ],
                actions: [
                    {
                        content: (0, $1RnLW.messages).linkFlagActionLabel,
                        href: portalUrl,
                        target: '_blank'
                    }
                ]
            });
            // @ts-expect-error - TS2554 - Expected 1-2 arguments, but got 0.
            onClose();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (submitError) {
            showFlag({
                type: 'error',
                isAutoDismiss: true,
                title: (0, $1RnLW.messages).externalLinkAddFailureTitle,
                description: (0, $1RnLW.messages).externalLinkAddFailureDescription
            });
        }
        else try {
            if (link !== null) {
                await updateExternalLink(formData, link.id);
                showFlag({
                    type: 'success',
                    isAutoDismiss: true,
                    title: (0, $1RnLW.messages).externalLinkUpdateSuccessFlagTitle,
                    description: [
                        (0, $1RnLW.messages).externalLinkUpdateSuccessFlagDescription,
                        {
                            linkTitle: (0, $exuoN.getTruncatedTitleForFlag)(formData.title)
                        }
                    ],
                    actions: [
                        {
                            content: (0, $1RnLW.messages).linkFlagActionLabel,
                            href: portalUrl,
                            target: '_blank'
                        }
                    ]
                });
            }
            // @ts-expect-error - TS2554 - Expected 1-2 arguments, but got 0.
            onClose();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (submitError) {
            showFlag({
                type: 'error',
                isAutoDismiss: true,
                title: (0, $1RnLW.messages).externalLinkUpdateFailureTitle,
                description: (0, $1RnLW.messages).externalLinkUpdateFailureDescription
            });
        }
        return undefined;
    }, [
        mode,
        addExternalLink,
        showFlag,
        portalUrl,
        onClose,
        link,
        updateExternalLink
    ]);
    const modalFooterActions = (0, $eUqFw.useMemo)(()=>{
        // add link modal actions
        if (mode === (0, $aNx7t.MODES).ADD) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            appearance: "subtle",
            onClick: (_, analyticsEvent)=>{
                (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'externalResourceAddLinkModalCancel');
                // @ts-expect-error - TS2554 - Expected 1-2 arguments, but got 0.
                onClose();
            },
            isDisabled: isAdding
        }, formatMessage((0, $1RnLW.messages).externalLinksCancel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7opLA.default), {
            appearance: "primary",
            type: "submit",
            onClick: (_, analyticsEvent)=>{
                (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'externalResourceAddLinkModalAdd');
            },
            isDisabled: isAdding,
            isLoading: isAdding
        }, formatMessage((0, $1RnLW.messages).externalLinksAdd)));
        // update link modal actions
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            appearance: "subtle",
            onClick: (_, analyticsEvent)=>{
                (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'externalResourceUpdateLinkModalCancel');
                // @ts-expect-error - TS2554 - Expected 1-2 arguments, but got 0.
                onClose();
            },
            isDisabled: isUpdating
        }, formatMessage((0, $1RnLW.messages).externalLinksCancel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7opLA.default), {
            type: "submit",
            onClick: (_, analyticsEvent)=>{
                (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'externalResourceUpdateLinkModalSave');
            },
            isLoading: isUpdating,
            isDisabled: isUpdating || !isModified,
            appearance: "primary"
        }, formatMessage((0, $1RnLW.messages).externalLinksSaveLink)));
    }, [
        formatMessage,
        isAdding,
        onClose,
        mode,
        isUpdating,
        isModified
    ]);
    const ModalContainer = (0, $eUqFw.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (containerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lzLxZ.default), {
            ...containerProps,
            onSubmit: onSubmit
        }, ({ formProps: formProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("form", formProps, containerProps.children)), [
        onSubmit
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dxopF.default), null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "externalResourcesAdd",
        packageName: "jiraServicedeskExternalResourcesSettings",
        teamName: "jsm-nebula",
        fallback: "flag",
        onError: (0, $aLG4f.markAddUpdateExperienceFailed)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kGQen.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOw1G.default), {
        testId: "servicedesk-external-links.ui.links.add-link-modal.add-links-modal",
        onClose: onClose,
        width: "medium"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ModalContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kigFe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $boSVF.default), null, mode === (0, $aNx7t.MODES).ADD ? formatMessage((0, $1RnLW.messages).externalLinksAddLink) : formatMessage((0, $1RnLW.messages).externalLinksEditLink))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lfiOu.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aLG4f.ProductExperienceStart), {
        ufoExperience: (0, $aLG4f.externalResourcesAddUpdateExperience)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $40AVL.AddLinkForm), {
        link: link,
        mode: mode,
        isModified: isModified,
        setIsModified: setIsModified
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2OJfS.default), null, modalFooterActions)))))));
};

});
parcelRegister("lzLxZ", function(module, exports) {

$parcel$export(module.exports, "FormContext", () => $35270e9129320e50$export$c24727297075ec6a);
$parcel$export(module.exports, "IsDisabledContext", () => $35270e9129320e50$export$c17cf6b332a82dbc);
$parcel$export(module.exports, "default", () => $35270e9129320e50$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3DX5R = parcelRequire("3DX5R");

var $519wV = parcelRequire("519wV");

var $a0i0f = parcelRequire("a0i0f");
const $35270e9129320e50$export$c24727297075ec6a = /*#__PURE__*/ (0, $eUqFw.createContext)({
    registerField: function() {
        return ()=>{};
    },
    getCurrentValue: ()=>undefined,
    subscribe: function() {
        return ()=>{};
    }
});
const $35270e9129320e50$export$c17cf6b332a82dbc = /*#__PURE__*/ (0, $eUqFw.createContext)(false);
function $35270e9129320e50$export$2e2bcd8739ae039(props) {
    const formRef = (0, $eUqFw.useRef)(null);
    const onSubmitRef = (0, $eUqFw.useRef)(props.onSubmit);
    onSubmitRef.current = props.onSubmit;
    const [form] = (0, $eUqFw.useState)(()=>{
        // Types here would break the existing API
        const finalForm = (0, $3DX5R.createForm)({
            onSubmit: (...args)=>onSubmitRef.current(...args),
            destroyOnUnregister: true,
            initialValues: {},
            mutators: {
                setDefaultValue: ([name, defaultValue], state)=>{
                    if (state.formState.initialValues) {
                        const initialValues = state.formState.initialValues;
                        const values = state.formState.values;
                        const value = name && typeof defaultValue === 'function' ? defaultValue(initialValues[name]) : defaultValue;
                        /* eslint-disable no-param-reassign */ (0, (/*@__PURE__*/$parcel$interopDefault($a0i0f)))(initialValues, name, value);
                        (0, (/*@__PURE__*/$parcel$interopDefault($a0i0f)))(values, name, value);
                    /* eslint-enable */ }
                }
            }
        });
        (0, $519wV.default)(()=>formRef.current ? Array.from(formRef.current.querySelectorAll('input')) : [])(finalForm);
        return finalForm;
    });
    const [state, setState] = (0, $eUqFw.useState)({
        dirty: false,
        submitting: false
    });
    (0, $eUqFw.useEffect)(()=>{
        const unsubscribe = form.subscribe(({ dirty: dirty, submitting: submitting })=>{
            setState({
                dirty: dirty,
                submitting: submitting
            });
        }, {
            dirty: true,
            submitting: true
        });
        return unsubscribe;
    }, [
        form
    ]);
    const registerField = (0, $eUqFw.useCallback)((name, defaultValue, subscriber, subscription, config)=>{
        form.pauseValidation();
        const unsubscribe = form.registerField(name, subscriber, subscription, config);
        form.mutators.setDefaultValue(name, defaultValue);
        form.resumeValidation();
        return unsubscribe;
    }, [
        form
    ]);
    const handleSubmit = (e)=>{
        if (e) e.preventDefault();
        form.submit();
    };
    const handleReset = (initialValues)=>{
        form.reset(initialValues);
    };
    const handleKeyDown = (e)=>{
        if (e.key === 'Enter' && (e.ctrlKey || e.metaKey) && formRef.current) {
            const submitButton = formRef.current.querySelector('button:not([type]), button[type="submit"], input[type="submit"]');
            if (submitButton) submitButton.click();
            e.preventDefault();
        }
    };
    const { isDisabled: isDisabled = false, children: children } = props;
    const { dirty: dirty, submitting: submitting } = state;
    /**
	 * This method is needed in FormContext to use it on the field level
	 * to check the current value of the field in case of the component re-mounting.
	 */ const getCurrentValue = (0, $eUqFw.useCallback)((name)=>{
        const formState = form.getState();
        return formState?.values[name] || undefined;
    }, [
        form
    ]);
    const FormContextValue = (0, $eUqFw.useMemo)(()=>{
        return {
            registerField: registerField,
            getCurrentValue: getCurrentValue,
            subscribe: form.subscribe
        };
    }, [
        registerField,
        getCurrentValue,
        form.subscribe
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($35270e9129320e50$export$c24727297075ec6a.Provider, {
        value: FormContextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($35270e9129320e50$export$c17cf6b332a82dbc.Provider, {
        value: isDisabled
    }, children({
        formProps: {
            onSubmit: handleSubmit,
            ref: formRef,
            onKeyDown: handleKeyDown
        },
        dirty: dirty,
        reset: handleReset,
        submitting: submitting,
        disabled: isDisabled,
        getState: ()=>form.getState(),
        getValues: ()=>form.getState().values,
        setFieldValue: form.change
    })));
}

});
parcelRegister("3DX5R", function(module, exports) {

$parcel$export(module.exports, "getIn", () => $2a72da5b7ec16659$export$c52e5867d5879e24);
$parcel$export(module.exports, "FORM_ERROR", () => $2a72da5b7ec16659$export$97cd7fc25dd32915);
$parcel$export(module.exports, "fieldSubscriptionItems", () => $2a72da5b7ec16659$export$41e855cb628c1b55);
$parcel$export(module.exports, "formSubscriptionItems", () => $2a72da5b7ec16659$export$f1ff97b9d1c7a3c3);
$parcel$export(module.exports, "version", () => $2a72da5b7ec16659$export$83d89fbfd8236492);
$parcel$export(module.exports, "createForm", () => $2a72da5b7ec16659$export$f681a8129d2e9d28);

var $kU09D = parcelRequire("kU09D");

var $6XgOP = parcelRequire("6XgOP");
//      
var $2a72da5b7ec16659$var$charCodeOfDot = ".".charCodeAt(0);
var $2a72da5b7ec16659$var$reEscapeChar = /\\(\\)?/g;
var $2a72da5b7ec16659$var$rePropName = RegExp(// Match anything that isn't a dot or bracket.
"[^.[\\]]+|\\[(?:([^\"'][^[]*)|([\"'])((?:(?!\\2)[^\\\\]|\\\\.)*?)\\2)\\]|(?=(?:\\.|\\[\\])(?:\\.|\\[\\]|$))", "g");
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $2a72da5b7ec16659$var$stringToPath = function stringToPath(string) {
    var result = [];
    if (string.charCodeAt(0) === $2a72da5b7ec16659$var$charCodeOfDot) result.push("");
    string.replace($2a72da5b7ec16659$var$rePropName, function(match, expression, quote, subString) {
        var key = match;
        if (quote) key = subString.replace($2a72da5b7ec16659$var$reEscapeChar, "$1");
        else if (expression) key = expression.trim();
        result.push(key);
    });
    return result;
};
var $2a72da5b7ec16659$var$keysCache = {};
var $2a72da5b7ec16659$var$keysRegex = /[.[\]]+/;
var $2a72da5b7ec16659$var$toPath = function toPath(key) {
    if (key === null || key === undefined || !key.length) return [];
    if (typeof key !== "string") throw new Error("toPath() expects a string");
    if ($2a72da5b7ec16659$var$keysCache[key] == null) {
        /**
     * The following patch fixes issue 456, introduced since v4.20.3:
     *
     * Before v4.20.3, i.e. in v4.20.2, a `key` like 'choices[]' would map to ['choices']
     * (e.g. an array of choices used where 'choices[]' is name attribute of an input of type checkbox).
     *
     * Since v4.20.3, a `key` like 'choices[]' would map to ['choices', ''] which is wrong and breaks
     * this kind of inputs e.g. in React.
     *
     * v4.20.3 introduced an unwanted breaking change, this patch fixes it, see the issue at the link below.
     *
     * @see https://github.com/final-form/final-form/issues/456
     */ if (key.endsWith("[]")) // v4.20.2 (a `key` like 'choices[]' should map to ['choices'], which is fine).
        $2a72da5b7ec16659$var$keysCache[key] = key.split($2a72da5b7ec16659$var$keysRegex).filter(Boolean);
        else // v4.20.3 (a `key` like 'choices[]' maps to ['choices', ''], which breaks applications relying on inputs like `<input type="checkbox" name="choices[]" />`).
        $2a72da5b7ec16659$var$keysCache[key] = $2a72da5b7ec16659$var$stringToPath(key);
    }
    return $2a72da5b7ec16659$var$keysCache[key];
};
//      
var $2a72da5b7ec16659$export$c52e5867d5879e24 = function getIn(state, complexKey) {
    // Intentionally using iteration rather than recursion
    var path = $2a72da5b7ec16659$var$toPath(complexKey);
    var current = state;
    for(var i = 0; i < path.length; i++){
        var key = path[i];
        if (current === undefined || current === null || typeof current !== "object" || Array.isArray(current) && isNaN(key)) return undefined;
        current = current[key];
    }
    return current;
};
function $2a72da5b7ec16659$var$_toPropertyKey(arg) {
    var key = $2a72da5b7ec16659$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $2a72da5b7ec16659$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $2a72da5b7ec16659$var$setInRecursor = function setInRecursor(current, index, path, value1, destroyArrays) {
    if (index >= path.length) // end of recursion
    return value1;
    var key = path[index];
    // determine type of key
    if (isNaN(key)) {
        var _extends2;
        // object set
        if (current === undefined || current === null) {
            var _ref;
            // recurse
            var _result = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
            // delete or create an object
            return _result === undefined ? undefined : (_ref = {}, _ref[key] = _result, _ref);
        }
        if (Array.isArray(current)) throw new Error("Cannot set a non-numeric property on an array");
        // current exists, so make a copy of all its values, and add/update the new one
        var _result2 = setInRecursor(current[key], index + 1, path, value1, destroyArrays);
        if (_result2 === undefined) {
            var numKeys = Object.keys(current).length;
            if (current[key] === undefined && numKeys === 0) // object was already empty
            return undefined;
            if (current[key] !== undefined && numKeys <= 1) {
                // only key we had was the one we are deleting
                if (!isNaN(path[index - 1]) && !destroyArrays) // we are in an array, so return an empty object
                return {};
                else return undefined;
            }
            current[key];
            var _final = (0, $6XgOP.default)(current, [
                key
            ].map($2a72da5b7ec16659$var$_toPropertyKey));
            return _final;
        }
        // set result in key
        return (0, $kU09D.default)({}, current, (_extends2 = {}, _extends2[key] = _result2, _extends2));
    }
    // array set
    var numericKey = Number(key);
    if (current === undefined || current === null) {
        // recurse
        var _result3 = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
        // if nothing returned, delete it
        if (_result3 === undefined) return undefined;
        // create an array
        var _array = [];
        _array[numericKey] = _result3;
        return _array;
    }
    if (!Array.isArray(current)) throw new Error("Cannot set a numeric property on an object");
    // recurse
    var existingValue = current[numericKey];
    var result = setInRecursor(existingValue, index + 1, path, value1, destroyArrays);
    // current exists, so make a copy of all its values, and add/update the new one
    var array = [].concat(current);
    if (destroyArrays && result === undefined) {
        array.splice(numericKey, 1);
        if (array.length === 0) return undefined;
    } else array[numericKey] = result;
    return array;
};
var $2a72da5b7ec16659$export$e6bdf135a54e021b = function setIn(state, key, value1, destroyArrays) {
    if (destroyArrays === void 0) destroyArrays = false;
    if (state === undefined || state === null) throw new Error("Cannot call setIn() with " + String(state) + " state");
    if (key === undefined || key === null) throw new Error("Cannot call setIn() with " + String(key) + " key");
    // Recursive function needs to accept and return State, but public API should
    // only deal with Objects
    return $2a72da5b7ec16659$var$setInRecursor(state, 0, $2a72da5b7ec16659$var$toPath(key), value1, destroyArrays);
};
var $2a72da5b7ec16659$export$97cd7fc25dd32915 = "FINAL_FORM/form-error";
var $2a72da5b7ec16659$export$735bebc8ffabf28a = "FINAL_FORM/array-error";
//      
/**
 * Converts internal field state to published field state
 */ function $2a72da5b7ec16659$var$publishFieldState(formState, field) {
    var errors = formState.errors, initialValues = formState.initialValues, lastSubmittedValues = formState.lastSubmittedValues, submitErrors = formState.submitErrors, submitFailed = formState.submitFailed, submitSucceeded = formState.submitSucceeded, submitting = formState.submitting, values = formState.values;
    var active = field.active, blur = field.blur, change = field.change, data = field.data, focus = field.focus, modified = field.modified, modifiedSinceLastSubmit = field.modifiedSinceLastSubmit, name = field.name, touched = field.touched, validating = field.validating, visited = field.visited;
    var value1 = $2a72da5b7ec16659$export$c52e5867d5879e24(values, name);
    var error = $2a72da5b7ec16659$export$c52e5867d5879e24(errors, name);
    if (error && error[$2a72da5b7ec16659$export$735bebc8ffabf28a]) error = error[$2a72da5b7ec16659$export$735bebc8ffabf28a];
    var submitError = submitErrors && $2a72da5b7ec16659$export$c52e5867d5879e24(submitErrors, name);
    var initial = initialValues && $2a72da5b7ec16659$export$c52e5867d5879e24(initialValues, name);
    var pristine = field.isEqual(initial, value1);
    var dirtySinceLastSubmit = !!(lastSubmittedValues && !field.isEqual($2a72da5b7ec16659$export$c52e5867d5879e24(lastSubmittedValues, name), value1));
    var valid = !error && !submitError;
    return {
        active: active,
        blur: blur,
        change: change,
        data: data,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        error: error,
        focus: focus,
        initial: initial,
        invalid: !valid,
        length: Array.isArray(value1) ? value1.length : undefined,
        modified: modified,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        name: name,
        pristine: pristine,
        submitError: submitError,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitting: submitting,
        touched: touched,
        valid: valid,
        value: value1,
        visited: visited,
        validating: validating
    };
}
//      
var $2a72da5b7ec16659$export$41e855cb628c1b55 = [
    "active",
    "data",
    "dirty",
    "dirtySinceLastSubmit",
    "error",
    "initial",
    "invalid",
    "length",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitError",
    "submitFailed",
    "submitSucceeded",
    "submitting",
    "touched",
    "valid",
    "value",
    "visited",
    "validating"
];
//      
var $2a72da5b7ec16659$var$shallowEqual = function shallowEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== "object" || !a || typeof b !== "object" || !b) return false;
    var keysA = Object.keys(a);
    var keysB = Object.keys(b);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(b);
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key) || a[key] !== b[key]) return false;
    }
    return true;
};
//      
function $2a72da5b7ec16659$var$subscriptionFilter(dest, src, previous, subscription, keys, shallowEqualKeys) {
    var different = false;
    keys.forEach(function(key) {
        if (subscription[key]) {
            dest[key] = src[key];
            if (!previous || (~shallowEqualKeys.indexOf(key) ? !$2a72da5b7ec16659$var$shallowEqual(src[key], previous[key]) : src[key] !== previous[key])) different = true;
        }
    });
    return different;
}
//      
var $2a72da5b7ec16659$var$shallowEqualKeys$1 = [
    "data"
];
/**
 * Filters items in a FieldState based on a FieldSubscription
 */ var $2a72da5b7ec16659$var$filterFieldState = function filterFieldState(state, previousState, subscription, force) {
    var result = {
        blur: state.blur,
        change: state.change,
        focus: state.focus,
        name: state.name
    };
    var different = $2a72da5b7ec16659$var$subscriptionFilter(result, state, previousState, subscription, $2a72da5b7ec16659$export$41e855cb628c1b55, $2a72da5b7ec16659$var$shallowEqualKeys$1) || !previousState;
    return different || force ? result : undefined;
};
//      
var $2a72da5b7ec16659$export$f1ff97b9d1c7a3c3 = [
    "active",
    "dirty",
    "dirtyFields",
    "dirtyFieldsSinceLastSubmit",
    "dirtySinceLastSubmit",
    "error",
    "errors",
    "hasSubmitErrors",
    "hasValidationErrors",
    "initialValues",
    "invalid",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitting",
    "submitError",
    "submitErrors",
    "submitFailed",
    "submitSucceeded",
    "touched",
    "valid",
    "validating",
    "values",
    "visited"
];
//      
var $2a72da5b7ec16659$var$shallowEqualKeys = [
    "touched",
    "visited"
];
/**
 * Filters items in a FormState based on a FormSubscription
 */ function $2a72da5b7ec16659$var$filterFormState(state, previousState, subscription, force) {
    var result = {};
    var different = $2a72da5b7ec16659$var$subscriptionFilter(result, state, previousState, subscription, $2a72da5b7ec16659$export$f1ff97b9d1c7a3c3, $2a72da5b7ec16659$var$shallowEqualKeys) || !previousState;
    return different || force ? result : undefined;
}
//      
var $2a72da5b7ec16659$var$memoize = function memoize(fn) {
    var lastArgs;
    var lastResult;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (!lastArgs || args.length !== lastArgs.length || args.some(function(arg, index) {
            return !$2a72da5b7ec16659$var$shallowEqual(lastArgs[index], arg);
        })) {
            lastArgs = args;
            lastResult = fn.apply(void 0, args);
        }
        return lastResult;
    };
};
var $2a72da5b7ec16659$var$isPromise = function(obj) {
    return !!obj && (typeof obj === "object" || typeof obj === "function") && typeof obj.then === "function";
};
var $2a72da5b7ec16659$export$83d89fbfd8236492 = "4.20.10";
var $2a72da5b7ec16659$export$480bc304a47a3b09 = [
    "debug",
    "initialValues",
    "keepDirtyOnReinitialize",
    "mutators",
    "onSubmit",
    "validate",
    "validateOnBlur"
];
var $2a72da5b7ec16659$var$tripleEquals = function tripleEquals(a, b) {
    return a === b;
};
var $2a72da5b7ec16659$var$hasAnyError = function hasAnyError(errors) {
    return Object.keys(errors).some(function(key) {
        var value1 = errors[key];
        if (value1 && typeof value1 === "object" && !(value1 instanceof Error)) return hasAnyError(value1);
        return typeof value1 !== "undefined";
    });
};
function $2a72da5b7ec16659$var$convertToExternalFormState(_ref) {
    var active = _ref.active, dirtySinceLastSubmit = _ref.dirtySinceLastSubmit, modifiedSinceLastSubmit = _ref.modifiedSinceLastSubmit, error = _ref.error, errors = _ref.errors, initialValues = _ref.initialValues, pristine = _ref.pristine, submitting = _ref.submitting, submitFailed = _ref.submitFailed, submitSucceeded = _ref.submitSucceeded, submitError = _ref.submitError, submitErrors = _ref.submitErrors, valid = _ref.valid, validating = _ref.validating, values = _ref.values;
    return {
        active: active,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        error: error,
        errors: errors,
        hasSubmitErrors: !!(submitError || submitErrors && $2a72da5b7ec16659$var$hasAnyError(submitErrors)),
        hasValidationErrors: !!(error || $2a72da5b7ec16659$var$hasAnyError(errors)),
        invalid: !valid,
        initialValues: initialValues,
        pristine: pristine,
        submitting: submitting,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitError: submitError,
        submitErrors: submitErrors,
        valid: valid,
        validating: validating > 0,
        values: values
    };
}
function $2a72da5b7ec16659$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force) {
    var notification = filter(state, lastState, subscription, force);
    if (notification) {
        subscriber(notification);
        return true;
    }
    return false;
}
function $2a72da5b7ec16659$var$notify(_ref2, state, lastState, filter, force) {
    var entries = _ref2.entries;
    Object.keys(entries).forEach(function(key) {
        var entry = entries[Number(key)];
        // istanbul ignore next
        if (entry) {
            var subscription = entry.subscription, subscriber = entry.subscriber, notified = entry.notified;
            if ($2a72da5b7ec16659$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force || !notified)) entry.notified = true;
        }
    });
}
function $2a72da5b7ec16659$export$f681a8129d2e9d28(config) {
    if (!config) throw new Error("No config specified");
    var debug = config.debug, destroyOnUnregister = config.destroyOnUnregister, keepDirtyOnReinitialize = config.keepDirtyOnReinitialize, initialValues = config.initialValues, mutators = config.mutators, onSubmit = config.onSubmit, validate = config.validate, validateOnBlur = config.validateOnBlur;
    if (!onSubmit) throw new Error("No onSubmit function specified");
    var state = {
        subscribers: {
            index: 0,
            entries: {}
        },
        fieldSubscribers: {},
        fields: {},
        formState: {
            asyncErrors: {},
            dirtySinceLastSubmit: false,
            modifiedSinceLastSubmit: false,
            errors: {},
            initialValues: initialValues && (0, $kU09D.default)({}, initialValues),
            invalid: false,
            pristine: true,
            submitting: false,
            submitFailed: false,
            submitSucceeded: false,
            resetWhileSubmitting: false,
            valid: true,
            validating: 0,
            values: initialValues ? (0, $kU09D.default)({}, initialValues) : {}
        },
        lastFormState: undefined
    };
    var inBatch = 0;
    var validationPaused = false;
    var validationBlocked = false;
    var preventNotificationWhileValidationPaused = false;
    var nextAsyncValidationKey = 0;
    var asyncValidationPromises = {};
    var clearAsyncValidationPromise = function clearAsyncValidationPromise(key) {
        return function(result) {
            delete asyncValidationPromises[key];
            return result;
        };
    };
    var changeValue = function changeValue(state, name, mutate) {
        var before = $2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.values, name);
        var after = mutate(before);
        state.formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.values, name, after) || {};
    };
    var renameField = function renameField(state, from, to) {
        if (state.fields[from]) {
            var _extends2, _extends3;
            state.fields = (0, $kU09D.default)({}, state.fields, (_extends2 = {}, _extends2[to] = (0, $kU09D.default)({}, state.fields[from], {
                name: to,
                // rebind event handlers
                blur: function blur() {
                    return api.blur(to);
                },
                change: function change(value1) {
                    return api.change(to, value1);
                },
                focus: function focus() {
                    return api.focus(to);
                },
                lastFieldState: undefined
            }), _extends2));
            delete state.fields[from];
            state.fieldSubscribers = (0, $kU09D.default)({}, state.fieldSubscribers, (_extends3 = {}, _extends3[to] = state.fieldSubscribers[from], _extends3));
            delete state.fieldSubscribers[from];
            var value1 = $2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.values, from);
            state.formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.values, from, undefined) || {};
            state.formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.values, to, value1);
            delete state.lastFormState;
        }
    };
    // bind state to mutators
    var getMutatorApi = function getMutatorApi(key) {
        return function() {
            // istanbul ignore next
            if (mutators) {
                // ^^ causes branch coverage warning, but needed to appease the Flow gods
                var mutatableState = {
                    formState: state.formState,
                    fields: state.fields,
                    fieldSubscribers: state.fieldSubscribers,
                    lastFormState: state.lastFormState
                };
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                var returnValue = mutators[key](args, mutatableState, {
                    changeValue: changeValue,
                    getIn: $2a72da5b7ec16659$export$c52e5867d5879e24,
                    renameField: renameField,
                    resetFieldState: api.resetFieldState,
                    setIn: $2a72da5b7ec16659$export$e6bdf135a54e021b,
                    shallowEqual: $2a72da5b7ec16659$var$shallowEqual
                });
                state.formState = mutatableState.formState;
                state.fields = mutatableState.fields;
                state.fieldSubscribers = mutatableState.fieldSubscribers;
                state.lastFormState = mutatableState.lastFormState;
                runValidation(undefined, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                return returnValue;
            }
        };
    };
    var mutatorsApi = mutators ? Object.keys(mutators).reduce(function(result, key) {
        result[key] = getMutatorApi(key);
        return result;
    }, {}) : {};
    var runRecordLevelValidation = function runRecordLevelValidation(setErrors) {
        var promises = [];
        if (validate) {
            var errorsOrPromise = validate((0, $kU09D.default)({}, state.formState.values)); // clone to avoid writing
            if ($2a72da5b7ec16659$var$isPromise(errorsOrPromise)) promises.push(errorsOrPromise.then(function(errors) {
                return setErrors(errors, true);
            }));
            else setErrors(errorsOrPromise, false);
        }
        return promises;
    };
    var getValidators = function getValidators(field) {
        return Object.keys(field.validators).reduce(function(result, index) {
            var validator = field.validators[Number(index)]();
            if (validator) result.push(validator);
            return result;
        }, []);
    };
    var runFieldLevelValidation = function runFieldLevelValidation(field, setError) {
        var promises = [];
        var validators = getValidators(field);
        if (validators.length) {
            var error;
            validators.forEach(function(validator) {
                var errorOrPromise = validator($2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.values, field.name), state.formState.values, validator.length === 0 || validator.length === 3 ? $2a72da5b7ec16659$var$publishFieldState(state.formState, state.fields[field.name]) : undefined);
                if (errorOrPromise && $2a72da5b7ec16659$var$isPromise(errorOrPromise)) {
                    field.validating = true;
                    var promise = errorOrPromise.then(function(error) {
                        if (state.fields[field.name]) {
                            state.fields[field.name].validating = false;
                            setError(error);
                        }
                    }); // errors must be resolved, not rejected
                    promises.push(promise);
                } else if (!error) // first registered validator wins
                error = errorOrPromise;
            });
            setError(error);
        }
        return promises;
    };
    var runValidation = function runValidation(fieldChanged, callback) {
        if (validationPaused) {
            validationBlocked = true;
            callback();
            return;
        }
        var fields = state.fields, formState = state.formState;
        var safeFields = (0, $kU09D.default)({}, fields);
        var fieldKeys = Object.keys(safeFields);
        if (!validate && !fieldKeys.some(function(key) {
            return getValidators(safeFields[key]).length;
        })) {
            callback();
            return; // no validation rules
        }
        // pare down field keys to actually validate
        var limitedFieldLevelValidation = false;
        if (fieldChanged) {
            var changedField = safeFields[fieldChanged];
            if (changedField) {
                var validateFields = changedField.validateFields;
                if (validateFields) {
                    limitedFieldLevelValidation = true;
                    fieldKeys = validateFields.length ? validateFields.concat(fieldChanged) : [
                        fieldChanged
                    ];
                }
            }
        }
        var recordLevelErrors = {};
        var asyncRecordLevelErrors = {};
        var fieldLevelErrors = {};
        var promises = [].concat(runRecordLevelValidation(function(errors, wasAsync) {
            if (wasAsync) asyncRecordLevelErrors = errors || {};
            else recordLevelErrors = errors || {};
        }), fieldKeys.reduce(function(result, name) {
            return result.concat(runFieldLevelValidation(fields[name], function(error) {
                fieldLevelErrors[name] = error;
            }));
        }, []));
        var hasAsyncValidations = promises.length > 0;
        var asyncValidationPromiseKey = ++nextAsyncValidationKey;
        var promise = Promise.all(promises).then(clearAsyncValidationPromise(asyncValidationPromiseKey));
        // backwards-compat: add promise to submit-blocking promises iff there are any promises to await
        if (hasAsyncValidations) asyncValidationPromises[asyncValidationPromiseKey] = promise;
        var processErrors = function processErrors(afterAsync) {
            var merged = (0, $kU09D.default)({}, limitedFieldLevelValidation ? formState.errors : {}, recordLevelErrors, afterAsync ? asyncRecordLevelErrors // new async errors
             : formState.asyncErrors);
            var forEachError = function forEachError(fn) {
                fieldKeys.forEach(function(name) {
                    if (fields[name]) {
                        // make sure field is still registered
                        // field-level errors take precedent over record-level errors
                        var recordLevelError = $2a72da5b7ec16659$export$c52e5867d5879e24(recordLevelErrors, name);
                        var errorFromParent = $2a72da5b7ec16659$export$c52e5867d5879e24(merged, name);
                        var hasFieldLevelValidation = getValidators(safeFields[name]).length;
                        var fieldLevelError = fieldLevelErrors[name];
                        fn(name, hasFieldLevelValidation && fieldLevelError || validate && recordLevelError || (!recordLevelError && !limitedFieldLevelValidation ? errorFromParent : undefined));
                    }
                });
            };
            forEachError(function(name, error) {
                merged = $2a72da5b7ec16659$export$e6bdf135a54e021b(merged, name, error) || {};
            });
            forEachError(function(name, error) {
                if (error && error[$2a72da5b7ec16659$export$735bebc8ffabf28a]) {
                    var existing = $2a72da5b7ec16659$export$c52e5867d5879e24(merged, name);
                    var copy = [].concat(existing);
                    copy[$2a72da5b7ec16659$export$735bebc8ffabf28a] = error[$2a72da5b7ec16659$export$735bebc8ffabf28a];
                    merged = $2a72da5b7ec16659$export$e6bdf135a54e021b(merged, name, copy);
                }
            });
            if (!$2a72da5b7ec16659$var$shallowEqual(formState.errors, merged)) formState.errors = merged;
            if (afterAsync) formState.asyncErrors = asyncRecordLevelErrors;
            formState.error = recordLevelErrors[$2a72da5b7ec16659$export$97cd7fc25dd32915];
        };
        if (hasAsyncValidations) {
            // async validations are running, ensure validating is true before notifying
            state.formState.validating++;
            callback();
        }
        // process sync errors
        processErrors(false);
        // sync errors have been set. notify listeners while we wait for others
        callback();
        if (hasAsyncValidations) {
            var afterPromise = function afterPromise() {
                state.formState.validating--;
                callback();
                // field async validation may affect formState validating
                // so force notifyFormListeners if validating is still 0 after callback finished
                // and lastFormState validating is true
                if (state.formState.validating === 0 && state.lastFormState.validating) notifyFormListeners();
            };
            promise.then(function() {
                if (nextAsyncValidationKey > asyncValidationPromiseKey) // if this async validator has been superseded by another, ignore its results
                return;
                processErrors(true);
            }).then(afterPromise, afterPromise);
        }
    };
    var notifyFieldListeners = function notifyFieldListeners(name) {
        if (inBatch) return;
        var fields = state.fields, fieldSubscribers = state.fieldSubscribers, formState = state.formState;
        var safeFields = (0, $kU09D.default)({}, fields);
        var notifyField = function notifyField(name) {
            var field = safeFields[name];
            var fieldState = $2a72da5b7ec16659$var$publishFieldState(formState, field);
            var lastFieldState = field.lastFieldState;
            field.lastFieldState = fieldState;
            var fieldSubscriber = fieldSubscribers[name];
            if (fieldSubscriber) $2a72da5b7ec16659$var$notify(fieldSubscriber, fieldState, lastFieldState, $2a72da5b7ec16659$var$filterFieldState, lastFieldState === undefined);
        };
        if (name) notifyField(name);
        else Object.keys(safeFields).forEach(notifyField);
    };
    var markAllFieldsTouched = function markAllFieldsTouched() {
        Object.keys(state.fields).forEach(function(key) {
            state.fields[key].touched = true;
        });
    };
    var hasSyncErrors = function hasSyncErrors() {
        return !!(state.formState.error || $2a72da5b7ec16659$var$hasAnyError(state.formState.errors));
    };
    var calculateNextFormState = function calculateNextFormState() {
        var fields = state.fields, formState = state.formState, lastFormState = state.lastFormState;
        var safeFields = (0, $kU09D.default)({}, fields);
        var safeFieldKeys = Object.keys(safeFields);
        // calculate dirty/pristine
        var foundDirty = false;
        var dirtyFields = safeFieldKeys.reduce(function(result, key) {
            var dirty = !safeFields[key].isEqual($2a72da5b7ec16659$export$c52e5867d5879e24(formState.values, key), $2a72da5b7ec16659$export$c52e5867d5879e24(formState.initialValues || {}, key));
            if (dirty) {
                foundDirty = true;
                result[key] = true;
            }
            return result;
        }, {});
        var dirtyFieldsSinceLastSubmit = safeFieldKeys.reduce(function(result, key) {
            // istanbul ignore next
            var nonNullLastSubmittedValues = formState.lastSubmittedValues || {}; // || {} is for flow, but causes branch coverage complaint
            if (!safeFields[key].isEqual($2a72da5b7ec16659$export$c52e5867d5879e24(formState.values, key), $2a72da5b7ec16659$export$c52e5867d5879e24(nonNullLastSubmittedValues, key))) result[key] = true;
            return result;
        }, {});
        formState.pristine = !foundDirty;
        formState.dirtySinceLastSubmit = !!(formState.lastSubmittedValues && Object.values(dirtyFieldsSinceLastSubmit).some(function(value1) {
            return value1;
        }));
        formState.modifiedSinceLastSubmit = !!(formState.lastSubmittedValues && // Object.values would treat values as mixed (facebook/flow#2221)
        Object.keys(safeFields).some(function(value1) {
            return safeFields[value1].modifiedSinceLastSubmit;
        }));
        formState.valid = !formState.error && !formState.submitError && !$2a72da5b7ec16659$var$hasAnyError(formState.errors) && !(formState.submitErrors && $2a72da5b7ec16659$var$hasAnyError(formState.submitErrors));
        var nextFormState = $2a72da5b7ec16659$var$convertToExternalFormState(formState);
        var _safeFieldKeys$reduce = safeFieldKeys.reduce(function(result, key) {
            result.modified[key] = safeFields[key].modified;
            result.touched[key] = safeFields[key].touched;
            result.visited[key] = safeFields[key].visited;
            return result;
        }, {
            modified: {},
            touched: {},
            visited: {}
        }), modified = _safeFieldKeys$reduce.modified, touched = _safeFieldKeys$reduce.touched, visited = _safeFieldKeys$reduce.visited;
        nextFormState.dirtyFields = lastFormState && $2a72da5b7ec16659$var$shallowEqual(lastFormState.dirtyFields, dirtyFields) ? lastFormState.dirtyFields : dirtyFields;
        nextFormState.dirtyFieldsSinceLastSubmit = lastFormState && $2a72da5b7ec16659$var$shallowEqual(lastFormState.dirtyFieldsSinceLastSubmit, dirtyFieldsSinceLastSubmit) ? lastFormState.dirtyFieldsSinceLastSubmit : dirtyFieldsSinceLastSubmit;
        nextFormState.modified = lastFormState && $2a72da5b7ec16659$var$shallowEqual(lastFormState.modified, modified) ? lastFormState.modified : modified;
        nextFormState.touched = lastFormState && $2a72da5b7ec16659$var$shallowEqual(lastFormState.touched, touched) ? lastFormState.touched : touched;
        nextFormState.visited = lastFormState && $2a72da5b7ec16659$var$shallowEqual(lastFormState.visited, visited) ? lastFormState.visited : visited;
        return lastFormState && $2a72da5b7ec16659$var$shallowEqual(lastFormState, nextFormState) ? lastFormState : nextFormState;
    };
    var callDebug = function callDebug() {
        return debug && true && debug(calculateNextFormState(), Object.keys(state.fields).reduce(function(result, key) {
            result[key] = state.fields[key];
            return result;
        }, {}));
    };
    var notifying = false;
    var scheduleNotification = false;
    var notifyFormListeners = function notifyFormListeners() {
        if (notifying) scheduleNotification = true;
        else {
            notifying = true;
            callDebug();
            if (!inBatch && !(validationPaused && preventNotificationWhileValidationPaused)) {
                var lastFormState = state.lastFormState;
                var nextFormState = calculateNextFormState();
                if (nextFormState !== lastFormState) {
                    state.lastFormState = nextFormState;
                    $2a72da5b7ec16659$var$notify(state.subscribers, nextFormState, lastFormState, $2a72da5b7ec16659$var$filterFormState);
                }
            }
            notifying = false;
            if (scheduleNotification) {
                scheduleNotification = false;
                notifyFormListeners();
            }
        }
    };
    var beforeSubmit = function beforeSubmit() {
        return Object.keys(state.fields).some(function(name) {
            return state.fields[name].beforeSubmit && state.fields[name].beforeSubmit() === false;
        });
    };
    var afterSubmit = function afterSubmit() {
        return Object.keys(state.fields).forEach(function(name) {
            return state.fields[name].afterSubmit && state.fields[name].afterSubmit();
        });
    };
    var resetModifiedAfterSubmit = function resetModifiedAfterSubmit() {
        return Object.keys(state.fields).forEach(function(key) {
            return state.fields[key].modifiedSinceLastSubmit = false;
        });
    };
    // generate initial errors
    runValidation(undefined, function() {
        notifyFormListeners();
    });
    var api = {
        batch: function batch(fn) {
            inBatch++;
            fn();
            inBatch--;
            notifyFieldListeners();
            notifyFormListeners();
        },
        blur: function blur(name) {
            var fields = state.fields, formState = state.formState;
            var previous = fields[name];
            if (previous) {
                // can only blur registered fields
                delete formState.active;
                fields[name] = (0, $kU09D.default)({}, previous, {
                    active: false,
                    touched: true
                });
                if (validateOnBlur) runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                else {
                    notifyFieldListeners();
                    notifyFormListeners();
                }
            }
        },
        change: function change(name, value1) {
            var fields = state.fields, formState = state.formState;
            if ($2a72da5b7ec16659$export$c52e5867d5879e24(formState.values, name) !== value1) {
                changeValue(state, name, function() {
                    return value1;
                });
                var previous = fields[name];
                if (previous) // only track modified for registered fields
                fields[name] = (0, $kU09D.default)({}, previous, {
                    modified: true,
                    modifiedSinceLastSubmit: !!formState.lastSubmittedValues
                });
                if (validateOnBlur) {
                    notifyFieldListeners();
                    notifyFormListeners();
                } else runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
            }
        },
        get destroyOnUnregister () {
            return !!destroyOnUnregister;
        },
        set destroyOnUnregister (value){
            destroyOnUnregister = value;
        },
        focus: function focus(name) {
            var field = state.fields[name];
            if (field && !field.active) {
                state.formState.active = name;
                field.active = true;
                field.visited = true;
                notifyFieldListeners();
                notifyFormListeners();
            }
        },
        mutators: mutatorsApi,
        getFieldState: function getFieldState(name) {
            var field = state.fields[name];
            return field && field.lastFieldState;
        },
        getRegisteredFields: function getRegisteredFields() {
            return Object.keys(state.fields);
        },
        getState: function getState() {
            return calculateNextFormState();
        },
        initialize: function initialize(data) {
            var fields = state.fields, formState = state.formState;
            var safeFields = (0, $kU09D.default)({}, fields);
            var values = typeof data === "function" ? data(formState.values) : data;
            if (!keepDirtyOnReinitialize) formState.values = values;
            /**
       * Hello, inquisitive code reader! Thanks for taking the time to dig in!
       *
       * The following code is the way it is to allow for non-registered deep
       * field values to be set via initialize()
       */ // save dirty values
            var savedDirtyValues = keepDirtyOnReinitialize ? Object.keys(safeFields).reduce(function(result, key) {
                var field = safeFields[key];
                var pristine = field.isEqual($2a72da5b7ec16659$export$c52e5867d5879e24(formState.values, key), $2a72da5b7ec16659$export$c52e5867d5879e24(formState.initialValues || {}, key));
                if (!pristine) result[key] = $2a72da5b7ec16659$export$c52e5867d5879e24(formState.values, key);
                return result;
            }, {}) : {};
            // update initalValues and values
            formState.initialValues = values;
            formState.values = values;
            // restore the dirty values
            Object.keys(savedDirtyValues).forEach(function(key) {
                formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(formState.values, key, savedDirtyValues[key]) || {};
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        isValidationPaused: function isValidationPaused() {
            return validationPaused;
        },
        pauseValidation: function pauseValidation(preventNotification) {
            if (preventNotification === void 0) preventNotification = true;
            validationPaused = true;
            preventNotificationWhileValidationPaused = preventNotification;
        },
        registerField: function registerField(name, subscriber, subscription, fieldConfig) {
            if (subscription === void 0) subscription = {};
            if (!state.fieldSubscribers[name]) state.fieldSubscribers[name] = {
                index: 0,
                entries: {}
            };
            var index = state.fieldSubscribers[name].index++;
            // save field subscriber callback
            state.fieldSubscribers[name].entries[index] = {
                subscriber: $2a72da5b7ec16659$var$memoize(subscriber),
                subscription: subscription,
                notified: false
            };
            // create initial field state if not exists
            var field = state.fields[name] || {
                active: false,
                afterSubmit: fieldConfig && fieldConfig.afterSubmit,
                beforeSubmit: fieldConfig && fieldConfig.beforeSubmit,
                data: fieldConfig && fieldConfig.data || {},
                isEqual: fieldConfig && fieldConfig.isEqual || $2a72da5b7ec16659$var$tripleEquals,
                lastFieldState: undefined,
                modified: false,
                modifiedSinceLastSubmit: false,
                name: name,
                touched: false,
                valid: true,
                validateFields: fieldConfig && fieldConfig.validateFields,
                validators: {},
                validating: false,
                visited: false
            };
            // Mutators can create a field in order to keep the field states
            // We must update this field when registerField is called afterwards
            field.blur = field.blur || function() {
                return api.blur(name);
            };
            field.change = field.change || function(value1) {
                return api.change(name, value1);
            };
            field.focus = field.focus || function() {
                return api.focus(name);
            };
            state.fields[name] = field;
            var haveValidator = false;
            var silent = fieldConfig && fieldConfig.silent;
            var notify = function notify() {
                if (silent && state.fields[name]) notifyFieldListeners(name);
                else {
                    notifyFormListeners();
                    notifyFieldListeners();
                }
            };
            if (fieldConfig) {
                haveValidator = !!(fieldConfig.getValidator && fieldConfig.getValidator());
                if (fieldConfig.getValidator) state.fields[name].validators[index] = fieldConfig.getValidator;
                var noValueInFormState = $2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.values, name) === undefined;
                if (fieldConfig.initialValue !== undefined && (noValueInFormState || $2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.values, name) === $2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.initialValues, name))) {
                    state.formState.initialValues = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.initialValues || {}, name, fieldConfig.initialValue);
                    state.formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.initialValue);
                    runValidation(undefined, notify);
                }
                // only use defaultValue if we don't yet have any value for this field
                if (fieldConfig.defaultValue !== undefined && fieldConfig.initialValue === undefined && $2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.initialValues, name) === undefined && noValueInFormState) state.formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.defaultValue);
            }
            if (haveValidator) runValidation(undefined, notify);
            else notify();
            return function() {
                var validatorRemoved = false;
                // istanbul ignore next
                if (state.fields[name]) {
                    // state.fields[name] may have been removed by a mutator
                    validatorRemoved = !!(state.fields[name].validators[index] && state.fields[name].validators[index]());
                    delete state.fields[name].validators[index];
                }
                var hasFieldSubscribers = !!state.fieldSubscribers[name];
                if (hasFieldSubscribers) // state.fieldSubscribers[name] may have been removed by a mutator
                delete state.fieldSubscribers[name].entries[index];
                var lastOne = hasFieldSubscribers && !Object.keys(state.fieldSubscribers[name].entries).length;
                if (lastOne) {
                    delete state.fieldSubscribers[name];
                    delete state.fields[name];
                    if (validatorRemoved) state.formState.errors = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.errors, name, undefined) || {};
                    if (destroyOnUnregister) state.formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.values, name, undefined, true) || {};
                }
                if (!silent) {
                    if (validatorRemoved) runValidation(undefined, function() {
                        notifyFormListeners();
                        notifyFieldListeners();
                    });
                    else if (lastOne) // values or errors may have changed
                    notifyFormListeners();
                }
            };
        },
        reset: function reset(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            if (state.formState.submitting) state.formState.resetWhileSubmitting = true;
            state.formState.submitFailed = false;
            state.formState.submitSucceeded = false;
            delete state.formState.submitError;
            delete state.formState.submitErrors;
            delete state.formState.lastSubmittedValues;
            api.initialize(initialValues || {});
        },
        /**
     * Resets all field flags (e.g. touched, visited, etc.) to their initial state
     */ resetFieldState: function resetFieldState(name) {
            state.fields[name] = (0, $kU09D.default)({}, state.fields[name], {
                active: false,
                lastFieldState: undefined,
                modified: false,
                touched: false,
                valid: true,
                validating: false,
                visited: false
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        /**
     * Returns the form to a clean slate; that is:
     * - Clear all values
     * - Resets all fields to their initial state
     */ restart: function restart(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            api.batch(function() {
                for(var name in state.fields){
                    api.resetFieldState(name);
                    state.fields[name] = (0, $kU09D.default)({}, state.fields[name], {
                        active: false,
                        lastFieldState: undefined,
                        modified: false,
                        modifiedSinceLastSubmit: false,
                        touched: false,
                        valid: true,
                        validating: false,
                        visited: false
                    });
                }
                api.reset(initialValues);
            });
        },
        resumeValidation: function resumeValidation() {
            validationPaused = false;
            preventNotificationWhileValidationPaused = false;
            if (validationBlocked) // validation was attempted while it was paused, so run it now
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
            validationBlocked = false;
        },
        setConfig: function setConfig(name, value1) {
            switch(name){
                case "debug":
                    debug = value1;
                    break;
                case "destroyOnUnregister":
                    destroyOnUnregister = value1;
                    break;
                case "initialValues":
                    api.initialize(value1);
                    break;
                case "keepDirtyOnReinitialize":
                    keepDirtyOnReinitialize = value1;
                    break;
                case "mutators":
                    mutators = value1;
                    if (value1) {
                        Object.keys(mutatorsApi).forEach(function(key) {
                            if (!(key in value1)) delete mutatorsApi[key];
                        });
                        Object.keys(value1).forEach(function(key) {
                            mutatorsApi[key] = getMutatorApi(key);
                        });
                    } else Object.keys(mutatorsApi).forEach(function(key) {
                        delete mutatorsApi[key];
                    });
                    break;
                case "onSubmit":
                    onSubmit = value1;
                    break;
                case "validate":
                    validate = value1;
                    runValidation(undefined, function() {
                        notifyFieldListeners();
                        notifyFormListeners();
                    });
                    break;
                case "validateOnBlur":
                    validateOnBlur = value1;
                    break;
                default:
                    throw new Error("Unrecognised option " + name);
            }
        },
        submit: function submit() {
            var formState = state.formState;
            if (formState.submitting) return;
            delete formState.submitErrors;
            delete formState.submitError;
            formState.lastSubmittedValues = (0, $kU09D.default)({}, formState.values);
            if (hasSyncErrors()) {
                markAllFieldsTouched();
                resetModifiedAfterSubmit();
                state.formState.submitFailed = true;
                notifyFormListeners();
                notifyFieldListeners();
                return; // no submit for you!!
            }
            var asyncValidationPromisesKeys = Object.keys(asyncValidationPromises);
            if (asyncValidationPromisesKeys.length) {
                // still waiting on async validation to complete...
                Promise.all(asyncValidationPromisesKeys.map(function(key) {
                    return asyncValidationPromises[Number(key)];
                })).then(api.submit, console.error);
                return;
            }
            var submitIsBlocked = beforeSubmit();
            if (submitIsBlocked) return;
            var resolvePromise;
            var completeCalled = false;
            var complete = function complete(errors) {
                formState.submitting = false;
                var resetWhileSubmitting = formState.resetWhileSubmitting;
                if (resetWhileSubmitting) formState.resetWhileSubmitting = false;
                if (errors && $2a72da5b7ec16659$var$hasAnyError(errors)) {
                    formState.submitFailed = true;
                    formState.submitSucceeded = false;
                    formState.submitErrors = errors;
                    formState.submitError = errors[$2a72da5b7ec16659$export$97cd7fc25dd32915];
                    markAllFieldsTouched();
                } else {
                    if (!resetWhileSubmitting) {
                        formState.submitFailed = false;
                        formState.submitSucceeded = true;
                    }
                    afterSubmit();
                }
                notifyFormListeners();
                notifyFieldListeners();
                completeCalled = true;
                if (resolvePromise) resolvePromise(errors);
                return errors;
            };
            formState.submitting = true;
            formState.submitFailed = false;
            formState.submitSucceeded = false;
            formState.lastSubmittedValues = (0, $kU09D.default)({}, formState.values);
            resetModifiedAfterSubmit();
            // onSubmit is either sync, callback or async with a Promise
            var result = onSubmit(formState.values, api, complete);
            if (!completeCalled) {
                if (result && $2a72da5b7ec16659$var$isPromise(result)) {
                    // onSubmit is async with a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return result.then(complete, function(error) {
                        complete();
                        throw error;
                    });
                } else if (onSubmit.length >= 3) {
                    // must be async, so we should return a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return new Promise(function(resolve) {
                        resolvePromise = resolve;
                    });
                } else // onSubmit is sync
                complete(result);
            }
        },
        subscribe: function subscribe(subscriber, subscription) {
            if (!subscriber) throw new Error("No callback given.");
            if (!subscription) throw new Error("No subscription provided. What values do you want to listen to?");
            var memoized = $2a72da5b7ec16659$var$memoize(subscriber);
            var subscribers = state.subscribers;
            var index = subscribers.index++;
            subscribers.entries[index] = {
                subscriber: memoized,
                subscription: subscription,
                notified: false
            };
            var nextFormState = calculateNextFormState();
            $2a72da5b7ec16659$var$notifySubscriber(memoized, subscription, nextFormState, nextFormState, $2a72da5b7ec16659$var$filterFormState, true);
            return function() {
                delete subscribers.entries[index];
            };
        }
    };
    return api;
}

});

parcelRegister("519wV", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a747034649a7960$export$2e2bcd8739ae039);

var $3DX5R = parcelRequire("3DX5R");
//      
/**
 * Predicate to identify inputs that can have focus() called on them
 */ var $3a747034649a7960$var$isFocusableInput = function isFocusableInput(wtf) {
    return !!(wtf && typeof wtf.focus === 'function');
};
//      
/**
 * Gets all the inputs inside all forms on the page
 */ var $3a747034649a7960$var$getAllInputs = function getAllInputs() {
    if (typeof document === 'undefined') return [];
    return Array.prototype.slice.call(document.forms).reduce(function(accumulator, form) {
        return accumulator.concat(Array.prototype.slice.call(form).filter($3a747034649a7960$var$isFocusableInput));
    }, []);
};
//      
/**
 * Finds the input by looking if the name attribute path is existing in the errors object
 */ var $3a747034649a7960$var$findInput = function findInput(inputs, errors) {
    return inputs.find(function(input) {
        return input.name && (0, $3DX5R.getIn)(errors, input.name);
    });
};
//      
var $3a747034649a7960$var$noop = function noop() {};
var $3a747034649a7960$var$createDecorator = function createDecorator(getInputs, findInput$$1) {
    return function(form) {
        var focusOnFirstError = function focusOnFirstError(errors) {
            if (!getInputs) getInputs = $3a747034649a7960$var$getAllInputs;
            if (!findInput$$1) findInput$$1 = $3a747034649a7960$var$findInput;
            var firstInput = findInput$$1(getInputs(), errors);
            if (firstInput) firstInput.focus();
        }; // Save original submit function
        var originalSubmit = form.submit; // Subscribe to errors, and keep a local copy of them
        var state = {};
        var unsubscribe = form.subscribe(function(nextState) {
            state = nextState;
        }, {
            errors: true,
            submitErrors: true
        }); // What to do after submit
        var afterSubmit = function afterSubmit() {
            var _state = state, errors = _state.errors, submitErrors = _state.submitErrors;
            if (errors && Object.keys(errors).length) focusOnFirstError(errors);
            else if (submitErrors && Object.keys(submitErrors).length) focusOnFirstError(submitErrors);
        }; // Rewrite submit function
        form.submit = function() {
            var result = originalSubmit.call(form);
            if (result && typeof result.then === 'function') // async
            result.then(afterSubmit, $3a747034649a7960$var$noop);
            else // sync
            afterSubmit();
            return result;
        };
        return function() {
            unsubscribe();
            form.submit = originalSubmit;
        };
    };
};
//      
/**
 * Generates a function to get all the inputs in a form with the specified name
 */ var $3a747034649a7960$export$a53c79cbd9f0d029 = function getFormInputs(name) {
    return function() {
        if (typeof document === 'undefined') return [];
         // $FlowFixMe
        var form = document.forms[name];
        return form && form.length ? Array.prototype.slice.call(form).filter($3a747034649a7960$var$isFocusableInput) : []; // cast cheat to get from HTMLFormElement children to FocusableInput
    };
};
var //
$3a747034649a7960$export$2e2bcd8739ae039 = $3a747034649a7960$var$createDecorator;

});

parcelRegister("a0i0f", function(module, exports) {

var $buvff = parcelRequire("buvff");
/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */ function $7487de7aebcafd99$var$set(object, path, value) {
    return object == null ? object : $buvff(object, path, value);
}
module.exports = $7487de7aebcafd99$var$set;

});


parcelRegister("kGQen", function(module, exports) {

$parcel$export(module.exports, "ShortcutRegistryContext", () => $082205e2100625d8$export$ebbb59327adb551a);
$parcel$export(module.exports, "default", () => $082205e2100625d8$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $fVFUy = parcelRequire("fVFUy");
const $082205e2100625d8$export$ebbb59327adb551a = /*#__PURE__*/ (0, $eUqFw.createContext)((0, $fVFUy.rootRegistry));
const $082205e2100625d8$var$ShortcutScope = ({ children: children = null })=>{
    const registry = (0, $eUqFw.useMemo)(()=>new (0, $fVFUy.ShortcutRegistry)(), []);
    const parentRegistry = (0, $eUqFw.useContext)($082205e2100625d8$export$ebbb59327adb551a) || (0, $fVFUy.rootRegistry);
    (0, $eUqFw.useEffect)(()=>{
        // "This only happens ONCE.  But it happens AFTER the initial render."
        const removeRegistry = parentRegistry.addChildRegistry(registry);
        return removeRegistry;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($082205e2100625d8$export$ebbb59327adb551a.Provider, {
        value: registry
    }, children);
};
var $082205e2100625d8$export$2e2bcd8739ae039 = false ? ({ children: children = null })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children) : $082205e2100625d8$var$ShortcutScope;

});
parcelRegister("fVFUy", function(module, exports) {

$parcel$export(module.exports, "ShortcutRegistry", () => $3843ad0413ec519e$export$ca1c75b575abf5ff);
$parcel$export(module.exports, "rootRegistry", () => $3843ad0413ec519e$export$1dd4c61d1ce1fa15);
/* eslint-disable jira/js/no-reduce-accumulator-spread */ /**
 * A tree-like registry of shortcuts, with a default, root registry.
 */ 
var $fUTZC = parcelRequire("fUTZC");

var $6G5mG = parcelRequire("6G5mG");

var $ldoFd = parcelRequire("ldoFd");

var $bFXjh = parcelRequire("bFXjh");

var $1YqdI = parcelRequire("1YqdI");
const $3843ad0413ec519e$var$validateKeyMaps = (keyMaps)=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(keyMaps, (keyMap, keyMapIndex)=>{
        const shortcuts = Object.keys(keyMap);
        (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(shortcuts, (shortcut, shortcutIndex)=>{
            if (!(0, $1YqdI.isValidShortcut)(shortcut)) // eslint-disable-next-line no-console
            console.error(`"${shortcut}" is an incorrect shortcut. Please, update it according to a playbook entry on shortcuts.`);
            for(let indexForOtherKeymaps = keyMapIndex + 1; indexForOtherKeymaps < keyMaps.length; indexForOtherKeymaps += 1){
                const anotherKeyMap = keyMaps[indexForOtherKeymaps];
                (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(anotherKeyMap, (anotherAction, anotherShortcut)=>{
                    if ((0, $1YqdI.isShortcutCollision)(anotherShortcut, shortcut)) // If neither shortcut has a priority we have a conflict.. You should ideally
                    // put a priority on one of these conflicting shortcut configs so you definitively
                    // know which one should be active when there is a conflict.
                    {
                        if ((0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(keyMap[shortcut].priority) && (0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(anotherKeyMap[anotherShortcut].priority) || keyMap[shortcut].priority === anotherKeyMap[anotherShortcut].priority) // DO NOT LET THIS HAPPEN. ADD A PRIORITY!!!
                        // eslint-disable-next-line no-console
                        console.error(`"${shortcut}" has a collision with "${anotherShortcut}" shortcut from another keyMap.`);
                    }
                });
            }
            for(let indexToCompareSelf = shortcutIndex + 1; indexToCompareSelf < shortcuts.length; indexToCompareSelf += 1)if ((0, $1YqdI.isShortcutCollision)(shortcut, shortcuts[indexToCompareSelf])) // eslint-disable-next-line no-console
            console.error(`"${shortcut}" has a collision with "${shortcuts[indexToCompareSelf]}" shortcut from the same keyMap.`);
        });
    });
};
const $3843ad0413ec519e$var$mergeKeyMaps = (keyMapsToMerge)=>// Instead of doing the standard Object.assign({}, ...keyMapsToMerge)
    // we want to have a bit more control over what we can and can't override
    // through the use of the priority
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    keyMapsToMerge.reduce((prev, keyMap)=>({
            ...prev,
            // Add the keys that can be overridden
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            ...Object.keys(keyMap).reduce((newAccumulator, newKey)=>{
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($6G5mG)))(prev, newKey) || (prev[newKey].priority ?? 0) < (keyMap[newKey].priority ?? 1 // Default behaviour is override
                )) return {
                    ...newAccumulator,
                    [newKey]: keyMap[newKey]
                };
                return newAccumulator;
            }, {})
        }), {});
class $3843ad0413ec519e$export$ca1c75b575abf5ff {
    addChildRegistry(child) {
        this.children.push(child);
        return ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($bFXjh)))(this.children, child);
        };
    }
    addKeyMap(getKeyMap) {
        this.keyMapRetrievers.push(getKeyMap);
        return ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($bFXjh)))(this.keyMapRetrievers, getKeyMap);
        };
    }
    getActiveKeyMap() {
        const keyMaps = this.children.length ? this.children.map((child)=>child.getActiveKeyMap()) : this.keyMapRetrievers.map((getKeyMap)=>getKeyMap().keyMap);
        return {
            ...$3843ad0413ec519e$var$mergeKeyMaps(keyMaps)
        };
    }
    getKeyMapInfo() {
        const info = this.children.length ? this.children.map((child)=>child.getKeyMapInfo()) : this.keyMapRetrievers.map((getInfo)=>getInfo());
        // @ts-expect-error - TS2769 - No overload matches this call.
        const flattenedInfo = [].concat(...info);
        return flattenedInfo;
    }
    constructor(){
        // go/jfe-eslint
        this.children = [];
        this.keyMapRetrievers = [];
    }
}
const $3843ad0413ec519e$export$1dd4c61d1ce1fa15 = new $3843ad0413ec519e$export$ca1c75b575abf5ff();

});
parcelRegister("1YqdI", function(module, exports) {

$parcel$export(module.exports, "toKeyWithModifiers", () => $1b99fa3356e664b3$export$8cf0d2c3d060a0c2);
$parcel$export(module.exports, "isValidShortcut", () => $1b99fa3356e664b3$export$8e231506c5580162);
$parcel$export(module.exports, "isShortcutCollision", () => $1b99fa3356e664b3$export$4add9e50cb49d130);
/**
 * Converts a KeyboardEvent to a normalised string representation of
 * modifiers and key.
 *
 * Ordering of modifier keys is taken from Apple's guidelines:
 * https://developer.apple.com/macos/human-interface-guidelines/input-and-output/keyboard/
 *
 * Example representation of ArrowUp key with all modifiers present:
 * ctrl+shift+meta+arrowup
 *
 * Character keys never include the 'shift' modifier,.
 * as it changes the character itself.
 * Examples:
 *  - instead of 'shift+a' the normal form is 'A'
 *  - instead of 'shift+/' the normal form is '?'
 *
 * The 'alt' modifier is NOT supported at all due to inconsistent behaviour
 * across platforms. On Mac, it changes the character input, e.g.
 * 'alt+z' is 'Ω' - which becomes the `event.key`. To properly support
 * this, a reverse-mapping of all these characters needs to be added.
 * Alternatively, `String.fromCharCode(event.which)` can be used, but
 * 1. This is a deprecated property
 * 2. The char code is still for the modified character for some keys on Mac
 *    (e.g. The char code for 'alt+/' is '¿')
 */ // Special keys such as 'Escape', 'ArrowUp' or ' '
const $1b99fa3356e664b3$var$isNonCharacterKey = (e)=>e.key.length > 1 || e.key === ' ';
const $1b99fa3356e664b3$var$modifiers = [
    {
        name: 'ctrl',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.ctrlKey
    },
    {
        name: 'shift',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.shiftKey && $1b99fa3356e664b3$var$isNonCharacterKey(e)
    },
    {
        // Command key on MacOS, Windows key on Windows
        name: 'meta',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.metaKey || e.getModifierState && e.getModifierState('OS')
    }
];
const $1b99fa3356e664b3$var$toKey = (e)=>{
    if ($1b99fa3356e664b3$var$isNonCharacterKey(e)) return e.key.toLowerCase();
    // Ignore accidental CapsLock
    return e.shiftKey ? e.key.toUpperCase() : e.key.toLowerCase();
};
const $1b99fa3356e664b3$export$8cf0d2c3d060a0c2 = (e)=>{
    if (!e || !e.key) // There are still browsers out there that do not support e.key;
    // Just today (Oct 2018) I have observed Chrome 47 in Sentry, but it started supporting e.key since 51.
    // So instead of crashing the page with TypeError let's not detect keyboard shortcuts.
    return {
        sequence: '',
        e: e
    };
    return {
        sequence: $1b99fa3356e664b3$var$modifiers.filter((modifier)=>modifier.test(e)).map((modifier)=>modifier.name).concat($1b99fa3356e664b3$var$toKey(e)).join('+'),
        e: e
    };
};
/*
 *  Selected special key values disjunction for regex. All lowercase, ordered alphabethically.
 *  See https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key/Key_Values.
 */ const $1b99fa3356e664b3$var$orSpecialChars = ' |arrowdown|arrowleft|arrowright|arrowup|backspace|clear|delete|end|enter|escape|home|insert|pagedown|pageup|pause|printscreen|tab';
/*
 * This string when used as a regular expression:
 * 1. Allows lowercase only with a single exception (see 3)
 * 2. Allows optional ctrl, shift, meta followed by "+" in that specific order in the beginning
 * 3. Allows any printable character (may be uppercase letter) or a special key value
 * 4. If shift modifier is used it can only be followed by a special char
 * 5. Is based on toKeyWithModifiers, uses orSpecialChars whitelist for shift chars
 * 6. Does not capture redundant groups
 */ const $1b99fa3356e664b3$var$singleShortcutEntry = `(ctrl\\+)?(shift\\+(?=(?:(?:meta\\+)?(?:${$1b99fa3356e664b3$var$orSpecialChars}))))?(meta\\+)?(${$1b99fa3356e664b3$var$orSpecialChars}|[!-~])`;
/*
 * Any number of singleShortcutEntry separated by a single space
 * We are not specifying "g" flag, so it's fine to reuse the same regex object.
 */ const $1b99fa3356e664b3$var$shortcutRegex = RegExp(`^${$1b99fa3356e664b3$var$singleShortcutEntry}( ${$1b99fa3356e664b3$var$singleShortcutEntry})*$`);
const $1b99fa3356e664b3$export$8e231506c5580162 = (shortcut)=>$1b99fa3356e664b3$var$shortcutRegex.test(shortcut);
const $1b99fa3356e664b3$export$4add9e50cb49d130 = (leftShortcut, rightShortcut)=>{
    if (!leftShortcut || !rightShortcut) return leftShortcut === rightShortcut;
    if (rightShortcut === leftShortcut) return true;
    if (leftShortcut.indexOf(rightShortcut) === 0) return leftShortcut[rightShortcut.length] === ' ';
    if (rightShortcut.indexOf(leftShortcut) === 0) return rightShortcut[leftShortcut.length] === ' ';
    return false;
};

});



parcelRegister("40AVL", function(module, exports) {

$parcel$export(module.exports, "AddLinkForm", () => $e9ad03b7d03b6019$export$a80fd3bd8dd47158);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7jPhn = parcelRequire("7jPhn");
var $4LhB6 = parcelRequire("4LhB6");

var $3nnLQ = parcelRequire("3nnLQ");

var $aQrlQ = parcelRequire("aQrlQ");

var $aJdjG = parcelRequire("aJdjG");

var $5wCDk = parcelRequire("5wCDk");

var $xeS7R = parcelRequire("xeS7R");

var $cf2Y4 = parcelRequire("cf2Y4");

var $5JgJ2 = parcelRequire("5JgJ2");

var $aNx7t = parcelRequire("aNx7t");

var $4QDtr = parcelRequire("4QDtr");

var $8z4xM = parcelRequire("8z4xM");
const $e9ad03b7d03b6019$export$a80fd3bd8dd47158 = ({ link: link, mode: mode, isModified: isModified, setIsModified: setIsModified })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const linkTypeOptions = [
        {
            value: 'knowledge',
            label: formatMessage((0, $4QDtr.messages).externalLinksLinkTypeKnowledge)
        },
        {
            value: 'request-form',
            label: formatMessage((0, $4QDtr.messages).externalLinksLinkTypeRequestForm)
        },
        {
            value: 'channel',
            label: formatMessage((0, $4QDtr.messages).externalLinksLinkTypeChannels)
        }
    ].filter(Boolean);
    const defaultValues = mode === (0, $aNx7t.MODES).EDIT && link !== null ? {
        resourceType: linkTypeOptions.find((linkTypeOption)=>linkTypeOption?.value === link.resourceType),
        link: link.link,
        title: link.title,
        description: link.description
    } : {
        resourceType: null,
        link: '',
        title: '',
        description: ''
    };
    const [isChannelSelected, setIsChannelSelected] = (0, $eUqFw.useState)(// @ts-expect-error - TS2367 - This condition will always return 'false' since the types '{ value: string; label: string; } | null | undefined' and 'string' have no overlap.
    defaultValues.resourceType === 'channel'); // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const formatLinkTypeOptions = (option)=>{
        switch(option.value){
            case 'knowledge':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e9ad03b7d03b6019$var$IconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3nnLQ))), {
                    label: ""
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e9ad03b7d03b6019$var$IconMessageWrapper, null, option.label));
            case 'request-form':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e9ad03b7d03b6019$var$IconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aQrlQ))), {
                    label: ""
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e9ad03b7d03b6019$var$IconMessageWrapper, null, option.label));
            case 'channel':
            default:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e9ad03b7d03b6019$var$IconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aJdjG))), {
                    label: ""
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e9ad03b7d03b6019$var$IconMessageWrapper, null, option.label));
        }
    };
    // @ts-expect-error - TS7006 - Parameter 'fieldProps' implicitly has an 'any' type.
    const fieldErrorMessage = (valid, error, fieldProps)=>{
        const showError = !valid && error !== undefined;
        let errorMessage = null;
        switch(fieldProps.name){
            case 'resourceType':
                errorMessage = formatMessage((0, $4QDtr.messages).externalLinksLinkTypeIsRequired);
                break;
            case 'link':
                if (error === (0, $aNx7t.ERROR_TYPES).CHAR_LIMIT_EXCEEDED) errorMessage = formatMessage((0, $4QDtr.messages).externalLinksLinkCharLimitExceeded, {
                    limit: (0, $aNx7t.MAX_URL_LENGTH)
                });
                else errorMessage = formatMessage((0, $4QDtr.messages).externalLinksLinkUrlIsRequired);
                break;
            case 'title':
                if (error === (0, $aNx7t.ERROR_TYPES).CHAR_LIMIT_EXCEEDED) errorMessage = formatMessage((0, $4QDtr.messages).externalLinksTitleCharLimitExceeded, {
                    limit: (0, $aNx7t.MAX_TITLE_LENGTH)
                });
                else errorMessage = formatMessage((0, $4QDtr.messages).externalLinksLinkTitleIsRequired);
                break;
            case 'description':
                if (error === (0, $aNx7t.ERROR_TYPES).CHAR_LIMIT_EXCEEDED) errorMessage = formatMessage((0, $4QDtr.messages).externalLinksDescriptionCharLimitExceeded, {
                    limit: (0, $aNx7t.MAX_DESCRIPTION_LENGTH)
                });
                else errorMessage = formatMessage((0, $4QDtr.messages).externalLinksLinkDescriptionIsRequired);
                break;
            default:
                errorMessage = null;
        }
        return showError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7jPhn.ErrorMessage), null, errorMessage) : null;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LhB6.default), {
        autoFocus: true,
        "aria-required": true,
        name: "resourceType",
        defaultValue: defaultValues.resourceType,
        label: formatMessage((0, $4QDtr.messages).externalLinksLinkType),
        validate: (0, $8z4xM.validateSelectField),
        isRequired: true,
        isDisabled: mode === (0, $aNx7t.MODES).EDIT
    }, ({ fieldProps: { id: id, onChange: onChange, ...rest }, error: error, valid: valid })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5wCDk.default), {
            placeholder: formatMessage((0, $4QDtr.messages).externalLinksLinkTypePlaceholder),
            inputId: id,
            ...rest,
            options: linkTypeOptions,
            onChange: (option)=>{
                setIsChannelSelected(option?.value === 'channel');
                onChange(option);
                !isModified && setIsModified(true);
            },
            validationState: error !== undefined ? 'error' : 'default',
            formatOptionLabel: formatLinkTypeOptions,
            testId: "servicedesk-external-links.ui.links.add-link-modal.add-link-form.select-resource-type"
        }), fieldErrorMessage(valid, error, rest))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LhB6.default), {
        "aria-required": true,
        name: "link",
        defaultValue: defaultValues.link,
        label: formatMessage((0, $4QDtr.messages).externalLinksLinkUrl),
        validate: (value)=>(0, $8z4xM.validateTextField)('link', value),
        isRequired: true
    }, ({ fieldProps: { onChange: onChange, ...rest }, error: error, valid: valid })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cf2Y4.default), {
            ...rest,
            placeholder: formatMessage(isChannelSelected ? (0, $4QDtr.messages).externalLinksLinkChannelPlaceholder : (0, $4QDtr.messages).externalLinksLinkUrlPlaceholder),
            testId: "servicedesk-external-links.ui.links.add-link-modal.add-link-form.link-url",
            onChange: (option)=>{
                onChange(option);
                !isModified && setIsModified(true);
            }
        }), fieldErrorMessage(valid, error, rest))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LhB6.default), {
        "aria-required": true,
        name: "title",
        defaultValue: defaultValues.title,
        label: formatMessage((0, $4QDtr.messages).externalLinksTitle),
        validate: (value)=>(0, $8z4xM.validateTextField)('title', value),
        isRequired: true
    }, ({ fieldProps: { onChange: onChange, ...rest }, error: error, valid: valid })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cf2Y4.default), {
            ...rest,
            placeholder: formatMessage((0, $4QDtr.messages).externalLinksTitlePlaceholder),
            testId: "servicedesk-external-links.ui.links.add-link-modal.add-link-form.title",
            onChange: (option)=>{
                onChange(option);
                !isModified && setIsModified(true);
            }
        }), fieldErrorMessage(valid, error, rest))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LhB6.default), {
        "aria-required": true,
        name: "description",
        defaultValue: defaultValues.description,
        label: formatMessage((0, $4QDtr.messages).externalLinksDescription),
        validate: (value)=>(0, $8z4xM.validateTextField)('description', value),
        isRequired: true
    }, ({ fieldProps: { onChange: onChange, ...rest }, error: error, valid: valid })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $xeS7R.default), {
            ...rest,
            minimumRows: (0, $aNx7t.MIN_ROWS_DESCRIPTION),
            placeholder: formatMessage((0, $4QDtr.messages).externalLinksDescriptionPlaceholder),
            resize: "vertical",
            testId: "servicedesk-external-links.ui.links.add-link-modal.add-link-form.description",
            onChange: (option)=>{
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                onChange(option);
                !isModified && setIsModified(true);
            }
        }), fieldErrorMessage(valid, error, rest))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e9ad03b7d03b6019$var$IconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e9ad03b7d03b6019$var$IconMessageWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u0u2gc _2hwx1b66",
            __cmplp.className
        ])
    });
});

});
parcelRegister("7jPhn", function(module, exports) {

$parcel$export(module.exports, "HelperMessage", () => $8d7fd15aabd72279$export$8fbe3c7d0ed2c683);
$parcel$export(module.exports, "ErrorMessage", () => $8d7fd15aabd72279$export$915e9e7bd4f0f96d);
$parcel$export(module.exports, "ValidMessage", () => $8d7fd15aabd72279$export$5505afb209a532c8);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $lD2Nx = parcelRequire("lD2Nx");

var $96IgR = parcelRequire("96IgR");


var $gaA9C = parcelRequire("gaA9C");
function $8d7fd15aabd72279$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $8d7fd15aabd72279$var$messageStyles = {
    name: "ywqxo4",
    styles: "display:flex;justify-content:baseline;gap:var(--ds-space-050, 4px);font:var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);margin-block-start:var(--ds-space-050, 4px)"
};
const $8d7fd15aabd72279$var$messageAppearanceStyles = {
    default: /*#__PURE__*/ (0, $byn9U.css)({
        color: `var(--ds-text-subtlest, ${(0, $73a5c9d720aa66e1$export$f563ee71e9ee74cd)})`
    }),
    error: {
        name: "g75jq6",
        styles: "color:var(--ds-text-danger, #AE2A19)"
    },
    valid: {
        name: "118r6eb",
        styles: "color:var(--ds-text-success, #216E4E)"
    }
};
const $8d7fd15aabd72279$var$iconWrapperStyles = {
    name: "zjik7",
    styles: "display:flex"
};
const $8d7fd15aabd72279$var$IconWrapper = ({ children: children })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $8d7fd15aabd72279$var$iconWrapperStyles
    }, children);
};
const $8d7fd15aabd72279$var$messageIcons = {
    error: /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($96IgR))), {
        size: "small",
        label: "error"
    }),
    valid: /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lD2Nx))), {
        size: "small",
        label: "success"
    })
};
const $8d7fd15aabd72279$var$Message = ({ children: children, appearance: appearance = 'default', fieldId: fieldId, testId: testId })=>{
    const icon = $8d7fd15aabd72279$var$messageIcons[appearance];
    const messageRef = (0, $eUqFw.useRef)(null);
    const [hasMessageWrapper, setHasMessageWrapper] = (0, $eUqFw.useState)(false);
    const { isWrapper: isWrapper } = (0, $eUqFw.useContext)($8d7fd15aabd72279$export$579aef2c392a54d4);
    (0, $eUqFw.useEffect)(()=>{
        if (messageRef.current) setHasMessageWrapper(isWrapper);
    }, [
        isWrapper
    ]);
    /**
   * The wrapping span is necessary to preserve spaces between children.
   * Otherwise the flex layout of the message will remove any whitespace
   * between children.
   *
   * If the child is just a string, this is not required and we can use one
   * less DOM element.
   */ const content = typeof children === 'string' ? children : /*#__PURE__*/ (0, $byn9U.jsx)("span", null, children);
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $8d7fd15aabd72279$var$messageStyles,
            $8d7fd15aabd72279$var$messageAppearanceStyles[appearance]
        ],
        "data-testid": testId,
        id: fieldId,
        ref: messageRef,
        // For backwards compatability, if there is a wrapper, aria-live is not needed
        "aria-live": !hasMessageWrapper ? 'polite' : undefined
    }, icon && /*#__PURE__*/ (0, $byn9U.jsx)($8d7fd15aabd72279$var$IconWrapper, null, icon), content);
};
const $8d7fd15aabd72279$export$8fbe3c7d0ed2c683 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $gaA9C.FieldId).Consumer, null, (fieldId)=>/*#__PURE__*/ (0, $byn9U.jsx)($8d7fd15aabd72279$var$Message, {
            fieldId: fieldId ? `${fieldId}-helper` : undefined,
            testId: testId
        }, children));
const $8d7fd15aabd72279$export$915e9e7bd4f0f96d = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $gaA9C.FieldId).Consumer, null, (fieldId)=>/*#__PURE__*/ (0, $byn9U.jsx)($8d7fd15aabd72279$var$Message, {
            appearance: "error",
            fieldId: fieldId ? `${fieldId}-error` : undefined,
            testId: testId
        }, children));
const $8d7fd15aabd72279$export$5505afb209a532c8 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $gaA9C.FieldId).Consumer, null, (fieldId)=>/*#__PURE__*/ (0, $byn9U.jsx)($8d7fd15aabd72279$var$Message, {
            appearance: "valid",
            fieldId: fieldId ? `${fieldId}-valid` : undefined,
            testId: testId
        }, children));
const $8d7fd15aabd72279$export$579aef2c392a54d4 = /*#__PURE__*/ (0, $eUqFw.createContext)({
    isWrapper: false
});
const $8d7fd15aabd72279$export$ec445f12f63100a5 = ({ children: children })=>{
    const contextValue = {
        isWrapper: true
    };
    return /*#__PURE__*/ (0, $byn9U.jsx)($8d7fd15aabd72279$export$579aef2c392a54d4.Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        "aria-live": "polite",
        "data-testid": "message-wrapper"
    }, children));
};

});
parcelRegister("lD2Nx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fbef6921e18df378$var$_react = $fbef6921e18df378$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $fbef6921e18df378$var$_success = $fbef6921e18df378$var$_interopRequireDefault((parcelRequire("50qGm")));
function $fbef6921e18df378$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $fbef6921e18df378$var$EditorSuccessIcon = (props)=>/*#__PURE__*/ $fbef6921e18df378$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16m1.364-10.964-2.152 4.11-1.543-1.39a1 1 0 1 0-1.338 1.487l2.5 2.25a1 1 0 0 0 1.555-.279l2.75-5.25a1 1 0 0 0-1.772-.928"/></svg>`
    }, props, {
        newIcon: $fbef6921e18df378$var$_success.default
    }));
$fbef6921e18df378$var$EditorSuccessIcon.displayName = 'EditorSuccessIcon';
var $fbef6921e18df378$var$_default = module.exports.default = $fbef6921e18df378$var$EditorSuccessIcon;

});
parcelRegister("50qGm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3f4494144da7877c599489a550534c1d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3a51a662974016bc$var$_react = $3a51a662974016bc$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $3a51a662974016bc$var$_UNSAFE_baseNew = $3a51a662974016bc$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $3a51a662974016bc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Success".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single-purpose - Reserved for success section messages and form validation messages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3a51a662974016bc$var$SuccessIcon = (props)=>/*#__PURE__*/ $3a51a662974016bc$var$_react.default.createElement($3a51a662974016bc$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m12.326-2.52-1.152-.96L6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0z" clip-rule="evenodd"/>`
    }, props));
$3a51a662974016bc$var$SuccessIcon.displayName = 'SuccessIcon';
var $3a51a662974016bc$var$_default = module.exports.default = $3a51a662974016bc$var$SuccessIcon;

});


var $73a5c9d720aa66e1$exports = {};

$parcel$export($73a5c9d720aa66e1$exports, "R50", () => $73a5c9d720aa66e1$export$4b84fd0e2c617bd);
$parcel$export($73a5c9d720aa66e1$exports, "R75", () => $73a5c9d720aa66e1$export$b34b069eff244586);
$parcel$export($73a5c9d720aa66e1$exports, "R100", () => $73a5c9d720aa66e1$export$be802dd0d8b57f35);
$parcel$export($73a5c9d720aa66e1$exports, "R200", () => $73a5c9d720aa66e1$export$60847d42f9da92a6);
$parcel$export($73a5c9d720aa66e1$exports, "R300", () => $73a5c9d720aa66e1$export$4a7404f376229999);
$parcel$export($73a5c9d720aa66e1$exports, "R400", () => $73a5c9d720aa66e1$export$2010d0fb4295b346);
$parcel$export($73a5c9d720aa66e1$exports, "R500", () => $73a5c9d720aa66e1$export$2837b5a1a71d5c02);
$parcel$export($73a5c9d720aa66e1$exports, "Y50", () => $73a5c9d720aa66e1$export$8d9596b529bbb9cf);
$parcel$export($73a5c9d720aa66e1$exports, "Y75", () => $73a5c9d720aa66e1$export$41060a744ab0b7ae);
$parcel$export($73a5c9d720aa66e1$exports, "Y100", () => $73a5c9d720aa66e1$export$1cc05bbbf340e559);
$parcel$export($73a5c9d720aa66e1$exports, "Y200", () => $73a5c9d720aa66e1$export$5aae31392d72caaa);
$parcel$export($73a5c9d720aa66e1$exports, "Y300", () => $73a5c9d720aa66e1$export$c6930421db9fa514);
$parcel$export($73a5c9d720aa66e1$exports, "Y400", () => $73a5c9d720aa66e1$export$59619663aa6500fb);
$parcel$export($73a5c9d720aa66e1$exports, "Y500", () => $73a5c9d720aa66e1$export$874739ea9e379ab6);
$parcel$export($73a5c9d720aa66e1$exports, "G50", () => $73a5c9d720aa66e1$export$8a6341c32b6a3ee6);
$parcel$export($73a5c9d720aa66e1$exports, "G75", () => $73a5c9d720aa66e1$export$69a3bf21b9686c2b);
$parcel$export($73a5c9d720aa66e1$exports, "G100", () => $73a5c9d720aa66e1$export$afbce1382ec95f73);
$parcel$export($73a5c9d720aa66e1$exports, "G200", () => $73a5c9d720aa66e1$export$747d86715d4175de);
$parcel$export($73a5c9d720aa66e1$exports, "G300", () => $73a5c9d720aa66e1$export$940e1f69e873f202);
$parcel$export($73a5c9d720aa66e1$exports, "G400", () => $73a5c9d720aa66e1$export$a49394138f7b8e85);
$parcel$export($73a5c9d720aa66e1$exports, "G500", () => $73a5c9d720aa66e1$export$6fa04827ac68a4fb);
$parcel$export($73a5c9d720aa66e1$exports, "B50", () => $73a5c9d720aa66e1$export$226de0355ed012f8);
$parcel$export($73a5c9d720aa66e1$exports, "B75", () => $73a5c9d720aa66e1$export$8c13c2ee36917869);
$parcel$export($73a5c9d720aa66e1$exports, "B100", () => $73a5c9d720aa66e1$export$ecfc1dff386a3e7a);
$parcel$export($73a5c9d720aa66e1$exports, "B200", () => $73a5c9d720aa66e1$export$215b7063051591f1);
$parcel$export($73a5c9d720aa66e1$exports, "B300", () => $73a5c9d720aa66e1$export$e62e8919cca44969);
$parcel$export($73a5c9d720aa66e1$exports, "B400", () => $73a5c9d720aa66e1$export$b3de0ae08da2ce64);
$parcel$export($73a5c9d720aa66e1$exports, "B500", () => $73a5c9d720aa66e1$export$a6ee3d71bc067634);
$parcel$export($73a5c9d720aa66e1$exports, "P50", () => $73a5c9d720aa66e1$export$363e4475840015bb);
$parcel$export($73a5c9d720aa66e1$exports, "P75", () => $73a5c9d720aa66e1$export$4b0a4417ed59760f);
$parcel$export($73a5c9d720aa66e1$exports, "P100", () => $73a5c9d720aa66e1$export$6011520a64d9a187);
$parcel$export($73a5c9d720aa66e1$exports, "P200", () => $73a5c9d720aa66e1$export$a7175d4e9206bc80);
$parcel$export($73a5c9d720aa66e1$exports, "P300", () => $73a5c9d720aa66e1$export$b48405b95304b5a1);
$parcel$export($73a5c9d720aa66e1$exports, "P400", () => $73a5c9d720aa66e1$export$c71e4279dd54a18d);
$parcel$export($73a5c9d720aa66e1$exports, "P500", () => $73a5c9d720aa66e1$export$147899de772240ec);
$parcel$export($73a5c9d720aa66e1$exports, "T50", () => $73a5c9d720aa66e1$export$2cf711fe14c66f06);
$parcel$export($73a5c9d720aa66e1$exports, "T75", () => $73a5c9d720aa66e1$export$7a8f4d33f6f9772c);
$parcel$export($73a5c9d720aa66e1$exports, "T100", () => $73a5c9d720aa66e1$export$776c9c497ef08533);
$parcel$export($73a5c9d720aa66e1$exports, "T200", () => $73a5c9d720aa66e1$export$69cb3ca10c1e330e);
$parcel$export($73a5c9d720aa66e1$exports, "T300", () => $73a5c9d720aa66e1$export$9dc1ef0f3f48059b);
$parcel$export($73a5c9d720aa66e1$exports, "T400", () => $73a5c9d720aa66e1$export$7c835c78b6fcdef8);
$parcel$export($73a5c9d720aa66e1$exports, "T500", () => $73a5c9d720aa66e1$export$6036577f95c3877e);
$parcel$export($73a5c9d720aa66e1$exports, "N0", () => $73a5c9d720aa66e1$export$29a4f05edc054374);
$parcel$export($73a5c9d720aa66e1$exports, "N10", () => $73a5c9d720aa66e1$export$e655ef011c4aa1a2);
$parcel$export($73a5c9d720aa66e1$exports, "N20", () => $73a5c9d720aa66e1$export$9fdfb749e33cdf97);
$parcel$export($73a5c9d720aa66e1$exports, "N30", () => $73a5c9d720aa66e1$export$3e51e8f1440314ba);
$parcel$export($73a5c9d720aa66e1$exports, "N40", () => $73a5c9d720aa66e1$export$1ce2d1575d444ceb);
$parcel$export($73a5c9d720aa66e1$exports, "N50", () => $73a5c9d720aa66e1$export$8754fc7e6d8b3000);
$parcel$export($73a5c9d720aa66e1$exports, "N60", () => $73a5c9d720aa66e1$export$c2e91cbeada39b8b);
$parcel$export($73a5c9d720aa66e1$exports, "N70", () => $73a5c9d720aa66e1$export$5f71e19f3a7ad9de);
$parcel$export($73a5c9d720aa66e1$exports, "N80", () => $73a5c9d720aa66e1$export$eaa8c8a70ac22806);
$parcel$export($73a5c9d720aa66e1$exports, "N90", () => $73a5c9d720aa66e1$export$7c87d337fb91a97d);
$parcel$export($73a5c9d720aa66e1$exports, "N100", () => $73a5c9d720aa66e1$export$d6447c357493214f);
$parcel$export($73a5c9d720aa66e1$exports, "N200", () => $73a5c9d720aa66e1$export$f563ee71e9ee74cd);
$parcel$export($73a5c9d720aa66e1$exports, "N300", () => $73a5c9d720aa66e1$export$e2ef2124cf4024b1);
$parcel$export($73a5c9d720aa66e1$exports, "N400", () => $73a5c9d720aa66e1$export$eece5f492e429f08);
$parcel$export($73a5c9d720aa66e1$exports, "N500", () => $73a5c9d720aa66e1$export$c39c0fe0f26207ae);
$parcel$export($73a5c9d720aa66e1$exports, "N600", () => $73a5c9d720aa66e1$export$7090862dc3038a9f);
$parcel$export($73a5c9d720aa66e1$exports, "N700", () => $73a5c9d720aa66e1$export$ad0bacf983b7ddaa);
$parcel$export($73a5c9d720aa66e1$exports, "N800", () => $73a5c9d720aa66e1$export$7d61b15e0da132af);
$parcel$export($73a5c9d720aa66e1$exports, "N900", () => $73a5c9d720aa66e1$export$fbda843f0a27fe96);
$parcel$export($73a5c9d720aa66e1$exports, "N10A", () => $73a5c9d720aa66e1$export$791e57b27ca738ef);
$parcel$export($73a5c9d720aa66e1$exports, "N20A", () => $73a5c9d720aa66e1$export$8d43898f60b96a82);
$parcel$export($73a5c9d720aa66e1$exports, "N30A", () => $73a5c9d720aa66e1$export$920c0d5c49070351);
$parcel$export($73a5c9d720aa66e1$exports, "N40A", () => $73a5c9d720aa66e1$export$46987b49aab6d1a8);
$parcel$export($73a5c9d720aa66e1$exports, "N50A", () => $73a5c9d720aa66e1$export$7d3359664e8bb0e5);
$parcel$export($73a5c9d720aa66e1$exports, "N60A", () => $73a5c9d720aa66e1$export$d2d3bedfb276cac0);
$parcel$export($73a5c9d720aa66e1$exports, "N70A", () => $73a5c9d720aa66e1$export$6e5e7499ff054f6d);
$parcel$export($73a5c9d720aa66e1$exports, "N80A", () => $73a5c9d720aa66e1$export$59264b346c877fa7);
$parcel$export($73a5c9d720aa66e1$exports, "N90A", () => $73a5c9d720aa66e1$export$d092757d7c64925c);
$parcel$export($73a5c9d720aa66e1$exports, "N100A", () => $73a5c9d720aa66e1$export$486ab785e4bac3c6);
$parcel$export($73a5c9d720aa66e1$exports, "N200A", () => $73a5c9d720aa66e1$export$fba592bbc6419fea);
$parcel$export($73a5c9d720aa66e1$exports, "N300A", () => $73a5c9d720aa66e1$export$13609db0e6812ab8);
$parcel$export($73a5c9d720aa66e1$exports, "N400A", () => $73a5c9d720aa66e1$export$fbae4efaa892d883);
$parcel$export($73a5c9d720aa66e1$exports, "N500A", () => $73a5c9d720aa66e1$export$f13946d26f440ce6);
$parcel$export($73a5c9d720aa66e1$exports, "N600A", () => $73a5c9d720aa66e1$export$19f58225ac52a306);
$parcel$export($73a5c9d720aa66e1$exports, "N700A", () => $73a5c9d720aa66e1$export$6384f09da70e7b62);
$parcel$export($73a5c9d720aa66e1$exports, "N800A", () => $73a5c9d720aa66e1$export$d0dccc730683edc2);
$parcel$export($73a5c9d720aa66e1$exports, "DN900", () => $73a5c9d720aa66e1$export$2f6319cf7d736c2a);
$parcel$export($73a5c9d720aa66e1$exports, "DN800", () => $73a5c9d720aa66e1$export$95126bc8884d6634);
$parcel$export($73a5c9d720aa66e1$exports, "DN700", () => $73a5c9d720aa66e1$export$8338d8c35d44ff1);
$parcel$export($73a5c9d720aa66e1$exports, "DN600", () => $73a5c9d720aa66e1$export$5368d76ae4fbbda7);
$parcel$export($73a5c9d720aa66e1$exports, "DN500", () => $73a5c9d720aa66e1$export$9f0a771d16ec8d36);
$parcel$export($73a5c9d720aa66e1$exports, "DN400", () => $73a5c9d720aa66e1$export$abcf8c38338b4aa5);
$parcel$export($73a5c9d720aa66e1$exports, "DN300", () => $73a5c9d720aa66e1$export$97e81faa16a182c7);
$parcel$export($73a5c9d720aa66e1$exports, "DN200", () => $73a5c9d720aa66e1$export$bfe21c59123ecf33);
$parcel$export($73a5c9d720aa66e1$exports, "DN100", () => $73a5c9d720aa66e1$export$ee82aa2ea6a1558);
$parcel$export($73a5c9d720aa66e1$exports, "DN90", () => $73a5c9d720aa66e1$export$682927c6ed76be02);
$parcel$export($73a5c9d720aa66e1$exports, "DN80", () => $73a5c9d720aa66e1$export$91fd9994c5be9757);
$parcel$export($73a5c9d720aa66e1$exports, "DN70", () => $73a5c9d720aa66e1$export$d281fbfe3cff2df6);
$parcel$export($73a5c9d720aa66e1$exports, "DN60", () => $73a5c9d720aa66e1$export$3902c91d8b98a753);
$parcel$export($73a5c9d720aa66e1$exports, "DN50", () => $73a5c9d720aa66e1$export$8e8133c1ba5845b5);
$parcel$export($73a5c9d720aa66e1$exports, "DN40", () => $73a5c9d720aa66e1$export$33ff357f6620b39);
$parcel$export($73a5c9d720aa66e1$exports, "DN30", () => $73a5c9d720aa66e1$export$633847cf062b69e0);
$parcel$export($73a5c9d720aa66e1$exports, "DN20", () => $73a5c9d720aa66e1$export$9776a6e503bdbf76);
$parcel$export($73a5c9d720aa66e1$exports, "DN10", () => $73a5c9d720aa66e1$export$6c813d5160dff5db);
$parcel$export($73a5c9d720aa66e1$exports, "DN0", () => $73a5c9d720aa66e1$export$3d4f271a500072a);
$parcel$export($73a5c9d720aa66e1$exports, "DN800A", () => $73a5c9d720aa66e1$export$fe151285c22759ec);
$parcel$export($73a5c9d720aa66e1$exports, "DN700A", () => $73a5c9d720aa66e1$export$a101c6190d0da34);
$parcel$export($73a5c9d720aa66e1$exports, "DN600A", () => $73a5c9d720aa66e1$export$4b16f52932fda51);
$parcel$export($73a5c9d720aa66e1$exports, "DN500A", () => $73a5c9d720aa66e1$export$a74bcd7b9845b0d8);
$parcel$export($73a5c9d720aa66e1$exports, "DN400A", () => $73a5c9d720aa66e1$export$9209c179316d1751);
$parcel$export($73a5c9d720aa66e1$exports, "DN300A", () => $73a5c9d720aa66e1$export$88f55133f636c8dd);
$parcel$export($73a5c9d720aa66e1$exports, "DN200A", () => $73a5c9d720aa66e1$export$51126f85d1009512);
$parcel$export($73a5c9d720aa66e1$exports, "DN100A", () => $73a5c9d720aa66e1$export$a069b547bd23af78);
$parcel$export($73a5c9d720aa66e1$exports, "DN90A", () => $73a5c9d720aa66e1$export$40cce05af3b2600a);
$parcel$export($73a5c9d720aa66e1$exports, "DN80A", () => $73a5c9d720aa66e1$export$b78942185925a0d);
$parcel$export($73a5c9d720aa66e1$exports, "DN70A", () => $73a5c9d720aa66e1$export$e058fb44b8eaafca);
$parcel$export($73a5c9d720aa66e1$exports, "DN60A", () => $73a5c9d720aa66e1$export$92b0b8de26920c18);
$parcel$export($73a5c9d720aa66e1$exports, "DN50A", () => $73a5c9d720aa66e1$export$67564f7459d3fc9e);
$parcel$export($73a5c9d720aa66e1$exports, "DN40A", () => $73a5c9d720aa66e1$export$77868e1ca884ffa3);
$parcel$export($73a5c9d720aa66e1$exports, "DN30A", () => $73a5c9d720aa66e1$export$2afd71d7d3ea2cd5);
$parcel$export($73a5c9d720aa66e1$exports, "DN20A", () => $73a5c9d720aa66e1$export$f2a0acaab9972c70);
$parcel$export($73a5c9d720aa66e1$exports, "DN10A", () => $73a5c9d720aa66e1$export$9ab70e67d6475361);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
const $73a5c9d720aa66e1$export$4b84fd0e2c617bd = '#FFEBE6';
const $73a5c9d720aa66e1$export$b34b069eff244586 = '#FFBDAD';
const $73a5c9d720aa66e1$export$be802dd0d8b57f35 = '#FF8F73';
const $73a5c9d720aa66e1$export$60847d42f9da92a6 = '#FF7452';
const $73a5c9d720aa66e1$export$4a7404f376229999 = '#FF5630';
const $73a5c9d720aa66e1$export$2010d0fb4295b346 = '#DE350B';
const $73a5c9d720aa66e1$export$2837b5a1a71d5c02 = '#BF2600';
const $73a5c9d720aa66e1$export$8d9596b529bbb9cf = '#FFFAE6';
const $73a5c9d720aa66e1$export$41060a744ab0b7ae = '#FFF0B3';
const $73a5c9d720aa66e1$export$1cc05bbbf340e559 = '#FFE380';
const $73a5c9d720aa66e1$export$5aae31392d72caaa = '#FFC400';
const $73a5c9d720aa66e1$export$c6930421db9fa514 = '#FFAB00';
const $73a5c9d720aa66e1$export$59619663aa6500fb = '#FF991F';
const $73a5c9d720aa66e1$export$874739ea9e379ab6 = '#FF8B00';
const $73a5c9d720aa66e1$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $73a5c9d720aa66e1$export$69a3bf21b9686c2b = '#ABF5D1';
const $73a5c9d720aa66e1$export$afbce1382ec95f73 = '#79F2C0';
const $73a5c9d720aa66e1$export$747d86715d4175de = '#57D9A3';
const $73a5c9d720aa66e1$export$940e1f69e873f202 = '#36B37E';
const $73a5c9d720aa66e1$export$a49394138f7b8e85 = '#00875A';
const $73a5c9d720aa66e1$export$6fa04827ac68a4fb = '#006644';
const $73a5c9d720aa66e1$export$226de0355ed012f8 = '#DEEBFF';
const $73a5c9d720aa66e1$export$8c13c2ee36917869 = '#B3D4FF';
const $73a5c9d720aa66e1$export$ecfc1dff386a3e7a = '#4C9AFF';
const $73a5c9d720aa66e1$export$215b7063051591f1 = '#2684FF';
const $73a5c9d720aa66e1$export$e62e8919cca44969 = '#0065FF';
const $73a5c9d720aa66e1$export$b3de0ae08da2ce64 = '#0052CC';
const $73a5c9d720aa66e1$export$a6ee3d71bc067634 = '#0747A6';
const $73a5c9d720aa66e1$export$363e4475840015bb = '#EAE6FF';
const $73a5c9d720aa66e1$export$4b0a4417ed59760f = '#C0B6F2';
const $73a5c9d720aa66e1$export$6011520a64d9a187 = '#998DD9';
const $73a5c9d720aa66e1$export$a7175d4e9206bc80 = '#8777D9';
const $73a5c9d720aa66e1$export$b48405b95304b5a1 = '#6554C0';
const $73a5c9d720aa66e1$export$c71e4279dd54a18d = '#5243AA';
const $73a5c9d720aa66e1$export$147899de772240ec = '#403294';
const $73a5c9d720aa66e1$export$2cf711fe14c66f06 = '#E6FCFF';
const $73a5c9d720aa66e1$export$7a8f4d33f6f9772c = '#B3F5FF';
const $73a5c9d720aa66e1$export$776c9c497ef08533 = '#79E2F2';
const $73a5c9d720aa66e1$export$69cb3ca10c1e330e = '#00C7E6';
const $73a5c9d720aa66e1$export$9dc1ef0f3f48059b = '#00B8D9';
const $73a5c9d720aa66e1$export$7c835c78b6fcdef8 = '#00A3BF';
const $73a5c9d720aa66e1$export$6036577f95c3877e = '#008DA6';
const $73a5c9d720aa66e1$export$29a4f05edc054374 = '#FFFFFF';
const $73a5c9d720aa66e1$export$e655ef011c4aa1a2 = '#FAFBFC';
const $73a5c9d720aa66e1$export$9fdfb749e33cdf97 = '#F4F5F7';
const $73a5c9d720aa66e1$export$3e51e8f1440314ba = '#EBECF0';
const $73a5c9d720aa66e1$export$1ce2d1575d444ceb = '#DFE1E6';
const $73a5c9d720aa66e1$export$8754fc7e6d8b3000 = '#C1C7D0';
const $73a5c9d720aa66e1$export$c2e91cbeada39b8b = '#B3BAC5';
const $73a5c9d720aa66e1$export$5f71e19f3a7ad9de = '#A5ADBA';
const $73a5c9d720aa66e1$export$eaa8c8a70ac22806 = '#97A0AF';
const $73a5c9d720aa66e1$export$7c87d337fb91a97d = '#8993A4';
const $73a5c9d720aa66e1$export$d6447c357493214f = '#7A869A';
const $73a5c9d720aa66e1$export$f563ee71e9ee74cd = '#6B778C';
const $73a5c9d720aa66e1$export$e2ef2124cf4024b1 = '#5E6C84';
const $73a5c9d720aa66e1$export$eece5f492e429f08 = '#505F79';
const $73a5c9d720aa66e1$export$c39c0fe0f26207ae = '#42526E';
const $73a5c9d720aa66e1$export$7090862dc3038a9f = '#344563';
const $73a5c9d720aa66e1$export$ad0bacf983b7ddaa = '#253858';
const $73a5c9d720aa66e1$export$7d61b15e0da132af = '#172B4D';
const $73a5c9d720aa66e1$export$fbda843f0a27fe96 = '#091E42';
const $73a5c9d720aa66e1$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $73a5c9d720aa66e1$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $73a5c9d720aa66e1$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $73a5c9d720aa66e1$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $73a5c9d720aa66e1$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $73a5c9d720aa66e1$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $73a5c9d720aa66e1$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $73a5c9d720aa66e1$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $73a5c9d720aa66e1$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $73a5c9d720aa66e1$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $73a5c9d720aa66e1$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $73a5c9d720aa66e1$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $73a5c9d720aa66e1$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $73a5c9d720aa66e1$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $73a5c9d720aa66e1$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $73a5c9d720aa66e1$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $73a5c9d720aa66e1$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $73a5c9d720aa66e1$export$2f6319cf7d736c2a = '#E6EDFA';
const $73a5c9d720aa66e1$export$95126bc8884d6634 = '#DCE5F5';
const $73a5c9d720aa66e1$export$8338d8c35d44ff1 = '#CED9EB';
const $73a5c9d720aa66e1$export$5368d76ae4fbbda7 = '#B8C7E0';
const $73a5c9d720aa66e1$export$9f0a771d16ec8d36 = '#ABBBD6';
const $73a5c9d720aa66e1$export$abcf8c38338b4aa5 = '#9FB0CC';
const $73a5c9d720aa66e1$export$97e81faa16a182c7 = '#8C9CB8';
const $73a5c9d720aa66e1$export$bfe21c59123ecf33 = '#7988A3';
const $73a5c9d720aa66e1$export$ee82aa2ea6a1558 = '#67758F';
const $73a5c9d720aa66e1$export$682927c6ed76be02 = '#56637A';
const $73a5c9d720aa66e1$export$91fd9994c5be9757 = '#455166';
const $73a5c9d720aa66e1$export$d281fbfe3cff2df6 = '#3B475C';
const $73a5c9d720aa66e1$export$3902c91d8b98a753 = '#313D52';
const $73a5c9d720aa66e1$export$8e8133c1ba5845b5 = '#283447';
const $73a5c9d720aa66e1$export$33ff357f6620b39 = '#202B3D';
const $73a5c9d720aa66e1$export$633847cf062b69e0 = '#1B2638';
const $73a5c9d720aa66e1$export$9776a6e503bdbf76 = '#121A29';
const $73a5c9d720aa66e1$export$6c813d5160dff5db = '#0E1624';
const $73a5c9d720aa66e1$export$3d4f271a500072a = '#0D1424';
const $73a5c9d720aa66e1$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $73a5c9d720aa66e1$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $73a5c9d720aa66e1$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $73a5c9d720aa66e1$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $73a5c9d720aa66e1$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $73a5c9d720aa66e1$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $73a5c9d720aa66e1$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $73a5c9d720aa66e1$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $73a5c9d720aa66e1$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $73a5c9d720aa66e1$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $73a5c9d720aa66e1$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $73a5c9d720aa66e1$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $73a5c9d720aa66e1$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $73a5c9d720aa66e1$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $73a5c9d720aa66e1$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $73a5c9d720aa66e1$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $73a5c9d720aa66e1$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';

parcelRegister("gaA9C", function(module, exports) {

$parcel$export(module.exports, "FieldId", () => $d60d84c188ee2cc0$export$3c4232819458a302);

var $eUqFw = parcelRequire("eUqFw");
const $d60d84c188ee2cc0$export$3c4232819458a302 = /*#__PURE__*/ (0, $eUqFw.createContext)(undefined);

});


parcelRegister("4LhB6", function(module, exports) {

$parcel$export(module.exports, "default", () => $dde75f35762e3dcb$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $tkrFt = parcelRequire("tkrFt");
parcelRequire("8ynlC");

var $gaA9C = parcelRequire("gaA9C");

var $lzLxZ = parcelRequire("lzLxZ");

var $6ROLN = parcelRequire("6ROLN");

var $jeetE = parcelRequire("jeetE");

var $2fFJv = parcelRequire("2fFJv");
function $dde75f35762e3dcb$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $dde75f35762e3dcb$var$fieldWrapperStyles = {
    name: "wkpnc",
    styles: "margin-block-start:var(--ds-space-100, 8px)"
};
function $dde75f35762e3dcb$var$isEvent(event) {
    return Boolean(event && event.target);
}
function $dde75f35762e3dcb$var$isFunction(x) {
    return typeof x === 'function';
}
function $dde75f35762e3dcb$var$usePreviousRef(current) {
    const ref = (0, $eUqFw.useRef)(current);
    // will be updated on the next render
    (0, $eUqFw.useEffect)(()=>{
        ref.current = current;
    });
    // return the existing current (pre render)
    return ref;
}
function $dde75f35762e3dcb$var$isShallowEqual(previousValue, currentValue) {
    if (previousValue === currentValue) return true;
    // not checking functions
    if (typeof previousValue === 'function' && typeof currentValue === 'function') return true;
    if (Array.isArray(previousValue) && Array.isArray(currentValue)) return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    if (typeof previousValue === 'object' && typeof currentValue === 'object') return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    return false;
}
function $dde75f35762e3dcb$export$2e2bcd8739ae039(props) {
    const { registerField: registerField, getCurrentValue: getCurrentValue } = (0, $eUqFw.useContext)((0, $lzLxZ.FormContext));
    const isDisabled = (0, $eUqFw.useContext)((0, $lzLxZ.IsDisabledContext)) || props.isDisabled || false;
    const defaultValue = $dde75f35762e3dcb$var$isFunction(props.defaultValue) ? props.defaultValue() : props.defaultValue;
    const latestPropsRef = $dde75f35762e3dcb$var$usePreviousRef(props);
    /**
   * HACK: defaultValue can potentially be an array or object which cannot be
   * passed directly into a `useEffect` dependency array, since it will trigger
   * the hook every time.
   */ const isDefaultValueChanged = !$dde75f35762e3dcb$var$isShallowEqual(latestPropsRef.current.defaultValue, props.defaultValue);
    const [state, setState] = (0, $eUqFw.useState)({
        fieldProps: {
            onChange: ()=>{},
            onBlur: ()=>{},
            onFocus: ()=>{},
            /* Previously, defaultValue was being set as undefined in Field.defaultProps, which
       * effectively made it an optional prop to external consumers of Field. However the
       * prop types defined defaultValue as required, so inside the component it was not
       * valid for defaultValue to be undefined. We need to suppress the error
       * after changing defaultValue to explictly be an optional prop.
       * If default value has changed we are using new default value.
       * Otherwise we need to check if we already have value for this field
       * (because we are using changing key prop to re-run field level validation, and that
       * cause the component re-mounting) to not override the actual value with the default value.
       */ // @ts-ignore
            value: isDefaultValueChanged ? defaultValue : getCurrentValue(props.name) ?? defaultValue
        },
        error: undefined,
        valid: false,
        meta: {
            dirty: false,
            dirtySinceLastSubmit: false,
            touched: false,
            valid: false,
            validating: false,
            submitting: false,
            submitFailed: false,
            error: undefined,
            submitError: undefined
        }
    });
    const latestStateRef = $dde75f35762e3dcb$var$usePreviousRef(state);
    (0, $eUqFw.useEffect)(()=>{
        typeof $2fFJv;
        function fieldStateToMeta(value = {}) {
            return {
                dirty: value.dirty || false,
                dirtySinceLastSubmit: value.dirtySinceLastSubmit || false,
                touched: value.touched || false,
                valid: value.valid || false,
                submitting: value.submitting || false,
                submitFailed: value.submitFailed || false,
                error: value.error,
                submitError: value.submitError,
                validating: !!value.validating
            };
        }
        const unregister = registerField(latestPropsRef.current.name, /**
     * Similar as for setting initial state value.
     * Additionally we are checking if the default value is a function,
     * it is used in checkbox fields, where fields with same name and
     * defaultIsChecked should create array of values. In this situation we can't
     * override the default value on re-registering, but also we don't need to change
     * the key prop to re-run validation.
     */ // @ts-ignore
        isDefaultValueChanged || // @ts-ignore
        $dde75f35762e3dcb$var$isFunction(latestPropsRef.current.defaultValue) ? latestPropsRef.current.defaultValue : latestStateRef.current.fieldProps.value, (fieldState)=>{
            /**
       * Do not update dirtySinceLastSubmit until submission has finished.
       */ const modifiedDirtySinceLastSubmit = fieldState.submitting ? latestStateRef.current.meta.dirtySinceLastSubmit : fieldState.dirtySinceLastSubmit;
            /**
       * Do not update submitFailed until submission has finished.
       */ const modifiedSubmitFailed = fieldState.submitting ? latestStateRef.current.meta.submitFailed : fieldState.submitFailed;
            /**
       * Do not use submitError if the value has changed.
       */ const modifiedSubmitError = modifiedDirtySinceLastSubmit && latestPropsRef.current.validate ? undefined : fieldState.submitError;
            const modifiedError = modifiedSubmitError || (fieldState.touched || fieldState.dirty) && fieldState.error;
            /**
       * If there has been a submit error, then use logic in modifiedError to determine validity,
       * so we can determine when there is a submit error which we do not want to display
       * because the value has been changed.
       */ const modifiedValid = modifiedSubmitFailed ? modifiedError === undefined : fieldState.valid;
            function getTransform(eventOrValue, currentValue) {
                if (latestPropsRef.current.transform) return latestPropsRef.current.transform(eventOrValue, currentValue);
                if ($dde75f35762e3dcb$var$isEvent(eventOrValue)) {
                    const { currentTarget: currentTarget } = eventOrValue;
                    if (currentTarget.type === 'checkbox') {
                        if (currentTarget.checked) return currentTarget.value || true;
                        return currentTarget.value ? undefined : false;
                    } else if (currentTarget) return currentTarget.value;
                } else return eventOrValue;
            }
            setState({
                fieldProps: {
                    onChange: (e)=>{
                        fieldState.change(getTransform(e, fieldState.value));
                    },
                    onBlur: fieldState.blur,
                    onFocus: fieldState.focus,
                    value: fieldState.value
                },
                error: modifiedError || undefined,
                /**
         * The following parameters are optionally typed in final-form to indicate that not all parameters need
         * to be subscribed to. We cast them as booleans (using || false), since this is what they are semantically.
         */ valid: modifiedValid || false,
                meta: fieldStateToMeta(fieldState)
            });
        }, {
            dirty: true,
            dirtySinceLastSubmit: true,
            touched: true,
            valid: true,
            submitting: true,
            submitFailed: true,
            value: true,
            error: true,
            submitError: true,
            validating: true
        }, {
            getValidator: ()=>function validate(value, formState, fieldState) {
                    const supplied = latestPropsRef.current.validate;
                    if (supplied && fieldState) return supplied(value, formState, fieldStateToMeta(fieldState));
                }
        });
        return unregister;
    }, [
        latestPropsRef,
        latestStateRef,
        registerField,
        props.name,
        isDefaultValueChanged
    ]);
    const fieldId = (0, $eUqFw.useMemo)(// eslint-disable-next-line @repo/internal/react/disallow-unstable-values
    ()=>props.id ? props.id : `${props.name}-${(0, $tkrFt.uid)({
            id: props.name
        })}`, [
        props.id,
        props.name
    ]);
    const getDescribedBy = ()=>{
        let value = '';
        if (state.error) value += `${fieldId}-error `;
        if (state.valid) value += `${fieldId}-valid `;
        return `${value}${fieldId}-helper`;
    };
    const extendedFieldProps = {
        ...state.fieldProps,
        name: props.name,
        isDisabled: isDisabled,
        isInvalid: Boolean(state.error),
        isRequired: Boolean(props.isRequired),
        'aria-invalid': state.error ? 'true' : 'false',
        'aria-describedby': getDescribedBy(),
        'aria-labelledby': `${fieldId}-label`,
        id: fieldId
    };
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $dde75f35762e3dcb$var$fieldWrapperStyles,
        "data-testid": props.testId
    }, props.label && /*#__PURE__*/ (0, $byn9U.jsx)((0, $6ROLN.Label), {
        htmlFor: fieldId,
        id: `${fieldId}-label`,
        testId: props.testId && `${props.testId}--label`
    }, props.label, props.isRequired && /*#__PURE__*/ (0, $byn9U.jsx)((0, $jeetE.default), null), props.elementAfterLabel), /*#__PURE__*/ (0, $byn9U.jsx)((0, $gaA9C.FieldId).Provider, {
        value: fieldId
    }, props.children({
        fieldProps: extendedFieldProps,
        error: state.error,
        valid: state.valid,
        meta: state.meta
    })));
}

});
parcelRegister("6ROLN", function(module, exports) {

$parcel$export(module.exports, "Label", () => $7dbb02f7c217159b$export$b04be29aa201d4f5);
$parcel$export(module.exports, "Legend", () => $7dbb02f7c217159b$export$ed247974535929c7);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");
function $7dbb02f7c217159b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7dbb02f7c217159b$var$fieldsetLabelStyles = {
    name: "zjewl9",
    styles: "display:inline-block;color:var(--ds-text-subtle, #44546F);font:var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);font-weight:var(--ds-font-weight-bold, 700);margin-block-end:var(--ds-space-050, 4px);margin-block-start:var(--ds-space-0, 0px)"
};
const $7dbb02f7c217159b$export$b04be29aa201d4f5 = ({ children: children, htmlFor: htmlFor, id: id, testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)("label", {
        css: $7dbb02f7c217159b$var$fieldsetLabelStyles,
        id: id,
        htmlFor: htmlFor,
        "data-testid": testId
    }, children);
const $7dbb02f7c217159b$export$ed247974535929c7 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("legend", {
        css: $7dbb02f7c217159b$var$fieldsetLabelStyles
    }, children);
};
var $7dbb02f7c217159b$export$2e2bcd8739ae039 = $7dbb02f7c217159b$export$b04be29aa201d4f5;

});

parcelRegister("jeetE", function(module, exports) {

$parcel$export(module.exports, "default", () => $d43a5e2537ba41ea$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

const $d43a5e2537ba41ea$var$requiredIndicatorStyles = /*#__PURE__*/ (0, $byn9U.css)({
    color: `var(--ds-text-danger, ${(0, $73a5c9d720aa66e1$export$2010d0fb4295b346)})`,
    fontFamily: "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    paddingInlineStart: "var(--ds-space-025, 2px)"
});
function $d43a5e2537ba41ea$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $d43a5e2537ba41ea$var$requiredIndicatorStyles,
        "aria-hidden": "true",
        title: "required"
    }, "*");
}

});


parcelRegister("3nnLQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2755f57284cb8101$var$_react = $2755f57284cb8101$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $2755f57284cb8101$var$_bookWithBookmark = $2755f57284cb8101$var$_interopRequireDefault((parcelRequire("aySPZ")));
function $2755f57284cb8101$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $2755f57284cb8101$var$BookIcon = (props)=>/*#__PURE__*/ $2755f57284cb8101$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M7 6.002v9.996c0 .546.446 1.002.995 1.002h8.01c.54 0 .995-.449.995-1.002V6.002C17 5.456 16.554 5 16.005 5h-8.01C7.455 5 7 5.449 7 6.002m-2 0A3.005 3.005 0 0 1 7.995 3h8.01A3.003 3.003 0 0 1 19 6.002v9.996A3.005 3.005 0 0 1 16.005 19h-8.01A3.003 3.003 0 0 1 5 15.998z"/><path d="M9 7h6v4H9zm0 6h6v2H9zm1 7.86V20H7v.86L8.5 20zM7 18h3v2H7z"/></g></svg>`
    }, props, {
        newIcon: $2755f57284cb8101$var$_bookWithBookmark.default
    }));
$2755f57284cb8101$var$BookIcon.displayName = 'BookIcon';
var $2755f57284cb8101$var$_default = module.exports.default = $2755f57284cb8101$var$BookIcon;

});
parcelRegister("aySPZ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::21a3f0f1fb45ae923f1f4e869eaa786a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7b079df464c03232$var$_react = $7b079df464c03232$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $7b079df464c03232$var$_UNSAFE_baseNew = $7b079df464c03232$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $7b079df464c03232$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "BookWithBookmark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: knowledge bases, articles, and other representations of books or info.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7b079df464c03232$var$BookWithBookmarkIcon = (props)=>/*#__PURE__*/ $7b079df464c03232$var$_react.default.createElement($7b079df464c03232$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M2.75 11.625c0 1.174.951 2.125 2.125 2.125H5.5m-2.75-2.125c0-1.174.951-2.125 2.125-2.125H12.5m-9.75 2.125v-8.75C2.75 1.701 3.701.75 4.875.75h8.375V9.5h-.75m1.5 4.25h-1.5m-2 0h2m0-4.25v4.25"/><path fill="currentcolor" d="M6.5 15.564V11.5h3v4.064a.25.25 0 0 1-.441.16L8 14.465l-1.059 1.26a.25.25 0 0 1-.441-.16"/>`
    }, props));
$7b079df464c03232$var$BookWithBookmarkIcon.displayName = 'BookWithBookmarkIcon';
var $7b079df464c03232$var$_default = module.exports.default = $7b079df464c03232$var$BookWithBookmarkIcon;

});


parcelRegister("aQrlQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7e53fa1b2735af75$var$_react = $7e53fa1b2735af75$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $7e53fa1b2735af75$var$_lobbyBell = $7e53fa1b2735af75$var$_interopRequireDefault((parcelRequire("hc1zW")));
function $7e53fa1b2735af75$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $7e53fa1b2735af75$var$HipchatLobbyIcon = (props)=>/*#__PURE__*/ $7e53fa1b2735af75$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M5 14a7.002 7.002 0 0 1 13.858 0z"/><rect width="16" height="2" x="4" y="15" rx="1"/><path d="M11 7h2v3h-2z"/><rect width="4" height="1" x="10" y="6" rx=".5"/></g></svg>`
    }, props, {
        newIcon: $7e53fa1b2735af75$var$_lobbyBell.default
    }));
$7e53fa1b2735af75$var$HipchatLobbyIcon.displayName = 'HipchatLobbyIcon';
var $7e53fa1b2735af75$var$_default = module.exports.default = $7e53fa1b2735af75$var$HipchatLobbyIcon;

});
parcelRegister("hc1zW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::09dffcf454e65423d222d458e536db22>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c844c82dfdc2320b$var$_react = $c844c82dfdc2320b$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $c844c82dfdc2320b$var$_UNSAFE_baseNew = $c844c82dfdc2320b$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $c844c82dfdc2320b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "LobbyBell".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: risks in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c844c82dfdc2320b$var$LobbyBellIcon = (props)=>/*#__PURE__*/ $c844c82dfdc2320b$var$_react.default.createElement($c844c82dfdc2320b$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M8 5V1.75M8 5h1.67a4 4 0 0 1 3.975 3.558L14 11.75H2l.355-3.192A4 4 0 0 1 6.33 5zm0-3.25h2m-2 0H6m-5 12.5h14"/>`
    }, props));
$c844c82dfdc2320b$var$LobbyBellIcon.displayName = 'LobbyBellIcon';
var $c844c82dfdc2320b$var$_default = module.exports.default = $c844c82dfdc2320b$var$LobbyBellIcon;

});


parcelRegister("aJdjG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7cf86fb59fd607cb$var$_react = $7cf86fb59fd607cb$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $7cf86fb59fd607cb$var$_comment = $7cf86fb59fd607cb$var$_interopRequireDefault((parcelRequire("75UoT")));
function $7cf86fb59fd607cb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $7cf86fb59fd607cb$var$QuestionsIcon = (props)=>/*#__PURE__*/ $7cf86fb59fd607cb$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M15 16h4V6H5v10h7.333L15 18zm2 2v2a1 1 0 0 1-1.6.8L11.667 18H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2z"/><path d="M7 10h10V8H7zm0 4h6v-2H7z"/></g></svg>`
    }, props, {
        newIcon: $7cf86fb59fd607cb$var$_comment.default
    }));
$7cf86fb59fd607cb$var$QuestionsIcon.displayName = 'QuestionsIcon';
var $7cf86fb59fd607cb$var$_default = module.exports.default = $7cf86fb59fd607cb$var$QuestionsIcon;

});
parcelRegister("75UoT", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::36758847330c30e3d31c155e38099f5e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $52a4bffd3c43d738$var$_react = $52a4bffd3c43d738$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $52a4bffd3c43d738$var$_UNSAFE_baseNew = $52a4bffd3c43d738$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $52a4bffd3c43d738$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Comment".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for comments on objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $52a4bffd3c43d738$var$CommentIcon = (props)=>/*#__PURE__*/ $52a4bffd3c43d738$var$_react.default.createElement($52a4bffd3c43d738$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M4.25 13.25v-.75h-.2l-.172.099zm-3.5 2H0a.75.75 0 0 0 1.122.651zM2.625 2h10.75V.5H2.625zM14.5 3.125v8.25H16v-8.25zM13.375 12.5H4.25V14h9.125zm-9.497.099-3.5 2 .744 1.302 3.5-2zM1.5 15.25V3.125H0V15.25zM4 6.5h8V5H4zm0 3h5V8H4zm10.5 1.875c0 .621-.504 1.125-1.125 1.125V14A2.625 2.625 0 0 0 16 11.375zM13.375 2c.621 0 1.125.504 1.125 1.125H16A2.625 2.625 0 0 0 13.375.5zM2.625.5A2.625 2.625 0 0 0 0 3.125h1.5C1.5 2.504 2.004 2 2.625 2z"/>`
    }, props));
$52a4bffd3c43d738$var$CommentIcon.displayName = 'CommentIcon';
var $52a4bffd3c43d738$var$_default = module.exports.default = $52a4bffd3c43d738$var$CommentIcon;

});


parcelRegister("5wCDk", function(module, exports) {

$parcel$export(module.exports, "SelectWithoutAnalytics", () => $eb73e877c5661200$export$d1de3b251ccaa8a3);
$parcel$export(module.exports, "default", () => $eb73e877c5661200$export$2e2bcd8739ae039);

var $hOLnS = parcelRequire("hOLnS");

var $hM7RE = parcelRequire("hM7RE");
var $1ngde = parcelRequire("1ngde");
var $2jDha = parcelRequire("2jDha");

var $5FjBr = parcelRequire("5FjBr");
const $eb73e877c5661200$var$packageName = "platform-pkg";
const $eb73e877c5661200$var$packageVersion = "0.0.0-use.local";
const $eb73e877c5661200$export$d1de3b251ccaa8a3 = (0, $5FjBr.default)((0, $hOLnS.default));
const $eb73e877c5661200$var$createAndFireEventOnAtlaskit = (0, $hM7RE.default)('atlaskit');
const $eb73e877c5661200$var$Select = (0, $1ngde.default)({
    componentName: 'select',
    packageName: $eb73e877c5661200$var$packageName,
    packageVersion: $eb73e877c5661200$var$packageVersion
})((0, $2jDha.default)({
    onChange: $eb73e877c5661200$var$createAndFireEventOnAtlaskit({
        action: 'changed',
        actionSubject: 'option',
        attributes: {
            componentName: 'select',
            packageName: $eb73e877c5661200$var$packageName,
            packageVersion: $eb73e877c5661200$var$packageVersion
        }
    })
})($eb73e877c5661200$export$d1de3b251ccaa8a3));
var $eb73e877c5661200$export$2e2bcd8739ae039 = $eb73e877c5661200$var$Select;

});
parcelRegister("hOLnS", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf8bdca71ec4c4b4$export$2e2bcd8739ae039);

var $7IqRg = parcelRequire("7IqRg");

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $cEc3i = parcelRequire("cEc3i");

var $4WmDP = parcelRequire("4WmDP");

var $i4xqP = parcelRequire("i4xqP");

var $jQxSL = parcelRequire("jQxSL");
parcelRequire("1Xn5q");
parcelRequire("aKcqM");
parcelRequire("bwPfh");
parcelRequire("lDSrn");
parcelRequire("lIEGP");
parcelRequire("eT4IF");
parcelRequire("7Dzgl");
parcelRequire("fVK4C");

parcelRequire("5sKOb");
parcelRequire("jqNEH");
parcelRequire("5zQU9");
parcelRequire("lEfVV");

parcelRequire("k286k");
var $cf8bdca71ec4c4b4$var$StateManagedSelect = /*#__PURE__*/ (0, $eUqFw.forwardRef)(function(props, ref) {
    var baseSelectProps = (0, $7IqRg.u)(props);
    return /*#__PURE__*/ $eUqFw.createElement((0, $cEc3i.S), (0, $kU09D.default)({
        ref: ref
    }, baseSelectProps));
});
var $cf8bdca71ec4c4b4$export$a7deb1594c5ce10e = function(_ref) {
    var nonce = _ref.nonce, children = _ref.children, cacheKey = _ref.cacheKey;
    var emotionCache = (0, $eUqFw.useMemo)(function() {
        return (0, $i4xqP.default)({
            key: cacheKey,
            nonce: nonce
        });
    }, [
        cacheKey,
        nonce
    ]);
    return /*#__PURE__*/ $eUqFw.createElement((0, $4WmDP.C), {
        value: emotionCache
    }, children);
};
var $cf8bdca71ec4c4b4$export$2e2bcd8739ae039 = $cf8bdca71ec4c4b4$var$StateManagedSelect;

});
parcelRegister("7IqRg", function(module, exports) {

$parcel$export(module.exports, "u", () => $59e179ee89746bd6$export$3b14a55fb2447963);

var $1Xn5q = parcelRequire("1Xn5q");

var $aKcqM = parcelRequire("aKcqM");

var $bwPfh = parcelRequire("bwPfh");

var $eUqFw = parcelRequire("eUqFw");
var $59e179ee89746bd6$var$_excluded = [
    "defaultInputValue",
    "defaultMenuIsOpen",
    "defaultValue",
    "inputValue",
    "menuIsOpen",
    "onChange",
    "onInputChange",
    "onMenuClose",
    "onMenuOpen",
    "value"
];
function $59e179ee89746bd6$export$3b14a55fb2447963(_ref) {
    var _ref$defaultInputValu = _ref.defaultInputValue, defaultInputValue = _ref$defaultInputValu === void 0 ? '' : _ref$defaultInputValu, _ref$defaultMenuIsOpe = _ref.defaultMenuIsOpen, defaultMenuIsOpen = _ref$defaultMenuIsOpe === void 0 ? false : _ref$defaultMenuIsOpe, _ref$defaultValue = _ref.defaultValue, defaultValue = _ref$defaultValue === void 0 ? null : _ref$defaultValue, propsInputValue = _ref.inputValue, propsMenuIsOpen = _ref.menuIsOpen, propsOnChange = _ref.onChange, propsOnInputChange = _ref.onInputChange, propsOnMenuClose = _ref.onMenuClose, propsOnMenuOpen = _ref.onMenuOpen, propsValue = _ref.value, restSelectProps = (0, $bwPfh.default)(_ref, $59e179ee89746bd6$var$_excluded);
    var _useState = (0, $eUqFw.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue), _useState2 = (0, $aKcqM.default)(_useState, 2), stateInputValue = _useState2[0], setStateInputValue = _useState2[1];
    var _useState3 = (0, $eUqFw.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen), _useState4 = (0, $aKcqM.default)(_useState3, 2), stateMenuIsOpen = _useState4[0], setStateMenuIsOpen = _useState4[1];
    var _useState5 = (0, $eUqFw.useState)(propsValue !== undefined ? propsValue : defaultValue), _useState6 = (0, $aKcqM.default)(_useState5, 2), stateValue = _useState6[0], setStateValue = _useState6[1];
    var onChange = (0, $eUqFw.useCallback)(function(value, actionMeta) {
        if (typeof propsOnChange === 'function') propsOnChange(value, actionMeta);
        setStateValue(value);
    }, [
        propsOnChange
    ]);
    var onInputChange = (0, $eUqFw.useCallback)(function(value, actionMeta) {
        var newValue;
        if (typeof propsOnInputChange === 'function') newValue = propsOnInputChange(value, actionMeta);
        setStateInputValue(newValue !== undefined ? newValue : value);
    }, [
        propsOnInputChange
    ]);
    var onMenuOpen = (0, $eUqFw.useCallback)(function() {
        if (typeof propsOnMenuOpen === 'function') propsOnMenuOpen();
        setStateMenuIsOpen(true);
    }, [
        propsOnMenuOpen
    ]);
    var onMenuClose = (0, $eUqFw.useCallback)(function() {
        if (typeof propsOnMenuClose === 'function') propsOnMenuClose();
        setStateMenuIsOpen(false);
    }, [
        propsOnMenuClose
    ]);
    var inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
    var menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
    var value = propsValue !== undefined ? propsValue : stateValue;
    return (0, $1Xn5q.default)((0, $1Xn5q.default)({}, restSelectProps), {}, {
        inputValue: inputValue,
        menuIsOpen: menuIsOpen,
        onChange: onChange,
        onInputChange: onInputChange,
        onMenuClose: onMenuClose,
        onMenuOpen: onMenuOpen,
        value: value
    });
}

});
parcelRegister("aKcqM", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d27d7cb7c770f64$export$2e2bcd8739ae039);

var $kcDiK = parcelRequire("kcDiK");

var $61Jn4 = parcelRequire("61Jn4");

var $e5SQy = parcelRequire("e5SQy");

var $gP5fl = parcelRequire("gP5fl");
function $7d27d7cb7c770f64$export$2e2bcd8739ae039(r, e) {
    return (0, $kcDiK.default)(r) || (0, $61Jn4.default)(r, e) || (0, $e5SQy.default)(r, e) || (0, $gP5fl.default)();
}

});
parcelRegister("kcDiK", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb536a1805ce1726$export$2e2bcd8739ae039);
function $eb536a1805ce1726$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("61Jn4", function(module, exports) {

$parcel$export(module.exports, "default", () => $463607d84fb47652$export$2e2bcd8739ae039);
function $463607d84fb47652$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("e5SQy", function(module, exports) {

$parcel$export(module.exports, "default", () => $a42c13bbb83e195c$export$2e2bcd8739ae039);

var $aLrjs = parcelRequire("aLrjs");
function $a42c13bbb83e195c$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $aLrjs.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $aLrjs.default)(r, a) : void 0;
    }
}

});
parcelRegister("aLrjs", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d637af256120630$export$2e2bcd8739ae039);
function $7d637af256120630$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("gP5fl", function(module, exports) {

$parcel$export(module.exports, "default", () => $c3f57a97be8f63bf$export$2e2bcd8739ae039);
function $c3f57a97be8f63bf$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("bwPfh", function(module, exports) {

$parcel$export(module.exports, "default", () => $864a6f28f9285041$export$2e2bcd8739ae039);

var $6XgOP = parcelRequire("6XgOP");
function $864a6f28f9285041$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $6XgOP.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], t.indexOf(o) >= 0 || ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});


parcelRegister("cEc3i", function(module, exports) {

$parcel$export(module.exports, "c", () => $935291c440101c41$export$db3b6bfb95261072);
$parcel$export(module.exports, "b", () => $935291c440101c41$export$8b22cf2602fb60ce);
$parcel$export(module.exports, "g", () => $935291c440101c41$export$39b482c5e57630a8);
$parcel$export(module.exports, "m", () => $935291c440101c41$export$953cecd6e717a553);
$parcel$export(module.exports, "S", () => $935291c440101c41$export$25ce5a424b770e84);

var $kU09D = parcelRequire("kU09D");

var $1Xn5q = parcelRequire("1Xn5q");

var $lDSrn = parcelRequire("lDSrn");

var $lIEGP = parcelRequire("lIEGP");

var $eT4IF = parcelRequire("eT4IF");

var $7Dzgl = parcelRequire("7Dzgl");

var $fVK4C = parcelRequire("fVK4C");

var $eUqFw = parcelRequire("eUqFw");

var $jQxSL = parcelRequire("jQxSL");

var $byn9U = parcelRequire("byn9U");

var $5iWql = parcelRequire("5iWql");

var $bwPfh = parcelRequire("bwPfh");
function $935291c440101c41$var$_EMOTION_STRINGIFIED_CSS_ERROR__$2() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Assistive text to describe visual elements. Hidden for sighted users.
var $935291c440101c41$var$_ref = {
    name: "7pg0cj-a11yText",
    styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
};
var $935291c440101c41$var$A11yText = function A11yText(props) {
    return (0, $byn9U.jsx)("span", (0, $kU09D.default)({
        css: $935291c440101c41$var$_ref
    }, props));
};
var $935291c440101c41$var$defaultAriaLiveMessages = {
    guidance: function guidance(props) {
        var isSearchable = props.isSearchable, isMulti = props.isMulti, isDisabled = props.isDisabled, tabSelectsValue = props.tabSelectsValue, context = props.context;
        switch(context){
            case 'menu':
                return "Use Up and Down to choose options".concat(isDisabled ? '' : ', press Enter to select the currently focused option', ", press Escape to exit the menu").concat(tabSelectsValue ? ', press Tab to select the option and exit the menu' : '', ".");
            case 'input':
                return "".concat(props['aria-label'] || 'Select', " is focused ").concat(isSearchable ? ',type to refine list' : '', ", press Down to open the menu, ").concat(isMulti ? ' press left to focus selected values' : '');
            case 'value':
                return 'Use left and right to toggle between focused values, press Backspace to remove the currently focused value';
            default:
                return '';
        }
    },
    onChange: function onChange(props) {
        var action = props.action, _props$label = props.label, label = _props$label === void 0 ? '' : _props$label, labels = props.labels, isDisabled = props.isDisabled;
        switch(action){
            case 'deselect-option':
            case 'pop-value':
            case 'remove-value':
                return "option ".concat(label, ", deselected.");
            case 'clear':
                return 'All selected options have been cleared.';
            case 'initial-input-focus':
                return "option".concat(labels.length > 1 ? 's' : '', " ").concat(labels.join(','), ", selected.");
            case 'select-option':
                return isDisabled ? "option ".concat(label, " is disabled. Select another option.") : "option ".concat(label, ", selected.");
            default:
                return '';
        }
    },
    onFocus: function onFocus(props) {
        var context = props.context, focused = props.focused, options = props.options, _props$label2 = props.label, label = _props$label2 === void 0 ? '' : _props$label2, selectValue = props.selectValue, isDisabled = props.isDisabled, isSelected = props.isSelected;
        var getArrayIndex = function getArrayIndex(arr, item) {
            return arr && arr.length ? "".concat(arr.indexOf(item) + 1, " of ").concat(arr.length) : '';
        };
        if (context === 'value' && selectValue) return "value ".concat(label, " focused, ").concat(getArrayIndex(selectValue, focused), ".");
        if (context === 'menu') {
            var disabled = isDisabled ? ' disabled' : '';
            var status = "".concat(isSelected ? 'selected' : 'focused').concat(disabled);
            return "option ".concat(label, " ").concat(status, ", ").concat(getArrayIndex(options, focused), ".");
        }
        return '';
    },
    onFilter: function onFilter(props) {
        var inputValue = props.inputValue, resultsMessage = props.resultsMessage;
        return "".concat(resultsMessage).concat(inputValue ? ' for search term ' + inputValue : '', ".");
    }
};
var $935291c440101c41$var$LiveRegion = function LiveRegion(props) {
    var ariaSelection = props.ariaSelection, focusedOption = props.focusedOption, focusedValue = props.focusedValue, focusableOptions = props.focusableOptions, isFocused = props.isFocused, selectValue = props.selectValue, selectProps = props.selectProps, id = props.id;
    var ariaLiveMessages = selectProps.ariaLiveMessages, getOptionLabel = selectProps.getOptionLabel, inputValue = selectProps.inputValue, isMulti = selectProps.isMulti, isOptionDisabled = selectProps.isOptionDisabled, isSearchable = selectProps.isSearchable, menuIsOpen = selectProps.menuIsOpen, options = selectProps.options, screenReaderStatus = selectProps.screenReaderStatus, tabSelectsValue = selectProps.tabSelectsValue;
    var ariaLabel = selectProps['aria-label'];
    var ariaLive = selectProps['aria-live'];
    // Update aria live message configuration when prop changes
    var messages = (0, $eUqFw.useMemo)(function() {
        return (0, $1Xn5q.default)((0, $1Xn5q.default)({}, $935291c440101c41$var$defaultAriaLiveMessages), ariaLiveMessages || {});
    }, [
        ariaLiveMessages
    ]);
    // Update aria live selected option when prop changes
    var ariaSelected = (0, $eUqFw.useMemo)(function() {
        var message = '';
        if (ariaSelection && messages.onChange) {
            var option = ariaSelection.option, selectedOptions = ariaSelection.options, removedValue = ariaSelection.removedValue, removedValues = ariaSelection.removedValues, value = ariaSelection.value;
            // select-option when !isMulti does not return option so we assume selected option is value
            var asOption = function asOption(val) {
                return !Array.isArray(val) ? val : null;
            };
            // If there is just one item from the action then get its label
            var selected = removedValue || option || asOption(value);
            var label = selected ? getOptionLabel(selected) : '';
            // If there are multiple items from the action then return an array of labels
            var multiSelected = selectedOptions || removedValues || undefined;
            var labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
            var onChangeProps = (0, $1Xn5q.default)({
                // multiSelected items are usually items that have already been selected
                // or set by the user as a default value so we assume they are not disabled
                isDisabled: selected && isOptionDisabled(selected, selectValue),
                label: label,
                labels: labels
            }, ariaSelection);
            message = messages.onChange(onChangeProps);
        }
        return message;
    }, [
        ariaSelection,
        messages,
        isOptionDisabled,
        selectValue,
        getOptionLabel
    ]);
    var ariaFocused = (0, $eUqFw.useMemo)(function() {
        var focusMsg = '';
        var focused = focusedOption || focusedValue;
        var isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));
        if (focused && messages.onFocus) {
            var onFocusProps = {
                focused: focused,
                label: getOptionLabel(focused),
                isDisabled: isOptionDisabled(focused, selectValue),
                isSelected: isSelected,
                options: focusableOptions,
                context: focused === focusedOption ? 'menu' : 'value',
                selectValue: selectValue
            };
            focusMsg = messages.onFocus(onFocusProps);
        }
        return focusMsg;
    }, [
        focusedOption,
        focusedValue,
        getOptionLabel,
        isOptionDisabled,
        messages,
        focusableOptions,
        selectValue
    ]);
    var ariaResults = (0, $eUqFw.useMemo)(function() {
        var resultsMsg = '';
        if (menuIsOpen && options.length && messages.onFilter) {
            var resultsMessage = screenReaderStatus({
                count: focusableOptions.length
            });
            resultsMsg = messages.onFilter({
                inputValue: inputValue,
                resultsMessage: resultsMessage
            });
        }
        return resultsMsg;
    }, [
        focusableOptions,
        inputValue,
        menuIsOpen,
        messages,
        options,
        screenReaderStatus
    ]);
    var ariaGuidance = (0, $eUqFw.useMemo)(function() {
        var guidanceMsg = '';
        if (messages.guidance) {
            var context = focusedValue ? 'value' : menuIsOpen ? 'menu' : 'input';
            guidanceMsg = messages.guidance({
                'aria-label': ariaLabel,
                context: context,
                isDisabled: focusedOption && isOptionDisabled(focusedOption, selectValue),
                isMulti: isMulti,
                isSearchable: isSearchable,
                tabSelectsValue: tabSelectsValue
            });
        }
        return guidanceMsg;
    }, [
        ariaLabel,
        focusedOption,
        focusedValue,
        isMulti,
        isOptionDisabled,
        isSearchable,
        menuIsOpen,
        messages,
        selectValue,
        tabSelectsValue
    ]);
    var ariaContext = "".concat(ariaFocused, " ").concat(ariaResults, " ").concat(ariaGuidance);
    var ScreenReaderText = (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, (0, $byn9U.jsx)("span", {
        id: "aria-selection"
    }, ariaSelected), (0, $byn9U.jsx)("span", {
        id: "aria-context"
    }, ariaContext));
    var isInitialFocus = (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus';
    return (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, (0, $byn9U.jsx)($935291c440101c41$var$A11yText, {
        id: id
    }, isInitialFocus && ScreenReaderText), (0, $byn9U.jsx)($935291c440101c41$var$A11yText, {
        "aria-live": ariaLive,
        "aria-atomic": "false",
        "aria-relevant": "additions text"
    }, isFocused && !isInitialFocus && ScreenReaderText));
};
var $935291c440101c41$var$diacritics = [
    {
        base: 'A',
        letters: "A\u24B6\uFF21\xC0\xC1\xC2\u1EA6\u1EA4\u1EAA\u1EA8\xC3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xC4\u01DE\u1EA2\xC5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
    },
    {
        base: 'AA',
        letters: "\uA732"
    },
    {
        base: 'AE',
        letters: "\xC6\u01FC\u01E2"
    },
    {
        base: 'AO',
        letters: "\uA734"
    },
    {
        base: 'AU',
        letters: "\uA736"
    },
    {
        base: 'AV',
        letters: "\uA738\uA73A"
    },
    {
        base: 'AY',
        letters: "\uA73C"
    },
    {
        base: 'B',
        letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
    },
    {
        base: 'C',
        letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xC7\u1E08\u0187\u023B\uA73E"
    },
    {
        base: 'D',
        letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779"
    },
    {
        base: 'DZ',
        letters: "\u01F1\u01C4"
    },
    {
        base: 'Dz',
        letters: "\u01F2\u01C5"
    },
    {
        base: 'E',
        letters: "E\u24BA\uFF25\xC8\xC9\xCA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xCB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
    },
    {
        base: 'F',
        letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
    },
    {
        base: 'G',
        letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
    },
    {
        base: 'H',
        letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
    },
    {
        base: 'I',
        letters: "I\u24BE\uFF29\xCC\xCD\xCE\u0128\u012A\u012C\u0130\xCF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
    },
    {
        base: 'J',
        letters: "J\u24BF\uFF2A\u0134\u0248"
    },
    {
        base: 'K',
        letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
    },
    {
        base: 'L',
        letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
    },
    {
        base: 'LJ',
        letters: "\u01C7"
    },
    {
        base: 'Lj',
        letters: "\u01C8"
    },
    {
        base: 'M',
        letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
    },
    {
        base: 'N',
        letters: "N\u24C3\uFF2E\u01F8\u0143\xD1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
    },
    {
        base: 'NJ',
        letters: "\u01CA"
    },
    {
        base: 'Nj',
        letters: "\u01CB"
    },
    {
        base: 'O',
        letters: "O\u24C4\uFF2F\xD2\xD3\xD4\u1ED2\u1ED0\u1ED6\u1ED4\xD5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xD6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xD8\u01FE\u0186\u019F\uA74A\uA74C"
    },
    {
        base: 'OI',
        letters: "\u01A2"
    },
    {
        base: 'OO',
        letters: "\uA74E"
    },
    {
        base: 'OU',
        letters: "\u0222"
    },
    {
        base: 'P',
        letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
    },
    {
        base: 'Q',
        letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
    },
    {
        base: 'R',
        letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
    },
    {
        base: 'S',
        letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
    },
    {
        base: 'T',
        letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
    },
    {
        base: 'TZ',
        letters: "\uA728"
    },
    {
        base: 'U',
        letters: "U\u24CA\uFF35\xD9\xDA\xDB\u0168\u1E78\u016A\u1E7A\u016C\xDC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
    },
    {
        base: 'V',
        letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
    },
    {
        base: 'VY',
        letters: "\uA760"
    },
    {
        base: 'W',
        letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
    },
    {
        base: 'X',
        letters: "X\u24CD\uFF38\u1E8A\u1E8C"
    },
    {
        base: 'Y',
        letters: "Y\u24CE\uFF39\u1EF2\xDD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
    },
    {
        base: 'Z',
        letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
    },
    {
        base: 'a',
        letters: "a\u24D0\uFF41\u1E9A\xE0\xE1\xE2\u1EA7\u1EA5\u1EAB\u1EA9\xE3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xE4\u01DF\u1EA3\xE5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
    },
    {
        base: 'aa',
        letters: "\uA733"
    },
    {
        base: 'ae',
        letters: "\xE6\u01FD\u01E3"
    },
    {
        base: 'ao',
        letters: "\uA735"
    },
    {
        base: 'au',
        letters: "\uA737"
    },
    {
        base: 'av',
        letters: "\uA739\uA73B"
    },
    {
        base: 'ay',
        letters: "\uA73D"
    },
    {
        base: 'b',
        letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
    },
    {
        base: 'c',
        letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xE7\u1E09\u0188\u023C\uA73F\u2184"
    },
    {
        base: 'd',
        letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
    },
    {
        base: 'dz',
        letters: "\u01F3\u01C6"
    },
    {
        base: 'e',
        letters: "e\u24D4\uFF45\xE8\xE9\xEA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xEB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
    },
    {
        base: 'f',
        letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
    },
    {
        base: 'g',
        letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
    },
    {
        base: 'h',
        letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
    },
    {
        base: 'hv',
        letters: "\u0195"
    },
    {
        base: 'i',
        letters: "i\u24D8\uFF49\xEC\xED\xEE\u0129\u012B\u012D\xEF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
    },
    {
        base: 'j',
        letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
    },
    {
        base: 'k',
        letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
    },
    {
        base: 'l',
        letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
    },
    {
        base: 'lj',
        letters: "\u01C9"
    },
    {
        base: 'm',
        letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
    },
    {
        base: 'n',
        letters: "n\u24DD\uFF4E\u01F9\u0144\xF1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
    },
    {
        base: 'nj',
        letters: "\u01CC"
    },
    {
        base: 'o',
        letters: "o\u24DE\uFF4F\xF2\xF3\xF4\u1ED3\u1ED1\u1ED7\u1ED5\xF5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xF6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xF8\u01FF\u0254\uA74B\uA74D\u0275"
    },
    {
        base: 'oi',
        letters: "\u01A3"
    },
    {
        base: 'ou',
        letters: "\u0223"
    },
    {
        base: 'oo',
        letters: "\uA74F"
    },
    {
        base: 'p',
        letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
    },
    {
        base: 'q',
        letters: "q\u24E0\uFF51\u024B\uA757\uA759"
    },
    {
        base: 'r',
        letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
    },
    {
        base: 's',
        letters: "s\u24E2\uFF53\xDF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
    },
    {
        base: 't',
        letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
    },
    {
        base: 'tz',
        letters: "\uA729"
    },
    {
        base: 'u',
        letters: "u\u24E4\uFF55\xF9\xFA\xFB\u0169\u1E79\u016B\u1E7B\u016D\xFC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
    },
    {
        base: 'v',
        letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
    },
    {
        base: 'vy',
        letters: "\uA761"
    },
    {
        base: 'w',
        letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
    },
    {
        base: 'x',
        letters: "x\u24E7\uFF58\u1E8B\u1E8D"
    },
    {
        base: 'y',
        letters: "y\u24E8\uFF59\u1EF3\xFD\u0177\u1EF9\u0233\u1E8F\xFF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
    },
    {
        base: 'z',
        letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
    }
];
var $935291c440101c41$var$anyDiacritic = new RegExp('[' + $935291c440101c41$var$diacritics.map(function(d) {
    return d.letters;
}).join('') + ']', 'g');
var $935291c440101c41$var$diacriticToBase = {};
for(var $935291c440101c41$var$i = 0; $935291c440101c41$var$i < $935291c440101c41$var$diacritics.length; $935291c440101c41$var$i++){
    var $935291c440101c41$var$diacritic = $935291c440101c41$var$diacritics[$935291c440101c41$var$i];
    for(var $935291c440101c41$var$j = 0; $935291c440101c41$var$j < $935291c440101c41$var$diacritic.letters.length; $935291c440101c41$var$j++)$935291c440101c41$var$diacriticToBase[$935291c440101c41$var$diacritic.letters[$935291c440101c41$var$j]] = $935291c440101c41$var$diacritic.base;
}
var $935291c440101c41$var$stripDiacritics = function stripDiacritics(str) {
    return str.replace($935291c440101c41$var$anyDiacritic, function(match) {
        return $935291c440101c41$var$diacriticToBase[match];
    });
};
var $935291c440101c41$var$memoizedStripDiacriticsForInput = (0, $5iWql.default)($935291c440101c41$var$stripDiacritics);
var $935291c440101c41$var$trimString = function trimString(str) {
    return str.replace(/^\s+|\s+$/g, '');
};
var $935291c440101c41$var$defaultStringify = function defaultStringify(option) {
    return "".concat(option.label, " ").concat(option.value);
};
var $935291c440101c41$export$db3b6bfb95261072 = function createFilter(config) {
    return function(option, rawInput) {
        // eslint-disable-next-line no-underscore-dangle
        if (option.data.__isNew__) return true;
        var _ignoreCase$ignoreAcc = (0, $1Xn5q.default)({
            ignoreCase: true,
            ignoreAccents: true,
            stringify: $935291c440101c41$var$defaultStringify,
            trim: true,
            matchFrom: 'any'
        }, config), ignoreCase = _ignoreCase$ignoreAcc.ignoreCase, ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents, stringify = _ignoreCase$ignoreAcc.stringify, trim = _ignoreCase$ignoreAcc.trim, matchFrom = _ignoreCase$ignoreAcc.matchFrom;
        var input = trim ? $935291c440101c41$var$trimString(rawInput) : rawInput;
        var candidate = trim ? $935291c440101c41$var$trimString(stringify(option)) : stringify(option);
        if (ignoreCase) {
            input = input.toLowerCase();
            candidate = candidate.toLowerCase();
        }
        if (ignoreAccents) {
            input = $935291c440101c41$var$memoizedStripDiacriticsForInput(input);
            candidate = $935291c440101c41$var$stripDiacritics(candidate);
        }
        return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
    };
};
var $935291c440101c41$var$_excluded = [
    "innerRef"
];
function $935291c440101c41$var$DummyInput(_ref) {
    var innerRef = _ref.innerRef, props = (0, $bwPfh.default)(_ref, $935291c440101c41$var$_excluded);
    // Remove animation props not meant for HTML elements
    var filteredProps = (0, $jQxSL.r)(props, 'onExited', 'in', 'enter', 'exit', 'appear');
    return (0, $byn9U.jsx)("input", (0, $kU09D.default)({
        ref: innerRef
    }, filteredProps, {
        css: /*#__PURE__*/ (0, $byn9U.css)({
            label: 'dummyInput',
            // get rid of any default styles
            background: 0,
            border: 0,
            // important! this hides the flashing cursor
            caretColor: 'transparent',
            fontSize: 'inherit',
            gridArea: '1 / 1 / 2 / 3',
            outline: 0,
            padding: 0,
            // important! without `width` browsers won't allow focus
            width: 1,
            // remove cursor on desktop
            color: 'transparent',
            // remove cursor on mobile whilst maintaining "scroll into view" behaviour
            left: -100,
            opacity: 0,
            position: 'relative',
            transform: 'scale(.01)'
        }, "", "")
    }));
}
var $935291c440101c41$var$cancelScroll = function cancelScroll(event) {
    event.preventDefault();
    event.stopPropagation();
};
function $935291c440101c41$var$useScrollCapture(_ref) {
    var isEnabled = _ref.isEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var isBottom = (0, $eUqFw.useRef)(false);
    var isTop = (0, $eUqFw.useRef)(false);
    var touchStart = (0, $eUqFw.useRef)(0);
    var scrollTarget = (0, $eUqFw.useRef)(null);
    var handleEventDelta = (0, $eUqFw.useCallback)(function(event, delta) {
        if (scrollTarget.current === null) return;
        var _scrollTarget$current = scrollTarget.current, scrollTop = _scrollTarget$current.scrollTop, scrollHeight = _scrollTarget$current.scrollHeight, clientHeight = _scrollTarget$current.clientHeight;
        var target = scrollTarget.current;
        var isDeltaPositive = delta > 0;
        var availableScroll = scrollHeight - clientHeight - scrollTop;
        var shouldCancelScroll = false;
        // reset bottom/top flags
        if (availableScroll > delta && isBottom.current) {
            if (onBottomLeave) onBottomLeave(event);
            isBottom.current = false;
        }
        if (isDeltaPositive && isTop.current) {
            if (onTopLeave) onTopLeave(event);
            isTop.current = false;
        }
        // bottom limit
        if (isDeltaPositive && delta > availableScroll) {
            if (onBottomArrive && !isBottom.current) onBottomArrive(event);
            target.scrollTop = scrollHeight;
            shouldCancelScroll = true;
            isBottom.current = true;
        // top limit
        } else if (!isDeltaPositive && -delta > scrollTop) {
            if (onTopArrive && !isTop.current) onTopArrive(event);
            target.scrollTop = 0;
            shouldCancelScroll = true;
            isTop.current = true;
        }
        // cancel scroll
        if (shouldCancelScroll) $935291c440101c41$var$cancelScroll(event);
    }, [
        onBottomArrive,
        onBottomLeave,
        onTopArrive,
        onTopLeave
    ]);
    var onWheel = (0, $eUqFw.useCallback)(function(event) {
        handleEventDelta(event, event.deltaY);
    }, [
        handleEventDelta
    ]);
    var onTouchStart = (0, $eUqFw.useCallback)(function(event) {
        // set touch start so we can calculate touchmove delta
        touchStart.current = event.changedTouches[0].clientY;
    }, []);
    var onTouchMove = (0, $eUqFw.useCallback)(function(event) {
        var deltaY = touchStart.current - event.changedTouches[0].clientY;
        handleEventDelta(event, deltaY);
    }, [
        handleEventDelta
    ]);
    var startListening = (0, $eUqFw.useCallback)(function(el) {
        // bail early if no element is available to attach to
        if (!el) return;
        var notPassive = (0, $jQxSL.s) ? {
            passive: false
        } : false;
        el.addEventListener('wheel', onWheel, notPassive);
        el.addEventListener('touchstart', onTouchStart, notPassive);
        el.addEventListener('touchmove', onTouchMove, notPassive);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    var stopListening = (0, $eUqFw.useCallback)(function(el) {
        // bail early if no element is available to detach from
        if (!el) return;
        el.removeEventListener('wheel', onWheel, false);
        el.removeEventListener('touchstart', onTouchStart, false);
        el.removeEventListener('touchmove', onTouchMove, false);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    (0, $eUqFw.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        startListening(element);
        return function() {
            stopListening(element);
        };
    }, [
        isEnabled,
        startListening,
        stopListening
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
var $935291c440101c41$var$STYLE_KEYS = [
    'boxSizing',
    'height',
    'overflow',
    'paddingRight',
    'position'
];
var $935291c440101c41$var$LOCK_STYLES = {
    boxSizing: 'border-box',
    // account for possible declaration `width: 100%;` on body
    overflow: 'hidden',
    position: 'relative',
    height: '100%'
};
function $935291c440101c41$var$preventTouchMove(e) {
    e.preventDefault();
}
function $935291c440101c41$var$allowTouchMove(e) {
    e.stopPropagation();
}
function $935291c440101c41$var$preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $935291c440101c41$var$isTouchDevice() {
    return 'ontouchstart' in window || navigator.maxTouchPoints;
}
var $935291c440101c41$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
var $935291c440101c41$var$activeScrollLocks = 0;
var $935291c440101c41$var$listenerOptions = {
    capture: false,
    passive: false
};
function $935291c440101c41$var$useScrollLock(_ref) {
    var isEnabled = _ref.isEnabled, _ref$accountForScroll = _ref.accountForScrollbars, accountForScrollbars = _ref$accountForScroll === void 0 ? true : _ref$accountForScroll;
    var originalStyles = (0, $eUqFw.useRef)({});
    var scrollTarget = (0, $eUqFw.useRef)(null);
    var addScrollLock = (0, $eUqFw.useCallback)(function(touchScrollTarget) {
        if (!$935291c440101c41$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        if (accountForScrollbars) // store any styles already applied to the body
        $935291c440101c41$var$STYLE_KEYS.forEach(function(key) {
            var val = targetStyle && targetStyle[key];
            originalStyles.current[key] = val;
        });
        // apply the lock styles and padding if this is the first scroll lock
        if (accountForScrollbars && $935291c440101c41$var$activeScrollLocks < 1) {
            var currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
            var clientWidth = document.body ? document.body.clientWidth : 0;
            var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
            Object.keys($935291c440101c41$var$LOCK_STYLES).forEach(function(key) {
                var val = $935291c440101c41$var$LOCK_STYLES[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (targetStyle) targetStyle.paddingRight = "".concat(adjustedPadding, "px");
        }
        // account for touch devices
        if (target && $935291c440101c41$var$isTouchDevice()) {
            // Mobile Safari ignores { overflow: hidden } declaration on the body.
            target.addEventListener('touchmove', $935291c440101c41$var$preventTouchMove, $935291c440101c41$var$listenerOptions);
            // Allow scroll on provided target
            if (touchScrollTarget) {
                touchScrollTarget.addEventListener('touchstart', $935291c440101c41$var$preventInertiaScroll, $935291c440101c41$var$listenerOptions);
                touchScrollTarget.addEventListener('touchmove', $935291c440101c41$var$allowTouchMove, $935291c440101c41$var$listenerOptions);
            }
        }
        // increment active scroll locks
        $935291c440101c41$var$activeScrollLocks += 1;
    }, [
        accountForScrollbars
    ]);
    var removeScrollLock = (0, $eUqFw.useCallback)(function(touchScrollTarget) {
        if (!$935291c440101c41$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        // safely decrement active scroll locks
        $935291c440101c41$var$activeScrollLocks = Math.max($935291c440101c41$var$activeScrollLocks - 1, 0);
        // reapply original body styles, if any
        if (accountForScrollbars && $935291c440101c41$var$activeScrollLocks < 1) $935291c440101c41$var$STYLE_KEYS.forEach(function(key) {
            var val = originalStyles.current[key];
            if (targetStyle) targetStyle[key] = val;
        });
        // remove touch listeners
        if (target && $935291c440101c41$var$isTouchDevice()) {
            target.removeEventListener('touchmove', $935291c440101c41$var$preventTouchMove, $935291c440101c41$var$listenerOptions);
            if (touchScrollTarget) {
                touchScrollTarget.removeEventListener('touchstart', $935291c440101c41$var$preventInertiaScroll, $935291c440101c41$var$listenerOptions);
                touchScrollTarget.removeEventListener('touchmove', $935291c440101c41$var$allowTouchMove, $935291c440101c41$var$listenerOptions);
            }
        }
    }, [
        accountForScrollbars
    ]);
    (0, $eUqFw.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        addScrollLock(element);
        return function() {
            removeScrollLock(element);
        };
    }, [
        isEnabled,
        addScrollLock,
        removeScrollLock
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
function $935291c440101c41$var$_EMOTION_STRINGIFIED_CSS_ERROR__$1() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $935291c440101c41$var$blurSelectInput = function blurSelectInput() {
    return document.activeElement && document.activeElement.blur();
};
var $935291c440101c41$var$_ref2$1 = {
    name: "1kfdb0e",
    styles: "position:fixed;left:0;bottom:0;right:0;top:0"
};
function $935291c440101c41$var$ScrollManager(_ref) {
    var children = _ref.children, lockEnabled = _ref.lockEnabled, _ref$captureEnabled = _ref.captureEnabled, captureEnabled = _ref$captureEnabled === void 0 ? true : _ref$captureEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var setScrollCaptureTarget = $935291c440101c41$var$useScrollCapture({
        isEnabled: captureEnabled,
        onBottomArrive: onBottomArrive,
        onBottomLeave: onBottomLeave,
        onTopArrive: onTopArrive,
        onTopLeave: onTopLeave
    });
    var setScrollLockTarget = $935291c440101c41$var$useScrollLock({
        isEnabled: lockEnabled
    });
    var targetRef = function targetRef(element) {
        setScrollCaptureTarget(element);
        setScrollLockTarget(element);
    };
    return (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, lockEnabled && (0, $byn9U.jsx)("div", {
        onClick: $935291c440101c41$var$blurSelectInput,
        css: $935291c440101c41$var$_ref2$1
    }), children(targetRef));
}
function $935291c440101c41$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $935291c440101c41$var$_ref2 = {
    name: "1a0ro4n-requiredInput",
    styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%"
};
var $935291c440101c41$var$RequiredInput = function RequiredInput(_ref) {
    var name = _ref.name, onFocus = _ref.onFocus;
    return (0, $byn9U.jsx)("input", {
        required: true,
        name: name,
        tabIndex: -1,
        "aria-hidden": "true",
        onFocus: onFocus,
        css: $935291c440101c41$var$_ref2,
        value: "",
        onChange: function onChange() {}
    });
};
var $935291c440101c41$var$formatGroupLabel = function formatGroupLabel(group) {
    return group.label;
};
var $935291c440101c41$export$8b22cf2602fb60ce = function getOptionLabel(option) {
    return option.label;
};
var $935291c440101c41$export$39b482c5e57630a8 = function getOptionValue(option) {
    return option.value;
};
var $935291c440101c41$var$isOptionDisabled = function isOptionDisabled(option) {
    return !!option.isDisabled;
};
var $935291c440101c41$var$defaultStyles = {
    clearIndicator: (0, $jQxSL.a),
    container: (0, $jQxSL.b),
    control: (0, $jQxSL.d),
    dropdownIndicator: (0, $jQxSL.e),
    group: (0, $jQxSL.g),
    groupHeading: (0, $jQxSL.f),
    indicatorsContainer: (0, $jQxSL.i),
    indicatorSeparator: (0, $jQxSL.h),
    input: (0, $jQxSL.j),
    loadingIndicator: (0, $jQxSL.l),
    loadingMessage: (0, $jQxSL.k),
    menu: (0, $jQxSL.m),
    menuList: (0, $jQxSL.n),
    menuPortal: (0, $jQxSL.o),
    multiValue: (0, $jQxSL.p),
    multiValueLabel: (0, $jQxSL.q),
    multiValueRemove: (0, $jQxSL.t),
    noOptionsMessage: (0, $jQxSL.u),
    option: (0, $jQxSL.v),
    placeholder: (0, $jQxSL.w),
    singleValue: (0, $jQxSL.x),
    valueContainer: (0, $jQxSL.y)
};
// Merge Utility
// Allows consumers to extend a base Select with additional styles
function $935291c440101c41$export$953cecd6e717a553(source) {
    var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // initialize with source styles
    var styles = (0, $1Xn5q.default)({}, source);
    // massage in target styles
    Object.keys(target).forEach(function(keyAsString) {
        var key = keyAsString;
        if (source[key]) styles[key] = function(rsCss, props) {
            return target[key](source[key](rsCss, props), props);
        };
        else styles[key] = target[key];
    });
    return styles;
}
var $935291c440101c41$var$colors = {
    primary: '#2684FF',
    primary75: '#4C9AFF',
    primary50: '#B2D4FF',
    primary25: '#DEEBFF',
    danger: '#DE350B',
    dangerLight: '#FFBDAD',
    neutral0: 'hsl(0, 0%, 100%)',
    neutral5: 'hsl(0, 0%, 95%)',
    neutral10: 'hsl(0, 0%, 90%)',
    neutral20: 'hsl(0, 0%, 80%)',
    neutral30: 'hsl(0, 0%, 70%)',
    neutral40: 'hsl(0, 0%, 60%)',
    neutral50: 'hsl(0, 0%, 50%)',
    neutral60: 'hsl(0, 0%, 40%)',
    neutral70: 'hsl(0, 0%, 30%)',
    neutral80: 'hsl(0, 0%, 20%)',
    neutral90: 'hsl(0, 0%, 10%)'
};
var $935291c440101c41$var$borderRadius = 4;
// Used to calculate consistent margin/padding on elements
var $935291c440101c41$var$baseUnit = 4;
// The minimum height of the control
var $935291c440101c41$var$controlHeight = 38;
// The amount of space between the control and menu */
var $935291c440101c41$var$menuGutter = $935291c440101c41$var$baseUnit * 2;
var $935291c440101c41$var$spacing = {
    baseUnit: $935291c440101c41$var$baseUnit,
    controlHeight: $935291c440101c41$var$controlHeight,
    menuGutter: $935291c440101c41$var$menuGutter
};
var $935291c440101c41$export$4368d992c4eafac0 = {
    borderRadius: $935291c440101c41$var$borderRadius,
    colors: $935291c440101c41$var$colors,
    spacing: $935291c440101c41$var$spacing
};
var $935291c440101c41$export$407448d2b89b1813 = {
    'aria-live': 'polite',
    backspaceRemovesValue: true,
    blurInputOnSelect: (0, $jQxSL.z)(),
    captureMenuScroll: !(0, $jQxSL.z)(),
    classNames: {},
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    components: {},
    controlShouldRenderValue: true,
    escapeClearsValue: false,
    filterOption: $935291c440101c41$export$db3b6bfb95261072(),
    formatGroupLabel: $935291c440101c41$var$formatGroupLabel,
    getOptionLabel: $935291c440101c41$export$8b22cf2602fb60ce,
    getOptionValue: $935291c440101c41$export$39b482c5e57630a8,
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isRtl: false,
    isSearchable: true,
    isOptionDisabled: $935291c440101c41$var$isOptionDisabled,
    loadingMessage: function loadingMessage() {
        return 'Loading...';
    },
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: false,
    menuPlacement: 'bottom',
    menuPosition: 'absolute',
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: !(0, $jQxSL.A)(),
    noOptionsMessage: function noOptionsMessage() {
        return 'No options';
    },
    openMenuOnFocus: false,
    openMenuOnClick: true,
    options: [],
    pageSize: 5,
    placeholder: 'Select...',
    screenReaderStatus: function screenReaderStatus(_ref) {
        var count = _ref.count;
        return "".concat(count, " result").concat(count !== 1 ? 's' : '', " available");
    },
    styles: {},
    tabIndex: 0,
    tabSelectsValue: true,
    unstyled: false
};
function $935291c440101c41$var$toCategorizedOption(props, option, selectValue, index) {
    var isDisabled = $935291c440101c41$var$_isOptionDisabled(props, option, selectValue);
    var isSelected = $935291c440101c41$var$_isOptionSelected(props, option, selectValue);
    var label = $935291c440101c41$var$getOptionLabel(props, option);
    var value = $935291c440101c41$var$getOptionValue(props, option);
    return {
        type: 'option',
        data: option,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        value: value,
        index: index
    };
}
function $935291c440101c41$var$buildCategorizedOptions(props, selectValue) {
    return props.options.map(function(groupOrOption, groupOrOptionIndex) {
        if ('options' in groupOrOption) {
            var categorizedOptions = groupOrOption.options.map(function(option, optionIndex) {
                return $935291c440101c41$var$toCategorizedOption(props, option, selectValue, optionIndex);
            }).filter(function(categorizedOption) {
                return $935291c440101c41$var$isFocusable(props, categorizedOption);
            });
            return categorizedOptions.length > 0 ? {
                type: 'group',
                data: groupOrOption,
                options: categorizedOptions,
                index: groupOrOptionIndex
            } : undefined;
        }
        var categorizedOption = $935291c440101c41$var$toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
        return $935291c440101c41$var$isFocusable(props, categorizedOption) ? categorizedOption : undefined;
    }).filter((0, $jQxSL.G));
}
function $935291c440101c41$var$buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === 'group') optionsAccumulator.push.apply(optionsAccumulator, (0, $fVK4C.default)(categorizedOption.options.map(function(option) {
            return option.data;
        })));
        else optionsAccumulator.push(categorizedOption.data);
        return optionsAccumulator;
    }, []);
}
function $935291c440101c41$var$buildFocusableOptions(props, selectValue) {
    return $935291c440101c41$var$buildFocusableOptionsFromCategorizedOptions($935291c440101c41$var$buildCategorizedOptions(props, selectValue));
}
function $935291c440101c41$var$isFocusable(props, categorizedOption) {
    var _props$inputValue = props.inputValue, inputValue = _props$inputValue === void 0 ? '' : _props$inputValue;
    var data = categorizedOption.data, isSelected = categorizedOption.isSelected, label = categorizedOption.label, value = categorizedOption.value;
    return (!$935291c440101c41$var$shouldHideSelectedOptions(props) || !isSelected) && $935291c440101c41$var$_filterOption(props, {
        label: label,
        value: value,
        data: data
    }, inputValue);
}
function $935291c440101c41$var$getNextFocusedValue(state, nextSelectValue) {
    var focusedValue = state.focusedValue, lastSelectValue = state.selectValue;
    var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
    if (lastFocusedIndex > -1) {
        var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
        if (nextFocusedIndex > -1) // the focused value is still in the selectValue, return it
        return focusedValue;
        else if (lastFocusedIndex < nextSelectValue.length) // the focusedValue is not present in the next selectValue array by
        // reference, so return the new value at the same index
        return nextSelectValue[lastFocusedIndex];
    }
    return null;
}
function $935291c440101c41$var$getNextFocusedOption(state, options) {
    var lastFocusedOption = state.focusedOption;
    return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
var $935291c440101c41$var$getOptionLabel = function getOptionLabel(props, data) {
    return props.getOptionLabel(data);
};
var $935291c440101c41$var$getOptionValue = function getOptionValue(props, data) {
    return props.getOptionValue(data);
};
function $935291c440101c41$var$_isOptionDisabled(props, option, selectValue) {
    return typeof props.isOptionDisabled === 'function' ? props.isOptionDisabled(option, selectValue) : false;
}
function $935291c440101c41$var$_isOptionSelected(props, option, selectValue) {
    if (selectValue.indexOf(option) > -1) return true;
    if (typeof props.isOptionSelected === 'function') return props.isOptionSelected(option, selectValue);
    var candidate = $935291c440101c41$var$getOptionValue(props, option);
    return selectValue.some(function(i) {
        return $935291c440101c41$var$getOptionValue(props, i) === candidate;
    });
}
function $935291c440101c41$var$_filterOption(props, option, inputValue) {
    return props.filterOption ? props.filterOption(option, inputValue) : true;
}
var $935291c440101c41$var$shouldHideSelectedOptions = function shouldHideSelectedOptions(props) {
    var hideSelectedOptions = props.hideSelectedOptions, isMulti = props.isMulti;
    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
};
var $935291c440101c41$var$instanceId = 1;
var $935291c440101c41$export$25ce5a424b770e84 = /*#__PURE__*/ function(_Component) {
    (0, $eT4IF.default)(Select, _Component);
    var _super = (0, $7Dzgl.default)(Select);
    // Misc. Instance Properties
    // ------------------------------
    // TODO
    // Refs
    // ------------------------------
    // Lifecycle
    // ------------------------------
    function Select(_props) {
        var _this;
        (0, $lDSrn.default)(this, Select);
        _this = _super.call(this, _props);
        _this.state = {
            ariaSelection: null,
            focusedOption: null,
            focusedValue: null,
            inputIsHidden: false,
            isFocused: false,
            selectValue: [],
            clearFocusValueOnUpdate: false,
            prevWasFocused: false,
            inputIsHiddenAfterUpdate: undefined,
            prevProps: undefined
        };
        _this.blockOptionHover = false;
        _this.isComposing = false;
        _this.commonProps = void 0;
        _this.initialTouchX = 0;
        _this.initialTouchY = 0;
        _this.instancePrefix = '';
        _this.openAfterFocus = false;
        _this.scrollToFocusedOptionOnUpdate = false;
        _this.userIsDragging = void 0;
        _this.controlRef = null;
        _this.getControlRef = function(ref) {
            _this.controlRef = ref;
        };
        _this.focusedOptionRef = null;
        _this.getFocusedOptionRef = function(ref) {
            _this.focusedOptionRef = ref;
        };
        _this.menuListRef = null;
        _this.getMenuListRef = function(ref) {
            _this.menuListRef = ref;
        };
        _this.inputRef = null;
        _this.getInputRef = function(ref) {
            _this.inputRef = ref;
        };
        _this.focus = _this.focusInput;
        _this.blur = _this.blurInput;
        _this.onChange = function(newValue, actionMeta) {
            var _this$props = _this.props, onChange = _this$props.onChange, name = _this$props.name;
            actionMeta.name = name;
            _this.ariaOnChange(newValue, actionMeta);
            onChange(newValue, actionMeta);
        };
        _this.setValue = function(newValue, action, option) {
            var _this$props2 = _this.props, closeMenuOnSelect = _this$props2.closeMenuOnSelect, isMulti = _this$props2.isMulti, inputValue = _this$props2.inputValue;
            _this.onInputChange('', {
                action: 'set-value',
                prevInputValue: inputValue
            });
            if (closeMenuOnSelect) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            }
            // when the select value should change, we should reset focusedValue
            _this.setState({
                clearFocusValueOnUpdate: true
            });
            _this.onChange(newValue, {
                action: action,
                option: option
            });
        };
        _this.selectOption = function(newValue) {
            var _this$props3 = _this.props, blurInputOnSelect = _this$props3.blurInputOnSelect, isMulti = _this$props3.isMulti, name = _this$props3.name;
            var selectValue = _this.state.selectValue;
            var deselected = isMulti && _this.isOptionSelected(newValue, selectValue);
            var isDisabled = _this.isOptionDisabled(newValue, selectValue);
            if (deselected) {
                var candidate = _this.getOptionValue(newValue);
                _this.setValue((0, $jQxSL.B)(selectValue.filter(function(i) {
                    return _this.getOptionValue(i) !== candidate;
                })), 'deselect-option', newValue);
            } else if (!isDisabled) {
                // Select option if option is not disabled
                if (isMulti) _this.setValue((0, $jQxSL.B)([].concat((0, $fVK4C.default)(selectValue), [
                    newValue
                ])), 'select-option', newValue);
                else _this.setValue((0, $jQxSL.C)(newValue), 'select-option');
            } else {
                _this.ariaOnChange((0, $jQxSL.C)(newValue), {
                    action: 'select-option',
                    option: newValue,
                    name: name
                });
                return;
            }
            if (blurInputOnSelect) _this.blurInput();
        };
        _this.removeValue = function(removedValue) {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var candidate = _this.getOptionValue(removedValue);
            var newValueArray = selectValue.filter(function(i) {
                return _this.getOptionValue(i) !== candidate;
            });
            var newValue = (0, $jQxSL.D)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: 'remove-value',
                removedValue: removedValue
            });
            _this.focusInput();
        };
        _this.clearValue = function() {
            var selectValue = _this.state.selectValue;
            _this.onChange((0, $jQxSL.D)(_this.props.isMulti, [], null), {
                action: 'clear',
                removedValues: selectValue
            });
        };
        _this.popValue = function() {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var lastSelectedValue = selectValue[selectValue.length - 1];
            var newValueArray = selectValue.slice(0, selectValue.length - 1);
            var newValue = (0, $jQxSL.D)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: 'pop-value',
                removedValue: lastSelectedValue
            });
        };
        _this.getValue = function() {
            return _this.state.selectValue;
        };
        _this.cx = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return (0, $jQxSL.E).apply(void 0, [
                _this.props.classNamePrefix
            ].concat(args));
        };
        _this.getOptionLabel = function(data) {
            return $935291c440101c41$var$getOptionLabel(_this.props, data);
        };
        _this.getOptionValue = function(data) {
            return $935291c440101c41$var$getOptionValue(_this.props, data);
        };
        _this.getStyles = function(key, props) {
            var unstyled = _this.props.unstyled;
            var base = $935291c440101c41$var$defaultStyles[key](props, unstyled);
            base.boxSizing = 'border-box';
            var custom = _this.props.styles[key];
            return custom ? custom(base, props) : base;
        };
        _this.getClassNames = function(key, props) {
            var _this$props$className, _this$props$className2;
            return (_this$props$className = (_this$props$className2 = _this.props.classNames)[key]) === null || _this$props$className === void 0 ? void 0 : _this$props$className.call(_this$props$className2, props);
        };
        _this.getElementId = function(element) {
            return "".concat(_this.instancePrefix, "-").concat(element);
        };
        _this.getComponents = function() {
            return (0, $jQxSL.F)(_this.props);
        };
        _this.buildCategorizedOptions = function() {
            return $935291c440101c41$var$buildCategorizedOptions(_this.props, _this.state.selectValue);
        };
        _this.getCategorizedOptions = function() {
            return _this.props.menuIsOpen ? _this.buildCategorizedOptions() : [];
        };
        _this.buildFocusableOptions = function() {
            return $935291c440101c41$var$buildFocusableOptionsFromCategorizedOptions(_this.buildCategorizedOptions());
        };
        _this.getFocusableOptions = function() {
            return _this.props.menuIsOpen ? _this.buildFocusableOptions() : [];
        };
        _this.ariaOnChange = function(value, actionMeta) {
            _this.setState({
                ariaSelection: (0, $1Xn5q.default)({
                    value: value
                }, actionMeta)
            });
        };
        _this.onMenuMouseDown = function(event) {
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
            _this.focusInput();
        };
        _this.onMenuMouseMove = function(event) {
            _this.blockOptionHover = false;
        };
        _this.onControlMouseDown = function(event) {
            var openMenuOnClick = _this.props.openMenuOnClick;
            if (!_this.state.isFocused) {
                if (openMenuOnClick) _this.openAfterFocus = true;
                _this.focusInput();
            } else if (!_this.props.menuIsOpen) {
                if (openMenuOnClick) _this.openMenu('first');
            } else if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') _this.onMenuClose();
            if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') event.preventDefault();
        };
        _this.onDropdownIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            if (_this.props.isDisabled) return;
            var _this$props4 = _this.props, isMulti = _this$props4.isMulti, menuIsOpen = _this$props4.menuIsOpen;
            _this.focusInput();
            if (menuIsOpen) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            } else _this.openMenu('first');
            event.preventDefault();
            event.stopPropagation();
        };
        _this.onClearIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            _this.clearValue();
            event.preventDefault();
            event.stopPropagation();
            _this.openAfterFocus = false;
            if (event.type === 'touchend') _this.focusInput();
            else setTimeout(function() {
                return _this.focusInput();
            });
        };
        _this.onScroll = function(event) {
            if (typeof _this.props.closeMenuOnScroll === 'boolean') {
                if (event.target instanceof HTMLElement && (0, $jQxSL.H)(event.target)) _this.props.onMenuClose();
            } else if (typeof _this.props.closeMenuOnScroll === 'function') {
                if (_this.props.closeMenuOnScroll(event)) _this.props.onMenuClose();
            }
        };
        _this.onCompositionStart = function() {
            _this.isComposing = true;
        };
        _this.onCompositionEnd = function() {
            _this.isComposing = false;
        };
        _this.onTouchStart = function(_ref2) {
            var touches = _ref2.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            _this.initialTouchX = touch.clientX;
            _this.initialTouchY = touch.clientY;
            _this.userIsDragging = false;
        };
        _this.onTouchMove = function(_ref3) {
            var touches = _ref3.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
            var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
            var moveThreshold = 5;
            _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
        };
        _this.onTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            // close the menu if the user taps outside
            // we're checking on event.target here instead of event.currentTarget, because we want to assert information
            // on events on child elements, not the document (which we've attached this handler to).
            if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) _this.blurInput();
            // reset move vars
            _this.initialTouchX = 0;
            _this.initialTouchY = 0;
        };
        _this.onControlTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onControlMouseDown(event);
        };
        _this.onClearIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onClearIndicatorMouseDown(event);
        };
        _this.onDropdownIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onDropdownIndicatorMouseDown(event);
        };
        _this.handleInputChange = function(event) {
            var prevInputValue = _this.props.inputValue;
            var inputValue = event.currentTarget.value;
            _this.setState({
                inputIsHiddenAfterUpdate: false
            });
            _this.onInputChange(inputValue, {
                action: 'input-change',
                prevInputValue: prevInputValue
            });
            if (!_this.props.menuIsOpen) _this.onMenuOpen();
        };
        _this.onInputFocus = function(event) {
            if (_this.props.onFocus) _this.props.onFocus(event);
            _this.setState({
                inputIsHiddenAfterUpdate: false,
                isFocused: true
            });
            if (_this.openAfterFocus || _this.props.openMenuOnFocus) _this.openMenu('first');
            _this.openAfterFocus = false;
        };
        _this.onInputBlur = function(event) {
            var prevInputValue = _this.props.inputValue;
            if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
                _this.inputRef.focus();
                return;
            }
            if (_this.props.onBlur) _this.props.onBlur(event);
            _this.onInputChange('', {
                action: 'input-blur',
                prevInputValue: prevInputValue
            });
            _this.onMenuClose();
            _this.setState({
                focusedValue: null,
                isFocused: false
            });
        };
        _this.onOptionHover = function(focusedOption) {
            if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) return;
            _this.setState({
                focusedOption: focusedOption
            });
        };
        _this.shouldHideSelectedOptions = function() {
            return $935291c440101c41$var$shouldHideSelectedOptions(_this.props);
        };
        _this.onValueInputFocus = function(e) {
            e.preventDefault();
            e.stopPropagation();
            _this.focus();
        };
        _this.onKeyDown = function(event) {
            var _this$props5 = _this.props, isMulti = _this$props5.isMulti, backspaceRemovesValue = _this$props5.backspaceRemovesValue, escapeClearsValue = _this$props5.escapeClearsValue, inputValue = _this$props5.inputValue, isClearable = _this$props5.isClearable, isDisabled = _this$props5.isDisabled, menuIsOpen = _this$props5.menuIsOpen, onKeyDown = _this$props5.onKeyDown, tabSelectsValue = _this$props5.tabSelectsValue, openMenuOnFocus = _this$props5.openMenuOnFocus;
            var _this$state = _this.state, focusedOption = _this$state.focusedOption, focusedValue = _this$state.focusedValue, selectValue = _this$state.selectValue;
            if (isDisabled) return;
            if (typeof onKeyDown === 'function') {
                onKeyDown(event);
                if (event.defaultPrevented) return;
            }
            // Block option hover events when the user has just pressed a key
            _this.blockOptionHover = true;
            switch(event.key){
                case 'ArrowLeft':
                    if (!isMulti || inputValue) return;
                    _this.focusValue('previous');
                    break;
                case 'ArrowRight':
                    if (!isMulti || inputValue) return;
                    _this.focusValue('next');
                    break;
                case 'Delete':
                case 'Backspace':
                    if (inputValue) return;
                    if (focusedValue) _this.removeValue(focusedValue);
                    else {
                        if (!backspaceRemovesValue) return;
                        if (isMulti) _this.popValue();
                        else if (isClearable) _this.clearValue();
                    }
                    break;
                case 'Tab':
                    if (_this.isComposing) return;
                    if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
                    // option is already selected; it breaks the flow of navigation
                    openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) return;
                    _this.selectOption(focusedOption);
                    break;
                case 'Enter':
                    if (event.keyCode === 229) break;
                    if (menuIsOpen) {
                        if (!focusedOption) return;
                        if (_this.isComposing) return;
                        _this.selectOption(focusedOption);
                        break;
                    }
                    return;
                case 'Escape':
                    if (menuIsOpen) {
                        _this.setState({
                            inputIsHiddenAfterUpdate: false
                        });
                        _this.onInputChange('', {
                            action: 'menu-close',
                            prevInputValue: inputValue
                        });
                        _this.onMenuClose();
                    } else if (isClearable && escapeClearsValue) _this.clearValue();
                    break;
                case ' ':
                    // space
                    if (inputValue) return;
                    if (!menuIsOpen) {
                        _this.openMenu('first');
                        break;
                    }
                    if (!focusedOption) return;
                    _this.selectOption(focusedOption);
                    break;
                case 'ArrowUp':
                    if (menuIsOpen) _this.focusOption('up');
                    else _this.openMenu('last');
                    break;
                case 'ArrowDown':
                    if (menuIsOpen) _this.focusOption('down');
                    else _this.openMenu('first');
                    break;
                case 'PageUp':
                    if (!menuIsOpen) return;
                    _this.focusOption('pageup');
                    break;
                case 'PageDown':
                    if (!menuIsOpen) return;
                    _this.focusOption('pagedown');
                    break;
                case 'Home':
                    if (!menuIsOpen) return;
                    _this.focusOption('first');
                    break;
                case 'End':
                    if (!menuIsOpen) return;
                    _this.focusOption('last');
                    break;
                default:
                    return;
            }
            event.preventDefault();
        };
        _this.instancePrefix = 'react-select-' + (_this.props.instanceId || ++$935291c440101c41$var$instanceId);
        _this.state.selectValue = (0, $jQxSL.I)(_props.value);
        // Set focusedOption if menuIsOpen is set on init (e.g. defaultMenuIsOpen)
        if (_props.menuIsOpen && _this.state.selectValue.length) {
            var focusableOptions = _this.buildFocusableOptions();
            var optionIndex = focusableOptions.indexOf(_this.state.selectValue[0]);
            _this.state.focusedOption = focusableOptions[optionIndex];
        }
        return _this;
    }
    (0, $lIEGP.default)(Select, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.startListeningComposition();
                this.startListeningToTouch();
                if (this.props.closeMenuOnScroll && document && document.addEventListener) // Listen to all scroll events, and filter them out inside of 'onScroll'
                document.addEventListener('scroll', this.onScroll, true);
                if (this.props.autoFocus) this.focusInput();
                // Scroll focusedOption into view if menuIsOpen is set on mount (e.g. defaultMenuIsOpen)
                if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) (0, $jQxSL.J)(this.menuListRef, this.focusedOptionRef);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props6 = this.props, isDisabled = _this$props6.isDisabled, menuIsOpen = _this$props6.menuIsOpen;
                var isFocused = this.state.isFocused;
                if (// ensure focus is restored correctly when the control becomes enabled
                isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
                isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
                if (isFocused && isDisabled && !prevProps.isDisabled) // ensure select state gets blurred in case Select is programmatically disabled while focused
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: false
                }, this.onMenuClose);
                else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) // ensure select state gets focused in case Select is programatically re-enabled while focused (Firefox)
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: true
                });
                // scroll the focused option into view if necessary
                if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
                    (0, $jQxSL.J)(this.menuListRef, this.focusedOptionRef);
                    this.scrollToFocusedOptionOnUpdate = false;
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.stopListeningComposition();
                this.stopListeningToTouch();
                document.removeEventListener('scroll', this.onScroll, true);
            }
        },
        {
            key: "onMenuOpen",
            value: function onMenuOpen() {
                this.props.onMenuOpen();
            }
        },
        {
            key: "onMenuClose",
            value: function onMenuClose() {
                this.onInputChange('', {
                    action: 'menu-close',
                    prevInputValue: this.props.inputValue
                });
                this.props.onMenuClose();
            }
        },
        {
            key: "onInputChange",
            value: function onInputChange(newValue, actionMeta) {
                this.props.onInputChange(newValue, actionMeta);
            }
        },
        {
            key: "focusInput",
            value: function focusInput() {
                if (!this.inputRef) return;
                this.inputRef.focus();
            }
        },
        {
            key: "blurInput",
            value: function blurInput() {
                if (!this.inputRef) return;
                this.inputRef.blur();
            }
        },
        {
            key: "openMenu",
            value: function openMenu(focusOption) {
                var _this2 = this;
                var _this$state2 = this.state, selectValue = _this$state2.selectValue, isFocused = _this$state2.isFocused;
                var focusableOptions = this.buildFocusableOptions();
                var openAtIndex = focusOption === 'first' ? 0 : focusableOptions.length - 1;
                if (!this.props.isMulti) {
                    var selectedIndex = focusableOptions.indexOf(selectValue[0]);
                    if (selectedIndex > -1) openAtIndex = selectedIndex;
                }
                // only scroll if the menu isn't already open
                this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
                this.setState({
                    inputIsHiddenAfterUpdate: false,
                    focusedValue: null,
                    focusedOption: focusableOptions[openAtIndex]
                }, function() {
                    return _this2.onMenuOpen();
                });
            }
        },
        {
            key: "focusValue",
            value: function focusValue(direction) {
                var _this$state3 = this.state, selectValue = _this$state3.selectValue, focusedValue = _this$state3.focusedValue;
                // Only multiselects support value focusing
                if (!this.props.isMulti) return;
                this.setState({
                    focusedOption: null
                });
                var focusedIndex = selectValue.indexOf(focusedValue);
                if (!focusedValue) focusedIndex = -1;
                var lastIndex = selectValue.length - 1;
                var nextFocus = -1;
                if (!selectValue.length) return;
                switch(direction){
                    case 'previous':
                        if (focusedIndex === 0) // don't cycle from the start to the end
                        nextFocus = 0;
                        else if (focusedIndex === -1) // if nothing is focused, focus the last value first
                        nextFocus = lastIndex;
                        else nextFocus = focusedIndex - 1;
                        break;
                    case 'next':
                        if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                        break;
                }
                this.setState({
                    inputIsHidden: nextFocus !== -1,
                    focusedValue: selectValue[nextFocus]
                });
            }
        },
        {
            key: "focusOption",
            value: function focusOption() {
                var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'first';
                var pageSize = this.props.pageSize;
                var focusedOption = this.state.focusedOption;
                var options = this.getFocusableOptions();
                if (!options.length) return;
                var nextFocus = 0; // handles 'first'
                var focusedIndex = options.indexOf(focusedOption);
                if (!focusedOption) focusedIndex = -1;
                if (direction === 'up') nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
                else if (direction === 'down') nextFocus = (focusedIndex + 1) % options.length;
                else if (direction === 'pageup') {
                    nextFocus = focusedIndex - pageSize;
                    if (nextFocus < 0) nextFocus = 0;
                } else if (direction === 'pagedown') {
                    nextFocus = focusedIndex + pageSize;
                    if (nextFocus > options.length - 1) nextFocus = options.length - 1;
                } else if (direction === 'last') nextFocus = options.length - 1;
                this.scrollToFocusedOptionOnUpdate = true;
                this.setState({
                    focusedOption: options[nextFocus],
                    focusedValue: null
                });
            }
        },
        {
            key: "getTheme",
            value: // ==============================
            // Getters
            // ==============================
            function getTheme() {
                // Use the default theme if there are no customisations.
                if (!this.props.theme) return $935291c440101c41$export$4368d992c4eafac0;
                // If the theme prop is a function, assume the function
                // knows how to merge the passed-in default theme with
                // its own modifications.
                if (typeof this.props.theme === 'function') return this.props.theme($935291c440101c41$export$4368d992c4eafac0);
                // Otherwise, if a plain theme object was passed in,
                // overlay it with the default theme.
                return (0, $1Xn5q.default)((0, $1Xn5q.default)({}, $935291c440101c41$export$4368d992c4eafac0), this.props.theme);
            }
        },
        {
            key: "getCommonProps",
            value: function getCommonProps() {
                var clearValue = this.clearValue, cx = this.cx, getStyles = this.getStyles, getClassNames = this.getClassNames, getValue = this.getValue, selectOption = this.selectOption, setValue = this.setValue, props = this.props;
                var isMulti = props.isMulti, isRtl = props.isRtl, options = props.options;
                var hasValue = this.hasValue();
                return {
                    clearValue: clearValue,
                    cx: cx,
                    getStyles: getStyles,
                    getClassNames: getClassNames,
                    getValue: getValue,
                    hasValue: hasValue,
                    isMulti: isMulti,
                    isRtl: isRtl,
                    options: options,
                    selectOption: selectOption,
                    selectProps: props,
                    setValue: setValue,
                    theme: this.getTheme()
                };
            }
        },
        {
            key: "hasValue",
            value: function hasValue() {
                var selectValue = this.state.selectValue;
                return selectValue.length > 0;
            }
        },
        {
            key: "hasOptions",
            value: function hasOptions() {
                return !!this.getFocusableOptions().length;
            }
        },
        {
            key: "isClearable",
            value: function isClearable() {
                var _this$props7 = this.props, isClearable = _this$props7.isClearable, isMulti = _this$props7.isMulti;
                // single select, by default, IS NOT clearable
                // multi select, by default, IS clearable
                if (isClearable === undefined) return isMulti;
                return isClearable;
            }
        },
        {
            key: "isOptionDisabled",
            value: function isOptionDisabled(option, selectValue) {
                return $935291c440101c41$var$_isOptionDisabled(this.props, option, selectValue);
            }
        },
        {
            key: "isOptionSelected",
            value: function isOptionSelected(option, selectValue) {
                return $935291c440101c41$var$_isOptionSelected(this.props, option, selectValue);
            }
        },
        {
            key: "filterOption",
            value: function filterOption(option, inputValue) {
                return $935291c440101c41$var$_filterOption(this.props, option, inputValue);
            }
        },
        {
            key: "formatOptionLabel",
            value: function formatOptionLabel(data, context) {
                if (typeof this.props.formatOptionLabel === 'function') {
                    var _inputValue = this.props.inputValue;
                    var _selectValue = this.state.selectValue;
                    return this.props.formatOptionLabel(data, {
                        context: context,
                        inputValue: _inputValue,
                        selectValue: _selectValue
                    });
                } else return this.getOptionLabel(data);
            }
        },
        {
            key: "formatGroupLabel",
            value: function formatGroupLabel(data) {
                return this.props.formatGroupLabel(data);
            }
        },
        {
            key: "startListeningComposition",
            value: // ==============================
            // Composition Handlers
            // ==============================
            function startListeningComposition() {
                if (document && document.addEventListener) {
                    document.addEventListener('compositionstart', this.onCompositionStart, false);
                    document.addEventListener('compositionend', this.onCompositionEnd, false);
                }
            }
        },
        {
            key: "stopListeningComposition",
            value: function stopListeningComposition() {
                if (document && document.removeEventListener) {
                    document.removeEventListener('compositionstart', this.onCompositionStart);
                    document.removeEventListener('compositionend', this.onCompositionEnd);
                }
            }
        },
        {
            key: "startListeningToTouch",
            value: // ==============================
            // Touch Handlers
            // ==============================
            function startListeningToTouch() {
                if (document && document.addEventListener) {
                    document.addEventListener('touchstart', this.onTouchStart, false);
                    document.addEventListener('touchmove', this.onTouchMove, false);
                    document.addEventListener('touchend', this.onTouchEnd, false);
                }
            }
        },
        {
            key: "stopListeningToTouch",
            value: function stopListeningToTouch() {
                if (document && document.removeEventListener) {
                    document.removeEventListener('touchstart', this.onTouchStart);
                    document.removeEventListener('touchmove', this.onTouchMove);
                    document.removeEventListener('touchend', this.onTouchEnd);
                }
            }
        },
        {
            key: "renderInput",
            value: // ==============================
            // Renderers
            // ==============================
            function renderInput() {
                var _this$props8 = this.props, isDisabled = _this$props8.isDisabled, isSearchable = _this$props8.isSearchable, inputId = _this$props8.inputId, inputValue = _this$props8.inputValue, tabIndex = _this$props8.tabIndex, form = _this$props8.form, menuIsOpen = _this$props8.menuIsOpen, required = _this$props8.required;
                var _this$getComponents = this.getComponents(), Input = _this$getComponents.Input;
                var _this$state4 = this.state, inputIsHidden = _this$state4.inputIsHidden, ariaSelection = _this$state4.ariaSelection;
                var commonProps = this.commonProps;
                var id = inputId || this.getElementId('input');
                // aria attributes makes the JSX "noisy", separated for clarity
                var ariaAttributes = (0, $1Xn5q.default)((0, $1Xn5q.default)((0, $1Xn5q.default)({
                    'aria-autocomplete': 'list',
                    'aria-expanded': menuIsOpen,
                    'aria-haspopup': true,
                    'aria-errormessage': this.props['aria-errormessage'],
                    'aria-invalid': this.props['aria-invalid'],
                    'aria-label': this.props['aria-label'],
                    'aria-labelledby': this.props['aria-labelledby'],
                    'aria-required': required,
                    role: 'combobox'
                }, menuIsOpen && {
                    'aria-controls': this.getElementId('listbox'),
                    'aria-owns': this.getElementId('listbox')
                }), !isSearchable && {
                    'aria-readonly': true
                }), this.hasValue() ? (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus' && {
                    'aria-describedby': this.getElementId('live-region')
                } : {
                    'aria-describedby': this.getElementId('placeholder')
                });
                if (!isSearchable) // use a dummy input to maintain focus/blur functionality
                return /*#__PURE__*/ $eUqFw.createElement($935291c440101c41$var$DummyInput, (0, $kU09D.default)({
                    id: id,
                    innerRef: this.getInputRef,
                    onBlur: this.onInputBlur,
                    onChange: (0, $jQxSL.K),
                    onFocus: this.onInputFocus,
                    disabled: isDisabled,
                    tabIndex: tabIndex,
                    inputMode: "none",
                    form: form,
                    value: ""
                }, ariaAttributes));
                return /*#__PURE__*/ $eUqFw.createElement(Input, (0, $kU09D.default)({}, commonProps, {
                    autoCapitalize: "none",
                    autoComplete: "off",
                    autoCorrect: "off",
                    id: id,
                    innerRef: this.getInputRef,
                    isDisabled: isDisabled,
                    isHidden: inputIsHidden,
                    onBlur: this.onInputBlur,
                    onChange: this.handleInputChange,
                    onFocus: this.onInputFocus,
                    spellCheck: "false",
                    tabIndex: tabIndex,
                    form: form,
                    type: "text",
                    value: inputValue
                }, ariaAttributes));
            }
        },
        {
            key: "renderPlaceholderOrValue",
            value: function renderPlaceholderOrValue() {
                var _this3 = this;
                var _this$getComponents2 = this.getComponents(), MultiValue = _this$getComponents2.MultiValue, MultiValueContainer = _this$getComponents2.MultiValueContainer, MultiValueLabel = _this$getComponents2.MultiValueLabel, MultiValueRemove = _this$getComponents2.MultiValueRemove, SingleValue = _this$getComponents2.SingleValue, Placeholder = _this$getComponents2.Placeholder;
                var commonProps = this.commonProps;
                var _this$props9 = this.props, controlShouldRenderValue = _this$props9.controlShouldRenderValue, isDisabled = _this$props9.isDisabled, isMulti = _this$props9.isMulti, inputValue = _this$props9.inputValue, placeholder = _this$props9.placeholder;
                var _this$state5 = this.state, selectValue = _this$state5.selectValue, focusedValue = _this$state5.focusedValue, isFocused = _this$state5.isFocused;
                if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : /*#__PURE__*/ $eUqFw.createElement(Placeholder, (0, $kU09D.default)({}, commonProps, {
                    key: "placeholder",
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    innerProps: {
                        id: this.getElementId('placeholder')
                    }
                }), placeholder);
                if (isMulti) return selectValue.map(function(opt, index) {
                    var isOptionFocused = opt === focusedValue;
                    var key = "".concat(_this3.getOptionLabel(opt), "-").concat(_this3.getOptionValue(opt));
                    return /*#__PURE__*/ $eUqFw.createElement(MultiValue, (0, $kU09D.default)({}, commonProps, {
                        components: {
                            Container: MultiValueContainer,
                            Label: MultiValueLabel,
                            Remove: MultiValueRemove
                        },
                        isFocused: isOptionFocused,
                        isDisabled: isDisabled,
                        key: key,
                        index: index,
                        removeProps: {
                            onClick: function onClick() {
                                return _this3.removeValue(opt);
                            },
                            onTouchEnd: function onTouchEnd() {
                                return _this3.removeValue(opt);
                            },
                            onMouseDown: function onMouseDown(e) {
                                e.preventDefault();
                                e.stopPropagation();
                            }
                        },
                        data: opt
                    }), _this3.formatOptionLabel(opt, 'value'));
                });
                if (inputValue) return null;
                var singleValue = selectValue[0];
                return /*#__PURE__*/ $eUqFw.createElement(SingleValue, (0, $kU09D.default)({}, commonProps, {
                    data: singleValue,
                    isDisabled: isDisabled
                }), this.formatOptionLabel(singleValue, 'value'));
            }
        },
        {
            key: "renderClearIndicator",
            value: function renderClearIndicator() {
                var _this$getComponents3 = this.getComponents(), ClearIndicator = _this$getComponents3.ClearIndicator;
                var commonProps = this.commonProps;
                var _this$props10 = this.props, isDisabled = _this$props10.isDisabled, isLoading = _this$props10.isLoading;
                var isFocused = this.state.isFocused;
                if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
                var innerProps = {
                    onMouseDown: this.onClearIndicatorMouseDown,
                    onTouchEnd: this.onClearIndicatorTouchEnd,
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ $eUqFw.createElement(ClearIndicator, (0, $kU09D.default)({}, commonProps, {
                    innerProps: innerProps,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderLoadingIndicator",
            value: function renderLoadingIndicator() {
                var _this$getComponents4 = this.getComponents(), LoadingIndicator = _this$getComponents4.LoadingIndicator;
                var commonProps = this.commonProps;
                var _this$props11 = this.props, isDisabled = _this$props11.isDisabled, isLoading = _this$props11.isLoading;
                var isFocused = this.state.isFocused;
                if (!LoadingIndicator || !isLoading) return null;
                var innerProps = {
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ $eUqFw.createElement(LoadingIndicator, (0, $kU09D.default)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderIndicatorSeparator",
            value: function renderIndicatorSeparator() {
                var _this$getComponents5 = this.getComponents(), DropdownIndicator = _this$getComponents5.DropdownIndicator, IndicatorSeparator = _this$getComponents5.IndicatorSeparator;
                // separator doesn't make sense without the dropdown indicator
                if (!DropdownIndicator || !IndicatorSeparator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                return /*#__PURE__*/ $eUqFw.createElement(IndicatorSeparator, (0, $kU09D.default)({}, commonProps, {
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderDropdownIndicator",
            value: function renderDropdownIndicator() {
                var _this$getComponents6 = this.getComponents(), DropdownIndicator = _this$getComponents6.DropdownIndicator;
                if (!DropdownIndicator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                var innerProps = {
                    onMouseDown: this.onDropdownIndicatorMouseDown,
                    onTouchEnd: this.onDropdownIndicatorTouchEnd,
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ $eUqFw.createElement(DropdownIndicator, (0, $kU09D.default)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderMenu",
            value: function renderMenu() {
                var _this4 = this;
                var _this$getComponents7 = this.getComponents(), Group = _this$getComponents7.Group, GroupHeading = _this$getComponents7.GroupHeading, Menu = _this$getComponents7.Menu, MenuList = _this$getComponents7.MenuList, MenuPortal = _this$getComponents7.MenuPortal, LoadingMessage = _this$getComponents7.LoadingMessage, NoOptionsMessage = _this$getComponents7.NoOptionsMessage, Option = _this$getComponents7.Option;
                var commonProps = this.commonProps;
                var focusedOption = this.state.focusedOption;
                var _this$props12 = this.props, captureMenuScroll = _this$props12.captureMenuScroll, inputValue = _this$props12.inputValue, isLoading = _this$props12.isLoading, loadingMessage = _this$props12.loadingMessage, minMenuHeight = _this$props12.minMenuHeight, maxMenuHeight = _this$props12.maxMenuHeight, menuIsOpen = _this$props12.menuIsOpen, menuPlacement = _this$props12.menuPlacement, menuPosition = _this$props12.menuPosition, menuPortalTarget = _this$props12.menuPortalTarget, menuShouldBlockScroll = _this$props12.menuShouldBlockScroll, menuShouldScrollIntoView = _this$props12.menuShouldScrollIntoView, noOptionsMessage = _this$props12.noOptionsMessage, onMenuScrollToTop = _this$props12.onMenuScrollToTop, onMenuScrollToBottom = _this$props12.onMenuScrollToBottom;
                if (!menuIsOpen) return null;
                // TODO: Internal Option Type here
                var render = function render(props, id) {
                    var type = props.type, data = props.data, isDisabled = props.isDisabled, isSelected = props.isSelected, label = props.label, value = props.value;
                    var isFocused = focusedOption === data;
                    var onHover = isDisabled ? undefined : function() {
                        return _this4.onOptionHover(data);
                    };
                    var onSelect = isDisabled ? undefined : function() {
                        return _this4.selectOption(data);
                    };
                    var optionId = "".concat(_this4.getElementId('option'), "-").concat(id);
                    var innerProps = {
                        id: optionId,
                        onClick: onSelect,
                        onMouseMove: onHover,
                        onMouseOver: onHover,
                        tabIndex: -1
                    };
                    return /*#__PURE__*/ $eUqFw.createElement(Option, (0, $kU09D.default)({}, commonProps, {
                        innerProps: innerProps,
                        data: data,
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        key: optionId,
                        label: label,
                        type: type,
                        value: value,
                        isFocused: isFocused,
                        innerRef: isFocused ? _this4.getFocusedOptionRef : undefined
                    }), _this4.formatOptionLabel(props.data, 'menu'));
                };
                var menuUI;
                if (this.hasOptions()) menuUI = this.getCategorizedOptions().map(function(item) {
                    if (item.type === 'group') {
                        var _data = item.data, options = item.options, groupIndex = item.index;
                        var groupId = "".concat(_this4.getElementId('group'), "-").concat(groupIndex);
                        var headingId = "".concat(groupId, "-heading");
                        return /*#__PURE__*/ $eUqFw.createElement(Group, (0, $kU09D.default)({}, commonProps, {
                            key: groupId,
                            data: _data,
                            options: options,
                            Heading: GroupHeading,
                            headingProps: {
                                id: headingId,
                                data: item.data
                            },
                            label: _this4.formatGroupLabel(item.data)
                        }), item.options.map(function(option) {
                            return render(option, "".concat(groupIndex, "-").concat(option.index));
                        }));
                    } else if (item.type === 'option') return render(item, "".concat(item.index));
                });
                else if (isLoading) {
                    var message = loadingMessage({
                        inputValue: inputValue
                    });
                    if (message === null) return null;
                    menuUI = /*#__PURE__*/ $eUqFw.createElement(LoadingMessage, commonProps, message);
                } else {
                    var _message = noOptionsMessage({
                        inputValue: inputValue
                    });
                    if (_message === null) return null;
                    menuUI = /*#__PURE__*/ $eUqFw.createElement(NoOptionsMessage, commonProps, _message);
                }
                var menuPlacementProps = {
                    minMenuHeight: minMenuHeight,
                    maxMenuHeight: maxMenuHeight,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition,
                    menuShouldScrollIntoView: menuShouldScrollIntoView
                };
                var menuElement = /*#__PURE__*/ $eUqFw.createElement((0, $jQxSL.M), (0, $kU09D.default)({}, commonProps, menuPlacementProps), function(_ref4) {
                    var ref = _ref4.ref, _ref4$placerProps = _ref4.placerProps, placement = _ref4$placerProps.placement, maxHeight = _ref4$placerProps.maxHeight;
                    return /*#__PURE__*/ $eUqFw.createElement(Menu, (0, $kU09D.default)({}, commonProps, menuPlacementProps, {
                        innerRef: ref,
                        innerProps: {
                            onMouseDown: _this4.onMenuMouseDown,
                            onMouseMove: _this4.onMenuMouseMove,
                            id: _this4.getElementId('listbox')
                        },
                        isLoading: isLoading,
                        placement: placement
                    }), /*#__PURE__*/ $eUqFw.createElement($935291c440101c41$var$ScrollManager, {
                        captureEnabled: captureMenuScroll,
                        onTopArrive: onMenuScrollToTop,
                        onBottomArrive: onMenuScrollToBottom,
                        lockEnabled: menuShouldBlockScroll
                    }, function(scrollTargetRef) {
                        return /*#__PURE__*/ $eUqFw.createElement(MenuList, (0, $kU09D.default)({}, commonProps, {
                            innerRef: function innerRef(instance) {
                                _this4.getMenuListRef(instance);
                                scrollTargetRef(instance);
                            },
                            isLoading: isLoading,
                            maxHeight: maxHeight,
                            focusedOption: focusedOption
                        }), menuUI);
                    }));
                });
                // positioning behaviour is almost identical for portalled and fixed,
                // so we use the same component. the actual portalling logic is forked
                // within the component based on `menuPosition`
                return menuPortalTarget || menuPosition === 'fixed' ? /*#__PURE__*/ $eUqFw.createElement(MenuPortal, (0, $kU09D.default)({}, commonProps, {
                    appendTo: menuPortalTarget,
                    controlElement: this.controlRef,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition
                }), menuElement) : menuElement;
            }
        },
        {
            key: "renderFormField",
            value: function renderFormField() {
                var _this5 = this;
                var _this$props13 = this.props, delimiter = _this$props13.delimiter, isDisabled = _this$props13.isDisabled, isMulti = _this$props13.isMulti, name = _this$props13.name, required = _this$props13.required;
                var selectValue = this.state.selectValue;
                if (required && !this.hasValue() && !isDisabled) return /*#__PURE__*/ $eUqFw.createElement($935291c440101c41$var$RequiredInput, {
                    name: name,
                    onFocus: this.onValueInputFocus
                });
                if (!name || isDisabled) return;
                if (isMulti) {
                    if (delimiter) {
                        var value = selectValue.map(function(opt) {
                            return _this5.getOptionValue(opt);
                        }).join(delimiter);
                        return /*#__PURE__*/ $eUqFw.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: value
                        });
                    } else {
                        var input = selectValue.length > 0 ? selectValue.map(function(opt, i) {
                            return /*#__PURE__*/ $eUqFw.createElement("input", {
                                key: "i-".concat(i),
                                name: name,
                                type: "hidden",
                                value: _this5.getOptionValue(opt)
                            });
                        }) : /*#__PURE__*/ $eUqFw.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: ""
                        });
                        return /*#__PURE__*/ $eUqFw.createElement("div", null, input);
                    }
                } else {
                    var _value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
                    return /*#__PURE__*/ $eUqFw.createElement("input", {
                        name: name,
                        type: "hidden",
                        value: _value
                    });
                }
            }
        },
        {
            key: "renderLiveRegion",
            value: function renderLiveRegion() {
                var commonProps = this.commonProps;
                var _this$state6 = this.state, ariaSelection = _this$state6.ariaSelection, focusedOption = _this$state6.focusedOption, focusedValue = _this$state6.focusedValue, isFocused = _this$state6.isFocused, selectValue = _this$state6.selectValue;
                var focusableOptions = this.getFocusableOptions();
                return /*#__PURE__*/ $eUqFw.createElement($935291c440101c41$var$LiveRegion, (0, $kU09D.default)({}, commonProps, {
                    id: this.getElementId('live-region'),
                    ariaSelection: ariaSelection,
                    focusedOption: focusedOption,
                    focusedValue: focusedValue,
                    isFocused: isFocused,
                    selectValue: selectValue,
                    focusableOptions: focusableOptions
                }));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$getComponents8 = this.getComponents(), Control = _this$getComponents8.Control, IndicatorsContainer = _this$getComponents8.IndicatorsContainer, SelectContainer = _this$getComponents8.SelectContainer, ValueContainer = _this$getComponents8.ValueContainer;
                var _this$props14 = this.props, className = _this$props14.className, id = _this$props14.id, isDisabled = _this$props14.isDisabled, menuIsOpen = _this$props14.menuIsOpen;
                var isFocused = this.state.isFocused;
                var commonProps = this.commonProps = this.getCommonProps();
                return /*#__PURE__*/ $eUqFw.createElement(SelectContainer, (0, $kU09D.default)({}, commonProps, {
                    className: className,
                    innerProps: {
                        id: id,
                        onKeyDown: this.onKeyDown
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }), this.renderLiveRegion(), /*#__PURE__*/ $eUqFw.createElement(Control, (0, $kU09D.default)({}, commonProps, {
                    innerRef: this.getControlRef,
                    innerProps: {
                        onMouseDown: this.onControlMouseDown,
                        onTouchEnd: this.onControlTouchEnd
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    menuIsOpen: menuIsOpen
                }), /*#__PURE__*/ $eUqFw.createElement(ValueContainer, (0, $kU09D.default)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderPlaceholderOrValue(), this.renderInput()), /*#__PURE__*/ $eUqFw.createElement(IndicatorsContainer, (0, $kU09D.default)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                var prevProps = state.prevProps, clearFocusValueOnUpdate = state.clearFocusValueOnUpdate, inputIsHiddenAfterUpdate = state.inputIsHiddenAfterUpdate, ariaSelection = state.ariaSelection, isFocused = state.isFocused, prevWasFocused = state.prevWasFocused;
                var options = props.options, value = props.value, menuIsOpen = props.menuIsOpen, inputValue = props.inputValue, isMulti = props.isMulti;
                var selectValue = (0, $jQxSL.I)(value);
                var newMenuOptionsState = {};
                if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
                    var focusableOptions = menuIsOpen ? $935291c440101c41$var$buildFocusableOptions(props, selectValue) : [];
                    var focusedValue = clearFocusValueOnUpdate ? $935291c440101c41$var$getNextFocusedValue(state, selectValue) : null;
                    var focusedOption = $935291c440101c41$var$getNextFocusedOption(state, focusableOptions);
                    newMenuOptionsState = {
                        selectValue: selectValue,
                        focusedOption: focusedOption,
                        focusedValue: focusedValue,
                        clearFocusValueOnUpdate: false
                    };
                }
                // some updates should toggle the state of the input visibility
                var newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
                    inputIsHidden: inputIsHiddenAfterUpdate,
                    inputIsHiddenAfterUpdate: undefined
                } : {};
                var newAriaSelection = ariaSelection;
                var hasKeptFocus = isFocused && prevWasFocused;
                if (isFocused && !hasKeptFocus) {
                    // If `value` or `defaultValue` props are not empty then announce them
                    // when the Select is initially focused
                    newAriaSelection = {
                        value: (0, $jQxSL.D)(isMulti, selectValue, selectValue[0] || null),
                        options: selectValue,
                        action: 'initial-input-focus'
                    };
                    hasKeptFocus = !prevWasFocused;
                }
                // If the 'initial-input-focus' action has been set already
                // then reset the ariaSelection to null
                if ((ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus') newAriaSelection = null;
                return (0, $1Xn5q.default)((0, $1Xn5q.default)((0, $1Xn5q.default)({}, newMenuOptionsState), newInputIsHiddenState), {}, {
                    prevProps: props,
                    ariaSelection: newAriaSelection,
                    prevWasFocused: hasKeptFocus
                });
            }
        }
    ]);
    return Select;
}((0, $eUqFw.Component));
$935291c440101c41$export$25ce5a424b770e84.defaultProps = $935291c440101c41$export$407448d2b89b1813;

});
parcelRegister("lDSrn", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc177843783b087f$export$2e2bcd8739ae039);
function $fc177843783b087f$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("lIEGP", function(module, exports) {

$parcel$export(module.exports, "default", () => $fcfd452a83bb612a$export$2e2bcd8739ae039);

var $aM0Ke = parcelRequire("aM0Ke");
function $fcfd452a83bb612a$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $aM0Ke.default)(o.key), o);
    }
}
function $fcfd452a83bb612a$export$2e2bcd8739ae039(e, r, t) {
    return r && $fcfd452a83bb612a$var$_defineProperties(e.prototype, r), t && $fcfd452a83bb612a$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});

parcelRegister("eT4IF", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad69dceb97fc37d0$export$2e2bcd8739ae039);

var $c2pQl = parcelRequire("c2pQl");
function $ad69dceb97fc37d0$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $c2pQl.default)(t, e);
}

});

parcelRegister("7Dzgl", function(module, exports) {

$parcel$export(module.exports, "default", () => $58f7875a71af82f1$export$2e2bcd8739ae039);

var $i3rTN = parcelRequire("i3rTN");

var $8c5pC = parcelRequire("8c5pC");

var $4mIeV = parcelRequire("4mIeV");
function $58f7875a71af82f1$export$2e2bcd8739ae039(t) {
    var r = (0, $8c5pC.default)();
    return function() {
        var e, o = (0, $i3rTN.default)(t);
        if (r) {
            var s = (0, $i3rTN.default)(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return (0, $4mIeV.default)(this, e);
    };
}

});
parcelRegister("i3rTN", function(module, exports) {

$parcel$export(module.exports, "default", () => $d24e25f7bdedc6a7$export$2e2bcd8739ae039);
function $d24e25f7bdedc6a7$export$2e2bcd8739ae039(t) {
    return $d24e25f7bdedc6a7$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $d24e25f7bdedc6a7$export$2e2bcd8739ae039(t);
}

});

parcelRegister("8c5pC", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f73a47aa7a9581c$export$2e2bcd8739ae039);
function $5f73a47aa7a9581c$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($5f73a47aa7a9581c$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}

});

parcelRegister("4mIeV", function(module, exports) {

$parcel$export(module.exports, "default", () => $32db889076b63d40$export$2e2bcd8739ae039);

var $5sKOb = parcelRequire("5sKOb");

var $aCdHv = parcelRequire("aCdHv");
function $32db889076b63d40$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $5sKOb.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $aCdHv.default)(t);
}

});


parcelRegister("fVK4C", function(module, exports) {

$parcel$export(module.exports, "default", () => $b98feb1d5dd86921$export$2e2bcd8739ae039);

var $b7OIr = parcelRequire("b7OIr");

var $2B3l3 = parcelRequire("2B3l3");

var $e5SQy = parcelRequire("e5SQy");

var $csAMF = parcelRequire("csAMF");
function $b98feb1d5dd86921$export$2e2bcd8739ae039(r) {
    return (0, $b7OIr.default)(r) || (0, $2B3l3.default)(r) || (0, $e5SQy.default)(r) || (0, $csAMF.default)();
}

});
parcelRegister("b7OIr", function(module, exports) {

$parcel$export(module.exports, "default", () => $8197b040df4187a0$export$2e2bcd8739ae039);

var $aLrjs = parcelRequire("aLrjs");
function $8197b040df4187a0$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $aLrjs.default)(r);
}

});

parcelRegister("2B3l3", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e41a0710a3b4a62$export$2e2bcd8739ae039);
function $1e41a0710a3b4a62$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("csAMF", function(module, exports) {

$parcel$export(module.exports, "default", () => $9124a21752235a23$export$2e2bcd8739ae039);
function $9124a21752235a23$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("jQxSL", function(module, exports) {

$parcel$export(module.exports, "K", () => $e72d27f6b1599862$export$3466f893ebf79586);
$parcel$export(module.exports, "E", () => $e72d27f6b1599862$export$a9c23c6ac3fc3eca);
$parcel$export(module.exports, "I", () => $e72d27f6b1599862$export$9bb611d729802a56);
$parcel$export(module.exports, "L", () => $e72d27f6b1599862$export$61196ced6d74a310);
$parcel$export(module.exports, "H", () => $e72d27f6b1599862$export$7f8ddf7c7c20b3cd);
$parcel$export(module.exports, "J", () => $e72d27f6b1599862$export$b4171a6734a65d42);
$parcel$export(module.exports, "z", () => $e72d27f6b1599862$export$df995fae86a55f06);
$parcel$export(module.exports, "A", () => $e72d27f6b1599862$export$ebd11618f299a286);
$parcel$export(module.exports, "s", () => $e72d27f6b1599862$export$2408f22a0fab9ae5);
$parcel$export(module.exports, "G", () => $e72d27f6b1599862$export$2329c99376c9d0a4);
$parcel$export(module.exports, "D", () => $e72d27f6b1599862$export$96f57966bedc81b4);
$parcel$export(module.exports, "C", () => $e72d27f6b1599862$export$e7094788287c5e9b);
$parcel$export(module.exports, "B", () => $e72d27f6b1599862$export$ef35774e6d314e91);
$parcel$export(module.exports, "r", () => $e72d27f6b1599862$export$43caf9889c228507);
$parcel$export(module.exports, "m", () => $e72d27f6b1599862$export$953cecd6e717a553);
$parcel$export(module.exports, "M", () => $e72d27f6b1599862$export$3a1a48c8f6ef640e);
$parcel$export(module.exports, "n", () => $e72d27f6b1599862$export$7ccc53e8f1e7dfc5);
$parcel$export(module.exports, "u", () => $e72d27f6b1599862$export$3b14a55fb2447963);
$parcel$export(module.exports, "k", () => $e72d27f6b1599862$export$342063e11d6c3cad);
$parcel$export(module.exports, "o", () => $e72d27f6b1599862$export$ae1af26003f05816);
$parcel$export(module.exports, "b", () => $e72d27f6b1599862$export$8b22cf2602fb60ce);
$parcel$export(module.exports, "y", () => $e72d27f6b1599862$export$4a5767248b18ef41);
$parcel$export(module.exports, "i", () => $e72d27f6b1599862$export$23f2a1d2818174ef);
$parcel$export(module.exports, "e", () => $e72d27f6b1599862$export$f1e1789686576879);
$parcel$export(module.exports, "a", () => $e72d27f6b1599862$export$407448d2b89b1813);
$parcel$export(module.exports, "h", () => $e72d27f6b1599862$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "l", () => $e72d27f6b1599862$export$882b5998b3b9117c);
$parcel$export(module.exports, "d", () => $e72d27f6b1599862$export$4368d992c4eafac0);
$parcel$export(module.exports, "g", () => $e72d27f6b1599862$export$39b482c5e57630a8);
$parcel$export(module.exports, "f", () => $e72d27f6b1599862$export$2d1720544b23b823);
$parcel$export(module.exports, "j", () => $e72d27f6b1599862$export$35e795649ee09318);
$parcel$export(module.exports, "p", () => $e72d27f6b1599862$export$ffb5f4729a158638);
$parcel$export(module.exports, "q", () => $e72d27f6b1599862$export$9e5f44173e64f162);
$parcel$export(module.exports, "t", () => $e72d27f6b1599862$export$625550452a3fa3ec);
$parcel$export(module.exports, "v", () => $e72d27f6b1599862$export$90a7f3efeed30595);
$parcel$export(module.exports, "w", () => $e72d27f6b1599862$export$efccba1c4a2ef57b);
$parcel$export(module.exports, "x", () => $e72d27f6b1599862$export$d141bba7fdc215a3);
$parcel$export(module.exports, "c", () => $e72d27f6b1599862$export$db3b6bfb95261072);
$parcel$export(module.exports, "F", () => $e72d27f6b1599862$export$d66501df72047452);

var $1Xn5q = parcelRequire("1Xn5q");

var $kU09D = parcelRequire("kU09D");

var $byn9U = parcelRequire("byn9U");

var $aKcqM = parcelRequire("aKcqM");

var $bwPfh = parcelRequire("bwPfh");

var $5sKOb = parcelRequire("5sKOb");

var $jqNEH = parcelRequire("jqNEH");

var $5zQU9 = parcelRequire("5zQU9");

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $5O3G9 = parcelRequire("5O3G9");

var $k286k = parcelRequire("k286k");
var $e72d27f6b1599862$var$_excluded$3 = [
    "className",
    "clearValue",
    "cx",
    "getStyles",
    "getClassNames",
    "getValue",
    "hasValue",
    "isMulti",
    "isRtl",
    "options",
    "selectOption",
    "selectProps",
    "setValue",
    "theme"
];
// ==============================
// NO OP
// ==============================
var $e72d27f6b1599862$export$3466f893ebf79586 = function noop() {};
// ==============================
// Class Name Prefixer
// ==============================
/**
 String representation of component state for styling with class names.

 Expects an array of strings OR a string/object pair:
 - className(['comp', 'comp-arg', 'comp-arg-2'])
   @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 - className('comp', { some: true, state: false })
   @returns 'react-select__comp react-select__comp--some'
*/ function $e72d27f6b1599862$var$applyPrefixToName(prefix, name) {
    if (!name) return prefix;
    else if (name[0] === '-') return prefix + name;
    else return prefix + '__' + name;
}
function $e72d27f6b1599862$export$a9c23c6ac3fc3eca(prefix, state) {
    for(var _len = arguments.length, classNameList = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)classNameList[_key - 2] = arguments[_key];
    var arr = [].concat(classNameList);
    if (state && prefix) {
        for(var key in state)if (state.hasOwnProperty(key) && state[key]) arr.push("".concat($e72d27f6b1599862$var$applyPrefixToName(prefix, key)));
    }
    return arr.filter(function(i) {
        return i;
    }).map(function(i) {
        return String(i).trim();
    }).join(' ');
}
// ==============================
// Clean Value
// ==============================
var $e72d27f6b1599862$export$9bb611d729802a56 = function cleanValue(value) {
    if ($e72d27f6b1599862$var$isArray(value)) return value.filter(Boolean);
    if ((0, $5sKOb.default)(value) === 'object' && value !== null) return [
        value
    ];
    return [];
};
// ==============================
// Clean Common Props
// ==============================
var $e72d27f6b1599862$var$cleanCommonProps = function cleanCommonProps(props) {
    //className
    props.className;
    props.clearValue;
    props.cx;
    props.getStyles;
    props.getClassNames;
    props.getValue;
    props.hasValue;
    props.isMulti;
    props.isRtl;
    props.options;
    props.selectOption;
    props.selectProps;
    props.setValue;
    props.theme;
    var innerProps = (0, $bwPfh.default)(props, $e72d27f6b1599862$var$_excluded$3);
    return (0, $1Xn5q.default)({}, innerProps);
};
// ==============================
// Get Style Props
// ==============================
var $e72d27f6b1599862$var$getStyleProps = function getStyleProps(props, name, classNamesState) {
    var cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, className = props.className;
    return {
        css: getStyles(name, props),
        className: cx(classNamesState !== null && classNamesState !== void 0 ? classNamesState : {}, getClassNames(name, props), className)
    };
};
// ==============================
// Handle Input Change
// ==============================
function $e72d27f6b1599862$export$61196ced6d74a310(inputValue, actionMeta, onInputChange) {
    if (onInputChange) {
        var _newValue = onInputChange(inputValue, actionMeta);
        if (typeof _newValue === 'string') return _newValue;
    }
    return inputValue;
}
// ==============================
// Scroll Helpers
// ==============================
function $e72d27f6b1599862$export$7f8ddf7c7c20b3cd(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}
// Normalized Scroll Top
// ------------------------------
function $e72d27f6b1599862$var$normalizedHeight(el) {
    if ($e72d27f6b1599862$export$7f8ddf7c7c20b3cd(el)) return window.innerHeight;
    return el.clientHeight;
}
// Normalized scrollTo & scrollTop
// ------------------------------
function $e72d27f6b1599862$var$getScrollTop(el) {
    if ($e72d27f6b1599862$export$7f8ddf7c7c20b3cd(el)) return window.pageYOffset;
    return el.scrollTop;
}
function $e72d27f6b1599862$var$scrollTo(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ($e72d27f6b1599862$export$7f8ddf7c7c20b3cd(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}
// Get Scroll Parent
// ------------------------------
function $e72d27f6b1599862$var$getScrollParent(element) {
    var style = getComputedStyle(element);
    var excludeStaticParent = style.position === 'absolute';
    var overflowRx = /(auto|scroll)/;
    if (style.position === 'fixed') return document.documentElement;
    for(var parent = element; parent = parent.parentElement;){
        style = getComputedStyle(parent);
        if (excludeStaticParent && style.position === 'static') continue;
        if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
    }
    return document.documentElement;
}
// Animated Scroll To
// ------------------------------
/**
  @param t: time (elapsed)
  @param b: initial value
  @param c: amount of change
  @param d: duration
*/ function $e72d27f6b1599862$var$easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
}
function $e72d27f6b1599862$var$animatedScrollTo(element, to) {
    var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
    var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $e72d27f6b1599862$export$3466f893ebf79586;
    var start = $e72d27f6b1599862$var$getScrollTop(element);
    var change = to - start;
    var increment = 10;
    var currentTime = 0;
    function animateScroll() {
        currentTime += increment;
        var val = $e72d27f6b1599862$var$easeOutCubic(currentTime, start, change, duration);
        $e72d27f6b1599862$var$scrollTo(element, val);
        if (currentTime < duration) window.requestAnimationFrame(animateScroll);
        else callback(element);
    }
    animateScroll();
}
// Scroll Into View
// ------------------------------
function $e72d27f6b1599862$export$b4171a6734a65d42(menuEl, focusedEl) {
    var menuRect = menuEl.getBoundingClientRect();
    var focusedRect = focusedEl.getBoundingClientRect();
    var overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom) $e72d27f6b1599862$var$scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    else if (focusedRect.top - overScroll < menuRect.top) $e72d27f6b1599862$var$scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
}
// ==============================
// Get bounding client object
// ==============================
// cannot get keys using array notation with DOMRect
function $e72d27f6b1599862$var$getBoundingClientObj(element) {
    var rect = element.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width
    };
}
// ==============================
// Touch Capability Detector
// ==============================
function $e72d27f6b1599862$export$df995fae86a55f06() {
    try {
        document.createEvent('TouchEvent');
        return true;
    } catch (e) {
        return false;
    }
}
// ==============================
// Mobile Device Detector
// ==============================
function $e72d27f6b1599862$export$ebd11618f299a286() {
    try {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch (e) {
        return false;
    }
}
// ==============================
// Passive Event Detector
// ==============================
// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
var $e72d27f6b1599862$var$passiveOptionAccessed = false;
var $e72d27f6b1599862$var$options = {
    get passive () {
        return $e72d27f6b1599862$var$passiveOptionAccessed = true;
    }
};
// check for SSR
var $e72d27f6b1599862$var$w = typeof window !== 'undefined' ? window : {};
if ($e72d27f6b1599862$var$w.addEventListener && $e72d27f6b1599862$var$w.removeEventListener) {
    $e72d27f6b1599862$var$w.addEventListener('p', $e72d27f6b1599862$export$3466f893ebf79586, $e72d27f6b1599862$var$options);
    $e72d27f6b1599862$var$w.removeEventListener('p', $e72d27f6b1599862$export$3466f893ebf79586, false);
}
var $e72d27f6b1599862$export$2408f22a0fab9ae5 = $e72d27f6b1599862$var$passiveOptionAccessed;
function $e72d27f6b1599862$export$2329c99376c9d0a4(item) {
    return item != null;
}
function $e72d27f6b1599862$var$isArray(arg) {
    return Array.isArray(arg);
}
function $e72d27f6b1599862$export$96f57966bedc81b4(isMulti, multiValue, singleValue) {
    return isMulti ? multiValue : singleValue;
}
function $e72d27f6b1599862$export$e7094788287c5e9b(singleValue) {
    return singleValue;
}
function $e72d27f6b1599862$export$ef35774e6d314e91(multiValue) {
    return multiValue;
}
var $e72d27f6b1599862$export$43caf9889c228507 = function removeProps(propsObj) {
    for(var _len2 = arguments.length, properties = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)properties[_key2 - 1] = arguments[_key2];
    var propsMap = Object.entries(propsObj).filter(function(_ref) {
        var _ref2 = (0, $aKcqM.default)(_ref, 1), key = _ref2[0];
        return !properties.includes(key);
    });
    return propsMap.reduce(function(newProps, _ref3) {
        var _ref4 = (0, $aKcqM.default)(_ref3, 2), key = _ref4[0], val = _ref4[1];
        newProps[key] = val;
        return newProps;
    }, {});
};
function $e72d27f6b1599862$var$getMenuPlacement(_ref) {
    var preferredMaxHeight = _ref.maxHeight, menuEl = _ref.menuEl, minHeight = _ref.minHeight, preferredPlacement = _ref.placement, shouldScroll = _ref.shouldScroll, isFixedPosition = _ref.isFixedPosition, controlHeight = _ref.controlHeight;
    var scrollParent = $e72d27f6b1599862$var$getScrollParent(menuEl);
    var defaultState = {
        placement: 'bottom',
        maxHeight: preferredMaxHeight
    };
    // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState;
    // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    var _scrollParent$getBoun = scrollParent.getBoundingClientRect(), scrollHeight = _scrollParent$getBoun.height;
    var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(), menuBottom = _menuEl$getBoundingCl.bottom, menuHeight = _menuEl$getBoundingCl.height, menuTop = _menuEl$getBoundingCl.top;
    var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(), containerTop = _menuEl$offsetParent$.top;
    var viewHeight = isFixedPosition ? window.innerHeight : $e72d27f6b1599862$var$normalizedHeight(scrollParent);
    var scrollTop = $e72d27f6b1599862$var$getScrollTop(scrollParent);
    var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    var viewSpaceAbove = containerTop - marginTop;
    var viewSpaceBelow = viewHeight - menuTop;
    var scrollSpaceAbove = viewSpaceAbove + scrollTop;
    var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
    var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    var scrollUp = scrollTop + menuTop - marginTop;
    var scrollDuration = 160;
    switch(preferredPlacement){
        case 'auto':
        case 'bottom':
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $e72d27f6b1599862$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) $e72d27f6b1599862$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: 'bottom',
                    maxHeight: constrainedHeight
                };
            }
            // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (preferredPlacement === 'auto' || isFixedPosition) {
                // may need to be constrained after flipping
                var _constrainedHeight = preferredMaxHeight;
                var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) _constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                return {
                    placement: 'top',
                    maxHeight: _constrainedHeight
                };
            }
            // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (preferredPlacement === 'bottom') {
                if (shouldScroll) $e72d27f6b1599862$var$scrollTo(scrollParent, scrollDown);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            break;
        case 'top':
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: 'top',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $e72d27f6b1599862$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                var _constrainedHeight2 = preferredMaxHeight;
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) $e72d27f6b1599862$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: _constrainedHeight2
                };
            }
            // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
        default:
            throw new Error("Invalid placement provided \"".concat(preferredPlacement, "\"."));
    }
    return defaultState;
}
// Menu Component
// ------------------------------
function $e72d27f6b1599862$var$alignToControl(placement) {
    var placementToCSSProp = {
        bottom: 'top',
        top: 'bottom'
    };
    return placement ? placementToCSSProp[placement] : 'bottom';
}
var $e72d27f6b1599862$var$coercePlacement = function coercePlacement(p) {
    return p === 'auto' ? 'bottom' : p;
};
var $e72d27f6b1599862$export$953cecd6e717a553 = function menuCSS(_ref2, unstyled) {
    var _objectSpread2;
    var placement = _ref2.placement, _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, spacing = _ref2$theme.spacing, colors = _ref2$theme.colors;
    return (0, $1Xn5q.default)((_objectSpread2 = {
        label: 'menu'
    }, (0, $5zQU9.default)(_objectSpread2, $e72d27f6b1599862$var$alignToControl(placement), '100%'), (0, $5zQU9.default)(_objectSpread2, "position", 'absolute'), (0, $5zQU9.default)(_objectSpread2, "width", '100%'), (0, $5zQU9.default)(_objectSpread2, "zIndex", 1), _objectSpread2), unstyled ? {} : {
        backgroundColor: colors.neutral0,
        borderRadius: borderRadius,
        boxShadow: '0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)',
        marginBottom: spacing.menuGutter,
        marginTop: spacing.menuGutter
    });
};
var $e72d27f6b1599862$var$PortalPlacementContext = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
// NOTE: internal only
var $e72d27f6b1599862$export$3a1a48c8f6ef640e = function MenuPlacer(props) {
    var children = props.children, minMenuHeight = props.minMenuHeight, maxMenuHeight = props.maxMenuHeight, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition, menuShouldScrollIntoView = props.menuShouldScrollIntoView, theme = props.theme;
    var _ref3 = (0, $eUqFw.useContext)($e72d27f6b1599862$var$PortalPlacementContext) || {}, setPortalPlacement = _ref3.setPortalPlacement;
    var ref = (0, $eUqFw.useRef)(null);
    var _useState = (0, $eUqFw.useState)(maxMenuHeight), _useState2 = (0, $aKcqM.default)(_useState, 2), maxHeight = _useState2[0], setMaxHeight = _useState2[1];
    var _useState3 = (0, $eUqFw.useState)(null), _useState4 = (0, $aKcqM.default)(_useState3, 2), placement = _useState4[0], setPlacement = _useState4[1];
    var controlHeight = theme.spacing.controlHeight;
    (0, $k286k.default)(function() {
        var menuEl = ref.current;
        if (!menuEl) return;
        // DO NOT scroll if position is fixed
        var isFixedPosition = menuPosition === 'fixed';
        var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
        var state = $e72d27f6b1599862$var$getMenuPlacement({
            maxHeight: maxMenuHeight,
            menuEl: menuEl,
            minHeight: minMenuHeight,
            placement: menuPlacement,
            shouldScroll: shouldScroll,
            isFixedPosition: isFixedPosition,
            controlHeight: controlHeight
        });
        setMaxHeight(state.maxHeight);
        setPlacement(state.placement);
        setPortalPlacement === null || setPortalPlacement === void 0 || setPortalPlacement(state.placement);
    }, [
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView,
        minMenuHeight,
        setPortalPlacement,
        controlHeight
    ]);
    return children({
        ref: ref,
        placerProps: (0, $1Xn5q.default)((0, $1Xn5q.default)({}, props), {}, {
            placement: placement || $e72d27f6b1599862$var$coercePlacement(menuPlacement),
            maxHeight: maxHeight
        })
    });
};
var $e72d27f6b1599862$var$Menu = function Menu(props) {
    var children = props.children, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'menu', {
        menu: true
    }), {
        ref: innerRef
    }, innerProps), children);
};
// ==============================
// Menu List
// ==============================
var $e72d27f6b1599862$export$7ccc53e8f1e7dfc5 = function menuListCSS(_ref4, unstyled) {
    var maxHeight = _ref4.maxHeight, baseUnit = _ref4.theme.spacing.baseUnit;
    return (0, $1Xn5q.default)({
        maxHeight: maxHeight,
        overflowY: 'auto',
        position: 'relative',
        // required for offset[Height, Top] > keyboard scroll
        WebkitOverflowScrolling: 'touch'
    }, unstyled ? {} : {
        paddingBottom: baseUnit,
        paddingTop: baseUnit
    });
};
var $e72d27f6b1599862$var$MenuList = function MenuList(props) {
    var children = props.children, innerProps = props.innerProps, innerRef = props.innerRef, isMulti = props.isMulti;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'menuList', {
        'menu-list': true,
        'menu-list--is-multi': isMulti
    }), {
        ref: innerRef
    }, innerProps), children);
};
// ==============================
// Menu Notices
// ==============================
var $e72d27f6b1599862$var$noticeCSS = function noticeCSS(_ref5, unstyled) {
    var _ref5$theme = _ref5.theme, baseUnit = _ref5$theme.spacing.baseUnit, colors = _ref5$theme.colors;
    return (0, $1Xn5q.default)({
        textAlign: 'center'
    }, unstyled ? {} : {
        color: colors.neutral40,
        padding: "".concat(baseUnit * 2, "px ").concat(baseUnit * 3, "px")
    });
};
var $e72d27f6b1599862$export$3b14a55fb2447963 = $e72d27f6b1599862$var$noticeCSS;
var $e72d27f6b1599862$export$342063e11d6c3cad = $e72d27f6b1599862$var$noticeCSS;
var $e72d27f6b1599862$var$NoOptionsMessage = function NoOptionsMessage(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'noOptionsMessage', {
        'menu-notice': true,
        'menu-notice--no-options': true
    }), innerProps), children);
};
$e72d27f6b1599862$var$NoOptionsMessage.defaultProps = {
    children: 'No options'
};
var $e72d27f6b1599862$var$LoadingMessage = function LoadingMessage(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'loadingMessage', {
        'menu-notice': true,
        'menu-notice--loading': true
    }), innerProps), children);
};
$e72d27f6b1599862$var$LoadingMessage.defaultProps = {
    children: 'Loading...'
};
// ==============================
// Menu Portal
// ==============================
var $e72d27f6b1599862$export$ae1af26003f05816 = function menuPortalCSS(_ref6) {
    var rect = _ref6.rect, offset = _ref6.offset, position = _ref6.position;
    return {
        left: rect.left,
        position: position,
        top: offset,
        width: rect.width,
        zIndex: 1
    };
};
var $e72d27f6b1599862$var$MenuPortal = function MenuPortal(props) {
    var appendTo = props.appendTo, children = props.children, controlElement = props.controlElement, innerProps = props.innerProps, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition;
    var menuPortalRef = (0, $eUqFw.useRef)(null);
    var cleanupRef = (0, $eUqFw.useRef)(null);
    var _useState5 = (0, $eUqFw.useState)($e72d27f6b1599862$var$coercePlacement(menuPlacement)), _useState6 = (0, $aKcqM.default)(_useState5, 2), placement = _useState6[0], setPortalPlacement = _useState6[1];
    var portalPlacementContext = (0, $eUqFw.useMemo)(function() {
        return {
            setPortalPlacement: setPortalPlacement
        };
    }, []);
    var _useState7 = (0, $eUqFw.useState)(null), _useState8 = (0, $aKcqM.default)(_useState7, 2), computedPosition = _useState8[0], setComputedPosition = _useState8[1];
    var updateComputedPosition = (0, $eUqFw.useCallback)(function() {
        if (!controlElement) return;
        var rect = $e72d27f6b1599862$var$getBoundingClientObj(controlElement);
        var scrollDistance = menuPosition === 'fixed' ? 0 : window.pageYOffset;
        var offset = rect[placement] + scrollDistance;
        if (offset !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset) || rect.left !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left) || rect.width !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width)) setComputedPosition({
            offset: offset,
            rect: rect
        });
    }, [
        controlElement,
        menuPosition,
        placement,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width
    ]);
    (0, $k286k.default)(function() {
        updateComputedPosition();
    }, [
        updateComputedPosition
    ]);
    var runAutoUpdate = (0, $eUqFw.useCallback)(function() {
        if (typeof cleanupRef.current === 'function') {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (controlElement && menuPortalRef.current) cleanupRef.current = (0, $5O3G9.autoUpdate)(controlElement, menuPortalRef.current, updateComputedPosition, {
            elementResize: 'ResizeObserver' in window
        });
    }, [
        controlElement,
        updateComputedPosition
    ]);
    (0, $k286k.default)(function() {
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    var setMenuPortalElement = (0, $eUqFw.useCallback)(function(menuPortalElement) {
        menuPortalRef.current = menuPortalElement;
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    // bail early if required elements aren't present
    if (!appendTo && menuPosition !== 'fixed' || !computedPosition) return null;
    // same wrapper element whether fixed or portalled
    var menuWrapper = (0, $byn9U.jsx)("div", (0, $kU09D.default)({
        ref: setMenuPortalElement
    }, $e72d27f6b1599862$var$getStyleProps((0, $1Xn5q.default)((0, $1Xn5q.default)({}, props), {}, {
        offset: computedPosition.offset,
        position: menuPosition,
        rect: computedPosition.rect
    }), 'menuPortal', {
        'menu-portal': true
    }), innerProps), children);
    return (0, $byn9U.jsx)($e72d27f6b1599862$var$PortalPlacementContext.Provider, {
        value: portalPlacementContext
    }, appendTo ? /*#__PURE__*/ (0, $lEfVV.createPortal)(menuWrapper, appendTo) : menuWrapper);
};
// ==============================
// Root Container
// ==============================
var $e72d27f6b1599862$export$8b22cf2602fb60ce = function containerCSS(_ref) {
    var isDisabled = _ref.isDisabled, isRtl = _ref.isRtl;
    return {
        label: 'container',
        direction: isRtl ? 'rtl' : undefined,
        pointerEvents: isDisabled ? 'none' : undefined,
        // cancel mouse events when disabled
        position: 'relative'
    };
};
var $e72d27f6b1599862$var$SelectContainer = function SelectContainer(props) {
    var children = props.children, innerProps = props.innerProps, isDisabled = props.isDisabled, isRtl = props.isRtl;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'container', {
        '--is-disabled': isDisabled,
        '--is-rtl': isRtl
    }), innerProps), children);
};
// ==============================
// Value Container
// ==============================
var $e72d27f6b1599862$export$4a5767248b18ef41 = function valueContainerCSS(_ref2, unstyled) {
    var spacing = _ref2.theme.spacing, isMulti = _ref2.isMulti, hasValue = _ref2.hasValue, controlShouldRenderValue = _ref2.selectProps.controlShouldRenderValue;
    return (0, $1Xn5q.default)({
        alignItems: 'center',
        display: isMulti && hasValue && controlShouldRenderValue ? 'flex' : 'grid',
        flex: 1,
        flexWrap: 'wrap',
        WebkitOverflowScrolling: 'touch',
        position: 'relative',
        overflow: 'hidden'
    }, unstyled ? {} : {
        padding: "".concat(spacing.baseUnit / 2, "px ").concat(spacing.baseUnit * 2, "px")
    });
};
var $e72d27f6b1599862$var$ValueContainer = function ValueContainer(props) {
    var children = props.children, innerProps = props.innerProps, isMulti = props.isMulti, hasValue = props.hasValue;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'valueContainer', {
        'value-container': true,
        'value-container--is-multi': isMulti,
        'value-container--has-value': hasValue
    }), innerProps), children);
};
// ==============================
// Indicator Container
// ==============================
var $e72d27f6b1599862$export$23f2a1d2818174ef = function indicatorsContainerCSS() {
    return {
        alignItems: 'center',
        alignSelf: 'stretch',
        display: 'flex',
        flexShrink: 0
    };
};
var $e72d27f6b1599862$var$IndicatorsContainer = function IndicatorsContainer(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'indicatorsContainer', {
        indicators: true
    }), innerProps), children);
};
var $e72d27f6b1599862$var$_templateObject;
var $e72d27f6b1599862$var$_excluded$2 = [
    "size"
];
function $e72d27f6b1599862$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// ==============================
// Dropdown & Clear Icons
// ==============================
var $e72d27f6b1599862$var$_ref2 = {
    name: "8mmkcg",
    styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
};
var $e72d27f6b1599862$var$Svg = function Svg(_ref) {
    var size = _ref.size, props = (0, $bwPfh.default)(_ref, $e72d27f6b1599862$var$_excluded$2);
    return (0, $byn9U.jsx)("svg", (0, $kU09D.default)({
        height: size,
        width: size,
        viewBox: "0 0 20 20",
        "aria-hidden": "true",
        focusable: "false",
        css: $e72d27f6b1599862$var$_ref2
    }, props));
};
var $e72d27f6b1599862$var$CrossIcon = function CrossIcon(props) {
    return (0, $byn9U.jsx)($e72d27f6b1599862$var$Svg, (0, $kU09D.default)({
        size: 20
    }, props), (0, $byn9U.jsx)("path", {
        d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
    }));
};
var $e72d27f6b1599862$var$DownChevron = function DownChevron(props) {
    return (0, $byn9U.jsx)($e72d27f6b1599862$var$Svg, (0, $kU09D.default)({
        size: 20
    }, props), (0, $byn9U.jsx)("path", {
        d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
    }));
};
// ==============================
// Dropdown & Clear Buttons
// ==============================
var $e72d27f6b1599862$var$baseCSS = function baseCSS(_ref3, unstyled) {
    var isFocused = _ref3.isFocused, _ref3$theme = _ref3.theme, baseUnit = _ref3$theme.spacing.baseUnit, colors = _ref3$theme.colors;
    return (0, $1Xn5q.default)({
        label: 'indicatorContainer',
        display: 'flex',
        transition: 'color 150ms'
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2,
        ':hover': {
            color: isFocused ? colors.neutral80 : colors.neutral40
        }
    });
};
var $e72d27f6b1599862$export$f1e1789686576879 = $e72d27f6b1599862$var$baseCSS;
var $e72d27f6b1599862$var$DropdownIndicator = function DropdownIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'dropdownIndicator', {
        indicator: true,
        'dropdown-indicator': true
    }), innerProps), children || (0, $byn9U.jsx)($e72d27f6b1599862$var$DownChevron, null));
};
var $e72d27f6b1599862$export$407448d2b89b1813 = $e72d27f6b1599862$var$baseCSS;
var $e72d27f6b1599862$var$ClearIndicator = function ClearIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'clearIndicator', {
        indicator: true,
        'clear-indicator': true
    }), innerProps), children || (0, $byn9U.jsx)($e72d27f6b1599862$var$CrossIcon, null));
};
// ==============================
// Separator
// ==============================
var $e72d27f6b1599862$export$dda1d9f60106f0e9 = function indicatorSeparatorCSS(_ref4, unstyled) {
    var isDisabled = _ref4.isDisabled, _ref4$theme = _ref4.theme, baseUnit = _ref4$theme.spacing.baseUnit, colors = _ref4$theme.colors;
    return (0, $1Xn5q.default)({
        label: 'indicatorSeparator',
        alignSelf: 'stretch',
        width: 1
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
        marginBottom: baseUnit * 2,
        marginTop: baseUnit * 2
    });
};
var $e72d27f6b1599862$var$IndicatorSeparator = function IndicatorSeparator(props) {
    var innerProps = props.innerProps;
    return (0, $byn9U.jsx)("span", (0, $kU09D.default)({}, innerProps, $e72d27f6b1599862$var$getStyleProps(props, 'indicatorSeparator', {
        'indicator-separator': true
    })));
};
// ==============================
// Loading
// ==============================
var $e72d27f6b1599862$var$loadingDotAnimations = (0, $byn9U.keyframes)($e72d27f6b1599862$var$_templateObject || ($e72d27f6b1599862$var$_templateObject = (0, $jqNEH.default)([
    "\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"
])));
var $e72d27f6b1599862$export$882b5998b3b9117c = function loadingIndicatorCSS(_ref5, unstyled) {
    var isFocused = _ref5.isFocused, size = _ref5.size, _ref5$theme = _ref5.theme, colors = _ref5$theme.colors, baseUnit = _ref5$theme.spacing.baseUnit;
    return (0, $1Xn5q.default)({
        label: 'loadingIndicator',
        display: 'flex',
        transition: 'color 150ms',
        alignSelf: 'center',
        fontSize: size,
        lineHeight: 1,
        marginRight: size,
        textAlign: 'center',
        verticalAlign: 'middle'
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2
    });
};
var $e72d27f6b1599862$var$LoadingDot = function LoadingDot(_ref6) {
    var delay = _ref6.delay, offset = _ref6.offset;
    return (0, $byn9U.jsx)("span", {
        css: /*#__PURE__*/ (0, $byn9U.css)({
            animation: "".concat($e72d27f6b1599862$var$loadingDotAnimations, " 1s ease-in-out ").concat(delay, "ms infinite;"),
            backgroundColor: 'currentColor',
            borderRadius: '1em',
            display: 'inline-block',
            marginLeft: offset ? '1em' : undefined,
            height: '1em',
            verticalAlign: 'top',
            width: '1em'
        }, "", "")
    });
};
var $e72d27f6b1599862$var$LoadingIndicator = function LoadingIndicator(props) {
    var innerProps = props.innerProps, isRtl = props.isRtl;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'loadingIndicator', {
        indicator: true,
        'loading-indicator': true
    }), innerProps), (0, $byn9U.jsx)($e72d27f6b1599862$var$LoadingDot, {
        delay: 0,
        offset: isRtl
    }), (0, $byn9U.jsx)($e72d27f6b1599862$var$LoadingDot, {
        delay: 160,
        offset: true
    }), (0, $byn9U.jsx)($e72d27f6b1599862$var$LoadingDot, {
        delay: 320,
        offset: !isRtl
    }));
};
$e72d27f6b1599862$var$LoadingIndicator.defaultProps = {
    size: 4
};
var $e72d27f6b1599862$export$4368d992c4eafac0 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, _ref$theme = _ref.theme, colors = _ref$theme.colors, borderRadius = _ref$theme.borderRadius, spacing = _ref$theme.spacing;
    return (0, $1Xn5q.default)({
        label: 'control',
        alignItems: 'center',
        cursor: 'default',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        minHeight: spacing.controlHeight,
        outline: '0 !important',
        position: 'relative',
        transition: 'all 100ms'
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
        borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
        borderRadius: borderRadius,
        borderStyle: 'solid',
        borderWidth: 1,
        boxShadow: isFocused ? "0 0 0 1px ".concat(colors.primary) : undefined,
        '&:hover': {
            borderColor: isFocused ? colors.primary : colors.neutral30
        }
    });
};
var $e72d27f6b1599862$var$Control = function Control(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, innerRef = props.innerRef, innerProps = props.innerProps, menuIsOpen = props.menuIsOpen;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({
        ref: innerRef
    }, $e72d27f6b1599862$var$getStyleProps(props, 'control', {
        control: true,
        'control--is-disabled': isDisabled,
        'control--is-focused': isFocused,
        'control--menu-is-open': menuIsOpen
    }), innerProps), children);
};
var $e72d27f6b1599862$var$_excluded$1 = [
    "data"
];
var $e72d27f6b1599862$export$39b482c5e57630a8 = function groupCSS(_ref, unstyled) {
    var spacing = _ref.theme.spacing;
    return unstyled ? {} : {
        paddingBottom: spacing.baseUnit * 2,
        paddingTop: spacing.baseUnit * 2
    };
};
var $e72d27f6b1599862$var$Group = function Group(props) {
    var children = props.children, cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, Heading = props.Heading, headingProps = props.headingProps, innerProps = props.innerProps, label = props.label, theme = props.theme, selectProps = props.selectProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'group', {
        group: true
    }), innerProps), (0, $byn9U.jsx)(Heading, (0, $kU09D.default)({}, headingProps, {
        selectProps: selectProps,
        theme: theme,
        getStyles: getStyles,
        getClassNames: getClassNames,
        cx: cx
    }), label), (0, $byn9U.jsx)("div", null, children));
};
var $e72d27f6b1599862$export$2d1720544b23b823 = function groupHeadingCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, colors = _ref2$theme.colors, spacing = _ref2$theme.spacing;
    return (0, $1Xn5q.default)({
        label: 'group',
        cursor: 'default',
        display: 'block'
    }, unstyled ? {} : {
        color: colors.neutral40,
        fontSize: '75%',
        fontWeight: 500,
        marginBottom: '0.25em',
        paddingLeft: spacing.baseUnit * 3,
        paddingRight: spacing.baseUnit * 3,
        textTransform: 'uppercase'
    });
};
var $e72d27f6b1599862$var$GroupHeading = function GroupHeading(props) {
    var _cleanCommonProps = $e72d27f6b1599862$var$cleanCommonProps(props);
    _cleanCommonProps.data;
    var innerProps = (0, $bwPfh.default)(_cleanCommonProps, $e72d27f6b1599862$var$_excluded$1);
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'groupHeading', {
        'group-heading': true
    }), innerProps));
};
var $e72d27f6b1599862$var$_excluded = [
    "innerRef",
    "isDisabled",
    "isHidden",
    "inputClassName"
];
var $e72d27f6b1599862$export$35e795649ee09318 = function inputCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, value = _ref.value, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $1Xn5q.default)((0, $1Xn5q.default)({
        visibility: isDisabled ? 'hidden' : 'visible',
        // force css to recompute when value change due to @emotion bug.
        // We can remove it whenever the bug is fixed.
        transform: value ? 'translateZ(0)' : ''
    }, $e72d27f6b1599862$var$containerStyle), unstyled ? {} : {
        margin: spacing.baseUnit / 2,
        paddingBottom: spacing.baseUnit / 2,
        paddingTop: spacing.baseUnit / 2,
        color: colors.neutral80
    });
};
var $e72d27f6b1599862$var$spacingStyle = {
    gridArea: '1 / 2',
    font: 'inherit',
    minWidth: '2px',
    border: 0,
    margin: 0,
    outline: 0,
    padding: 0
};
var $e72d27f6b1599862$var$containerStyle = {
    flex: '1 1 auto',
    display: 'inline-grid',
    gridArea: '1 / 1 / 2 / 3',
    gridTemplateColumns: '0 min-content',
    '&:after': (0, $1Xn5q.default)({
        content: 'attr(data-value) " "',
        visibility: 'hidden',
        whiteSpace: 'pre'
    }, $e72d27f6b1599862$var$spacingStyle)
};
var $e72d27f6b1599862$var$inputStyle = function inputStyle(isHidden) {
    return (0, $1Xn5q.default)({
        label: 'input',
        color: 'inherit',
        background: 0,
        opacity: isHidden ? 0 : 1,
        width: '100%'
    }, $e72d27f6b1599862$var$spacingStyle);
};
var $e72d27f6b1599862$var$Input = function Input(props) {
    var cx = props.cx, value = props.value;
    var _cleanCommonProps = $e72d27f6b1599862$var$cleanCommonProps(props), innerRef = _cleanCommonProps.innerRef, isDisabled = _cleanCommonProps.isDisabled, isHidden = _cleanCommonProps.isHidden, inputClassName = _cleanCommonProps.inputClassName, innerProps = (0, $bwPfh.default)(_cleanCommonProps, $e72d27f6b1599862$var$_excluded);
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'input', {
        'input-container': true
    }), {
        "data-value": value || ''
    }), (0, $byn9U.jsx)("input", (0, $kU09D.default)({
        className: cx({
            input: true
        }, inputClassName),
        ref: innerRef,
        style: $e72d27f6b1599862$var$inputStyle(isHidden),
        disabled: isDisabled
    }, innerProps)));
};
var $e72d27f6b1599862$export$ffb5f4729a158638 = function multiValueCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, borderRadius = _ref$theme.borderRadius, colors = _ref$theme.colors;
    return (0, $1Xn5q.default)({
        label: 'multiValue',
        display: 'flex',
        minWidth: 0
    }, unstyled ? {} : {
        backgroundColor: colors.neutral10,
        borderRadius: borderRadius / 2,
        margin: spacing.baseUnit / 2
    });
};
var $e72d27f6b1599862$export$9e5f44173e64f162 = function multiValueLabelCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, colors = _ref2$theme.colors, cropWithEllipsis = _ref2.cropWithEllipsis;
    return (0, $1Xn5q.default)({
        overflow: 'hidden',
        textOverflow: cropWithEllipsis || cropWithEllipsis === undefined ? 'ellipsis' : undefined,
        whiteSpace: 'nowrap'
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        color: colors.neutral80,
        fontSize: '85%',
        padding: 3,
        paddingLeft: 6
    });
};
var $e72d27f6b1599862$export$625550452a3fa3ec = function multiValueRemoveCSS(_ref3, unstyled) {
    var _ref3$theme = _ref3.theme, spacing = _ref3$theme.spacing, borderRadius = _ref3$theme.borderRadius, colors = _ref3$theme.colors, isFocused = _ref3.isFocused;
    return (0, $1Xn5q.default)({
        alignItems: 'center',
        display: 'flex'
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        backgroundColor: isFocused ? colors.dangerLight : undefined,
        paddingLeft: spacing.baseUnit,
        paddingRight: spacing.baseUnit,
        ':hover': {
            backgroundColor: colors.dangerLight,
            color: colors.danger
        }
    });
};
var $e72d27f6b1599862$var$MultiValueGeneric = function MultiValueGeneric(_ref4) {
    var children = _ref4.children, innerProps = _ref4.innerProps;
    return (0, $byn9U.jsx)("div", innerProps, children);
};
var $e72d27f6b1599862$var$MultiValueContainer = $e72d27f6b1599862$var$MultiValueGeneric;
var $e72d27f6b1599862$var$MultiValueLabel = $e72d27f6b1599862$var$MultiValueGeneric;
function $e72d27f6b1599862$var$MultiValueRemove(_ref5) {
    var children = _ref5.children, innerProps = _ref5.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({
        role: "button"
    }, innerProps), children || (0, $byn9U.jsx)($e72d27f6b1599862$var$CrossIcon, {
        size: 14
    }));
}
var $e72d27f6b1599862$var$MultiValue = function MultiValue(props) {
    var children = props.children, components = props.components, data = props.data, innerProps = props.innerProps, isDisabled = props.isDisabled, removeProps = props.removeProps, selectProps = props.selectProps;
    var Container = components.Container, Label = components.Label, Remove = components.Remove;
    return (0, $byn9U.jsx)(Container, {
        data: data,
        innerProps: (0, $1Xn5q.default)((0, $1Xn5q.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'multiValue', {
            'multi-value': true,
            'multi-value--is-disabled': isDisabled
        })), innerProps),
        selectProps: selectProps
    }, (0, $byn9U.jsx)(Label, {
        data: data,
        innerProps: (0, $1Xn5q.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'multiValueLabel', {
            'multi-value__label': true
        })),
        selectProps: selectProps
    }, children), (0, $byn9U.jsx)(Remove, {
        data: data,
        innerProps: (0, $1Xn5q.default)((0, $1Xn5q.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'multiValueRemove', {
            'multi-value__remove': true
        })), {}, {
            'aria-label': "Remove ".concat(children || 'option')
        }, removeProps),
        selectProps: selectProps
    }));
};
var $e72d27f6b1599862$export$90a7f3efeed30595 = function optionCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, isSelected = _ref.isSelected, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $1Xn5q.default)({
        label: 'option',
        cursor: 'default',
        display: 'block',
        fontSize: 'inherit',
        width: '100%',
        userSelect: 'none',
        WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)'
    }, unstyled ? {} : {
        backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : 'transparent',
        color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : 'inherit',
        padding: "".concat(spacing.baseUnit * 2, "px ").concat(spacing.baseUnit * 3, "px"),
        // provide some affordance on touch devices
        ':active': {
            backgroundColor: !isDisabled ? isSelected ? colors.primary : colors.primary50 : undefined
        }
    });
};
var $e72d27f6b1599862$var$Option = function Option(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, isSelected = props.isSelected, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'option', {
        option: true,
        'option--is-disabled': isDisabled,
        'option--is-focused': isFocused,
        'option--is-selected': isSelected
    }), {
        ref: innerRef,
        "aria-disabled": isDisabled
    }, innerProps), children);
};
var $e72d27f6b1599862$export$efccba1c4a2ef57b = function placeholderCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $1Xn5q.default)({
        label: 'placeholder',
        gridArea: '1 / 1 / 2 / 3'
    }, unstyled ? {} : {
        color: colors.neutral50,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var $e72d27f6b1599862$var$Placeholder = function Placeholder(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'placeholder', {
        placeholder: true
    }), innerProps), children);
};
var $e72d27f6b1599862$export$d141bba7fdc215a3 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $1Xn5q.default)({
        label: 'singleValue',
        gridArea: '1 / 1 / 2 / 3',
        maxWidth: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    }, unstyled ? {} : {
        color: isDisabled ? colors.neutral40 : colors.neutral80,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var $e72d27f6b1599862$var$SingleValue = function SingleValue(props) {
    var children = props.children, isDisabled = props.isDisabled, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'singleValue', {
        'single-value': true,
        'single-value--is-disabled': isDisabled
    }), innerProps), children);
};
var $e72d27f6b1599862$export$db3b6bfb95261072 = {
    ClearIndicator: $e72d27f6b1599862$var$ClearIndicator,
    Control: $e72d27f6b1599862$var$Control,
    DropdownIndicator: $e72d27f6b1599862$var$DropdownIndicator,
    DownChevron: $e72d27f6b1599862$var$DownChevron,
    CrossIcon: $e72d27f6b1599862$var$CrossIcon,
    Group: $e72d27f6b1599862$var$Group,
    GroupHeading: $e72d27f6b1599862$var$GroupHeading,
    IndicatorsContainer: $e72d27f6b1599862$var$IndicatorsContainer,
    IndicatorSeparator: $e72d27f6b1599862$var$IndicatorSeparator,
    Input: $e72d27f6b1599862$var$Input,
    LoadingIndicator: $e72d27f6b1599862$var$LoadingIndicator,
    Menu: $e72d27f6b1599862$var$Menu,
    MenuList: $e72d27f6b1599862$var$MenuList,
    MenuPortal: $e72d27f6b1599862$var$MenuPortal,
    LoadingMessage: $e72d27f6b1599862$var$LoadingMessage,
    NoOptionsMessage: $e72d27f6b1599862$var$NoOptionsMessage,
    MultiValue: $e72d27f6b1599862$var$MultiValue,
    MultiValueContainer: $e72d27f6b1599862$var$MultiValueContainer,
    MultiValueLabel: $e72d27f6b1599862$var$MultiValueLabel,
    MultiValueRemove: $e72d27f6b1599862$var$MultiValueRemove,
    Option: $e72d27f6b1599862$var$Option,
    Placeholder: $e72d27f6b1599862$var$Placeholder,
    SelectContainer: $e72d27f6b1599862$var$SelectContainer,
    SingleValue: $e72d27f6b1599862$var$SingleValue,
    ValueContainer: $e72d27f6b1599862$var$ValueContainer
};
var $e72d27f6b1599862$export$d66501df72047452 = function defaultComponents(props) {
    return (0, $1Xn5q.default)((0, $1Xn5q.default)({}, $e72d27f6b1599862$export$db3b6bfb95261072), props.components);
};

});
parcelRegister("jqNEH", function(module, exports) {

$parcel$export(module.exports, "default", () => $e256f68f3295e6bf$export$2e2bcd8739ae039);
function $e256f68f3295e6bf$export$2e2bcd8739ae039(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}

});

parcelRegister("5O3G9", function(module, exports) {

$parcel$export(module.exports, "autoUpdate", () => $023d07731ce8610f$export$deee3a793edee05f);

var $7MIdi = parcelRequire("7MIdi");
function $023d07731ce8610f$var$n(t) {
    var e;
    return (null == (e = t.ownerDocument) ? void 0 : e.defaultView) || window;
}
function $023d07731ce8610f$var$o(t) {
    return $023d07731ce8610f$var$n(t).getComputedStyle(t);
}
function $023d07731ce8610f$var$i(t) {
    return t instanceof $023d07731ce8610f$var$n(t).Node;
}
function $023d07731ce8610f$var$r(t) {
    return $023d07731ce8610f$var$i(t) ? (t.nodeName || "").toLowerCase() : "";
}
let $023d07731ce8610f$var$l;
function $023d07731ce8610f$var$c() {
    if ($023d07731ce8610f$var$l) return $023d07731ce8610f$var$l;
    const t = navigator.userAgentData;
    return t && Array.isArray(t.brands) ? ($023d07731ce8610f$var$l = t.brands.map((t)=>t.brand + "/" + t.version).join(" "), $023d07731ce8610f$var$l) : navigator.userAgent;
}
function $023d07731ce8610f$var$s(t) {
    return t instanceof $023d07731ce8610f$var$n(t).HTMLElement;
}
function $023d07731ce8610f$var$f(t) {
    return t instanceof $023d07731ce8610f$var$n(t).Element;
}
function $023d07731ce8610f$var$u(t) {
    if ("undefined" == typeof ShadowRoot) return !1;
    return t instanceof $023d07731ce8610f$var$n(t).ShadowRoot || t instanceof ShadowRoot;
}
function $023d07731ce8610f$var$a(t) {
    const { overflow: e, overflowX: n, overflowY: i, display: r } = $023d07731ce8610f$var$o(t);
    return /auto|scroll|overlay|hidden|clip/.test(e + i + n) && ![
        "inline",
        "contents"
    ].includes(r);
}
function $023d07731ce8610f$var$d(t) {
    return [
        "table",
        "td",
        "th"
    ].includes($023d07731ce8610f$var$r(t));
}
function $023d07731ce8610f$var$h(t) {
    const e = /firefox/i.test($023d07731ce8610f$var$c()), n = $023d07731ce8610f$var$o(t), i = n.backdropFilter || n.WebkitBackdropFilter;
    return "none" !== n.transform || "none" !== n.perspective || !!i && "none" !== i || e && "filter" === n.willChange || e && !!n.filter && "none" !== n.filter || [
        "transform",
        "perspective"
    ].some((t)=>n.willChange.includes(t)) || [
        "paint",
        "layout",
        "strict",
        "content"
    ].some((t)=>{
        const e = n.contain;
        return null != e && e.includes(t);
    });
}
function $023d07731ce8610f$var$p() {
    return /^((?!chrome|android).)*safari/i.test($023d07731ce8610f$var$c());
}
function $023d07731ce8610f$var$g(t) {
    return [
        "html",
        "body",
        "#document"
    ].includes($023d07731ce8610f$var$r(t));
}
const $023d07731ce8610f$var$m = Math.min, $023d07731ce8610f$var$y = Math.max, $023d07731ce8610f$var$x = Math.round;
function $023d07731ce8610f$var$w(t) {
    const e = $023d07731ce8610f$var$o(t);
    let n = parseFloat(e.width), i = parseFloat(e.height);
    const r = $023d07731ce8610f$var$s(t), l = r ? t.offsetWidth : n, c = r ? t.offsetHeight : i, f = $023d07731ce8610f$var$x(n) !== l || $023d07731ce8610f$var$x(i) !== c;
    return f && (n = l, i = c), {
        width: n,
        height: i,
        fallback: f
    };
}
function $023d07731ce8610f$var$v(t) {
    return $023d07731ce8610f$var$f(t) ? t : t.contextElement;
}
const $023d07731ce8610f$var$b = {
    x: 1,
    y: 1
};
function $023d07731ce8610f$var$L(t) {
    const e = $023d07731ce8610f$var$v(t);
    if (!$023d07731ce8610f$var$s(e)) return $023d07731ce8610f$var$b;
    const n = e.getBoundingClientRect(), { width: o, height: i, fallback: r } = $023d07731ce8610f$var$w(e);
    let l = (r ? $023d07731ce8610f$var$x(n.width) : n.width) / o, c = (r ? $023d07731ce8610f$var$x(n.height) : n.height) / i;
    return l && Number.isFinite(l) || (l = 1), c && Number.isFinite(c) || (c = 1), {
        x: l,
        y: c
    };
}
function $023d07731ce8610f$var$E(e, o, i, r) {
    var l, c;
    void 0 === o && (o = !1), void 0 === i && (i = !1);
    const s = e.getBoundingClientRect(), u = $023d07731ce8610f$var$v(e);
    let a = $023d07731ce8610f$var$b;
    o && (r ? $023d07731ce8610f$var$f(r) && (a = $023d07731ce8610f$var$L(r)) : a = $023d07731ce8610f$var$L(e));
    const d = u ? $023d07731ce8610f$var$n(u) : window, h = $023d07731ce8610f$var$p() && i;
    let g = (s.left + (h && (null == (l = d.visualViewport) ? void 0 : l.offsetLeft) || 0)) / a.x, m = (s.top + (h && (null == (c = d.visualViewport) ? void 0 : c.offsetTop) || 0)) / a.y, y = s.width / a.x, x = s.height / a.y;
    if (u) {
        const t = $023d07731ce8610f$var$n(u), e = r && $023d07731ce8610f$var$f(r) ? $023d07731ce8610f$var$n(r) : r;
        let o = t.frameElement;
        for(; o && r && e !== t;){
            const t = $023d07731ce8610f$var$L(o), e = o.getBoundingClientRect(), i = getComputedStyle(o);
            e.x += (o.clientLeft + parseFloat(i.paddingLeft)) * t.x, e.y += (o.clientTop + parseFloat(i.paddingTop)) * t.y, g *= t.x, m *= t.y, y *= t.x, x *= t.y, g += e.x, m += e.y, o = $023d07731ce8610f$var$n(o).frameElement;
        }
    }
    return (0, $7MIdi.rectToClientRect)({
        width: y,
        height: x,
        x: g,
        y: m
    });
}
function $023d07731ce8610f$var$T(t) {
    return (($023d07731ce8610f$var$i(t) ? t.ownerDocument : t.document) || window.document).documentElement;
}
function $023d07731ce8610f$var$R(t) {
    return $023d07731ce8610f$var$f(t) ? {
        scrollLeft: t.scrollLeft,
        scrollTop: t.scrollTop
    } : {
        scrollLeft: t.pageXOffset,
        scrollTop: t.pageYOffset
    };
}
function $023d07731ce8610f$var$C(t) {
    return $023d07731ce8610f$var$E($023d07731ce8610f$var$T(t)).left + $023d07731ce8610f$var$R(t).scrollLeft;
}
function $023d07731ce8610f$var$F(t) {
    if ("html" === $023d07731ce8610f$var$r(t)) return t;
    const e = t.assignedSlot || t.parentNode || $023d07731ce8610f$var$u(t) && t.host || $023d07731ce8610f$var$T(t);
    return $023d07731ce8610f$var$u(e) ? e.host : e;
}
function $023d07731ce8610f$var$W(t) {
    const e = $023d07731ce8610f$var$F(t);
    return $023d07731ce8610f$var$g(e) ? e.ownerDocument.body : $023d07731ce8610f$var$s(e) && $023d07731ce8610f$var$a(e) ? e : $023d07731ce8610f$var$W(e);
}
function $023d07731ce8610f$export$3b57c1601291186b(t, e) {
    var o;
    void 0 === e && (e = []);
    const i = $023d07731ce8610f$var$W(t), r = i === (null == (o = t.ownerDocument) ? void 0 : o.body), l = $023d07731ce8610f$var$n(i);
    return r ? e.concat(l, l.visualViewport || [], $023d07731ce8610f$var$a(i) ? i : []) : e.concat(i, $023d07731ce8610f$export$3b57c1601291186b(i));
}
function $023d07731ce8610f$var$S(e, i, r) {
    let l;
    if ("viewport" === i) l = function(t, e) {
        const o = $023d07731ce8610f$var$n(t), i = $023d07731ce8610f$var$T(t), r = o.visualViewport;
        let l = i.clientWidth, c = i.clientHeight, s = 0, f = 0;
        if (r) {
            l = r.width, c = r.height;
            const t = $023d07731ce8610f$var$p();
            (!t || t && "fixed" === e) && (s = r.offsetLeft, f = r.offsetTop);
        }
        return {
            width: l,
            height: c,
            x: s,
            y: f
        };
    }(e, r);
    else if ("document" === i) l = function(t) {
        const e = $023d07731ce8610f$var$T(t), n = $023d07731ce8610f$var$R(t), i = t.ownerDocument.body, r = $023d07731ce8610f$var$y(e.scrollWidth, e.clientWidth, i.scrollWidth, i.clientWidth), l = $023d07731ce8610f$var$y(e.scrollHeight, e.clientHeight, i.scrollHeight, i.clientHeight);
        let c = -n.scrollLeft + $023d07731ce8610f$var$C(t);
        const s = -n.scrollTop;
        return "rtl" === $023d07731ce8610f$var$o(i).direction && (c += $023d07731ce8610f$var$y(e.clientWidth, i.clientWidth) - r), {
            width: r,
            height: l,
            x: c,
            y: s
        };
    }($023d07731ce8610f$var$T(e));
    else if ($023d07731ce8610f$var$f(i)) l = function(t, e) {
        const n = $023d07731ce8610f$var$E(t, !0, "fixed" === e), o = n.top + t.clientTop, i = n.left + t.clientLeft, r = $023d07731ce8610f$var$s(t) ? $023d07731ce8610f$var$L(t) : {
            x: 1,
            y: 1
        };
        return {
            width: t.clientWidth * r.x,
            height: t.clientHeight * r.y,
            x: i * r.x,
            y: o * r.y
        };
    }(i, r);
    else {
        const t = {
            ...i
        };
        if ($023d07731ce8610f$var$p()) {
            var c, u;
            const o = $023d07731ce8610f$var$n(e);
            t.x -= (null == (c = o.visualViewport) ? void 0 : c.offsetLeft) || 0, t.y -= (null == (u = o.visualViewport) ? void 0 : u.offsetTop) || 0;
        }
        l = t;
    }
    return (0, $7MIdi.rectToClientRect)(l);
}
function $023d07731ce8610f$var$A(t, e) {
    return $023d07731ce8610f$var$s(t) && "fixed" !== $023d07731ce8610f$var$o(t).position ? e ? e(t) : t.offsetParent : null;
}
function $023d07731ce8610f$var$H(t, e) {
    const i = $023d07731ce8610f$var$n(t);
    if (!$023d07731ce8610f$var$s(t)) return i;
    let l = $023d07731ce8610f$var$A(t, e);
    for(; l && $023d07731ce8610f$var$d(l) && "static" === $023d07731ce8610f$var$o(l).position;)l = $023d07731ce8610f$var$A(l, e);
    return l && ("html" === $023d07731ce8610f$var$r(l) || "body" === $023d07731ce8610f$var$r(l) && "static" === $023d07731ce8610f$var$o(l).position && !$023d07731ce8610f$var$h(l)) ? i : l || function(t) {
        let e = $023d07731ce8610f$var$F(t);
        for(; $023d07731ce8610f$var$s(e) && !$023d07731ce8610f$var$g(e);){
            if ($023d07731ce8610f$var$h(e)) return e;
            e = $023d07731ce8610f$var$F(e);
        }
        return null;
    }(t) || i;
}
function $023d07731ce8610f$var$V(t, e, n) {
    const o = $023d07731ce8610f$var$s(e), i = $023d07731ce8610f$var$T(e), l = $023d07731ce8610f$var$E(t, !0, "fixed" === n, e);
    let c = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const f = {
        x: 0,
        y: 0
    };
    if (o || !o && "fixed" !== n) {
        if (("body" !== $023d07731ce8610f$var$r(e) || $023d07731ce8610f$var$a(i)) && (c = $023d07731ce8610f$var$R(e)), $023d07731ce8610f$var$s(e)) {
            const t = $023d07731ce8610f$var$E(e, !0);
            f.x = t.x + e.clientLeft, f.y = t.y + e.clientTop;
        } else i && (f.x = $023d07731ce8610f$var$C(i));
    }
    return {
        x: l.left + c.scrollLeft - f.x,
        y: l.top + c.scrollTop - f.y,
        width: l.width,
        height: l.height
    };
}
const $023d07731ce8610f$export$722a64dea1b767dc = {
    getClippingRect: function(t) {
        let { element: e, boundary: n, rootBoundary: i, strategy: l } = t;
        const c = "clippingAncestors" === n ? function(t, e) {
            const n = e.get(t);
            if (n) return n;
            let i = $023d07731ce8610f$export$3b57c1601291186b(t).filter((t)=>$023d07731ce8610f$var$f(t) && "body" !== $023d07731ce8610f$var$r(t)), l = null;
            const c = "fixed" === $023d07731ce8610f$var$o(t).position;
            let s = c ? $023d07731ce8610f$var$F(t) : t;
            for(; $023d07731ce8610f$var$f(s) && !$023d07731ce8610f$var$g(s);){
                const t = $023d07731ce8610f$var$o(s), e = $023d07731ce8610f$var$h(s);
                "fixed" === t.position ? l = null : (c ? e || l : e || "static" !== t.position || !l || ![
                    "absolute",
                    "fixed"
                ].includes(l.position)) ? l = t : i = i.filter((t)=>t !== s), s = $023d07731ce8610f$var$F(s);
            }
            return e.set(t, i), i;
        }(e, this._c) : [].concat(n), s = [
            ...c,
            i
        ], u = s[0], a = s.reduce((t, n)=>{
            const o = $023d07731ce8610f$var$S(e, n, l);
            return t.top = $023d07731ce8610f$var$y(o.top, t.top), t.right = $023d07731ce8610f$var$m(o.right, t.right), t.bottom = $023d07731ce8610f$var$m(o.bottom, t.bottom), t.left = $023d07731ce8610f$var$y(o.left, t.left), t;
        }, $023d07731ce8610f$var$S(e, u, l));
        return {
            width: a.right - a.left,
            height: a.bottom - a.top,
            x: a.left,
            y: a.top
        };
    },
    convertOffsetParentRelativeRectToViewportRelativeRect: function(t) {
        let { rect: e, offsetParent: n, strategy: o } = t;
        const i = $023d07731ce8610f$var$s(n), l = $023d07731ce8610f$var$T(n);
        if (n === l) return e;
        let c = {
            scrollLeft: 0,
            scrollTop: 0
        }, f = {
            x: 1,
            y: 1
        };
        const u = {
            x: 0,
            y: 0
        };
        if ((i || !i && "fixed" !== o) && (("body" !== $023d07731ce8610f$var$r(n) || $023d07731ce8610f$var$a(l)) && (c = $023d07731ce8610f$var$R(n)), $023d07731ce8610f$var$s(n))) {
            const t = $023d07731ce8610f$var$E(n);
            f = $023d07731ce8610f$var$L(n), u.x = t.x + n.clientLeft, u.y = t.y + n.clientTop;
        }
        return {
            width: e.width * f.x,
            height: e.height * f.y,
            x: e.x * f.x - c.scrollLeft * f.x + u.x,
            y: e.y * f.y - c.scrollTop * f.y + u.y
        };
    },
    isElement: $023d07731ce8610f$var$f,
    getDimensions: function(t) {
        return $023d07731ce8610f$var$w(t);
    },
    getOffsetParent: $023d07731ce8610f$var$H,
    getDocumentElement: $023d07731ce8610f$var$T,
    getScale: $023d07731ce8610f$var$L,
    async getElementRects (t) {
        let { reference: e, floating: n, strategy: o } = t;
        const i = this.getOffsetParent || $023d07731ce8610f$var$H, r = this.getDimensions;
        return {
            reference: $023d07731ce8610f$var$V(e, await i(n), o),
            floating: {
                x: 0,
                y: 0,
                ...await r(n)
            }
        };
    },
    getClientRects: (t)=>Array.from(t.getClientRects()),
    isRTL: (t)=>"rtl" === $023d07731ce8610f$var$o(t).direction
};
function $023d07731ce8610f$export$deee3a793edee05f(t, e, n, o) {
    void 0 === o && (o = {});
    const { ancestorScroll: i = !0, ancestorResize: r = !0, elementResize: l = !0, animationFrame: c = !1 } = o, s = i && !c, u = s || r ? [
        ...$023d07731ce8610f$var$f(t) ? $023d07731ce8610f$export$3b57c1601291186b(t) : t.contextElement ? $023d07731ce8610f$export$3b57c1601291186b(t.contextElement) : [],
        ...$023d07731ce8610f$export$3b57c1601291186b(e)
    ] : [];
    u.forEach((t)=>{
        s && t.addEventListener("scroll", n, {
            passive: !0
        }), r && t.addEventListener("resize", n);
    });
    let a, d = null;
    l && (d = new ResizeObserver(()=>{
        n();
    }), $023d07731ce8610f$var$f(t) && !c && d.observe(t), $023d07731ce8610f$var$f(t) || !t.contextElement || c || d.observe(t.contextElement), d.observe(e));
    let h = c ? $023d07731ce8610f$var$E(t) : null;
    return c && function e() {
        const o = $023d07731ce8610f$var$E(t);
        !h || o.x === h.x && o.y === h.y && o.width === h.width && o.height === h.height || n();
        h = o, a = requestAnimationFrame(e);
    }(), n(), ()=>{
        var t;
        u.forEach((t)=>{
            s && t.removeEventListener("scroll", n), r && t.removeEventListener("resize", n);
        }), null == (t = d) || t.disconnect(), d = null, c && cancelAnimationFrame(a);
    };
}
const $023d07731ce8610f$export$48a53dcb22e581d0 = (t, n, o)=>{
    const i = new Map, r = {
        platform: $023d07731ce8610f$export$722a64dea1b767dc,
        ...o
    }, l = {
        ...r.platform,
        _c: i
    };
    return (0, $7MIdi.computePosition)(t, n, {
        ...r,
        platform: l
    });
};

});
parcelRegister("7MIdi", function(module, exports) {

$parcel$export(module.exports, "computePosition", () => $4dacbd6c81f90f16$export$48a53dcb22e581d0);
$parcel$export(module.exports, "rectToClientRect", () => $4dacbd6c81f90f16$export$ee05aea0aeecbad4);
function $4dacbd6c81f90f16$var$t(t) {
    return t.split("-")[1];
}
function $4dacbd6c81f90f16$var$e(t) {
    return "y" === t ? "height" : "width";
}
function $4dacbd6c81f90f16$var$n(t) {
    return t.split("-")[0];
}
function $4dacbd6c81f90f16$var$o(t) {
    return [
        "top",
        "bottom"
    ].includes($4dacbd6c81f90f16$var$n(t)) ? "x" : "y";
}
function $4dacbd6c81f90f16$var$i(i, r, a) {
    let { reference: l, floating: s } = i;
    const c = l.x + l.width / 2 - s.width / 2, f = l.y + l.height / 2 - s.height / 2, m = $4dacbd6c81f90f16$var$o(r), u = $4dacbd6c81f90f16$var$e(m), g = l[u] / 2 - s[u] / 2, d = "x" === m;
    let p;
    switch($4dacbd6c81f90f16$var$n(r)){
        case "top":
            p = {
                x: c,
                y: l.y - s.height
            };
            break;
        case "bottom":
            p = {
                x: c,
                y: l.y + l.height
            };
            break;
        case "right":
            p = {
                x: l.x + l.width,
                y: f
            };
            break;
        case "left":
            p = {
                x: l.x - s.width,
                y: f
            };
            break;
        default:
            p = {
                x: l.x,
                y: l.y
            };
    }
    switch($4dacbd6c81f90f16$var$t(r)){
        case "start":
            p[m] -= g * (a && d ? -1 : 1);
            break;
        case "end":
            p[m] += g * (a && d ? -1 : 1);
    }
    return p;
}
const $4dacbd6c81f90f16$export$48a53dcb22e581d0 = async (t, e, n)=>{
    const { placement: o = "bottom", strategy: r = "absolute", middleware: a = [], platform: l } = n, s = a.filter(Boolean), c = await (null == l.isRTL ? void 0 : l.isRTL(e));
    let f = await l.getElementRects({
        reference: t,
        floating: e,
        strategy: r
    }), { x: m, y: u } = $4dacbd6c81f90f16$var$i(f, o, c), g = o, d = {}, p = 0;
    for(let n = 0; n < s.length; n++){
        const { name: a, fn: h } = s[n], { x: y, y: x, data: w, reset: v } = await h({
            x: m,
            y: u,
            initialPlacement: o,
            placement: g,
            strategy: r,
            middlewareData: d,
            rects: f,
            platform: l,
            elements: {
                reference: t,
                floating: e
            }
        });
        m = null != y ? y : m, u = null != x ? x : u, d = {
            ...d,
            [a]: {
                ...d[a],
                ...w
            }
        }, v && p <= 50 && (p++, "object" == typeof v && (v.placement && (g = v.placement), v.rects && (f = !0 === v.rects ? await l.getElementRects({
            reference: t,
            floating: e,
            strategy: r
        }) : v.rects), { x: m, y: u } = $4dacbd6c81f90f16$var$i(f, g, c)), n = -1);
    }
    return {
        x: m,
        y: u,
        placement: g,
        strategy: r,
        middlewareData: d
    };
};
function $4dacbd6c81f90f16$var$a(t) {
    return "number" != typeof t ? function(t) {
        return {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            ...t
        };
    }(t) : {
        top: t,
        right: t,
        bottom: t,
        left: t
    };
}
function $4dacbd6c81f90f16$export$ee05aea0aeecbad4(t) {
    return {
        ...t,
        top: t.y,
        left: t.x,
        right: t.x + t.width,
        bottom: t.y + t.height
    };
}
async function $4dacbd6c81f90f16$export$37b6bde19b108ecc(t, e) {
    var n;
    void 0 === e && (e = {});
    const { x: o, y: i, platform: r, rects: s, elements: c, strategy: f } = t, { boundary: m = "clippingAncestors", rootBoundary: u = "viewport", elementContext: g = "floating", altBoundary: d = !1, padding: p = 0 } = e, h = $4dacbd6c81f90f16$var$a(p), y = c[d ? "floating" === g ? "reference" : "floating" : g], x = $4dacbd6c81f90f16$export$ee05aea0aeecbad4(await r.getClippingRect({
        element: null == (n = await (null == r.isElement ? void 0 : r.isElement(y))) || n ? y : y.contextElement || await (null == r.getDocumentElement ? void 0 : r.getDocumentElement(c.floating)),
        boundary: m,
        rootBoundary: u,
        strategy: f
    })), w = "floating" === g ? {
        ...s.floating,
        x: o,
        y: i
    } : s.reference, v = await (null == r.getOffsetParent ? void 0 : r.getOffsetParent(c.floating)), b = await (null == r.isElement ? void 0 : r.isElement(v)) && await (null == r.getScale ? void 0 : r.getScale(v)) || {
        x: 1,
        y: 1
    }, A = $4dacbd6c81f90f16$export$ee05aea0aeecbad4(r.convertOffsetParentRelativeRectToViewportRelativeRect ? await r.convertOffsetParentRelativeRectToViewportRelativeRect({
        rect: w,
        offsetParent: v,
        strategy: f
    }) : w);
    return {
        top: (x.top - A.top + h.top) / b.y,
        bottom: (A.bottom - x.bottom + h.bottom) / b.y,
        left: (x.left - A.left + h.left) / b.x,
        right: (A.right - x.right + h.right) / b.x
    };
}
const $4dacbd6c81f90f16$var$c = Math.min, $4dacbd6c81f90f16$var$f = Math.max;
function $4dacbd6c81f90f16$var$m(t, e, n) {
    return $4dacbd6c81f90f16$var$f(t, $4dacbd6c81f90f16$var$c(e, n));
}
const $4dacbd6c81f90f16$export$f2120bbfa5450bd2 = (n)=>({
        name: "arrow",
        options: n,
        async fn (i) {
            const { element: r, padding: l = 0 } = n || {}, { x: s, y: c, placement: f, rects: u, platform: g, elements: d } = i;
            if (null == r) return {};
            const p = $4dacbd6c81f90f16$var$a(l), h = {
                x: s,
                y: c
            }, y = $4dacbd6c81f90f16$var$o(f), x = $4dacbd6c81f90f16$var$e(y), w = await g.getDimensions(r), v = "y" === y, b = v ? "top" : "left", A = v ? "bottom" : "right", R = v ? "clientHeight" : "clientWidth", P = u.reference[x] + u.reference[y] - h[y] - u.floating[x], E = h[y] - u.reference[y], T = await (null == g.getOffsetParent ? void 0 : g.getOffsetParent(r));
            let D = T ? T[R] : 0;
            D && await (null == g.isElement ? void 0 : g.isElement(T)) || (D = d.floating[R] || u.floating[x]);
            const L = P / 2 - E / 2, k = p[b], O = D - w[x] - p[A], B = D / 2 - w[x] / 2 + L, C = $4dacbd6c81f90f16$var$m(k, B, O), H = null != $4dacbd6c81f90f16$var$t(f) && B != C && u.reference[x] / 2 - (B < k ? p[b] : p[A]) - w[x] / 2 < 0;
            return {
                [y]: h[y] - (H ? B < k ? k - B : O - B : 0),
                data: {
                    [y]: C,
                    centerOffset: B - C
                }
            };
        }
    }), $4dacbd6c81f90f16$var$g = [
    "top",
    "right",
    "bottom",
    "left"
], $4dacbd6c81f90f16$var$d = $4dacbd6c81f90f16$var$g.reduce((t, e)=>t.concat(e, e + "-start", e + "-end"), []), $4dacbd6c81f90f16$var$p = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $4dacbd6c81f90f16$var$h(t) {
    return t.replace(/left|right|bottom|top/g, (t)=>$4dacbd6c81f90f16$var$p[t]);
}
function $4dacbd6c81f90f16$var$y(n, i, r) {
    void 0 === r && (r = !1);
    const a = $4dacbd6c81f90f16$var$t(n), l = $4dacbd6c81f90f16$var$o(n), s = $4dacbd6c81f90f16$var$e(l);
    let c = "x" === l ? a === (r ? "end" : "start") ? "right" : "left" : "start" === a ? "bottom" : "top";
    return i.reference[s] > i.floating[s] && (c = $4dacbd6c81f90f16$var$h(c)), {
        main: c,
        cross: $4dacbd6c81f90f16$var$h(c)
    };
}
const $4dacbd6c81f90f16$var$x = {
    start: "end",
    end: "start"
};
function $4dacbd6c81f90f16$var$w(t) {
    return t.replace(/start|end/g, (t)=>$4dacbd6c81f90f16$var$x[t]);
}
const $4dacbd6c81f90f16$export$91fb6ecbd551914 = function(e) {
    return void 0 === e && (e = {}), {
        name: "autoPlacement",
        options: e,
        async fn (o) {
            var i, r, a;
            const { rects: l, middlewareData: c, placement: f, platform: m, elements: u } = o, { crossAxis: g = !1, alignment: p, allowedPlacements: h = $4dacbd6c81f90f16$var$d, autoAlignment: x = !0, ...v } = e, b = void 0 !== p || h === $4dacbd6c81f90f16$var$d ? function(e, o, i) {
                return (e ? [
                    ...i.filter((n)=>$4dacbd6c81f90f16$var$t(n) === e),
                    ...i.filter((n)=>$4dacbd6c81f90f16$var$t(n) !== e)
                ] : i.filter((t)=>$4dacbd6c81f90f16$var$n(t) === t)).filter((n)=>!e || $4dacbd6c81f90f16$var$t(n) === e || !!o && $4dacbd6c81f90f16$var$w(n) !== n);
            }(p || null, x, h) : h, A = await $4dacbd6c81f90f16$export$37b6bde19b108ecc(o, v), R = (null == (i = c.autoPlacement) ? void 0 : i.index) || 0, P = b[R];
            if (null == P) return {};
            const { main: E, cross: T } = $4dacbd6c81f90f16$var$y(P, l, await (null == m.isRTL ? void 0 : m.isRTL(u.floating)));
            if (f !== P) return {
                reset: {
                    placement: b[0]
                }
            };
            const D = [
                A[$4dacbd6c81f90f16$var$n(P)],
                A[E],
                A[T]
            ], L = [
                ...(null == (r = c.autoPlacement) ? void 0 : r.overflows) || [],
                {
                    placement: P,
                    overflows: D
                }
            ], k = b[R + 1];
            if (k) return {
                data: {
                    index: R + 1,
                    overflows: L
                },
                reset: {
                    placement: k
                }
            };
            const O = L.map((e)=>{
                const n = $4dacbd6c81f90f16$var$t(e.placement);
                return [
                    e.placement,
                    n && g ? e.overflows.slice(0, 2).reduce((t, e)=>t + e, 0) : e.overflows[0],
                    e.overflows
                ];
            }).sort((t, e)=>t[1] - e[1]), B = (null == (a = O.filter((e)=>e[2].slice(0, $4dacbd6c81f90f16$var$t(e[0]) ? 2 : 3).every((t)=>t <= 0))[0]) ? void 0 : a[0]) || O[0][0];
            return B !== f ? {
                data: {
                    index: R + 1,
                    overflows: L
                },
                reset: {
                    placement: B
                }
            } : {};
        }
    };
};
const $4dacbd6c81f90f16$export$8a83211c878a3f1f = function(e) {
    return void 0 === e && (e = {}), {
        name: "flip",
        options: e,
        async fn (o) {
            var i;
            const { placement: r, middlewareData: a, rects: l, initialPlacement: c, platform: f, elements: m } = o, { mainAxis: u = !0, crossAxis: g = !0, fallbackPlacements: d, fallbackStrategy: p = "bestFit", fallbackAxisSideDirection: x = "none", flipAlignment: v = !0, ...b } = e, A = $4dacbd6c81f90f16$var$n(r), R = $4dacbd6c81f90f16$var$n(c) === c, P = await (null == f.isRTL ? void 0 : f.isRTL(m.floating)), E = d || (R || !v ? [
                $4dacbd6c81f90f16$var$h(c)
            ] : function(t) {
                const e = $4dacbd6c81f90f16$var$h(t);
                return [
                    $4dacbd6c81f90f16$var$w(t),
                    e,
                    $4dacbd6c81f90f16$var$w(e)
                ];
            }(c));
            d || "none" === x || E.push(...function(e, o, i, r) {
                const a = $4dacbd6c81f90f16$var$t(e);
                let l = function(t, e, n) {
                    const o = [
                        "left",
                        "right"
                    ], i = [
                        "right",
                        "left"
                    ], r = [
                        "top",
                        "bottom"
                    ], a = [
                        "bottom",
                        "top"
                    ];
                    switch(t){
                        case "top":
                        case "bottom":
                            return n ? e ? i : o : e ? o : i;
                        case "left":
                        case "right":
                            return e ? r : a;
                        default:
                            return [];
                    }
                }($4dacbd6c81f90f16$var$n(e), "start" === i, r);
                return a && (l = l.map((t)=>t + "-" + a), o && (l = l.concat(l.map($4dacbd6c81f90f16$var$w)))), l;
            }(c, v, x, P));
            const T = [
                c,
                ...E
            ], D = await $4dacbd6c81f90f16$export$37b6bde19b108ecc(o, b), L = [];
            let k = (null == (i = a.flip) ? void 0 : i.overflows) || [];
            if (u && L.push(D[A]), g) {
                const { main: t, cross: e } = $4dacbd6c81f90f16$var$y(r, l, P);
                L.push(D[t], D[e]);
            }
            if (k = [
                ...k,
                {
                    placement: r,
                    overflows: L
                }
            ], !L.every((t)=>t <= 0)) {
                var O, B;
                const t = ((null == (O = a.flip) ? void 0 : O.index) || 0) + 1, e = T[t];
                if (e) return {
                    data: {
                        index: t,
                        overflows: k
                    },
                    reset: {
                        placement: e
                    }
                };
                let n = null == (B = k.filter((t)=>t.overflows[0] <= 0).sort((t, e)=>t.overflows[1] - e.overflows[1])[0]) ? void 0 : B.placement;
                if (!n) switch(p){
                    case "bestFit":
                        {
                            var C;
                            const t = null == (C = k.map((t)=>[
                                    t.placement,
                                    t.overflows.filter((t)=>t > 0).reduce((t, e)=>t + e, 0)
                                ]).sort((t, e)=>t[1] - e[1])[0]) ? void 0 : C[0];
                            t && (n = t);
                            break;
                        }
                    case "initialPlacement":
                        n = c;
                }
                if (r !== n) return {
                    reset: {
                        placement: n
                    }
                };
            }
            return {};
        }
    };
};
function $4dacbd6c81f90f16$var$A(t, e) {
    return {
        top: t.top - e.height,
        right: t.right - e.width,
        bottom: t.bottom - e.height,
        left: t.left - e.width
    };
}
function $4dacbd6c81f90f16$var$R(t) {
    return $4dacbd6c81f90f16$var$g.some((e)=>t[e] >= 0);
}
const $4dacbd6c81f90f16$export$fe8985bb6374093c = function(t) {
    return void 0 === t && (t = {}), {
        name: "hide",
        options: t,
        async fn (e) {
            const { strategy: n = "referenceHidden", ...o } = t, { rects: i } = e;
            switch(n){
                case "referenceHidden":
                    {
                        const t = $4dacbd6c81f90f16$var$A(await $4dacbd6c81f90f16$export$37b6bde19b108ecc(e, {
                            ...o,
                            elementContext: "reference"
                        }), i.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: t,
                                referenceHidden: $4dacbd6c81f90f16$var$R(t)
                            }
                        };
                    }
                case "escaped":
                    {
                        const t = $4dacbd6c81f90f16$var$A(await $4dacbd6c81f90f16$export$37b6bde19b108ecc(e, {
                            ...o,
                            altBoundary: !0
                        }), i.floating);
                        return {
                            data: {
                                escapedOffsets: t,
                                escaped: $4dacbd6c81f90f16$var$R(t)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $4dacbd6c81f90f16$var$E(t) {
    const e = $4dacbd6c81f90f16$var$c(...t.map((t)=>t.left)), n = $4dacbd6c81f90f16$var$c(...t.map((t)=>t.top));
    return {
        x: e,
        y: n,
        width: $4dacbd6c81f90f16$var$f(...t.map((t)=>t.right)) - e,
        height: $4dacbd6c81f90f16$var$f(...t.map((t)=>t.bottom)) - n
    };
}
const $4dacbd6c81f90f16$export$18c8ad048e32c7d5 = function(t) {
    return void 0 === t && (t = {}), {
        name: "inline",
        options: t,
        async fn (e) {
            const { placement: i, elements: r, rects: s, platform: m, strategy: u } = e, { padding: g = 2, x: d, y: p } = t, h = Array.from(await (null == m.getClientRects ? void 0 : m.getClientRects(r.reference)) || []), y = function(t) {
                const e = t.slice().sort((t, e)=>t.y - e.y), n = [];
                let o = null;
                for(let t = 0; t < e.length; t++){
                    const i = e[t];
                    !o || i.y - o.y > o.height / 2 ? n.push([
                        i
                    ]) : n[n.length - 1].push(i), o = i;
                }
                return n.map((t)=>$4dacbd6c81f90f16$export$ee05aea0aeecbad4($4dacbd6c81f90f16$var$E(t)));
            }(h), x = $4dacbd6c81f90f16$export$ee05aea0aeecbad4($4dacbd6c81f90f16$var$E(h)), w = $4dacbd6c81f90f16$var$a(g);
            const v = await m.getElementRects({
                reference: {
                    getBoundingClientRect: function() {
                        if (2 === y.length && y[0].left > y[1].right && null != d && null != p) return y.find((t)=>d > t.left - w.left && d < t.right + w.right && p > t.top - w.top && p < t.bottom + w.bottom) || x;
                        if (y.length >= 2) {
                            if ("x" === $4dacbd6c81f90f16$var$o(i)) {
                                const t = y[0], e = y[y.length - 1], o = "top" === $4dacbd6c81f90f16$var$n(i), r = t.top, a = e.bottom, l = o ? t.left : e.left, s = o ? t.right : e.right;
                                return {
                                    top: r,
                                    bottom: a,
                                    left: l,
                                    right: s,
                                    width: s - l,
                                    height: a - r,
                                    x: l,
                                    y: r
                                };
                            }
                            const t = "left" === $4dacbd6c81f90f16$var$n(i), e = $4dacbd6c81f90f16$var$f(...y.map((t)=>t.right)), r = $4dacbd6c81f90f16$var$c(...y.map((t)=>t.left)), a = y.filter((n)=>t ? n.left === r : n.right === e), l = a[0].top, s = a[a.length - 1].bottom;
                            return {
                                top: l,
                                bottom: s,
                                left: r,
                                right: e,
                                width: e - r,
                                height: s - l,
                                x: r,
                                y: l
                            };
                        }
                        return x;
                    }
                },
                floating: r.floating,
                strategy: u
            });
            return s.reference.x !== v.reference.x || s.reference.y !== v.reference.y || s.reference.width !== v.reference.width || s.reference.height !== v.reference.height ? {
                reset: {
                    rects: v
                }
            } : {};
        }
    };
};
const $4dacbd6c81f90f16$export$cc800923e997bb8 = function(e) {
    return void 0 === e && (e = 0), {
        name: "offset",
        options: e,
        async fn (i) {
            const { x: r, y: a } = i, l = await async function(e, i) {
                const { placement: r, platform: a, elements: l } = e, s = await (null == a.isRTL ? void 0 : a.isRTL(l.floating)), c = $4dacbd6c81f90f16$var$n(r), f = $4dacbd6c81f90f16$var$t(r), m = "x" === $4dacbd6c81f90f16$var$o(r), u = [
                    "left",
                    "top"
                ].includes(c) ? -1 : 1, g = s && m ? -1 : 1, d = "function" == typeof i ? i(e) : i;
                let { mainAxis: p, crossAxis: h, alignmentAxis: y } = "number" == typeof d ? {
                    mainAxis: d,
                    crossAxis: 0,
                    alignmentAxis: null
                } : {
                    mainAxis: 0,
                    crossAxis: 0,
                    alignmentAxis: null,
                    ...d
                };
                return f && "number" == typeof y && (h = "end" === f ? -1 * y : y), m ? {
                    x: h * g,
                    y: p * u
                } : {
                    x: p * u,
                    y: h * g
                };
            }(i, e);
            return {
                x: r + l.x,
                y: a + l.y,
                data: l
            };
        }
    };
};
function $4dacbd6c81f90f16$var$L(t) {
    return "x" === t ? "y" : "x";
}
const $4dacbd6c81f90f16$export$fba63a578e423eb = function(t) {
    return void 0 === t && (t = {}), {
        name: "shift",
        options: t,
        async fn (e) {
            const { x: i, y: r, placement: a } = e, { mainAxis: l = !0, crossAxis: c = !1, limiter: f = {
                fn: (t)=>{
                    let { x: e, y: n } = t;
                    return {
                        x: e,
                        y: n
                    };
                }
            }, ...u } = t, g = {
                x: i,
                y: r
            }, d = await $4dacbd6c81f90f16$export$37b6bde19b108ecc(e, u), p = $4dacbd6c81f90f16$var$o($4dacbd6c81f90f16$var$n(a)), h = $4dacbd6c81f90f16$var$L(p);
            let y = g[p], x = g[h];
            if (l) {
                const t = "y" === p ? "bottom" : "right";
                y = $4dacbd6c81f90f16$var$m(y + d["y" === p ? "top" : "left"], y, y - d[t]);
            }
            if (c) {
                const t = "y" === h ? "bottom" : "right";
                x = $4dacbd6c81f90f16$var$m(x + d["y" === h ? "top" : "left"], x, x - d[t]);
            }
            const w = f.fn({
                ...e,
                [p]: y,
                [h]: x
            });
            return {
                ...w,
                data: {
                    x: w.x - i,
                    y: w.y - r
                }
            };
        }
    };
}, $4dacbd6c81f90f16$export$7bf07e38f3dc4b69 = function(t) {
    return void 0 === t && (t = {}), {
        options: t,
        fn (e) {
            const { x: i, y: r, placement: a, rects: l, middlewareData: s } = e, { offset: c = 0, mainAxis: f = !0, crossAxis: m = !0 } = t, u = {
                x: i,
                y: r
            }, g = $4dacbd6c81f90f16$var$o(a), d = $4dacbd6c81f90f16$var$L(g);
            let p = u[g], h = u[d];
            const y = "function" == typeof c ? c(e) : c, x = "number" == typeof y ? {
                mainAxis: y,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...y
            };
            if (f) {
                const t = "y" === g ? "height" : "width", e = l.reference[g] - l.floating[t] + x.mainAxis, n = l.reference[g] + l.reference[t] - x.mainAxis;
                p < e ? p = e : p > n && (p = n);
            }
            if (m) {
                var w, v;
                const t = "y" === g ? "width" : "height", e = [
                    "top",
                    "left"
                ].includes($4dacbd6c81f90f16$var$n(a)), o = l.reference[d] - l.floating[t] + (e && (null == (w = s.offset) ? void 0 : w[d]) || 0) + (e ? 0 : x.crossAxis), i = l.reference[d] + l.reference[t] + (e ? 0 : (null == (v = s.offset) ? void 0 : v[d]) || 0) - (e ? x.crossAxis : 0);
                h < o ? h = o : h > i && (h = i);
            }
            return {
                [g]: p,
                [d]: h
            };
        }
    };
}, $4dacbd6c81f90f16$export$346677f925de839c = function(e) {
    return void 0 === e && (e = {}), {
        name: "size",
        options: e,
        async fn (i) {
            const { placement: r, rects: a, platform: l, elements: m } = i, { apply: u = ()=>{}, ...g } = e, d = await $4dacbd6c81f90f16$export$37b6bde19b108ecc(i, g), p = $4dacbd6c81f90f16$var$n(r), h = $4dacbd6c81f90f16$var$t(r), y = "x" === $4dacbd6c81f90f16$var$o(r), { width: x, height: w } = a.floating;
            let v, b;
            "top" === p || "bottom" === p ? (v = p, b = h === (await (null == l.isRTL ? void 0 : l.isRTL(m.floating)) ? "start" : "end") ? "left" : "right") : (b = p, v = "end" === h ? "top" : "bottom");
            const A = w - d[v], R = x - d[b];
            let P = A, E = R;
            if (y ? E = $4dacbd6c81f90f16$var$c(x - d.right - d.left, R) : P = $4dacbd6c81f90f16$var$c(w - d.bottom - d.top, A), !i.middlewareData.shift && !h) {
                const t = $4dacbd6c81f90f16$var$f(d.left, 0), e = $4dacbd6c81f90f16$var$f(d.right, 0), n = $4dacbd6c81f90f16$var$f(d.top, 0), o = $4dacbd6c81f90f16$var$f(d.bottom, 0);
                y ? E = x - 2 * (0 !== t || 0 !== e ? t + e : $4dacbd6c81f90f16$var$f(d.left, d.right)) : P = w - 2 * (0 !== n || 0 !== o ? n + o : $4dacbd6c81f90f16$var$f(d.top, d.bottom));
            }
            await u({
                ...i,
                availableWidth: E,
                availableHeight: P
            });
            const T = await l.getDimensions(m.floating);
            return x !== T.width || w !== T.height ? {
                reset: {
                    rects: !0
                }
            } : {};
        }
    };
};

});


parcelRegister("k286k", function(module, exports) {

$parcel$export(module.exports, "default", () => $e95a473d1e65c2a9$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
var $e95a473d1e65c2a9$var$index = (0, $eUqFw.useLayoutEffect);
var $e95a473d1e65c2a9$export$2e2bcd8739ae039 = $e95a473d1e65c2a9$var$index;

});




parcelRegister("5FjBr", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba6ba00681316b2f$export$2e2bcd8739ae039);
// eslint-disable-next-line @repo/internal/fs/filename-pattern-match

var $eUqFw = parcelRequire("eUqFw");

var $cEc3i = parcelRequire("cEc3i");

var $o2lI9 = parcelRequire("o2lI9");
var $7HYS7 = parcelRequire("7HYS7");

var $jQirI = parcelRequire("jQirI");

var $hgqfZ = parcelRequire("hgqfZ");

var $bKJfr = parcelRequire("bKJfr");

var $lT14u = parcelRequire("lT14u");
function $ba6ba00681316b2f$export$2e2bcd8739ae039(WrappedComponent) {
    const AtlaskitSelect = /*#__PURE__*/ (0, $eUqFw.forwardRef)(function AtlaskitSelect(props, forwardedRef) {
        const { appearance: appearance, ariaLiveMessages: ariaLiveMessages, components: componentsProp, isInvalid: isInvalid, onClickPreventDefault: onClickPreventDefault = true, spacing: spacing = 'default', styles: styles = {}, tabSelectsValue: tabSelectsValue = false, validationState: validationState = 'default', ...restProps } = props;
        const internalSelectRef = (0, $eUqFw.useRef)(null);
        const components = (0, $eUqFw.useMemo)(()=>({
                ClearIndicator: $o2lI9.ClearIndicator,
                DropdownIndicator: $o2lI9.DropdownIndicator,
                LoadingIndicator: $o2lI9.LoadingIndicator,
                MultiValueRemove: $7HYS7.MultiValueRemove,
                IndicatorSeparator: $7HYS7.IndicatorSeparator,
                Input: $jQirI.Input,
                NoOptionsMessage: $hgqfZ.NoOptionsMessage,
                ...componentsProp
            }), [
            componentsProp
        ]);
        const descriptionId = props['aria-describedby'];
        const isSearchable = props.isSearchable;
        (0, $eUqFw.useEffect)(()=>{
            if (!isSearchable && descriptionId) {
                // when isSearchable is false, react-select will create its own dummy input instead of using ours,
                // so we need to manually add the additional aria-describedby using ref.
                const input = internalSelectRef.current?.inputRef;
                const ariaDescribedby = input?.getAttribute('aria-describedby');
                if (!ariaDescribedby?.includes(descriptionId)) input?.setAttribute('aria-describedby', `${ariaDescribedby} ${descriptionId}`);
            }
        }, [
            descriptionId,
            isSearchable
        ]);
        const isCompact = spacing === 'compact';
        /**
		 * The following `useImperativeHandle` hook exists for the sake of backwards compatibility.
		 * This component used to be a class component which set the value of the `ref` prop to object with the properties and value as below.
		 * This has lead to slightly odd usage of refs with this component, e.g. `myRef.current.select.select.controlRef` instead of just `myRef.current.select.controlRef`
		 * In the next major release, this should removed and the ref should be passed directly to the wrapped component (given users have updated usage)
		 * More info https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/pull-requests/88021/overview
		 */ (0, $eUqFw.useImperativeHandle)(forwardedRef, ()=>({
                select: internalSelectRef.current,
                focus: ()=>internalSelectRef.current?.focus(),
                blur: ()=>internalSelectRef.current?.blur()
            }), []);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
            ref: internalSelectRef,
            "aria-live": "assertive",
            ariaLiveMessages: (0, $lT14u.isOptionsGrouped)(props.options) ? {
                onFocus: (data)=>(0, $lT14u.onFocus)(data, props.options),
                ...ariaLiveMessages
            } : {
                ...ariaLiveMessages
            },
            tabSelectsValue: tabSelectsValue,
            onClickPreventDefault: onClickPreventDefault,
            ...restProps,
            components: components,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            styles: (0, $cEc3i.m)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $bKJfr.default)(// This will cover both props for invalid state while giving priority to isInvalid. When cleaning up validationState, we can just keep the inner condition.
            typeof isInvalid !== 'undefined' ? isInvalid ? 'error' : 'default' : validationState, isCompact, appearance || 'default'), styles)
        });
    });
    AtlaskitSelect.displayName = 'AtlaskitSelect';
    return AtlaskitSelect;
}

});
parcelRegister("o2lI9", function(module, exports) {

$parcel$export(module.exports, "ClearIndicator", () => $a14d8b5e9bff27a8$export$ecf9cf59142dd54a);
$parcel$export(module.exports, "DropdownIndicator", () => $a14d8b5e9bff27a8$export$ec98719d3db7f2e4);
$parcel$export(module.exports, "LoadingIndicator", () => $a14d8b5e9bff27a8$export$7c20be4c1d342248);
/* eslint-disable @repo/internal/react/require-jsdoc */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $jQxSL = parcelRequire("jQxSL");

var $e9T6i = parcelRequire("e9T6i");

var $exKxp = parcelRequire("exKxp");

var $9Amv1 = parcelRequire("9Amv1");
var $4ZL0y = parcelRequire("4ZL0y");
var $1ZAYh = parcelRequire("1ZAYh");

var $4Bees = parcelRequire("4Bees");
const $a14d8b5e9bff27a8$var$iconContainerStyles = (0, $1ZAYh.xcss)({
    all: 'unset',
    outline: 'revert',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 'space.025'
});
const $a14d8b5e9bff27a8$var$dropdownWrapperStyles = (0, $1ZAYh.xcss)({
    padding: 'space.075'
});
const $a14d8b5e9bff27a8$export$ecf9cf59142dd54a = (props)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $jQxSL.c).ClearIndicator, {
        ...props,
        innerProps: {
            ...props.innerProps,
            'aria-hidden': 'false'
        }
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $4ZL0y.default), {
        xcss: $a14d8b5e9bff27a8$var$iconContainerStyles,
        tabIndex: -1
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($exKxp))), {
        label: "clear",
        color: "currentColor",
        LEGACY_size: "small",
        LEGACY_margin: "var(--ds-space-negative-025, -0.125rem)"
    })));
const $a14d8b5e9bff27a8$export$ec98719d3db7f2e4 = (props)=>// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $byn9U.jsx)((0, $jQxSL.c).DropdownIndicator, props, /*#__PURE__*/ (0, $byn9U.jsx)((0, $9Amv1.default), {
        as: "span",
        xcss: $a14d8b5e9bff27a8$var$dropdownWrapperStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e9T6i))), {
        color: "currentColor",
        label: "open",
        LEGACY_margin: "var(--ds-space-negative-075, -0.375rem)"
    })));
const $a14d8b5e9bff27a8$export$7c20be4c1d342248 = (props)=>{
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    const loadingStyles = /*#__PURE__*/ (0, $byn9U.css)(props.getStyles('loadingIndicator', props));
    return(// This *must* be constructed this way because this is being consumed by
    // `react-select` and we don't control what it wants.
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: loadingStyles,
        ...props.innerProps
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $4Bees.default), {
        size: "small"
    })));
};

});
parcelRegister("exKxp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::35e97232317682a60395e2ccf8df4ad7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a9683f39a4d9c20b$var$_react = $a9683f39a4d9c20b$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $a9683f39a4d9c20b$var$_crossCircle = $a9683f39a4d9c20b$var$_interopRequireDefault((parcelRequire("iOPxW")));

var $a9683f39a4d9c20b$var$_selectClear = $a9683f39a4d9c20b$var$_interopRequireDefault((parcelRequire("hUbUe")));
function $a9683f39a4d9c20b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for CrossCircleIcon.
 * This component is CrossCircleIcon, with `UNSAFE_fallbackIcon` set to "SelectClearIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a9683f39a4d9c20b$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $a9683f39a4d9c20b$var$_react.default.createElement($a9683f39a4d9c20b$var$_crossCircle.default, Object.assign({
        LEGACY_fallbackIcon: $a9683f39a4d9c20b$var$_selectClear.default
    }, props));
$a9683f39a4d9c20b$var$CrossCircleIcon.Name = 'CrossCircleIconMigration';
var $a9683f39a4d9c20b$var$_default = module.exports.default = $a9683f39a4d9c20b$var$CrossCircleIcon;

});
parcelRegister("iOPxW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bc42d217064fbe3eaef70b43f6c007b6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $db34e18c123e5251$var$_react = $db34e18c123e5251$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $db34e18c123e5251$var$_UNSAFE_baseNew = $db34e18c123e5251$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $db34e18c123e5251$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "CrossCircle".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $db34e18c123e5251$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $db34e18c123e5251$var$_react.default.createElement($db34e18c123e5251$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6 12A6 6 0 1 0 6 0a6 6 0 0 0 0 12m3.28-8.22L7.06 6l2.22 2.22-1.06 1.06L6 7.06 3.78 9.28 2.72 8.22 4.94 6 2.72 3.78l1.06-1.06L6 4.94l2.22-2.22z" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$db34e18c123e5251$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
var $db34e18c123e5251$var$_default = module.exports.default = $db34e18c123e5251$var$CrossCircleIcon;

});

parcelRegister("hUbUe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d090e6e9cc89e346$var$_react = $d090e6e9cc89e346$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $d090e6e9cc89e346$var$_crossCircle = $d090e6e9cc89e346$var$_interopRequireDefault((parcelRequire("hsyGm")));
function $d090e6e9cc89e346$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d090e6e9cc89e346$var$SelectClearIcon = (props)=>/*#__PURE__*/ $d090e6e9cc89e346$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="9" fill="currentcolor"/><path fill="inherit" d="M16.155 14.493a1.174 1.174 0 1 1-1.662 1.663L12 13.662l-2.494 2.494a1.17 1.17 0 0 1-1.662 0 1.176 1.176 0 0 1 0-1.663L10.337 12 7.844 9.507a1.176 1.176 0 0 1 1.662-1.662L12 10.338l2.493-2.493a1.174 1.174 0 1 1 1.662 1.662L13.662 12z"/></g></svg>`
    }, props, {
        newIcon: $d090e6e9cc89e346$var$_crossCircle.default
    }));
$d090e6e9cc89e346$var$SelectClearIcon.displayName = 'SelectClearIcon';
var $d090e6e9cc89e346$var$_default = module.exports.default = $d090e6e9cc89e346$var$SelectClearIcon;

});
parcelRegister("hsyGm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b195e70c8e4b45875c876105018c6db5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cb5ff45e92d98b0f$var$_react = $cb5ff45e92d98b0f$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $cb5ff45e92d98b0f$var$_UNSAFE_baseNew = $cb5ff45e92d98b0f$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $cb5ff45e92d98b0f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "CrossCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: clear text field, error status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cb5ff45e92d98b0f$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $cb5ff45e92d98b0f$var$_react.default.createElement($cb5ff45e92d98b0f$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m4.03 5.03L9.06 8l2.97 2.97-1.06 1.06L8 9.06l-2.97 2.97-1.06-1.06L6.94 8 3.97 5.03l1.06-1.06L8 6.94l2.97-2.97z" clip-rule="evenodd"/>`
    }, props));
$cb5ff45e92d98b0f$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
var $cb5ff45e92d98b0f$var$_default = module.exports.default = $cb5ff45e92d98b0f$var$CrossCircleIcon;

});




parcelRegister("7HYS7", function(module, exports) {

$parcel$export(module.exports, "MultiValueRemove", () => $7fda2332979a5c13$export$8e1fd1a40e7a2f4a);
$parcel$export(module.exports, "IndicatorSeparator", () => $7fda2332979a5c13$export$bd638c2ba7915668);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $jQxSL = parcelRequire("jQxSL");

var $hUbUe = parcelRequire("hUbUe");

var $adUQx = parcelRequire("adUQx");

var $XHGTv = parcelRequire("XHGTv");

var $9Amv1 = parcelRequire("9Amv1");
var $1ZAYh = parcelRequire("1ZAYh");

var $o2lI9 = parcelRequire("o2lI9");
function $7fda2332979a5c13$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7fda2332979a5c13$var$disabledStyles = {
    name: "eivff4",
    styles: "display:none"
};
const $7fda2332979a5c13$var$enabledStyles = {
    name: "ck88l6",
    styles: "display:inherit"
};
const $7fda2332979a5c13$var$iconWrapperStyles = (0, $1ZAYh.xcss)({
    padding: 'space.025'
});
const $7fda2332979a5c13$export$8e1fd1a40e7a2f4a = (props)=>{
    const { isDisabled: isDisabled } = props.selectProps;
    const renderIcon = ()=>{
        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $XHGTv.fg)('platform-component-visual-refresh')) return /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($adUQx))), {
            label: "Clear",
            color: "currentColor"
        });
        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $XHGTv.fg)('platform-visual-refresh-icons-legacy-facade')) return /*#__PURE__*/ (0, $byn9U.jsx)((0, $9Amv1.default), {
            xcss: $7fda2332979a5c13$var$iconWrapperStyles
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($adUQx))), {
            label: "Clear",
            color: "currentColor"
        }));
        return(// eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hUbUe))), {
            label: "Clear",
            primaryColor: "transparent",
            size: "small",
            secondaryColor: "inherit"
        }));
    };
    return(// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $byn9U.jsx)((0, $jQxSL.c).MultiValueRemove, props, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: isDisabled ? $7fda2332979a5c13$var$disabledStyles : $7fda2332979a5c13$var$enabledStyles,
        "data-testid": isDisabled ? 'hide-clear-icon' : 'show-clear-icon'
    }, renderIcon())));
};
const $7fda2332979a5c13$export$bd638c2ba7915668 = null;

});
parcelRegister("adUQx", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8a2857e231b7db111b6bd9efbc440f24>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $771736c5909ba4b4$var$_react = $771736c5909ba4b4$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $771736c5909ba4b4$var$_UNSAFE_baseNew = $771736c5909ba4b4$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $771736c5909ba4b4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Cross".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: remove tag.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $771736c5909ba4b4$var$CrossIcon = (props)=>/*#__PURE__*/ $771736c5909ba4b4$var$_react.default.createElement($771736c5909ba4b4$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m2 10 4-4m4-4L6 6m0 0L2 2m4 4 4 4"/>`,
        type: 'utility'
    }, props));
$771736c5909ba4b4$var$CrossIcon.displayName = 'CrossIcon';
var $771736c5909ba4b4$var$_default = module.exports.default = $771736c5909ba4b4$var$CrossIcon;

});


parcelRegister("jQirI", function(module, exports) {

$parcel$export(module.exports, "Input", () => $644d9bc3d652d5d7$export$f5b8910cec6cf069);

var $eUqFw = parcelRequire("eUqFw");

var $jQxSL = parcelRequire("jQxSL");
function $644d9bc3d652d5d7$export$f5b8910cec6cf069(props) {
    let ariaDescribedByAttribute;
    const passed_describedby = props.selectProps['aria-describedby'];
    if (props['aria-describedby'] && passed_describedby) ariaDescribedByAttribute = props['aria-describedby'] + ' ' + passed_describedby;
    else ariaDescribedByAttribute = props['aria-describedby'] || passed_describedby;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).Input, {
        ...props,
        "aria-describedby": ariaDescribedByAttribute
    });
}

});

parcelRegister("hgqfZ", function(module, exports) {

$parcel$export(module.exports, "NoOptionsMessage", () => $4d0dc96eef1d75f0$export$d58b72b7d3c4072c);

var $eUqFw = parcelRequire("eUqFw");

var $jQxSL = parcelRequire("jQxSL");

var $1Yimi = parcelRequire("1Yimi");
const $4d0dc96eef1d75f0$export$d58b72b7d3c4072c = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).NoOptionsMessage, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        id: "no-options",
        role: "alert"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
        color: "color.text.subtle"
    }, props.children || `No options`)));
};

});

parcelRegister("bKJfr", function(module, exports) {

$parcel$export(module.exports, "default", () => $6eba8612e97e7e89$export$2e2bcd8739ae039);

var $XHGTv = parcelRequire("XHGTv");

function $6eba8612e97e7e89$export$2e2bcd8739ae039(validationState, isCompact = false, appearance) {
    return {
        container: (css, { isDisabled: isDisabled })=>({
                ...css,
                font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                // react-select disables pointer events when isDisabled is true.
                // We override this and make the inner container turn it off instead.
                pointerEvents: 'all',
                cursor: isDisabled ? 'not-allowed' : css.cursor
            }),
        input: (css)=>({
                ...css,
                color: "var(--ds-text, hsl(0, 0%, 20%))"
            }),
        control: (css, { isFocused: isFocused, isDisabled: isDisabled })=>{
            let borderColor = isFocused ? `var(--ds-border-focused, ${0, $73a5c9d720aa66e1$export$ecfc1dff386a3e7a})` : `var(--ds-border-input, ${0, $73a5c9d720aa66e1$export$d6447c357493214f})`;
            let backgroundColor = isFocused ? `var(--ds-background-input-pressed, ${0, $73a5c9d720aa66e1$export$29a4f05edc054374})` : `var(--ds-background-input, ${0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97})`;
            let backgroundColorHover = isFocused ? `var(--ds-background-input-pressed, ${0, $73a5c9d720aa66e1$export$29a4f05edc054374})` : `var(--ds-background-input-hovered, ${0, $73a5c9d720aa66e1$export$3e51e8f1440314ba})`;
            if (isDisabled) {
                backgroundColor = `var(--ds-background-disabled, ${0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97})`;
                borderColor = `var(--ds-background-disabled, ${0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97})`;
            }
            if (validationState === 'error') borderColor = `var(--ds-border-danger, ${0, $73a5c9d720aa66e1$export$2010d0fb4295b346})`;
            if (validationState === 'success') borderColor = `var(--ds-border-success, ${0, $73a5c9d720aa66e1$export$a49394138f7b8e85})`;
            let borderColorHover = isFocused ? `var(--ds-border-focused, ${0, $73a5c9d720aa66e1$export$ecfc1dff386a3e7a})` : `var(--ds-border-input, ${0, $73a5c9d720aa66e1$export$d6447c357493214f})`;
            if (validationState === 'error') borderColorHover = `var(--ds-border-danger, ${0, $73a5c9d720aa66e1$export$2010d0fb4295b346})`;
            if (validationState === 'success') borderColorHover = `var(--ds-border-success, ${0, $73a5c9d720aa66e1$export$a49394138f7b8e85})`;
            const transitionDuration = '200ms';
            if (appearance === 'subtle') {
                borderColor = isFocused ? `var(--ds-border-focused, ${0, $73a5c9d720aa66e1$export$ecfc1dff386a3e7a})` : 'transparent';
                backgroundColor = isFocused ? `var(--ds-surface, ${0, $73a5c9d720aa66e1$export$29a4f05edc054374})` : 'transparent';
                backgroundColorHover = isFocused ? `var(--ds-background-input-pressed, ${0, $73a5c9d720aa66e1$export$29a4f05edc054374})` : `var(--ds-background-input-hovered, ${0, $73a5c9d720aa66e1$export$3e51e8f1440314ba})`;
            }
            if (appearance === 'none') {
                borderColor = 'transparent';
                backgroundColor = 'transparent';
                backgroundColorHover = 'transparent';
                borderColorHover = 'transparent';
            }
            return {
                ...css,
                // Turn pointer events off when disabled - this makes it so hover etc don't work.
                pointerEvents: isDisabled ? 'none' : undefined,
                backgroundColor: backgroundColor,
                borderColor: borderColor,
                borderStyle: 'solid',
                borderRadius: "var(--ds-border-radius-100, 3px)",
                borderWidth: "var(--ds-border-width, 1px)",
                boxShadow: validationState === 'error' ? `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${borderColor}` : 'none',
                '&:focus-within': {
                    boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${borderColor}`
                },
                minHeight: isCompact ? 32 : 40,
                padding: 0,
                transition: `background-color ${transitionDuration} ease-in-out,
        border-color ${transitionDuration} ease-in-out`,
                '::-webkit-scrollbar': {
                    height: 8,
                    width: 8
                },
                '::-webkit-scrollbar-corner': {
                    display: 'none'
                },
                ':hover': {
                    '::-webkit-scrollbar-thumb': {
                        // scrollbars occur only if the user passes in a custom component with overflow: scroll
                        backgroundColor: 'rgba(0,0,0,0.2)'
                    },
                    cursor: 'pointer',
                    backgroundColor: backgroundColorHover,
                    borderColor: borderColorHover
                },
                '::-webkit-scrollbar-thumb:hover': {
                    backgroundColor: 'rgba(0,0,0,0.4)'
                }
            };
        },
        valueContainer: (css)=>({
                ...css,
                paddingLeft: "var(--ds-space-075, 6px)",
                paddingRight: "var(--ds-space-075, 6px)",
                paddingBottom: isCompact ? 0 : 2,
                paddingTop: isCompact ? 0 : 2
            }),
        clearIndicator: (css)=>({
                ...css,
                color: `var(--ds-text-subtlest, ${0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de})`,
                paddingLeft: "var(--ds-space-025, 2px)",
                paddingRight: "var(--ds-space-025, 2px)",
                paddingBottom: isCompact ? 0 : 6,
                paddingTop: isCompact ? 0 : 6,
                ':hover': {
                    color: `var(--ds-text-subtle, ${0, $73a5c9d720aa66e1$export$c39c0fe0f26207ae})`
                }
            }),
        loadingIndicator: (css)=>({
                ...css,
                paddingBottom: isCompact ? 0 : 6,
                paddingTop: isCompact ? 0 : 6
            }),
        dropdownIndicator: (css, { isDisabled: isDisabled })=>{
            let color = `var(--ds-text-subtle, ${(0, $73a5c9d720aa66e1$export$c39c0fe0f26207ae)})`;
            if (isDisabled) color = `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de})`;
            return {
                ...css,
                color: color,
                paddingLeft: "var(--ds-space-025, 2px)",
                paddingRight: "var(--ds-space-025, 2px)",
                paddingBottom: isCompact ? 0 : 6,
                paddingTop: isCompact ? 0 : 6,
                ':hover': {
                    color: `var(--ds-text-subtle, ${0, $73a5c9d720aa66e1$export$f563ee71e9ee74cd})`
                }
            };
        },
        indicatorsContainer: (css)=>({
                ...css,
                paddingRight: "var(--ds-space-050, 4px)"
            }),
        option: (css, { isFocused: isFocused, isSelected: isSelected, isDisabled: isDisabled })=>{
            let color = `var(--ds-text, ${(0, $73a5c9d720aa66e1$export$7d61b15e0da132af)})`;
            if (isDisabled) color = `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de})`;
            else if (isSelected) color = `var(--ds-text-selected, ${0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64})`;
            let boxShadow;
            let backgroundColor;
            if (isDisabled) backgroundColor = undefined;
            else if (isSelected && isFocused) backgroundColor = `var(--ds-background-selected-hovered, ${0, $73a5c9d720aa66e1$export$226de0355ed012f8})`;
            else if (isSelected) backgroundColor = `var(--ds-background-selected, ${0, $73a5c9d720aa66e1$export$226de0355ed012f8})`;
            else if (isFocused) backgroundColor = `var(--ds-background-neutral-subtle-hovered, ${0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97})`;
            if (!isDisabled && (isFocused || isSelected)) boxShadow = `inset 2px 0px 0px ${`var(--ds-border-selected, ${0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64})`}`;
            const cursor = isDisabled ? 'not-allowed' : css.cursor;
            return {
                ...css,
                padding: '6px 12px',
                backgroundColor: backgroundColor,
                color: color,
                cursor: cursor,
                boxShadow: boxShadow,
                ':active': {
                    backgroundColor: !isDisabled ? isSelected ? `var(--ds-background-selected-pressed, ${0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97})` : `var(--ds-background-neutral-subtle-pressed, ${0, $73a5c9d720aa66e1$export$3e51e8f1440314ba})` : undefined
                },
                '@media screen and (-ms-high-contrast: active)': {
                    borderLeft: !isDisabled && (isFocused || isSelected) ? '2px solid transparent' : ''
                }
            };
        },
        placeholder: (css, { isDisabled: isDisabled })=>({
                ...css,
                color: isDisabled ? `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$e2ef2124cf4024b1})` : `var(--ds-text-subtlest, ${0, $73a5c9d720aa66e1$export$f563ee71e9ee74cd})`
            }),
        singleValue: (css, { isDisabled: isDisabled })=>({
                ...css,
                color: isDisabled ? `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de})` : `var(--ds-text, ${0, $73a5c9d720aa66e1$export$7d61b15e0da132af})`
            }),
        menu: (css)=>({
                ...css,
                backgroundColor: "var(--ds-surface-overlay, white)",
                boxShadow: "var(--ds-shadow-overlay, 0 0 0 1px hsl(0deg 0% 0% / 10%), 0 4px 11px hsl(0deg 0% 0% / 10%))"
            }),
        menuList: (css)=>({
                ...css,
                paddingTop: "var(--ds-space-100, 8px)",
                paddingBottom: "var(--ds-space-100, 8px)"
            }),
        multiValue: (css, { isDisabled: isDisabled, isFocused: isFocused })=>{
            let backgroundColor;
            let color;
            if (isDisabled) {
                // Use the basic neutral background so it is slightly separate from the
                // field's background
                backgroundColor = `var(--ds-background-neutral, ${0, $73a5c9d720aa66e1$export$1ce2d1575d444ceb})`;
                color = `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de})`;
            } else if (isFocused) {
                backgroundColor = `var(--ds-background-selected, ${0, $73a5c9d720aa66e1$export$1ce2d1575d444ceb})`;
                color = "var(--ds-text-selected, hsl(0, 0%, 20%))";
            } else {
                backgroundColor = (0, $XHGTv.fg)('platform-component-visual-refresh') ? "var(--ds-background-neutral-subtle-hovered, #091E420F)" : `var(--ds-background-neutral, ${0, $73a5c9d720aa66e1$export$1ce2d1575d444ceb})`;
                color = "var(--ds-text, hsl(0, 0%, 20%))";
            }
            return {
                ...css,
                borderRadius: "var(--ds-border-radius-050, 2px)",
                backgroundColor: backgroundColor,
                boxShadow: isFocused ? `0 0 0 2px ${"var(--ds-surface, transparent)"}, 0 0 0 4px ${"var(--ds-border-focused, transparent)"}` : 'none',
                maxWidth: '100%',
                '@media screen and (-ms-high-contrast: active)': {
                    border: isFocused ? '1px solid transparent' : 'none'
                },
                color: color,
                ...(0, $XHGTv.fg)('platform-component-visual-refresh') && {
                    borderRadius: "var(--ds-border-radius-100, 4px)",
                    // Hardcode this color for visual refresh as there is no token color yet
                    borderColor: '#B7B9BE',
                    borderWidth: "var(--ds-border-width, 1px)",
                    borderStyle: 'solid',
                    backgroundColor: "var(--ds-background-input, #FFFFFF)"
                }
            };
        },
        multiValueLabel: (css, { isDisabled: isDisabled })=>({
                ...css,
                font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                padding: "var(--ds-space-025, 2px)",
                color: isDisabled ? `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de})` : 'inherit',
                paddingRight: "var(--ds-space-025, 2px)",
                ...(0, $XHGTv.fg)('platform-component-visual-refresh') && {
                    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                    paddingTop: 0,
                    paddingBottom: 0,
                    paddingLeft: "var(--ds-space-050, 4px)"
                }
            }),
        multiValueRemove: (css, { isFocused: isFocused })=>({
                ...css,
                backgroundColor: isFocused ? `var(--ds-UNSAFE-transparent, ${0, $73a5c9d720aa66e1$export$b34b069eff244586})` : undefined,
                fill: isFocused ? "var(--ds-text-selected, #000)" : "var(--ds-text, #000)",
                paddingLeft: "var(--ds-space-025, 2px)",
                paddingRight: "var(--ds-space-025, 2px)",
                borderRadius: '0px 2px 2px 0px',
                // DSP-6470 we should style like Tag once we have the :has selector
                ':hover': {
                    backgroundColor: `var(--ds-background-danger-hovered, ${0, $73a5c9d720aa66e1$export$b34b069eff244586})`,
                    fill: "var(--ds-text-danger, #000)"
                },
                ':active': {
                    backgroundColor: `var(--ds-background-danger-pressed, ${0, $73a5c9d720aa66e1$export$b34b069eff244586})`,
                    fill: "var(--ds-text-danger, #000)"
                },
                ...(0, $XHGTv.fg)('platform-component-visual-refresh') && {
                    backgroundColor: "var(--ds-background-neutral-subtle, #00000000)",
                    border: 'none',
                    alignItems: 'center',
                    justifyContent: 'center',
                    alignSelf: 'center',
                    appearance: 'none',
                    borderRadius: "var(--ds-border-radius, 4px)",
                    color: "var(--ds-text, #172B4D)",
                    padding: "var(--ds-space-025, 2px)",
                    marginRight: "var(--ds-space-025, 2px)",
                    ':focus-visible': {
                        outlineOffset: "var(--ds-space-negative-025, -2px)"
                    },
                    ':hover': {
                        backgroundColor: "var(--ds-background-neutral-subtle-hovered, #091E420F)"
                    },
                    ':active': {
                        backgroundColor: "var(--ds-background-neutral-subtle-pressed, #091E4224)"
                    }
                }
            }),
        groupHeading: (css)=>({
                ...css,
                font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                color: `var(--ds-text-subtle, ${0, $73a5c9d720aa66e1$export$f563ee71e9ee74cd})`,
                ...(0, $XHGTv.fg)('platform_design_system_team_select_typography') && {
                    fontWeight: `${"var(--ds-font-weight-bold, 700)"} !important`,
                    textTransform: 'none'
                }
            })
    };
}

});

parcelRegister("lT14u", function(module, exports) {

$parcel$export(module.exports, "onFocus", () => $7ccc5140c845bc58$export$ecf9bf35ad97eb74);
$parcel$export(module.exports, "isOptionsGrouped", () => $7ccc5140c845bc58$export$d2756249f53f9f8);
$parcel$export(module.exports, "countAllOptions", () => $7ccc5140c845bc58$export$8ee33f304118fce4);
function $7ccc5140c845bc58$export$ecf9bf35ad97eb74(onFocusProps, defaultOptions) {
    const { focused: focused } = onFocusProps;
    const isOptionFocused = (option)=>{
        return option.label === focused.label;
    };
    const groupData = defaultOptions?.find((option)=>{
        return option.options?.some(isOptionFocused);
    });
    const groupOptionIndex = groupData?.options.findIndex(isOptionFocused) ?? 0;
    return `Option ${focused.label}, ${groupData?.label} group, item ${groupOptionIndex + 1} out of ${groupData?.options.length}. All in all `;
}
const $7ccc5140c845bc58$export$d2756249f53f9f8 = (arr)=>{
    return arr?.every((obj)=>obj.hasOwnProperty('options'));
};
const $7ccc5140c845bc58$export$8ee33f304118fce4 = (groupsArray)=>{
    const totalLength = groupsArray?.reduce((acc, currentGroup)=>{
        const group = currentGroup;
        acc += group?.options?.length;
        return acc;
    }, 0);
    return totalLength;
};

});



parcelRegister("xeS7R", function(module, exports) {

$parcel$export(module.exports, "default", () => $2fe3143162b284fd$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $lUFyV = parcelRequire("lUFyV");

var $dkGpW = parcelRequire("dkGpW");
const $2fe3143162b284fd$var$packageName = "platform-pkg";
const $2fe3143162b284fd$var$packageVersion = "0.0.0-use.local";
const $2fe3143162b284fd$var$analyticsParams = {
    componentName: 'textArea',
    packageName: $2fe3143162b284fd$var$packageName,
    packageVersion: $2fe3143162b284fd$var$packageVersion
};
const $2fe3143162b284fd$var$setSmartHeight = (el)=>{
    // Always reset height to auto before calculating new height
    el.style.height = 'auto';
    const borderHeight = (0, $dkGpW.borderWidth);
    const paddingBoxHeight = el.scrollHeight;
    const borderBoxHeight = paddingBoxHeight + borderHeight * 2;
    el.style.height = `${borderBoxHeight}px`;
};
const $2fe3143162b284fd$var$InnerTextArea = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const ourRef = (0, $eUqFw.useRef)(null);
    const { resize: resize = 'smart', appearance: appearance = 'standard', isCompact: isCompact = false, isRequired: isRequired = false, isReadOnly: isReadOnly = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, minimumRows: minimumRows = 2, testId: testId, maxHeight: maxHeight = '50vh', onBlur: onBlur, onFocus: onFocus, onChange: onChange, value: value, ...rest } = props;
    (0, $eUqFw.useEffect)(()=>{
        const el = ourRef.current;
        if (resize === 'smart' && el) $2fe3143162b284fd$var$setSmartHeight(el);
    }, [
        resize,
        value
    ]);
    const onBlurWithAnalytics = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onBlur && onBlur(event);
        },
        action: 'blurred',
        ...$2fe3143162b284fd$var$analyticsParams
    });
    const onFocusWithAnalytics = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onFocus && onFocus(event);
        },
        action: 'focused',
        ...$2fe3143162b284fd$var$analyticsParams
    });
    const getTextAreaRef = (elementRef)=>{
        ourRef.current = elementRef;
        if (ref && typeof ref === 'object') // @ts-ignore
        ref.current = elementRef;
        if (ref && typeof ref === 'function') ref(elementRef);
    };
    const handleOnChange = (0, $eUqFw.useCallback)((e)=>{
        const el = ourRef.current;
        if (resize === 'smart' && el) $2fe3143162b284fd$var$setSmartHeight(el);
        onChange && onChange(e);
    }, [
        onChange,
        resize
    ]);
    const controlProps = {
        'data-invalid': isInvalid ? isInvalid : undefined,
        'data-compact': isCompact ? isCompact : undefined,
        'data-testid': testId ? testId : undefined
    };
    const baseStyles = (0, $eUqFw.useMemo)(()=>(0, $dkGpW.getBaseStyles)({
            minimumRows: minimumRows,
            resize: resize,
            appearance: appearance,
            isMonospaced: isMonospaced,
            maxHeight: maxHeight
        }), [
        minimumRows,
        resize,
        appearance,
        isMonospaced,
        maxHeight
    ]);
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-array-arguments, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    const textAreaStyles = /*#__PURE__*/ (0, $byn9U.css)([
        baseStyles,
        (0, $dkGpW.dynamicStyles)(appearance)
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)("textarea", {
        ...controlProps,
        value: value,
        disabled: isDisabled,
        readOnly: isReadOnly,
        required: isRequired,
        ref: getTextAreaRef,
        onChange: handleOnChange,
        onBlur: onBlurWithAnalytics,
        onFocus: onFocusWithAnalytics,
        rows: minimumRows,
        // TODO refactor to follow emotion styling rules
        // see: https://product-fabric.atlassian.net/browse/DSP-6060
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: textAreaStyles,
        ...rest
    });
});
/**
 * __Text area__
 *
 * A text area lets users enter long form text which spans over multiple lines.
 *
 * - [Examples](https://atlassian.design/components/textarea/examples)
 * - [Code](https://atlassian.design/components/textarea/code)
 * - [Usage](https://atlassian.design/components/textarea/usage)
 */ const $2fe3143162b284fd$var$TextArea = /*#__PURE__*/ (0, $eUqFw.memo)(/*#__PURE__*/ (0, $eUqFw.forwardRef)(function TextArea(props, ref) {
    return /*#__PURE__*/ (0, $byn9U.jsx)($2fe3143162b284fd$var$InnerTextArea, {
        ref: ref,
        ...props
    });
}));
$2fe3143162b284fd$var$TextArea.displayName = 'TextArea';
var $2fe3143162b284fd$export$2e2bcd8739ae039 = $2fe3143162b284fd$var$TextArea;

});
parcelRegister("dkGpW", function(module, exports) {

$parcel$export(module.exports, "borderWidth", () => $ffa47244c710aa2a$export$12879c7697ed953d);
$parcel$export(module.exports, "getBaseStyles", () => $ffa47244c710aa2a$export$bff8031d86bb089);
$parcel$export(module.exports, "dynamicStyles", () => $ffa47244c710aa2a$export$98856a888ef36079);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $9rnqv = parcelRequire("9rnqv");
function $ffa47244c710aa2a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $ffa47244c710aa2a$var$disabledRules = {
    backgroundColor: $9rnqv.disabledBackground,
    backgroundColorFocus: $9rnqv.disabledBackground,
    backgroundColorHover: $9rnqv.disabledBackground,
    borderColor: $9rnqv.disabledBorder,
    borderColorFocus: $9rnqv.defaultBorderColorFocus,
    textColor: $9rnqv.disabledTextColor
};
const $ffa47244c710aa2a$var$invalidRules = {
    borderColor: $9rnqv.invalidBorderColor,
    borderColorFocus: $9rnqv.defaultBorderColorFocus,
    backgroundColor: $9rnqv.defaultBackgroundColor,
    backgroundColorFocus: $9rnqv.defaultBackgroundColorFocus,
    backgroundColorHover: $9rnqv.defaultBackgroundColorHover
};
const $ffa47244c710aa2a$var$backgroundColor = {
    standard: $9rnqv.defaultBackgroundColor,
    subtle: $9rnqv.transparent,
    none: $9rnqv.transparent
};
const $ffa47244c710aa2a$var$backgroundColorFocus = {
    standard: $9rnqv.defaultBackgroundColorFocus,
    subtle: $9rnqv.defaultBackgroundColorFocus,
    none: $9rnqv.transparent
};
const $ffa47244c710aa2a$var$backgroundColorHover = {
    standard: $9rnqv.defaultBackgroundColorHover,
    subtle: $9rnqv.defaultBackgroundColorHover,
    none: $9rnqv.transparent
};
const $ffa47244c710aa2a$var$borderColor = {
    standard: $9rnqv.defaultBorderColor,
    subtle: $9rnqv.transparent,
    none: $9rnqv.transparent
};
const $ffa47244c710aa2a$var$borderColorFocus = {
    standard: $9rnqv.defaultBorderColorFocus,
    subtle: $9rnqv.defaultBorderColorFocus,
    none: $9rnqv.transparent
};
const $ffa47244c710aa2a$var$borderColorHover = {
    standard: $9rnqv.defaultBorderColor,
    subtle: $9rnqv.subtleBorderColorHover,
    none: $9rnqv.transparent
};
const $ffa47244c710aa2a$var$lineHeightBase = 20;
const $ffa47244c710aa2a$var$lineHeightCompact = 16;
const $ffa47244c710aa2a$var$compactVerticalPadding = 2;
const $ffa47244c710aa2a$var$verticalPadding = 6;
const $ffa47244c710aa2a$var$horizontalPadding = 8;
const $ffa47244c710aa2a$var$transitionDuration = '0.2s';
const $ffa47244c710aa2a$var$fontFamily = "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)";
const $ffa47244c710aa2a$var$codeFontFamily = "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)";
const $ffa47244c710aa2a$export$12879c7697ed953d = 2;
// Safari puts on some difficult to remove styles, mainly for disabled inputs
// but we want full control so need to override them in all cases
const $ffa47244c710aa2a$var$overrideSafariDisabledStyles = {
    WebkitTextFillColor: 'unset',
    WebkitOpacity: '1'
};
const $ffa47244c710aa2a$var$borderBoxMinHeight = (minimumRows, borderHeight)=>{
    const contentHeight = $ffa47244c710aa2a$var$lineHeightBase * minimumRows;
    return contentHeight + $ffa47244c710aa2a$var$verticalPadding * 2 + borderHeight * 2;
};
const $ffa47244c710aa2a$var$borderBoxMinHeightCompact = (minimumRows, borderHeight)=>{
    const contentHeightCompact = $ffa47244c710aa2a$var$lineHeightCompact * minimumRows;
    return contentHeightCompact + $ffa47244c710aa2a$var$compactVerticalPadding * 2 + borderHeight * 2;
};
const $ffa47244c710aa2a$var$bgAndBorderColorStyles = (appearance)=>appearance && /*#__PURE__*/ (0, $byn9U.css)({
        '&:focus': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: $ffa47244c710aa2a$var$backgroundColorFocus[appearance],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderColor: $ffa47244c710aa2a$var$borderColorFocus[appearance],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$ffa47244c710aa2a$var$borderColorFocus[appearance]}`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:not(:focus)': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: $ffa47244c710aa2a$var$backgroundColor[appearance],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderColor: $ffa47244c710aa2a$var$borderColor[appearance]
        },
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-invalid]:focus': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: $ffa47244c710aa2a$var$invalidRules.backgroundColorFocus,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderColor: $ffa47244c710aa2a$var$invalidRules.borderColorFocus,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$ffa47244c710aa2a$var$invalidRules.borderColorFocus}`
        },
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&[data-invalid]:not(:focus)': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: $ffa47244c710aa2a$var$invalidRules.backgroundColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderColor: $ffa47244c710aa2a$var$invalidRules.borderColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$ffa47244c710aa2a$var$invalidRules.borderColor}`
        },
        // Disabled background and border styles should not be applied to components that
        // have either no background or transparent background to begin with
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...appearance === 'standard' ? {
            '&:disabled:focus': {
                backgroundColor: $ffa47244c710aa2a$var$disabledRules.backgroundColorFocus,
                borderColor: $ffa47244c710aa2a$var$disabledRules.borderColorFocus
            },
            '&:disabled:not(:focus)': {
                backgroundColor: $ffa47244c710aa2a$var$disabledRules.backgroundColor,
                borderColor: $ffa47244c710aa2a$var$disabledRules.borderColor
            }
        } : {}
    });
const $ffa47244c710aa2a$var$placeholderStyles = /*#__PURE__*/ (0, $byn9U.css)({
    '&::placeholder': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: $9rnqv.placeholderTextColor
    },
    '&:disabled::placeholder': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: $ffa47244c710aa2a$var$disabledRules.textColor
    }
});
const $ffa47244c710aa2a$var$hoverBackgroundAndBorderStyles = (appearance)=>appearance && /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:hover:not(:read-only):not(:focus)': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: $ffa47244c710aa2a$var$backgroundColorHover[appearance],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderColor: $ffa47244c710aa2a$var$borderColorHover[appearance],
            '&:disabled': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                backgroundColor: $ffa47244c710aa2a$var$disabledRules.backgroundColorHover
            },
            // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '&[data-invalid]': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                backgroundColor: $ffa47244c710aa2a$var$invalidRules.backgroundColorHover,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                borderColor: $ffa47244c710aa2a$var$invalidRules.borderColor,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$ffa47244c710aa2a$var$invalidRules.borderColor}`
            }
        }
    });
var $ffa47244c710aa2a$var$_ref = {
    name: "utehjx",
    styles: "resize:none"
};
var $ffa47244c710aa2a$var$_ref2 = {
    name: "bolgb9",
    styles: "resize:both"
};
const $ffa47244c710aa2a$var$resizeStyle = (resize)=>{
    if (resize === 'horizontal' || resize === 'vertical') // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    return /*#__PURE__*/ (0, $byn9U.css)({
        resize: resize
    });
    if (resize === 'auto') return $ffa47244c710aa2a$var$_ref2;
    return $ffa47244c710aa2a$var$_ref;
};
const $ffa47244c710aa2a$var$borderStyle = (appearance)=>/*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        borderStyle: appearance === 'none' ? 'none' : 'solid'
    });
const $ffa47244c710aa2a$var$fontFamilyStyle = (isMonospaced)=>/*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        fontFamily: isMonospaced ? $ffa47244c710aa2a$var$codeFontFamily : $ffa47244c710aa2a$var$fontFamily
    });
const $ffa47244c710aa2a$var$borderPaddingAndHeightStyles = (minimumRows = 1, appearance)=>{
    const borderWidth = appearance !== 'none' ? 1 : 2;
    const horizontalPaddingWithoutBorderWidth = $ffa47244c710aa2a$var$horizontalPadding - borderWidth;
    const borderHeight = borderWidth;
    return /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-compact]': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            minHeight: $ffa47244c710aa2a$var$borderBoxMinHeightCompact(minimumRows, borderHeight),
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            padding: `${$ffa47244c710aa2a$var$compactVerticalPadding}px ${horizontalPaddingWithoutBorderWidth}px`,
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values
            lineHeight: $ffa47244c710aa2a$var$lineHeightCompact / 14
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:not([data-compact])': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            minHeight: $ffa47244c710aa2a$var$borderBoxMinHeight(minimumRows, borderHeight),
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            padding: `${$ffa47244c710aa2a$var$verticalPadding}px ${horizontalPaddingWithoutBorderWidth}px`,
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values
            lineHeight: $ffa47244c710aa2a$var$lineHeightBase / 14
        }
    });
};
const $ffa47244c710aa2a$var$staticStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'block',
    boxSizing: 'border-box',
    width: '100%',
    minWidth: 0,
    maxWidth: '100%',
    margin: 0,
    position: 'relative',
    flex: '1 1 100%',
    borderRadius: "var(--ds-border-radius, 3px)",
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    borderWidth: 1,
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    outline: 'none',
    overflow: 'auto',
    transition: `background-color ${$ffa47244c710aa2a$var$transitionDuration} ease-in-out,
               border-color ${$ffa47244c710aa2a$var$transitionDuration} ease-in-out`,
    wordWrap: 'break-word',
    '&:disabled': {
        cursor: 'not-allowed',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...$ffa47244c710aa2a$var$overrideSafariDisabledStyles
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&::-ms-clear': {
        display: 'none'
    },
    '&:invalid': {
        boxShadow: 'none'
    }
});
const $ffa47244c710aa2a$export$bff8031d86bb089 = ({ minimumRows: minimumRows, resize: resize, appearance: appearance, isMonospaced: isMonospaced, maxHeight: maxHeight })=>/*#__PURE__*/ // eslint-disable-next-line @repo/internal/styles/no-exported-styles
    (0, $byn9U.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $ffa47244c710aa2a$var$staticStyles, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $ffa47244c710aa2a$var$borderPaddingAndHeightStyles(minimumRows, appearance), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $ffa47244c710aa2a$var$resizeStyle(resize), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $ffa47244c710aa2a$var$borderStyle(appearance), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $ffa47244c710aa2a$var$fontFamilyStyle(isMonospaced), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    {
        maxHeight: maxHeight
    });
const $ffa47244c710aa2a$export$98856a888ef36079 = (appearance)=>/*#__PURE__*/ // eslint-disable-next-line @repo/internal/styles/no-exported-styles
    (0, $byn9U.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $ffa47244c710aa2a$var$bgAndBorderColorStyles(appearance), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $ffa47244c710aa2a$var$hoverBackgroundAndBorderStyles(appearance), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $ffa47244c710aa2a$var$placeholderStyles, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: $9rnqv.textColor,
        '&:disabled': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            color: $ffa47244c710aa2a$var$disabledRules.textColor
        }
    });

});
parcelRegister("9rnqv", function(module, exports) {

$parcel$export(module.exports, "disabledBackground", () => $f5064939140dcbf4$export$ae3cba7672df0890);
$parcel$export(module.exports, "disabledBorder", () => $f5064939140dcbf4$export$fe505fe3c5edbdf6);
$parcel$export(module.exports, "invalidBorderColor", () => $f5064939140dcbf4$export$7f333bbf7ddab792);
$parcel$export(module.exports, "defaultBorderColor", () => $f5064939140dcbf4$export$dafd83031c202ca8);
$parcel$export(module.exports, "defaultBorderColorFocus", () => $f5064939140dcbf4$export$e8320c09dc1e4012);
$parcel$export(module.exports, "defaultBackgroundColor", () => $f5064939140dcbf4$export$b13414ee9ac9cae6);
$parcel$export(module.exports, "defaultBackgroundColorHover", () => $f5064939140dcbf4$export$bca15982c103d57b);
$parcel$export(module.exports, "defaultBackgroundColorFocus", () => $f5064939140dcbf4$export$21287e4b7f134f09);
$parcel$export(module.exports, "subtleBorderColorHover", () => $f5064939140dcbf4$export$a87538d56ee366ec);
$parcel$export(module.exports, "placeholderTextColor", () => $f5064939140dcbf4$export$5e076b2557ef7bbb);
$parcel$export(module.exports, "textColor", () => $f5064939140dcbf4$export$32f78bffcd82ff28);
$parcel$export(module.exports, "disabledTextColor", () => $f5064939140dcbf4$export$eb4a7d363eec53c8);
$parcel$export(module.exports, "transparent", () => $f5064939140dcbf4$export$f4d082c200a4b4b8);

const $f5064939140dcbf4$export$ae3cba7672df0890 = `var(--ds-background-disabled, ${(0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97)})`;
const $f5064939140dcbf4$export$fe505fe3c5edbdf6 = `var(--ds-border-disabled, ${(0, $73a5c9d720aa66e1$export$1ce2d1575d444ceb)})`;
const $f5064939140dcbf4$export$7f333bbf7ddab792 = `var(--ds-border-danger, ${(0, $73a5c9d720aa66e1$export$2010d0fb4295b346)})`;
const $f5064939140dcbf4$export$dafd83031c202ca8 = `var(--ds-border-input, ${(0, $73a5c9d720aa66e1$export$d6447c357493214f)})`;
const $f5064939140dcbf4$export$e8320c09dc1e4012 = `var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$export$215b7063051591f1)})`;
const $f5064939140dcbf4$export$b13414ee9ac9cae6 = `var(--ds-background-input, ${(0, $73a5c9d720aa66e1$export$e655ef011c4aa1a2)})`;
const $f5064939140dcbf4$export$bca15982c103d57b = `var(--ds-background-input-hovered, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`;
const $f5064939140dcbf4$export$21287e4b7f134f09 = `var(--ds-background-input-pressed, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`;
const $f5064939140dcbf4$export$a87538d56ee366ec = "var(--ds-border-input, transparent)";
const $f5064939140dcbf4$export$5e076b2557ef7bbb = `var(--ds-text-subtlest, ${(0, $73a5c9d720aa66e1$export$f563ee71e9ee74cd)})`;
const $f5064939140dcbf4$export$32f78bffcd82ff28 = `var(--ds-text, ${(0, $73a5c9d720aa66e1$export$fbda843f0a27fe96)})`;
const $f5064939140dcbf4$export$eb4a7d363eec53c8 = `var(--ds-text-disabled, ${(0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de)})`;
const $f5064939140dcbf4$export$f4d082c200a4b4b8 = 'transparent';

});



parcelRegister("cf2Y4", function(module, exports) {

$parcel$export(module.exports, "default", () => $ecaf8c9a10cf48c9$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $lUFyV = parcelRequire("lUFyV");

var $abUSh = parcelRequire("abUSh");
const $ecaf8c9a10cf48c9$var$analyticsParams = {
    componentName: 'textField',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
/**
 * __Textfield__
 *
 * A text field is an input that allows a user to write or edit text.
 *
 * - [Examples](https://atlassian.design/components/textfield/examples)
 * - [Code](https://atlassian.design/components/textfield/code)
 * - [Usage](https://atlassian.design/components/textfield/usage)
 */ const $ecaf8c9a10cf48c9$var$Textfield = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { appearance: appearance = 'standard', className: className, elemAfterInput: elemAfterInput, elemBeforeInput: elemBeforeInput, isCompact: isCompact = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, isReadOnly: isReadOnly = false, isRequired: isRequired = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, onMouseDown: onMouseDown, placeholder: placeholder, testId: testId, width: width, ...spreadProps } = props;
    const inputRef = (0, $eUqFw.useRef)(null);
    const handleOnFocus = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onFocus && onFocus(event);
        },
        action: 'focused',
        ...$ecaf8c9a10cf48c9$var$analyticsParams
    });
    const handleOnBlur = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onBlur && onBlur(event);
        },
        action: 'blurred',
        ...$ecaf8c9a10cf48c9$var$analyticsParams
    });
    const handleOnMouseDown = (0, $eUqFw.useCallback)((event)=>{
        // Running e.preventDefault() on the INPUT prevents double click behaviour
        // Sadly we needed this cast as the target type is being correctly set
        const target = event.target;
        if (target.tagName !== 'INPUT') event.preventDefault();
        if (inputRef && inputRef.current && !isDisabled && document.activeElement !== inputRef.current) inputRef.current.focus();
        onMouseDown && onMouseDown(event);
    }, [
        onMouseDown,
        isDisabled
    ]);
    const setInputRef = (0, $eUqFw.useCallback)((inputElement)=>{
        inputRef.current = inputElement;
        if (!ref) return;
        if (typeof ref === 'object') ref.current = inputElement;
        if (typeof ref === 'function') ref(inputElement);
    }, [
        ref
    ]);
    const containerStyles = (0, $eUqFw.useMemo)(()=>(0, $abUSh.containerStyles)(appearance, width), [
        appearance,
        width
    ]);
    const inputStyle = (0, $abUSh.inputStyles)();
    return(/**
     * It is not normally acceptable to add click and key handlers to
     * non-interactive elements as this is an accessibility anti-pattern.
     * However, because this instance is to handle events on all children that
     * should be associated with the input, we can add role="presentation" so
     * that there are no negative impacts to assistive technologies.
     */ /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        role: "presentation",
        "data-disabled": isDisabled ? isDisabled : undefined,
        "data-invalid": isInvalid ? isInvalid : undefined,
        "data-ds--text-field--container": true,
        "data-testid": testId && `${testId}-container`,
        onMouseDown: handleOnMouseDown,
        // TODO: When removing legacy theming fix this.
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: containerStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className
    }, elemBeforeInput, /*#__PURE__*/ (0, $byn9U.jsx)("input", {
        ...spreadProps,
        "aria-invalid": isInvalid ? isInvalid : undefined,
        // TODO: When removing legacy theming fix this.
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: inputStyle,
        "data-compact": isCompact ? isCompact : undefined,
        "data-ds--text-field--input": true,
        "data-monospaced": isMonospaced ? isMonospaced : undefined,
        "data-testid": testId,
        disabled: isDisabled,
        name: name,
        onBlur: handleOnBlur,
        onChange: onChange,
        onFocus: handleOnFocus,
        placeholder: placeholder,
        readOnly: isReadOnly,
        ref: setInputRef,
        required: isRequired
    }), elemAfterInput));
});
var $ecaf8c9a10cf48c9$export$2e2bcd8739ae039 = $ecaf8c9a10cf48c9$var$Textfield;

});
parcelRegister("abUSh", function(module, exports) {

$parcel$export(module.exports, "containerStyles", () => $6ff5b404db052892$export$5972a68b6e54f38f);
$parcel$export(module.exports, "inputStyles", () => $6ff5b404db052892$export$3eeb47dc8e6249d9);

const $6ff5b404db052892$var$backgroundColor = {
    standard: `var(--ds-background-input, ${(0, $73a5c9d720aa66e1$export$e655ef011c4aa1a2)})`,
    subtle: 'transparent',
    none: 'transparent'
};
const $6ff5b404db052892$var$backgroundColorFocus = {
    standard: `var(--ds-background-input-pressed, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`,
    subtle: `var(--ds-background-input-pressed, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`,
    none: 'transparent'
};
const $6ff5b404db052892$var$backgroundColorHover = {
    standard: `var(--ds-background-input-hovered, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`,
    subtle: `var(--ds-background-input-hovered, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`,
    none: 'transparent'
};
const $6ff5b404db052892$var$borderColor = {
    standard: `var(--ds-border-input, ${(0, $73a5c9d720aa66e1$export$d6447c357493214f)})`,
    subtle: 'transparent',
    none: 'transparent'
};
const $6ff5b404db052892$var$borderColorFocus = {
    standard: `var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$export$215b7063051591f1)})`,
    subtle: `var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$export$215b7063051591f1)})`,
    none: 'transparent'
};
const $6ff5b404db052892$var$borderColorHover = {
    standard: `var(--ds-border-input, ${(0, $73a5c9d720aa66e1$export$d6447c357493214f)})`,
    subtle: "var(--ds-border-input, transparent)",
    none: 'transparent'
};
const $6ff5b404db052892$var$getContainerTextBgAndBorderColor = (appearance)=>({
        backgroundColor: $6ff5b404db052892$var$backgroundColor[appearance],
        borderColor: $6ff5b404db052892$var$borderColor[appearance],
        color: `var(--ds-text, ${0, $73a5c9d720aa66e1$export$fbda843f0a27fe96})`,
        cursor: 'text',
        '&:hover:not([data-disabled])': {
            backgroundColor: $6ff5b404db052892$var$backgroundColorHover[appearance],
            borderColor: $6ff5b404db052892$var$borderColorHover[appearance]
        },
        '&:focus-within:not([data-disabled])': {
            backgroundColor: $6ff5b404db052892$var$backgroundColorFocus[appearance],
            borderColor: $6ff5b404db052892$var$borderColorFocus[appearance],
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$6ff5b404db052892$var$borderColorFocus[appearance]}`
        },
        '&[data-disabled]': {
            color: `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de})`,
            cursor: 'not-allowed',
            // Disabled background and border styles should not be applied to components that
            // have either no background or transparent background to begin with
            ...appearance === 'standard' && {
                backgroundColor: `var(--ds-background-disabled, ${0, $73a5c9d720aa66e1$export$e655ef011c4aa1a2})`,
                borderColor: `var(--ds-background-disabled, ${0, $73a5c9d720aa66e1$export$e655ef011c4aa1a2})`
            }
        },
        '&[data-invalid], &[data-invalid]:hover': {
            borderColor: `var(--ds-border-danger, ${0, $73a5c9d720aa66e1$export$2010d0fb4295b346})`,
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-danger, ${0, $73a5c9d720aa66e1$export$2010d0fb4295b346})`}`
        },
        '&[data-invalid]:focus-within': {
            backgroundColor: `var(--ds-background-input-pressed, ${0, $73a5c9d720aa66e1$export$29a4f05edc054374})`,
            borderColor: `var(--ds-border-focused, ${0, $73a5c9d720aa66e1$export$215b7063051591f1})`,
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-focused, ${0, $73a5c9d720aa66e1$export$215b7063051591f1})`}`
        },
        '@media screen and (-ms-high-contrast: active)': {
            '&[data-invalid]:focus-within': {
                borderColor: 'Highlight'
            },
            '&:focus-within': {
                borderColor: 'Highlight'
            },
            '&[data-disabled]': {
                borderColor: 'GrayText'
            }
        }
    });
const $6ff5b404db052892$var$widthMap = {
    xsmall: 80,
    small: 160,
    medium: 240,
    large: 320,
    xlarge: 480
};
const $6ff5b404db052892$var$getMaxWidth = (width)=>!width ? `100%` : width in $6ff5b404db052892$var$widthMap ? $6ff5b404db052892$var$widthMap[width] : +width;
const $6ff5b404db052892$export$5972a68b6e54f38f = (appearance, width)=>({
        alignItems: 'center',
        ...$6ff5b404db052892$var$getContainerTextBgAndBorderColor(appearance),
        borderRadius: 3,
        borderWidth: "var(--ds-border-width, 1px)",
        // add 1px padding on both top and bottom to keep the same overall height after border reduced from 2px to 1px under feature flag
        ...appearance !== 'none' ? {
            padding: `${"var(--ds-border-width, 1px)"} 0`
        } : {},
        borderStyle: appearance === 'none' ? 'none' : 'solid',
        boxSizing: 'border-box',
        display: 'flex',
        flex: '1 1 100%',
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        justifyContent: 'space-between',
        maxWidth: $6ff5b404db052892$var$getMaxWidth(width),
        overflow: 'hidden',
        transition: `background-color 0.2s ease-in-out, border-color 0.2s ease-in-out`,
        wordWrap: 'break-word',
        verticalAlign: 'top',
        pointerEvents: 'auto'
    });
const $6ff5b404db052892$export$3eeb47dc8e6249d9 = ()=>({
        backgroundColor: 'transparent',
        border: 0,
        boxSizing: 'border-box',
        color: 'inherit',
        cursor: 'inherit',
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        minWidth: '0',
        outline: 'none',
        width: '100%',
        '&[data-monospaced]': {
            fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)"
        },
        '&[data-compact]': {
            padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-075, 6px)"}`
        },
        '&:not([data-compact])': {
            padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-075, 6px)"}`
        },
        '&[disabled]': {
            // Safari (WebKit) adds a -webkit-text-fill-color style to disabled inputs
            // which takes priority over color and makes the text unreadable. Need to
            // override it with the color we want.
            WebkitTextFillColor: `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de})`
        },
        // Hide the clear indicator on Edge (Windows only)
        '&::-ms-clear': {
            display: 'none'
        },
        '&:invalid': {
            boxShadow: 'none'
        },
        '&:placeholder-shown': {
            textOverflow: 'ellipsis'
        },
        '&::placeholder': {
            color: `var(--ds-text-subtlest, ${0, $73a5c9d720aa66e1$export$f563ee71e9ee74cd})`,
            '&:disabled': {
                color: `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de})`
            }
        },
        '@media screen and (-ms-high-contrast: active)': {
            '&[disabled]': {
                color: 'GrayText'
            }
        }
    });

});


parcelRegister("4QDtr", function(module, exports) {

$parcel$export(module.exports, "messages", () => $7d945783e0838d15$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $7d945783e0838d15$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    externalLinksLinkType: {
        "id": "servicedesk-external-links.links.add-link-modal.add-link-form.external-links-link-type",
        "defaultMessage": "Type"
    },
    externalLinksLinkTypeKnowledge: {
        "id": "servicedesk-external-links.links.add-link-modal.add-link-form.external-links-link-type-knowledge",
        "defaultMessage": "Self-help resource"
    },
    externalLinksLinkTypeRequestForm: {
        "id": "servicedesk-external-links.links.add-link-modal.add-link-form.external-links-link-type-request-form",
        "defaultMessage": "External request form"
    },
    externalLinksLinkTypeChannels: {
        "id": "servicedesk-external-links.links.add-link-modal.add-link-form.external-links-link-type-channels",
        "defaultMessage": "Communication channel"
    },
    externalLinksLinkTypePlaceholder: {
        "id": "servicedesk-external-links.links.add-link-modal.add-link-form.external-links-link-type-placeholder",
        "defaultMessage": "Select the type of resource you\u2019re linking to"
    },
    externalLinksLinkUrl: {
        "id": "servicedesk-external-links.links.add-link-modal.add-link-form.external-links-link-url",
        "defaultMessage": "URL"
    },
    externalLinksLinkUrlPlaceholder: {
        "id": "servicedesk-external-links.links.add-link-modal.add-link-form.external-links-link-url-placeholder",
        "defaultMessage": "https://www.example.com"
    },
    externalLinksLinkChannelPlaceholder: {
        "id": "servicedesk-external-links.links.add-link-modal.add-link-form.external-links-link-channel-placeholder",
        "defaultMessage": "Enter email (mailto:), phone number (tel:), links to chat etc"
    },
    externalLinksTitle: {
        "id": "servicedesk-external-links.links.add-link-modal.add-link-form.external-links-title",
        "defaultMessage": "Title"
    },
    externalLinksTitlePlaceholder: {
        "id": "servicedesk-external-links.links.add-link-modal.add-link-form.external-links-title-placeholder",
        "defaultMessage": "Your customers will see this title in the portal and help center"
    },
    externalLinksDescription: {
        "id": "servicedesk-external-links.links.add-link-modal.add-link-form.external-links-description",
        "defaultMessage": "Description"
    },
    externalLinksDescriptionPlaceholder: {
        "id": "servicedesk-external-links.links.add-link-modal.add-link-form.external-links-description-placeholder",
        "defaultMessage": "Let your customers know how to use this help resource. This will also show up in your help center search results."
    },
    externalLinksLinkTypeIsRequired: {
        "id": "servicedesk-external-links.links.add-link-modal.add-link-form.external-links-link-type-is-required",
        "defaultMessage": "Select a type."
    },
    externalLinksLinkUrlIsRequired: {
        "id": "servicedesk-external-links.links.add-link-modal.add-link-form.external-links-link-url-is-required",
        "defaultMessage": "Enter a URL."
    },
    externalLinksLinkTitleIsRequired: {
        "id": "servicedesk-external-links.links.add-link-modal.add-link-form.external-links-link-title-is-required",
        "defaultMessage": "Enter a title."
    },
    externalLinksLinkDescriptionIsRequired: {
        "id": "servicedesk-external-links.links.add-link-modal.add-link-form.external-links-link-description-is-required",
        "defaultMessage": "Enter a description."
    },
    externalLinksLinkCharLimitExceeded: {
        "id": "servicedesk-external-links.links.add-link-modal.add-link-form.external-links-link-char-limit-exceeded",
        "defaultMessage": "URL can't exceed {limit, plural, one {# character} other {# characters}}"
    },
    externalLinksTitleCharLimitExceeded: {
        "id": "servicedesk-external-links.links.add-link-modal.add-link-form.external-links-title-char-limit-exceeded",
        "defaultMessage": "Title can't exceed {limit, plural, one {# character} other {# characters}}"
    },
    externalLinksDescriptionCharLimitExceeded: {
        "id": "servicedesk-external-links.links.add-link-modal.add-link-form.external-links-description-char-limit-exceeded",
        "defaultMessage": "Description can't exceed {limit, plural, one {# character} other {# characters}}"
    }
});

});

parcelRegister("8z4xM", function(module, exports) {

$parcel$export(module.exports, "validateSelectField", () => $efd4b16e24e3e2da$export$53ded7ceec493f10);
$parcel$export(module.exports, "validateTextField", () => $efd4b16e24e3e2da$export$13faa191399bd985);

var $8blac = parcelRequire("8blac");

var $aNx7t = parcelRequire("aNx7t");
const $efd4b16e24e3e2da$var$trimValue = (value)=>value !== undefined ? value.trim() : '';
const $efd4b16e24e3e2da$export$32cbc862f10d11f4 = (value)=>{
    const trimmedValue = $efd4b16e24e3e2da$var$trimValue(value);
    if (trimmedValue.length === 0) return (0, $aNx7t.ERROR_TYPES).EMPTY;
    return undefined;
};
const $efd4b16e24e3e2da$export$53ded7ceec493f10 = (linkType)=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(linkType) || (0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(linkType.value)) return (0, $aNx7t.ERROR_TYPES).EMPTY;
    return undefined;
};
const $efd4b16e24e3e2da$export$92b4f8d12c3d0dc3 = (value)=>{
    const trimmedValue = $efd4b16e24e3e2da$var$trimValue(value);
    const regex = "^(ht|f)tp(s?)://[0-9a-zA-Z]([-.w]*[0-9a-zA-Z])*(:(0-9)*)*(/?)([a-zA-Z0-9-.?,'/\\+&amp;%$#_]*)?$";
    if (trimmedValue.match(regex)) return false;
    return true;
};
const $efd4b16e24e3e2da$export$13faa191399bd985 = (name, value)=>{
    const error = $efd4b16e24e3e2da$export$32cbc862f10d11f4(value);
    if (error === undefined && value !== undefined) switch(name){
        case 'link':
            return value.length > (0, $aNx7t.MAX_URL_LENGTH) ? (0, $aNx7t.ERROR_TYPES).CHAR_LIMIT_EXCEEDED : undefined;
        case 'title':
            return value.length > (0, $aNx7t.MAX_TITLE_LENGTH) ? (0, $aNx7t.ERROR_TYPES).CHAR_LIMIT_EXCEEDED : undefined;
        case 'description':
            return value.length > (0, $aNx7t.MAX_DESCRIPTION_LENGTH) ? (0, $aNx7t.ERROR_TYPES).CHAR_LIMIT_EXCEEDED : undefined;
        default:
            return undefined;
    }
    return error;
};

});


parcelRegister("1RnLW", function(module, exports) {

$parcel$export(module.exports, "messages", () => $2e703487b7959f6b$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $2e703487b7959f6b$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    externalLinksAddLink: {
        "id": "servicedesk-external-links.links.add-link-modal.external-links-add-link",
        "defaultMessage": "Add link"
    },
    externalLinksAdd: {
        "id": "servicedesk-external-links.links.add-link-modal.external-links-add",
        "defaultMessage": "Add"
    },
    externalLinksCancel: {
        "id": "servicedesk-external-links.links.add-link-modal.external-links-cancel",
        "defaultMessage": "Cancel"
    },
    externalLinkAddSuccessFlagTitle: {
        "id": "servicedesk-external-links.links.add-link-modal.external-link-add-success-flag-title",
        "defaultMessage": "Link added"
    },
    externalLinkAddSuccessFlagDescription: {
        "id": "servicedesk-external-links.links.add-link-modal.external-link-add-success-flag-description",
        "defaultMessage": "The link \u2018{linkTitle}\u2019 will now show up in your portal."
    },
    externalLinkAddFailureTitle: {
        "id": "servicedesk-external-links.links.add-link-modal.external-link-add-failure-title",
        "defaultMessage": "We couldn\u2019t add this link"
    },
    externalLinkAddFailureDescription: {
        "id": "servicedesk-external-links.links.add-link-modal.external-link-add-failure-description",
        "defaultMessage": "Try again in some time."
    },
    externalLinksEditLink: {
        "id": "servicedesk-external-links.links.add-link-modal.external-links-edit-link",
        "defaultMessage": "Edit link"
    },
    externalLinksSaveLink: {
        "id": "servicedesk-external-links.links.add-link-modal.external-links-save-link",
        "defaultMessage": "Save changes"
    },
    externalLinkUpdateSuccessFlagTitle: {
        "id": "servicedesk-external-links.links.add-link-modal.external-link-update-success-flag-title",
        "defaultMessage": "Link updated"
    },
    externalLinkUpdateSuccessFlagDescription: {
        "id": "servicedesk-external-links.links.add-link-modal.external-link-update-success-flag-description",
        "defaultMessage": "The changes you made to the link \u2018{linkTitle}\u2019 will now be visible to customers."
    },
    linkFlagActionLabel: {
        "id": "servicedesk-external-links.links.add-link-modal.link-flag-action-label",
        "defaultMessage": "View in portal"
    },
    externalLinkUpdateFailureTitle: {
        "id": "servicedesk-external-links.links.add-link-modal.external-link-update-failure-title",
        "defaultMessage": "We couldn\u2019t update this link"
    },
    externalLinkUpdateFailureDescription: {
        "id": "servicedesk-external-links.links.add-link-modal.external-link-update-failure-description",
        "defaultMessage": "Try again in some time."
    }
});

});


parcelRegister("2XNf4", function(module, exports) {

$parcel$export(module.exports, "DeleteDiscardPrompt", () => $88727f79be2b5ef5$export$17ef430d0a063b04);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");
var $7opLA = parcelRequire("7opLA");

var $aOw1G = parcelRequire("aOw1G");
var $lfiOu = parcelRequire("lfiOu");
var $2OJfS = parcelRequire("2OJfS");
var $kigFe = parcelRequire("kigFe");
var $boSVF = parcelRequire("boSVF");
var $dxopF = parcelRequire("dxopF");

var $kGQen = parcelRequire("kGQen");

var $0cdA8 = parcelRequire("0cdA8");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");

var $aLG4f = parcelRequire("aLG4f");

var $dIgM7 = parcelRequire("dIgM7");
function $88727f79be2b5ef5$export$17ef430d0a063b04(props) {
    const { isOpen: isOpen, isDeleting: isDeleting, onCancel: onCancel, onProceed: onProceed } = props;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dxopF.default), null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aLG4f.ProductExperienceStart), {
        ufoExperience: (0, $aLG4f.externalResourcesDeleteExperience)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "externalResourcesDelete",
        packageName: "jiraServicedeskExternalResourcesSettings",
        teamName: "jsm-nebula",
        fallback: "flag",
        onError: (0, $aLG4f.markDeleteExperienceFailed)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kGQen.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOw1G.default), {
        onClose: (_, analyticsEvent)=>{
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'externalResourceDeleteDiscardPrompt');
            onCancel();
            (0, $aLG4f.externalResourcesDeleteExperience).abort();
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kigFe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $boSVF.default), {
        appearance: "warning"
    }, formatMessage((0, $dIgM7.default).externalLinkDeleteDiscardPromptHeader))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lfiOu.default), null, formatMessage((0, $dIgM7.default).externalLinkDeleteDiscardPromptBody)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2OJfS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "subtle-link",
        onClick: (_, analyticsEvent)=>{
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'externalResourceDeleteDiscardPromptCancel');
            onCancel();
            (0, $aLG4f.externalResourcesDeleteExperience).abort();
        },
        isDisabled: isDeleting
    }, formatMessage((0, $dIgM7.default).externalLinkDeleteDiscardPromptCancel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7opLA.default), {
        appearance: "warning",
        onClick: (_, analyticsEvent)=>{
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'externalResourceDeleteDiscardPromptProceed');
            onProceed();
        },
        isDisabled: isDeleting,
        isLoading: isDeleting
    }, formatMessage((0, $dIgM7.default).externalLinkDeleteDiscardPromptProceed))))))));
}
var $88727f79be2b5ef5$export$2e2bcd8739ae039 = $88727f79be2b5ef5$export$17ef430d0a063b04;

});
parcelRegister("dIgM7", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2144e6929a6908f$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $e2144e6929a6908f$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    externalLinkDeleteDiscardPromptHeader: {
        "id": "servicedesk-external-links.links.delete-discard-prompt.external-link-delete-discard-prompt-header",
        "defaultMessage": "Remove link"
    },
    externalLinkDeleteDiscardPromptBody: {
        "id": "servicedesk-external-links.links.delete-discard-prompt.external-link-delete-discard-prompt-body",
        "defaultMessage": "This link will no longer show up on your portal or help center."
    },
    externalLinkDeleteDiscardPromptCancel: {
        "id": "servicedesk-external-links.links.delete-discard-prompt.external-link-delete-discard-prompt-cancel",
        "defaultMessage": "Cancel"
    },
    externalLinkDeleteDiscardPromptProceed: {
        "id": "servicedesk-external-links.links.delete-discard-prompt.external-link-delete-discard-prompt-proceed",
        "defaultMessage": "Remove link"
    }
});

});


parcelRegister("aQ7jM", function(module, exports) {

$parcel$export(module.exports, "EmptyLinkSection", () => $6f8b6040026feeda$export$40c4be18204b85d1);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $eI5EY = parcelRequire("eI5EY");

var $bVljD = parcelRequire("bVljD");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");

var $iJHZm = parcelRequire("iJHZm");

var $9ejd1 = parcelRequire("9ejd1");
const $6f8b6040026feeda$export$40c4be18204b85d1 = (props)=>{
    const { onAddLinkClick: onAddLinkClick } = props;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6f8b6040026feeda$var$EmptyLinkSectionWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bVljD.default), {
        alt: formatMessage((0, $9ejd1.default).externalLinkEmptyImageAlt)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6f8b6040026feeda$var$EmptyLinkSectionHeading, null, formatMessage((0, $9ejd1.default).externalLinkEmptySectionHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6f8b6040026feeda$var$EmptyLinkSectionBody, null, formatMessage((0, $9ejd1.default).externalLinkEmptySectionBody)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "primary",
        onClick: (_, analyticsEvent)=>{
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'externalResourceAdd', {
                isEmpty: true
            });
            onAddLinkClick();
        },
        "data-testId": "servicedesk-external-links.ui.links.empty-link-section.add-link-button"
    }, formatMessage((0, $9ejd1.default).externalLinkEmptySectionAddLinkButton)), (0, $eI5EY.fg)('jsm_simplified_project_settings_navigation') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJHZm.SpaStatePageReady), null));
};
var $6f8b6040026feeda$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $6f8b6040026feeda$export$40c4be18204b85d1;
const $6f8b6040026feeda$var$EmptyLinkSectionWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _4cvr1h6o _18s810tx _1yt4xncg _p12f1ogm _vchhusvi",
            __cmplp.className
        ])
    });
});
const $6f8b6040026feeda$var$EmptyLinkSectionHeading = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "h3", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pkoahv _otyrpxbi",
            __cmplp.className
        ])
    });
});
const $6f8b6040026feeda$var$EmptyLinkSectionBody = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pkidpf _otyr1ejb _y3gn1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("bVljD", function(module, exports) {

$parcel$export(module.exports, "default", () => $815c7ce1f624f18e$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See closest README.md

var $9TZf5 = parcelRequire("9TZf5");

var $kUZ6U = parcelRequire("kUZ6U");
const $815c7ce1f624f18e$var$Illustration = (0, $9TZf5.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($kUZ6U)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($kUZ6U))
});
var $815c7ce1f624f18e$export$2e2bcd8739ae039 = $815c7ce1f624f18e$var$Illustration;
// for advanced use only
// view box should be automatically set by svg values
const $815c7ce1f624f18e$export$a179c88182cb9d56 = [
    0,
    0,
    264,
    212
];

});
parcelRegister("kUZ6U", function(module, exports) {
module.exports = new URL("empty-help-links.ba11e4e4.svg", import.meta.url).toString();

});


parcelRegister("9ejd1", function(module, exports) {

$parcel$export(module.exports, "default", () => $cdedc55a59ee6993$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $cdedc55a59ee6993$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    externalLinkEmptySectionHeader: {
        "id": "servicedesk-external-links.links.empty-link-section.external-link-emptty-section-header",
        "defaultMessage": "Link out to external resources from your help center"
    },
    externalLinkEmptyImageAlt: {
        "id": "servicedesk-external-links.links.empty-link-section.external-link-empty-image-alt",
        "defaultMessage": "empty help links image"
    },
    externalLinkEmptySectionBody: {
        "id": "servicedesk-external-links.links.empty-link-section.external-link-emptty-section-body",
        "defaultMessage": "Give your customers and team access to external knowledge and tools from your Jira Service Management portal."
    },
    externalLinkEmptySectionAddLinkButton: {
        "id": "servicedesk-external-links.links.empty-link-section.external-link-empty-section-add-link-button",
        "defaultMessage": "Add a link"
    }
});

});


parcelRegister("6SJDT", function(module, exports) {

$parcel$export(module.exports, "LimitReachedPopup", () => $36a5ac72ce54f614$export$cdfc1869a20fa03a);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $jgrQL = parcelRequire("jgrQL");

var $aUqTb = parcelRequire("aUqTb");

var $3MV1G = parcelRequire("3MV1G");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");

var $jR55q = parcelRequire("jR55q");
const $36a5ac72ce54f614$export$cdfc1869a20fa03a = ()=>{
    const [isDisabledPopupOpen, setIsDisabledPopupOpen] = (0, $eUqFw.useState)(false);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        isOpen: isDisabledPopupOpen,
        onClose: ()=>{
            setIsDisabledPopupOpen(false);
        },
        placement: "bottom-end",
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($36a5ac72ce54f614$var$PopupWrapper, null, formatMessage((0, $jR55q.default).limitReachedPopupContent)),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                ...triggerProps,
                onClick: (_, analyticsEvent)=>{
                    (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'externalResourceLimitReachedInfo');
                    setIsDisabledPopupOpen(!isDisabledPopupOpen);
                },
                iconBefore: isDisabledPopupOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jgrQL))), {
                    label: (0, $jR55q.default).editorInfoIconLabel.defaultMessage
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aUqTb))), {
                    label: (0, $jR55q.default).editorPanelIconLabel.defaultMessage
                }),
                appearance: "subtle-link"
            })
    });
};
var $36a5ac72ce54f614$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $36a5ac72ce54f614$export$cdfc1869a20fa03a;
const $36a5ac72ce54f614$var$PopupWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt4pxbi _p12fclpc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jgrQL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e0651d627acb5549$var$_react = $e0651d627acb5549$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $e0651d627acb5549$var$_information = $e0651d627acb5549$var$_interopRequireDefault((parcelRequire("h6FFs")));
function $e0651d627acb5549$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e0651d627acb5549$var$EditorInfoIcon = (props)=>/*#__PURE__*/ $e0651d627acb5549$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16m0-8.5a1 1 0 0 0-1 1V15a1 1 0 0 0 2 0v-2.5a1 1 0 0 0-1-1m0-1.125a1.375 1.375 0 1 0 0-2.75 1.375 1.375 0 0 0 0 2.75"/></svg>`
    }, props, {
        newIcon: $e0651d627acb5549$var$_information.default
    }));
$e0651d627acb5549$var$EditorInfoIcon.displayName = 'EditorInfoIcon';
var $e0651d627acb5549$var$_default = module.exports.default = $e0651d627acb5549$var$EditorInfoIcon;

});
parcelRegister("h6FFs", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6db48d6c22f8d07c19434865c237f982>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c743518dce4b322a$var$_react = $c743518dce4b322a$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $c743518dce4b322a$var$_UNSAFE_baseNew = $c743518dce4b322a$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $c743518dce4b322a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Information".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: information state in section messages or inline messages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c743518dce4b322a$var$InformationIcon = (props)=>/*#__PURE__*/ $c743518dce4b322a$var$_react.default.createElement($c743518dce4b322a$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m6.5-1.25H8a.75.75 0 0 1 .75.75v5h-1.5V8.25H6.5zM8 5.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`
    }, props));
$c743518dce4b322a$var$InformationIcon.displayName = 'InformationIcon';
var $c743518dce4b322a$var$_default = module.exports.default = $c743518dce4b322a$var$InformationIcon;

});


parcelRegister("aUqTb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7f13fdf9f823d771$var$_react = $7f13fdf9f823d771$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $7f13fdf9f823d771$var$_information = $7f13fdf9f823d771$var$_interopRequireDefault((parcelRequire("h6FFs")));
function $7f13fdf9f823d771$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $7f13fdf9f823d771$var$EditorPanelIcon = (props)=>/*#__PURE__*/ $7f13fdf9f823d771$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 19a7 7 0 1 1 0-14 7 7 0 0 1 0 14m0-1.5a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11m0-6a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0v-2a1 1 0 0 1 1-1m0-3a1 1 0 1 1 0 2 1 1 0 0 1 0-2"/></svg>`
    }, props, {
        newIcon: $7f13fdf9f823d771$var$_information.default
    }));
$7f13fdf9f823d771$var$EditorPanelIcon.displayName = 'EditorPanelIcon';
var $7f13fdf9f823d771$var$_default = module.exports.default = $7f13fdf9f823d771$var$EditorPanelIcon;

});

parcelRegister("jR55q", function(module, exports) {

$parcel$export(module.exports, "default", () => $834c1c237f4eeaa7$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $834c1c237f4eeaa7$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    limitReachedPopupContent: {
        "id": "servicedesk-external-links.links.limit-reached-popup.limit-reached-popup-content",
        "defaultMessage": "You\u2019ve already added 10 links. Remove a link to add another one."
    },
    editorInfoIconLabel: {
        "id": "servicedesk-external-links.links.limit-reached-popup.editor-info-icon-label",
        "defaultMessage": "Editor Info"
    },
    editorPanelIconLabel: {
        "id": "servicedesk-external-links.links.limit-reached-popup.editor-panel-icon-label",
        "defaultMessage": "Editor Panel"
    }
});

});


parcelRegister("hI9bd", function(module, exports) {

$parcel$export(module.exports, "Link", () => $8428b4adcccae05e$export$a6c7ac8248d6e38a);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $bFzGY = parcelRequire("bFzGY");

var $7u4fN = parcelRequire("7u4fN");

var $hI5oG = parcelRequire("hI5oG");

var $3nnLQ = parcelRequire("3nnLQ");

var $jWuk1 = parcelRequire("jWuk1");

var $dG2h0 = parcelRequire("dG2h0");

var $aQrlQ = parcelRequire("aQrlQ");

var $hUwRB = parcelRequire("hUwRB");

var $aJdjG = parcelRequire("aJdjG");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $2eG9N = parcelRequire("2eG9N");

var $9VPEO = parcelRequire("9VPEO");

var $c9TLT = parcelRequire("c9TLT");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");

var $bFQmf = parcelRequire("bFQmf");

var $eJ9JU = parcelRequire("eJ9JU");
function $8428b4adcccae05e$export$a6c7ac8248d6e38a(props) {
    const { id: id, title: title, description: description, link: link, resourceType: resourceType, index: index, onDelete: onDelete, onUpdate: onUpdate } = props;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    let origin;
    try {
        origin = new URL(link).origin;
    } catch (error) {
        origin = '';
    }
    const isValidOrigin = Boolean(origin) && origin !== 'null';
    const [data, { fetchExternalLinkIcon: fetchExternalLinkIcon }] = (0, $bFQmf.useLinkIcon)(origin);
    (0, $eUqFw.useEffect)(()=>{
        if (isValidOrigin) fetchExternalLinkIcon(origin);
    }, [
        isValidOrigin,
        origin,
        fetchExternalLinkIcon
    ]);
    const getFallbackIcon = (iconType)=>{
        switch(iconType){
            case 'request-form':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aQrlQ))), {
                    label: formatMessage((0, $eJ9JU.default).externalLinkRequestFormIconLabel)
                });
            case 'knowledge':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3nnLQ))), {
                    label: formatMessage((0, $eJ9JU.default).externalLinkKnowledgeIconLabel)
                });
            case 'channel':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aJdjG))), {
                    label: formatMessage((0, $eJ9JU.default).externalLinkChannelIconLabel)
                });
            default:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hUwRB))), {
                    label: formatMessage((0, $eJ9JU.default).externalLinkOtherIconLabel)
                });
        }
    };
    const linkAnalyticsEvent = createAnalyticsEvent({
        action: 'clicked',
        actionSubject: 'link'
    });
    const getIcon = ()=>{
        if (isValidOrigin) {
            if (!data || data.isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9VPEO.Skeleton), {
                height: $8428b4adcccae05e$var$iconDimension,
                width: $8428b4adcccae05e$var$iconDimension
            });
            if (data.iconUrl) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8428b4adcccae05e$var$ImageContainer, {
                src: data.iconUrl,
                alt: ""
            });
        }
        return getFallbackIcon(resourceType);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8428b4adcccae05e$var$LinkWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $8428b4adcccae05e$var$iconWrapperStyles
    }, getIcon()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8428b4adcccae05e$var$ContentWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
        content: formatMessage((0, $eJ9JU.default).externalLinkTitleTooltip),
        position: "mouse",
        mousePosition: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8428b4adcccae05e$var$LinkContainer, {
        target: "_blank",
        rel: "noopener noreferrer",
        href: link,
        onClick: ()=>{
            (0, $jMP2a.fireUIAnalytics)(linkAnalyticsEvent, 'externalResource', {
                link_position: index,
                resourceType: resourceType
            });
        },
        "data-testid": "servicedesk-external-links.ui.links.link.a"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        size: "small",
        as: "h2"
    }, title))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8428b4adcccae05e$var$DescriptionContainer, null, description)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8428b4adcccae05e$var$LinkActions, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
        content: formatMessage((0, $eJ9JU.default).externalLinkUpdateButtonTooltip)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "subtle",
        name: "external-resource-update",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dG2h0))), {
            label: formatMessage((0, $eJ9JU.default).externalLinkUpdateButtonLabel, {
                title: title
            })
        }),
        onClick: (_, analyticsEvent)=>{
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'externalResourceUpdate', {
                link_position: index + 1,
                resourceType: resourceType
            });
            onUpdate(id);
        },
        "data-testId": "servicedesk-external-links.ui.links.link.update-link-button"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
        content: formatMessage((0, $eJ9JU.default).externalLinkRemoveButtonTooltip)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "subtle",
        name: "external-resource-delete",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jWuk1))), {
            label: formatMessage((0, $eJ9JU.default).externalLinkRemoveButtonLabel, {
                title: title
            })
        }),
        onClick: (_, analyticsEvent)=>{
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'externalResourceDelete', {
                link_position: index + 1,
                resourceType: resourceType
            });
            onDelete(id);
        },
        "data-testId": "servicedesk-external-links.ui.links.link.delete-link-button"
    }))));
}
var $8428b4adcccae05e$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $8428b4adcccae05e$export$a6c7ac8248d6e38a;
const $8428b4adcccae05e$var$LinkWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _80om73ad _1yt41b66 _otyrpxbi _1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8428b4adcccae05e$var$LinkActions = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1wpz1h6o _2hwxpxbi",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8428b4adcccae05e$var$ContentWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1nmz9jpi",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8428b4adcccae05e$var$DescriptionContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaznoz8",
            __cmplp.className
        ])
    });
});
const $8428b4adcccae05e$var$iconWrapperStyles = (0, $1ZAYh.xcss)({
    marginRight: 'space.200'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $8428b4adcccae05e$var$iconDimension = `${3 * (0, $c9TLT.gridSize)}px`; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8428b4adcccae05e$var$ImageContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_5w6uu": (0, $9t7rW.default)($8428b4adcccae05e$var$iconDimension)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1c36 _1bsb1c36 _5ral1f51",
            __cmplp.className
        ])
    });
});
const $8428b4adcccae05e$var$LinkContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1o8l _30l31fxt",
            __cmplp.className
        ])
    });
});

});
parcelRegister("dG2h0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9f50f60bfaf41385$var$_react = $9f50f60bfaf41385$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $9f50f60bfaf41385$var$_edit = $9f50f60bfaf41385$var$_interopRequireDefault((parcelRequire("e5yQJ")));
function $9f50f60bfaf41385$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9f50f60bfaf41385$var$EditorEditIcon = (props)=>/*#__PURE__*/ $9f50f60bfaf41385$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M15.148 6.852a.5.5 0 0 1 .708.004l2.288 2.288a.5.5 0 0 1 .004.708L11 17l-3-3zM7 15l3 3-3.51.877c-.27.068-.436-.092-.367-.367z"/></svg>`
    }, props, {
        newIcon: $9f50f60bfaf41385$var$_edit.default
    }));
$9f50f60bfaf41385$var$EditorEditIcon.displayName = 'EditorEditIcon';
var $9f50f60bfaf41385$var$_default = module.exports.default = $9f50f60bfaf41385$var$EditorEditIcon;

});
parcelRegister("e5yQJ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d48c51235c7072e6617b637653c3f4fe>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a41c90bad15a5169$var$_react = $a41c90bad15a5169$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $a41c90bad15a5169$var$_UNSAFE_baseNew = $a41c90bad15a5169$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $a41c90bad15a5169$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Edit".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for editing objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a41c90bad15a5169$var$EditIcon = (props)=>/*#__PURE__*/ $a41c90bad15a5169$var$_react.default.createElement($a41c90bad15a5169$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M6 1.751H3c-.69 0-1.25.56-1.25 1.25v10c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V10m-.75-5 1.116-1.116a1.25 1.25 0 0 0 0-1.768l-.732-.732a1.25 1.25 0 0 0-1.768 0L11 2.5M13.5 5 9.479 9.021c-.15.15-.336.26-.54.318l-3.189.911.911-3.189a1.25 1.25 0 0 1 .318-.54L11 2.5M13.5 5 11 2.5"/>`
    }, props));
$a41c90bad15a5169$var$EditIcon.displayName = 'EditIcon';
var $a41c90bad15a5169$var$_default = module.exports.default = $a41c90bad15a5169$var$EditIcon;

});


parcelRegister("hUwRB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d0a128a0d80d703a$var$_react = $d0a128a0d80d703a$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $d0a128a0d80d703a$var$_link = $d0a128a0d80d703a$var$_interopRequireDefault((parcelRequire("h0HFa")));
function $d0a128a0d80d703a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d0a128a0d80d703a$var$LinkIcon = (props)=>/*#__PURE__*/ $d0a128a0d80d703a$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="m12.856 5.457-.937.92a1 1 0 0 0 0 1.437 1.047 1.047 0 0 0 1.463 0l.984-.966c.967-.95 2.542-1.135 3.602-.288a2.54 2.54 0 0 1 .203 3.81l-2.903 2.852a2.646 2.646 0 0 1-3.696 0l-1.11-1.09L9 13.57l1.108 1.089c1.822 1.788 4.802 1.788 6.622 0l2.905-2.852a4.558 4.558 0 0 0-.357-6.82c-1.893-1.517-4.695-1.226-6.422.47"/><path d="m11.144 19.543.937-.92a1 1 0 0 0 0-1.437 1.047 1.047 0 0 0-1.462 0l-.985.966c-.967.95-2.542 1.135-3.602.288a2.54 2.54 0 0 1-.203-3.81l2.903-2.852a2.646 2.646 0 0 1 3.696 0l1.11 1.09L15 11.43l-1.108-1.089c-1.822-1.788-4.802-1.788-6.622 0l-2.905 2.852a4.558 4.558 0 0 0 .357 6.82c1.893 1.517 4.695 1.226 6.422-.47"/></g></svg>`
    }, props, {
        newIcon: $d0a128a0d80d703a$var$_link.default
    }));
$d0a128a0d80d703a$var$LinkIcon.displayName = 'LinkIcon';
var $d0a128a0d80d703a$var$_default = module.exports.default = $d0a128a0d80d703a$var$LinkIcon;

});
parcelRegister("h0HFa", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::af316a11070150755855d308e4656f28>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c6244e4cd9ddde64$var$_react = $c6244e4cd9ddde64$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $c6244e4cd9ddde64$var$_UNSAFE_baseNew = $c6244e4cd9ddde64$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $c6244e4cd9ddde64$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Link".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links, urls, or copy link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c6244e4cd9ddde64$var$LinkIcon = (props)=>/*#__PURE__*/ $c6244e4cd9ddde64$var$_react.default.createElement($c6244e4cd9ddde64$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="m5.25 10.75 5.5-5.5M5 6.5 2.75 8.75a3.182 3.182 0 0 0 4.5 4.5L9.5 11m-3-6 2.25-2.25a3.182 3.182 0 0 1 4.5 4.5L11 9.5"/>`
    }, props));
$c6244e4cd9ddde64$var$LinkIcon.displayName = 'LinkIcon';
var $c6244e4cd9ddde64$var$_default = module.exports.default = $c6244e4cd9ddde64$var$LinkIcon;

});


parcelRegister("9VPEO", function(module, exports) {

$parcel$export(module.exports, "getKeyframes", () => $fdf3dd89d5b95a51$export$b2b5e866b2fbf2ec);
$parcel$export(module.exports, "Skeleton", () => $fdf3dd89d5b95a51$export$8f31e4c4a37b8e9c);
$parcel$export(module.exports, "Spacer", () => $fdf3dd89d5b95a51$export$d7a54cba636a8cd6);
$parcel$export(module.exports, "SkeletonCompiled", () => $fdf3dd89d5b95a51$export$dc84d515085190e);
$parcel$export(module.exports, "SpacerCompiled", () => $fdf3dd89d5b95a51$export$e477bb7d17087f28);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line jira/restricted/styled-components-migration, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $kwce8 = parcelRequire("kwce8");

const $fdf3dd89d5b95a51$export$b2b5e866b2fbf2ec = (offsetX = 0)=>{
    const fromPositionX = -Math.abs(offsetX) - 300;
    const toPositionX = fromPositionX + 2000;
    return (0, $kwce8.keyframes)({
        '0%': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundPosition: `${fromPositionX}px 0`
        },
        '100%': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundPosition: `${toPositionX}px 0`
        }
    });
};
const $fdf3dd89d5b95a51$var$shimmer = $fdf3dd89d5b95a51$export$b2b5e866b2fbf2ec();
const $fdf3dd89d5b95a51$export$8f31e4c4a37b8e9c = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "ieqbub-0"
})(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        animationDelay: props.theme.animationDelay || '0s',
        animationDuration: '1s',
        animationFillMode: 'forwards',
        animationIterationCount: 'infinite',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        animationName: props.theme.animationName || $fdf3dd89d5b95a51$var$shimmer,
        animationTimingFunction: 'linear',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        backgroundColor: `var(--ds-skeleton, ${(0, $73a5c9d720aa66e1$exports).N30})`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        backgroundImage: `linear-gradient( to right, ${`var(--ds-skeleton, ${(0, $73a5c9d720aa66e1$exports).N30})`} 10%, ${`var(--ds-skeleton-subtle, ${(0, $73a5c9d720aa66e1$exports).N20})`} 30%, ${`var(--ds-skeleton, ${(0, $73a5c9d720aa66e1$exports).N30})`} 50% )`,
        backgroundRepeat: 'no-repeat',
        borderRadius: '2px',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: props.height,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: props.width
    }));
const $fdf3dd89d5b95a51$export$d7a54cba636a8cd6 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "ieqbub-1"
})((props)=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: props.height
    }));
const $fdf3dd89d5b95a51$export$dc84d515085190e = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_8jvb0j": (0, $9t7rW.default)(__cmplp.height),
            "--_1gljcou": (0, $9t7rW.default)(__cmplp.width)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_ju25ru3m _5sag9cwz _1o51q7pw _tip812c5 _j7hq1245 _1pglp3kn _bfhkqrzy _1itk1ipn _12vemgnk _2rkoyh40 _4t3i1474 _1bsb1rkg",
            __cmplp.className
        ])
    });
});
const $fdf3dd89d5b95a51$export$e477bb7d17087f28 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_8jvb0j": (0, $9t7rW.default)(__cmplp.height)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1474",
            __cmplp.className
        ])
    });
});

});

parcelRegister("eJ9JU", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca65797e2a364a89$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $ca65797e2a364a89$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    externalLinkRequestFormIconLabel: {
        "id": "servicedesk-external-links.links.link.external-link-request-form-icon-label",
        "defaultMessage": "External request form"
    },
    externalLinkKnowledgeIconLabel: {
        "id": "servicedesk-external-links.links.link.external-link-knowledge-icon-label",
        "defaultMessage": "Self-help resources"
    },
    externalLinkChannelIconLabel: {
        "id": "servicedesk-external-links.links.link.external-link-channel-icon-label",
        "defaultMessage": "Communication channel"
    },
    externalLinkOtherIconLabel: {
        "id": "servicedesk-external-links.links.link.external-link-other-icon-label",
        "defaultMessage": "Other"
    },
    externalLinkRemoveButtonLabel: {
        "id": "servicedesk-external-links.links.link.external-link-remove-button-label",
        "defaultMessage": "Remove {title}"
    },
    externalLinkRemoveButtonTooltip: {
        "id": "servicedesk-external-links.links.link.external-link-remove-button-tooltip",
        "defaultMessage": "Remove link"
    },
    externalLinkTitleTooltip: {
        "id": "servicedesk-external-links.links.link.external-link-title-tooltip",
        "defaultMessage": "Opens in new tab"
    },
    externalLinkUpdateButtonLabel: {
        "id": "servicedesk-external-links.links.link.external-link-update-button-label",
        "defaultMessage": "Edit {title}"
    },
    externalLinkUpdateButtonTooltip: {
        "id": "servicedesk-external-links.links.link.external-link-update-button-tooltip",
        "defaultMessage": "Edit link"
    }
});

});


parcelRegister("ajZNq", function(module, exports) {

$parcel$export(module.exports, "default", () => $9fc09d9a9a4a4ea6$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $9fc09d9a9a4a4ea6$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    externalLinksAddLinkButton: {
        "id": "servicedesk-external-links.links.external-links-add-link-button",
        "defaultMessage": "Add link"
    },
    externalLinksPageHeaderHeading: {
        "id": "servicedesk-external-links.links.external-links-page-header-heading",
        "defaultMessage": "External resources"
    },
    externalLinksPageHeaderDescription: {
        "id": "servicedesk-external-links.links.external-links-page-header-description",
        "defaultMessage": "Share helpful external resources as links on your portal. These links can be added to topics in your help center and will also show up in your help center search. View these links on your portal."
    },
    externalLinksReorderingPageHeaderDescription: {
        "id": "servicedesk-external-links.links.external-links-reordering-page-header-description",
        "defaultMessage": "Share helpful external resources as links on your portal. Add up to {limit, plural, one {# link} other {# links}} and drag and drop to reorder them. These links can be added to topics in your help center and will also show up in your help center search. <a>View these links on your portal.</a>"
    },
    externalLinksDeleteSuccessFlagTitle: {
        "id": "servicedesk-external-links.links.external-links-delete-success-flag-title",
        "defaultMessage": "Link removed"
    },
    externalLinksDeleteSuccessFlagDescription: {
        "id": "servicedesk-external-links.links.external-links-delete-success-flag-description",
        "defaultMessage": "The link \u2018{linkTitle}\u2019 will no longer show up in your portal or help center."
    },
    externalLinksDeleteFailureTitle: {
        "id": "servicedesk-external-links.links.external-links-delete-failure-title",
        "defaultMessage": "We couldn\u2019t remove this link"
    },
    externalLinksDeleteFailureDescription: {
        "id": "servicedesk-external-links.links.external-links-delete-failure-description",
        "defaultMessage": "Try again in some time."
    },
    externalLinksMaxLimitReached: {
        "id": "servicedesk-external-links.links.external-links-max-limit-reached",
        "defaultMessage": "You\u2019ve already added {limit, number} links. Remove a link to add another one."
    },
    externalLinksReorderDragIndicatorNonfinal: {
        "id": "servicedesk-external-links.links.external-links-reorder-drag-indicator-nonfinal",
        "defaultMessage": "Use arrow keys to reorder group"
    },
    externalLinksReorderFailureTitle: {
        "id": "servicedesk-external-links.links.external-links-reorder-failure-title",
        "defaultMessage": "We couldn't move that link"
    },
    externalLinksReorderFailureDescription: {
        "id": "servicedesk-external-links.links.external-links-reorder-failure-description",
        "defaultMessage": "Try reordering it again in some time."
    }
});

});

parcelRegister("frmnI", function(module, exports) {

$parcel$export(module.exports, "LinksWrapper", () => $65fcb3732e8a9300$export$cbf4695255523013);
$parcel$export(module.exports, "LinksContentContainer", () => $65fcb3732e8a9300$export$2e31a6d94bf6a1fa);
$parcel$export(module.exports, "SpinnerContainer", () => $65fcb3732e8a9300$export$a5e06607a5ac6158);
$parcel$export(module.exports, "PageActionsWrapper", () => $65fcb3732e8a9300$export$1054f56b41fa041d);
$parcel$export(module.exports, "StyledButton", () => $65fcb3732e8a9300$export$2d5d2ba3c7c8c40b);
$parcel$export(module.exports, "LinkContentWrapper", () => $65fcb3732e8a9300$export$6d09c475984ed8b7);
$parcel$export(module.exports, "DragButton", () => $65fcb3732e8a9300$export$1c653b07d89b38);
$parcel$export(module.exports, "DragWrapper", () => $65fcb3732e8a9300$export$2449e465a73dd7ac);
$parcel$export(module.exports, "LinkWrapper", () => $65fcb3732e8a9300$export$ce4b6a469c26f53f);
$parcel$export(module.exports, "LinksListWrapper", () => $65fcb3732e8a9300$export$d54373d94c02833a);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");
const $65fcb3732e8a9300$export$cbf4695255523013 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_p12f1c3h",
            __cmplp.className
        ])
    });
});
const $65fcb3732e8a9300$export$2e31a6d94bf6a1fa = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pk1jfw",
            __cmplp.className
        ])
    });
});
const $65fcb3732e8a9300$export$a5e06607a5ac6158 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_y3gn1h6o",
            __cmplp.className
        ])
    });
});
const $65fcb3732e8a9300$export$1054f56b41fa041d = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $65fcb3732e8a9300$export$2d5d2ba3c7c8c40b = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $7u4fN.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2hwx1b66",
            __cmplp.className
        ])
    });
});
const $65fcb3732e8a9300$var$LINK_CONTENT_WRAPPER_SELECTOR = 'link-content-wrapper';
const $65fcb3732e8a9300$var$linkContentWrapperStyles = null;
const $65fcb3732e8a9300$export$6d09c475984ed8b7 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-component-selector": $65fcb3732e8a9300$var$LINK_CONTENT_WRAPPER_SELECTOR,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _18u01b66 _19pk1b66"
        ])
    }, props.children);
const $65fcb3732e8a9300$export$1c653b07d89b38 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _syazkjmk _19pku2gc _12ji1r31 _1qu2glyw _12y31o36 _1bsb1tcg _1o9zidpf",
            __cmplp.className
        ])
    });
});
const $65fcb3732e8a9300$export$2449e465a73dd7ac = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isDragging: isDragging, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "",
            __cmplp.isDragging && "_1pbyowjs _16qs1gmf _2rko1y44 _17rqglyw",
            __cmplp.className
        ])
    });
});
const $65fcb3732e8a9300$export$ce4b6a469c26f53f = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1yt41b66 _otyru2gc _2rko1y44 _bfhkr01l _1pbyb4wl _16qs1drn _irr31nz6",
            __cmplp.className
        ])
    });
});
const $65fcb3732e8a9300$export$d54373d94c02833a = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isDraggingOver: isDraggingOver, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_otyr1ejb _ggi1u2gc",
            __cmplp.isDraggingOver && "_fy25glyw",
            __cmplp.className
        ])
    });
});

});


parcelRegister("kNDA2", function(module, exports) {

$parcel$export(module.exports, "isNetworkError", () => $307706c33bff9976$export$476aa014e2fd89d5);
const $307706c33bff9976$var$ERROR_MESSAGE_CHROME = 'Failed to fetch';
const $307706c33bff9976$var$ERROR_MESSAGE_FIREFOX = 'NetworkError when attempting to fetch resource.';
const $307706c33bff9976$var$ERROR_MESSAGE_OTHER = 'Network request failed';
const $307706c33bff9976$var$NetworkErrorMessages = new Set([
    $307706c33bff9976$var$ERROR_MESSAGE_CHROME,
    $307706c33bff9976$var$ERROR_MESSAGE_FIREFOX,
    $307706c33bff9976$var$ERROR_MESSAGE_OTHER
]);
const $307706c33bff9976$export$476aa014e2fd89d5 = (error)=>typeof error === 'object' && error.reason && $307706c33bff9976$var$NetworkErrorMessages.has(error.reason.replace(/^Network error: (.*)/, '$1'));

});


parcelRegister("2d7Sj", function(module, exports) {

$parcel$export(module.exports, "PageTitle", () => $0653f34646647329$export$155581e8dc02007a);
$parcel$export(module.exports, "ServiceDeskDocumentTitle", () => $0653f34646647329$export$c7841d2c1c13065e);

var $eUqFw = parcelRequire("eUqFw");

var $knPb9 = parcelRequire("knPb9");

var $heNSb = parcelRequire("heNSb");

var $giAhk = parcelRequire("giAhk");

var $f9Osc = parcelRequire("f9Osc");
const $0653f34646647329$export$155581e8dc02007a = (props)=>{
    const { DocumentTitle: DocumentTitle, section: section, intl: { formatMessage: formatMessage }, projectName: projectName, subsection: subsection } = props;
    const title = subsection ? // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ proformaForms: MessageDescriptorV2; chat: MessageDescriptorV2; incidentManagementSettings: MessageDescriptorV2; ... 32 more ...; serviceProject: MessageDescriptorV2; }'.
    `${projectName} - ${formatMessage((0, $f9Osc.default)[section])} - ${subsection} - ${formatMessage((0, $f9Osc.default).serviceProject)}` : // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ proformaForms: MessageDescriptorV2; chat: MessageDescriptorV2; incidentManagementSettings: MessageDescriptorV2; ... 32 more ...; serviceProject: MessageDescriptorV2; }'.
    `${projectName} - ${formatMessage((0, $f9Osc.default)[section])} - ${formatMessage((0, $f9Osc.default).serviceProject)}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(DocumentTitle, {
        title: title
    });
};
const $0653f34646647329$var$InjectedPage = (0, $knPb9.default)($0653f34646647329$export$155581e8dc02007a, {
    DocumentTitle: (0, $heNSb.DocumentTitle)
});
const $0653f34646647329$export$c7841d2c1c13065e = (0, $giAhk.injectIntlV2)($0653f34646647329$var$InjectedPage);
var $0653f34646647329$export$2e2bcd8739ae039 = $0653f34646647329$export$c7841d2c1c13065e;

});
parcelRegister("f9Osc", function(module, exports) {

$parcel$export(module.exports, "default", () => $7be746c19c254767$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $7be746c19c254767$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    atlassianAnalytics: {
        "id": "servicedesk-spa-commons.common.utils.document-title.atlassian-analytics",
        "defaultMessage": "Atlassian Analytics"
    },
    serviceProject: {
        "id": "servicedesk-spa-commons.common.utils.document-title.service-project",
        "defaultMessage": "Service project"
    },
    knowledge: {
        "id": "servicedesk-spa-commons.common.utils.document-title.knowledge",
        "defaultMessage": "Knowledge base"
    },
    itsmFeatures: {
        "id": "servicedesk-spa-commons.common.utils.document-title.itsm-features",
        "defaultMessage": "Features"
    },
    queues: {
        "id": "servicedesk-spa-commons.common.utils.document-title.queues",
        "defaultMessage": "Queues"
    },
    customers: {
        "id": "servicedesk-spa-commons.common.utils.document-title.customers",
        "defaultMessage": "Customers"
    },
    organizations: {
        "id": "servicedesk-spa-commons.common.utils.document-title.organizations",
        "defaultMessage": "Organizations"
    },
    customerServiceEscalations: {
        "id": "servicedesk-spa-commons.common.utils.document-title.customer-service-escalations",
        "defaultMessage": "Developer escalations"
    },
    reports: {
        "id": "servicedesk-spa-commons.common.utils.document-title.reports",
        "defaultMessage": "Reports"
    },
    services: {
        "id": "servicedesk-spa-commons.common.utils.document-title.services",
        "defaultMessage": "Services"
    },
    oncall: {
        "id": "servicedesk-spa-commons.common.utils.document-title.oncall",
        "defaultMessage": "On-call"
    },
    email: {
        "id": "servicedesk-spa-commons.common.utils.document-title.email",
        "defaultMessage": "Email request"
    },
    sla: {
        "id": "servicedesk-spa-commons.common.utils.document-title.sla",
        "defaultMessage": "Service level agreements"
    },
    csat: {
        "id": "servicedesk-spa-commons.common.utils.document-title.csat",
        "defaultMessage": "Customer satisfaction"
    },
    details: {
        "id": "servicedesk-spa-commons.common.utils.document-title.details",
        "defaultMessage": "Details"
    },
    portal: {
        "id": "servicedesk-spa-commons.common.utils.document-title.portal",
        "defaultMessage": "Customer portal"
    },
    externalLinks: {
        "id": "servicedesk-spa-commons.common.utils.document-title.external-links",
        "defaultMessage": "Links"
    },
    portalSettings: {
        "id": "servicedesk-spa-commons.common.utils.document-title.portal-settings",
        "defaultMessage": "Portal settings"
    },
    automation: {
        "id": "servicedesk-spa-commons.common.utils.document-title.automation",
        "defaultMessage": "Automation"
    },
    advanced: {
        "id": "servicedesk-spa-commons.common.utils.document-title.advanced",
        "defaultMessage": "Advanced"
    },
    languageSupport: {
        "id": "servicedesk-spa-commons.common.utils.document-title.language-support",
        "defaultMessage": "Language support"
    },
    languageTranslations: {
        "id": "servicedesk-spa-commons.common.utils.document-title.language-translations",
        "defaultMessage": "Language translations"
    },
    notificationEmail: {
        "id": "servicedesk-spa-commons.common.utils.document-title.notification-email",
        "defaultMessage": "Notification email"
    },
    notifications: {
        "id": "servicedesk-spa-commons.common.utils.document-title.notifications",
        "defaultMessage": "Notifications"
    },
    internalNotifications: {
        "id": "servicedesk-spa-commons.common.utils.document-title.internal-notifications",
        "defaultMessage": "Internal notifications"
    },
    customerNotifications: {
        "id": "servicedesk-spa-commons.common.utils.document-title.customer-notifications",
        "defaultMessage": "Customer notifications"
    },
    widget: {
        "id": "servicedesk-spa-commons.common.utils.document-title.widget",
        "defaultMessage": "Widget"
    },
    customerPermissions: {
        "id": "servicedesk-spa-commons.common.utils.document-title.customer-permissions",
        "defaultMessage": "Customer permissions"
    },
    people: {
        "id": "servicedesk-spa-commons.common.utils.document-title.people",
        "defaultMessage": "Internal access"
    },
    issueType: {
        "id": "servicedesk-spa-commons.common.utils.document-title.issue-type",
        "defaultMessage": "Request types"
    },
    connectAppControls: {
        "id": "servicedesk-spa-commons.common.utils.document-title.connect-app-controls",
        "defaultMessage": "Apps"
    },
    features: {
        "id": "servicedesk-spa-commons.common.utils.document-title.features",
        "defaultMessage": "Features"
    },
    calendar: {
        "id": "servicedesk-spa-commons.common.utils.document-title.calendar",
        "defaultMessage": "Calendar"
    },
    changeCalendar: {
        "id": "servicedesk-spa-commons.common.utils.document-title.change-calendar",
        "defaultMessage": "Change calendar"
    },
    changeManagementSettings: {
        "id": "servicedesk-spa-commons.common.utils.document-title.change-management-settings",
        "defaultMessage": "Change management"
    },
    incidentManagementSettings: {
        "id": "servicedesk-spa-commons.common.utils.document-title.incident-management-settings",
        "defaultMessage": "Incident management"
    },
    virtualAgentConversations: {
        "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-conversations",
        "defaultMessage": "Conversations"
    },
    virtualAgentIntents: {
        "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-intents",
        "defaultMessage": "Intents"
    },
    virtualAgentStandardFlows: {
        "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-standard-flows",
        "defaultMessage": "Standard flows"
    },
    virtualAgentSettings: {
        "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-settings",
        "defaultMessage": "Settings"
    },
    virtualAgentLanding: {
        "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-landing",
        "defaultMessage": "Virtual agent"
    },
    chat: {
        "id": "servicedesk-spa-commons.common.utils.document-title.chat",
        "defaultMessage": "Chat"
    },
    proformaForms: {
        "id": "servicedesk-spa-commons.common.utils.document-title.proforma-forms",
        "defaultMessage": "Forms"
    },
    playbooks: {
        "id": "servicedesk-spa-commons.common.utils.document-title.playbooks-non-final",
        "defaultMessage": "Playbooks"
    },
    dataClassifications: {
        "id": "servicedesk-spa-commons.common.utils.document-title.data-classifications",
        "defaultMessage": "Data classification"
    },
    // EAX-256 - Finalise this string
    fieldsNonFinal: {
        "id": "servicedesk-spa-commons.common.utils.document-title.fields-non-final",
        "defaultMessage": "Fields"
    },
    workflowScheme: {
        "id": "servicedesk-spa-commons.common.utils.document-title.workflow-scheme",
        "defaultMessage": "Workflows"
    },
    journeysNonFinal: {
        "id": "servicedesk-spa-commons.common.utils.document-title.journeys-non-final",
        "defaultMessage": "Journeys"
    },
    journeyConfigNonFinal: {
        "id": "servicedesk-spa-commons.common.utils.document-title.journey-config-non-final",
        "defaultMessage": "Journey configuration"
    }
});

});


parcelRegister("ifUq1", function(module, exports) {

$parcel$export(module.exports, "default", () => $75607b44b71bf2f5$export$2e2bcd8739ae039);
/* app-container.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $j7bQJ = parcelRequire("j7bQJ");
var $6tahE = parcelRequire("6tahE");

var $7ehAr = parcelRequire("7ehAr");

var $c76ap = parcelRequire("c76ap");

var $1YMP9 = parcelRequire("1YMP9");

var $dpXKE = parcelRequire("dpXKE");

var $1ybV0 = parcelRequire("1ybV0");

var $bNe1g = parcelRequire("bNe1g");
const $75607b44b71bf2f5$var$AppContainer = ({ children: children, projectKey: projectKey, gridLayout: gridLayout, fullSize: fullSize = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bNe1g.ProjectContextProvider), null, ({ data: projectData })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($75607b44b71bf2f5$var$ConditionalGrid, {
            gridLayout: gridLayout,
            fullSize: fullSize
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7ehAr.BreadcrumbManager), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($75607b44b71bf2f5$var$BreadcrumbsWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c76ap.default), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dpXKE.default), {
            baseUrl: "",
            projectKey: projectKey,
            // Use projectKey as fallback display name to solve issues with projectData being unmocked in tests, projectData should never be undefined in the actual app as we are in the context of a project seeing as projectKey is a required prop
            projectName: projectData ? projectData.projectName : projectKey
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1YMP9.default), {
            baseUrl: "",
            projectKey: projectKey,
            projectType: projectData ? projectData.projectType : undefined,
            isSimplified: projectData ? projectData.simplified : false
        }, children)))));
var $75607b44b71bf2f5$export$2e2bcd8739ae039 = $75607b44b71bf2f5$var$AppContainer;
const $75607b44b71bf2f5$var$ConditionalGrid = ({ children: children, gridLayout: gridLayout, fullSize: fullSize })=>{
    if (fullSize && (0, $1ybV0.ff)('com.atlassian.connect.change-jira-appcontainer-to-better-support-jira-project-admin-tab-panel')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($75607b44b71bf2f5$var$FullHeightWrapper, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($75607b44b71bf2f5$var$NormalWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j7bQJ.default), {
        layout: gridLayout
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6tahE.default), null, children)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $75607b44b71bf2f5$var$NormalWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _kqswh2mm _1yt45gjp",
            __cmplp.className
        ])
    });
});
const $75607b44b71bf2f5$var$FullHeightWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $75607b44b71bf2f5$var$NormalWrapper, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1osq _1e0c1txw _2lx21bp4 _zulp1ejb",
            __cmplp.className
        ])
    });
});
const $75607b44b71bf2f5$var$BreadcrumbsWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pk1ejb _otyrmgjw _18u0r5cr _1tkepxbi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("j7bQJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $21cf405c5617943d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $cuCEk = parcelRequire("cuCEk");

var $gw8fk = parcelRequire("gw8fk");

var $6tahE = parcelRequire("6tahE");

var $02LzD = parcelRequire("02LzD");
/**
 * __Grid__
 *
 * A grid contains one or more `GridColumn` to provide a grid layout.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/page)
 */ const $21cf405c5617943d$var$GridWrapper = ({ spacing: spacingProp, columns: columnsProp, layout: layout, testId: testId, children: children, theme: theme })=>{
    /**
	 * isRoot is `true` only in the default context (i.e. no ancestor Grid).
	 */ const { isRoot: isRoot } = (0, $eUqFw.useContext)((0, $02LzD.GridContext));
    const { medium: medium } = (0, $eUqFw.useContext)((0, $6tahE.GridColumnContext));
    /**
	 * The colspan of the current containing GridColumn provides
	 * the default amount of columns in a nested grid.
	 */ const defaultColumns = medium > 0 ? medium : (0, $cuCEk.defaultGridColumns);
    /**
	 * This is to account for the eventual removal of the `theme` prop. In theory, this should not be exposed.
	 * However, consumers are still using it - there should be a major rerelease with the complete removal of this prop later.
	 */ const spacing = spacingProp ?? theme?.spacing ?? (0, $cuCEk.defaultSpacing);
    const columns = columnsProp ?? theme?.columns ?? defaultColumns;
    const isNested = theme?.isNestedGrid ?? !isRoot;
    const contextValue = (0, $eUqFw.useMemo)(()=>({
            isRoot: false,
            isNested: isNested,
            spacing: spacing,
            columns: columns
        }), [
        spacing,
        columns,
        isNested
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $02LzD.GridContext).Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gw8fk.Grid), {
        layout: layout,
        testId: testId
    }, children));
};
var $21cf405c5617943d$export$2e2bcd8739ae039 = $21cf405c5617943d$var$GridWrapper;

});
parcelRegister("cuCEk", function(module, exports) {

$parcel$export(module.exports, "defaultGridColumns", () => $63536614c324c20f$export$74797698e12f8baa);
$parcel$export(module.exports, "defaultGridColumnWidth", () => $63536614c324c20f$export$b8241a1616ab1b96);
$parcel$export(module.exports, "spacingMapping", () => $63536614c324c20f$export$2a89a65a43bab52d);
$parcel$export(module.exports, "defaultSpacing", () => $63536614c324c20f$export$8ec7372efd74b753);
$parcel$export(module.exports, "defaultBannerHeight", () => $63536614c324c20f$export$d77f83c3d17a7b8a);
$parcel$export(module.exports, "defaultMedium", () => $63536614c324c20f$export$f8725d21f81f3e01);
$parcel$export(module.exports, "defaultLayout", () => $63536614c324c20f$export$2303d2bd9eeff99a);
$parcel$export(module.exports, "varColumnsNum", () => $63536614c324c20f$export$9ddc3632bbfb8966);
$parcel$export(module.exports, "varColumnSpan", () => $63536614c324c20f$export$8b7e31f391e6e681);
$parcel$export(module.exports, "varGridSpacing", () => $63536614c324c20f$export$936829b4511db3e4);
const $63536614c324c20f$export$3aaf3a78c909ea56 = 8;
const $63536614c324c20f$export$74797698e12f8baa = 12;
const $63536614c324c20f$export$b8241a1616ab1b96 = $63536614c324c20f$export$3aaf3a78c909ea56 * 10;
const $63536614c324c20f$export$2a89a65a43bab52d = {
    comfortable: $63536614c324c20f$export$3aaf3a78c909ea56 * 5,
    cosy: $63536614c324c20f$export$3aaf3a78c909ea56 * 2,
    compact: $63536614c324c20f$export$3aaf3a78c909ea56 * 0.5
};
const $63536614c324c20f$export$8ec7372efd74b753 = 'cosy';
const $63536614c324c20f$export$d77f83c3d17a7b8a = 52;
const $63536614c324c20f$export$f8725d21f81f3e01 = 0;
const $63536614c324c20f$export$2303d2bd9eeff99a = 'fixed';
const $63536614c324c20f$export$9ddc3632bbfb8966 = '--ds-columns-num';
const $63536614c324c20f$export$8b7e31f391e6e681 = '--ds-column-span';
const $63536614c324c20f$export$936829b4511db3e4 = '--ds-grid-spacing';

});

parcelRegister("gw8fk", function(module, exports) {

$parcel$export(module.exports, "Grid", () => $7946ba115b4da3a8$export$ef2184bd89960b14);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $cuCEk = parcelRequire("cuCEk");

var $02LzD = parcelRequire("02LzD");
function $7946ba115b4da3a8$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7946ba115b4da3a8$var$gridStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    margin: '0 auto',
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    padding: `0 calc(var(${(0, $cuCEk.varGridSpacing)}) / 2)`,
    position: 'relative',
    alignItems: 'flex-start',
    flexWrap: 'wrap'
});
const $7946ba115b4da3a8$var$gridLayoutStyles = {
    fixed: /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `calc(var(${(0, $cuCEk.varColumnsNum)}) * ${(0, $cuCEk.defaultGridColumnWidth)}px)`
    }),
    fluid: {
        name: "qhxz92",
        styles: "max-width:100%"
    }
};
const $7946ba115b4da3a8$var$nestedGridStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: `0 calc(-1 * var(${(0, $cuCEk.varGridSpacing)}))`
});
const $7946ba115b4da3a8$export$ef2184bd89960b14 = ({ layout: layout = (0, $cuCEk.defaultLayout), testId: testId, children: children })=>{
    const { isNested: isNested, columns: columns, spacing: spacing } = (0, $eUqFw.useContext)((0, $02LzD.GridContext));
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $7946ba115b4da3a8$var$gridStyles,
            $7946ba115b4da3a8$var$gridLayoutStyles[layout],
            isNested && $7946ba115b4da3a8$var$nestedGridStyles
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $cuCEk.varColumnsNum)]: columns,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $cuCEk.varGridSpacing)]: `${(0, $cuCEk.spacingMapping)[spacing]}px`
        },
        "data-testid": testId
    }, children);
};

});
parcelRegister("02LzD", function(module, exports) {

$parcel$export(module.exports, "GridContext", () => $abe6d6b3e91c4986$export$11cae3e04ab99fae);

var $eUqFw = parcelRequire("eUqFw");

var $cuCEk = parcelRequire("cuCEk");
const $abe6d6b3e91c4986$export$11cae3e04ab99fae = /*#__PURE__*/ (0, $eUqFw.createContext)({
    isRoot: true,
    isNested: false,
    spacing: (0, $cuCEk.defaultSpacing),
    columns: (0, $cuCEk.defaultGridColumns)
});

});


parcelRegister("6tahE", function(module, exports) {

$parcel$export(module.exports, "GridColumnContext", () => $384e4fce86f51330$export$1229ad7112b989f5);
$parcel$export(module.exports, "default", () => $384e4fce86f51330$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $cuCEk = parcelRequire("cuCEk");

var $02LzD = parcelRequire("02LzD");
var $384e4fce86f51330$var$ColumnVariant;
/**
 * Determines the method by which column width is calculated.
 */ (function(ColumnVariant) {
    /**
   * Column occupies available space.
   *
   * Used when `medium` is 0 (the default).
   */ ColumnVariant["Auto"] = "auto";
    /**
   * Column occupies specified space.
   *
   * Used when 0 < `medium` < `columns`.
   */ ColumnVariant["Bounded"] = "bounded";
    /**
   * Column occupies entire row.
   *
   * Used when `medium` >= `columns`.
   *
   * This case is handled separately because of rounding.
   */ ColumnVariant["FullWidth"] = "fullWidth";
})($384e4fce86f51330$var$ColumnVariant || ($384e4fce86f51330$var$ColumnVariant = {}));
const $384e4fce86f51330$var$getVariant = ({ medium: medium, columns: columns })=>{
    if (medium === (0, $cuCEk.defaultMedium)) return "auto";
    else if (medium < columns) return "bounded";
    return "fullWidth";
};
/**
 * IE11 and Edge both have rounding issues for flexbox which is why a width of
 * 99.9999% is used. Using 100% here causes columns to wrap prematurely.
 */ const $384e4fce86f51330$var$availableWidth = '99.9999%';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $384e4fce86f51330$var$singleColumnWidth = `(${$384e4fce86f51330$var$availableWidth} / var(${(0, $cuCEk.varColumnsNum)}))`;
const $384e4fce86f51330$var$gridColumnStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    minWidth: `calc(${$384e4fce86f51330$var$singleColumnWidth} - var(${(0, $cuCEk.varGridSpacing)}))`,
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: `0 calc(var(${(0, $cuCEk.varGridSpacing)}) / 2)`,
    flexGrow: 1,
    flexShrink: 0,
    wordWrap: 'break-word'
});
const $384e4fce86f51330$var$gridColumnWidthStyles = {
    ["auto"]: /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `calc(100% - var(${(0, $cuCEk.varGridSpacing)}))`,
        flexBasis: `auto`
    }),
    ["bounded"]: /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `calc(${$384e4fce86f51330$var$singleColumnWidth} *  var(${(0, $cuCEk.varColumnSpan)}) - var(${(0, $cuCEk.varGridSpacing)}))`,
        flexBasis: `100%`
    }),
    ["fullWidth"]: /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `calc(100% - var(${(0, $cuCEk.varGridSpacing)}))`,
        flexBasis: `100%`
    })
};
const $384e4fce86f51330$export$1229ad7112b989f5 = /*#__PURE__*/ (0, $eUqFw.createContext)({
    medium: (0, $cuCEk.defaultMedium)
});
/**
 * __Grid column__
 *
 * A grid column can span one or more column positions within a grid.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/page)
 */ const $384e4fce86f51330$var$GridColumn = ({ medium: medium = (0, $cuCEk.defaultMedium), children: children, testId: testId })=>{
    const { columns: columns } = (0, $eUqFw.useContext)((0, $02LzD.GridContext));
    const contextValue = (0, $eUqFw.useMemo)(()=>({
            medium: medium
        }), [
        medium
    ]);
    /**
   * The real column span,
   * obtained by clamping the passed `medium` value within the allowed range.
   */ const colSpan = Math.max(1, Math.min(medium, columns));
    /**
   * How we should calculate the column width.
   */ const variant = $384e4fce86f51330$var$getVariant({
        medium: medium,
        columns: columns
    });
    return /*#__PURE__*/ (0, $byn9U.jsx)($384e4fce86f51330$export$1229ad7112b989f5.Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $384e4fce86f51330$var$gridColumnStyles,
            $384e4fce86f51330$var$gridColumnWidthStyles[variant]
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            /**
       * The 'auto' value here isn't actually consumed anywhere and is
       * just to better reflect what is happening when inspecting CSS.
       */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $cuCEk.varColumnSpan)]: variant === "auto" ? 'auto' : colSpan
        },
        "data-testid": testId
    }, children));
};
var $384e4fce86f51330$export$2e2bcd8739ae039 = $384e4fce86f51330$var$GridColumn;

});


parcelRegister("1YMP9", function(module, exports) {

$parcel$export(module.exports, "default", () => $90e5325849889e8c$export$2e2bcd8739ae039);

var $giAhk = parcelRequire("giAhk");

var $7AJNu = parcelRequire("7AJNu");
var $90e5325849889e8c$export$2e2bcd8739ae039 = (0, $giAhk.injectIntlV2)((0, $7AJNu.default));

});
parcelRegister("7AJNu", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a78352310a6c306$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7ZZxN = parcelRequire("7ZZxN");

var $aTgXo = parcelRequire("aTgXo");

var $5IARc = parcelRequire("5IARc");

var $jBULE = parcelRequire("jBULE");
const $8a78352310a6c306$var$ProjectSettingsBreadcrumb = ({ children: children, projectKey: projectKey, projectType: projectType, isSimplified: isSimplified = false, intl: { formatMessage: formatMessage } })=>projectType && // <- we need this first condition just to avoid Flow error at createProjectSettingsUrl
    (projectType === (0, $7ZZxN.CORE_PROJECT) || projectType === (0, $7ZZxN.SOFTWARE_PROJECT) || projectType === (0, $7ZZxN.SERVICE_DESK_PROJECT)) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aTgXo.default), {
        breadcrumb: {
            href: (0, $5IARc.createProjectSettingsUrl)(projectKey, projectType, isSimplified),
            text: formatMessage((0, $jBULE.default).projectSettingsTitle),
            type: 'projectSettings'
        }
    }, children) : children;
var $8a78352310a6c306$export$2e2bcd8739ae039 = $8a78352310a6c306$var$ProjectSettingsBreadcrumb;

});
parcelRegister("jBULE", function(module, exports) {

$parcel$export(module.exports, "default", () => $b99c71c52f70e552$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $b99c71c52f70e552$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    projectSettingsTitle: {
        "id": "platform.ui.breadcrumbs.common-breadcrumbs.project-settings.project-settings-title",
        "defaultMessage": "Project settings"
    }
});

});







//# sourceMappingURL=async-project-settings-service-desk-external-links.47694cd6.js.map
